export default {
  notification:{
    admin:{
      user:{
        add:{
          success:{
            a1:'Success',
            a2:'User Added Successfully'
          },
          error:{
            a1:'Failed',
            a2:'User Create Failed'
          }
        },
        confirm:{
          success:{
            c1:'confirm',
            c2:'Confirm Delete',
            c3:'You are about to delete {traineeName}',
            c4:'Delete'
          },
        },
        deleted:{
          success:{
            d1:'User Deleted',
            d2:'The selected user deleted successfully '
          },
          error:{
            d1:'User Deletion Failed',
            d2:'The selected user could not be deleted'
          },
          warning:{
            w1:'Confirm Delete',
            w2:'You are about to delete {username}'
          }
        },
        updateUser:{
          success:{
            u1:'Information Updated',
            u2:'Information was successfully updated'
          },
          error:{
            u1:'Information Update Failed',
            u2:'Information could not be updated'
          }
        },
        updateSocialDetails:{
          success:{
            u1:'Social Details Updated',
            u2:'Social details successfully updated'
          },
          error:{
            u1:'Social Details Update Failed',
            u2:'Social details could not be updated'
          }
        },
        cellRenderer:{
          coachAssign:{
            a1:'Coach Assigned',
            a2:'This Player is in a coaching relationship. If you want to remove the user; Delete the coaching assignment and try again.'
          },
          playerAssign:{
            p1:'Player Assigned',
            p2:'This User is in a coaching relationship. If you want to remove the user; Delete the coaching assignment and try again.'
          },
          confirmDelete:{
            c1:'Confirm Delete',
            c2:'You are about to delete {firstName}'
          }
        },
        update:{
          u1:'',
          u2:'',
          u3:''
        }
      },
      company:{
        add:{
          success:{
            a1:'Success',
            a2:'Company Added Successfully'
          },
          error:{
            a1:'Failed',
            a2:'Company Create Failed'
          }
        },
        updateCompany:{
          success:{
            u1:'Success',
            u2:'Company Updated Successfully'
          },
          error:{
            u1:'Failed',
            u2:'Company Not Updated Successfully'
          }
        },
        emailExist:{
          success:{
            e1:'Failed',
            e2:'Email Id already exists'
          },
        },
        deleted:{
          success:{
            d1:'User Deleted',
            d2:'The selected user deleted successfully '
          },
          error:{
            d1:'Failed',
            d2:'User Create Failed'
          }
        },
        confirmDelete:{
          confirm:{
            c1:'Coach Assigned',
            c2:'Player is associated with Organization. If you want to remove the Organization; Delete the users and try again.'
          },
          delete:{
            d1:'Confirm Delete',
            d2:'You are about to delete {name}'
          }
        },
        removeCompany:{
          success:{
            r1:'Company Deleted',
            r2:'The selected company was successfully deleted'
          },
          error:{
            r1:'Company Deletion Failed',
            r2:'The selected company could not be deleted, Because the User is associated with this company.'
          }
        },
        updateUser:{
          success:{
            u1:'Coach Updated',
            u2:'The selected coach was successfully updated'
          },
          error:{
            u1:'Coach Update Failed',
            u2:'The selected coach could not be updated'
          }
        },
        updateUserSocial:{
          success:{
            u1:'Coach Updated',
            u2:'The selected user was successfully updated'
          },
          error:{
            u1:'Coach Update Failed',
            u2:'The selected user could not be updated'
          }
        },
        update:{
          u1:'',
          u2:'',
          u3:''
        }
      },
      auth:{
        checkLogin:{
          warning:{
            w1:'Login Attempt',
            w2:'You are already logged in!'
          },
          error:{
            e1:'Error',
            e2:''
          }
        },
        update:{
          u1:'',
          u2:'',
          u3:''
        }
      },
      assignCoach:{
        coachAssigned:{
          success:{
            s1:'Success',
            s2:'Coach Assigned Successfully'
          },
          warning:{
            f1:'Failed',
            f2:'Self assignment is not possible'
          },
          failed:{
            f1:'Failed',
            f2:'Coach Already Assigned'
          }
        },
        deleted:{
          success:{
            d1:'User Deleted',
            d2:'The selected user was successfully deleted'
          }
        },
        updateAssigned:{
          success:{
            u1:'Success',
            u2:'Coach Assigned Updated Successfully'
          },
          failed:{
            u1:'Failed',
            u2:'Coach Assignment Update Failed'
          }
        },
        coachDeleted:{
          success:{
            d1:'Trainee Assigned Coach Deleted',
            d2:'The selected Trainee Assign Coach was successfully deleted'
          },
          failed:{
            d1:'Trainee Assign Coach Deletion Failed',
            d2:'The selected Trainee Assign Coach could not be deleted'
          }
        },
        showDeleteSuccess:{
          success:{
            d1:'Trainee Assign Coach Deleted',
            d2:'The selected Trainee Assign Coach was successfully deleted'
          }
        },
        updateUser:{
          success:{
            u1:'Coach Updated',
            u2:'The selected coach was successfully updated'
          },
          failed:{
            u1:'Coach Update Failed',
            u2:'The selected coach could not be updated'
          }
        },

        update:{
          u1:'',
          u2:'',
          u3:''
        }
      }
    },
    user:{
      addSkill:{
        userId:{
          success:{
            a1:'Coach switch to {traineeName} (Add Skill)'
          }
        },
        getCompetency:{
          a1:'{comp} attribute, has already been added'
        }
      },
      auth:{
        resetPassword:{
          success:{
            r1:'Password Changed',
            r2:'You have successfully Password Changed'
          },
          error:{
            r1:'Password Not Changed',
            r2:'You have Not successfully Password Changed'
          }
        },
        matchPassword:{
          notMatch:{
            n1:'Password are not match',
            n2:'Please Try Again'
          }
        },
        checkLogin:{
          warning:{
            w1:'Login Attempt',
            w2:'You are already logged in!'
          }
        },
        EmailExist:{
          error:{
            e1:'Error',
            e2:'Email Not Registered'
          },
          passwordReset:{
            r1:'Success',
            r2:'Password Reset Link Sent'
          }
        },
        signUp:{
          success:{
            s1:'Successful Registration',
            s2:'You have successfully registered'
          }
        }
      },
      components:{
        emailSent:{
          success:{
            e1:'Email Sent',
            e2:'Email Sent Successfully'
          }
        }
      },
      myCoach:{
        deleteUser:{
          confirm:{
            c1:'Confirm Delete',
            c2:'You are about to delete {username}'
          },
          success:{
            d1:'User Deleted',
            d2:'The selected user was successfully deleted'
          }
        },
        addNote:{
          success:{
            a1:'Success',
            a2:'Note Added Successfully'
          },
          failed:{
            a1:'Failed',
            a2:'Note Create Failed'
          }
        }
      },
      myRater:{
        raterList:{
          success:{
            a1:'Coach Switch to {traineeName} (Rater List)'
          }
        },
        mailCancel:{
          warning:{
            c1:'Email Canceled',
            c2:'Scheduled Email Already Cancel'
          },
          success:{
            c1:'Email Canceled',
            c2:'Scheduled Email Canceled Successfully'
          }
        },
        emailReschedule:{
          success:{
            s1:'Email Reschedule',
            s2:'Reschedule Email Successfully'
          },
          failed:{
            s1:'Email Reschedule',
            s2:'Reschedule Email Not Successfully'
          },
        }
      },
      profile:{
        confirm:{
          c1:'Confirm Delete',
          c2:'You are about to delete {username}'
        },
        profileSynced:{
          error:{
            e1:'User Profile',
            e2:'User data not synced'
          }
        },
        dataSynced:{
          success:{
            d1:'User Profile',
            d2:'User data sync successfully updated'
          },
          failed:{
            d1:'User Profile',
            d2:'User data not sync successfully updated'
          }
        },
        removeRecord:{
          success:{
            r1:'User Deleted',
            r2:'The selected user was successfully deleted'
          }
        }
      },
      skillDetails:{
        emails:{
          cancel:{
            success:{
              c1:'Email Canceled',
              c2:'Scheduled Email Canceled Successfully'
            },
            error:{
              c1:'Email Canceled',
              c2:'Scheduled Email Already Cancel'
            }

          },
          expire:{
            e1:'Email Expire',
            e2:'Email Expire Successfully'
          },
          sent:{
            e1:'Email Sent',
            e2:'Email Sent Successfully'
          },
          schedule:{
            success:{
              c1:'Email Reschedule',
              c2:'Reschedule Email Successfully'
            },
            error:{
              c1:'Email Reschedule',
              c2:'Reschedule Email Not Successfully'
            }

          }

        },
        rater:{
          deactivate:{
            success:{
              a1:'Success',
              a2:'Rater deactivated Successfully'
            },
            error:{
              a1:'Failed',
              a2:'Rater Deactivation Failed'
            }
          },
          activate:{
            success:{
              a1:'Success',
              a2:'Rater activated Successfully'
            },
            error:{
              a1:'Failed',
              a2:'Rater Activation Failed'
            }
          }
        },
        invite:{
          emailFind:{
            e1:'Rater Email Exists',
            e2:'Rater Email already exist , Please Invite another Rater Email'
          },
          userFind:{
            u1:'Rater Email Exists',
            u2:'Player can not invite for peer Feedback itself, Please Invite another Rater Email'
          }
        }
      },
      todo:{
        update:{
          success:{
            u1:'Success',
            u2:'Status Updated Successfully'
          },
          failed:{
            u1:'Failed',
            u2:'Status Updation Failed'
          }
        }
      },
      traineeList:{
        removeRecord:{
          success:{
            r1:'User Deleted',
            r2:'The selected user was successfully deleted'
          },
          failed:{
            r1:'User Deletion Failed',
            r2:'The selected user could not be deleted'
          }
        },
        updateUser:{
          success:{
            u1:'Information Updated',
            u2:'Information was successfully updated'
          },
          failed:{
            u1:'Information Update Failed',
            u2:'Information could not be updated'
          }
        },
        updateSocial:{
          success:{
            u1:'Social Details Updated',
            u2:'Social details successfully updated'
          },
          failed:{
            u1:'Social Details Update Failed',
            u2:'Social details could not be updated'
          }
        },
        rater:{
          r1:'Mentor Switch to Player(Rater List)'
        },
        emailSchedule:{
          cancelSchedule:{
            warning:{
              c1:'Email Canceled',
              c2:'Scheduled Email Already Cancel'
            },
            success:{
              c1:'Email Canceled',
              c2:'Scheduled Email Canceled Successfully'
            }
          },
          reSchedule:{
            success:{
              s1:'Email Reschedule',
              s2:'Reschedule Email Successfully'
            },
            failed:{
              s1:'Email Reschedule',
              s2:'Reschedule Email Failed'
            }
          }

        },
        addUser:{
          success:{
            a1:'Success',
            a2:'User Added Successfully'
          },
          failed:{
            a1:'Failed',
            a2:'User Create Failed'
          }
        }
      }
    }
  },
  trainingLibrary:{
    presentations:"Presentations",
    video:'Video tutorials',
    books:"Books",
    contact:'Contact support',
    appsIntegration:'Apps and Integrations',
    ogrNot:'Training center is not yet activated for your organization',
    gbSupport:'Contact GetBoarded Support.'
  },
  login:{
    title:"Login",
    h1: "Welcome back, please login to your account.",
    tb1: "Email Login",
    tb2: "Single Sign On",
    lbl1: "Email",
    lbl2: "Password",
    lbl3: "Remember Me",
    lbl4: "Forgot Password",
    btn1: "Login",
    btn2: "Login with PeopleTree",
    btn3: "Login with GetBoarded"
  },
  coachLogin:{
    trainee:{
      raterList:'Advisors details of ',
      addSkill:'You are viewing this page information as '
    },
  },
  Schedules:'Schedules',
  raterList:"Rater List",
  trainingCenter:"Training Center",
  home_title:"Progress Dashboard",
  Response:{
    t1:'NO GAP',
    t2:'SMALL GAP',
    t3:'MODERATE GAP',
    t4:'LARGE GAP',
    t5:'SIGNIFICANT GAP'
  },
  NoGap:'No Gap',

  playerJourney :{
    t1_1:'Player has created account',
    t1_2:'Player has not created account',
    t2_1:'Abilities  Added  ',
    t2_2:'Has not Started adding abilities ',
    t3_1:'Motivation Survey Complete',
    t3_2:'Motivation Survey Overdue',
    t3_3:'Yet to complete first motivation Survey',
    t4_1:'Coaching Survey Complete',
    t4_2:'Coaching Survey Overdue',
    t4_3:'Yet to complete first Coaching Survey'
  },
  RequestAccess:"Request Access",
  routeTitle:{
    t1:"Player Details",
    t2:"Development Experience"
  },
  CoachProfile:"My Coach Profile",
  CoacheeList:"Player List",
  coachingExperiences:"Experience Log",
  Addnewskill:"Set a Goal",
  MySkills:"My Abilities ",
  MyProfile:"My Profile",
  MyMentorProfile: "My Coach Profile",
  MyRaters:"My Advisors",
  MyDevelopmentManager:"My DPM",
  Progress_measure:"Your Progress Measure",
  Progress:"Progress",
  progressStatus:"In Progress",
  progressStatus1:"Goal Completed",
  Account:"Account",
  Information:"Information",
  TrainingCenter:"Training Center",
  Videos:"Videos",
  Books:"Books",

  PersonalInformation:"Personal Information",
  Male:"Male",
  Female:"Female",
  Other:"Other",
  Address:"Address",
  PostCode:"Post Code",
  socialLink: "Social Links",
  Coachee: "Player",
  Coach: "Coach",
  calender:{
    c1:" started working on ",
    c2:" Goal on ",
    c3:" marked completed by ",
    c4:" has not added any Abilities ."
  },
  Invited:"Invited",
  GapClosed:"Gap Closed",
  Benchmark:"Feedback Received",
  Benchmark_1:"Benchmark",
  GapBigger:"Gap Bigger",
  NoRating:"No Rating",
  GapSmaller:"Gap Smaller",
  LogOut:"Log Out",

  Attribute_History:"Attribute History",
  TrainingDuration:"Select Custom Duration",
  User:"Founders",
  Company:"Organization",
  AssignCoach:"Coach Assignments",
  TraineeDetails:"Player Details",
  Trainee: "Player",
  raterDetails: "Advisor Details",
  Rater: "Advisor",
  Access: "Access",
  List: "List",
  Edit: "Edit",
  userlist: "Founder List",
  edituser: "User Edit",
  adduser:{
    title: "Add Founder",
    lbl0: "User Type",
    lbl1: "First Name",
    lbl2: "Last Name",
    lbl3: "Email",
    lbl4: "Organization",
    lbl5: "Language",
    btn0: "Submit and Send Invite"
  },
  companylist: "Organization List",
  addcompany:{
    title: "Add Organization",
    lbl0: "Organization Name",
    lbl1: "Admin Email",
    lbl2: "Password",
    lbl3: "Coaching Survey",
    lbl4: "Motivation Survey",
    lbl5: "Terminology",
    lbl5_opt0: "Coach",
    lbl5_opt1: "DPM",
    lbl6: "Enterprise",
    lbl6_opt0: "Free",
    lbl6_opt1: "Paid",
    lbl7: "Theme Color",
    lbl8: "Feedback Frequency",
    lbl9: "Secondary Color"
  },
  updatecompany:{
    title: "Update Organization",
    lbl2: "New Password",
    lbl3: "Confirm Password"
  },
  CoachingEffectiveness:'Coaching Effectiveness',
  Save: "Save",
  Submit: "Submit",
  Update: "Update",
  updateCoach:"Update Coach",
  Cancel:"Cancel",
  Schedule: "Schedule",
  Extend: "Extend",
  requestAccess:{
    title: "Request Access",
    popupTitle: "Upgrade Plan",
    popupText1: "To add unlimited users, upgrade to an enterprise access to Coach App.",
    popupText2: "To add a single user",
    h1:"My Coach",
    p1:"Request an access",
    q1:"What is your full name? This question is required. *",
    q2:"Your email?",
    q3:"Do you have any coupon code?",
    q3p:"Enter your code, if you have any, else skip to payment."
  },
  home: {
    h1: "Welcome",
    h2: "You haven't added any abilities ",
    h3: "When you add abilities, they will appear below",
    h4: "Add New Skill",
    h5: "Time to view your progress",
    h6: "Your Latest Stats",
    h7: "Skill Details",
    h8: "Your Previous Stats"
  },
  coachingExperience: {
    ce1: "No Coaching association Found! Please contact admin to map your coach.",
    ce2: "Your development experience survey is currently overdue for more than ",
    ce3: "Going Great",
    ce4: "Can be Better",
    ce5: "Your feedback has been submitted successfully!",
    ce6: "We are glad things are going well!",
    ce7: "Your next checkpoint for coaching survey will be in ",
    ce8: "Provide feedback on your development experience with this coaching. It will help us understand your development journey",
    ce9: "Personal Experience",
    ce10: "How happy are you with your development experience? Think; Can I be myself? Do I dare to ask and show I do not know? Or do I have to wear a mask and act like someone I am not?",
    ce11: "Resource Availability",
    ce12: "Do you have sufficient time and resources available to you to achieve your goals? Think; Can I develop myself? Can I evolve ?",
    ce13: "Leadership Support",
    ce14: "Are you getting the support you need from your organizational leadership? Think; Am I safe here? Do I contribute to the bigger Organizational goal? Is my contribution recognized? Valorised?",
    ce15: "Submit",
    ce16: "Your feedback has been submitted successfully!",
    ce17: "We will work to improve your experience in the future. Keep up the good work.",
    ce18: "Your next checkpoint will be in a month. But feel free to submit feedback anytime!",
    ce19: " Days.",
    ce20:" \n" +
        "Please take a minute to suggest if your skill development is on track.",
    ce21:"Frequency of reminders is set by Organization, but feel free to submit feedback anytime you want!",
    ce22:"Need to start adding abilities  before a coaching experience can be logged",
    ce23:"Development experience survey is recently completed. You will be able to submit a new one soon."
  },

  addNewSkill: {
    ans1: "Back",
    ans2: "Next",
    ans3: "Submit",
    data: {     
      'es': {
        characteristic: 'Ecosystem Activation',
        wdd: "Activate your ecosystem by defining vision, mission and values.",
        icon: require('@/assets/Iconography/Characteristics/15_Skilled Communicator.svg'),
        competencies: [
        {
            id: 'es-0',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Getting Started',
            wdd: '',
            progressMeasures: [
            {
                id: 'es-0-0',
                pm: 'The team has found a particular, critical, and recurring issue through reason and research that they want to build a community around.',
                title:'Need',
                pmMap: 'The team has found a particular, critical, and recurring issue through reason and research that they want to build a community around.',
                developmentActions:[
                  {                    
                    id: "es-0-0-0", da: "Define a clear vision and purpose for the ecosystem to exist."
                   },
                   {
                    id: "es-0-0-1", da: "Conduct research to identify and validate opportunities."
                   },
                   {
                    id: "es-0-0-2", da: "Conduct landscape to understand gaps. Identify Local vs International opportunities."
                   },
                   {
                    id: "es-0-0-3", da: "Create a roadmap with specific goals and milestones for the activation."
                   },
                   {
                    id: "es-0-0-4", da: "Develop a detailed project plan and timeline."
                   },
                   {
                    id: "es-0-0-5", da: "Create a cross-functional team with diverse skills."
                   },
                   {
                    id: "es-0-0-6", da: "Assign clear roles and responsibilities to co-founding or core team members."
                   },
                   {
                    id: "es-0-0-7", da: "Establish a budget for development and set aside funds for initial infrastructures."
                   },
                   {
                    id: "es-0-0-8", da: "Identify the need of funds and secure available funding or investment if needed."
                   },
                   {
                    id: "es-0-0-9", da: "Participate in industry events seeking collaborators, investors or incubation programs."
                   },
                   {
                    id: "es-0-0-10", da: "Network with people within your region to build a support system. Get early validations."
                   },
                   {
                    id: "es-0-0-11", da: "Develop a unique value proposition for your ecosystem."
                   },
                   {
                    id: "es-0-0-12", da: "Craft a compelling elevator pitch to explain the purpose concisely."
                   },
                   {
                    id: "es-0-0-13", da: "Design user personas to understand your target audience and participants."
                   },
                   {
                    id: "es-0-0-14", da: "Identify key pain points your participants will act-on, address, and evangelize."
                   },
                   {
                    id: "es-0-0-15", da: "Prioritize utility based on community needs and impact it aspires."
                   },
                   {
                    id: "es-0-0-16", da: "Develop a Paper Minimum Viable Community (MVC) to validate the concept."
                   },
                   {
                    id: "es-0-0-17", da: "Test the mockups of your MVC with a small group of users."
                   },
                   {
                    id: "es-0-0-18", da: "Gather participant feedback and iterate on the initial concepts."
                   },
                   {
                    id: "es-0-0-19", da: "Define the user interface and user experience (UI\/UX)."
                   },
                   {
                    id: "es-0-0-20", da: "Conduct usability testing to ensure intuitive navigation with early mockups to confirm need."
                   },
                   {
                    id: "es-0-0-21", da: "Plan a user-friendly onboarding processes."
                   },
                   {
                    id: "es-0-0-22", da: "Plan a for a robust backend architecture and identify the tech stack and infrastructure."
                   },
                   {
                    id: "es-0-0-23", da: "Plan for scalability, to handle increasing user load."
                   },
                   {
                    id: "es-0-0-24", da: "Focus on data security and privacy measures. List compliances you'd need to adhere to."
                   },
                   {
                    id: "es-0-0-25", da: "Estimate the product for performance and speed."
                   },
                   {
                    id: "es-0-0-26", da: "Strategize for responsive design for various devices."
                   },
                   {
                    id: "es-0-0-27", da: "Choose analytics to track user behavior and metrics."
                   },
                   {
                    id: "es-0-0-28", da: "Develop a marketing strategy for product promotion."
                   },
                   {
                    id: "es-0-0-29", da: "Envision a compelling product website or landing page."
                   },
                   {
                    id: "es-0-0-30", da: "Choose medium for marketing, like generating high-quality marketing content (videos, visuals, etc.)."
                   },
                   {
                    id: "es-0-0-31", da: "Define key performance indicators (KPIs) for your marketing."
                   },
                   {
                    id: "es-0-0-32", da: "Choose the platforms to leverage social media platforms for audience engagement."
                   },
                   {
                    id: "es-0-0-33", da: "Identify early partnerships or collaborations for promotion."
                   },
                   {
                    id: "es-0-0-34", da: "Set up a feedback mechanism for ongoing user input."
                   },
                   {
                    id: "es-0-0-35", da: "Plan a customer support system for inquiries."
                   },
                   {
                    id: "es-0-0-36", da: "Implement a bug tracking and reporting process."
                   },
                   {
                    id: "es-0-0-37", da: "Pick a frequency to regularly update and maintain the product."
                   },
                   {
                    id: "es-0-0-38", da: "Monitor industry trends and technological advancements."
                   },
                   {
                    id: "es-0-0-39", da: "If published, keep an eye on customer reviews and feedback."
                   },
                   {
                    id: "es-0-0-40", da: "Continuously analyze user behavior and usage patterns in market."
                   },
                   {
                    id: "es-0-0-41", da: "Consider internationalization and localization if applicable. Lookout for government support in these areas."
                   },
                   {
                    id: "es-0-0-42", da: "Collect and analyze user data ethically and transparently."
                   },
                   {
                    id: "es-0-0-43", da: "Plan for version updates and feature releases."
                   },
                   {
                    id: "es-0-0-44", da: "Engage in continuous learning and skill development."
                   },
                   {
                    id: "es-0-0-45", da: "Conduct A\/B testing for feature optimization."
                   },
                   {
                    id: "es-0-0-46", da: "Seek input from experts or mentors in your field."
                   },
                   {
                    id: "es-0-0-47", da: "Monitor and manage online reputation and brand image."
                   },
                   {
                    id: "es-0-0-48", da: "Consider sustainability and environmental impact."
                   },
                   {
                    id: "es-0-0-49", da: "Foster a culture of innovation and adaptability within your team."
                   },
                ]
            },
            {
              id: 'es-0-1',
              pm: 'Team can express the total addressable market (TAM), potential market share, and primary target market clearly. There is belief in the cause and its sustainability potential.',
              title:'Market',
              pmMap: 'Team can express the total addressable market (TAM), potential market share, and primary target market clearly. There is belief in the cause and its sustainability potential.',
              developmentActions:[
                {
                  id: "es-0-1-0", da: "Conduct thorough market research to identify trends, competition, and gaps."
                 },
                 {
                  id: "es-0-1-1", da: "Define your target audience and create detailed customer personas."
                 },
                 {
                  id: "es-0-1-2", da: "Analyze the needs, pain points, and preferences of your target customers."
                 },
                 {
                  id: "es-0-1-3", da: "Study your competitors to understand their strengths and weaknesses."
                 },
                 {
                  id: "es-0-1-4", da: "Identify niche markets or underserved segments within your industry."
                 },
                 {
                  id: "es-0-1-5", da: "Craft a clear and compelling value proposition that addresses customer pain points."
                 },
                 {
                  id: "es-0-1-6", da: "Develop a unique selling proposition (USP) that sets your product apart from competitors."
                 },
                 {
                  id: "es-0-1-7", da: "Create consistent and resonant messaging that appeals to your target audience."
                 },
                 {
                  id: "es-0-1-8", da: "Highlight your product's key features and benefits in a concise manner."
                 },
                 {
                  id: "es-0-1-9", da: "Communicate your product's value in various marketing materials."
                 },
                 {
                  id: "es-0-1-10", da: "Develop a strong brand identity that reflects your product's personality and values."
                 },
                 {
                  id: "es-0-1-11", da: "Create a memorable and visually appealing logo and brand assets."
                 },
                 {
                  id: "es-0-1-12", da: "Establish your product's positioning in the market (e.g., affordable luxury, premium quality)."
                 },
                 {
                  id: "es-0-1-13", da: "Align your branding with the emotions and aspirations of your target customers."
                 },
                 {
                  id: "es-0-1-14", da: "Ensure consistency in branding across all touchpoints, from packaging to social media."
                 },
                 {
                  id: "es-0-1-15", da: "Build a user-friendly and responsive website optimized for search engines (SEO)."
                 },
                 {
                  id: "es-0-1-16", da: "Develop a content marketing strategy to create valuable and informative content."
                 },
                 {
                  id: "es-0-1-17", da: "Utilize social media platforms to engage with your audience and share updates."
                 },
                 {
                  id: "es-0-1-18", da: "Launch targeted online advertising campaigns (e.g., Google Ads, social media ads)."
                 },
                 {
                  id: "es-0-1-19", da: "Implement a robust email marketing strategy to nurture leads and keep customers engaged."
                 },
                 {
                  id: "es-0-1-20", da: "Attend industry-specific trade shows, conferences, and events to network."
                 },
                 {
                  id: "es-0-1-21", da: "Partner with influencers or thought leaders who align with your brand."
                 },
                 {
                  id: "es-0-1-22", da: "Distribute printed materials such as brochures, flyers, and business cards."
                 },
                 {
                  id: "es-0-1-23", da: "Explore traditional advertising channels like radio, TV, and billboards if relevant."
                 },
                 {
                  id: "es-0-1-24", da: "Collaborate with local businesses to cross-promote each other's products."
                 },
                 {
                  id: "es-0-1-25", da: "Set up customer feedback mechanisms to gather insights and suggestions."
                 },
                 {
                  id: "es-0-1-26", da: "Establish active communication channels, such as chatbots or customer service helplines."
                 },
                 {
                  id: "es-0-1-27", da: "Encourage user-generated content, such as reviews, testimonials, and social media posts."
                 },
                 {
                  id: "es-0-1-28", da: "Actively respond to customer inquiries and feedback on social media and review platforms."
                 },
                 {
                  id: "es-0-1-29", da: "Implement a loyalty program or referral system to reward loyal customers."
                 },
                 {
                  id: "es-0-1-30", da: "Forge partnerships with complementary products or services in your industry."
                 },
                 {
                  id: "es-0-1-31", da: "Collaborate with influencers or bloggers to promote your product to their audience."
                 },
                 {
                  id: "es-0-1-32", da: "Seek co-branding opportunities with established brands to enhance credibility."
                 },
                 {
                  id: "es-0-1-33", da: "Consider joint ventures or strategic alliances for expanded distribution."
                 },
                 {
                  id: "es-0-1-34", da: "Explore affiliate marketing programs to tap into new customer bases."
                 },
                 {
                  id: "es-0-1-35", da: "Adapt your product, website, and marketing materials for different languages and cultures."
                 },
                 {
                  id: "es-0-1-36", da: "Research and understand the local market nuances and preferences in new regions."
                 },
                 {
                  id: "es-0-1-37", da: "Establish partnerships with local distributors or retailers for better market penetration."
                 },
                 {
                  id: "es-0-1-38", da: "Launch targeted marketing campaigns tailored to specific regions or countries."
                 },
                 {
                  id: "es-0-1-39", da: "Ensure compliance with regulatory and cultural requirements in international markets."
                 },
                 {
                  id: "es-0-1-40", da: "Implement analytics tools to track user behavior on your website and app."
                 },
                 {
                  id: "es-0-1-41", da: "Analyze conversion rates, user engagement, and bounce rates to identify areas for improvement."
                 },
                 {
                  id: "es-0-1-42", da: "A\/B test different marketing strategies to determine the most effective approaches."
                 },
                 {
                  id: "es-0-1-43", da: "Continuously refine your marketing campaigns based on data-driven insights."
                 },
                 {
                  id: "es-0-1-44", da: "Monitor and respond to shifts in customer preferences and market dynamics."
                 },
                 {
                  id: "es-0-1-45", da: "Stay updated on industry trends, emerging technologies, and consumer behaviors."
                 },
                 {
                  id: "es-0-1-46", da: "Continuously innovate your product or service to meet evolving customer needs."
                 },
                 {
                  id: "es-0-1-47", da: "Offer limited-time promotions or special offers to attract new customers."
                 },
                 {
                  id: "es-0-1-48", da: "Experiment with new distribution channels or sales models to expand reach."
                 },
                 {
                  id: "es-0-1-49", da: "Stay flexible and ready to pivot your marketing strategies based on market feedback."
                 },
              ]
            },
            {
              id: 'es-0-2',
              pm: 'Team understands and possesses the needed skills to build, buy, or borrow the technology needed to setup operations including necessary communication channels.',
              title:'Technology',
              pmMap: 'Team understands and possesses the needed skills to build, buy, or borrow the technology needed to setup operations including necessary communication channels.',
              developmentActions:[
                {
                  id: "es-0-2-0", da: "Conduct a technology landscape analysis to identify relevant trends and advancements."
                 },
                 {
                  id: "es-0-2-1", da: "Foster open communication within the team. Set communication channels."
                 },
                 {
                  id: "es-0-2-2", da: "Identify if the community can run on 3rd party or self hosted software platforms."
                 },
                 {
                  id: "es-0-2-3", da: "Define the technology stack required for your product's development. "
                 },
                 {
                  id: "es-0-2-4", da: "Research and select the most appropriate programming languages and frameworks."
                 },
                 {
                  id: "es-0-2-5", da: "Determine whether any third-party APIs or services can enhance your product."
                 },
                 {
                  id: "es-0-2-6", da: "Design a scalable and modular architecture to accommodate future growth."
                 },
                 {
                  id: "es-0-2-7", da: "Create system flowcharts and diagrams to visualize the product's technical structure."
                 },
                 {
                  id: "es-0-2-8", da: "Develop a clear database schema and data storage strategy."
                 },
                 {
                  id: "es-0-2-9", da: "Plan for security measures, including encryption, authentication, and authorization."
                 },
                 {
                  id: "es-0-2-10", da: "Choose an appropriate cloud hosting provider and architecture (e.g., AWS, Azure)."
                 },
                 {
                  id: "es-0-2-11", da: "Implement version control (e.g., Git) to manage code changes and collaboration."
                 },
                 {
                  id: "es-0-2-12", da: "Adopt an Agile development methodology for iterative and adaptive progress."
                 },
                 {
                  id: "es-0-2-13", da: "Set up continuous integration and continuous deployment (CI\/CD) pipelines."
                 },
                 {
                  id: "es-0-2-14", da: "Develop coding standards and guidelines for consistent and maintainable code."
                 },
                 {
                  id: "es-0-2-15", da: "Implement automated testing to ensure code quality and minimize bugs."
                 },
                 {
                  id: "es-0-2-16", da: "Create a functional prototype to validate core features and user interactions."
                 },
                 {
                  id: "es-0-2-17", da: "Develop a Minimum Viable Product (MVP) to test the initial product concept."
                 },
                 {
                  id: "es-0-2-18", da: "Use rapid development frameworks to expedite the creation of basic functionalities."
                 },
                 {
                  id: "es-0-2-19", da: "Gather user feedback on the prototype and MVP to inform further development."
                 },
                 {
                  id: "es-0-2-20", da: "Design a user-centered interface that is intuitive and user-friendly."
                 },
                 {
                  id: "es-0-2-21", da: "Conduct usability testing to identify areas for improvement in the user experience."
                 },
                 {
                  id: "es-0-2-22", da: "Optimize loading times and ensure responsive design for different devices and screen sizes."
                 },
                 {
                  id: "es-0-2-23", da: "Implement accessibility features to ensure your product is usable by everyone."
                 },
                 {
                  id: "es-0-2-24", da: "Architect the system to handle increased user loads and traffic as the product grows."
                 },
                 {
                  id: "es-0-2-25", da: "Implement caching mechanisms to optimize data retrieval and response times."
                 },
                 {
                  id: "es-0-2-26", da: "Use load testing tools to assess the system's performance under different conditions."
                 },
                 {
                  id: "es-0-2-27", da: "Optimize database queries and indexes for efficient data retrieval."
                 },
                 {
                  id: "es-0-2-28", da: "Conduct thorough security assessments and vulnerability testing."
                 },
                 {
                  id: "es-0-2-29", da: "Implement secure coding practices to prevent common security flaws."
                 },
                 {
                  id: "es-0-2-30", da: "Use encryption techniques to protect sensitive data during transmission and storage."
                 },
                 {
                  id: "es-0-2-31", da: "Develop a robust authentication and authorization system to control access."
                 },
                 {
                  id: "es-0-2-32", da: "Integrate third-party APIs for features like payments, social media sharing, or mapping."
                 },
                 {
                  id: "es-0-2-33", da: "Design a RESTful API to facilitate communication between different components."
                 },
                 {
                  id: "es-0-2-34", da: "Implement webhooks or event-driven architecture for real-time updates."
                 },
                 {
                  id: "es-0-2-35", da: "Develop documentation for your API to guide third-party developers."
                 },
                 {
                  id: "es-0-2-36", da: "Integrate analytics tools to track user behavior, usage patterns, and engagement."
                 },
                 {
                  id: "es-0-2-37", da: "Implement data visualization techniques to present insights in a meaningful way."
                 },
                 {
                  id: "es-0-2-38", da: "Develop algorithms to analyze collected data and provide valuable insights."
                 },
                 {
                  id: "es-0-2-39", da: "Use machine learning or AI techniques to enhance data-driven decision-making."
                 },
                 {
                  id: "es-0-2-40", da: "Regularly review and refactor code to keep it clean and maintainable."
                 },
                 {
                  id: "es-0-2-41", da: "Monitor error logs and implement error handling mechanisms."
                 },
                 {
                  id: "es-0-2-42", da: "Continuously update dependencies and libraries to ensure security and compatibility."
                 },
                 {
                  id: "es-0-2-43", da: "Implement user feedback loops to make iterative improvements based on user suggestions."
                 },
                 {
                  id: "es-0-2-44", da: "Stay updated on emerging technologies and consider their integration."
                 },
                 {
                  id: "es-0-2-45", da: "Set aside time for \"innovation sprints\" to explore new ideas and solutions."
                 },
                 {
                  id: "es-0-2-46", da: "Experiment with new tools, frameworks, or methodologies to enhance development."
                 },
                 {
                  id: "es-0-2-47", da: "Create comprehensive technical documentation for developers and users."
                 },
                 {
                  id: "es-0-2-48", da: "Establish a knowledge-sharing culture within the development team."
                 },
                 {
                  id: "es-0-2-49", da: "Organize regular code reviews to ensure consistent coding practices."
                 },
                 {
                  id: "es-0-2-50", da: "Maintain a central repository for resources, guides, and best practices."
                 },
                 {
                  id: "es-0-2-51", da: "Encourage cross-training among tech team members to ensure skill diversity and manage risk and contingency."
                 },
              ]
            },
            {
              id: 'es-0-3',
              pm: 'Team has a hypothesis of their potential actors in the community, and has articulated the value offer clearly.',
              title:'Value',
              pmMap: 'Team has a hypothesis of their potential actors in the community, and has articulated the value offer clearly.',
              developmentActions:[
                {                  
                  id: "es-0-3-0", da: "Conduct in-depth market research to understand customer pain points."
                 },
                 {
                  id: "es-0-3-1", da: "Define your target audience and their specific needs and preferences."
                 },
                 {
                  id: "es-0-3-2", da: "Engage in user interviews to gather insights and validate customer requirements."
                 },
                 {
                  id: "es-0-3-3", da: "Analyze feedback from existing customers to identify areas for improvement."
                 },
                 {
                  id: "es-0-3-4", da: "Continuously monitor customer sentiment through surveys and social media interactions."
                 },
                 {
                  id: "es-0-3-5", da: "Craft a compelling value proposition that addresses key customer challenges."
                 },
                 {
                  id: "es-0-3-6", da: "Focus on the unique benefits your product offers compared to competitors."
                 },
                 {
                  id: "es-0-3-7", da: "Clearly communicate how your product solves specific problems and adds value."
                 },
                 {
                  id: "es-0-3-8", da: "Align your value proposition with your target audience's goals and aspirations."
                 },
                 {
                  id: "es-0-3-9", da: "Test different value proposition messages to determine the most effective one."
                 },
                 {
                  id: "es-0-3-10", da: "Prioritize features based on their relevance and potential value to users."
                 },
                 {
                  id: "es-0-3-11", da: "Regularly update and refine existing features to align with user needs."
                 },
                 {
                  id: "es-0-3-12", da: "Introduce innovative features that address emerging customer demands."
                 },
                 {
                  id: "es-0-3-13", da: "Gather user feedback to identify feature gaps and opportunities for enhancement."
                 },
                 {
                  id: "es-0-3-14", da: "Consider customization options that allow users to tailor the product to their needs."
                 },
                 {
                  id: "es-0-3-15", da: "Focus on creating a seamless and intuitive user experience."
                 },
                 {
                  id: "es-0-3-16", da: "Streamline user flows and eliminate unnecessary steps or friction points."
                 },
                 {
                  id: "es-0-3-17", da: "Improve loading times and overall performance for a smoother experience."
                 },
                 {
                  id: "es-0-3-18", da: "Implement user-friendly onboarding to help users quickly understand the product."
                 },
                 {
                  id: "es-0-3-19", da: "Invest in a clean and visually appealing design that enhances usability."
                 },
                 {
                  id: "es-0-3-20", da: "Offer personalized recommendations based on user behavior and preferences."
                 },
                 {
                  id: "es-0-3-21", da: "Allow users to customize settings and features to suit their individual needs."
                 },
                 {
                  id: "es-0-3-22", da: "Implement dynamic content that adapts to each user's interests and interactions."
                 },
                 {
                  id: "es-0-3-23", da: "Use data analytics to identify personalized insights that deliver value."
                 },
                 {
                  id: "es-0-3-24", da: "Provide comprehensive user documentation and guides for product usage."
                 },
                 {
                  id: "es-0-3-25", da: "Develop tutorial videos and interactive resources to assist users."
                 },
                 {
                  id: "es-0-3-26", da: "Offer customer support channels that are responsive and helpful."
                 },
                 {
                  id: "es-0-3-27", da: "Establish a knowledge base or FAQ section to address common user queries."
                 },
                 {
                  id: "es-0-3-28", da: "Conduct regular webinars or training sessions to educate users on advanced features."
                 },
                 {
                  id: "es-0-3-29", da: "Encourage user feedback and suggestions for product improvement."
                 },
                 {
                  id: "es-0-3-30", da: "Actively engage with customer reviews to address concerns and feedback."
                 },
                 {
                  id: "es-0-3-31", da: "Regularly release updates that enhance the product's functionality and value."
                 },
                 {
                  id: "es-0-3-32", da: "Incorporate agile development methodologies to quickly respond to changing needs."
                 },
                 {
                  id: "es-0-3-33", da: "Use A\/B testing to assess the impact of changes on user engagement and satisfaction."
                 },
                 {
                  id: "es-0-3-34", da: "Implement analytics tools to track user behavior and product usage."
                 },
                 {
                  id: "es-0-3-35", da: "Analyze data to identify usage patterns and areas of high or low engagement."
                 },
                 {
                  id: "es-0-3-36", da: "Use data insights to refine user personas and tailor your value proposition."
                 },
                 {
                  id: "es-0-3-37", da: "Develop reports and dashboards that provide actionable insights to users."
                 },
                 {
                  id: "es-0-3-38", da: "Prioritize solving the most critical pain points your target audience faces."
                 },
                 {
                  id: "es-0-3-39", da: "Communicate how your product directly addresses these pain points."
                 },
                 {
                  id: "es-0-3-40", da: "Continuously gather feedback to ensure you're effectively addressing user pain points."
                 },
                 {
                  id: "es-0-3-41", da: "Monitor industry trends to identify emerging pain points and adapt your strategy."
                 },
                 {
                  id: "es-0-3-42", da: "Create educational content such as blog posts, eBooks, or webinars."
                 },
                 {
                  id: "es-0-3-43", da: "Offer resources that help users solve common challenges related to your product."
                 },
                 {
                  id: "es-0-3-44", da: "Share case studies and success stories that demonstrate your product's value."
                 },
                 {
                  id: "es-0-3-45", da: "Collaborate with experts to provide insights and tips related to your product."
                 },
                 {
                  id: "es-0-3-46", da: "Conduct competitive analysis to understand where your product excels."
                 },
                 {
                  id: "es-0-3-47", da: "Clearly highlight your product's advantages through direct comparisons."
                 },
                 {
                  id: "es-0-3-48", da: "Showcase how your product outperforms competitors in terms of features and benefits."
                 },
                 {
                  id: "es-0-3-49", da: "Provide objective data or metrics that demonstrate your product's superior value."
                 },
              ]
            },
            {
              id: 'es-0-4',
              pm: 'Team has the first ideas of how to monetize and build sustainable operations either by subscriptions, sales or donations.',
              title:'Business Model',
              pmMap: 'Team has the first ideas of how to monetize and build sustainable operations either by subscriptions, sales or donations.',
              developmentActions:[
                {
                  id: "es-0-4-0", da: "Conduct in-depth market research to identify evolving customer needs and trends."
                 },
                 {
                  id: "es-0-4-1", da: "Analyze customer behavior and preferences to understand their buying habits."
                 },
                 {
                  id: "es-0-4-2", da: "Define your target audience segments and their distinct needs."
                 },
                 {
                  id: "es-0-4-3", da: "Conduct surveys and interviews to gather feedback on your current business model."
                 },
                 {
                  id: "es-0-4-4", da: "Analyze your competitors' business models to identify opportunities for differentiation."
                 },
                 {
                  id: "es-0-4-5", da: "Reevaluate your product's value proposition based on customer feedback and market changes."
                 },
                 {
                  id: "es-0-4-6", da: "Identify new pain points that your product can address or underserved needs."
                 },
                 {
                  id: "es-0-4-7", da: "Ensure your value proposition is communicated clearly across marketing materials."
                 },
                 {
                  id: "es-0-4-8", da: "Consider different pricing strategies that align with the enhanced value proposition."
                 },
                 {
                  id: "es-0-4-9", da: "Test variations of your value proposition to see which resonates most with customers."
                 },
                 {
                  id: "es-0-4-10", da: "Review your pricing model and assess its competitiveness in the market."
                 },
                 {
                  id: "es-0-4-11", da: "Consider tiered pricing options to cater to different customer segments."
                 },
                 {
                  id: "es-0-4-12", da: "Experiment with subscription-based models or one-time purchase options."
                 },
                 {
                  id: "es-0-4-13", da: "Explore freemium or free trial models to attract new customers."
                 },
                 {
                  id: "es-0-4-14", da: "Implement dynamic pricing strategies that adjust based on usage or features."
                 },
                 {
                  id: "es-0-4-15", da: "Identify complementary products or services to bundle with your core offering."
                 },
                 {
                  id: "es-0-4-16", da: "Explore licensing, white-labeling, or reseller agreements to expand your reach."
                 },
                 {
                  id: "es-0-4-17", da: "Introduce premium features or add-ons that customers can purchase separately."
                 },
                 {
                  id: "es-0-4-18", da: "Develop upsell and cross-sell strategies to increase average transaction value."
                 },
                 {
                  id: "es-0-4-19", da: "Launch complementary products or services that align with your brand."
                 },
                 {
                  id: "es-0-4-20", da: "Reassess your customer acquisition channels and their effectiveness."
                 },
                 {
                  id: "es-0-4-21", da: "Develop a multi-channel approach that leverages online and offline channels."
                 },
                 {
                  id: "es-0-4-22", da: "Invest in content marketing to establish your brand as an industry authority."
                 },
                 {
                  id: "es-0-4-23", da: "Collaborate with influencers or partners to tap into their audience."
                 },
                 {
                  id: "es-0-4-24", da: "Refine your digital advertising campaigns for optimal targeting and ROI."
                 },
                 {
                  id: "es-0-4-25", da: "Evaluate your distribution channels for efficiency and cost-effectiveness."
                 },
                 {
                  id: "es-0-4-26", da: "Consider direct-to-consumer (DTC) options to have better control over the customer journey."
                 },
                 {
                  id: "es-0-4-27", da: "Explore partnerships with third-party retailers or distributors for wider reach."
                 },
                 {
                  id: "es-0-4-28", da: "Implement e-commerce and online storefronts for easy product access."
                 },
                 {
                  id: "es-0-4-29", da: "Optimize your supply chain and logistics to minimize delivery times and costs."
                 },
                 {
                  id: "es-0-4-30", da: "Revisit and update your Business Model Canvas to reflect current realities."
                 },
                 {
                  id: "es-0-4-31", da: "Examine each element of the canvas (value proposition, channels, revenue streams, etc.)."
                 },
                 {
                  id: "es-0-4-32", da: "Seek feedback from stakeholders, advisors, and customers on the canvas."
                 },
                 {
                  id: "es-0-4-33", da: "Use the canvas as a visual tool to brainstorm and iterate on your business model."
                 },
                 {
                  id: "es-0-4-34", da: "Explore the feasibility of offering subscription or membership plans."
                 },
                 {
                  id: "es-0-4-35", da: "Design subscription tiers with varying levels of features or benefits."
                 },
                 {
                  id: "es-0-4-36", da: "Develop a loyalty program that rewards customers for their long-term commitment."
                 },
                 {
                  id: "es-0-4-37", da: "Implement automatic renewal and billing processes to enhance convenience."
                 },
                 {
                  id: "es-0-4-38", da: "Communicate the long-term value of the subscription to customers."
                 },
                 {
                  id: "es-0-4-39", da: "Create partnerships with other businesses for mutually beneficial collaborations."
                 },
                 {
                  id: "es-0-4-40", da: "Develop an affiliate program that incentivizes partners to promote your product."
                 },
                 {
                  id: "es-0-4-41", da: "Offer referral bonuses or commissions to customers who refer new customers."
                 },
                 {
                  id: "es-0-4-42", da: "Build strategic alliances to extend your product's reach and tap into new markets."
                 },
                 {
                  id: "es-0-4-43", da: "Explore co-marketing initiatives with partners to expand brand visibility."
                 },
                 {
                  id: "es-0-4-44", da: "Challenge assumptions about your current business model and consider alternatives."
                 },
                 {
                  id: "es-0-4-45", da: "Test new business model hypotheses through small-scale pilots or experiments."
                 },
                 {
                  id: "es-0-4-46", da: "Embrace disruptive technologies that can enable novel business models."
                 },
                 {
                  id: "es-0-4-47", da: "Examine how platform-based or sharing economy models could apply to your industry."
                 },
                 {
                  id: "es-0-4-48", da: "Foster a culture of innovation within your team to encourage new business model ideas."
                 },
                 {
                  id: "es-0-4-49", da: "Continuously monitor industry trends and shifts that may require adapting your business model."
                 },
              ]
            },
            {
              id: 'es-0-5',
              pm: 'Team has identified its potential beneficiaries. Engage and collect feedback from a diverse set of potential buyers of the established offer.',
              title:'Go to Market',
              pmMap: 'Team has identified its potential beneficiaries. Engage and collect feedback from a diverse set of potential buyers of the established offer.',
              developmentActions:[
                {
                  id: "es-0-5-0", da: "Conduct thorough market research to understand customer needs and preferences."
                 },
                 {
                  id: "es-0-5-1", da: "Validate your product concept with potential customers before full development."
                 },
                 {
                  id: "es-0-5-2", da: "Gather insights on your target audience's pain points, behaviors, and motivations."
                 },
                 {
                  id: "es-0-5-3", da: "Identify key trends and changes in the market that may affect your strategy."
                 },
                 {
                  id: "es-0-5-4", da: "Analyze competitors and their go-to-market strategies to find opportunities."
                 },
                 {
                  id: "es-0-5-5", da: "Develop a clear and compelling value proposition that resonates with your target audience."
                 },
                 {
                  id: "es-0-5-6", da: "Craft messaging that communicates your product's unique benefits and solves specific problems."
                 },
                 {
                  id: "es-0-5-7", da: "Tailor your messaging to different customer segments for personalized communication."
                 },
                 {
                  id: "es-0-5-8", da: "Ensure consistency in messaging across all marketing channels and materials."
                 },
                 {
                  id: "es-0-5-9", da: "Test different messaging strategies to identify the most effective approach."
                 },
                 {
                  id: "es-0-5-10", da: "Define and segment your target audience based on demographics and psychographics."
                 },
                 {
                  id: "es-0-5-11", da: "Create detailed customer personas to understand their needs and behaviors."
                 },
                 {
                  id: "es-0-5-12", da: "Customize your marketing efforts to align with the characteristics of each persona."
                 },
                 {
                  id: "es-0-5-13", da: "Develop campaigns that speak directly to each persona's pain points and aspirations."
                 },
                 {
                  id: "es-0-5-14", da: "Continuously update personas based on customer feedback and evolving trends."
                 },
                 {
                  id: "es-0-5-15", da: "Identify the most suitable distribution channels for reaching your target customers."
                 },
                 {
                  id: "es-0-5-16", da: "Consider online platforms, brick-and-mortar retailers, e-commerce, or a combination."
                 },
                 {
                  id: "es-0-5-17", da: "Build partnerships with distributors, resellers, or affiliates to extend your reach."
                 },
                 {
                  id: "es-0-5-18", da: "Utilize social media and online marketplaces for direct-to-consumer sales."
                 },
                 {
                  id: "es-0-5-19", da: "Optimize your distribution strategy to ensure efficient product availability."
                 },
                 {
                  id: "es-0-5-20", da: "Develop a comprehensive marketing plan that outlines your promotional activities."
                 },
                 {
                  id: "es-0-5-21", da: "Utilize digital marketing channels such as social media, email, and content marketing."
                 },
                 {
                  id: "es-0-5-22", da: "Plan and execute paid advertising campaigns to drive initial awareness."
                 },
                 {
                  id: "es-0-5-23", da: "Leverage influencer marketing to reach a wider audience through trusted sources."
                 },
                 {
                  id: "es-0-5-24", da: "Implement search engine optimization (SEO) strategies to improve online visibility."
                 },
                 {
                  id: "es-0-5-25", da: "Produce valuable content that educates and engages your target audience."
                 },
                 {
                  id: "es-0-5-26", da: "Create blog posts, videos, webinars, and eBooks to establish thought leadership."
                 },
                 {
                  id: "es-0-5-27", da: "Foster engagement on social media by posting relevant content and interacting with users."
                 },
                 {
                  id: "es-0-5-28", da: "Develop a content calendar to ensure consistent and strategic content distribution."
                 },
                 {
                  id: "es-0-5-29", da: "Encourage user-generated content by showcasing customer success stories."
                 },
                 {
                  id: "es-0-5-30", da: "Develop a well-defined launch plan with specific timelines and milestones."
                 },
                 {
                  id: "es-0-5-31", da: "Use teaser campaigns to create anticipation and excitement before the launch."
                 },
                 {
                  id: "es-0-5-32", da: "Organize a launch event or webinar to showcase your product's features and benefits."
                 },
                 {
                  id: "es-0-5-33", da: "Offer exclusive early access or discounts to reward early adopters."
                 },
                 {
                  id: "es-0-5-34", da: "Collaborate with influencers or industry partners to amplify your launch."
                 },
                 {
                  id: "es-0-5-35", da: "Provide your sales team with comprehensive training on your product's features and benefits."
                 },
                 {
                  id: "es-0-5-36", da: "Equip them with sales collateral, presentations, and FAQs for effective pitching."
                 },
                 {
                  id: "es-0-5-37", da: "Develop sales scripts that address common objections and highlight value propositions."
                 },
                 {
                  id: "es-0-5-38", da: "Implement a CRM system to track leads, manage customer interactions, and analyze data."
                 },
                 {
                  id: "es-0-5-39", da: "Foster a feedback loop between sales and product teams to improve alignment."
                 },
                 {
                  id: "es-0-5-40", da: "Offer excellent customer support to address inquiries and resolve issues promptly."
                 },
                 {
                  id: "es-0-5-41", da: "Develop user-friendly onboarding materials and guides for new customers."
                 },
                 {
                  id: "es-0-5-42", da: "Implement self-service options, such as FAQs and knowledge bases, for common queries."
                 },
                 {
                  id: "es-0-5-43", da: "Gather feedback from early customers to identify areas for improvement in onboarding."
                 },
                 {
                  id: "es-0-5-44", da: "Provide proactive support to ensure a smooth transition for new users."
                 },
                 {
                  id: "es-0-5-45", da: "Establish a mechanism for collecting and acting upon customer feedback."
                 },
                 {
                  id: "es-0-5-46", da: "Regularly review customer feedback to identify areas for enhancement."
                 },
                 {
                  id: "es-0-5-47", da: "Use feedback to iterate on your product, marketing, and sales strategies."
                 },
                 {
                  id: "es-0-5-48", da: "Communicate improvements made based on customer suggestions to build trust."
                 },
                 {
                  id: "es-0-5-49", da: "Continuously refine your go-to-market strategy based on real-world results and insights."
                 },
              ]
            },
            {
              id: 'es-0-6',
              pm: 'At least 2 communicty moderators with complementary skillset, ideally a business and technical founder who have aligned value commitments.',
              title:'People',
              pmMap: 'At least 2 communicty moderators with complementary skillset, ideally a business and technical founder who have aligned value commitments.',
              developmentActions:[
                {
                  id: "es-0-6-0", da: "Assemble a diverse team with a mix of skills and expertise."
                 },
                 {
                  id: "es-0-6-1", da: "Foster a collaborative and inclusive team culture."
                 },
                 {
                  id: "es-0-6-2", da: "Define clear roles and responsibilities for team members."
                 },
                 {
                  id: "es-0-6-3", da: "Encourage open communication and idea sharing among team members."
                 },
                 {
                  id: "es-0-6-4", da: "Leverage team-building activities to strengthen relationships and trust."
                 },
                 {
                  id: "es-0-6-5", da: "Recruit skilled professionals who align with your product vision."
                 },
                 {
                  id: "es-0-6-6", da: "Invest in continuous learning and professional development for your team."
                 },
                 {
                  id: "es-0-6-7", da: "Provide mentorship and coaching to support team members' growth."
                 },
                 {
                  id: "es-0-6-8", da: "Encourage cross-functional learning to enhance skill diversity."
                 },
                 {
                  id: "es-0-6-9", da: "Foster a culture of innovation by rewarding creative thinking and risk-taking."
                 },
                 {
                  id: "es-0-6-10", da: "Instill empathy for users by regularly engaging with them and understanding their needs."
                 },
                 {
                  id: "es-0-6-11", da: "Encourage team members to put themselves in users' shoes when making decisions."
                 },
                 {
                  id: "es-0-6-12", da: "Organize user testing sessions to gain direct insights into user experiences."
                 },
                 {
                  id: "es-0-6-13", da: "Incorporate user feedback into the development process to drive improvements."
                 },
                 {
                  id: "es-0-6-14", da: "Prioritize features and enhancements based on their impact on user value."
                 },
                 {
                  id: "es-0-6-15", da: "Ensure all team members have a shared understanding of the product vision."
                 },
                 {
                  id: "es-0-6-16", da: "Use regular meetings to communicate progress, challenges, and goals."
                 },
                 {
                  id: "es-0-6-17", da: "Establish clear communication channels for both formal and informal discussions."
                 },
                 {
                  id: "es-0-6-18", da: "Encourage transparency by openly sharing successes, setbacks, and learnings."
                 },
                 {
                  id: "es-0-6-19", da: "Implement project management tools to track tasks and ensure accountability."
                 },
                 {
                  id: "es-0-6-20", da: "Promote collaboration between developers, designers, marketers, and other teams."
                 },
                 {
                  id: "es-0-6-21", da: "Create interdisciplinary teams to foster cross-pollination of ideas."
                 },
                 {
                  id: "es-0-6-22", da: "Organize regular cross-functional workshops to address complex challenges."
                 },
                 {
                  id: "es-0-6-23", da: "Break down silos and encourage knowledge sharing across departments."
                 },
                 {
                  id: "es-0-6-24", da: "Collaborate with external experts or consultants to bring fresh perspectives."
                 },
                 {
                  id: "es-0-6-25", da: "Adopt Agile frameworks like Scrum or Kanban to enhance flexibility and responsiveness."
                 },
                 {
                  id: "es-0-6-26", da: "Implement regular sprint planning and review meetings to keep projects on track."
                 },
                 {
                  id: "es-0-6-27", da: "Encourage iterative development and quick feedback loops."
                 },
                 {
                  id: "es-0-6-28", da: "Use retrospectives to reflect on the team's performance and identify improvements."
                 },
                 {
                  id: "es-0-6-29", da: "Embrace change and adapt plans based on evolving needs and insights."
                 },
                 {
                  id: "es-0-6-30", da: "Create an inclusive environment that values diverse perspectives."
                 },
                 {
                  id: "es-0-6-31", da: "Promote gender, ethnic, and cultural diversity within your team."
                 },
                 {
                  id: "es-0-6-32", da: "Seek input from team members with varying backgrounds to enrich decision-making."
                 },
                 {
                  id: "es-0-6-33", da: "Use diversity as a competitive advantage in problem-solving and creativity."
                 },
                 {
                  id: "es-0-6-34", da: "Incorporate accessibility features to ensure your product is usable by everyone."
                 },
                 {
                  id: "es-0-6-35", da: "Foster a culture that embraces continuous learning and adaptation."
                 },
                 {
                  id: "es-0-6-36", da: "Encourage experimentation and risk-taking to drive innovation."
                 },
                 {
                  id: "es-0-6-37", da: "Implement a process for post-project reviews to identify areas for improvement."
                 },
                 {
                  id: "es-0-6-38", da: "Celebrate successes and milestones to boost team morale."
                 },
                 {
                  id: "es-0-6-39", da: "Establish mechanisms for gathering feedback on team dynamics and collaboration."
                 },
                 {
                  id: "es-0-6-40", da: "Provide clear direction while allowing team members to make decisions within their expertise."
                 },
                 {
                  id: "es-0-6-41", da: "Empower team members to take ownership of their work and contribute ideas."
                 },
                 {
                  id: "es-0-6-42", da: "Lead by example, demonstrating commitment, dedication, and a positive attitude."
                 },
                 {
                  id: "es-0-6-43", da: "Encourage autonomy by giving team members the freedom to explore creative solutions."
                 },
                 {
                  id: "es-0-6-44", da: "Regularly recognize and reward exceptional performance and contributions."
                 },
                 {
                  id: "es-0-6-45", da: "Address conflicts constructively to maintain a healthy team dynamic."
                 },
                 {
                  id: "es-0-6-46", da: "Establish a feedback-rich environment where constructive criticism is welcomed."
                 },
                 {
                  id: "es-0-6-47", da: "Implement regular one-on-one check-ins to address concerns and provide support."
                 },
                 {
                  id: "es-0-6-48", da: "Create a safe space for team members to express ideas, concerns, and challenges."
                 },
                 {
                  id: "es-0-6-49", da: "Continuously refine team processes based on feedback to improve collaboration."
                 },
              ]
            },
            {
              id: 'es-0-7',
              pm: 'Team knows how they will measure initial success and KPIs to aim for.',
              title:'Data Metrics',
              pmMap: 'Team knows how they will measure initial success and KPIs to aim for.',
              developmentActions:[
                {
                  id: "es-0-7-0", da: "Identify key performance indicators (KPIs) relevant to your product goals."
                 },
                 {
                  id: "es-0-7-1", da: "Implement tracking tools (e.g., Google Analytics, Mixpanel) to collect data."
                 },
                 {
                  id: "es-0-7-2", da: "Set up event tracking to capture user interactions and behaviors."
                 },
                 {
                  id: "es-0-7-3", da: "Integrate data from different sources into a centralized analytics platform."
                 },
                 {
                  id: "es-0-7-4", da: "Ensure data collection is compliant with privacy regulations (e.g., GDPR, CCPA)."
                 },
                 {
                  id: "es-0-7-5", da: "Regularly audit and clean your data to remove duplicates and inaccuracies."
                 },
                 {
                  id: "es-0-7-6", da: "Implement data validation checks to prevent input errors and anomalies."
                 },
                 {
                  id: "es-0-7-7", da: "Establish data governance practices to maintain data accuracy and consistency."
                 },
                 {
                  id: "es-0-7-8", da: "Monitor data quality metrics and set up alerts for anomalies."
                 },
                 {
                  id: "es-0-7-9", da: "Conduct periodic data quality assessments to ensure reliable insights."
                 },
                 {
                  id: "es-0-7-10", da: "Create dashboards that visualize KPIs and trends for easy interpretation."
                 },
                 {
                  id: "es-0-7-11", da: "Implement interactive data visualizations for in-depth exploration."
                 },
                 {
                  id: "es-0-7-12", da: "Generate automated reports that provide regular insights to stakeholders."
                 },
                 {
                  id: "es-0-7-13", da: "Customize dashboards for different user roles to ensure relevance."
                 },
                 {
                  id: "es-0-7-14", da: "Include historical data to track progress over time and identify patterns."
                 },
                 {
                  id: "es-0-7-15", da: "Analyze user flows to identify drop-off points and areas of improvement."
                 },
                 {
                  id: "es-0-7-16", da: "Use funnel analysis to track user journeys and conversion rates."
                 },
                 {
                  id: "es-0-7-17", da: "Study heatmaps and click maps to understand user interactions on your platform."
                 },
                 {
                  id: "es-0-7-18", da: "Employ session replay tools to visualize user experiences and pain points."
                 },
                 {
                  id: "es-0-7-19", da: "Analyze user segmentation to understand how different user groups engage."
                 },
                 {
                  id: "es-0-7-20", da: "Implement A\/B testing to compare variations of features or designs."
                 },
                 {
                  id: "es-0-7-21", da: "Experiment with different call-to-actions to optimize user engagement."
                 },
                 {
                  id: "es-0-7-22", da: "Test pricing strategies to identify the most effective revenue-generating model."
                 },
                 {
                  id: "es-0-7-23", da: "Use split testing to evaluate different marketing messages or landing pages."
                 },
                 {
                  id: "es-0-7-24", da: "Leverage multivariate testing for more complex experiments."
                 },
                 {
                  id: "es-0-7-25", da: "Utilize machine learning to predict user behaviors and trends."
                 },
                 {
                  id: "es-0-7-26", da: "Develop models to forecast demand or customer churn rates."
                 },
                 {
                  id: "es-0-7-27", da: "Implement algorithms to recommend personalized content or products."
                 },
                 {
                  id: "es-0-7-28", da: "Analyze past data to identify patterns that can inform future decisions."
                 },
                 {
                  id: "es-0-7-29", da: "Use predictive analytics to optimize inventory management and resource allocation."
                 },
                 {
                  id: "es-0-7-30", da: "Segment users into cohorts based on specific attributes or timeframes."
                 },
                 {
                  id: "es-0-7-31", da: "Analyze how different cohorts interact with your product over time."
                 },
                 {
                  id: "es-0-7-32", da: "Identify trends, changes, or anomalies in user behavior by cohort."
                 },
                 {
                  id: "es-0-7-33", da: "Adjust strategies based on cohort analysis to improve user engagement."
                 },
                 {
                  id: "es-0-7-34", da: "Track cohorts to measure the long-term impact of changes you implement."
                 },
                 {
                  id: "es-0-7-35", da: "Analyze conversion funnels to identify areas for optimization."
                 },
                 {
                  id: "es-0-7-36", da: "A\/B test landing pages and forms to increase conversion rates."
                 },
                 {
                  id: "es-0-7-37", da: "Optimize checkout processes to reduce cart abandonment rates."
                 },
                 {
                  id: "es-0-7-38", da: "Study user engagement with specific content to improve engagement rates."
                 },
                 {
                  id: "es-0-7-39", da: "Test different pricing strategies to maximize conversion and revenue."
                 },
                 {
                  id: "es-0-7-40", da: "Monitor user churn rates to understand where users drop off."
                 },
                 {
                  id: "es-0-7-41", da: "Analyze the characteristics of churned users to identify common factors."
                 },
                 {
                  id: "es-0-7-42", da: "Develop targeted retention strategies based on churn analysis."
                 },
                 {
                  id: "es-0-7-43", da: "Implement personalized re-engagement campaigns for inactive users."
                 },
                 {
                  id: "es-0-7-44", da: "Continuously assess the impact of retention efforts on reducing churn."
                 },
                 {
                  id: "es-0-7-45", da: "ncorporate qualitative user feedback alongside quantitative metrics."
                 },
                 {
                  id: "es-0-7-46", da: "Analyze sentiment from user reviews and feedback for insights."
                 },
                 {
                  id: "es-0-7-47", da: "Use feedback to identify pain points and areas of improvement."
                 },
                 {
                  id: "es-0-7-48", da: "Prioritize feature enhancements based on user demand and feedback."
                 },
                 {
                  id: "es-0-7-49", da: "Continuously iterate based on user feedback to improve the user experience."
                 },
              ]
            },
            {
              id: 'es-0-8',
              pm: 'Team has productivity tools in place to set clear deadline to reach first milestone, e.g. Early Subscribers, tests, market testing milestone.',
              title:'Operations',
              pmMap: 'Team has productivity tools in place to set clear deadline to reach first milestone, e.g. Early Subscribers, tests, market testing milestone.',
              developmentActions:[
                {
                  id: "es-0-8-0", da: "Map out and document all operational processes."
                 },
                 {
                  id: "es-0-8-1", da: "Identify bottlenecks and inefficiencies in workflows."
                 },
                 {
                  id: "es-0-8-2", da: "Streamline processes to eliminate redundant steps."
                 },
                 {
                  id: "es-0-8-3", da: "Implement automation tools to expedite repetitive tasks."
                 },
                 {
                  id: "es-0-8-4", da: "Regularly review and refine operational processes for continuous improvement."
                 },
                 {
                  id: "es-0-8-5", da: "Establish a reliable and efficient supply chain for physical products."
                 },
                 {
                  id: "es-0-8-6", da: "Monitor inventory levels and implement just-in-time inventory practices."
                 },
                 {
                  id: "es-0-8-7", da: "Develop relationships with suppliers for better cost and delivery terms."
                 },
                 {
                  id: "es-0-8-8", da: "Implement demand forecasting to ensure stock availability."
                 },
                 {
                  id: "es-0-8-9", da: "Implement quality control measures to ensure consistent product quality."
                 },
                 {
                  id: "es-0-8-10", da: "Optimize shipping and fulfillment processes for timely deliveries."
                 },
                 {
                  id: "es-0-8-11", da: "Implement a robust order management system to track orders."
                 },
                 {
                  id: "es-0-8-12", da: "Offer multiple shipping options to cater to customer preferences."
                 },
                 {
                  id: "es-0-8-13", da: "Provide order tracking and delivery notifications to keep customers informed."
                 },
                 {
                  id: "es-0-8-14", da: "Continuously monitor and improve delivery times and accuracy."
                 },
                 {
                  id: "es-0-8-15", da: "Establish clear customer support channels for inquiries and assistance."
                 },
                 {
                  id: "es-0-8-16", da: "Implement a ticketing system to manage and prioritize support requests."
                 },
                 {
                  id: "es-0-8-17", da: "Train customer service representatives to handle diverse inquiries."
                 },
                 {
                  id: "es-0-8-18", da: "Offer self-service options, such as FAQs and chatbots, for common queries."
                 },
                 {
                  id: "es-0-8-19", da: "Continuously gather feedback to identify areas for improvement in customer support."
                 },
                 {
                  id: "es-0-8-20", da: "Implement monitoring tools to track system performance and uptime."
                 },
                 {
                  id: "es-0-8-21", da: "Set up alerts for any deviations from expected performance."
                 },
                 {
                  id: "es-0-8-22", da: "Continuously monitor website load times and page responsiveness."
                 },
                 {
                  id: "es-0-8-23", da: "Use performance data to identify areas for optimization and scaling."
                 },
                 {
                  id: "es-0-8-24", da: "Conduct load testing to ensure your systems can handle peak traffic."
                 },
                 {
                  id: "es-0-8-25", da: "Establish strong relationships with key technology vendors."
                 },
                 {
                  id: "es-0-8-26", da: "Regularly review vendor performance and negotiate terms."
                 },
                 {
                  id: "es-0-8-27", da: "Keep up-to-date with vendor updates, patches, and upgrades."
                 },
                 {
                  id: "es-0-8-28", da: "Develop contingency plans for vendor disruptions or failures."
                 },
                 {
                  id: "es-0-8-29", da: "Explore opportunities for collaboration and co-development with vendors."
                 },
                 {
                  id: "es-0-8-30", da: "Stay informed about relevant industry regulations and standards."
                 },
                 {
                  id: "es-0-8-31", da: "Ensure your product and operations are compliant with data privacy laws."
                 },
                 {
                  id: "es-0-8-32", da: "Implement necessary security measures to protect customer data."
                 },
                 {
                  id: "es-0-8-33", da: "Establish a process for auditing and documenting compliance efforts."
                 },
                 {
                  id: "es-0-8-34", da: "Educate your team about compliance requirements to prevent violations."
                 },
                 {
                  id: "es-0-8-35", da: "Avoid overreliance on a single vendor or supplier."
                 },
                 {
                  id: "es-0-8-36", da: "Establish relationships with multiple vendors for critical components."
                 },
                 {
                  id: "es-0-8-37", da: "Develop contingency plans to quickly switch vendors if needed."
                 },
                 {
                  id: "es-0-8-38", da: "Regularly assess vendor performance and reliability."
                 },
                 {
                  id: "es-0-8-39", da: "Diversify your vendor network to ensure a stable supply chain."
                 },
              ]
            },
            {
              id: 'es-0-9',
              pm: 'The team possesses a basic understanding of bringing the community to a sustainable future, with aligned aspiration to scale and fund the community.',
              title:'Exit Strategy',
              pmMap: 'The team possesses a basic understanding of bringing the community to a sustainable future, with aligned aspiration to scale and fund the community.',
              developmentActions:[
                {
                  id: "es-0-9-0", da: "Define clear exit goals and objectives for your product."
                 },
                 {
                  id: "es-0-9-1", da: "Determine the criteria that would trigger the need for an exit."
                 },
                 {
                  id: "es-0-9-2", da: "Consider various exit options (selling, merging, winding down) and their implications."
                 },
                 {
                  id: "es-0-9-3", da: "Establish a timeline for executing the exit strategy."
                 },
                 {
                  id: "es-0-9-4", da: "Consult legal and financial experts to ensure a well-informed decision."
                 },
                 {
                  id: "es-0-9-5", da: "Organize and document all intellectual property, patents, and copyrights."
                 },
                 {
                  id: "es-0-9-6", da: "Ensure proper licensing agreements for third-party components."
                 },
                 {
                  id: "es-0-9-7", da: "Clearly outline ownership and rights in agreements with team members."
                 },
                 {
                  id: "es-0-9-8", da: "Keep records of all development processes, decisions, and iterations."
                 },
                 {
                  id: "es-0-9-9", da: "Prepare all legal documents related to the product's ownership and usage."
                 },
                 {
                  id: "es-0-9-10", da: "Conduct a comprehensive valuation of your product and its assets."
                 },
                 {
                  id: "es-0-9-11", da: "Assess the financial health and profitability of the product."
                 },
                 {
                  id: "es-0-9-12", da: "Evaluate potential risks and liabilities that may affect its value."
                 },
                 {
                  id: "es-0-9-13", da: "Seek financial advice to determine the most advantageous exit strategy."
                 },
                 {
                  id: "es-0-9-14", da: "Perform sensitivity analysis to understand different exit scenarios' outcomes."
                 },
                 {
                  id: "es-0-9-15", da: "Research potential buyers or partners who may be interested."
                 },
                 {
                  id: "es-0-9-16", da: "Establish relationships with potential acquirers or investors."
                 },
                 {
                  id: "es-0-9-17", da: "Use industry events and networking opportunities to connect with potential buyers."
                 },
                 {
                  id: "es-0-9-18", da: "Create marketing materials that highlight the product's value proposition."
                 },
                 {
                  id: "es-0-9-19", da: "Evaluate the alignment of potential buyers' goals with your exit strategy."
                 },
                 {
                  id: "es-0-9-20", da: "Organize all relevant financial, legal, and operational documentation."
                 },
                 {
                  id: "es-0-9-21", da: "Address any potential issues that may arise during due diligence."
                 },
                 {
                  id: "es-0-9-22", da: "Conduct a thorough self-audit to identify areas that need improvement."
                 },
                 {
                  id: "es-0-9-23", da: "Ensure your product's compliance with industry regulations and standards."
                 },
                 {
                  id: "es-0-9-24", da: "Prepare a detailed report on the product's performance and potential growth."
                 },
                 {
                  id: "es-0-9-25", da: "Engage in negotiations with potential buyers or investors."
                 },
                 {
                  id: "es-0-9-26", da: "Define terms, conditions, and agreements in a clear and comprehensive manner."
                 },
                 {
                  id: "es-0-9-27", da: "Consult legal counsel to ensure agreements are legally binding and protective."
                 },
                 {
                  id: "es-0-9-28", da: "Address concerns, questions, and potential roadblocks during negotiations."
                 },
                 {
                  id: "es-0-9-29", da: "Seek win-win solutions that satisfy both parties' interests."
                 },
                 {
                  id: "es-0-9-30", da: "Develop a comprehensive knowledge transfer plan for the acquiring team."
                 },
                 {
                  id: "es-0-9-31", da: "Document all critical processes, workflows, and decision-making procedures."
                 },
                 {
                  id: "es-0-9-32", da: "Provide training sessions to ensure a smooth transition for the acquiring team."
                 },
                 {
                  id: "es-0-9-33", da: "Assign responsible individuals for supporting the transition process."
                 },
                 {
                  id: "es-0-9-34", da: "Ensure that the acquiring team has access to all necessary tools and resources."
                 },
                 {
                  id: "es-0-9-35", da: "Communicate the upcoming exit to your customers with transparency."
                 },
                 {
                  id: "es-0-9-36", da: "Provide clear information about the impact of the exit on their experience."
                 },
                 {
                  id: "es-0-9-37", da: "Offer support for migrating to alternative solutions, if applicable."
                 },
                 {
                  id: "es-0-9-38", da: "Gather feedback from customers to address their concerns and needs."
                 },
                 {
                  id: "es-0-9-39", da: "Establish a dedicated customer support channel for exit-related queries."
                 },
                 {
                  id: "es-0-9-40", da: "Communicate the exit strategy transparently to your team."
                 },
                 {
                  id: "es-0-9-41", da: "Provide support and resources to team members affected by the exit."
                 },
                 {
                  id: "es-0-9-42", da: "Offer assistance in finding new opportunities or roles for team members."
                 },
                 {
                  id: "es-0-9-43", da: "Facilitate a smooth handover of responsibilities to the acquiring team."
                 },
                 {
                  id: "es-0-9-44", da: "Consider retention incentives for key team members during the transition."
                 },
                 {
                  id: "es-0-9-45", da: "Ensure compliance with all legal requirements for the chosen exit strategy."
                 },
                 {
                  id: "es-0-9-46", da: "Obtain any necessary approvals from regulatory bodies or authorities."
                 },
                 {
                  id: "es-0-9-47", da: "Address potential legal obstacles or challenges that may arise."
                 },
                 {
                  id: "es-0-9-48", da: "Seek legal advice to ensure all contracts and agreements are in order."
                 },
                 {
                  id: "es-0-9-49", da: "Develop a contingency plan to address unexpected legal issues during the exit."
                 },
              ]
            },
          ]
        },
        {
          id: 'es-1',
          icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
          comp: 'Problem Solution Fit',
          wdd: '',
          progressMeasures:[
            {
              id: 'es-1-0',
              pm: 'Team has gained deep understanding of social pains, job-to-be-done and desired outcome by talking to participants. Team is able to express its vision of what large scale success looks like.',
              title:'Need',
              pmMap: 'Team has gained deep understanding of social pains, job-to-be-done and desired outcome by talking to participants. Team is able to express its vision of what large scale success looks like.',
              developmentActions:[
                {
                  id: "es-1-0-0", da: "Conduct in-depth customer interviews to uncover pain points and challenges."
                 },
                 {
                  id: "es-1-0-1", da: "Develop detailed customer personas to understand their needs and preferences."
                 },
                 {
                  id: "es-1-0-2", da: "Use surveys to gather quantitative data on specific pain points."
                 },
                 {
                  id: "es-1-0-3", da: "Analyze customer feedback from reviews, support interactions, and social media."
                 },
                 {
                  id: "es-1-0-4", da: "Explore online forums and communities to identify common pain points."
                 },
                 {
                  id: "es-1-0-5", da: "Implement analytics tools to track user behavior on your product."
                 },
                 {
                  id: "es-1-0-6", da: "Study user flows and interactions to identify areas of frustration."
                 },
                 {
                  id: "es-1-0-7", da: "Analyze drop-off points and bounce rates to pinpoint usability issues."
                 },
                 {
                  id: "es-1-0-8", da: "Monitor session recordings to understand how users navigate your product."
                 },
                 {
                  id: "es-1-0-9", da: "Use heatmaps to visualize where users engage most and encounter obstacles."
                 },
                 {
                  id: "es-1-0-10", da: "Study competitors to identify which pain points they're addressing."
                 },
                 {
                  id: "es-1-0-11", da: "Analyze their product offerings and features to find gaps."
                 },
                 {
                  id: "es-1-0-12", da: "Read user reviews of competitor products to understand user sentiment."
                 },
                 {
                  id: "es-1-0-13", da: "Look for opportunities to differentiate by addressing unmet needs."
                 },
                 {
                  id: "es-1-0-14", da: "Benchmark your product against competitors to highlight unique value."
                 },
                 {
                  id: "es-1-0-15", da: "Develop prototypes quickly to test potential solutions."
                 },
                 {
                  id: "es-1-0-16", da: "Gather user feedback on prototypes to identify usability issues."
                 },
                 {
                  id: "es-1-0-17", da: "Iterate on prototypes based on user feedback to refine solutions."
                 },
                 {
                  id: "es-1-0-18", da: "Test various features and designs to validate problem-solution fit."
                 },
                 {
                  id: "es-1-0-19", da: "Use rapid prototyping tools to expedite the testing process."
                 },
                 {
                  id: "es-1-0-20", da: "Conduct usability testing to observe how users interact with your product."
                 },
                 {
                  id: "es-1-0-21", da: "Provide users with specific tasks to perform and observe their struggles."
                 },
                 {
                  id: "es-1-0-22", da: "Encourage users to think aloud during testing to capture their thought process."
                 },
                 {
                  id: "es-1-0-23", da: "Analyze user testing feedback to identify areas that need improvement."
                 },
                 {
                  id: "es-1-0-24", da: "Continuously iterate on the product based on user testing insights."
                 },
                 {
                  id: "es-1-0-25", da: "Map out the entire customer journey to identify pain points."
                 },
                 {
                  id: "es-1-0-26", da: "Focus on touchpoints where customers face challenges or frustration."
                 },
                 {
                  id: "es-1-0-27", da: "Develop solutions that address pain points at each stage of the journey."
                 },
                 {
                  id: "es-1-0-28", da: "Consider emotional aspects of the journey and address user emotions."
                 },
                 {
                  id: "es-1-0-29", da: "Continuously update the customer journey map as you gather insights."
                 },
                 {
                  id: "es-1-0-30", da: "Analyze user data to identify patterns and trends."
                 },
                 {
                  id: "es-1-0-31", da: "Use data to understand when and why users drop off."
                 },
                 {
                  id: "es-1-0-32", da: "Look for correlations between user behavior and specific pain points."
                 },
                 {
                  id: "es-1-0-33", da: "Implement user segmentation to tailor solutions to different groups."
                 },
                 {
                  id: "es-1-0-34", da: "Combine qualitative and quantitative data for a holistic view."
                 },
                 {
                  id: "es-1-0-35", da: "Create surveys to directly ask users about their pain points."
                 },
                 {
                  id: "es-1-0-36", da: "Collect feedback at various touchpoints to gather ongoing insights."
                 },
                 {
                  id: "es-1-0-37", da: "Ask open-ended questions to encourage users to share their challenges."
                 },
                 {
                  id: "es-1-0-38", da: "Implement Net Promoter Score (NPS) surveys to gauge overall satisfaction."
                 },
                 {
                  id: "es-1-0-39", da: "Use feedback to continuously validate and refine your understanding of needs."
                 },
                 {
                  id: "es-1-0-40", da: "Stay informed about industry trends and challenges."
                 },
                 {
                  id: "es-1-0-41", da: "Attend industry events, conferences, and webinars for insights."
                 },
                 {
                  id: "es-1-0-42", da: "Read industry publications, reports, and whitepapers."
                 },
                 {
                  id: "es-1-0-43", da: "Engage with thought leaders and experts to understand evolving needs."
                 },
                 {
                  id: "es-1-0-44", da: "Network with peers in your industry to exchange insights."
                 },
                 {
                  id: "es-1-0-45", da: "Cultivate empathy for your users to deeply understand their perspectives."
                 },
                 {
                  id: "es-1-0-46", da: "Engage in conversations with users to hear their stories and pain points."
                 },
                 {
                  id: "es-1-0-47", da: "Show genuine interest in helping users overcome their challenges."
                 },
                 {
                  id: "es-1-0-48", da: "Create user communities where they can share experiences and insights."
                 },
                 {
                  id: "es-1-0-49", da: "Continuously prioritize user needs in your product development decisions."
                 },
              ]
            },
            {
              id: 'es-1-1',
              pm: 'Team has clarity on the barriers (legal, technical, regulatory, etc.) they need to overcome to successfully enter the market and understand alternatives.',
              title:'Market',
              pmMap: 'Team has clarity on the barriers (legal, technical, regulatory, etc.) they need to overcome to successfully enter the market and understand alternatives.',
              developmentActions:[
                {
                  id: "es-1-1-0", da: "Conduct thorough market research to identify current trends and demands."
                 },
                 {
                  id: "es-1-1-1", da: "Segment the market to understand different customer groups."
                 },
                 {
                  id: "es-1-1-2", da: "Study the demographics, behaviors, and preferences of your target audience."
                 },
                 {
                  id: "es-1-1-3", da: "Identify emerging pain points and challenges in your target market."
                 },
                 {
                  id: "es-1-1-4", da: "Analyze macroeconomic factors that could impact the market's needs."
                 },
                 {
                  id: "es-1-1-5", da: "Conduct in-depth interviews with potential customers to understand their pain points."
                 },
                 {
                  id: "es-1-1-6", da: "Ask open-ended questions to uncover hidden needs and motivations."
                 },
                 {
                  id: "es-1-1-7", da: "Listen actively and empathetically to capture nuanced insights."
                 },
                 {
                  id: "es-1-1-8", da: "Use probing questions to go deeper into customers' pain points."
                 },
                 {
                  id: "es-1-1-9", da: "Analyze interview data to identify common themes and challenges."
                 },
                 {
                  id: "es-1-1-10", da: "Test your assumptions about customer pain points through pilot programs."
                 },
                 {
                  id: "es-1-1-11", da: "Develop MVPs (Minimum Viable Products) to validate the relevance of your solution."
                 },
                 {
                  id: "es-1-1-12", da: "Gather feedback from users to confirm whether you're solving real problems."
                 },
                 {
                  id: "es-1-1-13", da: "Analyze user behavior with MVPs to assess engagement and usage patterns."
                 },
                 {
                  id: "es-1-1-14", da: "Conduct surveys to validate the priority and intensity of pain points."
                 },
                 {
                  id: "es-1-1-15", da: "Identify competitors in your market and study their offerings."
                 },
                 {
                  id: "es-1-1-16", da: "Analyze their strengths and weaknesses to find gaps in the market."
                 },
                 {
                  id: "es-1-1-17", da: "Look for underserved segments or unaddressed pain points."
                 },
                 {
                  id: "es-1-1-18", da: "Identify areas where your product can differentiate by solving unique problems."
                 },
                 {
                  id: "es-1-1-19", da: "Learn from competitor reviews and user feedback to enhance your solution."
                 },
                 {
                  id: "es-1-1-20", da: "Gain industry expertise to better understand market dynamics."
                 },
                 {
                  id: "es-1-1-21", da: "Engage with industry forums, webinars, and associations."
                 },
                 {
                  id: "es-1-1-22", da: "Network with professionals to gain insights into industry challenges."
                 },
                 {
                  id: "es-1-1-23", da: "Collaborate with industry experts to validate your understanding of pain points."
                 },
                 {
                  id: "es-1-1-24", da: "Leverage industry reports and studies for deeper insights."
                 },
                 {
                  id: "es-1-1-25", da: "Create detailed buyer personas to represent different customer segments."
                 },
                 {
                  id: "es-1-1-26", da: "Include pain points, motivations, and goals in persona profiles."
                 },
                 {
                  id: "es-1-1-27", da: "Develop empathy maps to visualize persona emotions and behaviors."
                 },
                 {
                  id: "es-1-1-28", da: "Use personas to guide your product development decisions."
                 },
                 {
                  id: "es-1-1-29", da: "Continuously update personas based on new insights and feedback."
                 },
                 {
                  id: "es-1-1-30", da: "dentify and engage with early adopters in your target market."
                 },
                 {
                  id: "es-1-1-31", da: "Build relationships and gather insights through personalized interactions."
                 },
                 {
                  id: "es-1-1-32", da: "Involve early adopters in product testing and iteration."
                 },
                 {
                  id: "es-1-1-33", da: "Leverage their feedback to refine your solution's alignment with their needs."
                 },
                 {
                  id: "es-1-1-34", da: "Develop case studies featuring early adopters' success stories."
                 },
                 {
                  id: "es-1-1-35", da: "Create surveys to gather quantitative data on pain points."
                 },
                 {
                  id: "es-1-1-36", da: "Ask direct questions about challenges customers are facing."
                 },
                 {
                  id: "es-1-1-37", da: "Use ranking or rating scales to assess the intensity of pain points."
                 },
                 {
                  id: "es-1-1-38", da: "Analyze survey data to prioritize which pain points to address."
                 },
                 {
                  id: "es-1-1-39", da: "Regularly conduct surveys to track changes in pain point intensity."
                 },
                 {
                  id: "es-1-1-40", da: "Use data analytics tools to monitor user behaviors and patterns."
                 },
                 {
                  id: "es-1-1-41", da: "Identify patterns that point to specific pain points or unmet needs."
                 },
                 {
                  id: "es-1-1-42", da: "Analyze user engagement data to understand where users struggle."
                 },
                 {
                  id: "es-1-1-43", da: "Apply data-driven insights to refine your solution's alignment with needs."
                 },
                 {
                  id: "es-1-1-44", da: "Segment data to understand how different groups experience pain points."
                 },
                 {
                  id: "es-1-1-45", da: "Continuously iterate on your solution based on user feedback."
                 },
                 {
                  id: "es-1-1-46", da: "Test different approaches to addressing pain points."
                 },
                 {
                  id: "es-1-1-47", da: "Gather feedback through usability testing and user interviews."
                 },
                 {
                  id: "es-1-1-48", da: "Use feedback to refine your solution's effectiveness in solving pain points."
                 },
                 {
                  id: "es-1-1-49", da: "Adopt an agile development approach to respond to changing market needs."
                 },
              ]
            },
            {
              id: 'es-1-2',
              pm: 'Team has a basic technology that proves technical capability to solve the chosen problem. Clear plan on how an MVC (Minimum Viable Community) can operate.',
              title:'Technology',
              pmMap: 'Team has a basic technology that proves technical capability to solve the chosen problem. Clear plan on how an MVC (Minimum Viable Community) can operate.',
              developmentActions:[
                {
                  id: "es-1-2-0", da: "Stay updated on the latest technological advancements in your industry."
                 },
                 {
                  id: "es-1-2-1", da: "Research emerging technologies that can solve specific pain points."
                 },
                 {
                  id: "es-1-2-2", da: "Identify relevant frameworks, libraries, and tools to streamline development."
                 },
                 {
                  id: "es-1-2-3", da: "Analyze technical trends that could impact your solution's feasibility."
                 },
                 {
                  id: "es-1-2-4", da: "Evaluate the scalability of your chosen technology stack."
                 },
                 {
                  id: "es-1-2-5", da: "Develop prototypes to demonstrate how your technology solves pain points."
                 },
                 {
                  id: "es-1-2-6", da: "Create proof-of-concept models to validate the feasibility of your solution."
                 },
                 {
                  id: "es-1-2-7", da: "Test technical hypotheses to ensure the technology can deliver results."
                 },
                 {
                  id: "es-1-2-8", da: "Gather user feedback on prototypes to assess their effectiveness."
                 },
                 {
                  id: "es-1-2-9", da: "Iterate on prototypes to refine your technology's alignment with needs."
                 },
                 {
                  id: "es-1-2-10", da: "Design a scalable and flexible architecture that can evolve with needs."
                 },
                 {
                  id: "es-1-2-11", da: "Ensure your architecture can accommodate future feature enhancements."
                 },
                 {
                  id: "es-1-2-12", da: "Consider microservices or modular design to address specific pain points."
                 },
                 {
                  id: "es-1-2-13", da: "Develop a system that can handle expected user loads and traffic."
                 },
                 {
                  id: "es-1-2-14", da: "Choose technologies that support real-time communication and updates."
                 },
                 {
                  id: "es-1-2-15", da: "Implement data storage solutions that can handle anticipated data volumes."
                 },
                 {
                  id: "es-1-2-16", da: "Choose databases that align with your solution's data processing needs."
                 },
                 {
                  id: "es-1-2-17", da: "Implement data caching mechanisms to improve performance."
                 },
                 {
                  id: "es-1-2-18", da: "Ensure data security measures are in place to protect user information."
                 },
                 {
                  id: "es-1-2-19", da: "Implement data analytics tools to gain insights into user behavior."
                 },
                 {
                  id: "es-1-2-20", da: "Create intuitive user interfaces that facilitate pain point resolution."
                 },
                 {
                  id: "es-1-2-21", da: "Optimize user flows to guide users toward desired outcomes."
                 },
                 {
                  id: "es-1-2-22", da: "Implement responsive design to ensure a consistent experience across devices."
                 },
                 {
                  id: "es-1-2-23", da: "Focus on accessibility to cater to users with diverse needs."
                 },
                 {
                  id: "es-1-2-24", da: "Implement interactive elements that engage users effectively."
                 },
                 {
                  id: "es-1-2-25", da: "Continuously monitor your solution's performance to identify bottlenecks."
                 },
                 {
                  id: "es-1-2-26", da: "Implement caching mechanisms to improve loading times."
                 },
                 {
                  id: "es-1-2-27", da: "Optimize code for faster execution and reduced resource consumption."
                 },
                 {
                  id: "es-1-2-28", da: "Use content delivery networks (CDNs) to ensure fast content delivery."
                 },
                 {
                  id: "es-1-2-29", da: "Conduct load testing to ensure your solution can handle peak traffic."
                 },
                 {
                  id: "es-1-2-30", da: "Design your solution to scale seamlessly as user demands increase."
                 },
                 {
                  id: "es-1-2-31", da: "Implement cloud-based solutions to accommodate variable workloads."
                 },
                 {
                  id: "es-1-2-32", da: "Use containerization and orchestration tools for efficient scaling."
                 },
                 {
                  id: "es-1-2-33", da: "Develop APIs to facilitate integrations with other systems."
                 },
                 {
                  id: "es-1-2-34", da: "Plan for future features and enhancements to avoid technical constraints."
                 },
                 {
                  id: "es-1-2-35", da: "Implement CI\/CD pipelines for automated testing and deployment."
                 },
                 {
                  id: "es-1-2-36", da: "Conduct regular code reviews to maintain code quality."
                 },
                 {
                  id: "es-1-2-37", da: "Use automated testing tools to ensure robust functionality."
                 },
                 {
                  id: "es-1-2-38", da: "Implement version control to track changes and manage codebase."
                 },
                 {
                  id: "es-1-2-39", da: "Establish a rollback plan to address unexpected deployment issues."
                 },
                 {
                  id: "es-1-2-40", da: "Implement monitoring tools to track application performance in real-time."
                 },
                 {
                  id: "es-1-2-41", da: "Set up alerts for system anomalies or performance degradation."
                 },
                 {
                  id: "es-1-2-42", da: "Analyze user interactions to understand how they use your solution."
                 },
                 {
                  id: "es-1-2-43", da: "Use analytics data to identify user pain points and areas for improvement."
                 },
                 {
                  id: "es-1-2-44", da: "Continuously gather feedback from technical metrics to refine your solution."
                 },
                 {
                  id: "es-1-2-45", da: "Implement robust security measures to protect user data."
                 },
                 {
                  id: "es-1-2-46", da: "Encrypt sensitive information to prevent unauthorized access."
                 },
                 {
                  id: "es-1-2-47", da: "Ensure compliance with data protection regulations (e.g., GDPR)."
                 },
                 {
                  id: "es-1-2-48", da: "Regularly perform security audits and vulnerability assessments."
                 },
                 {
                  id: "es-1-2-49", da: "Educate your team about best practices for secure development."
                 },
              ]
            },
            {
              id: 'es-1-3',
              pm: 'Team has validated their ICPs (ideal customer profile) and solution hypotheses with customer interviews and closed first pilot customers which serves as first evidence that solution solves key pain points.',
              title:'Value',
              pmMap: 'Team has validated their ICPs (ideal customer profile) and solution hypotheses with customer interviews and closed first pilot customers which serves as first evidence that solution solves key pain points.',
              developmentActions:[
                {
                  id: "es-1-3-0", da: "Conduct user surveys to understand their desired outcomes and value expectations."
                 },
                 {
                  id: "es-1-3-1", da: "Develop user personas to tailor your product's value proposition."
                 },
                 {
                  id: "es-1-3-2", da: "Align your product's features with the specific needs of different user segments."
                 },
                 {
                  id: "es-1-3-3", da: "Create user stories that highlight how your product addresses user pain points."
                 },
                 {
                  id: "es-1-3-4", da: "Continuously gather feedback to ensure your product remains aligned with user value."
                 },
                 {
                  id: "es-1-3-5", da: "Prioritize features based on their impact on solving user pain points."
                 },
                 {
                  id: "es-1-3-6", da: "Use techniques like the Kano model to identify essential and delighting features."
                 },
                 {
                  id: "es-1-3-7", da: "Continuously reassess feature priorities based on changing user needs."
                 },
                 {
                  id: "es-1-3-8", da: "Develop a roadmap that outlines how each feature contributes to user value."
                 },
                 {
                  id: "es-1-3-9", da: "Regularly evaluate and refine your product's feature set."
                 },
                 {
                  id: "es-1-3-10", da: "Clearly communicate the benefits users will receive from your product."
                 },
                 {
                  id: "es-1-3-11", da: "Create compelling marketing messages that highlight value propositions."
                 },
                 {
                  id: "es-1-3-12", da: "Develop case studies and success stories that showcase real-world outcomes."
                 },
                 {
                  id: "es-1-3-13", da: "Use visual aids like infographics to illustrate the value your product brings."
                 },
                 {
                  id: "es-1-3-14", da: "Continuously refine your value messaging based on user feedback."
                 },
                 {
                  id: "es-1-3-15", da: "Implement personalized recommendations based on user behavior."
                 },
                 {
                  id: "es-1-3-16", da: "Use machine learning to customize content or product offerings."
                 },
                 {
                  id: "es-1-3-17", da: "Allow users to set preferences that tailor their experience."
                 },
                 {
                  id: "es-1-3-18", da: "Offer options for customization that enhance user value."
                 },
                 {
                  id: "es-1-3-19", da: "Analyze data to identify opportunities for personalized enhancements."
                 },
                 {
                  id: "es-1-3-20", da: "Regularly update your product based on user feedback and market trends."
                 },
                 {
                  id: "es-1-3-21", da: "Conduct post-launch assessments to identify areas for improvement."
                 },
                 {
                  id: "es-1-3-22", da: "Develop a culture of continuous learning and iteration within your team."
                 },
                 {
                  id: "es-1-3-23", da: "Use A\/B testing to experiment with different approaches to delivering value."
                 },
                 {
                  id: "es-1-3-24", da: "Celebrate and communicate product enhancements to users."
                 },
                 {
                  id: "es-1-3-25", da: "Design an intuitive onboarding process that showcases immediate value."
                 },
                 {
                  id: "es-1-3-26", da: "Provide tutorials, videos, and guides to help users maximize product benefits."
                 },
                 {
                  id: "es-1-3-27", da: "Offer in-product tooltips and prompts to guide users toward value."
                 },
                 {
                  id: "es-1-3-28", da: "Regularly assess user engagement and interactions during onboarding."
                 },
                 {
                  id: "es-1-3-29", da: "Continuously refine onboarding based on user feedback."
                 },
                 {
                  id: "es-1-3-30", da: "Define and track key metrics that reflect the value users derive from your product."
                 },
                 {
                  id: "es-1-3-31", da: "Use Net Promoter Score (NPS) to measure user satisfaction and value perception."
                 },
                 {
                  id: "es-1-3-32", da: "Analyze user retention rates as an indicator of ongoing value."
                 },
                 {
                  id: "es-1-3-33", da: "Implement surveys to directly ask users about the value they've experienced."
                 },
                 {
                  id: "es-1-3-34", da: "Gather testimonials and user quotes that emphasize value outcomes."
                 },
                 {
                  id: "es-1-3-35", da: "Collect feedback on how users are benefiting from your product."
                 },
                 {
                  id: "es-1-3-36", da: "Use success stories and feedback to inspire potential customers."
                 },
                 {
                  id: "es-1-3-37", da: "Incorporate user feedback into feature enhancements to increase value."
                 },
                 {
                  id: "es-1-3-38", da: "Regularly engage with users to understand their evolving needs."
                 },
                 {
                  id: "es-1-3-39", da: "Develop a feedback loop that aligns product development with user value."
                 },
                 {
                  id: "es-1-3-40", da: "Integrate with complementary products to enhance overall value."
                 },
                 {
                  id: "es-1-3-41", da: "Develop partnerships that expand the utility of your product."
                 },
                 {
                  id: "es-1-3-42", da: "Offer seamless integrations with popular tools users already use."
                 },
                 {
                  id: "es-1-3-43", da: "Analyze how users combine your product with others for maximum value."
                 },
                 {
                  id: "es-1-3-44", da: "Communicate the synergy created by integrating with other solutions."
                 },
                 {
                  id: "es-1-3-45", da: "Highlight the long-term benefits and impact of using your product."
                 },
                 {
                  id: "es-1-3-46", da: "Provide data or case studies that demonstrate sustained value over time."
                 },
                 {
                  id: "es-1-3-47", da: "Create loyalty programs or rewards for long-term users."
                 },
                 {
                  id: "es-1-3-48", da: "Continuously engage with users to ensure your product's value endures."
                 },
                 {
                  id: "es-1-3-49", da: "Develop a strategy for maintaining value as user needs evolve."
                 },
              ]
            },
            {
              id: 'es-1-4',
              pm: 'Evidence on which business model to use to build sustainable operations. Team has gathered knowledge on which alternatives business models exist to confirm revenue assumptions.',
              title:'Business Model',
              pmMap: 'Evidence on which business model to use to build sustainable operations. Team has gathered knowledge on which alternatives business models exist to confirm revenue assumptions.',
              developmentActions:[
                {
                  id: "es-1-4-0", da: "Refine your target customer segments based on their willingness to pay."
                 },
                 {
                  id: "es-1-4-1", da: "Segment customers based on their specific needs and pain points."
                 },
                 {
                  id: "es-1-4-2", da: "Identify high-value customer segments that align with your business model."
                 },
                 {
                  id: "es-1-4-3", da: "Develop tailored solutions and pricing strategies for each segment."
                 },
                 {
                  id: "es-1-4-4", da: "Continuously evaluate and adjust customer segments based on feedback."
                 },
                 {
                  id: "es-1-4-5", da: "Analyze competitor pricing to position your product competitively."
                 },
                 {
                  id: "es-1-4-6", da: "Choose a pricing model (subscription, freemium, pay-per-use) that aligns with value."
                 },
                 {
                  id: "es-1-4-7", da: "Conduct pricing experiments to determine optimal price points."
                 },
                 {
                  id: "es-1-4-8", da: "Offer tiered pricing options to cater to different customer needs."
                 },
                 {
                  id: "es-1-4-9", da: "Consider dynamic pricing strategies that adapt based on demand."
                 },
                 {
                  id: "es-1-4-10", da: "Identify additional revenue streams beyond the core product offering."
                 },
                 {
                  id: "es-1-4-11", da: "Develop premium features or add-ons that provide extra value."
                 },
                 {
                  id: "es-1-4-12", da: "Offer consulting or training services related to your product."
                 },
                 {
                  id: "es-1-4-13", da: "Explore partnerships that generate revenue through referrals or integrations."
                 },
                 {
                  id: "es-1-4-14", da: "Continuously seek new opportunities for monetization."
                 },
                 {
                  id: "es-1-4-15", da: "Clearly communicate the value your pricing tiers provide."
                 },
                 {
                  id: "es-1-4-16", da: "Highlight the features and benefits offered at each price point."
                 },
                 {
                  id: "es-1-4-17", da: "Use case studies and testimonials to demonstrate ROI."
                 },
                 {
                  id: "es-1-4-18", da: "Provide transparent explanations for pricing decisions."
                 },
                 {
                  id: "es-1-4-19", da: "Continuously refine your value communication based on feedback."
                 },
                 {
                  id: "es-1-4-20", da: "Develop subscription plans that align with customer needs and usage patterns."
                 },
                 {
                  id: "es-1-4-21", da: "Offer tiered plans that cater to different user personas."
                 },
                 {
                  id: "es-1-4-22", da: "Implement usage-based pricing for scalable solutions."
                 },
                 {
                  id: "es-1-4-23", da: "Provide flexible billing options (monthly, annual) to accommodate customers."
                 },
                 {
                  id: "es-1-4-24", da: "Use data analysis to optimize subscription pricing over time."
                 },
                 {
                  id: "es-1-4-25", da: "Offer free trials to let potential customers experience value firsthand."
                 },
                 {
                  id: "es-1-4-26", da: "Implement a freemium model with limited features to attract users."
                 },
                 {
                  id: "es-1-4-27", da: "Clearly define the limitations of the free version to encourage upgrades."
                 },
                 {
                  id: "es-1-4-28", da: "Analyze conversion rates from free to paid plans and optimize the process."
                 },
                 {
                  id: "es-1-4-29", da: "Continuously assess the balance between free and paid features."
                 },
                 {
                  id: "es-1-4-30", da: "Identify value-added services that complement your product."
                 },
                 {
                  id: "es-1-4-31", da: "Offer training, implementation, or customization services."
                 },
                 {
                  id: "es-1-4-32", da: "Develop premium support options for faster response times."
                 },
                 {
                  id: "es-1-4-33", da: "Bundle services that enhance the overall user experience."
                 },
                 {
                  id: "es-1-4-34", da: "Continuously evaluate the demand for additional services."
                 },
                 {
                  id: "es-1-4-35", da: "Implement licensing models that protect your intellectual property."
                 },
                 {
                  id: "es-1-4-36", da: "Consider offering different licensing options for various use cases."
                 },
                 {
                  id: "es-1-4-37", da: "Monitor and enforce licensing agreements to prevent misuse."
                 },
                 {
                  id: "es-1-4-38", da: "Collaborate with legal experts to ensure proper licensing terms."
                 },
                 {
                  id: "es-1-4-39", da: "Continuously review and update licensing terms as needed."
                 },
                 {
                  id: "es-1-4-40", da: "Develop affiliate programs that incentivize users to refer new customers."
                 },
                 {
                  id: "es-1-4-41", da: "Offer referral bonuses or discounts to both the referrer and the referred."
                 },
                 {
                  id: "es-1-4-42", da: "Provide marketing materials to help affiliates promote your product."
                 },
                 {
                  id: "es-1-4-43", da: "Implement tracking mechanisms to accurately attribute referrals."
                 },
                 {
                  id: "es-1-4-44", da: "Continuously optimize affiliate programs based on their performance."
                 },
                 {
                  id: "es-1-4-45", da: "Identify strategic partners who can help distribute your product."
                 },
                 {
                  id: "es-1-4-46", da: "Develop co-marketing partnerships to expand your reach."
                 },
                 {
                  id: "es-1-4-47", da: "Integrate with complementary products to enhance your offering."
                 },
                 {
                  id: "es-1-4-48", da: "Offer revenue-sharing partnerships to encourage collaboration."
                 },
                 {
                  id: "es-1-4-49", da: "Continuously nurture and cultivate strategic partnerships."
                 },
              ]
            },
            {
              id: 'es-1-5',
              pm: "Pattern of market segmentation and potential ICP's are emerging which proofs that problem exists across different segments.",
              title:'Go to Market',
              pmMap: "Pattern of market segmentation and potential ICP's are emerging which proofs that problem exists across different segments.",
              developmentActions:[
                {
                  id: "es-1-5-0", da: "Conduct market research to identify the most receptive target audience."
                 },
                 {
                  id: "es-1-5-1", da: "Analyze customer segments that align closely with your solution's benefits."
                 },
                 {
                  id: "es-1-5-2", da: "Develop detailed buyer personas to guide your marketing strategies."
                 },
                 {
                  id: "es-1-5-3", da: "Segment your audience based on pain points and needs."
                 },
                 {
                  id: "es-1-5-4", da: "Continuously update and refine your target audience based on feedback."
                 },
                 {
                  id: "es-1-5-5", da: "Craft compelling value propositions that resonate with your audience's pain points."
                 },
                 {
                  id: "es-1-5-6", da: "Develop clear and concise messaging that highlights your product's benefits."
                 },
                 {
                  id: "es-1-5-7", da: "Use customer language and terminology in your marketing content."
                 },
                 {
                  id: "es-1-5-8", da: "Position your product as the solution to specific pain points in the market."
                 },
                 {
                  id: "es-1-5-9", da: "Continuously optimize messaging based on customer feedback and engagement."
                 },
                 {
                  id: "es-1-5-10", da: "Develop a content strategy that addresses pain points through valuable content."
                 },
                 {
                  id: "es-1-5-11", da: "Create blog posts, whitepapers, and guides that offer solutions."
                 },
                 {
                  id: "es-1-5-12", da: "Use case studies to demonstrate how your product solves real-world problems."
                 },
                 {
                  id: "es-1-5-13", da: "Incorporate SEO strategies to attract organic traffic."
                 },
                 {
                  id: "es-1-5-14", da: "Continuously produce and distribute relevant and high-quality content."
                 },
                 {
                  id: "es-1-5-15", da: "Identify social media platforms where your target audience is active."
                 },
                 {
                  id: "es-1-5-16", da: "Develop engaging content that sparks conversations around pain points."
                 },
                 {
                  id: "es-1-5-17", da: "Use social media ads to reach a wider audience with tailored messaging."
                 },
                 {
                  id: "es-1-5-18", da: "Participate in relevant online communities and forums."
                 },
                 {
                  id: "es-1-5-19", da: "Analyze social media metrics to assess engagement and refine strategies."
                 },
                 {
                  id: "es-1-5-20", da: "Identify industry influencers who can validate your solution's value."
                 },
                 {
                  id: "es-1-5-21", da: "Collaborate with influencers to showcase your product's benefits."
                 },
                 {
                  id: "es-1-5-22", da: "Leverage influencer testimonials or endorsements in your marketing."
                 },
                 {
                  id: "es-1-5-23", da: "Use influencer-generated content to expand your reach."
                 },
                 {
                  id: "es-1-5-24", da: "Continuously nurture relationships with influencers for ongoing support."
                 },
                 {
                  id: "es-1-5-25", da: "Build an email list of potential customers interested in your solution."
                 },
                 {
                  id: "es-1-5-26", da: "Create personalized email campaigns that address pain points directly."
                 },
                 {
                  id: "es-1-5-27", da: "Share educational content and product updates through email."
                 },
                 {
                  id: "es-1-5-28", da: "Use segmented lists to deliver targeted messages to specific audiences."
                 },
                 {
                  id: "es-1-5-29", da: "Continuously analyze email open rates and engagement for optimization."
                 },
                 {
                  id: "es-1-5-30", da: "Develop landing pages that highlight your solution's value proposition."
                 },
                 {
                  id: "es-1-5-31", da: "Optimize your website for user experience and clear navigation."
                 },
                 {
                  id: "es-1-5-32", da: "Use compelling visuals and copy to convey the benefits of your product."
                 },
                 {
                  id: "es-1-5-33", da: "Implement A\/B testing to refine landing page performance."
                 },
                 {
                  id: "es-1-5-34", da: "Continuously monitor and improve website conversion rates."
                 },
                 {
                  id: "es-1-5-35", da: "Offer live demos or webinars to showcase your product's features."
                 },
                 {
                  id: "es-1-5-36", da: "Provide interactive product tours that highlight value in real time."
                 },
                 {
                  id: "es-1-5-37", da: "Tailor demos to specific use cases or pain points."
                 },
                 {
                  id: "es-1-5-38", da: "Record demos for on-demand viewing by potential customers."
                 },
                 {
                  id: "es-1-5-39", da: "Continuously gather feedback on demos to improve their effectiveness."
                 },
                 {
                  id: "es-1-5-40", da: "Identify potential partners who can help amplify your go-to-market efforts."
                 },
                 {
                  id: "es-1-5-41", da: "Collaborate with complementary products for co-marketing initiatives."
                 },
                 {
                  id: "es-1-5-42", da: "Develop joint webinars or events that address pain points collectively."
                 },
                 {
                  id: "es-1-5-43", da: "Offer cross-promotion to partners with aligned target audiences."
                 },
                 {
                  id: "es-1-5-44", da: "Continuously explore new partnership opportunities."
                 },
                 {
                  id: "es-1-5-45", da: "Offer early access or beta programs to gather user feedback."
                 },
                 {
                  id: "es-1-5-46", da: "Allow participants to experience value firsthand and provide input."
                 },
                 {
                  id: "es-1-5-47", da: "Use beta testers' feedback to refine your go-to-market strategy."
                 },
                 {
                  id: "es-1-5-48", da: "Reward beta testers with discounts or exclusive offers for their participation."
                 },
                 {
                  id: "es-1-5-49", da: "Continuously engage with beta testers and gather insights for improvement."
                 },
              ]
            },
            {
              id: 'es-1-6',
              pm: 'Founding team has necessary skills, network and experience in the subject market. Bring advisors join the team. Take 10 user feedback',
              title:'People',
              pmMap: 'Founding team has necessary skills, network and experience in the subject market. Bring advisors join the team. Take 10 user feedback',
              developmentActions:[
                {
                  id: "es-1-6-0", da: "Clearly communicate your product's vision and mission to your team."
                 },
                 {
                  id: "es-1-6-1", da: "Conduct regular team meetings to ensure everyone understands the problem space."
                 },
                 {
                  id: "es-1-6-2", da: "Encourage open communication and idea sharing within the team."
                 },
                 {
                  id: "es-1-6-3", da: "Foster a collaborative environment where cross-functional teams work together."
                 },
                 {
                  id: "es-1-6-4", da: "Develop a shared understanding of user pain points among all team members."
                 },
                 {
                  id: "es-1-6-5", da: "Promote collaboration between development, design, and marketing teams."
                 },
                 {
                  id: "es-1-6-6", da: "Implement agile methodologies to ensure ongoing collaboration and feedback."
                 },
                 {
                  id: "es-1-6-7", da: "Create a process for cross-functional brainstorming and ideation sessions."
                 },
                 {
                  id: "es-1-6-8", da: "Involve team members from various disciplines in user research and interviews."
                 },
                 {
                  id: "es-1-6-9", da: "Continuously assess and improve collaboration practices within the team."
                 },
                 {
                  id: "es-1-6-10", da: "Identify skill gaps within your team and offer relevant training opportunities."
                 },
                 {
                  id: "es-1-6-11", da: "Encourage team members to continuously learn about emerging trends and technologies."
                 },
                 {
                  id: "es-1-6-12", da: "Provide resources for improving customer empathy and communication skills."
                 },
                 {
                  id: "es-1-6-13", da: "Invest in training that enhances problem-solving and critical thinking abilities."
                 },
                 {
                  id: "es-1-6-14", da: "Offer opportunities for team members to attend industry events and conferences."
                 },
                 {
                  id: "es-1-6-15", da: "Recruit team members who share the passion for solving user pain points."
                 },
                 {
                  id: "es-1-6-16", da: "Prioritize candidates who align with your product's values and mission."
                 },
                 {
                  id: "es-1-6-17", da: "Incorporate problem-solving scenarios in the interview process."
                 },
                 {
                  id: "es-1-6-18", da: "Assess candidates' ability to empathize with user challenges during interviews."
                 },
                 {
                  id: "es-1-6-19", da: "Develop a strong employer brand that attracts top talent aligned with your goals."
                 },
                 {
                  id: "es-1-6-20", da: "Instill a user-centric mindset across all roles within your team."
                 },
                 {
                  id: "es-1-6-21", da: "Regularly involve team members in user research and feedback collection."
                 },
                 {
                  id: "es-1-6-22", da: "Share user stories and testimonials to remind the team of the impact they make."
                 },
                 {
                  id: "es-1-6-23", da: "Encourage empathy workshops to help team members better understand users."
                 },
                 {
                  id: "es-1-6-24", da: "Develop a culture where every team member feels connected to user needs."
                 },
                 {
                  id: "es-1-6-25", da: "Establish a structured feedback loop that captures team insights."
                 },
                 {
                  id: "es-1-6-26", da: "Encourage team members to share observations from customer interactions."
                 },
                 {
                  id: "es-1-6-27", da: "Use retrospectives to discuss what's working and where improvements are needed."
                 },
                 {
                  id: "es-1-6-28", da: "Implement a mechanism for sharing user feedback directly with the team."
                 },
                 {
                  id: "es-1-6-29", da: "Continuously refine the feedback loop to make it more effective."
                 },
                 {
                  id: "es-1-6-30", da: "Foster a diverse and inclusive team with a wide range of backgrounds."
                 },
                 {
                  id: "es-1-6-31", da: "Value and incorporate different viewpoints to solve problems creatively."
                 },
                 {
                  id: "es-1-6-32", da: "Ensure that diverse team members can contribute to understanding user needs."
                 },
                 {
                  id: "es-1-6-33", da: "Address unconscious biases that may affect problem-solving processes."
                 },
                 {
                  id: "es-1-6-34", da: "Create an environment where everyone's voice is heard and respected."
                 },
                 {
                  id: "es-1-6-35", da: "Provide customer-focused training to team members who interact with users."
                 },
                 {
                  id: "es-1-6-36", da: "Teach active listening and effective communication techniques."
                 },
                 {
                  id: "es-1-6-37", da: "Train sales and support teams to identify and address user pain points."
                 },
                 {
                  id: "es-1-6-38", da: "Offer empathy training to help team members better understand user emotions."
                 },
                 {
                  id: "es-1-6-39", da: "Continuously update training based on new insights and feedback."
                 },
                 {
                  id: "es-1-6-40", da: "Involve users directly in the development process through co-creation sessions."
                 },
                 {
                  id: "es-1-6-41", da: "Host user testing sessions to gather real-time feedback on prototypes."
                 },
                 {
                  id: "es-1-6-42", da: "Develop advisory boards or user communities to foster ongoing engagement."
                 },
                 {
                  id: "es-1-6-43", da: "Use user input to guide feature prioritization and decision-making."
                 },
                 {
                  id: "es-1-6-44", da: "Continuously seek ways to involve users in shaping the product's direction."
                 },
                 {
                  id: "es-1-6-45", da: "Implement key performance indicators (KPIs) that reflect user value."
                 },
                 {
                  id: "es-1-6-46", da: "Track metrics related to user engagement, satisfaction, and pain point resolution."
                 },
                 {
                  id: "es-1-6-47", da: "Use user feedback to measure the impact of your product on their lives."
                 },
                 {
                  id: "es-1-6-48", da: "Align performance reviews and incentives with user-centric metrics."
                 },
                 {
                  id: "es-1-6-49", da: "Continuously monitor and analyze user-centric metrics for improvement."
                 },
              ]
            },
            {
              id: 'es-1-7',
              pm: 'Evaluate basic metrics starting with tracking success of community event or community calls.',
              title:'Data Metrics',
              pmMap: 'Evaluate basic metrics starting with tracking success of community event or community calls.',
              developmentActions:[
                {
                  id: "es-1-7-0", da: "Identify the key data points that align with user pain points."
                 },
                 {
                  id: "es-1-7-1", da: "Implement data tracking tools to capture relevant user interactions."
                 },
                 {
                  id: "es-1-7-2", da: "Integrate user behavior data with feedback and support data."
                 },
                 {
                  id: "es-1-7-3", da: "Use APIs to integrate data from various sources for a comprehensive view."
                 },
                 {
                  id: "es-1-7-4", da: "Continuously monitor data collection processes for accuracy."
                 },
                 {
                  id: "es-1-7-5", da: "Implement user journey tracking to understand pain points and drop-offs."
                 },
                 {
                  id: "es-1-7-6", da: "Analyze click-through rates to identify user engagement patterns."
                 },
                 {
                  id: "es-1-7-7", da: "Study feature usage data to uncover frequently encountered pain points."
                 },
                 {
                  id: "es-1-7-8", da: "Use heatmaps to visualize user interactions and identify pain points."
                 },
                 {
                  id: "es-1-7-9", da: "Continuously analyze behavioral data to refine user experience."
                 },
                 {
                  id: "es-1-7-10", da: "Develop surveys that directly ask users about their pain points."
                 },
                 {
                  id: "es-1-7-11", da: "Use Net Promoter Score (NPS) surveys to gauge user satisfaction."
                 },
                 {
                  id: "es-1-7-12", da: "Implement in-product feedback mechanisms for real-time insights."
                 },
                 {
                  id: "es-1-7-13", da: "Analyze qualitative feedback to identify recurring pain points."
                 },
                 {
                  id: "es-1-7-14", da: "Continuously iterate survey questions based on evolving needs."
                 },
                 {
                  id: "es-1-7-15", da: "Segment user data to understand how different groups experience pain points."
                 },
                 {
                  id: "es-1-7-16", da: "Develop user profiles that include pain points, behaviors, and preferences."
                 },
                 {
                  id: "es-1-7-17", da: "Use segmentation to tailor solutions to specific user segments."
                 },
                 {
                  id: "es-1-7-18", da: "Analyze data to identify commonalities among users facing similar challenges."
                 },
                 {
                  id: "es-1-7-19", da: "Continuously update user profiles based on new insights."
                 },
                 {
                  id: "es-1-7-20", da: "Map out the user conversion funnel to identify pain points and drop-offs."
                 },
                 {
                  id: "es-1-7-21", da: "Analyze each stage of the funnel to understand user behavior."
                 },
                 {
                  id: "es-1-7-22", da: "Identify specific steps where users struggle or abandon the process."
                 },
                 {
                  id: "es-1-7-23", da: "A\/B test variations in the funnel to optimize conversion rates."
                 },
                 {
                  id: "es-1-7-24", da: "Continuously monitor and refine the conversion funnel based on data."
                 },
                 {
                  id: "es-1-7-25", da: "Analyze customer support interactions to identify common pain points."
                 },
                 {
                  id: "es-1-7-26", da: "Study support ticket categories and trends related to pain points."
                 },
                 {
                  id: "es-1-7-27", da: "Use support chat logs to gather direct feedback on challenges."
                 },
                 {
                  id: "es-1-7-28", da: "Collaborate with the support team to extract insights from user queries."
                 },
                 {
                  id: "es-1-7-29", da: "Continuously integrate support data into your problem-solving strategies."
                 },
                 {
                  id: "es-1-7-30", da: "Implement sentiment analysis to gauge user emotions from feedback."
                 },
                 {
                  id: "es-1-7-31", da: "Analyze reviews, comments, and social media mentions for sentiment trends."
                 },
                 {
                  id: "es-1-7-32", da: "Identify pain points that evoke strong positive or negative emotions."
                 },
                 {
                  id: "es-1-7-33", da: "Use sentiment analysis to prioritize addressing highly emotional pain points."
                 },
                 {
                  id: "es-1-7-34", da: "Continuously improve sentiment analysis accuracy over time."
                 },
                 {
                  id: "es-1-7-35", da: "Analyze user churn patterns to identify reasons for attrition."
                 },
                 {
                  id: "es-1-7-36", da: "Study behaviors and interactions of users who cancel their subscription."
                 },
                 {
                  id: "es-1-7-37", da: "Identify common pain points that lead to user dissatisfaction."
                 },
                 {
                  id: "es-1-7-38", da: "Develop strategies to re-engage and retain users facing pain points."
                 },
                 {
                  id: "es-1-7-39", da: "Continuously track and analyze churn data for insights."
                 },
                 {
                  id: "es-1-7-40", da: "Measure the time it takes for users to realize value from your product."
                 },
                 {
                  id: "es-1-7-41", da: "Identify stages where users experience delays in finding value."
                 },
                 {
                  id: "es-1-7-42", da: "Analyze user behavior during the onboarding phase to reduce time-to-value."
                 },
                 {
                  id: "es-1-7-43", da: "Use data to optimize the onboarding process for quicker value delivery."
                 },
                 {
                  id: "es-1-7-44", da: "Continuously track and improve time-to-value metrics."
                 },
                 {
                  id: "es-1-7-45", da: "Use predictive models to forecast user behavior related to pain points."
                 },
                 {
                  id: "es-1-7-46", da: "Analyze historical data to predict potential pain points in the future."
                 },
                 {
                  id: "es-1-7-47", da: "Develop strategies to proactively address anticipated challenges."
                 },
                 {
                  id: "es-1-7-48", da: "Continuously refine predictive models based on real-time data."
                 },
                 {
                  id: "es-1-7-49", da: "Use predictive analytics to inform product roadmap decisions."
                 },
              ]
            },
            {
              id: 'es-1-8',
              pm: 'Evaluate if any legal compliance is required. Identify local legislation. Gather municpal support if possible.',
              title:'Operations',
              pmMap: 'Evaluate if any legal compliance is required. Identify local legislation. Gather municpal support if possible.',
              developmentActions:[
                {
                  id: "es-1-8-0", da: "Map out your product development and release processes."
                 },
                 {
                  id: "es-1-8-1", da: "Identify bottlenecks and areas of inefficiency in your workflows."
                 },
                 {
                  id: "es-1-8-2", da: "Streamline processes to reduce lead times and improve efficiency."
                 },
                 {
                  id: "es-1-8-3", da: "Implement agile methodologies to promote iterative development."
                 },
                 {
                  id: "es-1-8-4", da: "Continuously monitor and refine workflows based on performance data."
                 },
                 {
                  id: "es-1-8-5", da: "Foster collaboration between development, marketing, support, and other teams."
                 },
                 {
                  id: "es-1-8-6", da: "Hold regular cross-functional meetings to share insights and updates."
                 },
                 {
                  id: "es-1-8-7", da: "Develop a shared understanding of user pain points across teams."
                 },
                 {
                  id: "es-1-8-8", da: "Implement tools that facilitate collaboration and information sharing."
                 },
                 {
                  id: "es-1-8-9", da: "Continuously encourage cross-functional communication and alignment."
                 },
                 {
                  id: "es-1-8-10", da: "Allocate resources based on the priority of solving user pain points."
                 },
                 {
                  id: "es-1-8-11", da: "Balance development efforts between fixing pain points and adding features."
                 },
                 {
                  id: "es-1-8-12", da: "Use data to identify resource-intensive pain points that need immediate attention."
                 },
                 {
                  id: "es-1-8-13", da: "Continuously assess resource allocation to ensure alignment with needs."
                 },
                 {
                  id: "es-1-8-14", da: "Optimize resource distribution to maximize user impact."
                 },
                 {
                  id: "es-1-8-15", da: "Identify repetitive tasks in your operations and automate them."
                 },
                 {
                  id: "es-1-8-16", da: "Implement automation tools to streamline routine processes."
                 },
                 {
                  id: "es-1-8-17", da: "Use chatbots for handling common user inquiries and support requests."
                 },
                 {
                  id: "es-1-8-18", da: "Automate data collection and analysis for insights."
                 },
                 {
                  id: "es-1-8-19", da: "Continuously identify opportunities for further automation."
                 },
                 {
                  id: "es-1-8-20", da: "Implement rigorous testing processes to ensure bug-free releases."
                 },
                 {
                  id: "es-1-8-21", da: "Develop comprehensive test cases that cover user pain points."
                 },
                 {
                  id: "es-1-8-22", da: "Conduct user acceptance testing to verify pain point resolution."
                 },
                 {
                  id: "es-1-8-23", da: "Continuously monitor and improve QA processes based on feedback."
                 },
                 {
                  id: "es-1-8-24", da: "Prioritize bug fixes that directly address user pain points."
                 },
                 {
                  id: "es-1-8-25", da: "Develop a process for collecting and analyzing user feedback."
                 },
                 {
                  id: "es-1-8-26", da: "Use user feedback to inform prioritization of pain point resolutions."
                 },
                 {
                  id: "es-1-8-27", da: "Implement a mechanism to ensure user feedback is addressed in development."
                 },
                 {
                  id: "es-1-8-28", da: "Continuously update your feedback integration process based on insights."
                 },
                 {
                  id: "es-1-8-29", da: "Leverage user feedback to identify potential areas for improvement."
                 },
                 {
                  id: "es-1-8-30", da: "Develop comprehensive documentation to address user pain points."
                 },
                 {
                  id: "es-1-8-31", da: "Provide training resources that help users overcome challenges."
                 },
                 {
                  id: "es-1-8-32", da: "Implement a robust support system to assist users with pain points."
                 },
                 {
                  id: "es-1-8-33", da: "Use support interactions to gather insights about pain points."
                 },
                 {
                  id: "es-1-8-34", da: "Continuously update support resources based on user needs"
                 },
                 {
                  id: "es-1-8-35", da: "Develop a scalability plan to accommodate increased user demand."
                 },
                 {
                  id: "es-1-8-36", da: "Implement cloud-based infrastructure to support scalability."
                 },
                 {
                  id: "es-1-8-37", da: "Conduct load testing to ensure your product can handle growth."
                 },
                 {
                  id: "es-1-8-38", da: "Monitor performance and user behavior to anticipate scalability needs."
                 },
                 {
                  id: "es-1-8-39", da: "Continuously assess and adjust your scalability plan as necessary."
                 },
                 {
                  id: "es-1-8-40", da: "Identify potential risks that could impact the resolution of user pain points."
                 },
                 {
                  id: "es-1-8-41", da: "Develop contingency plans to mitigate risks in your operations."
                 },
                 {
                  id: "es-1-8-42", da: "Implement monitoring tools to identify early signs of potential issues."
                 },
                 {
                  id: "es-1-8-43", da: "Continuously reassess and update risk management strategies."
                 },
                 {
                  id: "es-1-8-44", da: "Be prepared to pivot your operations based on changing circumstances."
                 },
                 {
                  id: "es-1-8-45", da: "Develop a mechanism for gathering user feedback on new features."
                 },
                 {
                  id: "es-1-8-46", da: "Incorporate user feedback into iterative feature development."
                 },
                 {
                  id: "es-1-8-47", da: "Conduct usability testing to validate that new features address pain points."
                 },
                 {
                  id: "es-1-8-48", da: "Continuously engage with users to understand how new features impact them."
                 },
                 {
                  id: "es-1-8-49", da: "Use user feedback to refine future iterations and ensure alignment with pain points."
                 },
              ]
            },
            {
              id: 'es-1-9',
              pm: 'The forming committee has a clear, unified vision with a projection of how their community grows in long term. They envision to address a significant market problem over the next decade, with a strong conviction of a market value.',
              title:'Exit Strategy',
              pmMap: 'The forming committee has a clear, unified vision with a projection of how their community grows in long term. They envision to address a significant market problem over the next decade, with a strong conviction of a market value.',
              developmentActions:[
                {
                  id: "es-1-9-0", da: "Clearly define your preferred exit scenarios (acquisition, merger, IPO)."
                 },
                 {
                  id: "es-1-9-1", da: "Ensure that your product's growth and development align with the chosen exit strategy."
                 },
                 {
                  id: "es-1-9-2", da: "Develop a roadmap that demonstrates how your product will reach the desired valuation."
                 },
                 {
                  id: "es-1-9-3", da: "Continuously reassess your exit strategy based on market conditions and opportunities."
                 },
                 {
                  id: "es-1-9-4", da: "Align your product's goals with the expectations of potential acquirers or investors."
                 },
                 {
                  id: "es-1-9-5", da: "Position your product as an attractive investment or acquisition target."
                 },
                 {
                  id: "es-1-9-6", da: "Clearly communicate your product's unique value proposition to potential buyers."
                 },
                 {
                  id: "es-1-9-7", da: "Identify potential acquirers or partners who align with your exit strategy."
                 },
                 {
                  id: "es-1-9-8", da: "Develop marketing materials that showcase your product's growth potential."
                 },
                 {
                  id: "es-1-9-9", da: "Continuously monitor market trends to ensure your product's positioning is relevant."
                 },
                 {
                  id: "es-1-9-10", da: "Secure patents, trademarks, and copyrights to protect your product's assets."
                 },
                 {
                  id: "es-1-9-11", da: "Document your product's technology, design, and processes for future due diligence."
                 },
                 {
                  id: "es-1-9-12", da: "Implement legal safeguards to prevent disputes over intellectual property."
                 },
                 {
                  id: "es-1-9-13", da: "Maintain a comprehensive record of your product's IP protections."
                 },
                 {
                  id: "es-1-9-14", da: "Continuously update and maintain your intellectual property portfolio."
                 },
                 {
                  id: "es-1-9-15", da: "Develop financial projections that align with your exit strategy goals."
                 },
                 {
                  id: "es-1-9-16", da: "Monitor key financial metrics to track progress toward Attracting Leads."
                 },
                 {
                  id: "es-1-9-17", da: "Secure necessary funding or investments to support growth and development."
                 },
                 {
                  id: "es-1-9-18", da: "Collaborate with financial advisors to ensure fiscal preparedness for exit."
                 },
                 {
                  id: "es-1-9-19", da: "Continuously assess and adjust financial plans based on market dynamics."
                 },
                 {
                  id: "es-1-9-20", da: "Organize and maintain clean financial records and documentation."
                 },
                 {
                  id: "es-1-9-21", da: "Document your product's user base, growth metrics, and market positioning."
                 },
                 {
                  id: "es-1-9-22", da: "Prepare a comprehensive overview of your product's competitive landscape."
                 },
                 {
                  id: "es-1-9-23", da: "Develop a data room with all relevant documents for potential buyers or investors."
                 },
                 {
                  id: "es-1-9-24", da: "Continuously update due diligence materials to reflect current information."
                 },
                 {
                  id: "es-1-9-25", da: "Form strategic partnerships that enhance your product's appeal to potential buyers."
                 },
                 {
                  id: "es-1-9-26", da: "Collaborate with companies that could be interested in acquiring or investing."
                 },
                 {
                  id: "es-1-9-27", da: "Develop integration plans that showcase your product's value to partners."
                 },
                 {
                  id: "es-1-9-28", da: "Communicate the benefits of partnering with your product to potential acquirers."
                 },
                 {
                  id: "es-1-9-29", da: "Continuously nurture and expand strategic partnerships."
                 },
                 {
                  id: "es-1-9-30", da: "Develop a strong and engaged customer base that adds value to potential buyers."
                 },
                 {
                  id: "es-1-9-31", da: "Highlight customer success stories and testimonials in your marketing."
                 },
                 {
                  id: "es-1-9-32", da: "Foster ongoing relationships with users through engagement strategies."
                 },
                 {
                  id: "es-1-9-33", da: "Implement loyalty programs or referral incentives to grow your customer base."
                 },
                 {
                  id: "es-1-9-34", da: "Continuously engage with customers to maintain their loyalty and satisfaction."
                 },
                 {
                  id: "es-1-9-35", da: "Ensure that your product's infrastructure can support rapid scaling if required."
                 },
                 {
                  id: "es-1-9-36", da: "Implement cloud-based solutions for flexibility and scalability."
                 },
                 {
                  id: "es-1-9-37", da: "Develop strategies for handling increased user loads during exit scenarios."
                 },
                 {
                  id: "es-1-9-38", da: "Continuously optimize your product's architecture for scalability."
                 },
                 {
                  id: "es-1-9-39", da: "Prepare for potential infrastructure enhancements to meet exit strategy requirements."
                 },
                 {
                  id: "es-1-9-40", da: "Ensure that your product complies with relevant industry regulations."
                 },
                 {
                  id: "es-1-9-41", da: "Develop clear documentation of your compliance measures."
                 },
                 {
                  id: "es-1-9-42", da: "Collaborate with legal experts to ensure compliance during exit negotiations."
                 },
                 {
                  id: "es-1-9-43", da: "Continuously monitor and adapt to changing regulatory environments."
                 },
                 {
                  id: "es-1-9-44", da: "Address any outstanding legal issues that could impact your exit."
                 },
                 {
                  id: "es-1-9-45", da: "Develop a data strategy that captures and analyzes key performance metrics."
                 },
                 {
                  id: "es-1-9-46", da: "Use data to showcase your product's growth trajectory and potential."
                 },
                 {
                  id: "es-1-9-47", da: "Provide potential acquirers with insights into user behavior and engagement."
                 },
                 {
                  id: "es-1-9-48", da: "Continuously analyze data to identify opportunities for improvement."
                 },
                 {
                  id: "es-1-9-49", da: "Prepare data reports that demonstrate your product's value to potential buyers."
                 },
              ]
            },
          ]
        },
        {
          id: 'es-2',
          icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
          comp: 'Minimum Viable Community',
          wdd: '',
          progressMeasures:[
            {
              id: 'es-2-0',
              pm: 'Feedback from pilot meetings and events solidifies the need and resolves it for few participants.',
              title:'Need',
              pmMap: 'Feedback from pilot meetings and events solidifies the need and resolves it for few participants.',
              developmentActions:[
                {
                  id: "es-2-0-0", da: "Develop an ecosystem website or platform."
                 },
                 {
                  id: "es-2-0-1", da: "Set up user registration and profiles."
                 },
                 {
                  id: "es-2-0-2", da: "Create a forum for discussions."
                 },
                 {
                  id: "es-2-0-3", da: "Enable chat or messaging features."
                 },
                 {
                  id: "es-2-0-4", da: "Provide documentation for developers."
                 },
                 {
                  id: "es-2-0-5", da: "Implement version control for projects."
                 },
                 {
                  id: "es-2-0-6", da: "Create a bug tracking system."
                 },
                 {
                  id: "es-2-0-7", da: "Establish a code review process."
                 },
                 {
                  id: "es-2-0-8", da: "Define coding standards."
                 },
                 {
                  id: "es-2-0-9", da: "Encourage code contributions."
                 },
                 {
                  id: "es-2-0-10", da: "Host webinars or tutorials."
                 },
                 {
                  id: "es-2-0-11", da: "Organize hackathons."
                 },
                 {
                  id: "es-2-0-12", da: "Establish a mentoring program."
                 },
                 {
                  id: "es-2-0-13", da: "Share success stories."
                 },
                 {
                  id: "es-2-0-14", da: "Encourage cross-collaboration."
                 },
                 {
                  id: "es-2-0-15", da: "Implement a rewards and recognition system."
                 },
                 {
                  id: "es-2-0-16", da: "Host virtual or in-person events."
                 },
                 {
                  id: "es-2-0-17", da: "Develop mobile apps or integrations."
                 },
                 {
                  id: "es-2-0-18", da: "Provide support for new developers."
                 },
                 {
                  id: "es-2-0-19", da: "Conduct surveys for feedback."
                 },
                 {
                  id: "es-2-0-20", da: "Improve user experience on the platform."
                 },
                 {
                  id: "es-2-0-21", da: "Promote diversity and inclusion."
                 },
                 {
                  id: "es-2-0-22", da: "Support multiple languages."
                 },
                 {
                  id: "es-2-0-23", da: "Create special interest groups."
                 },
                 {
                  id: "es-2-0-24", da: "Foster partnerships with other communities."
                 },
                 {
                  id: "es-2-0-25", da: "Develop APIs for integration."
                 },
                 {
                  id: "es-2-0-26", da: "Improve search functionality."
                 },
                 {
                  id: "es-2-0-27", da: "Offer a knowledge base."
                 },
                 {
                  id: "es-2-0-28", da: "Encourage user-generated content."
                 },
                 {
                  id: "es-2-0-29", da: "Create a testing environment."
                 },
                 {
                  id: "es-2-0-30", da: "Run regular community calls."
                 },
                 {
                  id: "es-2-0-31", da: "Establish community guidelines."
                 },
                 {
                  id: "es-2-0-32", da: "Host developer showcases."
                 },
                 {
                  id: "es-2-0-33", da: "Expand the community on social media."
                 },
                 {
                  id: "es-2-0-34", da: "Offer training programs."
                 },
                 {
                  id: "es-2-0-35", da: "Support localization efforts."
                 },
                 {
                  id: "es-2-0-36", da: "Provide resources for beginners."
                 },
                 {
                  id: "es-2-0-37", da: "Address accessibility concerns."
                 },
                 {
                  id: "es-2-0-38", da: "Collaborate with educational institutions."
                 },
                 {
                  id: "es-2-0-39", da: "Share best practices."
                 },
                 {
                  id: "es-2-0-40", da: "Conduct regular code audits."
                 },
                 {
                  id: "es-2-0-41", da: "Set up a newsletter or mailing list."
                 },
                 {
                  id: "es-2-0-42", da: "Maintain a community blog."
                 },
                 {
                  id: "es-2-0-43", da: "Develop open-source projects."
                 },
                 {
                  id: "es-2-0-44", da: "Provide continuous integration."
                 },
                 {
                  id: "es-2-0-45", da: "Promote open-source licenses."
                 },
                 {
                  id: "es-2-0-46", da: "Establish a security process."
                 },
                 {
                  id: "es-2-0-47", da: "Collaborate with industry leaders."
                 },
                 {
                  id: "es-2-0-48", da: "Seek funding or grants."
                 },
                 {
                  id: "es-2-0-49", da: "Measure and report on community impact."
                 },
              ]
            },
            {
              id: 'es-2-1',
              pm: 'The initial results reveal that the chosen approach solves an identified pain point with an attributable market value.',
              title:'Market',
              pmMap: 'The initial results reveal that the chosen approach solves an identified pain point with an attributable market value.',
              developmentActions:[
                {
                  id: "es-2-1-0", da: " Conduct thorough market research to understand customer needs and preferences."
                 },
                 {
                  id: "es-2-1-1", da: " Identify and segment your target audience for tailored offerings."
                 },
                 {
                  id: "es-2-1-2", da: " Analyze your competition and identify gaps in the market."
                 },
                 {
                  id: "es-2-1-3", da: " Develop a competitive pricing strategy."
                 },
                 {
                  id: "es-2-1-4", da: " Continuously improve your products or services based on market feedback."
                 },
                 {
                  id: "es-2-1-5", da: " Create a comprehensive marketing plan."
                 },
                 {
                  id: "es-2-1-6", da: " Establish a strong social media presence for brand visibility."
                 },
                 {
                  id: "es-2-1-7", da: " Produce valuable content to engage and educate your audience."
                 },
                 {
                  id: "es-2-1-8", da: " Optimize your online content for search engines."
                 },
                 {
                  id: "es-2-1-9", da: " Utilize email campaigns for customer retention and acquisition."
                 },
                 {
                  id: "es-2-1-10", da: " Collaborate with influencers in your niche."
                 },
                 {
                  id: "es-2-1-11", da: " Implement a referral program to incentivize customer referrals."
                 },
                 {
                  id: "es-2-1-12", da: " Improve the user experience on your website or app."
                 },
                 {
                  id: "es-2-1-13", da: " Ensure your platform is mobile-friendly."
                 },
                 {
                  id: "es-2-1-14", da: " Provide exceptional customer support."
                 },
                 {
                  id: "es-2-1-15", da: " Leverage data to make informed decisions."
                 },
                 {
                  id: "es-2-1-16", da: " Conduct A\/B tests to optimize marketing campaigns."
                 },
                 {
                  id: "es-2-1-17", da: " Implement loyalty programs to retain customers."
                 },
                 {
                  id: "es-2-1-18", da: " Collaborate with complementary businesses for mutual benefit."
                 },
                 {
                  id: "es-2-1-19", da: " Collect and act on customer feedback."
                 },
                 {
                  id: "es-2-1-20", da: " Optimize for local search if relevant to your business."
                 },
                 {
                  id: "es-2-1-21", da: " Attend industry events to connect with potential customers."
                 },
                 {
                  id: "es-2-1-22", da: " Use surveys to gather insights."
                 },
                 {
                  id: "es-2-1-23", da: " Invest in online advertising campaigns."
                 },
                 {
                  id: "es-2-1-24", da: " Foster a community around your brand."
                 },
                 {
                  id: "es-2-1-25", da: " Offer product demonstrations or trials."
                 },
                 {
                  id: "es-2-1-26", da: " Enhance product packaging for shelf appeal."
                 },
                 {
                  id: "es-2-1-27", da: " Train your staff to provide exceptional service."
                 },
                 {
                  id: "es-2-1-28", da: " Equip your sales team with the right skills."
                 },
                 {
                  id: "es-2-1-29", da: " Consider expanding to new geographic regions."
                 },
                 {
                  id: "es-2-1-30", da: " Highlight sustainable and eco-friendly initiatives."
                 },
                 {
                  id: "es-2-1-31", da: " Encourage customers to create content about your products."
                 },
                 {
                  id: "es-2-1-32", da: " Run occasional sales promotions."
                 },
                 {
                  id: "es-2-1-33", da: " Show your commitment to social causes."
                 },
                 {
                  id: "es-2-1-34", da: " Explore niche markets for specialized offerings."
                 },
                 {
                  id: "es-2-1-35", da: " Recommend related products to customers."
                 },
                 {
                  id: "es-2-1-36", da: " Develop a dedicated mobile app."
                 },
                 {
                  id: "es-2-1-37", da: " Showcase testimonials from influential clients."
                 },
                 {
                  id: "es-2-1-38", da: " Ensure customers' data security and privacy."
                 },
                 {
                  id: "es-2-1-39", da: " Make the buying process as convenient as possible."
                 },
                 {
                  id: "es-2-1-40", da: " Offer various payment options."
                 },
                 {
                  id: "es-2-1-41", da: " Promote diversity and inclusion in your marketing."
                 },
                 {
                  id: "es-2-1-42", da: " Have a plan for handling PR crises."
                 },
                 {
                  id: "es-2-1-43", da: " Protect your brand and ideas."
                 },
                 {
                  id: "es-2-1-44", da: " Build relationships with key industry players."
                 },
                 {
                  id: "es-2-1-45", da: " Ensure compliance with relevant regulations."
                 },
                 {
                  id: "es-2-1-46", da: " Invest in appealing and informative packaging."
                 },
                 {
                  id: "es-2-1-47", da: " Communicate your long-term vision to customers."
                 },
                 {
                  id: "es-2-1-48", da: " Educate customers on your products or services."
                 },
                 {
                  id: "es-2-1-49", da: " Commit to ongoing improvement in all aspects of your business."
                 },
              ]
            },
            {
              id: 'es-2-2',
              pm: 'Various tools have been identified for use for the ecosystem and tred out. Clear use case for the use of technology is established.',
              title:'Technology',
              pmMap: 'Various tools have been identified for use for the ecosystem and tred out. Clear use case for the use of technology is established.',
              developmentActions:[
                {
                  id: "es-2-2-0", da: "Develop a community website or platform for collaboration."
                 },
                 {
                  id: "es-2-2-1", da: "Implement user-friendly onboarding processes."
                 },
                 {
                  id: "es-2-2-2", da: "Create mobile apps for community engagement."
                 },
                 {
                  id: "es-2-2-3", da: "Offer a community forum for discussions."
                 },
                 {
                  id: "es-2-2-4", da: "Improve website performance and load times."
                 },
                 {
                  id: "es-2-2-5", da: "Enhance data security and privacy measures."
                 },
                 {
                  id: "es-2-2-6", da: "Implement AI for data analysis and insights."
                 },
                 {
                  id: "es-2-2-7", da: "Provide video conferencing tools for virtual meetups."
                 },
                 {
                  id: "es-2-2-8", da: "Enable chatbots for instant support."
                 },
                 {
                  id: "es-2-2-9", da: "Optimize for mobile responsiveness."
                 },
                 {
                  id: "es-2-2-10", da: "Integrate blockchain for transparent transactions."
                 },
                 {
                  id: "es-2-2-11", da: "Launch a community management app."
                 },
                 {
                  id: "es-2-2-12", da: "Enable data analytics for decision-making."
                 },
                 {
                  id: "es-2-2-13", da: "Automate routine tasks with RPA."
                 },
                 {
                  id: "es-2-2-14", da: "Implement IoT for real-time monitoring."
                 },
                 {
                  id: "es-2-2-15", da: "Create a knowledge base for members."
                 },
                 {
                  id: "es-2-2-16", da: "Use machine learning for content recommendations."
                 },
                 {
                  id: "es-2-2-17", da: "Offer e-learning platforms."
                 },
                 {
                  id: "es-2-2-18", da: "Integrate social media sharing."
                 },
                 {
                  id: "es-2-2-19", da: "Improve search functionality."
                 },
                 {
                  id: "es-2-2-20", da: "Enable voice search."
                 },
                 {
                  id: "es-2-2-21", da: "Implement two-factor authentication (2FA)."
                 },
                 {
                  id: "es-2-2-22", da: "Create APIs for integration with other services."
                 },
                 {
                  id: "es-2-2-23", da: "Develop a mobile wallet for transactions."
                 },
                 {
                  id: "es-2-2-24", da: "Provide real-time language translation."
                 },
                 {
                  id: "es-2-2-25", da: "Use AR\/VR for immersive experiences."
                 },
                 {
                  id: "es-2-2-26", da: "Offer gamification for engagement."
                 },
                 {
                  id: "es-2-2-27", da: "Enable geolocation services."
                 },
                 {
                  id: "es-2-2-28", da: "Implement e-voting for decisions."
                 },
                 {
                  id: "es-2-2-29", da: "Create a token economy."
                 },
                 {
                  id: "es-2-2-30", da: "Provide content personalization."
                 },
                 {
                  id: "es-2-2-31", da: "Enable crowdfunding features."
                 },
                 {
                  id: "es-2-2-32", da: "Improve cybersecurity measures."
                 },
                 {
                  id: "es-2-2-33", da: "Implement data backup and recovery solutions."
                 },
                 {
                  id: "es-2-2-34", da: "Create interactive data visualizations."
                 },
                 {
                  id: "es-2-2-35", da: "Enable push notifications."
                 },
                 {
                  id: "es-2-2-36", da: "Integrate email marketing tools."
                 },
                 {
                  id: "es-2-2-37", da: "Develop a CRM system for member management."
                 },
                 {
                  id: "es-2-2-38", da: "Use data mining for insights."
                 },
                 {
                  id: "es-2-2-39", da: "Enable data export features."
                 },
                 {
                  id: "es-2-2-40", da: "Implement remote work tools."
                 },
                 {
                  id: "es-2-2-41", da: "Provide 24\/7 customer support."
                 },
                 {
                  id: "es-2-2-42", da: "Create a user-friendly dashboard."
                 },
                 {
                  id: "es-2-2-43", da: "Use big data analytics for trends."
                 },
                 {
                  id: "es-2-2-44", da: "Develop a mobile community app."
                 },
                 {
                  id: "es-2-2-45", da: "Offer live streaming for events."
                 },
                 {
                  id: "es-2-2-46", da: "Implement project management tools."
                 },
                 {
                  id: "es-2-2-47", da: "Enable content sharing and embedding."
                 },
                 {
                  id: "es-2-2-48", da: "Provide virtual reality training."
                 },
                 {
                  id: "es-2-2-49", da: "Use machine learning for user behavior analysis."
                 },
              ]
            },
            {
              id: 'es-2-3',
              pm: 'Initial results lead to clear value proposition and USPs (unique selling proposition). ',
              title:'Value',
              pmMap: 'Initial results lead to clear value proposition and USPs (unique selling proposition). ',
              developmentActions:[
                {
                  id: "es-2-3-0", da: "Define a clear mission and purpose for the ecosystem."
                 },
                 {
                  id: "es-2-3-1", da: "Identify key stakeholders and their roles."
                 },
                 {
                  id: "es-2-3-2", da: "Develop a strategic roadmap for ecosystem growth."
                 },
                 {
                  id: "es-2-3-3", da: "Create a user-friendly website or platform for the community."
                 },
                 {
                  id: "es-2-3-4", da: "Establish a forum or discussion board for community interactions."
                 },
                 {
                  id: "es-2-3-5", da: "Provide educational resources and training."
                 },
                 {
                  id: "es-2-3-6", da: "Encourage knowledge sharing among members."
                 },
                 {
                  id: "es-2-3-7", da: "Implement a reward or incentive system."
                 },
                 {
                  id: "es-2-3-8", da: "Set up regular webinars or online events."
                 },
                 {
                  id: "es-2-3-9", da: "Foster collaborations between members."
                 },
                 {
                  id: "es-2-3-10", da: "Launch a mentorship program."
                 },
                 {
                  id: "es-2-3-11", da: "Offer a sandbox or development environment."
                 },
                 {
                  id: "es-2-3-12", da: "Improve the onboarding process for new members."
                 },
                 {
                  id: "es-2-3-13", da: "Enable multi-language support."
                 },
                 {
                  id: "es-2-3-14", da: "Conduct surveys to gather feedback."
                 },
                 {
                  id: "es-2-3-15", da: "Identify and address pain points in the ecosystem."
                 },
                 {
                  id: "es-2-3-16", da: "Promote active participation from members."
                 },
                 {
                  id: "es-2-3-17", da: "Share success stories and case studies."
                 },
                 {
                  id: "es-2-3-18", da: "Develop a mobile app for accessibility."
                 },
                 {
                  id: "es-2-3-19", da: "Ensure diversity and inclusivity."
                 },
                 {
                  id: "es-2-3-20", da: "Establish clear guidelines and rules."
                 },
                 {
                  id: "es-2-3-21", da: "Enable private group discussions."
                 },
                 {
                  id: "es-2-3-22", da: "Facilitate networking opportunities."
                 },
                 {
                  id: "es-2-3-23", da: "Implement analytics for user behavior."
                 },
                 {
                  id: "es-2-3-24", da: "Promote open-source contributions."
                 },
                 {
                  id: "es-2-3-25", da: "Foster a sense of belonging and ownership."
                 },
                 {
                  id: "es-2-3-26", da: "Provide templates and tools for community projects."
                 },
                 {
                  id: "es-2-3-27", da: "Create a job board for opportunities."
                 },
                 {
                  id: "es-2-3-28", da: "Offer a marketplace for goods and services."
                 },
                 {
                  id: "es-2-3-29", da: "Conduct regular town hall meetings."
                 },
                 {
                  id: "es-2-3-30", da: "Build a resource library."
                 },
                 {
                  id: "es-2-3-31", da: "Encourage members to recruit new participants."
                 },
                 {
                  id: "es-2-3-32", da: "Develop a support ticket system."
                 },
                 {
                  id: "es-2-3-33", da: "Showcase member profiles and achievements."
                 },
                 {
                  id: "es-2-3-34", da: "Enable peer reviews and endorsements."
                 },
                 {
                  id: "es-2-3-35", da: "Provide a user-friendly search feature."
                 },
                 {
                  id: "es-2-3-36", da: "Offer a chat feature for real-time communication."
                 },
                 {
                  id: "es-2-3-37", da: "Develop API integrations with other tools."
                 },
                 {
                  id: "es-2-3-38", da: "Enable social media sharing."
                 },
                 {
                  id: "es-2-3-39", da: "Showcase upcoming events and deadlines."
                 },
                 {
                  id: "es-2-3-40", da: "Establish partnerships with related organizations."
                 },
                 {
                  id: "es-2-3-41", da: "Create a community newsletter."
                 },
                 {
                  id: "es-2-3-42", da: "Conduct regular challenges and contests."
                 },
                 {
                  id: "es-2-3-43", da: "Enable role-based access control."
                 },
                 {
                  id: "es-2-3-44", da: "Implement a tiered membership system."
                 },
                 {
                  id: "es-2-3-45", da: "Organize hackathons and coding competitions."
                 },
                 {
                  id: "es-2-3-46", da: "Build a resource marketplace."
                 },
                 {
                  id: "es-2-3-47", da: "Maintain a transparent development process."
                 },
                 {
                  id: "es-2-3-48", da: "Collect and display testimonials."
                 },
                 {
                  id: "es-2-3-49", da: "Continuously gather and act on user feedback."
                 },
              ]
            },
            {
              id: 'es-2-4',
              pm: 'Team can prove that their pricing model works with a sustainable ROI.',
              title:'Business Model',
              pmMap: 'Team can prove that their pricing model works with a sustainable ROI.',
              developmentActions:[
                {
                  id: "es-2-4-0", da: "Define your ecosystem's mission and purpose."
                 },
                 {
                  id: "es-2-4-1", da: "Identify key stakeholders and potential community members."
                 },
                 {
                  id: "es-2-4-2", da: "Develop a clear value proposition for community participation."
                 },
                 {
                  id: "es-2-4-3", da: "Create a user-friendly platform or website for community engagement."
                 },
                 {
                  id: "es-2-4-4", da: "Develop a community on social media platforms."
                 },
                 {
                  id: "es-2-4-5", da: "Launch an email newsletter to keep the community informed."
                 },
                 {
                  id: "es-2-4-6", da: "Host webinars, workshops, or events to engage the community."
                 },
                 {
                  id: "es-2-4-7", da: "Encourage peer-to-peer networking within the community."
                 },
                 {
                  id: "es-2-4-8", da: "Establish community guidelines and rules."
                 },
                 {
                  id: "es-2-4-9", da: "Appoint community managers to facilitate interactions."
                 },
                 {
                  id: "es-2-4-10", da: "Encourage user-generated content."
                 },
                 {
                  id: "es-2-4-11", da: "Provide incentives or rewards for active community members."
                 },
                 {
                  id: "es-2-4-12", da: "Share success stories within the community."
                 },
                 {
                  id: "es-2-4-13", da: "Foster a sense of belonging and inclusivity."
                 },
                 {
                  id: "es-2-4-14", da: "Implement feedback mechanisms for improvement."
                 },
                 {
                  id: "es-2-4-15", da: "Leverage influencers to promote the ecosystem."
                 },
                 {
                  id: "es-2-4-16", da: "Highlight early adopters and their contributions."
                 },
                 {
                  id: "es-2-4-17", da: "Collaborate with complementary ecosystems."
                 },
                 {
                  id: "es-2-4-18", da: "Create a referral program to attract new members."
                 },
                 {
                  id: "es-2-4-19", da: "Offer exclusive access or benefits to members."
                 },
                 {
                  id: "es-2-4-20", da: "Develop a roadmap for community growth."
                 },
                 {
                  id: "es-2-4-21", da: "Regularly measure and analyze community engagement."
                 },
                 {
                  id: "es-2-4-22", da: "Encourage cross-promotion within the community."
                 },
                 {
                  id: "es-2-4-23", da: "Implement a mentorship program for newcomers."
                 },
                 {
                  id: "es-2-4-24", da: "Recognize and celebrate community milestones."
                 },
                 {
                  id: "es-2-4-25", da: "Create a community knowledge base or resource center."
                 },
                 {
                  id: "es-2-4-26", da: "Establish a dedicated support system."
                 },
                 {
                  id: "es-2-4-27", da: "Encourage members to participate in research and surveys."
                 },
                 {
                  id: "es-2-4-28", da: "Promote thought leadership within the community."
                 },
                 {
                  id: "es-2-4-29", da: "Offer community-specific content and resources."
                 },
                 {
                  id: "es-2-4-30", da: "Organize contests or challenges."
                 },
                 {
                  id: "es-2-4-31", da: "Host virtual or physical meetups."
                 },
                 {
                  id: "es-2-4-32", da: "Promote the ecosystem at relevant industry events."
                 },
                 {
                  id: "es-2-4-33", da: "Implement gamification elements."
                 },
                 {
                  id: "es-2-4-34", da: "Develop a mobile app for community access."
                 },
                 {
                  id: "es-2-4-35", da: "Conduct user interviews for feedback."
                 },
                 {
                  id: "es-2-4-36", da: "Communicate the ecosystem's achievements."
                 },
                 {
                  id: "es-2-4-37", da: "Build partnerships with local organizations."
                 },
                 {
                  id: "es-2-4-38", da: "Regularly update community members on ecosystem progress."
                 },
                 {
                  id: "es-2-4-39", da: "Engage with community discussions and feedback."
                 },
                 {
                  id: "es-2-4-40", da: "Ensure transparency in decision-making processes."
                 },
                 {
                  id: "es-2-4-41", da: "Encourage members to share their skills and knowledge."
                 },
                 {
                  id: "es-2-4-42", da: "Showcase the impact of the ecosystem on members' lives."
                 },
                 {
                  id: "es-2-4-43", da: "Address concerns or issues promptly."
                 },
                 {
                  id: "es-2-4-44", da: "Create a member directory for networking."
                 },
                 {
                  id: "es-2-4-45", da: "Promote community engagement through storytelling."
                 },
                 {
                  id: "es-2-4-46", da: "Continuously adapt to community needs and preferences."
                 },
                 {
                  id: "es-2-4-47", da: "Recognize the importance of diversity and inclusion."
                 },
                 {
                  id: "es-2-4-48", da: "Foster a culture of continuous learning."
                 },
                 {
                  id: "es-2-4-49", da: "Build a data-driven approach to community growth."
                 },
              ]
            },
            {
              id: 'es-2-5',
              pm: 'All early adopters in the community feel its relevance and have a high NPS.',
              title:'Go to Market',
              pmMap: 'All early adopters in the community feel its relevance and have a high NPS.',
              developmentActions:[
                {
                  id: "es-2-5-0", da: "Define clear GTM objectives."
                 },
                 {
                  id: "es-2-5-1", da: "Identify the target audience and their pain points."
                 },
                 {
                  id: "es-2-5-2", da: "Develop detailed buyer personas."
                 },
                 {
                  id: "es-2-5-3", da: "Create compelling value propositions."
                 },
                 {
                  id: "es-2-5-4", da: "Analyze the competition and differentiators."
                 },
                 {
                  id: "es-2-5-5", da: "Build a strong online presence."
                 },
                 {
                  id: "es-2-5-6", da: "Optimize the website for search engines."
                 },
                 {
                  id: "es-2-5-7", da: "Leverage content marketing."
                 },
                 {
                  id: "es-2-5-8", da: "Launch a blog for thought leadership."
                 },
                 {
                  id: "es-2-5-9", da: "Use social media to engage and inform."
                 },
                 {
                  id: "es-2-5-10", da: "Email marketing campaigns."
                 },
                 {
                  id: "es-2-5-11", da: "Establish partnerships and alliances."
                 },
                 {
                  id: "es-2-5-12", da: "Identify key influencers."
                 },
                 {
                  id: "es-2-5-13", da: "Run webinars and online events."
                 },
                 {
                  id: "es-2-5-14", da: "Attend industry conferences and events."
                 },
                 {
                  id: "es-2-5-15", da: "Develop case studies and success stories."
                 },
                 {
                  id: "es-2-5-16", da: "Run A\/B testing on marketing campaigns."
                 },
                 {
                  id: "es-2-5-17", da: "Implement marketing automation."
                 },
                 {
                  id: "es-2-5-18", da: "Conduct customer surveys."
                 },
                 {
                  id: "es-2-5-19", da: "Invest in paid advertising (Google Ads, Facebook Ads)."
                 },
                 {
                  id: "es-2-5-20", da: "Develop referral programs."
                 },
                 {
                  id: "es-2-5-21", da: "Optimize product pricing and packaging."
                 },
                 {
                  id: "es-2-5-22", da: "Provide exceptional customer support."
                 },
                 {
                  id: "es-2-5-23", da: "Create a loyalty program."
                 },
                 {
                  id: "es-2-5-24", da: "Develop an affiliate marketing program."
                 },
                 {
                  id: "es-2-5-25", da: "Offer free trials."
                 },
                 {
                  id: "es-2-5-26", da: "Run promotional discounts."
                 },
                 {
                  id: "es-2-5-27", da: "Develop user-generated content."
                 },
                 {
                  id: "es-2-5-28", da: "Implement feedback loops."
                 },
                 {
                  id: "es-2-5-29", da: "Create an interactive knowledge base."
                 },
                 {
                  id: "es-2-5-30", da: "Launch a podcast or YouTube channel."
                 },
                 {
                  id: "es-2-5-31", da: "Offer onboarding and training resources."
                 },
                 {
                  id: "es-2-5-32", da: "Optimize landing pages for conversion."
                 },
                 {
                  id: "es-2-5-33", da: "Build a strong brand identity."
                 },
                 {
                  id: "es-2-5-34", da: "Conduct market research."
                 },
                 {
                  id: "es-2-5-35", da: "Launch a developer portal for community engagement."
                 },
                 {
                  id: "es-2-5-36", da: "Run contests and giveaways."
                 },
                 {
                  id: "es-2-5-37", da: "Provide developer resources and documentation."
                 },
                 {
                  id: "es-2-5-38", da: "Implement continuous product improvement."
                 },
                 {
                  id: "es-2-5-39", da: "Solicit feedback from community members."
                 },
                 {
                  id: "es-2-5-40", da: "Run user testing and usability studies."
                 },
                 {
                  id: "es-2-5-41", da: "Set up user forums or community platforms."
                 },
                 {
                  id: "es-2-5-42", da: "Launch a developer ambassador program."
                 },
                 {
                  id: "es-2-5-43", da: "Facilitate hackathons and coding challenges."
                 },
                 {
                  id: "es-2-5-44", da: "Offer co-marketing opportunities for partners."
                 },
                 {
                  id: "es-2-5-45", da: "Provide technical support resources."
                 },
                 {
                  id: "es-2-5-46", da: "Develop a referral program for community growth."
                 },
                 {
                  id: "es-2-5-47", da: "Create a system for tracking ROI on marketing efforts."
                 },
                 {
                  id: "es-2-5-48", da: "Evaluate and adjust the GTM strategy regularly."
                 },
                 {
                  id: "es-2-5-49", da: "Continuously measure and improve community engagement."
                 },
              ]
            },
            {
              id: 'es-2-6',
              pm: 'The early team and founders are reliably in it with substantial commitment.',
              title:'People',
              pmMap: 'The early team and founders are reliably in it with substantial commitment.',
              developmentActions:[
                {
                  id: "es-2-6-0", da: "Conduct training sessions and workshops."
                 },
                 {
                  id: "es-2-6-1", da: "Foster a culture of continuous learning."
                 },
                 {
                  id: "es-2-6-2", da: "Encourage personal development plans."
                 },
                 {
                  id: "es-2-6-3", da: "Provide mentorship opportunities."
                 },
                 {
                  id: "es-2-6-4", da: "Set clear expectations and goals."
                 },
                 {
                  id: "es-2-6-5", da: "Promote collaboration and teamwork."
                 },
                 {
                  id: "es-2-6-6", da: "Recognize and reward achievements."
                 },
                 {
                  id: "es-2-6-7", da: "Implement flexible work arrangements."
                 },
                 {
                  id: "es-2-6-8", da: "Offer health and wellness programs."
                 },
                 {
                  id: "es-2-6-9", da: "Support work-life balance."
                 },
                 {
                  id: "es-2-6-10", da: "Promote diversity and inclusion."
                 },
                 {
                  id: "es-2-6-11", da: "Build effective communication skills."
                 },
                 {
                  id: "es-2-6-12", da: "Enhance time management skills."
                 },
                 {
                  id: "es-2-6-13", da: "Develop leadership capabilities."
                 },
                 {
                  id: "es-2-6-14", da: "Provide conflict resolution training."
                 },
                 {
                  id: "es-2-6-15", da: "Offer stress management resources."
                 },
                 {
                  id: "es-2-6-16", da: "Foster creativity and innovation."
                 },
                 {
                  id: "es-2-6-17", da: "Encourage critical thinking."
                 },
                 {
                  id: "es-2-6-18", da: "Enhance problem-solving abilities."
                 },
                 {
                  id: "es-2-6-19", da: "Develop decision-making skills."
                 },
                 {
                  id: "es-2-6-20", da: "Build emotional intelligence."
                 },
                 {
                  id: "es-2-6-21", da: "Offer technical training."
                 },
                 {
                  id: "es-2-6-22", da: "Enhance coding and programming skills."
                 },
                 {
                  id: "es-2-6-23", da: "Develop design and UI\/UX skills."
                 },
                 {
                  id: "es-2-6-24", da: "Improve data analysis and reporting."
                 },
                 {
                  id: "es-2-6-25", da: "Foster project management skills."
                 },
                 {
                  id: "es-2-6-26", da: "Enhance marketing and sales capabilities."
                 },
                 {
                  id: "es-2-6-27", da: "Develop financial literacy."
                 },
                 {
                  id: "es-2-6-28", da: "Improve negotiation skills."
                 },
                 {
                  id: "es-2-6-29", da: "Enhance customer service skills."
                 },
                 {
                  id: "es-2-6-30", da: "Promote networking and relationship-building."
                 },
                 {
                  id: "es-2-6-31", da: "Develop public speaking and presentation skills."
                 },
                 {
                  id: "es-2-6-32", da: "Foster adaptability and resilience."
                 },
                 {
                  id: "es-2-6-33", da: "Enhance time and resource management."
                 },
                 {
                  id: "es-2-6-34", da: "Develop remote work skills."
                 },
                 {
                  id: "es-2-6-35", da: "Offer conflict resolution training."
                 },
                 {
                  id: "es-2-6-36", da: "Promote stress management resources."
                 },
                 {
                  id: "es-2-6-37", da: "Foster effective communication skills."
                 },
                 {
                  id: "es-2-6-38", da: "Enhance teamwork and collaboration."
                 },
                 {
                  id: "es-2-6-39", da: "Develop negotiation skills."
                 },
                 {
                  id: "es-2-6-40", da: "Improve problem-solving abilities."
                 },
                 {
                  id: "es-2-6-41", da: "Enhance decision-making skills."
                 },
                 {
                  id: "es-2-6-42", da: "Foster creativity and innovation."
                 },
                 {
                  id: "es-2-6-43", da: "Encourage critical thinking."
                 },
                 {
                  id: "es-2-6-44", da: "Develop leadership capabilities."
                 },
                 {
                  id: "es-2-6-45", da: "Provide mentorship opportunities."
                 },
                 {
                  id: "es-2-6-46", da: "Set clear expectations and goals."
                 },
                 {
                  id: "es-2-6-47", da: "Recognize and reward achievements."
                 },
                 {
                  id: "es-2-6-48", da: "Promote diversity and inclusion."
                 },
                 {
                  id: "es-2-6-49", da: "Build emotional intelligence."
                 },
              ]
            },
            {
              id: 'es-2-7',
              pm: 'Performance metrics are defined and structured to operate in periodic reporting.',
              title:'Data Metrics',
              pmMap: 'Performance metrics are defined and structured to operate in periodic reporting.',
              developmentActions:[
                {
                  id: "es-2-7-0", da: "Define clear data goals and objectives."
                 },
                 {
                  id: "es-2-7-1", da: "Identify key performance indicators (KPIs) for community growth."
                 },
                 {
                  id: "es-2-7-2", da: "Implement data collection methods."
                 },
                 {
                  id: "es-2-7-3", da: "Use analytics tools to track user engagement."
                 },
                 {
                  id: "es-2-7-4", da: "Monitor user onboarding metrics."
                 },
                 {
                  id: "es-2-7-5", da: "Analyze conversion rates within the ecosystem."
                 },
                 {
                  id: "es-2-7-6", da: "Measure user retention and churn rates."
                 },
                 {
                  id: "es-2-7-7", da: "Collect demographic data to understand your community."
                 },
                 {
                  id: "es-2-7-8", da: "Monitor user activity levels."
                 },
                 {
                  id: "es-2-7-9", da: "Analyze user-generated content."
                 },
                 {
                  id: "es-2-7-10", da: "Track community feedback and sentiment."
                 },
                 {
                  id: "es-2-7-11", da: "Assess the impact of marketing campaigns on data metrics."
                 },
                 {
                  id: "es-2-7-12", da: "Evaluate the success of user incentives and rewards."
                 },
                 {
                  id: "es-2-7-13", da: "Measure the effectiveness of community outreach efforts."
                 },
                 {
                  id: "es-2-7-14", da: "Analyze the impact of product updates on user behavior."
                 },
                 {
                  id: "es-2-7-15", da: "Monitor the performance of community leaders and influencers."
                 },
                 {
                  id: "es-2-7-16", da: "Assess the impact of user support initiatives."
                 },
                 {
                  id: "es-2-7-17", da: "Measure the effectiveness of educational resources."
                 },
                 {
                  id: "es-2-7-18", da: "Track the growth of sub-communities within the ecosystem."
                 },
                 {
                  id: "es-2-7-19", da: "Analyze the impact of community events and meetups."
                 },
                 {
                  id: "es-2-7-20", da: "Monitor the response to user surveys and feedback forms."
                 },
                 {
                  id: "es-2-7-21", da: "Assess the performance of community forums and discussion boards."
                 },
                 {
                  id: "es-2-7-22", da: "Track the effectiveness of community-based content marketing."
                 },
                 {
                  id: "es-2-7-23", da: "Measure user trust and credibility within the ecosystem."
                 },
                 {
                  id: "es-2-7-24", da: "Analyze the performance of referral programs."
                 },
                 {
                  id: "es-2-7-25", da: "Monitor user preferences and content consumption patterns."
                 },
                 {
                  id: "es-2-7-26", da: "Assess the impact of gamification on user engagement."
                 },
                 {
                  id: "es-2-7-27", da: "Measure the success of user-generated content campaigns."
                 },
                 {
                  id: "es-2-7-28", da: "Track the growth of user-generated content."
                 },
                 {
                  id: "es-2-7-29", da: "Analyze the impact of user segmentation on data metrics."
                 },
                 {
                  id: "es-2-7-30", da: "Monitor the effectiveness of data security measures."
                 },
                 {
                  id: "es-2-7-31", da: "Assess the impact of user privacy policies on trust."
                 },
                 {
                  id: "es-2-7-32", da: "Measure the performance of data analytics tools."
                 },
                 {
                  id: "es-2-7-33", da: "Analyze the impact of data quality and accuracy."
                 },
                 {
                  id: "es-2-7-34", da: "Track user adoption rates for new features."
                 },
                 {
                  id: "es-2-7-35", da: "Monitor the performance of data visualization tools."
                 },
                 {
                  id: "es-2-7-36", da: "Assess the impact of data accessibility and sharing features."
                 },
                 {
                  id: "es-2-7-37", da: "Measure the success of data integration efforts."
                 },
                 {
                  id: "es-2-7-38", da: "Analyze the performance of data reporting and dashboards."
                 },
                 {
                  id: "es-2-7-39", da: "Track user engagement across different channels."
                 },
                 {
                  id: "es-2-7-40", da: "Monitor data-related support requests and issues."
                 },
                 {
                  id: "es-2-7-41", da: "Assess the impact of user training and education on data metrics."
                 },
                 {
                  id: "es-2-7-42", da: "Measure the effectiveness of data sharing mechanisms."
                 },
                 {
                  id: "es-2-7-43", da: "Analyze the performance of user data management features."
                 },
                 {
                  id: "es-2-7-44", da: "Track the growth of data-related user communities."
                 },
                 {
                  id: "es-2-7-45", da: "Monitor the response to data-related surveys and feedback."
                 },
                 {
                  id: "es-2-7-46", da: "Assess the impact of data policy compliance."
                 },
                 {
                  id: "es-2-7-47", da: "Measure the success of data-related partnerships and integrations."
                 },
                 {
                  id: "es-2-7-48", da: "Analyze the performance of data-driven decision-making processes."
                 },
                 {
                  id: "es-2-7-49", da: "Track the overall improvement of data metrics over time."
                 },
              ]
            },
            {
              id: 'es-2-8',
              pm: "The 'routines' are established and 'rituals' are followed.",
              title:'Operations',
              pmMap: "The 'routines' are established and 'rituals' are followed.",
              developmentActions:[
                {
                  id: "es-2-8-0", da: "Define clear goals and objectives for ecosystem activation."
                 },
                 {
                  id: "es-2-8-1", da: "Establish key performance indicators (KPIs) to measure progress."
                 },
                 {
                  id: "es-2-8-2", da: "Develop a comprehensive project plan with timelines."
                 },
                 {
                  id: "es-2-8-3", da: "Allocate resources effectively to support operations."
                 },
                 {
                  id: "es-2-8-4", da: "Build a dedicated team for community management."
                 },
                 {
                  id: "es-2-8-5", da: "Create a communication strategy for engaging the community."
                 },
                 {
                  id: "es-2-8-6", da: "Provide community members with regular updates and information."
                 },
                 {
                  id: "es-2-8-7", da: "Implement a robust onboarding process for new members."
                 },
                 {
                  id: "es-2-8-8", da: "Ensure clear and consistent branding across all communication channels."
                 },
                 {
                  id: "es-2-8-9", da: "Set up a platform or forum for community interaction."
                 },
                 {
                  id: "es-2-8-10", da: "Monitor and moderate community discussions to maintain a positive atmosphere."
                 },
                 {
                  id: "es-2-8-11", da: "Establish guidelines for appropriate behavior and content."
                 },
                 {
                  id: "es-2-8-12", da: "Encourage active participation from community members."
                 },
                 {
                  id: "es-2-8-13", da: "Recognize and reward active contributors."
                 },
                 {
                  id: "es-2-8-14", da: "Provide opportunities for community leadership and volunteer roles."
                 },
                 {
                  id: "es-2-8-15", da: "Develop educational resources and training materials."
                 },
                 {
                  id: "es-2-8-16", da: "Host webinars, workshops, or events to educate the community."
                 },
                 {
                  id: "es-2-8-17", da: "Gather feedback from community members to inform improvements."
                 },
                 {
                  id: "es-2-8-18", da: "Continuously evaluate the effectiveness of your ecosystem activation efforts."
                 },
                 {
                  id: "es-2-8-19", da: "Collaborate with partners or influencers to expand your reach."
                 },
                 {
                  id: "es-2-8-20", da: "Create a roadmap for community growth and development."
                 },
                 {
                  id: "es-2-8-21", da: "Identify and address pain points and challenges faced by the community."
                 },
                 {
                  id: "es-2-8-22", da: "Offer technical support and troubleshooting assistance."
                 },
                 {
                  id: "es-2-8-23", da: "Establish a feedback loop for product or service improvements."
                 },
                 {
                  id: "es-2-8-24", da: "Ensure transparency in decision-making processes."
                 },
                 {
                  id: "es-2-8-25", da: "Develop a clear content strategy for community engagement."
                 },
                 {
                  id: "es-2-8-26", da: "Leverage data and analytics to make informed decisions."
                 },
                 {
                  id: "es-2-8-27", da: "Create a FAQ section to address common inquiries."
                 },
                 {
                  id: "es-2-8-28", da: "Encourage cross-collaboration between community members."
                 },
                 {
                  id: "es-2-8-29", da: "Conduct regular surveys to gather insights from the community."
                 },
                 {
                  id: "es-2-8-30", da: "Segment your community for more personalized engagement."
                 },
                 {
                  id: "es-2-8-31", da: "Monitor and optimize community engagement on social media."
                 },
                 {
                  id: "es-2-8-32", da: "Implement a content calendar for consistent messaging."
                 },
                 {
                  id: "es-2-8-33", da: "Share success stories and case studies."
                 },
                 {
                  id: "es-2-8-34", da: "Promote diversity and inclusivity within the community."
                 },
                 {
                  id: "es-2-8-35", da: "Provide resources for members to find mentors or experts."
                 },
                 {
                  id: "es-2-8-36", da: "Establish a crisis communication plan."
                 },
                 {
                  id: "es-2-8-37", da: "Foster a culture of trust and respect within the community."
                 },
                 {
                  id: "es-2-8-38", da: "Develop clear escalation procedures for conflict resolution."
                 },
                 {
                  id: "es-2-8-39", da: "Encourage peer support and mentorship."
                 },
                 {
                  id: "es-2-8-40", da: "Ensure that all community guidelines are easily accessible."
                 },
                 {
                  id: "es-2-8-41", da: "Create a directory of community members and their expertise."
                 },
                 {
                  id: "es-2-8-42", da: "Engage with community members outside of the primary platform."
                 },
                 {
                  id: "es-2-8-43", da: "Celebrate milestones and achievements within the community."
                 },
                 {
                  id: "es-2-8-44", da: "Implement a referral program to expand the community."
                 },
                 {
                  id: "es-2-8-45", da: "Provide options for anonymous feedback or reporting issues."
                 },
                 {
                  id: "es-2-8-46", da: "Promote innovation and creativity among community members."
                 },
                 {
                  id: "es-2-8-47", da: "Offer virtual or in-person meetups or conferences."
                 },
                 {
                  id: "es-2-8-48", da: "Establish a disaster recovery plan for community continuity."
                 },
                 {
                  id: "es-2-8-49", da: "Continuously assess and iterate on your operations for ongoing improvement."
                 },
              ]
            },
            {
              id: 'es-2-9',
              pm: 'Community has an independent life now, it is self-sustaininig and doesn’t rely heavily on one or certain individuals for its existance.',
              title:'Exit Strategy',
              pmMap: 'Community has an independent life now, it is self-sustaininig and doesn’t rely heavily on one or certain individuals for its existance.',
              developmentActions:[
                {
                  id: "es-2-9-0", da: "Clearly define your project's objectives and goals."
                 },
                 {
                  id: "es-2-9-1", da: "Identify key performance indicators (KPIs) to measure progress."
                 },
                 {
                  id: "es-2-9-2", da: "Create a timeline for the exit strategy."
                 },
                 {
                  id: "es-2-9-3", da: "Assess the potential risks and challenges."
                 },
                 {
                  id: "es-2-9-4", da: "Develop a communication plan for stakeholders."
                 },
                 {
                  id: "es-2-9-5", da: "Establish criteria for success and failure."
                 },
                 {
                  id: "es-2-9-6", da: "Determine the desired outcomes of the exit strategy."
                 },
                 {
                  id: "es-2-9-7", da: "Consider various exit options, such as acquisition or merger."
                 },
                 {
                  id: "es-2-9-8", da: "Evaluate the financial aspects of the exit strategy."
                 },
                 {
                  id: "es-2-9-9", da: "Ensure legal and regulatory compliance."
                 },
                 {
                  id: "es-2-9-10", da: "Communicate the exit strategy with the community."
                 },
                 {
                  id: "es-2-9-11", da: "Train community members to take over responsibilities."
                 },
                 {
                  id: "es-2-9-12", da: "Plan for knowledge transfer and documentation."
                 },
                 {
                  id: "es-2-9-13", da: "Assess the impact on the ecosystem."
                 },
                 {
                  id: "es-2-9-14", da: "Consider the long-term sustainability of the community."
                 },
                 {
                  id: "es-2-9-15", da: "Define roles and responsibilities for community members."
                 },
                 {
                  id: "es-2-9-16", da: "Identify potential leaders to carry the project forward."
                 },
                 {
                  id: "es-2-9-17", da: "Address any outstanding debts or financial obligations."
                 },
                 {
                  id: "es-2-9-18", da: "Explore opportunities for partnerships."
                 },
                 {
                  id: "es-2-9-19", da: "Prepare for potential challenges in governance."
                 },
                 {
                  id: "es-2-9-20", da: "Develop a contingency plan for unexpected events."
                 },
                 {
                  id: "es-2-9-21", da: "Seek feedback from community members."
                 },
                 {
                  id: "es-2-9-22", da: "Ensure transparency in the exit process."
                 },
                 {
                  id: "es-2-9-23", da: "Communicate the exit strategy timeline."
                 },
                 {
                  id: "es-2-9-24", da: "Consider the impact on employees and team members."
                 },
                 {
                  id: "es-2-9-25", da: "Analyze the competitive landscape."
                 },
                 {
                  id: "es-2-9-26", da: "Evaluate the intellectual property and assets."
                 },
                 {
                  id: "es-2-9-27", da: "Assess the market conditions for exit."
                 },
                 {
                  id: "es-2-9-28", da: "Develop a marketing plan for the transition."
                 },
                 {
                  id: "es-2-9-29", da: "Address any legal disputes or liabilities."
                 },
                 {
                  id: "es-2-9-30", da: "Consider the tax implications of the exit."
                 },
                 {
                  id: "es-2-9-31", da: "Evaluate the impact on customers and users."
                 },
                 {
                  id: "es-2-9-32", da: "Plan for the closure of physical locations, if applicable."
                 },
                 {
                  id: "es-2-9-33", da: "Identify potential acquirers or partners."
                 },
                 {
                  id: "es-2-9-34", da: "Consider the impact on suppliers and vendors."
                 },
                 {
                  id: "es-2-9-35", da: "Develop a strategy for employee retention."
                 },
                 {
                  id: "es-2-9-36", da: "Plan for the transfer of domain names and websites."
                 },
                 {
                  id: "es-2-9-37", da: "Address data security and privacy concerns."
                 },
                 {
                  id: "es-2-9-38", da: "Assess the cultural impact on the community."
                 },
                 {
                  id: "es-2-9-39", da: "Consider the impact on shareholders or investors."
                 },
                 {
                  id: "es-2-9-40", da: "Plan for the disposal of physical assets."
                 },
                 {
                  id: "es-2-9-41", da: "Evaluate the impact on research and development."
                 },
                 {
                  id: "es-2-9-42", da: "Assess the impact on marketing and branding."
                 },
                 {
                  id: "es-2-9-43", da: "Plan for the transition of customer support."
                 },
                 {
                  id: "es-2-9-44", da: "Address the impact on external contracts."
                 },
                 {
                  id: "es-2-9-45", da: "Evaluate the impact on the ecosystem's reputation."
                 },
                 {
                  id: "es-2-9-46", da: "Develop a plan for customer and user communication."
                 },
                 {
                  id: "es-2-9-47", da: "Consider the impact on charitable initiatives."
                 },
                 {
                  id: "es-2-9-48", da: "Plan for the transfer of social media accounts."
                 },
                 {
                  id: "es-2-9-49", da: "Create a post-exit evaluation and analysis process."
                 },
              ]
            },
          ]
        },
       ]
      },
      'ei':{
        characteristic: 'Ecosystem Intelligence',
        wdd: "Take your next step towards becoming an innovation analyst. Domain knowledge and data are key differentiators for innovation hubs. If you do not have exclusive insights or data, it is hard to convince customers to buy from you.",
        icon: require('@/assets/Iconography/Characteristics/15_Skilled Communicator.svg'),
        competencies: [
          {
            id: 'ei-0',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Research',
            wdd: '',
            progressMeasures:[
              {
                id: 'ei-0-0',
                pm: 'Establish a plan around the need and how to resolve it through community action.',
                title:'Need',
                pmMap: 'Establish a plan around the need and how to resolve it through community action.',
                developmentActions:[
                  {
                    id: "ei-0-0-0", da: "Enhanced data collection methods."
                   },
                   {
                    id: "ei-0-0-1", da: "Improved data accuracy and reliability."
                   },
                   {
                    id: "ei-0-0-2", da: "Better integration of data sources."
                   },
                   {
                    id: "ei-0-0-3", da: "Advanced data analytics tools."
                   },
                   {
                    id: "ei-0-0-4", da: "Real-time data processing."
                   },
                   {
                    id: "ei-0-0-5", da: "Data visualization for easier interpretation."
                   },
                   {
                    id: "ei-0-0-6", da: "Expanding data coverage to include more relevant sources."
                   },
                   {
                    id: "ei-0-0-7", da: "Automation of data collection processes."
                   },
                   {
                    id: "ei-0-0-8", da: "Deeper market research."
                   },
                   {
                    id: "ei-0-0-9", da: "More extensive competitive analysis."
                   },
                   {
                    id: "ei-0-0-10", da: "Comprehensive customer insights."
                   },
                   {
                    id: "ei-0-0-11", da: "Improved trend analysis."
                   },
                   {
                    id: "ei-0-0-12", da: "Enhanced predictive modeling."
                   },
                   {
                    id: "ei-0-0-13", da: "Better risk assessment."
                   },
                   {
                    id: "ei-0-0-14", da: "Integration of AI and machine learning for predictive analytics."
                   },
                   {
                    id: "ei-0-0-15", da: "Enhanced data security measures."
                   },
                   {
                    id: "ei-0-0-16", da: "Compliance with data protection regulations."
                   },
                   {
                    id: "ei-0-0-17", da: "Greater stakeholder engagement."
                   },
                   {
                    id: "ei-0-0-18", da: "In-depth partner analysis."
                   },
                   {
                    id: "ei-0-0-19", da: "Expanding the network of research collaborators."
                   },
                   {
                    id: "ei-0-0-20", da: "Enhanced reporting and communication tools."
                   },
                   {
                    id: "ei-0-0-21", da: "Regular feedback loops with stakeholders."
                   },
                   {
                    id: "ei-0-0-22", da: "Performance benchmarking against industry standards."
                   },
                   {
                    id: "ei-0-0-23", da: "Improved understanding of customer behavior."
                   },
                   {
                    id: "ei-0-0-24", da: "Streamlined information sharing among teams."
                   },
                   {
                    id: "ei-0-0-25", da: "Enhanced knowledge management systems."
                   },
                   {
                    id: "ei-0-0-26", da: "Identifying emerging market opportunities."
                   },
                   {
                    id: "ei-0-0-27", da: "Tracking key performance indicators (KPIs)."
                   },
                   {
                    id: "ei-0-0-28", da: "Advanced environmental scanning."
                   },
                   {
                    id: "ei-0-0-29", da: "Enhanced technology infrastructure."
                   },
                   {
                    id: "ei-0-0-30", da: "Data governance and management policies."
                   },
                   {
                    id: "ei-0-0-31", da: "Improved data quality control."
                   },
                   {
                    id: "ei-0-0-32", da: "Incorporating sustainability metrics."
                   },
                   {
                    id: "ei-0-0-33", da: "Identifying social impact indicators."
                   },
                   {
                    id: "ei-0-0-34", da: "Strengthened talent acquisition strategies."
                   },
                   {
                    id: "ei-0-0-35", da: "Better alignment with organizational goals."
                   },
                   {
                    id: "ei-0-0-36", da: "Enhanced decision-making processes."
                   },
                   {
                    id: "ei-0-0-37", da: "Fostering a culture of data-driven decision-making."
                   },
                   {
                    id: "ei-0-0-38", da: "Developing cross-functional teams for research."
                   },
                   {
                    id: "ei-0-0-39", da: "Encouraging a learning culture."
                   },
                   {
                    id: "ei-0-0-40", da: "Identifying and addressing information silos."
                   },
                   {
                    id: "ei-0-0-41", da: "Regular evaluation of research methodologies."
                   },
                   {
                    id: "ei-0-0-42", da: "Creating agile research processes."
                   },
                   {
                    id: "ei-0-0-43", da: "Advanced scenario planning."
                   },
                   {
                    id: "ei-0-0-44", da: "Implementing industry best practices."
                   },
                   {
                    id: "ei-0-0-45", da: "Continuous feedback collection."
                   },
                   {
                    id: "ei-0-0-46", da: "Conducting regular internal and external audits."
                   },
                   {
                    id: "ei-0-0-47", da: "Alignment of research with strategic goals."
                   },
                   {
                    id: "ei-0-0-48", da: "Enhanced tracking of industry trends."
                   },
                   {
                    id: "ei-0-0-49", da: "Robust crisis management strategies."
                   },
                ]
              },
              {
                id: 'ei-0-1',
                pm: 'Team knows all key players in the ecosystem and how the target market operates.',
                title:'Market',
                pmMap: 'Team knows all key players in the ecosystem and how the target market operates.',
                developmentActions:[
                  {
                    id: "ei-0-1-0", da: "Enhance market research to better understand customer needs."
                   },
                   {
                    id: "ei-0-1-1", da: "Improve customer segmentation for targeted marketing."
                   },
                   {
                    id: "ei-0-1-2", da: "Develop a competitive analysis strategy."
                   },
                   {
                    id: "ei-0-1-3", da: "Expand the product or service offering to meet market demand."
                   },
                   {
                    id: "ei-0-1-4", da: "Invest in R&D for product innovation."
                   },
                   {
                    id: "ei-0-1-5", da: "Create partnerships with complementary businesses."
                   },
                   {
                    id: "ei-0-1-6", da: "Implement effective pricing strategies."
                   },
                   {
                    id: "ei-0-1-7", da: "Focus on brand building and awareness."
                   },
                   {
                    id: "ei-0-1-8", da: "Improve customer service and support."
                   },
                   {
                    id: "ei-0-1-9", da: "Enhance online presence and e-commerce capabilities."
                   },
                   {
                    id: "ei-0-1-10", da: "Streamline the supply chain for efficiency."
                   },
                   {
                    id: "ei-0-1-11", da: "Expand to new geographic markets."
                   },
                   {
                    id: "ei-0-1-12", da: "Conduct regular customer feedback surveys."
                   },
                   {
                    id: "ei-0-1-13", da: "Implement data analytics for market insights."
                   },
                   {
                    id: "ei-0-1-14", da: "Develop a content marketing strategy."
                   },
                   {
                    id: "ei-0-1-15", da: "Explore new advertising channels."
                   },
                   {
                    id: "ei-0-1-16", da: "Invest in employee training and development."
                   },
                   {
                    id: "ei-0-1-17", da: "Optimize the sales process for higher conversions."
                   },
                   {
                    id: "ei-0-1-18", da: "Ensure product quality and reliability."
                   },
                   {
                    id: "ei-0-1-19", da: "Expand distribution channels."
                   },
                   {
                    id: "ei-0-1-20", da: "Explore international market opportunities."
                   },
                   {
                    id: "ei-0-1-21", da: "Develop a mobile app for increased accessibility."
                   },
                   {
                    id: "ei-0-1-22", da: "Implement sustainability initiatives."
                   },
                   {
                    id: "ei-0-1-23", da: "Improve cybersecurity measures."
                   },
                   {
                    id: "ei-0-1-24", da: "Enhance the customer onboarding process."
                   },
                   {
                    id: "ei-0-1-25", da: "Optimize inventory management."
                   },
                   {
                    id: "ei-0-1-26", da: "Invest in infrastructure and technology."
                   },
                   {
                    id: "ei-0-1-27", da: "Develop a crisis management plan."
                   },
                   {
                    id: "ei-0-1-28", da: "Offer personalized marketing and recommendations."
                   },
                   {
                    id: "ei-0-1-29", da: "Improve data privacy and compliance."
                   },
                   {
                    id: "ei-0-1-30", da: "Diversify product lines or services."
                   },
                   {
                    id: "ei-0-1-31", da: "Implement loyalty programs."
                   },
                   {
                    id: "ei-0-1-32", da: "Enhance customer retention strategies."
                   },
                   {
                    id: "ei-0-1-33", da: "Optimize the website for SEO."
                   },
                   {
                    id: "ei-0-1-34", da: "Create case studies and success stories."
                   },
                   {
                    id: "ei-0-1-35", da: "Improve social media engagement."
                   },
                   {
                    id: "ei-0-1-36", da: "Expand into emerging markets."
                   },
                   {
                    id: "ei-0-1-37", da: "Build strategic alliances with industry leaders."
                   },
                   {
                    id: "ei-0-1-38", da: "Focus on customer education and training."
                   },
                   {
                    id: "ei-0-1-39", da: "Enhance packaging and presentation."
                   },
                   {
                    id: "ei-0-1-40", da: "Conduct A\/B testing for marketing campaigns."
                   },
                   {
                    id: "ei-0-1-41", da: "Invest in market expansion research."
                   },
                   {
                    id: "ei-0-1-42", da: "Develop a customer referral program."
                   },
                   {
                    id: "ei-0-1-43", da: "Optimize the user experience (UX) of digital platforms."
                   },
                   {
                    id: "ei-0-1-44", da: "Offer seasonal promotions and discounts."
                   },
                   {
                    id: "ei-0-1-45", da: "Collaborate with influencers for marketing."
                   },
                   {
                    id: "ei-0-1-46", da: "Explore niche market opportunities."
                   },
                   {
                    id: "ei-0-1-47", da: "Invest in product certification or quality seals."
                   },
                   {
                    id: "ei-0-1-48", da: "Conduct market trend analysis."
                   },
                   {
                    id: "ei-0-1-49", da: "Create a market-specific newsletter or publication."
                   },
                ]
              },
              {
                id: 'ei-0-2',
                pm: 'A build vs buy analysis is done to choose inhouse capability for technology or an outcourced partnership.',
                title:'Technology',
                pmMap: 'A build vs buy analysis is done to choose inhouse capability for technology or an outcourced partnership.',
                developmentActions:[
                  {
                    id: "ei-0-2-0", da: "Implement advanced data analytics to gain deeper insights."
                   },
                   {
                    id: "ei-0-2-1", da: "Develop predictive modeling for ecosystem trends."
                   },
                   {
                    id: "ei-0-2-2", da: "Enhance data security and privacy measures."
                   },
                   {
                    id: "ei-0-2-3", da: "Upgrade data storage infrastructure for scalability."
                   },
                   {
                    id: "ei-0-2-4", da: "Explore blockchain technology for data integrity."
                   },
                   {
                    id: "ei-0-2-5", da: "Integrate artificial intelligence for automated insights."
                   },
                   {
                    id: "ei-0-2-6", da: "Improve data visualization tools for better understanding."
                   },
                   {
                    id: "ei-0-2-7", da: "Invest in machine learning for anomaly detection."
                   },
                   {
                    id: "ei-0-2-8", da: "Implement cloud computing for data accessibility."
                   },
                   {
                    id: "ei-0-2-9", da: "Develop a comprehensive data governance strategy."
                   },
                   {
                    id: "ei-0-2-10", da: "Invest in IoT sensors for real-time data collection."
                   },
                   {
                    id: "ei-0-2-11", da: "Enhance geospatial analysis capabilities."
                   },
                   {
                    id: "ei-0-2-12", da: "Establish a unified data warehouse."
                   },
                   {
                    id: "ei-0-2-13", da: "Implement natural language processing for data mining."
                   },
                   {
                    id: "ei-0-2-14", da: "Improve data quality through data cleansing."
                   },
                   {
                    id: "ei-0-2-15", da: "Upgrade server and network infrastructure."
                   },
                   {
                    id: "ei-0-2-16", da: "Enhance disaster recovery and business continuity plans."
                   },
                   {
                    id: "ei-0-2-17", da: "Develop a mobile app for data access on-the-go."
                   },
                   {
                    id: "ei-0-2-18", da: "Implement a centralized user authentication system."
                   },
                   {
                    id: "ei-0-2-19", da: "Invest in high-performance computing resources."
                   },
                   {
                    id: "ei-0-2-20", da: "Upgrade data transmission and network speed."
                   },
                   {
                    id: "ei-0-2-21", da: "Develop a digital twin for ecosystem simulation."
                   },
                   {
                    id: "ei-0-2-22", da: "Invest in energy-efficient data centers."
                   },
                   {
                    id: "ei-0-2-23", da: "Integrate data from social media platforms."
                   },
                   {
                    id: "ei-0-2-24", da: "Enhance data processing through parallel computing."
                   },
                   {
                    id: "ei-0-2-25", da: "Implement data version control for research reproducibility."
                   },
                   {
                    id: "ei-0-2-26", da: "Develop a knowledge base for research findings."
                   },
                   {
                    id: "ei-0-2-27", da: "Invest in remote sensing technologies."
                   },
                   {
                    id: "ei-0-2-28", da: "Improve collaboration tools for research teams."
                   },
                   {
                    id: "ei-0-2-29", da: "Establish data sharing agreements with partners."
                   },
                   {
                    id: "ei-0-2-30", da: "Enhance data encryption and data masking."
                   },
                   {
                    id: "ei-0-2-31", da: "Implement data compression techniques."
                   },
                   {
                    id: "ei-0-2-32", da: "Upgrade cybersecurity protocols and training."
                   },
                   {
                    id: "ei-0-2-33", da: "Invest in quantum computing research."
                   },
                   {
                    id: "ei-0-2-34", da: "Develop a data catalog for easy access."
                   },
                   {
                    id: "ei-0-2-35", da: "Enhance user training on data tools and platforms."
                   },
                   {
                    id: "ei-0-2-36", da: "Implement data lineage tracking."
                   },
                   {
                    id: "ei-0-2-37", da: "Invest in disaster recovery testing."
                   },
                   {
                    id: "ei-0-2-38", da: "Upgrade data classification and tagging."
                   },
                   {
                    id: "ei-0-2-39", da: "Develop a data retention policy."
                   },
                   {
                    id: "ei-0-2-40", da: "Enhance metadata management."
                   },
                   {
                    id: "ei-0-2-41", da: "Invest in data monitoring and auditing."
                   },
                   {
                    id: "ei-0-2-42", da: "Implement data anonymization techniques."
                   },
                   {
                    id: "ei-0-2-43", da: "Upgrade network segmentation for security."
                   },
                   {
                    id: "ei-0-2-44", da: "Develop an API for data access."
                   },
                   {
                    id: "ei-0-2-45", da: "Invest in remote data access solutions."
                   },
                   {
                    id: "ei-0-2-46", da: "Enhance data disaster recovery planning."
                   },
                   {
                    id: "ei-0-2-47", da: "Implement data archiving for historical records."
                   },
                   {
                    id: "ei-0-2-48", da: "Develop a data dashboard for key metrics."
                   },
                   {
                    id: "ei-0-2-49", da: "Invest in data compliance and legal support."
                   },
                ]
              },
              {
                id: 'ei-0-3',
                pm: 'Team has validated value proposition and USPs.',
                title:'Value',
                pmMap: 'Team has validated value proposition and USPs.',
                developmentActions:[
                  {
                    id: "ei-0-3-0", da: "Conduct a thorough ecosystem analysis to identify pain points and opportunities."
                   },
                   {
                    id: "ei-0-3-1", da: "Foster collaboration among ecosystem stakeholders."
                   },
                   {
                    id: "ei-0-3-2", da: "Develop clear and transparent governance rules."
                   },
                   {
                    id: "ei-0-3-3", da: "Identify key ecosystem metrics to measure success."
                   },
                   {
                    id: "ei-0-3-4", da: "Invest in ecosystem infrastructure and technology."
                   },
                   {
                    id: "ei-0-3-5", da: "Encourage innovation through open innovation challenges."
                   },
                   {
                    id: "ei-0-3-6", da: "Create an ecosystem directory to showcase participants."
                   },
                   {
                    id: "ei-0-3-7", da: "Establish mentorship programs for newcomers."
                   },
                   {
                    id: "ei-0-3-8", da: "Implement data-sharing agreements for better decision-making."
                   },
                   {
                    id: "ei-0-3-9", da: "Promote ecosystem inclusivity and diversity."
                   },
                   {
                    id: "ei-0-3-10", da: "Provide education and training opportunities."
                   },
                   {
                    id: "ei-0-3-11", da: "Create a shared resource center."
                   },
                   {
                    id: "ei-0-3-12", da: "Organize regular ecosystem meetups and events."
                   },
                   {
                    id: "ei-0-3-13", da: "Encourage cross-industry partnerships."
                   },
                   {
                    id: "ei-0-3-14", da: "Develop an ecosystem roadmap."
                   },
                   {
                    id: "ei-0-3-15", da: "Support startups and small businesses in the ecosystem."
                   },
                   {
                    id: "ei-0-3-16", da: "Share best practices and case studies."
                   },
                   {
                    id: "ei-0-3-17", da: "Establish a digital platform for communication."
                   },
                   {
                    id: "ei-0-3-18", da: "Implement feedback loops for continuous improvement."
                   },
                   {
                    id: "ei-0-3-19", da: "Leverage AI and analytics for data-driven insights."
                   },
                   {
                    id: "ei-0-3-20", da: "Create a community bulletin board."
                   },
                   {
                    id: "ei-0-3-21", da: "Develop a certification program for ecosystem participants."
                   },
                   {
                    id: "ei-0-3-22", da: "Identify and address legal and regulatory barriers."
                   },
                   {
                    id: "ei-0-3-23", da: "Encourage ecosystem sustainability practices."
                   },
                   {
                    id: "ei-0-3-24", da: "Monitor and reduce environmental impact."
                   },
                   {
                    id: "ei-0-3-25", da: "Develop a system for knowledge sharing and transfer."
                   },
                   {
                    id: "ei-0-3-26", da: "Foster a culture of trust and transparency."
                   },
                   {
                    id: "ei-0-3-27", da: "Implement a rewards system for active ecosystem contributors."
                   },
                   {
                    id: "ei-0-3-28", da: "Create a dedicated support team for ecosystem participants."
                   },
                   {
                    id: "ei-0-3-29", da: "Enable access to funding sources."
                   },
                   {
                    id: "ei-0-3-30", da: "Develop a shared IP and patent strategy."
                   },
                   {
                    id: "ei-0-3-31", da: "Promote ethical business practices."
                   },
                   {
                    id: "ei-0-3-32", da: "Establish an advisory board with ecosystem representation."
                   },
                   {
                    id: "ei-0-3-33", da: "Conduct regular surveys to gather feedback."
                   },
                   {
                    id: "ei-0-3-34", da: "Promote ecosystem branding and marketing."
                   },
                   {
                    id: "ei-0-3-35", da: "Set up a crisis management plan."
                   },
                   {
                    id: "ei-0-3-36", da: "Create a community recognition program."
                   },
                   {
                    id: "ei-0-3-37", da: "Offer legal and compliance training."
                   },
                   {
                    id: "ei-0-3-38", da: "Support ecosystem research and development."
                   },
                   {
                    id: "ei-0-3-39", da: "Encourage cross-border collaboration."
                   },
                   {
                    id: "ei-0-3-40", da: "Address security and privacy concerns."
                   },
                   {
                    id: "ei-0-3-41", da: "Develop a knowledge management system."
                   },
                   {
                    id: "ei-0-3-42", da: "Ensure access to affordable healthcare and benefits."
                   },
                   {
                    id: "ei-0-3-43", da: "Promote responsible AI and technology use."
                   },
                   {
                    id: "ei-0-3-44", da: "Enable seamless cross-platform integration."
                   },
                   {
                    id: "ei-0-3-45", da: "Establish an ecosystem ombudsman for dispute resolution."
                   },
                   {
                    id: "ei-0-3-46", da: "Implement a shared roadmap for technological advances."
                   },
                   {
                    id: "ei-0-3-47", da: "Address digital inclusion and accessibility."
                   },
                   {
                    id: "ei-0-3-48", da: "Collaborate with educational institutions."
                   },
                   {
                    id: "ei-0-3-49", da: "Conduct regular impact assessments and adjust strategies accordingly."
                   },
                ]
              },
              {
                id: 'ei-0-4',
                pm: 'Team understands, experiments and can define the alternatives models to build comparison map.',
                title:'Business Model',
                pmMap: 'Team understands, experiments and can define the alternatives models to build comparison map.',
                developmentActions:[
                  {
                    id: "ei-0-4-0", da: "Conduct a comprehensive SWOT analysis to identify strengths, weaknesses, opportunities, and threats."
                   },
                   {
                    id: "ei-0-4-1", da: "Review and update your value proposition to better meet customer needs."
                   },
                   {
                    id: "ei-0-4-2", da: "Explore new revenue streams or pricing models."
                   },
                   {
                    id: "ei-0-4-3", da: "Identify emerging market trends and adapt your model accordingly."
                   },
                   {
                    id: "ei-0-4-4", da: "Investigate potential partnerships and collaborations to expand your reach."
                   },
                   {
                    id: "ei-0-4-5", da: "Enhance your product or service quality to attract and retain customers."
                   },
                   {
                    id: "ei-0-4-6", da: "Improve customer service and support channels."
                   },
                   {
                    id: "ei-0-4-7", da: "Optimize supply chain and distribution channels."
                   },
                   {
                    id: "ei-0-4-8", da: "Streamline internal processes to reduce costs."
                   },
                   {
                    id: "ei-0-4-9", da: "Investigate cost-effective sourcing and procurement options."
                   },
                   {
                    id: "ei-0-4-10", da: "Expand into new geographic markets or customer segments."
                   },
                   {
                    id: "ei-0-4-11", da: "Develop a clear and actionable business growth strategy."
                   },
                   {
                    id: "ei-0-4-12", da: "Invest in research and development to stay innovative."
                   },
                   {
                    id: "ei-0-4-13", da: "Explore digital transformation opportunities."
                   },
                   {
                    id: "ei-0-4-14", da: "Invest in employee training and development."
                   },
                   {
                    id: "ei-0-4-15", da: "Create a more customer-centric organizational culture."
                   },
                   {
                    id: "ei-0-4-16", da: "Implement data analytics to make informed decisions."
                   },
                   {
                    id: "ei-0-4-17", da: "Invest in marketing and branding efforts."
                   },
                   {
                    id: "ei-0-4-18", da: "Expand your online presence and e-commerce capabilities."
                   },
                   {
                    id: "ei-0-4-19", da: "Launch a loyalty program to retain existing customers."
                   },
                   {
                    id: "ei-0-4-20", da: "Explore subscription-based business models."
                   },
                   {
                    id: "ei-0-4-21", da: "Diversify your product or service portfolio."
                   },
                   {
                    id: "ei-0-4-22", da: "Investigate international expansion opportunities."
                   },
                   {
                    id: "ei-0-4-23", da: "Conduct market segmentation to target niche markets."
                   },
                   {
                    id: "ei-0-4-24", da: "Evaluate the scalability of your business model."
                   },
                   {
                    id: "ei-0-4-25", da: "Analyze customer feedback and adjust your offerings."
                   },
                   {
                    id: "ei-0-4-26", da: "Develop a disaster recovery and business continuity plan."
                   },
                   {
                    id: "ei-0-4-27", da: "Embrace sustainable and eco-friendly practices."
                   },
                   {
                    id: "ei-0-4-28", da: "Investigate potential mergers and acquisitions."
                   },
                   {
                    id: "ei-0-4-29", da: "Enhance your competitive analysis and benchmarking."
                   },
                   {
                    id: "ei-0-4-30", da: "Implement cost-cutting measures without sacrificing quality."
                   },
                   {
                    id: "ei-0-4-31", da: "Improve your branding and messaging."
                   },
                   {
                    id: "ei-0-4-32", da: "Explore joint ventures or strategic alliances."
                   },
                   {
                    id: "ei-0-4-33", da: "Develop a comprehensive market entry strategy."
                   },
                   {
                    id: "ei-0-4-34", da: "Invest in automation and AI technologies."
                   },
                   {
                    id: "ei-0-4-35", da: "Evaluate the potential of subscription-based models."
                   },
                   {
                    id: "ei-0-4-36", da: "Enhance your customer onboarding and retention strategies."
                   },
                   {
                    id: "ei-0-4-37", da: "Explore mobile app development for improved customer engagement."
                   },
                   {
                    id: "ei-0-4-38", da: "Consider diversifying into complementary industries."
                   },
                   {
                    id: "ei-0-4-39", da: "Investigate the potential of franchising or licensing."
                   },
                   {
                    id: "ei-0-4-40", da: "Review and update your business plan regularly."
                   },
                   {
                    id: "ei-0-4-41", da: "Analyze your sales and distribution channels."
                   },
                   {
                    id: "ei-0-4-42", da: "Invest in advanced cybersecurity measures."
                   },
                   {
                    id: "ei-0-4-43", da: "Develop a clear pricing and discount strategy."
                   },
                   {
                    id: "ei-0-4-44", da: "Investigate the adoption of blockchain or other emerging technologies."
                   },
                   {
                    id: "ei-0-4-45", da: "Enhance your company's social and environmental responsibility."
                   },
                   {
                    id: "ei-0-4-46", da: "Monitor and respond to changes in consumer behavior."
                   },
                   {
                    id: "ei-0-4-47", da: "Conduct competitor analysis to identify gaps."
                   },
                   {
                    id: "ei-0-4-48", da: "Investigate government grants or incentives for business development."
                   },
                   {
                    id: "ei-0-4-49", da: "Seek professional consulting or advisory services for business model improvement."
                   },
                ]
              },
              {
                id: 'ei-0-5',
                pm: 'Team has clearity on which GTM motion to use including priority on which segment to approach.',
                title:'Go to Market',
                pmMap: 'Team has clearity on which GTM motion to use including priority on which segment to approach.',
                developmentActions:[
                  {
                    id: "ei-0-5-0", da: "Conduct market research to identify untapped customer segments."
                   },
                   {
                    id: "ei-0-5-1", da: "Define clear buyer personas to target the right audience."
                   },
                   {
                    id: "ei-0-5-2", da: "Develop a comprehensive marketing plan."
                   },
                   {
                    id: "ei-0-5-3", da: "Invest in SEO to improve online visibility."
                   },
                   {
                    id: "ei-0-5-4", da: "Optimize website user experience."
                   },
                   {
                    id: "ei-0-5-5", da: "Create compelling and informative content."
                   },
                   {
                    id: "ei-0-5-6", da: "Implement social media marketing."
                   },
                   {
                    id: "ei-0-5-7", da: "Engage in influencer marketing."
                   },
                   {
                    id: "ei-0-5-8", da: "Leverage email marketing campaigns."
                   },
                   {
                    id: "ei-0-5-9", da: "Invest in pay-per-click (PPC) advertising."
                   },
                   {
                    id: "ei-0-5-10", da: "Develop a referral program."
                   },
                   {
                    id: "ei-0-5-11", da: "Enhance your product's features."
                   },
                   {
                    id: "ei-0-5-12", da: "Create a loyalty program."
                   },
                   {
                    id: "ei-0-5-13", da: "Offer product bundling."
                   },
                   {
                    id: "ei-0-5-14", da: "Expand distribution channels."
                   },
                   {
                    id: "ei-0-5-15", da: "Partner with complementary businesses."
                   },
                   {
                    id: "ei-0-5-16", da: "Attend industry-specific trade shows."
                   },
                   {
                    id: "ei-0-5-17", da: "Invest in customer relationship management (CRM) software."
                   },
                   {
                    id: "ei-0-5-18", da: "Offer personalized product recommendations."
                   },
                   {
                    id: "ei-0-5-19", da: "Provide exceptional customer support."
                   },
                   {
                    id: "ei-0-5-20", da: "Optimize your pricing strategy."
                   },
                   {
                    id: "ei-0-5-21", da: "Develop case studies and customer success stories."
                   },
                   {
                    id: "ei-0-5-22", da: "Conduct competitive analysis."
                   },
                   {
                    id: "ei-0-5-23", da: "Implement a content calendar."
                   },
                   {
                    id: "ei-0-5-24", da: "Create a sales playbook for your team."
                   },
                   {
                    id: "ei-0-5-25", da: "Invest in market automation tools."
                   },
                   {
                    id: "ei-0-5-26", da: "Create value-added resources like eBooks or whitepapers."
                   },
                   {
                    id: "ei-0-5-27", da: "Offer free trials or demos."
                   },
                   {
                    id: "ei-0-5-28", da: "Collaborate with industry experts."
                   },
                   {
                    id: "ei-0-5-29", da: "Run targeted online ads."
                   },
                   {
                    id: "ei-0-5-30", da: "Implement A\/B testing for landing pages."
                   },
                   {
                    id: "ei-0-5-31", da: "Analyze and optimize your sales funnel."
                   },
                   {
                    id: "ei-0-5-32", da: "Conduct regular customer surveys."
                   },
                   {
                    id: "ei-0-5-33", da: "Leverage user-generated content."
                   },
                   {
                    id: "ei-0-5-34", da: "Build an affiliate marketing program."
                   },
                   {
                    id: "ei-0-5-35", da: "Improve your website's loading speed."
                   },
                   {
                    id: "ei-0-5-36", da: "Offer exclusive promotions or discounts."
                   },
                   {
                    id: "ei-0-5-37", da: "Expand into new geographic markets."
                   },
                   {
                    id: "ei-0-5-38", da: "Participate in industry forums and communities."
                   },
                   {
                    id: "ei-0-5-39", da: "Utilize retargeting advertising."
                   },
                   {
                    id: "ei-0-5-40", da: "Enhance your brand identity."
                   },
                   {
                    id: "ei-0-5-41", da: "Create a robust content marketing strategy."
                   },
                   {
                    id: "ei-0-5-42", da: "Develop thought leadership content."
                   },
                   {
                    id: "ei-0-5-43", da: "Conduct webinars and virtual events."
                   },
                   {
                    id: "ei-0-5-44", da: "Monitor and respond to online reviews."
                   },
                   {
                    id: "ei-0-5-45", da: "Implement chatbots for customer support."
                   },
                   {
                    id: "ei-0-5-46", da: "Improve product packaging and presentation."
                   },
                   {
                    id: "ei-0-5-47", da: "Offer flexible payment options."
                   },
                   {
                    id: "ei-0-5-48", da: "Collaborate with local influencers."
                   },
                   {
                    id: "ei-0-5-49", da: "Continuously analyze data and adjust your GTM strategy based on performance metrics."
                   },
                ]
              },
              {
                id: 'ei-0-6',
                pm: 'Start screening great talent to build out core team.',
                title:'People',
                pmMap: 'Start screening great talent to build out core team.',
                developmentActions:[
                  {
                    id: "ei-0-6-0", da: "Enhance cross-functional collaboration and communication."
                   },
                   {
                    id: "ei-0-6-1", da: "Foster a culture of innovation and creativity."
                   },
                   {
                    id: "ei-0-6-2", da: "Develop leadership skills at all levels of the organization."
                   },
                   {
                    id: "ei-0-6-3", da: "Improve emotional intelligence among team members."
                   },
                   {
                    id: "ei-0-6-4", da: "Enhance conflict resolution and problem-solving skills."
                   },
                   {
                    id: "ei-0-6-5", da: "Promote diversity and inclusion in decision-making."
                   },
                   {
                    id: "ei-0-6-6", da: "Strengthen interpersonal skills for relationship-building."
                   },
                   {
                    id: "ei-0-6-7", da: "Provide training in critical thinking and decision-making."
                   },
                   {
                    id: "ei-0-6-8", da: "Develop project management skills."
                   },
                   {
                    id: "ei-0-6-9", da: "Cultivate adaptability and resilience."
                   },
                   {
                    id: "ei-0-6-10", da: "Improve time management and organizational skills."
                   },
                   {
                    id: "ei-0-6-11", da: "Enhance negotiation and persuasion abilities."
                   },
                   {
                    id: "ei-0-6-12", da: "Develop effective public speaking and presentation skills."
                   },
                   {
                    id: "ei-0-6-13", da: "Foster a growth mindset for continuous learning."
                   },
                   {
                    id: "ei-0-6-14", da: "Improve conflict resolution and mediation skills."
                   },
                   {
                    id: "ei-0-6-15", da: "Develop cross-cultural competency."
                   },
                   {
                    id: "ei-0-6-16", da: "Enhance teamwork and collaboration skills."
                   },
                   {
                    id: "ei-0-6-17", da: "Strengthen active listening and empathy."
                   },
                   {
                    id: "ei-0-6-18", da: "Improve data analysis and interpretation capabilities."
                   },
                   {
                    id: "ei-0-6-19", da: "Develop effective mentoring and coaching skills."
                   },
                   {
                    id: "ei-0-6-20", da: "Promote ethical decision-making and integrity."
                   },
                   {
                    id: "ei-0-6-21", da: "Cultivate effective delegation skills."
                   },
                   {
                    id: "ei-0-6-22", da: "Improve stress management and work-life balance."
                   },
                   {
                    id: "ei-0-6-23", da: "Develop networking and relationship-building skills."
                   },
                   {
                    id: "ei-0-6-24", da: "Enhance problem-solving through design thinking."
                   },
                   {
                    id: "ei-0-6-25", da: "Improve data literacy and data-driven decision-making."
                   },
                   {
                    id: "ei-0-6-26", da: "Foster adaptability to change and ambiguity."
                   },
                   {
                    id: "ei-0-6-27", da: "Develop risk management and risk assessment skills."
                   },
                   {
                    id: "ei-0-6-28", da: "Strengthen strategic planning and execution."
                   },
                   {
                    id: "ei-0-6-29", da: "Improve customer service and client relationship skills."
                   },
                   {
                    id: "ei-0-6-30", da: "Enhance digital literacy and technology skills."
                   },
                   {
                    id: "ei-0-6-31", da: "Develop remote work and virtual team collaboration skills."
                   },
                   {
                    id: "ei-0-6-32", da: "Improve regulatory compliance and legal awareness."
                   },
                   {
                    id: "ei-0-6-33", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "ei-0-6-34", da: "Develop sustainability and environmental awareness."
                   },
                   {
                    id: "ei-0-6-35", da: "Strengthen resilience in the face of challenges."
                   },
                   {
                    id: "ei-0-6-36", da: "Enhance industry-specific knowledge and expertise."
                   },
                   {
                    id: "ei-0-6-37", da: "Promote effective communication in remote work settings."
                   },
                   {
                    id: "ei-0-6-38", da: "Cultivate project management methodologies (e.g., Agile)."
                   },
                   {
                    id: "ei-0-6-39", da: "Develop skills for remote leadership and management."
                   },
                   {
                    id: "ei-0-6-40", da: "Improve critical analysis and problem-solving skills."
                   },
                   {
                    id: "ei-0-6-41", da: "Enhance financial literacy and budgeting skills."
                   },
                   {
                    id: "ei-0-6-42", da: "Foster entrepreneurial thinking and risk-taking."
                   },
                   {
                    id: "ei-0-6-43", da: "Develop skills for managing and resolving disputes."
                   },
                   {
                    id: "ei-0-6-44", da: "Promote stress management and well-being."
                   },
                   {
                    id: "ei-0-6-45", da: "Cultivate public policy and advocacy skills."
                   },
                   {
                    id: "ei-0-6-46", da: "Improve skills for handling crises and emergencies."
                   },
                   {
                    id: "ei-0-6-47", da: "Develop cybersecurity awareness and skills."
                   },
                   {
                    id: "ei-0-6-48", da: "Strengthen skills for ethical AI and technology use."
                   },
                   {
                    id: "ei-0-6-49", da: "Promote industry-specific certifications and qualifications."
                   },
                ]
              },
              {
                id: 'ei-0-7',
                pm: 'Team has reserached and defined a strategy to acquire customers.',
                title:'Data Metrics',
                pmMap: 'Team has reserached and defined a strategy to acquire customers.',
                developmentActions:[
                  {
                    id: "ei-0-7-0", da: "Define clear and specific data goals."
                   },
                   {
                    id: "ei-0-7-1", da: "Establish key performance indicators (KPIs) for data quality."
                   },
                   {
                    id: "ei-0-7-2", da: "Ensure data is accurate and up-to-date."
                   },
                   {
                    id: "ei-0-7-3", da: "Implement data validation checks."
                   },
                   {
                    id: "ei-0-7-4", da: "Improve data cleaning and preprocessing techniques."
                   },
                   {
                    id: "ei-0-7-5", da: "Enhance data integration processes."
                   },
                   {
                    id: "ei-0-7-6", da: "Ensure data security and privacy compliance."
                   },
                   {
                    id: "ei-0-7-7", da: "Invest in data encryption methods."
                   },
                   {
                    id: "ei-0-7-8", da: "Implement data governance policies."
                   },
                   {
                    id: "ei-0-7-9", da: "Enhance data accessibility for authorized users."
                   },
                   {
                    id: "ei-0-7-10", da: "Create data dictionaries for better data understanding."
                   },
                   {
                    id: "ei-0-7-11", da: "Standardize data formats and naming conventions."
                   },
                   {
                    id: "ei-0-7-12", da: "Improve data documentation practices."
                   },
                   {
                    id: "ei-0-7-13", da: "Establish data version control."
                   },
                   {
                    id: "ei-0-7-14", da: "Implement data lineage tracking."
                   },
                   {
                    id: "ei-0-7-15", da: "Enhance data storage and retrieval efficiency."
                   },
                   {
                    id: "ei-0-7-16", da: "Optimize data compression methods."
                   },
                   {
                    id: "ei-0-7-17", da: "Ensure data redundancy is minimized."
                   },
                   {
                    id: "ei-0-7-18", da: "Implement data deduplication strategies."
                   },
                   {
                    id: "ei-0-7-19", da: "Enhance data consistency across sources."
                   },
                   {
                    id: "ei-0-7-20", da: "Improve data replication and synchronization."
                   },
                   {
                    id: "ei-0-7-21", da: "Invest in scalable data storage solutions."
                   },
                   {
                    id: "ei-0-7-22", da: "Develop robust data backup and recovery plans."
                   },
                   {
                    id: "ei-0-7-23", da: "Optimize data transfer speeds."
                   },
                   {
                    id: "ei-0-7-24", da: "Implement data quality profiling."
                   },
                   {
                    id: "ei-0-7-25", da: "Improve data mining and analysis techniques."
                   },
                   {
                    id: "ei-0-7-26", da: "Enhance data visualization for better insights."
                   },
                   {
                    id: "ei-0-7-27", da: "Implement advanced analytics tools."
                   },
                   {
                    id: "ei-0-7-28", da: "Invest in machine learning for predictive analysis."
                   },
                   {
                    id: "ei-0-7-29", da: "Develop anomaly detection models."
                   },
                   {
                    id: "ei-0-7-30", da: "Optimize data indexing and search capabilities."
                   },
                   {
                    id: "ei-0-7-31", da: "Improve data querying performance."
                   },
                   {
                    id: "ei-0-7-32", da: "Enhance natural language processing for data interpretation."
                   },
                   {
                    id: "ei-0-7-33", da: "Implement data correlation and causation analysis."
                   },
                   {
                    id: "ei-0-7-34", da: "Invest in data clustering and classification methods."
                   },
                   {
                    id: "ei-0-7-35", da: "Develop data forecasting models."
                   },
                   {
                    id: "ei-0-7-36", da: "Improve data trend analysis."
                   },
                   {
                    id: "ei-0-7-37", da: "Enhance data sentiment analysis."
                   },
                   {
                    id: "ei-0-7-38", da: "Implement recommendation engines."
                   },
                   {
                    id: "ei-0-7-39", da: "Invest in geospatial data analysis tools."
                   },
                   {
                    id: "ei-0-7-40", da: "Optimize data processing for real-time applications."
                   },
                   {
                    id: "ei-0-7-41", da: "Improve data streaming and event processing."
                   },
                   {
                    id: "ei-0-7-42", da: "Implement data enrichment through external sources."
                   },
                   {
                    id: "ei-0-7-43", da: "Invest in data crowdsourcing for additional insights."
                   },
                   {
                    id: "ei-0-7-44", da: "Enhance data monitoring and alerting systems."
                   },
                   {
                    id: "ei-0-7-45", da: "Optimize data reporting and dashboard creation."
                   },
                   {
                    id: "ei-0-7-46", da: "Improve data user training and education."
                   },
                   {
                    id: "ei-0-7-47", da: "Invest in data accessibility for diverse user profiles."
                   },
                   {
                    id: "ei-0-7-48", da: "Develop data governance committees."
                   },
                   {
                    id: "ei-0-7-49", da: "Regularly audit and assess data metrics improvement efforts."
                   },
                ]
              },
              {
                id: 'ei-0-8',
                pm: 'Operational SOPs (Standard Operating Procedures) are drafted.',
                title:'Operations',
                pmMap: 'Operational SOPs (Standard Operating Procedures) are drafted.',
                developmentActions:[
                  {
                    id: "ei-0-8-0", da: "Streamline supply chain processes."
                   },
                   {
                    id: "ei-0-8-1", da: "Automate inventory management."
                   },
                   {
                    id: "ei-0-8-2", da: "Enhance demand forecasting accuracy."
                   },
                   {
                    id: "ei-0-8-3", da: "Optimize order fulfillment procedures."
                   },
                   {
                    id: "ei-0-8-4", da: "Implement lean manufacturing principles."
                   },
                   {
                    id: "ei-0-8-5", da: "Improve quality control standards."
                   },
                   {
                    id: "ei-0-8-6", da: "Increase equipment maintenance efficiency."
                   },
                   {
                    id: "ei-0-8-7", da: "Enhance safety protocols for employees."
                   },
                   {
                    id: "ei-0-8-8", da: "Optimize energy consumption and reduce waste."
                   },
                   {
                    id: "ei-0-8-9", da: "Implement a robust project management system."
                   },
                   {
                    id: "ei-0-8-10", da: "Streamline document management and archiving."
                   },
                   {
                    id: "ei-0-8-11", da: "Invest in advanced data analytics tools."
                   },
                   {
                    id: "ei-0-8-12", da: "Enhance customer relationship management (CRM)."
                   },
                   {
                    id: "ei-0-8-13", da: "Optimize pricing strategies."
                   },
                   {
                    id: "ei-0-8-14", da: "Develop a comprehensive training program for employees."
                   },
                   {
                    id: "ei-0-8-15", da: "Implement better tracking and reporting for key performance indicators (KPIs)."
                   },
                   {
                    id: "ei-0-8-16", da: "Optimize logistics and transportation operations."
                   },
                   {
                    id: "ei-0-8-17", da: "Improve facility layout and workflow design."
                   },
                   {
                    id: "ei-0-8-18", da: "Upgrade IT infrastructure for better data handling."
                   },
                   {
                    id: "ei-0-8-19", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "ei-0-8-20", da: "Enhance vendor and supplier relationships."
                   },
                   {
                    id: "ei-0-8-21", da: "Implement a more efficient order-to-cash process."
                   },
                   {
                    id: "ei-0-8-22", da: "Develop a comprehensive disaster recovery plan."
                   },
                   {
                    id: "ei-0-8-23", da: "Optimize the use of data centers and cloud services."
                   },
                   {
                    id: "ei-0-8-24", da: "Improve the accuracy of financial reporting."
                   },
                   {
                    id: "ei-0-8-25", da: "Implement cost-saving measures in procurement."
                   },
                   {
                    id: "ei-0-8-26", da: "Enhance employee engagement and motivation."
                   },
                   {
                    id: "ei-0-8-27", da: "Streamline the onboarding process for new employees."
                   },
                   {
                    id: "ei-0-8-28", da: "Develop a robust knowledge management system."
                   },
                   {
                    id: "ei-0-8-29", da: "Enhance communication and collaboration tools."
                   },
                   {
                    id: "ei-0-8-30", da: "Optimize e-commerce and online sales platforms."
                   },
                   {
                    id: "ei-0-8-31", da: "Implement better risk management strategies."
                   },
                   {
                    id: "ei-0-8-32", da: "Enhance compliance with industry regulations."
                   },
                   {
                    id: "ei-0-8-33", da: "Optimize warehouse and storage solutions."
                   },
                   {
                    id: "ei-0-8-34", da: "Develop a strong brand identity and marketing strategy."
                   },
                   {
                    id: "ei-0-8-35", da: "Expand into new markets or regions."
                   },
                   {
                    id: "ei-0-8-36", da: "Implement a customer feedback and improvement loop."
                   },
                   {
                    id: "ei-0-8-37", da: "Enhance product or service innovation processes."
                   },
                   {
                    id: "ei-0-8-38", da: "Optimize financial forecasting and budgeting."
                   },
                   {
                    id: "ei-0-8-39", da: "Improve stakeholder communication."
                   },
                   {
                    id: "ei-0-8-40", da: "Implement a more efficient time and attendance system."
                   },
                   {
                    id: "ei-0-8-41", da: "Foster sustainability initiatives."
                   },
                   {
                    id: "ei-0-8-42", da: "Optimize internal and external reporting processes."
                   },
                   {
                    id: "ei-0-8-43", da: "Develop a comprehensive crisis management plan."
                   },
                   {
                    id: "ei-0-8-44", da: "Enhance security and data protection measures."
                   },
                   {
                    id: "ei-0-8-45", da: "Invest in employee skill development programs."
                   },
                   {
                    id: "ei-0-8-46", da: "Streamline HR and payroll processes."
                   },
                   {
                    id: "ei-0-8-47", da: "Implement performance-based incentive programs."
                   },
                   {
                    id: "ei-0-8-48", da: "Enhance the corporate social responsibility (CSR) strategy."
                   },
                   {
                    id: "ei-0-8-49", da: "Optimize outsourcing and offshoring strategies."
                   },
                ]
              },
              {
                id: 'ei-0-9',
                pm: 'Team is attending events, competitions and accelerators to understand landscape and operators.',
                title:'Exit Strategy',
                pmMap: 'Team is attending events, competitions and accelerators to understand landscape and operators.',
                developmentActions:[
                  {
                    id: "ei-0-9-0", da: "Create clear exit criteria for ecosystem participants."
                   },
                   {
                    id: "ei-0-9-1", da: "Develop a structured exit planning process."
                   },
                   {
                    id: "ei-0-9-2", da: "Offer mentorship programs for startups on exit strategies."
                   },
                   {
                    id: "ei-0-9-3", da: "Foster relationships with potential acquirers."
                   },
                   {
                    id: "ei-0-9-4", da: "Conduct Attracting Leads assessments."
                   },
                   {
                    id: "ei-0-9-5", da: "Facilitate exit-focused networking events."
                   },
                   {
                    id: "ei-0-9-6", da: "Provide legal and financial due diligence support."
                   },
                   {
                    id: "ei-0-9-7", da: "Encourage portfolio diversification for investors."
                   },
                   {
                    id: "ei-0-9-8", da: "Promote IPO readiness for startups."
                   },
                   {
                    id: "ei-0-9-9", da: "Establish an ecosystem-wide database of exit data."
                   },
                   {
                    id: "ei-0-9-10", da: "Offer tax planning and optimization services."
                   },
                   {
                    id: "ei-0-9-11", da: "Create an exit playbook for startups."
                   },
                   {
                    id: "ei-0-9-12", da: "Educate startups on valuation methods."
                   },
                   {
                    id: "ei-0-9-13", da: "Facilitate exit-focused peer groups."
                   },
                   {
                    id: "ei-0-9-14", da: "Develop resources for mergers and acquisitions (M&A) negotiations."
                   },
                   {
                    id: "ei-0-9-15", da: "Encourage partnerships and collaborations as exit alternatives."
                   },
                   {
                    id: "ei-0-9-16", da: "Provide access to exit experts and advisors."
                   },
                   {
                    id: "ei-0-9-17", da: "Support intellectual property management for exits."
                   },
                   {
                    id: "ei-0-9-18", da: "Build exit-focused accelerators or incubators."
                   },
                   {
                    id: "ei-0-9-19", da: "Offer access to debt financing for acquisition."
                   },
                   {
                    id: "ei-0-9-20", da: "Develop a centralized exit information portal."
                   },
                   {
                    id: "ei-0-9-21", da: "Promote exit strategy workshops and training."
                   },
                   {
                    id: "ei-0-9-22", da: "Engage in exit-focused research and publications."
                   },
                   {
                    id: "ei-0-9-23", da: "Provide exit-friendly legal services."
                   },
                   {
                    id: "ei-0-9-24", da: "Establish a fund for pre-exit transition investments."
                   },
                   {
                    id: "ei-0-9-25", da: "Promote cross-border exit opportunities."
                   },
                   {
                    id: "ei-0-9-26", da: "Encourage innovation in the exit process itself."
                   },
                   {
                    id: "ei-0-9-27", da: "Support startup acquisitions by corporate partners."
                   },
                   {
                    id: "ei-0-9-28", da: "Offer succession planning resources."
                   },
                   {
                    id: "ei-0-9-29", da: "Create a listing platform for exit-ready startups."
                   },
                   {
                    id: "ei-0-9-30", da: "Develop an ecosystem-specific exit index."
                   },
                   {
                    id: "ei-0-9-31", da: "Facilitate knowledge sharing on successful exits."
                   },
                   {
                    id: "ei-0-9-32", da: "Encourage private equity investments."
                   },
                   {
                    id: "ei-0-9-33", da: "Support exits through crowdfunding platforms."
                   },
                   {
                    id: "ei-0-9-34", da: "Promote exit case studies and success stories."
                   },
                   {
                    id: "ei-0-9-35", da: "Develop an exit-focused mentor network."
                   },
                   {
                    id: "ei-0-9-36", da: "Provide exit financing for high-potential startups."
                   },
                   {
                    id: "ei-0-9-37", da: "Encourage partnerships with exit consultants."
                   },
                   {
                    id: "ei-0-9-38", da: "Establish an exit-focused venture capital fund."
                   },
                   {
                    id: "ei-0-9-39", da: "Facilitate exit-focused hackathons and challenges."
                   },
                   {
                    id: "ei-0-9-40", da: "Promote government incentives for exits."
                   },
                   {
                    id: "ei-0-9-41", da: "Offer exit grants or awards."
                   },
                   {
                    id: "ei-0-9-42", da: "Support early exit planning, not just exits."
                   },
                   {
                    id: "ei-0-9-43", da: "Engage in ecosystem benchmarking for exits."
                   },
                   {
                    id: "ei-0-9-44", da: "Create an exit-focused investment fund."
                   },
                   {
                    id: "ei-0-9-45", da: "Develop a guide for acquisition targeting."
                   },
                   {
                    id: "ei-0-9-46", da: "Encourage sector-specific exit forums."
                   },
                   {
                    id: "ei-0-9-47", da: "Promote angel investor involvement in exits."
                   },
                   {
                    id: "ei-0-9-48", da: "Offer exit strategy competitions."
                   },
                   {
                    id: "ei-0-9-49", da: "Facilitate secondary market trading of startup shares."
                   },
                ]
              },   
            ]
          },
          {
            id: 'ei-1',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Pilot',
            wdd: '',
            progressMeasures:[
              {
                id: 'ei-1-0',
                pm: 'A wider need is confirmed, and experimental pilot engages the community.',
                title:'Need',
                pmMap: 'A wider need is confirmed, and experimental pilot engages the community.',
                developmentActions:[
                  {
                    id: "ei-1-0-0", da: "Enhance data collection methods."
                   },
                   {
                    id: "ei-1-0-1", da: "Improve data accuracy and reliability."
                   },
                   {
                    id: "ei-1-0-2", da: "Expand data sources for a more comprehensive view."
                   },
                   {
                    id: "ei-1-0-3", da: "Develop better data visualization tools."
                   },
                   {
                    id: "ei-1-0-4", da: "Implement machine learning for data analysis."
                   },
                   {
                    id: "ei-1-0-5", da: "Enhance data security measures."
                   },
                   {
                    id: "ei-1-0-6", da: "Improve user interface for data access."
                   },
                   {
                    id: "ei-1-0-7", da: "Provide real-time data updates."
                   },
                   {
                    id: "ei-1-0-8", da: "Optimize data storage and retrieval."
                   },
                   {
                    id: "ei-1-0-9", da: "Expand ecosystem coverage."
                   },
                   {
                    id: "ei-1-0-10", da: "Enhance predictive analytics."
                   },
                   {
                    id: "ei-1-0-11", da: "Streamline data integration from various systems."
                   },
                   {
                    id: "ei-1-0-12", da: "Improve data quality control."
                   },
                   {
                    id: "ei-1-0-13", da: "Enhance data sharing mechanisms."
                   },
                   {
                    id: "ei-1-0-14", da: "Develop a mobile app for data access."
                   },
                   {
                    id: "ei-1-0-15", da: "Expand the scope of ecosystem monitoring."
                   },
                   {
                    id: "ei-1-0-16", da: "Implement natural language processing for data extraction."
                   },
                   {
                    id: "ei-1-0-17", da: "Improve data interpretation algorithms."
                   },
                   {
                    id: "ei-1-0-18", da: "Develop customizable dashboards."
                   },
                   {
                    id: "ei-1-0-19", da: "Enhance data governance policies."
                   },
                   {
                    id: "ei-1-0-20", da: "Implement data encryption standards."
                   },
                   {
                    id: "ei-1-0-21", da: "Improve data categorization and tagging."
                   },
                   {
                    id: "ei-1-0-22", da: "Expand ecosystem impact analysis."
                   },
                   {
                    id: "ei-1-0-23", da: "Develop benchmarking tools for comparisons."
                   },
                   {
                    id: "ei-1-0-24", da: "Improve response time to ecosystem changes."
                   },
                   {
                    id: "ei-1-0-25", da: "Expand stakeholder engagement in data collection."
                   },
                   {
                    id: "ei-1-0-26", da: "Enhance data accessibility for non-technical users."
                   },
                   {
                    id: "ei-1-0-27", da: "Implement data anonymization for privacy."
                   },
                   {
                    id: "ei-1-0-28", da: "Improve data version control."
                   },
                   {
                    id: "ei-1-0-29", da: "Expand support for open data standards."
                   },
                   {
                    id: "ei-1-0-30", da: "Enhance data compliance with regulations."
                   },
                   {
                    id: "ei-1-0-31", da: "Develop a knowledge base for ecosystem understanding."
                   },
                   {
                    id: "ei-1-0-32", da: "Improve data storage capacity."
                   },
                   {
                    id: "ei-1-0-33", da: "Expand reporting capabilities."
                   },
                   {
                    id: "ei-1-0-34", da: "Enhance cross-platform data integration."
                   },
                   {
                    id: "ei-1-0-35", da: "Implement data monitoring alerts."
                   },
                   {
                    id: "ei-1-0-36", da: "Improve data normalization processes."
                   },
                   {
                    id: "ei-1-0-37", da: "Expand ecosystem forecasting models."
                   },
                   {
                    id: "ei-1-0-38", da: "Develop API integrations with other systems."
                   },
                   {
                    id: "ei-1-0-39", da: "Enhance data backup and recovery mechanisms."
                   },
                   {
                    id: "ei-1-0-40", da: "Improve data access control."
                   },
                   {
                    id: "ei-1-0-41", da: "Expand user training and support."
                   },
                   {
                    id: "ei-1-0-42", da: "Implement feedback mechanisms for data improvements."
                   },
                   {
                    id: "ei-1-0-43", da: "Enhance data retention policies."
                   },
                   {
                    id: "ei-1-0-44", da: "Develop a comprehensive data documentation."
                   },
                   {
                    id: "ei-1-0-45", da: "Expand ecosystem mapping capabilities."
                   },
                   {
                    id: "ei-1-0-46", da: "Improve user permissions and roles."
                   },
                   {
                    id: "ei-1-0-47", da: "Enhance metadata management."
                   },
                   {
                    id: "ei-1-0-48", da: "Implement data audit trails."
                   },
                   {
                    id: "ei-1-0-49", da: "Develop a sustainability plan for the ecosystem intelligence project."
                   },
                ]
              },
              {
                id: 'ei-1-1',
                pm: 'Market interest is increasing, leading to customer referrals and organic inbound requests.',
                title:'Market',
                pmMap: 'Market interest is increasing, leading to customer referrals and organic inbound requests.',
                developmentActions:[
                  {
                    id: "ei-1-1-0", da: "Conduct market research to identify key trends."
                   },
                   {
                    id: "ei-1-1-1", da: "Implement a competitive analysis to understand market dynamics."
                   },
                   {
                    id: "ei-1-1-2", da: "Develop a market entry strategy."
                   },
                   {
                    id: "ei-1-1-3", da: "Expand the product or service offering."
                   },
                   {
                    id: "ei-1-1-4", da: "Enhance customer support and service."
                   },
                   {
                    id: "ei-1-1-5", da: "Improve pricing strategies."
                   },
                   {
                    id: "ei-1-1-6", da: "Launch targeted marketing campaigns."
                   },
                   {
                    id: "ei-1-1-7", da: "Create partnerships with complementary businesses."
                   },
                   {
                    id: "ei-1-1-8", da: "Diversify distribution channels."
                   },
                   {
                    id: "ei-1-1-9", da: "Optimize supply chain and logistics."
                   },
                   {
                    id: "ei-1-1-10", da: "Invest in technology and infrastructure."
                   },
                   {
                    id: "ei-1-1-11", da: "Enhance product quality and features."
                   },
                   {
                    id: "ei-1-1-12", da: "Streamline business processes."
                   },
                   {
                    id: "ei-1-1-13", da: "Focus on customer feedback and satisfaction."
                   },
                   {
                    id: "ei-1-1-14", da: "Offer customization options."
                   },
                   {
                    id: "ei-1-1-15", da: "Expand to new geographic regions."
                   },
                   {
                    id: "ei-1-1-16", da: "Develop a robust online presence."
                   },
                   {
                    id: "ei-1-1-17", da: "Implement data-driven decision-making."
                   },
                   {
                    id: "ei-1-1-18", da: "Enhance brand visibility and recognition."
                   },
                   {
                    id: "ei-1-1-19", da: "Invest in employee training and development."
                   },
                   {
                    id: "ei-1-1-20", da: "Explore export opportunities."
                   },
                   {
                    id: "ei-1-1-21", da: "Introduce loyalty programs."
                   },
                   {
                    id: "ei-1-1-22", da: "Improve after-sales support."
                   },
                   {
                    id: "ei-1-1-23", da: "Strengthen intellectual property protection."
                   },
                   {
                    id: "ei-1-1-24", da: "Conduct regular SWOT analyses."
                   },
                   {
                    id: "ei-1-1-25", da: "Monitor market trends and consumer behavior."
                   },
                   {
                    id: "ei-1-1-26", da: "Invest in research and development."
                   },
                   {
                    id: "ei-1-1-27", da: "Optimize pricing and discount strategies."
                   },
                   {
                    id: "ei-1-1-28", da: "Upgrade IT systems and cybersecurity."
                   },
                   {
                    id: "ei-1-1-29", da: "Implement sustainability and green initiatives."
                   },
                   {
                    id: "ei-1-1-30", da: "Develop a crisis management plan."
                   },
                   {
                    id: "ei-1-1-31", da: "Foster innovation and creativity."
                   },
                   {
                    id: "ei-1-1-32", da: "Expand product lines and SKUs."
                   },
                   {
                    id: "ei-1-1-33", da: "Focus on niche market segments."
                   },
                   {
                    id: "ei-1-1-34", da: "Collaborate with industry associations."
                   },
                   {
                    id: "ei-1-1-35", da: "Offer financing options."
                   },
                   {
                    id: "ei-1-1-36", da: "Develop a content marketing strategy."
                   },
                   {
                    id: "ei-1-1-37", da: "Create customer personas for better targeting."
                   },
                   {
                    id: "ei-1-1-38", da: "Invest in market-specific advertising."
                   },
                   {
                    id: "ei-1-1-39", da: "Improve product packaging and presentation."
                   },
                   {
                    id: "ei-1-1-40", da: "Engage in public relations efforts."
                   },
                   {
                    id: "ei-1-1-41", da: "Optimize website user experience."
                   },
                   {
                    id: "ei-1-1-42", da: "Attend industry trade shows and events."
                   },
                   {
                    id: "ei-1-1-43", da: "Explore mergers and acquisitions."
                   },
                   {
                    id: "ei-1-1-44", da: "Establish key performance indicators (KPIs)."
                   },
                   {
                    id: "ei-1-1-45", da: "Conduct market segmentation analysis."
                   },
                   {
                    id: "ei-1-1-46", da: "Introduce subscription-based models."
                   },
                   {
                    id: "ei-1-1-47", da: "Enhance customer data analytics."
                   },
                   {
                    id: "ei-1-1-48", da: "Foster corporate social responsibility."
                   },
                   {
                    id: "ei-1-1-49", da: "Build relationships with regulatory bodies."
                   },
                ]
              },
              {
                id: 'ei-1-2',
                pm: 'Implemented technology solution has demonstrated working efficiency.',
                title:'Technology',
                pmMap: 'Implemented technology solution has demonstrated working efficiency.',
                developmentActions:[
                  {
                    id: "ei-1-2-0", da: "Enhance cybersecurity measures."
                   },
                   {
                    id: "ei-1-2-1", da: "Implement multi-factor authentication."
                   },
                   {
                    id: "ei-1-2-2", da: "Improve data encryption."
                   },
                   {
                    id: "ei-1-2-3", da: "Upgrade firewall systems."
                   },
                   {
                    id: "ei-1-2-4", da: "Optimize server performance."
                   },
                   {
                    id: "ei-1-2-5", da: "Implement a disaster recovery plan."
                   },
                   {
                    id: "ei-1-2-6", da: "Enhance data backup procedures."
                   },
                   {
                    id: "ei-1-2-7", da: "Upgrade software to the latest versions."
                   },
                   {
                    id: "ei-1-2-8", da: "Improve network monitoring."
                   },
                   {
                    id: "ei-1-2-9", da: "Implement intrusion detection systems."
                   },
                   {
                    id: "ei-1-2-10", da: "Upgrade to a more efficient database system."
                   },
                   {
                    id: "ei-1-2-11", da: "Enhance data analytics capabilities."
                   },
                   {
                    id: "ei-1-2-12", da: "Improve data visualization tools."
                   },
                   {
                    id: "ei-1-2-13", da: "Implement machine learning for data analysis."
                   },
                   {
                    id: "ei-1-2-14", da: "Optimize website and application load times."
                   },
                   {
                    id: "ei-1-2-15", da: "Upgrade to a cloud-based infrastructure."
                   },
                   {
                    id: "ei-1-2-16", da: "Improve mobile app performance."
                   },
                   {
                    id: "ei-1-2-17", da: "Enhance user experience design."
                   },
                   {
                    id: "ei-1-2-18", da: "Implement responsive web design."
                   },
                   {
                    id: "ei-1-2-19", da: "Upgrade hardware infrastructure."
                   },
                   {
                    id: "ei-1-2-20", da: "Improve IT service management."
                   },
                   {
                    id: "ei-1-2-21", da: "Enhance IT asset management."
                   },
                   {
                    id: "ei-1-2-22", da: "Optimize server virtualization."
                   },
                   {
                    id: "ei-1-2-23", da: "Improve digital marketing strategies."
                   },
                   {
                    id: "ei-1-2-24", da: "Implement social media analytics tools."
                   },
                   {
                    id: "ei-1-2-25", da: "Enhance SEO techniques."
                   },
                   {
                    id: "ei-1-2-26", da: "Upgrade content management systems."
                   },
                   {
                    id: "ei-1-2-27", da: "Improve e-commerce capabilities."
                   },
                   {
                    id: "ei-1-2-28", da: "Implement chatbots for customer support."
                   },
                   {
                    id: "ei-1-2-29", da: "Upgrade email marketing tools."
                   },
                   {
                    id: "ei-1-2-30", da: "Enhance data privacy compliance."
                   },
                   {
                    id: "ei-1-2-31", da: "Improve data governance policies."
                   },
                   {
                    id: "ei-1-2-32", da: "Implement data quality management."
                   },
                   {
                    id: "ei-1-2-33", da: "Upgrade the use of APIs."
                   },
                   {
                    id: "ei-1-2-34", da: "Enhance cloud security."
                   },
                   {
                    id: "ei-1-2-35", da: "Implement Internet of Things (IoT) solutions."
                   },
                   {
                    id: "ei-1-2-36", da: "Improve supply chain management technology."
                   },
                   {
                    id: "ei-1-2-37", da: "Enhance inventory tracking systems."
                   },
                   {
                    id: "ei-1-2-38", da: "Upgrade customer relationship management (CRM) tools."
                   },
                   {
                    id: "ei-1-2-39", da: "Implement predictive maintenance for machinery."
                   },
                   {
                    id: "ei-1-2-40", da: "Improve software development methodologies."
                   },
                   {
                    id: "ei-1-2-41", da: "Enhance test automation practices."
                   },
                   {
                    id: "ei-1-2-42", da: "Upgrade DevOps and CI\/CD pipelines."
                   },
                   {
                    id: "ei-1-2-43", da: "Implement continuous monitoring for performance."
                   },
                   {
                    id: "ei-1-2-44", da: "Improve user training and onboarding."
                   },
                   {
                    id: "ei-1-2-45", da: "Enhance remote work technology."
                   },
                   {
                    id: "ei-1-2-46", da: "Upgrade telecommunication systems."
                   },
                   {
                    id: "ei-1-2-47", da: "Implement video conferencing solutions."
                   },
                   {
                    id: "ei-1-2-48", da: "Improve collaboration and project management tools."
                   },
                   {
                    id: "ei-1-2-49", da: "Optimize the use of artificial intelligence in various processes."
                   },
                ]
              },
              {
                id: 'ei-1-3',
                pm: 'Value is provided to pilot users, and they have confirmed usefulness.',
                title:'Value',
                pmMap: 'Value is provided to pilot users, and they have confirmed usefulness.',
                developmentActions:[
                  {
                    id: "ei-1-3-0", da: "Enhance user experience on the platform."
                   },
                   {
                    id: "ei-1-3-1", da: "Implement user-friendly onboarding."
                   },
                   {
                    id: "ei-1-3-2", da: "Improve website\/mobile app performance."
                   },
                   {
                    id: "ei-1-3-3", da: "Enhance security measures."
                   },
                   {
                    id: "ei-1-3-4", da: "Optimize the registration process."
                   },
                   {
                    id: "ei-1-3-5", da: "Streamline content delivery."
                   },
                   {
                    id: "ei-1-3-6", da: "Implement real-time data updates."
                   },
                   {
                    id: "ei-1-3-7", da: "Offer better customer support."
                   },
                   {
                    id: "ei-1-3-8", da: "Increase website\/app loading speed."
                   },
                   {
                    id: "ei-1-3-9", da: "Provide comprehensive FAQs."
                   },
                   {
                    id: "ei-1-3-10", da: "Expand the platform's feature set."
                   },
                   {
                    id: "ei-1-3-11", da: "Personalize user recommendations."
                   },
                   {
                    id: "ei-1-3-12", da: "Implement a responsive design."
                   },
                   {
                    id: "ei-1-3-13", da: "Enhance data analytics capabilities."
                   },
                   {
                    id: "ei-1-3-14", da: "Offer multi-language support."
                   },
                   {
                    id: "ei-1-3-15", da: "Develop a mobile app if not available."
                   },
                   {
                    id: "ei-1-3-16", da: "Improve search functionality."
                   },
                   {
                    id: "ei-1-3-17", da: "Enhance data visualization."
                   },
                   {
                    id: "ei-1-3-18", da: "Optimize the checkout process."
                   },
                   {
                    id: "ei-1-3-19", da: "Expand payment options."
                   },
                   {
                    id: "ei-1-3-20", da: "Provide better reporting tools."
                   },
                   {
                    id: "ei-1-3-21", da: "Enhance social sharing features."
                   },
                   {
                    id: "ei-1-3-22", da: "Improve content curation."
                   },
                   {
                    id: "ei-1-3-23", da: "Implement AI-powered features."
                   },
                   {
                    id: "ei-1-3-24", da: "Streamline content management."
                   },
                   {
                    id: "ei-1-3-25", da: "Enhance push notification options."
                   },
                   {
                    id: "ei-1-3-26", da: "Optimize content delivery networks."
                   },
                   {
                    id: "ei-1-3-27", da: "Offer better integration options."
                   },
                   {
                    id: "ei-1-3-28", da: "Improve API documentation."
                   },
                   {
                    id: "ei-1-3-29", da: "Enhance accessibility features."
                   },
                   {
                    id: "ei-1-3-30", da: "Provide better content filtering."
                   },
                   {
                    id: "ei-1-3-31", da: "Optimize error handling."
                   },
                   {
                    id: "ei-1-3-32", da: "Improve user feedback mechanisms."
                   },
                   {
                    id: "ei-1-3-33", da: "Enhance data backup and recovery."
                   },
                   {
                    id: "ei-1-3-34", da: "Offer data export options."
                   },
                   {
                    id: "ei-1-3-35", da: "Implement machine learning algorithms."
                   },
                   {
                    id: "ei-1-3-36", da: "Expand data storage capabilities."
                   },
                   {
                    id: "ei-1-3-37", da: "Enhance third-party integrations."
                   },
                   {
                    id: "ei-1-3-38", da: "Optimize the subscription process."
                   },
                   {
                    id: "ei-1-3-39", da: "Improve tracking and analytics."
                   },
                   {
                    id: "ei-1-3-40", da: "Offer comprehensive user profiles."
                   },
                   {
                    id: "ei-1-3-41", da: "Enhance gamification features."
                   },
                   {
                    id: "ei-1-3-42", da: "Implement personalization engines."
                   },
                   {
                    id: "ei-1-3-43", da: "Optimize image and video handling."
                   },
                   {
                    id: "ei-1-3-44", da: "Offer better content moderation."
                   },
                   {
                    id: "ei-1-3-45", da: "Enhance mobile optimization."
                   },
                   {
                    id: "ei-1-3-46", da: "Improve email notifications."
                   },
                   {
                    id: "ei-1-3-47", da: "Expand user engagement strategies."
                   },
                   {
                    id: "ei-1-3-48", da: "Optimize data privacy and compliance."
                   },
                   {
                    id: "ei-1-3-49", da: "Provide scalability options."
                   },
                ]
              },
              {
                id: 'ei-1-4',
                pm: 'Team has experimented various models practically.',
                title:'Business Model',
                pmMap: 'Team has experimented various models practically.',
                developmentActions:[
                  {
                    id: "ei-1-4-0", da: "Conduct market research to understand customer needs."
                   },
                   {
                    id: "ei-1-4-1", da: "Identify new revenue streams within the ecosystem."
                   },
                   {
                    id: "ei-1-4-2", da: "Assess the scalability of the current business model."
                   },
                   {
                    id: "ei-1-4-3", da: "Explore partnerships with complementary ecosystem players."
                   },
                   {
                    id: "ei-1-4-4", da: "Optimize pricing strategies for better competitiveness."
                   },
                   {
                    id: "ei-1-4-5", da: "Create tiered pricing models to cater to different customer segments."
                   },
                   {
                    id: "ei-1-4-6", da: "Investigate subscription-based models for recurring revenue."
                   },
                   {
                    id: "ei-1-4-7", da: "Diversify product or service offerings."
                   },
                   {
                    id: "ei-1-4-8", da: "Leverage data analytics for actionable insights."
                   },
                   {
                    id: "ei-1-4-9", da: "Develop a more customer-centric approach."
                   },
                   {
                    id: "ei-1-4-10", da: "Enhance customer support and service quality."
                   },
                   {
                    id: "ei-1-4-11", da: "Expand the geographical reach of the ecosystem."
                   },
                   {
                    id: "ei-1-4-12", da: "Identify and remove bottlenecks in operations."
                   },
                   {
                    id: "ei-1-4-13", da: "Improve supply chain management."
                   },
                   {
                    id: "ei-1-4-14", da: "Focus on sustainable and ethical practices."
                   },
                   {
                    id: "ei-1-4-15", da: "Enhance brand awareness and recognition."
                   },
                   {
                    id: "ei-1-4-16", da: "Invest in digital marketing and online presence."
                   },
                   {
                    id: "ei-1-4-17", da: "Target new customer demographics."
                   },
                   {
                    id: "ei-1-4-18", da: "Streamline internal processes for efficiency."
                   },
                   {
                    id: "ei-1-4-19", da: "Invest in research and development."
                   },
                   {
                    id: "ei-1-4-20", da: "Enhance user experience for digital products."
                   },
                   {
                    id: "ei-1-4-21", da: "Offer customization options to customers."
                   },
                   {
                    id: "ei-1-4-22", da: "Create a more user-friendly website or app."
                   },
                   {
                    id: "ei-1-4-23", da: "Optimize SEO to attract organic traffic."
                   },
                   {
                    id: "ei-1-4-24", da: "Investigate blockchain technology for transparency."
                   },
                   {
                    id: "ei-1-4-25", da: "Implement IoT for data collection and analysis."
                   },
                   {
                    id: "ei-1-4-26", da: "Develop a mobile app for on-the-go access."
                   },
                   {
                    id: "ei-1-4-27", da: "Create a loyalty program for repeat customers."
                   },
                   {
                    id: "ei-1-4-28", da: "Improve customer data privacy and security."
                   },
                   {
                    id: "ei-1-4-29", da: "Offer free trials or samples to attract new users."
                   },
                   {
                    id: "ei-1-4-30", da: "Develop a content marketing strategy."
                   },
                   {
                    id: "ei-1-4-31", da: "Conduct A\/B testing for website optimization."
                   },
                   {
                    id: "ei-1-4-32", da: "Investigate gamification to engage users."
                   },
                   {
                    id: "ei-1-4-33", da: "Implement cost-cutting measures."
                   },
                   {
                    id: "ei-1-4-34", da: "Enhance data protection and cybersecurity."
                   },
                   {
                    id: "ei-1-4-35", da: "Develop a competitive analysis framework."
                   },
                   {
                    id: "ei-1-4-36", da: "Seek feedback from employees and stakeholders."
                   },
                   {
                    id: "ei-1-4-37", da: "Identify niche markets for potential growth."
                   },
                   {
                    id: "ei-1-4-38", da: "Conduct regular SWOT analyses."
                   },
                   {
                    id: "ei-1-4-39", da: "Create a crisis management plan."
                   },
                   {
                    id: "ei-1-4-40", da: "Expand into international markets."
                   },
                   {
                    id: "ei-1-4-41", da: "Optimize internal communication."
                   },
                   {
                    id: "ei-1-4-42", da: "Develop a disaster recovery plan."
                   },
                   {
                    id: "ei-1-4-43", da: "Focus on innovation and continuous improvement."
                   },
                   {
                    id: "ei-1-4-44", da: "Invest in employee training and development."
                   },
                   {
                    id: "ei-1-4-45", da: "Explore alternative funding sources."
                   },
                   {
                    id: "ei-1-4-46", da: "Monitor industry trends and adapt."
                   },
                   {
                    id: "ei-1-4-47", da: "Foster a culture of creativity and innovation."
                   },
                   {
                    id: "ei-1-4-48", da: "Create a business model canvas for clarity."
                   },
                   {
                    id: "ei-1-4-49", da: "Stay agile and responsive to changing needs."
                   },
                ]
              },
              {
                id: 'ei-1-5',
                pm: 'Team has created a target prospect list of key buyer personas.',
                title:'Go to Market',
                pmMap: 'Team has created a target prospect list of key buyer personas.',
                developmentActions:[
                  {
                    id: "ei-1-5-0", da: "Define your target audience clearly."
                   },
                   {
                    id: "ei-1-5-1", da: "Understand your customers' pain points."
                   },
                   {
                    id: "ei-1-5-2", da: "Create detailed customer personas."
                   },
                   {
                    id: "ei-1-5-3", da: "Analyze market trends and competition."
                   },
                   {
                    id: "ei-1-5-4", da: "Develop a unique value proposition."
                   },
                   {
                    id: "ei-1-5-5", da: "Set specific GTM goals."
                   },
                   {
                    id: "ei-1-5-6", da: "Establish key performance indicators (KPIs)."
                   },
                   {
                    id: "ei-1-5-7", da: "Determine your pricing strategy."
                   },
                   {
                    id: "ei-1-5-8", da: "Choose the right distribution channels."
                   },
                   {
                    id: "ei-1-5-9", da: "Develop a strong brand identity."
                   },
                   {
                    id: "ei-1-5-10", da: "Invest in market research."
                   },
                   {
                    id: "ei-1-5-11", da: "Create a compelling elevator pitch."
                   },
                   {
                    id: "ei-1-5-12", da: "Craft a comprehensive marketing plan."
                   },
                   {
                    id: "ei-1-5-13", da: "Develop a content marketing strategy."
                   },
                   {
                    id: "ei-1-5-14", da: "Use SEO to improve online visibility."
                   },
                   {
                    id: "ei-1-5-15", da: "Leverage social media for brand awareness."
                   },
                   {
                    id: "ei-1-5-16", da: "Invest in pay-per-click (PPC) advertising."
                   },
                   {
                    id: "ei-1-5-17", da: "Optimize your website for conversions."
                   },
                   {
                    id: "ei-1-5-18", da: "Implement email marketing campaigns."
                   },
                   {
                    id: "ei-1-5-19", da: "Consider influencer marketing."
                   },
                   {
                    id: "ei-1-5-20", da: "Create engaging product demos."
                   },
                   {
                    id: "ei-1-5-21", da: "Offer free trials or samples."
                   },
                   {
                    id: "ei-1-5-22", da: "Focus on customer education."
                   },
                   {
                    id: "ei-1-5-23", da: "Provide excellent customer support."
                   },
                   {
                    id: "ei-1-5-24", da: "Monitor customer feedback and reviews."
                   },
                   {
                    id: "ei-1-5-25", da: "Gather and analyze customer data."
                   },
                   {
                    id: "ei-1-5-26", da: "Invest in public relations."
                   },
                   {
                    id: "ei-1-5-27", da: "Establish partnerships and collaborations."
                   },
                   {
                    id: "ei-1-5-28", da: "Create referral programs."
                   },
                   {
                    id: "ei-1-5-29", da: "Leverage user-generated content."
                   },
                   {
                    id: "ei-1-5-30", da: "Optimize your sales funnel."
                   },
                   {
                    id: "ei-1-5-31", da: "Implement lead nurturing campaigns."
                   },
                   {
                    id: "ei-1-5-32", da: "Conduct A\/B testing for landing pages."
                   },
                   {
                    id: "ei-1-5-33", da: "Monitor and analyze conversion rates."
                   },
                   {
                    id: "ei-1-5-34", da: "Use marketing automation tools."
                   },
                   {
                    id: "ei-1-5-35", da: "Measure the ROI of your marketing efforts."
                   },
                   {
                    id: "ei-1-5-36", da: "Continuously improve your messaging."
                   },
                   {
                    id: "ei-1-5-37", da: "Adapt to changing market conditions."
                   },
                   {
                    id: "ei-1-5-38", da: "Stay updated with industry news."
                   },
                   {
                    id: "ei-1-5-39", da: "Train your sales team effectively."
                   },
                   {
                    id: "ei-1-5-40", da: "Develop sales collateral and materials."
                   },
                   {
                    id: "ei-1-5-41", da: "Consider international expansion."
                   },
                   {
                    id: "ei-1-5-42", da: "Evaluate the scalability of your GTM model."
                   },
                   {
                    id: "ei-1-5-43", da: "Set a clear product launch strategy."
                   },
                   {
                    id: "ei-1-5-44", da: "Build a strong company culture."
                   },
                   {
                    id: "ei-1-5-45", da: "Reward and motivate your sales team."
                   },
                   {
                    id: "ei-1-5-46", da: "Conduct market segmentation."
                   },
                   {
                    id: "ei-1-5-47", da: "Test different marketing channels."
                   },
                   {
                    id: "ei-1-5-48", da: "Explore new sales territories."
                   },
                   {
                    id: "ei-1-5-49", da: "Continuously iterate and refine your GTM strategy based on results."
                   },
                ]
              },
              {
                id: 'ei-1-6',
                pm: 'Team has all dedicated personnel to execute a pilot.',
                title:'People',
                pmMap: 'Team has all dedicated personnel to execute a pilot.',
                developmentActions:[
                  {
                    id: "ei-1-6-0", da: "Education and skill development programs"
                   },
                   {
                    id: "ei-1-6-1", da: "Access to quality healthcare"
                   },
                   {
                    id: "ei-1-6-2", da: "Affordable housing"
                   },
                   {
                    id: "ei-1-6-3", da: "Job training and placement services"
                   },
                   {
                    id: "ei-1-6-4", da: "Mental health support"
                   },
                   {
                    id: "ei-1-6-5", da: "Substance abuse treatment programs"
                   },
                   {
                    id: "ei-1-6-6", da: "Early childhood education initiatives"
                   },
                   {
                    id: "ei-1-6-7", da: "Access to nutritious food and clean water"
                   },
                   {
                    id: "ei-1-6-8", da: "Support for local entrepreneurs and small businesses"
                   },
                   {
                    id: "ei-1-6-9", da: "Financial literacy programs"
                   },
                   {
                    id: "ei-1-6-10", da: "Youth mentorship programs"
                   },
                   {
                    id: "ei-1-6-11", da: "Access to affordable transportation"
                   },
                   {
                    id: "ei-1-6-12", da: "Community gardens and green spaces"
                   },
                   {
                    id: "ei-1-6-13", da: "Elderly care and support services"
                   },
                   {
                    id: "ei-1-6-14", da: "Support for individuals with disabilities"
                   },
                   {
                    id: "ei-1-6-15", da: "Affordable childcare options"
                   },
                   {
                    id: "ei-1-6-16", da: "Programs for women's empowerment"
                   },
                   {
                    id: "ei-1-6-17", da: "Support for LGBTQ+ community"
                   },
                   {
                    id: "ei-1-6-18", da: "Cultural and recreational activities"
                   },
                   {
                    id: "ei-1-6-19", da: "English language classes for non-native speakers"
                   },
                   {
                    id: "ei-1-6-20", da: "Digital literacy and access to technology"
                   },
                   {
                    id: "ei-1-6-21", da: "Conflict resolution and mediation services"
                   },
                   {
                    id: "ei-1-6-22", da: "Substance abuse prevention programs"
                   },
                   {
                    id: "ei-1-6-23", da: "Access to legal aid and advocacy"
                   },
                   {
                    id: "ei-1-6-24", da: "Community policing and safety programs"
                   },
                   {
                    id: "ei-1-6-25", da: "Support for refugees and immigrants"
                   },
                   {
                    id: "ei-1-6-26", da: "Support for victims of domestic violence"
                   },
                   {
                    id: "ei-1-6-27", da: "Programs for at-risk youth"
                   },
                   {
                    id: "ei-1-6-28", da: "Support for homeless individuals"
                   },
                   {
                    id: "ei-1-6-29", da: "Access to clean and safe public spaces"
                   },
                   {
                    id: "ei-1-6-30", da: "Vocational training for specific industries"
                   },
                   {
                    id: "ei-1-6-31", da: "Affordable and accessible public transportation"
                   },
                   {
                    id: "ei-1-6-32", da: "Affordable childcare for working parents"
                   },
                   {
                    id: "ei-1-6-33", da: "Scholarships and grants for higher education"
                   },
                   {
                    id: "ei-1-6-34", da: "Programs for veterans' reintegration"
                   },
                   {
                    id: "ei-1-6-35", da: "Community-based healthcare clinics"
                   },
                   {
                    id: "ei-1-6-36", da: "Support for the arts and culture"
                   },
                   {
                    id: "ei-1-6-37", da: "Support for the homeless population"
                   },
                   {
                    id: "ei-1-6-38", da: "Access to clean energy solutions"
                   },
                   {
                    id: "ei-1-6-39", da: "Disaster preparedness and recovery programs"
                   },
                   {
                    id: "ei-1-6-40", da: "Community-based financial institutions"
                   },
                   {
                    id: "ei-1-6-41", da: "Support for indigenous communities"
                   },
                   {
                    id: "ei-1-6-42", da: "Anti-discrimination and diversity training"
                   },
                   {
                    id: "ei-1-6-43", da: "Support for rural and remote areas"
                   },
                   {
                    id: "ei-1-6-44", da: "Community-based policing and neighborhood watch"
                   },
                   {
                    id: "ei-1-6-45", da: "Programs for individuals with mental disabilities"
                   },
                   {
                    id: "ei-1-6-46", da: "Support for ex-convicts reintegration"
                   },
                   {
                    id: "ei-1-6-47", da: "Programs for victims of human trafficking"
                   },
                   {
                    id: "ei-1-6-48", da: "Support for individuals affected by natural disasters"
                   },
                   {
                    id: "ei-1-6-49", da: "Access to information and communication technology"
                   },
                ]
              },
              {
                id: 'ei-1-7',
                pm: 'First customers are acquired through a defined and repeatable process with a funnel.',
                title:'Data Metrics',
                pmMap: 'First customers are acquired through a defined and repeatable process with a funnel.',
                developmentActions:[
                  {
                    id: "ei-1-7-0", da: "Define clear data collection objectives."
                   },
                   {
                    id: "ei-1-7-1", da: "Establish a data governance framework."
                   },
                   {
                    id: "ei-1-7-2", da: "Identify key performance indicators (KPIs) for ecosystem intelligence."
                   },
                   {
                    id: "ei-1-7-3", da: "Implement data quality checks and validations."
                   },
                   {
                    id: "ei-1-7-4", da: "Standardize data collection methodologies."
                   },
                   {
                    id: "ei-1-7-5", da: "Use data from reliable sources."
                   },
                   {
                    id: "ei-1-7-6", da: "Ensure data is collected consistently across the ecosystem."
                   },
                   {
                    id: "ei-1-7-7", da: "Conduct regular data audits."
                   },
                   {
                    id: "ei-1-7-8", da: "Employ data encryption and security measures."
                   },
                   {
                    id: "ei-1-7-9", da: "Develop a data classification scheme."
                   },
                   {
                    id: "ei-1-7-10", da: "Create a data dictionary for consistent terminology."
                   },
                   {
                    id: "ei-1-7-11", da: "Implement data version control."
                   },
                   {
                    id: "ei-1-7-12", da: "Set up data access controls."
                   },
                   {
                    id: "ei-1-7-13", da: "Define data ownership responsibilities."
                   },
                   {
                    id: "ei-1-7-14", da: "Establish data retention policies."
                   },
                   {
                    id: "ei-1-7-15", da: "Implement data anonymization and privacy measures."
                   },
                   {
                    id: "ei-1-7-16", da: "Leverage machine learning for data analysis."
                   },
                   {
                    id: "ei-1-7-17", da: "Use data visualization tools for better insights."
                   },
                   {
                    id: "ei-1-7-18", da: "Conduct trend analysis to identify patterns."
                   },
                   {
                    id: "ei-1-7-19", da: "Implement predictive analytics for future planning."
                   },
                   {
                    id: "ei-1-7-20", da: "Create a dashboard for real-time data monitoring."
                   },
                   {
                    id: "ei-1-7-21", da: "Develop data reporting templates."
                   },
                   {
                    id: "ei-1-7-22", da: "Share data reports with relevant stakeholders."
                   },
                   {
                    id: "ei-1-7-23", da: "Use data to measure ecosystem health."
                   },
                   {
                    id: "ei-1-7-24", da: "Assess data for inclusivity and diversity."
                   },
                   {
                    id: "ei-1-7-25", da: "Analyze data on user behavior and preferences."
                   },
                   {
                    id: "ei-1-7-26", da: "Incorporate user feedback into data metrics."
                   },
                   {
                    id: "ei-1-7-27", da: "Monitor data on resource utilization."
                   },
                   {
                    id: "ei-1-7-28", da: "Assess data for scalability and growth."
                   },
                   {
                    id: "ei-1-7-29", da: "Use data to identify market opportunities."
                   },
                   {
                    id: "ei-1-7-30", da: "Measure the impact of development actions."
                   },
                   {
                    id: "ei-1-7-31", da: "Analyze data on competition within the ecosystem."
                   },
                   {
                    id: "ei-1-7-32", da: "Study data on external economic factors."
                   },
                   {
                    id: "ei-1-7-33", da: "Evaluate data on technology trends."
                   },
                   {
                    id: "ei-1-7-34", da: "Assess data on regulatory changes."
                   },
                   {
                    id: "ei-1-7-35", da: "Monitor data on environmental impacts."
                   },
                   {
                    id: "ei-1-7-36", da: "Utilize data for talent acquisition and retention."
                   },
                   {
                    id: "ei-1-7-37", da: "Analyze data on supply chain efficiency."
                   },
                   {
                    id: "ei-1-7-38", da: "Measure data on customer satisfaction."
                   },
                   {
                    id: "ei-1-7-39", da: "Assess data on financial performance."
                   },
                   {
                    id: "ei-1-7-40", da: "Use data to optimize marketing strategies."
                   },
                   {
                    id: "ei-1-7-41", da: "Analyze data on customer acquisition costs."
                   },
                   {
                    id: "ei-1-7-42", da: "Monitor data on customer churn rates."
                   },
                   {
                    id: "ei-1-7-43", da: "Utilize data for product or service improvements."
                   },
                   {
                    id: "ei-1-7-44", da: "Measure data on innovation and R&D activities."
                   },
                   {
                    id: "ei-1-7-45", da: "Analyze data on operational efficiency."
                   },
                   {
                    id: "ei-1-7-46", da: "Evaluate data on sales and revenue growth."
                   },
                   {
                    id: "ei-1-7-47", da: "Monitor data on partnerships and collaborations."
                   },
                   {
                    id: "ei-1-7-48", da: "Use data to identify areas for cost reduction."
                   },
                   {
                    id: "ei-1-7-49", da: "Assess data for compliance with legal and ethical standards."
                   },
                ]
              },
              {
                id: 'ei-1-8',
                pm: 'Team has set up their key operations infrastructure to win and deliver value to community.',
                title:'Operations',
                pmMap: 'Team has set up their key operations infrastructure to win and deliver value to community.',
                developmentActions:[
                  {
                    id: "ei-1-8-0", da: "Define clear objectives and key performance indicators (KPIs)."
                   },
                   {
                    id: "ei-1-8-1", da: "Streamline communication channels and processes."
                   },
                   {
                    id: "ei-1-8-2", da: "Implement a central knowledge repository for easy access to information."
                   },
                   {
                    id: "ei-1-8-3", da: "Enhance data collection and analysis."
                   },
                   {
                    id: "ei-1-8-4", da: "Invest in data security and privacy measures."
                   },
                   {
                    id: "ei-1-8-5", da: "Develop a robust feedback system for stakeholders."
                   },
                   {
                    id: "ei-1-8-6", da: "Optimize resource allocation."
                   },
                   {
                    id: "ei-1-8-7", da: "Improve supply chain management."
                   },
                   {
                    id: "ei-1-8-8", da: "Reduce lead times in production and distribution."
                   },
                   {
                    id: "ei-1-8-9", da: "Enhance product quality control."
                   },
                   {
                    id: "ei-1-8-10", da: "Minimize waste and optimize resource utilization."
                   },
                   {
                    id: "ei-1-8-11", da: "Automate routine tasks."
                   },
                   {
                    id: "ei-1-8-12", da: "Implement efficient inventory management."
                   },
                   {
                    id: "ei-1-8-13", da: "Enhance vendor and supplier relationships."
                   },
                   {
                    id: "ei-1-8-14", da: "Improve customer support and service."
                   },
                   {
                    id: "ei-1-8-15", da: "Streamline order processing."
                   },
                   {
                    id: "ei-1-8-16", da: "Optimize pricing strategies."
                   },
                   {
                    id: "ei-1-8-17", da: "Reduce operational costs."
                   },
                   {
                    id: "ei-1-8-18", da: "Implement green and sustainable practices."
                   },
                   {
                    id: "ei-1-8-19", da: "Foster innovation within the organization."
                   },
                   {
                    id: "ei-1-8-20", da: "Enhance workforce training and development."
                   },
                   {
                    id: "ei-1-8-21", da: "Streamline decision-making processes."
                   },
                   {
                    id: "ei-1-8-22", da: "Optimize marketing and advertising strategies."
                   },
                   {
                    id: "ei-1-8-23", da: "Implement agile project management."
                   },
                   {
                    id: "ei-1-8-24", da: "Enhance risk management and mitigation strategies."
                   },
                   {
                    id: "ei-1-8-25", da: "Optimize production scheduling."
                   },
                   {
                    id: "ei-1-8-26", da: "Improve workplace safety."
                   },
                   {
                    id: "ei-1-8-27", da: "Streamline financial management and reporting."
                   },
                   {
                    id: "ei-1-8-28", da: "Implement effective performance appraisal systems."
                   },
                   {
                    id: "ei-1-8-29", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "ei-1-8-30", da: "Enhance regulatory compliance."
                   },
                   {
                    id: "ei-1-8-31", da: "Improve facilities and infrastructure."
                   },
                   {
                    id: "ei-1-8-32", da: "Optimize energy and resource efficiency."
                   },
                   {
                    id: "ei-1-8-33", da: "Streamline product development and innovation."
                   },
                   {
                    id: "ei-1-8-34", da: "Invest in technology upgrades."
                   },
                   {
                    id: "ei-1-8-35", da: "Improve crisis management and recovery plans."
                   },
                   {
                    id: "ei-1-8-36", da: "Optimize cross-functional collaboration."
                   },
                   {
                    id: "ei-1-8-37", da: "Enhance data analytics capabilities."
                   },
                   {
                    id: "ei-1-8-38", da: "Implement efficient document management."
                   },
                   {
                    id: "ei-1-8-39", da: "Foster a culture of accountability."
                   },
                   {
                    id: "ei-1-8-40", da: "Streamline HR and recruitment processes."
                   },
                   {
                    id: "ei-1-8-41", da: "Improve knowledge sharing and transfer."
                   },
                   {
                    id: "ei-1-8-42", da: "Optimize service delivery processes."
                   },
                   {
                    id: "ei-1-8-43", da: "Enhance competitive analysis and market research."
                   },
                   {
                    id: "ei-1-8-44", da: "Improve workplace diversity and inclusion."
                   },
                   {
                    id: "ei-1-8-45", da: "Streamline logistics and transportation."
                   },
                   {
                    id: "ei-1-8-46", da: "Optimize IT infrastructure and cybersecurity."
                   },
                   {
                    id: "ei-1-8-47", da: "Foster customer loyalty and retention strategies."
                   },
                   {
                    id: "ei-1-8-48", da: "Implement effective change management."
                   },
                   {
                    id: "ei-1-8-49", da: "Continuously monitor and adapt to industry trends and developments."
                   },
                ]
              },
              {
                id: 'ei-1-9',
                pm: 'Pilot user cases are conducted and documented. Early testimonials collected.',
                title:'Exit Strategy',
                pmMap: 'Pilot user cases are conducted and documented. Early testimonials collected.',
                developmentActions:[
                  {
                    id: "ei-1-9-0", da: "Define clear exit goals and objectives."
                   },
                   {
                    id: "ei-1-9-1", da: "Establish a timeline for the exit strategy."
                   },
                   {
                    id: "ei-1-9-2", da: "Identify key stakeholders and their roles in the exit process."
                   },
                   {
                    id: "ei-1-9-3", da: "Conduct a risk assessment to anticipate potential challenges."
                   },
                   {
                    id: "ei-1-9-4", da: "Create a contingency plan for unexpected situations."
                   },
                   {
                    id: "ei-1-9-5", da: "Ensure legal and regulatory compliance during the exit."
                   },
                   {
                    id: "ei-1-9-6", da: "Communicate the exit strategy to all relevant parties."
                   },
                   {
                    id: "ei-1-9-7", da: "Set criteria for measuring the success of the exit."
                   },
                   {
                    id: "ei-1-9-8", da: "Determine the financial resources required for the exit."
                   },
                   {
                    id: "ei-1-9-9", da: "Secure necessary funding for the exit plan."
                   },
                   {
                    id: "ei-1-9-10", da: "Identify potential investors or buyers."
                   },
                   {
                    id: "ei-1-9-11", da: "Evaluate the market for opportunities and demand."
                   },
                   {
                    id: "ei-1-9-12", da: "Prepare your team for the transition."
                   },
                   {
                    id: "ei-1-9-13", da: "Document all processes and procedures."
                   },
                   {
                    id: "ei-1-9-14", da: "Address any outstanding contractual obligations."
                   },
                   {
                    id: "ei-1-9-15", da: "Secure intellectual property rights."
                   },
                   {
                    id: "ei-1-9-16", da: "Plan for data migration and archiving."
                   },
                   {
                    id: "ei-1-9-17", da: "Address employee retention and layoffs."
                   },
                   {
                    id: "ei-1-9-18", da: "Conduct a knowledge transfer process."
                   },
                   {
                    id: "ei-1-9-19", da: "Consider the impact on customers and clients."
                   },
                   {
                    id: "ei-1-9-20", da: "Communicate with customers regarding the exit."
                   },
                   {
                    id: "ei-1-9-21", da: "Develop a communication plan for stakeholders."
                   },
                   {
                    id: "ei-1-9-22", da: "Address public relations and branding concerns."
                   },
                   {
                    id: "ei-1-9-23", da: "Ensure compliance with employment laws."
                   },
                   {
                    id: "ei-1-9-24", da: "Plan for the disposal of physical assets."
                   },
                   {
                    id: "ei-1-9-25", da: "Assess the financial impact on partners."
                   },
                   {
                    id: "ei-1-9-26", da: "Consider tax implications of the exit."
                   },
                   {
                    id: "ei-1-9-27", da: "Secure necessary permits and licenses."
                   },
                   {
                    id: "ei-1-9-28", da: "Address any outstanding debts or liabilities."
                   },
                   {
                    id: "ei-1-9-29", da: "Create a process for winding down operations."
                   },
                   {
                    id: "ei-1-9-30", da: "Develop a plan for addressing any legal disputes."
                   },
                   {
                    id: "ei-1-9-31", da: "Secure the support of your board of directors."
                   },
                   {
                    id: "ei-1-9-32", da: "Ensure the safety and security of assets."
                   },
                   {
                    id: "ei-1-9-33", da: "Document the condition of assets."
                   },
                   {
                    id: "ei-1-9-34", da: "Create an inventory of assets."
                   },
                   {
                    id: "ei-1-9-35", da: "Identify potential post-exit opportunities."
                   },
                   {
                    id: "ei-1-9-36", da: "Explore options for reinvesting profits."
                   },
                   {
                    id: "ei-1-9-37", da: "Consider long-term financial sustainability."
                   },
                   {
                    id: "ei-1-9-38", da: "Evaluate the impact on local communities."
                   },
                   {
                    id: "ei-1-9-39", da: "Address the impact on the environment."
                   },
                   {
                    id: "ei-1-9-40", da: "Plan for the closure of physical locations."
                   },
                   {
                    id: "ei-1-9-41", da: "Consider the impact on suppliers and vendors."
                   },
                   {
                    id: "ei-1-9-42", da: "Evaluate the impact on shareholders."
                   },
                   {
                    id: "ei-1-9-43", da: "Develop a strategy for selling intellectual property."
                   },
                   {
                    id: "ei-1-9-44", da: "Ensure that employees are informed and supported."
                   },
                   {
                    id: "ei-1-9-45", da: "Provide training and career guidance for employees."
                   },
                   {
                    id: "ei-1-9-46", da: "Address cultural and morale concerns."
                   },
                   {
                    id: "ei-1-9-47", da: "Monitor and adjust the exit plan as needed."
                   },
                   {
                    id: "ei-1-9-48", da: "Consider the impact on innovation and R&D."
                   },
                   {
                    id: "ei-1-9-49", da: "Celebrate the achievements of the project and the transition."
                   },
                ]
              },
            ]
          },
          {
            id: 'ei-2',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Validation',
            wdd: '',
            progressMeasures:[
              {
                id: 'ei-2-0',
                pm: '>40 percent of participants would be very disappointed if the community does not exist.',
                title:'Need',
                pmMap: '>40 percent of participants would be very disappointed if the community does not exist.',
                developmentActions:[
                  {
                    id: "ei-2-0-0", da: "Insufficient data collection and analysis in your ecosystem."
                   },
                   {
                    id: "ei-2-0-1", da: "Lack of clear metrics to measure ecosystem performance."
                   },
                   {
                    id: "ei-2-0-2", da: "Inadequate tracking of user behavior and interactions."
                   },
                   {
                    id: "ei-2-0-3", da: "Limited understanding of customer needs and pain points."
                   },
                   {
                    id: "ei-2-0-4", da: "Lack of competitive analysis within the ecosystem."
                   },
                   {
                    id: "ei-2-0-5", da: "Poor integration of data from various sources."
                   },
                   {
                    id: "ei-2-0-6", da: "Incomplete customer journey mapping."
                   },
                   {
                    id: "ei-2-0-7", da: "Limited validation of assumptions and hypotheses."
                   },
                   {
                    id: "ei-2-0-8", da: "Ineffective feedback loops with ecosystem participants."
                   },
                   {
                    id: "ei-2-0-9", da: "Inefficient utilization of user feedback for product improvement."
                   },
                   {
                    id: "ei-2-0-10", da: "Inconsistent data quality and cleanliness."
                   },
                   {
                    id: "ei-2-0-11", da: "Absence of data privacy and security measures."
                   },
                   {
                    id: "ei-2-0-12", da: "No clear definition of key performance indicators (KPIs)."
                   },
                   {
                    id: "ei-2-0-13", da: "Limited transparency in data sharing within the ecosystem."
                   },
                   {
                    id: "ei-2-0-14", da: "Insufficient measures for ecosystem engagement."
                   },
                   {
                    id: "ei-2-0-15", da: "Lack of user personas and segmentation."
                   },
                   {
                    id: "ei-2-0-16", da: "Inadequate monitoring of user satisfaction and sentiment."
                   },
                   {
                    id: "ei-2-0-17", da: "Poor tracking of ecosystem trends and shifts."
                   },
                   {
                    id: "ei-2-0-18", da: "Limited validation of product-market fit."
                   },
                   {
                    id: "ei-2-0-19", da: "Lack of alignment between ecosystem goals and business objectives."
                   },
                   {
                    id: "ei-2-0-20", da: "Incomplete understanding of regulatory requirements."
                   },
                   {
                    id: "ei-2-0-21", da: "Limited interoperability within the ecosystem."
                   },
                   {
                    id: "ei-2-0-22", da: "Inadequate user education and onboarding."
                   },
                   {
                    id: "ei-2-0-23", da: "Poor documentation of ecosystem components and processes."
                   },
                   {
                    id: "ei-2-0-24", da: "No clear strategy for ecosystem expansion."
                   },
                   {
                    id: "ei-2-0-25", da: "Limited validation of the scalability of ecosystem solutions."
                   },
                   {
                    id: "ei-2-0-26", da: "Inefficient use of user-generated content."
                   },
                   {
                    id: "ei-2-0-27", da: "Lack of partnerships and collaborations within the ecosystem."
                   },
                   {
                    id: "ei-2-0-28", da: "Incomplete ecosystem governance structure."
                   },
                   {
                    id: "ei-2-0-29", da: "Poor validation of ecosystem risks and vulnerabilities."
                   },
                   {
                    id: "ei-2-0-30", da: "Limited understanding of ecosystem user needs and behaviors."
                   },
                   {
                    id: "ei-2-0-31", da: "Ineffective feedback collection from ecosystem stakeholders."
                   },
                   {
                    id: "ei-2-0-32", da: "Lack of real-time data analysis capabilities."
                   },
                   {
                    id: "ei-2-0-33", da: "Inadequate crisis management plans within the ecosystem."
                   },
                   {
                    id: "ei-2-0-34", da: "No clear process for addressing ecosystem conflicts."
                   },
                   {
                    id: "ei-2-0-35", da: "Limited measures for ensuring ecosystem sustainability."
                   },
                   {
                    id: "ei-2-0-36", da: "Poor user support and customer service."
                   },
                   {
                    id: "ei-2-0-37", da: "Incomplete measurement of ecosystem ROI."
                   },
                   {
                    id: "ei-2-0-38", da: "Lack of ecosystem branding and identity."
                   },
                   {
                    id: "ei-2-0-39", da: "Limited validation of the ecosystem's impact on the community."
                   },
                   {
                    id: "ei-2-0-40", da: "Inefficient communication channels within the ecosystem."
                   },
                   {
                    id: "ei-2-0-41", da: "Absence of clear product development roadmaps."
                   },
                   {
                    id: "ei-2-0-42", da: "Inadequate training for ecosystem participants."
                   },
                   {
                    id: "ei-2-0-43", da: "No clear understanding of the ecosystem's role in the market."
                   },
                   {
                    id: "ei-2-0-44", da: "Limited measures for addressing ecosystem redundancy."
                   },
                   {
                    id: "ei-2-0-45", da: "Poor validation of ecosystem accessibility and inclusivity."
                   },
                   {
                    id: "ei-2-0-46", da: "Insufficient measures for managing ecosystem dependencies."
                   },
                   {
                    id: "ei-2-0-47", da: "Lack of ecosystem innovation and adaptability."
                   },
                   {
                    id: "ei-2-0-48", da: "Incomplete ecosystem analytics and reporting."
                   },
                   {
                    id: "ei-2-0-49", da: "Limited validation of the ecosystem's long-term viability."
                   },
                ]
              },
              {
                id: 'ei-2-1',
                pm: 'Team has overcome biggest barriers to entry, has understood how to leverage market trends and is winning users.',
                title:'Market',
                pmMap: 'Team has overcome biggest barriers to entry, has understood how to leverage market trends and is winning users.',
                developmentActions:[
                  {
                    id: "ei-2-1-0", da: "Establish a dedicated market intelligence team."
                   },
                   {
                    id: "ei-2-1-1", da: "Invest in market research to understand customer needs."
                   },
                   {
                    id: "ei-2-1-2", da: "Develop comprehensive buyer personas."
                   },
                   {
                    id: "ei-2-1-3", da: "Collect and analyze customer feedback regularly."
                   },
                   {
                    id: "ei-2-1-4", da: "Create a competitive analysis framework."
                   },
                   {
                    id: "ei-2-1-5", da: "Monitor industry trends and emerging technologies."
                   },
                   {
                    id: "ei-2-1-6", da: "Identify key market influencers and thought leaders."
                   },
                   {
                    id: "ei-2-1-7", da: "Build partnerships with industry associations."
                   },
                   {
                    id: "ei-2-1-8", da: "Conduct surveys to gauge market sentiment."
                   },
                   {
                    id: "ei-2-1-9", da: "Utilize social listening tools to track industry conversations."
                   },
                   {
                    id: "ei-2-1-10", da: "Improve data analytics capabilities."
                   },
                   {
                    id: "ei-2-1-11", da: "Enhance data visualization for market insights."
                   },
                   {
                    id: "ei-2-1-12", da: "Implement sentiment analysis for customer feedback."
                   },
                   {
                    id: "ei-2-1-13", da: "Foster innovation through hackathons and idea generation."
                   },
                   {
                    id: "ei-2-1-14", da: "Develop a culture of experimentation."
                   },
                   {
                    id: "ei-2-1-15", da: "Create a product validation process."
                   },
                   {
                    id: "ei-2-1-16", da: "Implement A\/B testing for product features."
                   },
                   {
                    id: "ei-2-1-17", da: "Pilot new products or features with a select user group."
                   },
                   {
                    id: "ei-2-1-18", da: "Utilize Net Promoter Score (NPS) surveys."
                   },
                   {
                    id: "ei-2-1-19", da: "Collaborate with universities and research institutions."
                   },
                   {
                    id: "ei-2-1-20", da: "Develop case studies and success stories."
                   },
                   {
                    id: "ei-2-1-21", da: "Offer webinars and workshops on market trends."
                   },
                   {
                    id: "ei-2-1-22", da: "Enhance internal knowledge sharing among teams."
                   },
                   {
                    id: "ei-2-1-23", da: "Encourage cross-functional collaboration."
                   },
                   {
                    id: "ei-2-1-24", da: "Train employees in market intelligence best practices."
                   },
                   {
                    id: "ei-2-1-25", da: "Promote the use of storytelling for market insights."
                   },
                   {
                    id: "ei-2-1-26", da: "Conduct SWOT analysis regularly."
                   },
                   {
                    id: "ei-2-1-27", da: "Identify niche market segments."
                   },
                   {
                    id: "ei-2-1-28", da: "Build customer advisory boards."
                   },
                   {
                    id: "ei-2-1-29", da: "Implement feedback loops from customer support."
                   },
                   {
                    id: "ei-2-1-30", da: "Regularly update market intelligence dashboards."
                   },
                   {
                    id: "ei-2-1-31", da: "Improve data security and privacy practices."
                   },
                   {
                    id: "ei-2-1-32", da: "Invest in predictive analytics for demand forecasting."
                   },
                   {
                    id: "ei-2-1-33", da: "Explore international expansion opportunities."
                   },
                   {
                    id: "ei-2-1-34", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "ei-2-1-35", da: "Develop a crisis management plan."
                   },
                   {
                    id: "ei-2-1-36", da: "Offer market-specific certifications or training."
                   },
                   {
                    id: "ei-2-1-37", da: "Leverage influencer marketing to validate products."
                   },
                   {
                    id: "ei-2-1-38", da: "Monitor regulatory changes that affect the market."
                   },
                   {
                    id: "ei-2-1-39", da: "Implement a product lifecycle management system."
                   },
                   {
                    id: "ei-2-1-40", da: "Assess the impact of market developments on pricing."
                   },
                   {
                    id: "ei-2-1-41", da: "Optimize supply chain operations."
                   },
                   {
                    id: "ei-2-1-42", da: "Maintain a strong online presence."
                   },
                   {
                    id: "ei-2-1-43", da: "Develop a content marketing strategy."
                   },
                   {
                    id: "ei-2-1-44", da: "Utilize social media advertising for validation."
                   },
                   {
                    id: "ei-2-1-45", da: "Participate in industry trade shows and events."
                   },
                   {
                    id: "ei-2-1-46", da: "Publish whitepapers on market trends."
                   },
                   {
                    id: "ei-2-1-47", da: "Provide resources for market education."
                   },
                   {
                    id: "ei-2-1-48", da: "Establish a market intelligence portal for employees."
                   },
                   {
                    id: "ei-2-1-49", da: "Continuously review and update these actions based on market dynamics."
                   },
                ]
              },
              {
                id: 'ei-2-2',
                pm: 'Implemented tooling is validated by early customers. High tech/product development velocity.',
                title:'Technology',
                pmMap: 'Implemented tooling is validated by early customers. High tech/product development velocity.',
                developmentActions:[
                  {
                    id: "ei-2-2-0", da: "Implement machine learning algorithms for data analysis."
                   },
                   {
                    id: "ei-2-2-1", da: "Enhance data visualization tools for better insights."
                   },
                   {
                    id: "ei-2-2-2", da: "Improve real-time data collection techniques."
                   },
                   {
                    id: "ei-2-2-3", da: "Implement blockchain for secure data validation."
                   },
                   {
                    id: "ei-2-2-4", da: "Develop predictive analytics for ecosystem health."
                   },
                   {
                    id: "ei-2-2-5", da: "Enhance sensor technologies for data accuracy."
                   },
                   {
                    id: "ei-2-2-6", da: "Create a centralized data repository."
                   },
                   {
                    id: "ei-2-2-7", da: "Optimize data processing pipelines."
                   },
                   {
                    id: "ei-2-2-8", da: "Implement natural language processing for text analysis."
                   },
                   {
                    id: "ei-2-2-9", da: "Improve data storage and retrieval systems."
                   },
                   {
                    id: "ei-2-2-10", da: "Enhance cloud infrastructure for scalability."
                   },
                   {
                    id: "ei-2-2-11", da: "Develop mobile apps for data collection."
                   },
                   {
                    id: "ei-2-2-12", da: "Implement IoT devices for ecosystem monitoring."
                   },
                   {
                    id: "ei-2-2-13", da: "Enhance GIS (Geographic Information Systems) capabilities."
                   },
                   {
                    id: "ei-2-2-14", da: "Improve data security and encryption."
                   },
                   {
                    id: "ei-2-2-15", da: "Implement edge computing for faster data processing."
                   },
                   {
                    id: "ei-2-2-16", da: "Develop AI-powered chatbots for user assistance."
                   },
                   {
                    id: "ei-2-2-17", da: "Enhance data anomaly detection algorithms."
                   },
                   {
                    id: "ei-2-2-18", da: "Implement remote sensing technologies."
                   },
                   {
                    id: "ei-2-2-19", da: "Improve data quality control processes."
                   },
                   {
                    id: "ei-2-2-20", da: "Develop machine learning models for anomaly detection."
                   },
                   {
                    id: "ei-2-2-21", da: "Implement data fusion techniques."
                   },
                   {
                    id: "ei-2-2-22", da: "Enhance data integration across platforms."
                   },
                   {
                    id: "ei-2-2-23", da: "Improve data access APIs."
                   },
                   {
                    id: "ei-2-2-24", da: "Develop a user-friendly dashboard interface."
                   },
                   {
                    id: "ei-2-2-25", da: "Implement data validation rules."
                   },
                   {
                    id: "ei-2-2-26", da: "Enhance data redundancy and backup systems."
                   },
                   {
                    id: "ei-2-2-27", da: "Improve data governance and compliance."
                   },
                   {
                    id: "ei-2-2-28", da: "Develop data cleansing and transformation tools."
                   },
                   {
                    id: "ei-2-2-29", da: "Implement data streaming technologies."
                   },
                   {
                    id: "ei-2-2-30", da: "Enhance data privacy measures."
                   },
                   {
                    id: "ei-2-2-31", da: "Develop customized data analytics tools."
                   },
                   {
                    id: "ei-2-2-32", da: "Implement blockchain for data traceability."
                   },
                   {
                    id: "ei-2-2-33", da: "Improve data labeling and annotation."
                   },
                   {
                    id: "ei-2-2-34", da: "Develop automated data collection workflows."
                   },
                   {
                    id: "ei-2-2-35", da: "Implement data version control systems."
                   },
                   {
                    id: "ei-2-2-36", da: "Enhance data accessibility for users with disabilities."
                   },
                   {
                    id: "ei-2-2-37", da: "Improve user authentication and authorization systems."
                   },
                   {
                    id: "ei-2-2-38", da: "Develop data audit and tracking mechanisms."
                   },
                   {
                    id: "ei-2-2-39", da: "Implement data archiving and retention policies."
                   },
                   {
                    id: "ei-2-2-40", da: "Enhance data cataloging and metadata management."
                   },
                   {
                    id: "ei-2-2-41", da: "Develop automated reporting and alerting systems."
                   },
                   {
                    id: "ei-2-2-42", da: "Improve data monitoring and logging."
                   },
                   {
                    id: "ei-2-2-43", da: "Implement data migration tools."
                   },
                   {
                    id: "ei-2-2-44", da: "Enhance data backup and disaster recovery plans."
                   },
                   {
                    id: "ei-2-2-45", da: "Develop data lifecycle management strategies."
                   },
                   {
                    id: "ei-2-2-46", da: "Implement federated data querying."
                   },
                   {
                    id: "ei-2-2-47", da: "Improve data classification and tagging."
                   },
                   {
                    id: "ei-2-2-48", da: "Enhance data virtualization solutions."
                   },
                   {
                    id: "ei-2-2-49", da: "Develop data usage analytics and reporting."
                   },
                ]
              },
              {
                id: 'ei-2-3',
                pm: 'Team can publish the results of their research and seek citations.',
                title:'Value',
                pmMap: 'Team can publish the results of their research and seek citations.',
                developmentActions:[
                  {
                    id: "ei-2-3-0", da: "Conduct a thorough ecosystem analysis."
                   },
                   {
                    id: "ei-2-3-1", da: "Identify key ecosystem stakeholders."
                   },
                   {
                    id: "ei-2-3-2", da: "Develop a clear value proposition."
                   },
                   {
                    id: "ei-2-3-3", da: "Enhance communication with ecosystem participants."
                   },
                   {
                    id: "ei-2-3-4", da: "Establish a feedback mechanism for participants."
                   },
                   {
                    id: "ei-2-3-5", da: "Foster collaboration among ecosystem members."
                   },
                   {
                    id: "ei-2-3-6", da: "Define clear roles and responsibilities for ecosystem partners."
                   },
                   {
                    id: "ei-2-3-7", da: "Invest in data analytics and insights."
                   },
                   {
                    id: "ei-2-3-8", da: "Implement data-driven decision-making."
                   },
                   {
                    id: "ei-2-3-9", da: "Regularly assess ecosystem health."
                   },
                   {
                    id: "ei-2-3-10", da: "Identify and nurture ecosystem champions."
                   },
                   {
                    id: "ei-2-3-11", da: "Provide ecosystem education and training."
                   },
                   {
                    id: "ei-2-3-12", da: "Streamline onboarding processes for new ecosystem participants."
                   },
                   {
                    id: "ei-2-3-13", da: "Optimize resource allocation within the ecosystem."
                   },
                   {
                    id: "ei-2-3-14", da: "Explore new partnership opportunities."
                   },
                   {
                    id: "ei-2-3-15", da: "Create a central hub for ecosystem resources."
                   },
                   {
                    id: "ei-2-3-16", da: "Ensure data security and privacy."
                   },
                   {
                    id: "ei-2-3-17", da: "Foster a culture of innovation within the ecosystem."
                   },
                   {
                    id: "ei-2-3-18", da: "Develop joint marketing initiatives."
                   },
                   {
                    id: "ei-2-3-19", da: "Establish trust-building initiatives."
                   },
                   {
                    id: "ei-2-3-20", da: "Create KPIs for ecosystem performance."
                   },
                   {
                    id: "ei-2-3-21", da: "Provide incentives for ecosystem participants."
                   },
                   {
                    id: "ei-2-3-22", da: "Align ecosystem goals with the organization's strategic objectives."
                   },
                   {
                    id: "ei-2-3-23", da: "Segment the ecosystem for targeted actions."
                   },
                   {
                    id: "ei-2-3-24", da: "Promote diversity and inclusion within the ecosystem."
                   },
                   {
                    id: "ei-2-3-25", da: "Facilitate cross-functional working groups."
                   },
                   {
                    id: "ei-2-3-26", da: "Implement ecosystem governance and policies."
                   },
                   {
                    id: "ei-2-3-27", da: "Monitor and manage ecosystem risks."
                   },
                   {
                    id: "ei-2-3-28", da: "Develop a long-term ecosystem roadmap."
                   },
                   {
                    id: "ei-2-3-29", da: "Regularly update the ecosystem's value proposition."
                   },
                   {
                    id: "ei-2-3-30", da: "Collect and share best practices within the ecosystem."
                   },
                   {
                    id: "ei-2-3-31", da: "Leverage emerging technologies for ecosystem growth."
                   },
                   {
                    id: "ei-2-3-32", da: "Expand the ecosystem through strategic acquisitions."
                   },
                   {
                    id: "ei-2-3-33", da: "Foster an entrepreneurial mindset among ecosystem participants."
                   },
                   {
                    id: "ei-2-3-34", da: "Offer support for ecosystem innovation projects."
                   },
                   {
                    id: "ei-2-3-35", da: "Measure and report on ecosystem outcomes."
                   },
                   {
                    id: "ei-2-3-36", da: "Promote ecosystem sustainability."
                   },
                   {
                    id: "ei-2-3-37", da: "Conduct periodic ecosystem surveys."
                   },
                   {
                    id: "ei-2-3-38", da: "Create opportunities for ecosystem co-creation."
                   },
                   {
                    id: "ei-2-3-39", da: "Develop a knowledge-sharing platform."
                   },
                   {
                    id: "ei-2-3-40", da: "Enhance customer support and service within the ecosystem."
                   },
                   {
                    id: "ei-2-3-41", da: "Address any ecosystem pain points promptly."
                   },
                   {
                    id: "ei-2-3-42", da: "Enable ecosystem participants to self-serve where possible."
                   },
                   {
                    id: "ei-2-3-43", da: "Consider ecosystem-specific pricing strategies."
                   },
                   {
                    id: "ei-2-3-44", da: "Provide ecosystem networking opportunities."
                   },
                   {
                    id: "ei-2-3-45", da: "Develop a clear exit strategy for ecosystem participants."
                   },
                   {
                    id: "ei-2-3-46", da: "Promote ecosystem branding and awareness."
                   },
                   {
                    id: "ei-2-3-47", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "ei-2-3-48", da: "Encourage ecosystem participants to provide testimonials and case studies."
                   },
                   {
                    id: "ei-2-3-49", da: "Celebrate ecosystem successes and milestones."
                   },
                ]
              },
              {
                id: 'ei-2-4',
                pm: 'Clear understanding of cost points and revenue targets to reach positive unit economics.',
                title:'Business Model',
                pmMap: 'Clear understanding of cost points and revenue targets to reach positive unit economics.',
                developmentActions:[
                  {
                    id: "ei-2-4-0", da: "Identify key ecosystem partners that can enhance your business model."
                   },
                   {
                    id: "ei-2-4-1", da: "Analyze how ecosystem data can improve your product offerings."
                   },
                   {
                    id: "ei-2-4-2", da: "Consider co-creation with ecosystem partners for new products or services."
                   },
                   {
                    id: "ei-2-4-3", da: "Evaluate the impact of ecosystem intelligence on pricing strategies."
                   },
                   {
                    id: "ei-2-4-4", da: "Investigate how ecosystem insights can lead to better customer segmentation."
                   },
                   {
                    id: "ei-2-4-5", da: "Explore opportunities for ecosystem-driven innovation."
                   },
                   {
                    id: "ei-2-4-6", da: "Assess how ecosystem data can improve demand forecasting."
                   },
                   {
                    id: "ei-2-4-7", da: "Consider the role of ecosystems in reducing operational costs."
                   },
                   {
                    id: "ei-2-4-8", da: "Evaluate the potential for ecosystem-driven marketing campaigns."
                   },
                   {
                    id: "ei-2-4-9", da: "Analyze how ecosystem insights can enhance customer experience."
                   },
                   {
                    id: "ei-2-4-10", da: "Explore partnerships to expand your distribution channels."
                   },
                   {
                    id: "ei-2-4-11", da: "Assess the impact of ecosystem intelligence on supply chain optimization."
                   },
                   {
                    id: "ei-2-4-12", da: "Consider ecosystem data for risk management and fraud prevention."
                   },
                   {
                    id: "ei-2-4-13", da: "Evaluate ecosystem intelligence for talent acquisition and management."
                   },
                   {
                    id: "ei-2-4-14", da: "Explore the role of ecosystems in enhancing regulatory compliance."
                   },
                   {
                    id: "ei-2-4-15", da: "Analyze how ecosystems can lead to competitive advantage."
                   },
                   {
                    id: "ei-2-4-16", da: "Assess the impact of ecosystem data on product customization."
                   },
                   {
                    id: "ei-2-4-17", da: "Investigate opportunities for ecosystem-driven sustainability initiatives."
                   },
                   {
                    id: "ei-2-4-18", da: "Consider the role of ecosystems in geographic expansion."
                   },
                   {
                    id: "ei-2-4-19", da: "Explore how ecosystem intelligence can drive process automation."
                   },
                   {
                    id: "ei-2-4-20", da: "Assess the impact of ecosystems on brand reputation and trust."
                   },
                   {
                    id: "ei-2-4-21", da: "Investigate ecosystem-driven diversification strategies."
                   },
                   {
                    id: "ei-2-4-22", da: "Evaluate the potential for ecosystem partnerships to access new markets."
                   },
                   {
                    id: "ei-2-4-23", da: "Analyze the role of ecosystems in enhancing customer retention."
                   },
                   {
                    id: "ei-2-4-24", da: "Consider how ecosystem data can lead to data monetization opportunities."
                   },
                   {
                    id: "ei-2-4-25", da: "Assess the impact of ecosystem intelligence on customer lifetime value."
                   },
                   {
                    id: "ei-2-4-26", da: "Explore the role of ecosystems in enhancing cross-selling and upselling."
                   },
                   {
                    id: "ei-2-4-27", da: "Investigate ecosystem-driven cost reduction initiatives."
                   },
                   {
                    id: "ei-2-4-28", da: "Analyze how ecosystems can lead to improved product lifecycle management."
                   },
                   {
                    id: "ei-2-4-29", da: "Consider ecosystem data for better decision-making and strategy."
                   },
                   {
                    id: "ei-2-4-30", da: "Evaluate the potential for ecosystem-driven product bundling."
                   },
                   {
                    id: "ei-2-4-31", da: "Assess the impact of ecosystem intelligence on resource allocation."
                   },
                   {
                    id: "ei-2-4-32", da: "Investigate the role of ecosystems in reducing customer acquisition costs."
                   },
                   {
                    id: "ei-2-4-33", da: "Explore opportunities for ecosystem-driven innovation contests."
                   },
                   {
                    id: "ei-2-4-34", da: "Analyze how ecosystem data can lead to improved customer onboarding."
                   },
                   {
                    id: "ei-2-4-35", da: "Consider ecosystem intelligence for crisis management and resilience."
                   },
                   {
                    id: "ei-2-4-36", da: "Assess the impact of ecosystems on intellectual property management."
                   },
                   {
                    id: "ei-2-4-37", da: "Investigate how ecosystems can lead to strategic partnerships."
                   },
                   {
                    id: "ei-2-4-38", da: "Explore the role of ecosystems in market research and insights."
                   },
                   {
                    id: "ei-2-4-39", da: "Analyze the potential for ecosystem-driven product testing."
                   },
                   {
                    id: "ei-2-4-40", da: "Evaluate the impact of ecosystem intelligence on customer feedback."
                   },
                   {
                    id: "ei-2-4-41", da: "Consider ecosystem data for better inventory management."
                   },
                   {
                    id: "ei-2-4-42", da: "Assess the role of ecosystems in enhancing employee engagement."
                   },
                   {
                    id: "ei-2-4-43", da: "Investigate ecosystem-driven employee training and development."
                   },
                   {
                    id: "ei-2-4-44", da: "Explore how ecosystems can lead to cost-effective R&D."
                   },
                   {
                    id: "ei-2-4-45", da: "Analyze the impact of ecosystem intelligence on mergers and acquisitions."
                   },
                   {
                    id: "ei-2-4-46", da: "Consider the potential for ecosystem-driven product roadmaps."
                   },
                   {
                    id: "ei-2-4-47", da: "Assess the role of ecosystems in enhancing customer support."
                   },
                   {
                    id: "ei-2-4-48", da: "Investigate opportunities for ecosystem-driven gamification strategies."
                   },
                   {
                    id: "ei-2-4-49", da: "Analyze how ecosystem data can lead to more informed business model decisions."
                   },
                ]
              },
              {
                id: 'ei-2-5',
                pm: 'Initial evidence for correct positioning in the market.',
                title:'Go to Market',
                pmMap: 'Initial evidence for correct positioning in the market.',
                developmentActions:[
                  {
                    id: "ei-2-5-0", da: "Conduct a comprehensive market analysis to identify emerging trends and opportunities."
                   },
                   {
                    id: "ei-2-5-1", da: "Define and segment target markets for Ecosystem Intelligence solutions."
                   },
                   {
                    id: "ei-2-5-2", da: "Develop customer personas to better understand your audience."
                   },
                   {
                    id: "ei-2-5-3", da: "Enhance product positioning based on customer pain points."
                   },
                   {
                    id: "ei-2-5-4", da: "Create a content marketing strategy to educate your target audience."
                   },
                   {
                    id: "ei-2-5-5", da: "Establish a clear value proposition for your Ecosystem Intelligence offerings."
                   },
                   {
                    id: "ei-2-5-6", da: "Conduct competitive analysis to identify your unique selling points."
                   },
                   {
                    id: "ei-2-5-7", da: "Develop a pricing strategy that aligns with market expectations."
                   },
                   {
                    id: "ei-2-5-8", da: "Expand sales and distribution channels to reach a broader audience."
                   },
                   {
                    id: "ei-2-5-9", da: "Implement lead generation campaigns to build a robust sales pipeline."
                   },
                   {
                    id: "ei-2-5-10", da: "Enhance your website to serve as a lead generation tool."
                   },
                   {
                    id: "ei-2-5-11", da: "Invest in search engine optimization (SEO) to improve online visibility."
                   },
                   {
                    id: "ei-2-5-12", da: "Create case studies and success stories to showcase the value of Ecosystem Intelligence."
                   },
                   {
                    id: "ei-2-5-13", da: "Leverage social media platforms for brand building and audience engagement."
                   },
                   {
                    id: "ei-2-5-14", da: "Develop partnerships with industry influencers to extend your reach."
                   },
                   {
                    id: "ei-2-5-15", da: "Invest in customer relationship management (CRM) systems for improved customer engagement."
                   },
                   {
                    id: "ei-2-5-16", da: "Optimize your sales funnel to increase conversion rates."
                   },
                   {
                    id: "ei-2-5-17", da: "Offer free trials or demos to let customers experience your solutions."
                   },
                   {
                    id: "ei-2-5-18", da: "Develop a customer onboarding process to ensure seamless product adoption."
                   },
                   {
                    id: "ei-2-5-19", da: "Provide exceptional customer support and training resources."
                   },
                   {
                    id: "ei-2-5-20", da: "Implement data analytics tools for real-time insights into customer behavior."
                   },
                   {
                    id: "ei-2-5-21", da: "Expand into new geographic markets to reach a global audience."
                   },
                   {
                    id: "ei-2-5-22", da: "Conduct market-specific research for localization and customization."
                   },
                   {
                    id: "ei-2-5-23", da: "Consider strategic acquisitions to enter adjacent markets."
                   },
                   {
                    id: "ei-2-5-24", da: "Develop a referral program to incentivize customer advocacy."
                   },
                   {
                    id: "ei-2-5-25", da: "Create targeted email marketing campaigns for different customer segments."
                   },
                   {
                    id: "ei-2-5-26", da: "Implement account-based marketing strategies for key clients."
                   },
                   {
                    id: "ei-2-5-27", da: "Leverage webinars and virtual events to engage prospects."
                   },
                   {
                    id: "ei-2-5-28", da: "Attend industry conferences and trade shows to network and showcase your solutions."
                   },
                   {
                    id: "ei-2-5-29", da: "Offer flexible licensing options to cater to diverse customer needs."
                   },
                   {
                    id: "ei-2-5-30", da: "Implement agile product development processes for quicker iterations."
                   },
                   {
                    id: "ei-2-5-31", da: "Monitor customer feedback and use it for continuous product improvement."
                   },
                   {
                    id: "ei-2-5-32", da: "Develop a crisis communication plan for unexpected challenges."
                   },
                   {
                    id: "ei-2-5-33", da: "Engage in thought leadership by publishing whitepapers and industry reports."
                   },
                   {
                    id: "ei-2-5-34", da: "Develop sales collateral, including brochures and product sheets."
                   },
                   {
                    id: "ei-2-5-35", da: "Establish key performance indicators (KPIs) to measure GTM success."
                   },
                   {
                    id: "ei-2-5-36", da: "Create a sales playbook to standardize selling processes."
                   },
                   {
                    id: "ei-2-5-37", da: "Leverage marketing automation tools for lead nurturing."
                   },
                   {
                    id: "ei-2-5-38", da: "Ensure that your sales and marketing teams are aligned in their efforts."
                   },
                   {
                    id: "ei-2-5-39", da: "Implement customer segmentation for personalized marketing."
                   },
                   {
                    id: "ei-2-5-40", da: "Engage with industry associations and communities for networking."
                   },
                   {
                    id: "ei-2-5-41", da: "Develop a customer feedback loop for product feature enhancements."
                   },
                   {
                    id: "ei-2-5-42", da: "Analyze pricing strategies to remain competitive."
                   },
                   {
                    id: "ei-2-5-43", da: "Optimize your supply chain for better product availability."
                   },
                   {
                    id: "ei-2-5-44", da: "Foster strategic alliances with complementary technology providers."
                   },
                   {
                    id: "ei-2-5-45", da: "Invest in data security and compliance to build trust with customers."
                   },
                   {
                    id: "ei-2-5-46", da: "Develop a crisis response plan to handle unforeseen challenges."
                   },
                   {
                    id: "ei-2-5-47", da: "Create a continuous improvement culture within your organization."
                   },
                   {
                    id: "ei-2-5-48", da: "Monitor and adapt to evolving customer needs and market dynamics."
                   },
                   {
                    id: "ei-2-5-49", da: "Conduct regular performance reviews and make adjustments as needed."
                   },
                ]
              },
              {
                id: 'ei-2-6',
                pm: 'Team has proven to be able to work together, move fast, break things and deliver great results.',
                title:'People',
                pmMap: 'Team has proven to be able to work together, move fast, break things and deliver great results.',
                developmentActions:[
                  {
                    id: "ei-2-6-0", da: "Implement a mentorship program for knowledge transfer."
                   },
                   {
                    id: "ei-2-6-1", da: "Provide regular training sessions for employees."
                   },
                   {
                    id: "ei-2-6-2", da: "Encourage cross-functional team collaboration."
                   },
                   {
                    id: "ei-2-6-3", da: "Establish a clear career development path."
                   },
                   {
                    id: "ei-2-6-4", da: "Foster a culture of continuous learning."
                   },
                   {
                    id: "ei-2-6-5", da: "Conduct regular skill gap assessments."
                   },
                   {
                    id: "ei-2-6-6", da: "Promote diversity and inclusion initiatives."
                   },
                   {
                    id: "ei-2-6-7", da: "Develop leadership training programs."
                   },
                   {
                    id: "ei-2-6-8", da: "Recognize and reward employee achievements."
                   },
                   {
                    id: "ei-2-6-9", da: "Encourage open and honest communication."
                   },
                   {
                    id: "ei-2-6-10", da: "Create opportunities for employees to attend industry conferences."
                   },
                   {
                    id: "ei-2-6-11", da: "Offer flexible work arrangements."
                   },
                   {
                    id: "ei-2-6-12", da: "Provide access to educational resources."
                   },
                   {
                    id: "ei-2-6-13", da: "Conduct regular performance evaluations."
                   },
                   {
                    id: "ei-2-6-14", da: "Encourage knowledge sharing through internal wikis."
                   },
                   {
                    id: "ei-2-6-15", da: "Establish a wellness program to support employee health."
                   },
                   {
                    id: "ei-2-6-16", da: "Offer financial wellness workshops."
                   },
                   {
                    id: "ei-2-6-17", da: "Create cross-training opportunities."
                   },
                   {
                    id: "ei-2-6-18", da: "Implement a feedback mechanism for employees."
                   },
                   {
                    id: "ei-2-6-19", da: "Develop a strong onboarding process for new hires."
                   },
                   {
                    id: "ei-2-6-20", da: "Support professional certifications."
                   },
                   {
                    id: "ei-2-6-21", da: "Promote work-life balance."
                   },
                   {
                    id: "ei-2-6-22", da: "Foster a culture of innovation and experimentation."
                   },
                   {
                    id: "ei-2-6-23", da: "Encourage employees to pursue higher education."
                   },
                   {
                    id: "ei-2-6-24", da: "Recognize and celebrate cultural diversity."
                   },
                   {
                    id: "ei-2-6-25", da: "Provide resources for stress management."
                   },
                   {
                    id: "ei-2-6-26", da: "Offer opportunities for employees to attend workshops and seminars."
                   },
                   {
                    id: "ei-2-6-27", da: "Support team-building activities."
                   },
                   {
                    id: "ei-2-6-28", da: "Encourage employees to take ownership of projects."
                   },
                   {
                    id: "ei-2-6-29", da: "Implement knowledge-sharing tools and platforms."
                   },
                   {
                    id: "ei-2-6-30", da: "Develop a code of conduct for a positive workplace culture."
                   },
                   {
                    id: "ei-2-6-31", da: "Promote a sense of purpose and meaning in work."
                   },
                   {
                    id: "ei-2-6-32", da: "Create a clear organizational structure."
                   },
                   {
                    id: "ei-2-6-33", da: "Provide opportunities for skill-specific projects."
                   },
                   {
                    id: "ei-2-6-34", da: "Offer leadership development programs."
                   },
                   {
                    id: "ei-2-6-35", da: "Conduct regular team-building exercises."
                   },
                   {
                    id: "ei-2-6-36", da: "Establish feedback loops for continuous improvement."
                   },
                   {
                    id: "ei-2-6-37", da: "Recognize and celebrate work anniversaries."
                   },
                   {
                    id: "ei-2-6-38", da: "Encourage employees to attend industry meetups."
                   },
                   {
                    id: "ei-2-6-39", da: "Promote a healthy work environment."
                   },
                   {
                    id: "ei-2-6-40", da: "Foster a culture of empathy and understanding."
                   },
                   {
                    id: "ei-2-6-41", da: "Provide opportunities for volunteering and community engagement."
                   },
                   {
                    id: "ei-2-6-42", da: "Establish a diversity and inclusion committee."
                   },
                   {
                    id: "ei-2-6-43", da: "Encourage public speaking and presentation skills."
                   },
                   {
                    id: "ei-2-6-44", da: "Promote a culture of adaptability."
                   },
                   {
                    id: "ei-2-6-45", da: "Offer opportunities for employees to attend leadership conferences."
                   },
                   {
                    id: "ei-2-6-46", da: "Develop a strong employee referral program."
                   },
                   {
                    id: "ei-2-6-47", da: "Provide resources for conflict resolution and mediation."
                   },
                   {
                    id: "ei-2-6-48", da: "Support professional development associations."
                   },
                   {
                    id: "ei-2-6-49", da: "Create a culture of trust and empowerment."
                   },
                ]
              },
              {
                id: 'ei-2-7',
                pm: 'The funnel can track users success rate and drop-offs.',
                title:'Data Metrics',
                pmMap: 'The funnel can track users success rate and drop-offs.',
                developmentActions:[
                  {
                    id: "ei-2-7-0", da: "Identify Key Performance Indicators (KPIs) that align with business goals."
                   },
                   {
                    id: "ei-2-7-1", da: "Implement data governance to ensure data quality."
                   },
                   {
                    id: "ei-2-7-2", da: "Conduct regular data audits to identify discrepancies."
                   },
                   {
                    id: "ei-2-7-3", da: "Establish a data dictionary for standardized terminology."
                   },
                   {
                    id: "ei-2-7-4", da: "Enhance data collection methods for accuracy."
                   },
                   {
                    id: "ei-2-7-5", da: "Implement data validation rules to catch errors."
                   },
                   {
                    id: "ei-2-7-6", da: "Develop data entry guidelines for consistency."
                   },
                   {
                    id: "ei-2-7-7", da: "Invest in data integration to connect disparate data sources."
                   },
                   {
                    id: "ei-2-7-8", da: "Utilize data profiling tools to discover data anomalies."
                   },
                   {
                    id: "ei-2-7-9", da: "Implement data cleansing processes."
                   },
                   {
                    id: "ei-2-7-10", da: "Employ data enrichment services for more comprehensive data."
                   },
                   {
                    id: "ei-2-7-11", da: "Create a data roadmap to guide data initiatives."
                   },
                   {
                    id: "ei-2-7-12", da: "Invest in data visualization tools for better insights."
                   },
                   {
                    id: "ei-2-7-13", da: "Establish data security and access controls."
                   },
                   {
                    id: "ei-2-7-14", da: "Monitor data usage to detect unauthorized access."
                   },
                   {
                    id: "ei-2-7-15", da: "Develop a disaster recovery plan for data loss prevention."
                   },
                   {
                    id: "ei-2-7-16", da: "Implement a data retention policy to manage data lifecycle."
                   },
                   {
                    id: "ei-2-7-17", da: "Explore machine learning for predictive analytics."
                   },
                   {
                    id: "ei-2-7-18", da: "Employ data compression techniques for storage efficiency."
                   },
                   {
                    id: "ei-2-7-19", da: "Develop a data backup and recovery strategy."
                   },
                   {
                    id: "ei-2-7-20", da: "Investigate data deduplication methods."
                   },
                   {
                    id: "ei-2-7-21", da: "Explore data anonymization for privacy compliance."
                   },
                   {
                    id: "ei-2-7-22", da: "Invest in data encryption methods for security."
                   },
                   {
                    id: "ei-2-7-23", da: "Develop data governance policies and procedures."
                   },
                   {
                    id: "ei-2-7-24", da: "Create a data governance council for oversight."
                   },
                   {
                    id: "ei-2-7-25", da: "Implement data lineage tracking for traceability."
                   },
                   {
                    id: "ei-2-7-26", da: "Utilize master data management (MDM) for data consistency."
                   },
                   {
                    id: "ei-2-7-27", da: "Develop a data quality scorecard."
                   },
                   {
                    id: "ei-2-7-28", da: "Implement data profiling tools to understand data patterns."
                   },
                   {
                    id: "ei-2-7-29", da: "Use data correlation analysis for insights."
                   },
                   {
                    id: "ei-2-7-30", da: "Employ data segmentation to target specific audiences."
                   },
                   {
                    id: "ei-2-7-31", da: "Investigate data modeling for better understanding."
                   },
                   {
                    id: "ei-2-7-32", da: "Implement a data monitoring solution for real-time insights."
                   },
                   {
                    id: "ei-2-7-33", da: "Utilize data warehousing for central data storage."
                   },
                   {
                    id: "ei-2-7-34", da: "Develop data transformation processes."
                   },
                   {
                    id: "ei-2-7-35", da: "Create data reporting templates."
                   },
                   {
                    id: "ei-2-7-36", da: "Employ data mining techniques to discover trends."
                   },
                   {
                    id: "ei-2-7-37", da: "Investigate data validation rules for data entry."
                   },
                   {
                    id: "ei-2-7-38", da: "Implement data quality checks at data ingestion points."
                   },
                   {
                    id: "ei-2-7-39", da: "Develop data dashboards for easy monitoring."
                   },
                   {
                    id: "ei-2-7-40", da: "Utilize A\/B testing for data-driven decisions."
                   },
                   {
                    id: "ei-2-7-41", da: "Implement data archiving for historical data."
                   },
                   {
                    id: "ei-2-7-42", da: "Explore data streaming for real-time data processing."
                   },
                   {
                    id: "ei-2-7-43", da: "Develop data extraction methods for analysis."
                   },
                   {
                    id: "ei-2-7-44", da: "Employ data classification for sensitive data protection."
                   },
                   {
                    id: "ei-2-7-45", da: "Investigate data cataloging for data discovery."
                   },
                   {
                    id: "ei-2-7-46", da: "Implement data lineage tools to trace data sources."
                   },
                   {
                    id: "ei-2-7-47", da: "Utilize data curation for data organization."
                   },
                   {
                    id: "ei-2-7-48", da: "Develop data visualization standards."
                   },
                   {
                    id: "ei-2-7-49", da: "Employ data storytelling techniques for effective communication."
                   },
                ]
              },
              {
                id: 'ei-2-8',
                pm: 'Operations work and are validated with few early successes.',
                title:'Operations',
                pmMap: 'Operations work and are validated with few early successes.',
                developmentActions:[
                  {
                    id: "ei-2-8-0", da: "Implement a comprehensive performance review system."
                   },
                   {
                    id: "ei-2-8-1", da: "Streamline and automate repetitive tasks."
                   },
                   {
                    id: "ei-2-8-2", da: "Improve supply chain management."
                   },
                   {
                    id: "ei-2-8-3", da: "Enhance inventory control and tracking."
                   },
                   {
                    id: "ei-2-8-4", da: "Develop and implement standardized operating procedures."
                   },
                   {
                    id: "ei-2-8-5", da: "Invest in employee training and development."
                   },
                   {
                    id: "ei-2-8-6", da: "Optimize production processes."
                   },
                   {
                    id: "ei-2-8-7", da: "Enhance quality control measures."
                   },
                   {
                    id: "ei-2-8-8", da: "Improve vendor management and relationships."
                   },
                   {
                    id: "ei-2-8-9", da: "Increase data security and privacy measures."
                   },
                   {
                    id: "ei-2-8-10", da: "Invest in technology upgrades and digital transformation."
                   },
                   {
                    id: "ei-2-8-11", da: "Develop a disaster recovery and business continuity plan."
                   },
                   {
                    id: "ei-2-8-12", da: "Enhance customer relationship management (CRM) systems."
                   },
                   {
                    id: "ei-2-8-13", da: "Increase sustainability and eco-friendly initiatives."
                   },
                   {
                    id: "ei-2-8-14", da: "Implement a more efficient project management system."
                   },
                   {
                    id: "ei-2-8-15", da: "Foster a culture of innovation and creativity."
                   },
                   {
                    id: "ei-2-8-16", da: "Strengthen internal communication and collaboration."
                   },
                   {
                    id: "ei-2-8-17", da: "Streamline decision-making processes."
                   },
                   {
                    id: "ei-2-8-18", da: "Conduct regular cost-benefit analysis."
                   },
                   {
                    id: "ei-2-8-19", da: "Improve financial planning and budgeting."
                   },
                   {
                    id: "ei-2-8-20", da: "Enhance risk management strategies."
                   },
                   {
                    id: "ei-2-8-21", da: "Implement a feedback mechanism for employees."
                   },
                   {
                    id: "ei-2-8-22", da: "Enhance workplace safety measures."
                   },
                   {
                    id: "ei-2-8-23", da: "Expand marketing efforts and brand awareness."
                   },
                   {
                    id: "ei-2-8-24", da: "Optimize the use of data analytics."
                   },
                   {
                    id: "ei-2-8-25", da: "Strengthen compliance with industry regulations."
                   },
                   {
                    id: "ei-2-8-26", da: "Enhance scalability and flexibility."
                   },
                   {
                    id: "ei-2-8-27", da: "Develop a clear and actionable growth strategy."
                   },
                   {
                    id: "ei-2-8-28", da: "Improve customer support and service."
                   },
                   {
                    id: "ei-2-8-29", da: "Optimize asset management."
                   },
                   {
                    id: "ei-2-8-30", da: "Foster a diverse and inclusive workplace."
                   },
                   {
                    id: "ei-2-8-31", da: "Strengthen leadership and management skills."
                   },
                   {
                    id: "ei-2-8-32", da: "Invest in energy efficiency initiatives."
                   },
                   {
                    id: "ei-2-8-33", da: "Improve time management and productivity tools."
                   },
                   {
                    id: "ei-2-8-34", da: "Optimize document and knowledge management."
                   },
                   {
                    id: "ei-2-8-35", da: "Enhance procurement and sourcing strategies."
                   },
                   {
                    id: "ei-2-8-36", da: "Invest in IT infrastructure and cybersecurity."
                   },
                   {
                    id: "ei-2-8-37", da: "Optimize customer feedback analysis."
                   },
                   {
                    id: "ei-2-8-38", da: "Strengthen strategic partnerships."
                   },
                   {
                    id: "ei-2-8-39", da: "Develop a succession plan for key roles."
                   },
                   {
                    id: "ei-2-8-40", da: "Increase marketing personalization efforts."
                   },
                   {
                    id: "ei-2-8-41", da: "Optimize website and online presence."
                   },
                   {
                    id: "ei-2-8-42", da: "Foster a customer-centric culture."
                   },
                   {
                    id: "ei-2-8-43", da: "Enhance the onboarding and training process for new employees."
                   },
                   {
                    id: "ei-2-8-44", da: "Invest in cloud computing solutions."
                   },
                   {
                    id: "ei-2-8-45", da: "Improve dispute resolution mechanisms."
                   },
                   {
                    id: "ei-2-8-46", da: "Enhance innovation through R&D initiatives."
                   },
                   {
                    id: "ei-2-8-47", da: "Strengthen ethics and compliance programs."
                   },
                   {
                    id: "ei-2-8-48", da: "Conduct regular SWOT analysis."
                   },
                   {
                    id: "ei-2-8-49", da: "Implement a continuous improvement culture."
                   },
                ]
              },
              {
                id: 'ei-2-9',
                pm: 'Conducted pilots that are shown as use-cases to investors. Relationship building with angel investors started.',
                title:'Exit Strategy',
                pmMap: 'Conducted pilots that are shown as use-cases to investors. Relationship building with angel investors started.',
                developmentActions:[
                  {
                    id: "ei-2-9-0", da: "Review the overall market conditions and trends."
                   },
                   {
                    id: "ei-2-9-1", da: "Analyze the financial health of the business."
                   },
                   {
                    id: "ei-2-9-2", da: "Consider potential acquirers or investors."
                   },
                   {
                    id: "ei-2-9-3", da: "Determine the optimal timing for an exit."
                   },
                   {
                    id: "ei-2-9-4", da: "Assess the competitive landscape."
                   },
                   {
                    id: "ei-2-9-5", da: "Identify any potential legal or regulatory hurdles."
                   },
                   {
                    id: "ei-2-9-6", da: "Explore different exit options, such as acquisition or IPO."
                   },
                   {
                    id: "ei-2-9-7", da: "Evaluate the intellectual property portfolio."
                   },
                   {
                    id: "ei-2-9-8", da: "Assess the scalability of the business."
                   },
                   {
                    id: "ei-2-9-9", da: "Review the current team and their roles in the exit."
                   },
                   {
                    id: "ei-2-9-10", da: "Examine potential risks associated with the exit."
                   },
                   {
                    id: "ei-2-9-11", da: "Consider the impact on employees."
                   },
                   {
                    id: "ei-2-9-12", da: "Assess the cultural fit with potential acquirers."
                   },
                   {
                    id: "ei-2-9-13", da: "Evaluate customer relationships and contracts."
                   },
                   {
                    id: "ei-2-9-14", da: "Review financial projections."
                   },
                   {
                    id: "ei-2-9-15", da: "Examine the company's valuation."
                   },
                   {
                    id: "ei-2-9-16", da: "Assess the readiness of the management team."
                   },
                   {
                    id: "ei-2-9-17", da: "Consider the impact on shareholders."
                   },
                   {
                    id: "ei-2-9-18", da: "Review the due diligence process."
                   },
                   {
                    id: "ei-2-9-19", da: "Analyze potential tax implications."
                   },
                   {
                    id: "ei-2-9-20", da: "Consider post-exit roles for key team members."
                   },
                   {
                    id: "ei-2-9-21", da: "Evaluate the need for legal and financial advisors."
                   },
                   {
                    id: "ei-2-9-22", da: "Examine the impact on company culture."
                   },
                   {
                    id: "ei-2-9-23", da: "Consider the timing of external financing."
                   },
                   {
                    id: "ei-2-9-24", da: "Assess potential synergies with acquirers."
                   },
                   {
                    id: "ei-2-9-25", da: "Review customer retention strategies."
                   },
                   {
                    id: "ei-2-9-26", da: "Examine the potential impact on brand reputation."
                   },
                   {
                    id: "ei-2-9-27", da: "Consider the need for rebranding or repositioning."
                   },
                   {
                    id: "ei-2-9-28", da: "Evaluate potential earn-outs or performance-based incentives."
                   },
                   {
                    id: "ei-2-9-29", da: "Examine potential non-compete agreements."
                   },
                   {
                    id: "ei-2-9-30", da: "Consider the impact on suppliers and partners."
                   },
                   {
                    id: "ei-2-9-31", da: "Evaluate potential integration challenges."
                   },
                   {
                    id: "ei-2-9-32", da: "Assess the impact on company morale."
                   },
                   {
                    id: "ei-2-9-33", da: "Review the need for data migration and IT infrastructure changes."
                   },
                   {
                    id: "ei-2-9-34", da: "Consider the impact on product development."
                   },
                   {
                    id: "ei-2-9-35", da: "Evaluate potential communication strategies for stakeholders."
                   },
                   {
                    id: "ei-2-9-36", da: "Examine the impact on supply chain management."
                   },
                   {
                    id: "ei-2-9-37", da: "Assess potential restructuring or layoffs."
                   },
                   {
                    id: "ei-2-9-38", da: "Review the need for post-exit support for customers."
                   },
                   {
                    id: "ei-2-9-39", da: "Consider potential challenges in retaining key customers."
                   },
                   {
                    id: "ei-2-9-40", da: "Evaluate the need for employee training during the transition."
                   },
                   {
                    id: "ei-2-9-41", da: "Examine the impact on vendor relationships."
                   },
                   {
                    id: "ei-2-9-42", da: "Consider the potential impact on distribution channels."
                   },
                   {
                    id: "ei-2-9-43", da: "Assess potential changes in pricing and revenue models."
                   },
                   {
                    id: "ei-2-9-44", da: "Review the need for crisis management and contingency plans."
                   },
                   {
                    id: "ei-2-9-45", da: "Consider the impact on intellectual property licensing agreements."
                   },
                   {
                    id: "ei-2-9-46", da: "Examine potential regulatory compliance challenges."
                   },
                   {
                    id: "ei-2-9-47", da: "Evaluate the impact on community and social responsibility initiatives."
                   },
                   {
                    id: "ei-2-9-48", da: "Consider the need for post-exit reporting and auditing."
                   },
                   {
                    id: "ei-2-9-49", da: "Review the overall communication strategy for the exit."
                   },
                ]
              },
            ]
          }
        ]
      },
      'is':{
        characteristic: 'Innovation Scouting',
        wdd: "Take your next step towards becoming an expert on sourcing the best startups in the world. Position yourself as an interesting partner to corporate managers who need you to deliver tailor-made answers to their innovation needs. Know how to source startup leads and identify the best companies by using the right criteria.",
        icon: require('@/assets/Iconography/Characteristics/15_Skilled Communicator.svg'),
        competencies:[
          {
            id: 'is-0',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Brand Positioning',
            wdd: '',
            progressMeasures:[
              {
                id: 'is-0-0',
                pm: 'The need can be defined simply and succintly. Positioning is clear and single line.',
                title:'Need',
                pmMap: 'The need can be defined simply and succintly. Positioning is clear and single line.',
                developmentActions:[
                  {
                    id: "is-0-0-0", da: "Establish a dedicated innovation scouting team or department."
                   },
                   {
                    id: "is-0-0-1", da: "Improve collaboration with external partners, such as startups and research institutions."
                   },
                   {
                    id: "is-0-0-2", da: "Create clear criteria for evaluating potential innovation partners."
                   },
                   {
                    id: "is-0-0-3", da: "Streamline the process for scouting and evaluating innovations."
                   },
                   {
                    id: "is-0-0-4", da: "Invest in technology scouting tools and platforms."
                   },
                   {
                    id: "is-0-0-5", da: "Increase focus on disruptive innovations, not just incremental ones."
                   },
                   {
                    id: "is-0-0-6", da: "Foster a culture of innovation within the organization."
                   },
                   {
                    id: "is-0-0-7", da: "Develop a comprehensive innovation scouting strategy."
                   },
                   {
                    id: "is-0-0-8", da: "Expand the geographic reach for scouting opportunities."
                   },
                   {
                    id: "is-0-0-9", da: "Enhance the company's ability to identify emerging trends."
                   },
                   {
                    id: "is-0-0-10", da: "Increase the scouting efforts in emerging markets."
                   },
                   {
                    id: "is-0-0-11", da: "Establish key performance indicators (KPIs) for scouting success."
                   },
                   {
                    id: "is-0-0-12", da: "Strengthen intellectual property (IP) management for scouted innovations."
                   },
                   {
                    id: "is-0-0-13", da: "Build a robust network of innovation scouts and partners."
                   },
                   {
                    id: "is-0-0-14", da: "Provide training for employees involved in scouting activities."
                   },
                   {
                    id: "is-0-0-15", da: "Develop a budget specifically for innovation scouting efforts."
                   },
                   {
                    id: "is-0-0-16", da: "Regularly monitor and update the innovation scouting strategy."
                   },
                   {
                    id: "is-0-0-17", da: "Improve communication and feedback channels with external scouts."
                   },
                   {
                    id: "is-0-0-18", da: "Streamline the process of onboarding new innovations."
                   },
                   {
                    id: "is-0-0-19", da: "Foster a more agile approach to adopting innovations."
                   },
                   {
                    id: "is-0-0-20", da: "Define a unique value proposition for the brand."
                   },
                   {
                    id: "is-0-0-21", da: "Assess the competitive landscape and identify gaps."
                   },
                   {
                    id: "is-0-0-22", da: "Ensure brand messaging is consistent across all channels."
                   },
                   {
                    id: "is-0-0-23", da: "Reevaluate the target audience to align with current market trends."
                   },
                   {
                    id: "is-0-0-24", da: "Strengthen the emotional connection between the brand and customers."
                   },
                   {
                    id: "is-0-0-25", da: "Conduct a comprehensive brand audit to identify weaknesses."
                   },
                   {
                    id: "is-0-0-26", da: "Clarify the brand's mission, vision, and core values."
                   },
                   {
                    id: "is-0-0-27", da: "Develop a robust content marketing strategy."
                   },
                   {
                    id: "is-0-0-28", da: "Leverage data and analytics to refine brand positioning."
                   },
                   {
                    id: "is-0-0-29", da: "Engage in market research to understand customer perceptions."
                   },
                   {
                    id: "is-0-0-30", da: "Rebrand or refresh the visual identity if it's outdated."
                   },
                   {
                    id: "is-0-0-31", da: "Optimize the brand's digital presence, including the website."
                   },
                   {
                    id: "is-0-0-32", da: "Enhance social media engagement to build a brand community."
                   },
                   {
                    id: "is-0-0-33", da: "Seek customer feedback and act on it for brand improvement."
                   },
                   {
                    id: "is-0-0-34", da: "Consider a cause-related marketing campaign to enhance brand image."
                   },
                   {
                    id: "is-0-0-35", da: "Collaborate with influencers or industry leaders for brand endorsements."
                   },
                   {
                    id: "is-0-0-36", da: "Ensure that employees are brand ambassadors and aligned with brand values."
                   },
                   {
                    id: "is-0-0-37", da: "Explore new markets or segments for potential brand expansion."
                   },
                   {
                    id: "is-0-0-38", da: "Develop a crisis communication plan to protect brand reputation."
                   },
                   {
                    id: "is-0-0-39", da: "Monitor and respond to online reviews and customer feedback."
                   },
                   {
                    id: "is-0-0-40", da: "Foster cross-functional collaboration between innovation and branding teams."
                   },
                   {
                    id: "is-0-0-41", da: "Conduct regular brand health check assessments."
                   },
                   {
                    id: "is-0-0-42", da: "Stay updated on industry and market trends."
                   },
                   {
                    id: "is-0-0-43", da: "Enhance the customer experience to reflect brand values."
                   },
                   {
                    id: "is-0-0-44", da: "Align innovation scouting with brand positioning."
                   },
                   {
                    id: "is-0-0-45", da: "Implement continuous learning and development programs."
                   },
                   {
                    id: "is-0-0-46", da: "Measure the ROI of innovation and branding efforts."
                   },
                   {
                    id: "is-0-0-47", da: "Develop a clear brand architecture strategy for product lines."
                   },
                   {
                    id: "is-0-0-48", da: "Consider global expansion for brand recognition."
                   },
                   {
                    id: "is-0-0-49", da: "Continuously seek customer feedback to drive innovation and brand improvements."
                   },
                ]
              },
              {
                id: 'is-0-1',
                pm: 'Strong evidence for brand recognition and recall in minds of people.',
                title:'Market',
                pmMap: 'Strong evidence for brand recognition and recall in minds of people.',
                developmentActions:[
                  {
                    id: "is-0-1-0", da: "Identify emerging technologies relevant to your industry."
                   },
                   {
                    id: "is-0-1-1", da: "Establish partnerships with research institutions for technology transfer."
                   },
                   {
                    id: "is-0-1-2", da: "Set up an internal team dedicated to innovation and scouting."
                   },
                   {
                    id: "is-0-1-3", da: "Attend industry-specific innovation conferences and expos."
                   },
                   {
                    id: "is-0-1-4", da: "Explore open innovation by collaborating with startups."
                   },
                   {
                    id: "is-0-1-5", da: "Launch an innovation challenge or hackathon."
                   },
                   {
                    id: "is-0-1-6", da: "Conduct regular innovation workshops and brainstorming sessions."
                   },
                   {
                    id: "is-0-1-7", da: "Develop a formal process for vetting and implementing new technologies."
                   },
                   {
                    id: "is-0-1-8", da: "Invest in a dedicated R&D lab for testing and prototyping."
                   },
                   {
                    id: "is-0-1-9", da: "Foster a culture of innovation and encourage employees to submit ideas."
                   },
                   {
                    id: "is-0-1-10", da: "Leverage data analytics to identify trends and opportunities."
                   },
                   {
                    id: "is-0-1-11", da: "Create an innovation fund for investment in promising projects."
                   },
                   {
                    id: "is-0-1-12", da: "Monitor competitor innovation activities."
                   },
                   {
                    id: "is-0-1-13", da: "Partner with venture capitalists for access to innovative startups."
                   },
                   {
                    id: "is-0-1-14", da: "Develop a system for tracking and managing intellectual property."
                   },
                   {
                    id: "is-0-1-15", da: "Explore acquisitions of innovative companies in your field."
                   },
                   {
                    id: "is-0-1-16", da: "Build a network of innovation scouts and trendspotters."
                   },
                   {
                    id: "is-0-1-17", da: "Collaborate with government agencies for innovation grants and incentives."
                   },
                   {
                    id: "is-0-1-18", da: "Implement rapid prototyping and agile development methodologies."
                   },
                   {
                    id: "is-0-1-19", da: "Invest in cutting-edge tools and software for innovation management."
                   },
                   {
                    id: "is-0-1-20", da: "Conduct a thorough market analysis to understand customer needs."
                   },
                   {
                    id: "is-0-1-21", da: "Define a unique value proposition for your brand."
                   },
                   {
                    id: "is-0-1-22", da: "Develop buyer personas to guide marketing efforts."
                   },
                   {
                    id: "is-0-1-23", da: "Craft a compelling brand story and mission statement."
                   },
                   {
                    id: "is-0-1-24", da: "Implement a branding style guide for consistency."
                   },
                   {
                    id: "is-0-1-25", da: "Create a brand identity that resonates with your audience."
                   },
                   {
                    id: "is-0-1-26", da: "Optimize your website for SEO and user experience."
                   },
                   {
                    id: "is-0-1-27", da: "Use social media to build a brand community."
                   },
                   {
                    id: "is-0-1-28", da: "Provide exceptional customer service."
                   },
                   {
                    id: "is-0-1-29", da: "Develop content marketing strategies to establish authority."
                   },
                   {
                    id: "is-0-1-30", da: "Utilize influencer marketing for brand endorsements."
                   },
                   {
                    id: "is-0-1-31", da: "Enhance your product or service quality."
                   },
                   {
                    id: "is-0-1-32", da: "Engage in cause marketing or corporate social responsibility."
                   },
                   {
                    id: "is-0-1-33", da: "Monitor brand sentiment and address negative feedback."
                   },
                   {
                    id: "is-0-1-34", da: "Launch targeted advertising campaigns."
                   },
                   {
                    id: "is-0-1-35", da: "Create a referral program for existing customers."
                   },
                   {
                    id: "is-0-1-36", da: "Innovate in packaging and presentation."
                   },
                   {
                    id: "is-0-1-37", da: "Establish partnerships with complementary brands."
                   },
                   {
                    id: "is-0-1-38", da: "Expand into new markets and demographics."
                   },
                   {
                    id: "is-0-1-39", da: "Develop a mobile app or improve your digital presence."
                   },
                   {
                    id: "is-0-1-40", da: "Promote sustainability and eco-friendliness."
                   },
                   {
                    id: "is-0-1-41", da: "Invest in market research for continuous improvement."
                   },
                   {
                    id: "is-0-1-42", da: "Optimize pricing and value bundling strategies."
                   },
                   {
                    id: "is-0-1-43", da: "Conduct A\/B testing for marketing initiatives."
                   },
                   {
                    id: "is-0-1-44", da: "Collaborate with industry influencers and thought leaders."
                   },
                   {
                    id: "is-0-1-45", da: "Measure and track key brand performance metrics."
                   },
                   {
                    id: "is-0-1-46", da: "Provide educational resources and thought leadership."
                   },
                   {
                    id: "is-0-1-47", da: "Foster customer loyalty and brand advocacy."
                   },
                   {
                    id: "is-0-1-48", da: "Seek feedback from customers and adapt to their preferences."
                   },
                   {
                    id: "is-0-1-49", da: "Stay up to date with market trends and adapt your brand strategy accordingly."
                   },
                ]
              },
              {
                id: 'is-0-2',
                pm: 'Marketing and Onboarding channels are defined, brand profiles on social media pass a unified message.',
                title:'Technology',
                pmMap: 'Marketing and Onboarding channels are defined, brand profiles on social media pass a unified message.',
                developmentActions:[
                  {
                    id: "is-0-2-0", da: "Implement AI-powered chatbots for customer support."
                   },
                   {
                    id: "is-0-2-1", da: "Develop a mobile app to enhance customer engagement."
                   },
                   {
                    id: "is-0-2-2", da: "Upgrade your website to be mobile-responsive."
                   },
                   {
                    id: "is-0-2-3", da: "Explore blockchain for supply chain transparency."
                   },
                   {
                    id: "is-0-2-4", da: "Investigate IoT solutions for data collection and analysis."
                   },
                   {
                    id: "is-0-2-5", da: "Integrate augmented reality (AR) for interactive product experiences."
                   },
                   {
                    id: "is-0-2-6", da: "Adopt virtual reality (VR) for immersive marketing campaigns."
                   },
                   {
                    id: "is-0-2-7", da: "Invest in predictive analytics for market trend forecasting."
                   },
                   {
                    id: "is-0-2-8", da: "Improve data security measures to protect customer information."
                   },
                   {
                    id: "is-0-2-9", da: "Enhance your data analytics infrastructure."
                   },
                   {
                    id: "is-0-2-10", da: "Utilize big data analytics for personalized marketing."
                   },
                   {
                    id: "is-0-2-11", da: "Implement machine learning algorithms for customer behavior analysis."
                   },
                   {
                    id: "is-0-2-12", da: "Upgrade your CRM system for better customer relationship management."
                   },
                   {
                    id: "is-0-2-13", da: "Incorporate cloud-based solutions for scalability and accessibility."
                   },
                   {
                    id: "is-0-2-14", da: "Explore 5G technology for faster data transmission."
                   },
                   {
                    id: "is-0-2-15", da: "Optimize your website for voice search."
                   },
                   {
                    id: "is-0-2-16", da: "Invest in cybersecurity to safeguard sensitive data."
                   },
                   {
                    id: "is-0-2-17", da: "Implement geofencing for location-based marketing."
                   },
                   {
                    id: "is-0-2-18", da: "Develop a robust content management system (CMS)."
                   },
                   {
                    id: "is-0-2-19", da: "Investigate 3D printing for product prototyping."
                   },
                   {
                    id: "is-0-2-20", da: "Adopt e-commerce platforms for online sales."
                   },
                   {
                    id: "is-0-2-21", da: "Use social media listening tools for brand perception analysis."
                   },
                   {
                    id: "is-0-2-22", da: "Explore sustainability initiatives using green technology."
                   },
                   {
                    id: "is-0-2-23", da: "Develop a mobile payment system for ease of transactions."
                   },
                   {
                    id: "is-0-2-24", da: "Invest in data visualization tools for better insights."
                   },
                   {
                    id: "is-0-2-25", da: "Implement agile development methodologies for faster innovation."
                   },
                   {
                    id: "is-0-2-26", da: "Explore robotics for process automation."
                   },
                   {
                    id: "is-0-2-27", da: "Upgrade your data storage solutions."
                   },
                   {
                    id: "is-0-2-28", da: "Invest in data warehousing for consolidated data."
                   },
                   {
                    id: "is-0-2-29", da: "Develop a data-driven culture within the organization."
                   },
                   {
                    id: "is-0-2-30", da: "Investigate blockchain for smart contracts."
                   },
                   {
                    id: "is-0-2-31", da: "Optimize your email marketing with AI."
                   },
                   {
                    id: "is-0-2-32", da: "Implement data encryption techniques."
                   },
                   {
                    id: "is-0-2-33", da: "Develop a content personalization engine."
                   },
                   {
                    id: "is-0-2-34", da: "Explore edge computing for faster data processing."
                   },
                   {
                    id: "is-0-2-35", da: "Investigate quantum computing for advanced data analysis."
                   },
                   {
                    id: "is-0-2-36", da: "Optimize your website for fast loading times."
                   },
                   {
                    id: "is-0-2-37", da: "Invest in digital asset management for content control."
                   },
                   {
                    id: "is-0-2-38", da: "Implement location-based marketing campaigns."
                   },
                   {
                    id: "is-0-2-39", da: "Develop a technology-driven onboarding process for new employees."
                   },
                   {
                    id: "is-0-2-40", da: "Utilize gamification for customer engagement."
                   },
                   {
                    id: "is-0-2-41", da: "Investigate biometric authentication for security."
                   },
                   {
                    id: "is-0-2-42", da: "Optimize your IT infrastructure for scalability."
                   },
                   {
                    id: "is-0-2-43", da: "Invest in data mining techniques."
                   },
                   {
                    id: "is-0-2-44", da: "Develop a mobile-first strategy for content."
                   },
                   {
                    id: "is-0-2-45", da: "Explore 3D modeling for product visualization."
                   },
                   {
                    id: "is-0-2-46", da: "Investigate natural language processing (NLP) for customer interactions."
                   },
                   {
                    id: "is-0-2-47", da: "Optimize your technology stack for efficiency."
                   },
                   {
                    id: "is-0-2-48", da: "Implement DevOps practices for faster development cycles."
                   },
                   {
                    id: "is-0-2-49", da: "Explore the use of APIs and microservices for integrations."
                   },
                ]
              },
              {
                id: 'is-0-3',
                pm: 'New entrants can experience an "aha moment" when presented with the brand.',
                title:'Value',
                pmMap: 'New entrants can experience an "aha moment" when presented with the brand.',
                developmentActions:[
                  {
                    id: "is-0-3-0", da: "Identify emerging trends in your industry."
                   },
                   {
                    id: "is-0-3-1", da: "Monitor competitors' innovations and positioning strategies."
                   },
                   {
                    id: "is-0-3-2", da: "Enhance your brand's visual identity (logo, colors, etc.)."
                   },
                   {
                    id: "is-0-3-3", da: "Develop a content marketing strategy to strengthen brand positioning."
                   },
                   {
                    id: "is-0-3-4", da: "Conduct regular customer surveys to understand their needs."
                   },
                   {
                    id: "is-0-3-5", da: "Leverage customer feedback to improve product offerings."
                   },
                   {
                    id: "is-0-3-6", da: "Create a unique selling proposition (USP) for your brand."
                   },
                   {
                    id: "is-0-3-7", da: "Explore partnerships with complementary businesses."
                   },
                   {
                    id: "is-0-3-8", da: "Optimize your website for better user experience."
                   },
                   {
                    id: "is-0-3-9", da: "Expand your social media presence."
                   },
                   {
                    id: "is-0-3-10", da: "Implement a strong SEO strategy."
                   },
                   {
                    id: "is-0-3-11", da: "Launch a loyalty program for existing customers."
                   },
                   {
                    id: "is-0-3-12", da: "Invest in influencer marketing to boost brand visibility."
                   },
                   {
                    id: "is-0-3-13", da: "Develop a robust email marketing campaign."
                   },
                   {
                    id: "is-0-3-14", da: "Reevaluate your pricing strategy."
                   },
                   {
                    id: "is-0-3-15", da: "Enhance customer service and support."
                   },
                   {
                    id: "is-0-3-16", da: "Seek opportunities for international expansion."
                   },
                   {
                    id: "is-0-3-17", da: "Build a strong presence on emerging social media platforms."
                   },
                   {
                    id: "is-0-3-18", da: "Invest in employee training and development."
                   },
                   {
                    id: "is-0-3-19", da: "Streamline internal processes for efficiency."
                   },
                   {
                    id: "is-0-3-20", da: "Conduct regular SWOT analyses."
                   },
                   {
                    id: "is-0-3-21", da: "Continuously monitor and adjust your brand's messaging."
                   },
                   {
                    id: "is-0-3-22", da: "Embrace sustainable and ethical practices."
                   },
                   {
                    id: "is-0-3-23", da: "Offer exclusive products or services."
                   },
                   {
                    id: "is-0-3-24", da: "Optimize product packaging and design."
                   },
                   {
                    id: "is-0-3-25", da: "Enhance customer onboarding experiences."
                   },
                   {
                    id: "is-0-3-26", da: "Create informative and engaging blog content."
                   },
                   {
                    id: "is-0-3-27", da: "Investigate emerging technologies relevant to your industry."
                   },
                   {
                    id: "is-0-3-28", da: "Establish partnerships with local communities."
                   },
                   {
                    id: "is-0-3-29", da: "Explore opportunities for mobile app development."
                   },
                   {
                    id: "is-0-3-30", da: "Invest in market research to identify gaps."
                   },
                   {
                    id: "is-0-3-31", da: "Engage in A\/B testing for website and advertising campaigns."
                   },
                   {
                    id: "is-0-3-32", da: "Seek customer testimonials and case studies."
                   },
                   {
                    id: "is-0-3-33", da: "Implement data analytics for decision-making."
                   },
                   {
                    id: "is-0-3-34", da: "Emphasize your brand's unique history or story."
                   },
                   {
                    id: "is-0-3-35", da: "Optimize your supply chain for cost-efficiency."
                   },
                   {
                    id: "is-0-3-36", da: "Conduct competitor benchmarking."
                   },
                   {
                    id: "is-0-3-37", da: "Identify opportunities for process automation."
                   },
                   {
                    id: "is-0-3-38", da: "Invest in trade show and event participation."
                   },
                   {
                    id: "is-0-3-39", da: "Create a clear and compelling value proposition."
                   },
                   {
                    id: "is-0-3-40", da: "Innovate your product delivery and distribution methods."
                   },
                   {
                    id: "is-0-3-41", da: "Develop partnerships with industry influencers."
                   },
                   {
                    id: "is-0-3-42", da: "Expand into new market segments."
                   },
                   {
                    id: "is-0-3-43", da: "Embrace the latest design trends."
                   },
                   {
                    id: "is-0-3-44", da: "Offer educational resources to your audience."
                   },
                   {
                    id: "is-0-3-45", da: "Rebrand to better reflect your evolving identity."
                   },
                   {
                    id: "is-0-3-46", da: "Focus on building a strong online community."
                   },
                   {
                    id: "is-0-3-47", da: "Continuously analyze and adapt pricing strategies."
                   },
                   {
                    id: "is-0-3-48", da: "Offer discounts or promotions at strategic times."
                   },
                   {
                    id: "is-0-3-49", da: "Emphasize transparency in your business practices."
                   },
                ]
              },
              {
                id: 'is-0-4',
                pm: 'Have clear and understandable revenue model with clear pricing.',
                title:'Business Model',
                pmMap: 'Have clear and understandable revenue model with clear pricing.',
                developmentActions:[
                  {
                    id: "is-0-4-0", da: "Analyze current market trends and customer needs."
                   },
                   {
                    id: "is-0-4-1", da: "Conduct a competitive analysis to identify gaps."
                   },
                   {
                    id: "is-0-4-2", da: "Seek opportunities in emerging markets."
                   },
                   {
                    id: "is-0-4-3", da: "Diversify your product or service offerings."
                   },
                   {
                    id: "is-0-4-4", da: "Explore partnerships with complementary businesses."
                   },
                   {
                    id: "is-0-4-5", da: "Optimize your pricing strategy."
                   },
                   {
                    id: "is-0-4-6", da: "Investigate subscription-based models."
                   },
                   {
                    id: "is-0-4-7", da: "Enhance the customer experience."
                   },
                   {
                    id: "is-0-4-8", da: "Implement a loyalty program."
                   },
                   {
                    id: "is-0-4-9", da: "Develop a mobile app for convenience."
                   },
                   {
                    id: "is-0-4-10", da: "Consider a freemium model."
                   },
                   {
                    id: "is-0-4-11", da: "Expand your target audience."
                   },
                   {
                    id: "is-0-4-12", da: "Focus on sustainable and eco-friendly solutions."
                   },
                   {
                    id: "is-0-4-13", da: "Research technological advancements in your industry."
                   },
                   {
                    id: "is-0-4-14", da: "Create a data-driven decision-making process."
                   },
                   {
                    id: "is-0-4-15", da: "Invest in research and development."
                   },
                   {
                    id: "is-0-4-16", da: "Leverage artificial intelligence for personalization."
                   },
                   {
                    id: "is-0-4-17", da: "Experiment with new advertising channels."
                   },
                   {
                    id: "is-0-4-18", da: "Redefine your unique selling proposition."
                   },
                   {
                    id: "is-0-4-19", da: "Adapt to changing customer behaviors."
                   },
                   {
                    id: "is-0-4-20", da: "Consider white-labeling your products or services."
                   },
                   {
                    id: "is-0-4-21", da: "Review your supply chain for efficiency."
                   },
                   {
                    id: "is-0-4-22", da: "Implement lean manufacturing principles."
                   },
                   {
                    id: "is-0-4-23", da: "Experiment with different revenue streams."
                   },
                   {
                    id: "is-0-4-24", da: "Explore e-commerce and online sales."
                   },
                   {
                    id: "is-0-4-25", da: "Embrace the sharing economy."
                   },
                   {
                    id: "is-0-4-26", da: "Enhance your social media presence."
                   },
                   {
                    id: "is-0-4-27", da: "Create content that adds value to your audience."
                   },
                   {
                    id: "is-0-4-28", da: "Develop a content marketing strategy."
                   },
                   {
                    id: "is-0-4-29", da: "Use analytics to improve decision-making."
                   },
                   {
                    id: "is-0-4-30", da: "Conduct A\/B testing on your website."
                   },
                   {
                    id: "is-0-4-31", da: "Launch a referral program."
                   },
                   {
                    id: "is-0-4-32", da: "Offer customized solutions."
                   },
                   {
                    id: "is-0-4-33", da: "Seek external funding or investors."
                   },
                   {
                    id: "is-0-4-34", da: "Evaluate your cost structure."
                   },
                   {
                    id: "is-0-4-35", da: "Consider crowd-funding opportunities."
                   },
                   {
                    id: "is-0-4-36", da: "Optimize your distribution channels."
                   },
                   {
                    id: "is-0-4-37", da: "Improve your branding and visual identity."
                   },
                   {
                    id: "is-0-4-38", da: "Develop a crisis management plan."
                   },
                   {
                    id: "is-0-4-39", da: "Invest in employee training and development."
                   },
                   {
                    id: "is-0-4-40", da: "Enhance your intellectual property strategy."
                   },
                   {
                    id: "is-0-4-41", da: "Explore international expansion."
                   },
                   {
                    id: "is-0-4-42", da: "Investigate blockchain and cryptocurrency options."
                   },
                   {
                    id: "is-0-4-43", da: "Innovate in customer service solutions."
                   },
                   {
                    id: "is-0-4-44", da: "Create a content calendar for marketing."
                   },
                   {
                    id: "is-0-4-45", da: "Reevaluate your geographical presence."
                   },
                   {
                    id: "is-0-4-46", da: "Consider mergers and acquisitions."
                   },
                   {
                    id: "is-0-4-47", da: "Investigate the Internet of Things (IoT)."
                   },
                   {
                    id: "is-0-4-48", da: "Develop an omnichannel strategy."
                   },
                   {
                    id: "is-0-4-49", da: "Stay agile and adaptable in a changing market."
                   },
                ]
              },
              {
                id: 'is-0-5',
                pm: 'Team starts to experience a market pull.',
                title:'Go to Market',
                pmMap: 'Team starts to experience a market pull.',
                developmentActions:[
                  {
                    id: "is-0-5-0", da: "Conduct market research to identify emerging trends."
                   },
                   {
                    id: "is-0-5-1", da: "Explore new market segments for potential expansion."
                   },
                   {
                    id: "is-0-5-2", da: "Develop a comprehensive competitive analysis."
                   },
                   {
                    id: "is-0-5-3", da: "Invest in advanced data analytics for consumer insights."
                   },
                   {
                    id: "is-0-5-4", da: "Foster partnerships with technology startups for innovation."
                   },
                   {
                    id: "is-0-5-5", da: "Optimize your product packaging for visual appeal."
                   },
                   {
                    id: "is-0-5-6", da: "Create a content marketing plan for thought leadership."
                   },
                   {
                    id: "is-0-5-7", da: "Refine your brand message for clarity and impact."
                   },
                   {
                    id: "is-0-5-8", da: "Utilize social media influencers for brand promotion."
                   },
                   {
                    id: "is-0-5-9", da: "Implement a referral program for customer acquisition."
                   },
                   {
                    id: "is-0-5-10", da: "Optimize your website for mobile responsiveness."
                   },
                   {
                    id: "is-0-5-11", da: "Invest in video marketing to engage a wider audience."
                   },
                   {
                    id: "is-0-5-12", da: "Develop case studies to showcase customer success stories."
                   },
                   {
                    id: "is-0-5-13", da: "Expand your content marketing to reach more channels."
                   },
                   {
                    id: "is-0-5-14", da: "Collaborate with industry experts on webinars and podcasts."
                   },
                   {
                    id: "is-0-5-15", da: "Conduct A\/B testing for website optimization."
                   },
                   {
                    id: "is-0-5-16", da: "Leverage user-generated content for authenticity."
                   },
                   {
                    id: "is-0-5-17", da: "Use marketing automation for lead nurturing."
                   },
                   {
                    id: "is-0-5-18", da: "Implement chatbots for customer support and engagement."
                   },
                   {
                    id: "is-0-5-19", da: "Run targeted email marketing campaigns."
                   },
                   {
                    id: "is-0-5-20", da: "Create product tutorials and how-to guides."
                   },
                   {
                    id: "is-0-5-21", da: "Explore partnerships with complementary brands."
                   },
                   {
                    id: "is-0-5-22", da: "Conduct focus groups to gather consumer feedback."
                   },
                   {
                    id: "is-0-5-23", da: "Invest in SEO for improved online visibility."
                   },
                   {
                    id: "is-0-5-24", da: "Develop an influencer marketing strategy."
                   },
                   {
                    id: "is-0-5-25", da: "Localize your marketing efforts for international expansion."
                   },
                   {
                    id: "is-0-5-26", da: "Improve website load times for better user experience."
                   },
                   {
                    id: "is-0-5-27", da: "Implement a loyalty program for customer retention."
                   },
                   {
                    id: "is-0-5-28", da: "Develop an omnichannel marketing strategy."
                   },
                   {
                    id: "is-0-5-29", da: "Create a mobile app for better customer engagement."
                   },
                   {
                    id: "is-0-5-30", da: "Explore co-branding opportunities with non-competitors."
                   },
                   {
                    id: "is-0-5-31", da: "Expand to new geographic markets."
                   },
                   {
                    id: "is-0-5-32", da: "Create a crisis management plan for potential issues."
                   },
                   {
                    id: "is-0-5-33", da: "Launch a targeted Google Ads campaign."
                   },
                   {
                    id: "is-0-5-34", da: "Participate in industry trade shows and events."
                   },
                   {
                    id: "is-0-5-35", da: "Implement a referral program for business partners."
                   },
                   {
                    id: "is-0-5-36", da: "Develop a robust PR strategy for brand visibility."
                   },
                   {
                    id: "is-0-5-37", da: "Conduct regular webinars for thought leadership."
                   },
                   {
                    id: "is-0-5-38", da: "Collaborate with influencers on co-branded content."
                   },
                   {
                    id: "is-0-5-39", da: "Expand your product\/service line for diversification."
                   },
                   {
                    id: "is-0-5-40", da: "Invest in user-generated content contests."
                   },
                   {
                    id: "is-0-5-41", da: "Optimize your website for voice search."
                   },
                   {
                    id: "is-0-5-42", da: "Engage with customers on social media for feedback."
                   },
                   {
                    id: "is-0-5-43", da: "Create a customer loyalty app."
                   },
                   {
                    id: "is-0-5-44", da: "Improve packaging sustainability for eco-conscious consumers."
                   },
                   {
                    id: "is-0-5-45", da: "Launch a virtual reality (VR) marketing campaign."
                   },
                   {
                    id: "is-0-5-46", da: "Create educational content for lead nurturing."
                   },
                   {
                    id: "is-0-5-47", da: "Develop custom landing pages for campaigns."
                   },
                   {
                    id: "is-0-5-48", da: "Enhance customer support with AI-powered solutions."
                   },
                   {
                    id: "is-0-5-49", da: "Conduct regular performance reviews and adjustments."
                   },
                ]
              },
              {
                id: 'is-0-6',
                pm: 'Employee incentive program is in place for incentivising first hires.',
                title:'People',
                pmMap: 'Employee incentive program is in place for incentivising first hires.',
                developmentActions:[
                  {
                    id: "is-0-6-0", da: "Conduct regular training sessions on innovative thinking."
                   },
                   {
                    id: "is-0-6-1", da: "Encourage cross-functional collaboration."
                   },
                   {
                    id: "is-0-6-2", da: "Promote a culture of continuous learning."
                   },
                   {
                    id: "is-0-6-3", da: "Identify and nurture in-house talent."
                   },
                   {
                    id: "is-0-6-4", da: "Hire individuals with diverse skill sets."
                   },
                   {
                    id: "is-0-6-5", da: "Foster a growth mindset among employees."
                   },
                   {
                    id: "is-0-6-6", da: "Create mentorship programs."
                   },
                   {
                    id: "is-0-6-7", da: "Establish a creativity and innovation task force."
                   },
                   {
                    id: "is-0-6-8", da: "Encourage open communication and idea sharing."
                   },
                   {
                    id: "is-0-6-9", da: "Recognize and reward innovative ideas."
                   },
                   {
                    id: "is-0-6-10", da: "Develop leadership skills to inspire innovation."
                   },
                   {
                    id: "is-0-6-11", da: "Implement flexible work arrangements."
                   },
                   {
                    id: "is-0-6-12", da: "Conduct regular skills assessments."
                   },
                   {
                    id: "is-0-6-13", da: "Invest in employee well-being and mental health."
                   },
                   {
                    id: "is-0-6-14", da: "Provide access to innovation-related resources."
                   },
                   {
                    id: "is-0-6-15", da: "Develop a supportive work environment."
                   },
                   {
                    id: "is-0-6-16", da: "Promote diversity and inclusion."
                   },
                   {
                    id: "is-0-6-17", da: "Encourage autonomy and risk-taking."
                   },
                   {
                    id: "is-0-6-18", da: "Establish innovation-focused KPIs."
                   },
                   {
                    id: "is-0-6-19", da: "Offer innovation-related workshops and seminars."
                   },
                   {
                    id: "is-0-6-20", da: "Encourage experimentation and prototyping."
                   },
                   {
                    id: "is-0-6-21", da: "Set up innovation labs or creative spaces."
                   },
                   {
                    id: "is-0-6-22", da: "Promote customer-centric thinking."
                   },
                   {
                    id: "is-0-6-23", da: "Create cross-functional innovation teams."
                   },
                   {
                    id: "is-0-6-24", da: "Benchmark against industry leaders."
                   },
                   {
                    id: "is-0-6-25", da: "Conduct regular innovation audits."
                   },
                   {
                    id: "is-0-6-26", da: "Foster a culture of customer empathy."
                   },
                   {
                    id: "is-0-6-27", da: "Establish innovation-related career paths."
                   },
                   {
                    id: "is-0-6-28", da: "Encourage feedback and ideation platforms."
                   },
                   {
                    id: "is-0-6-29", da: "Promote design thinking principles."
                   },
                   {
                    id: "is-0-6-30", da: "Develop storytelling and presentation skills."
                   },
                   {
                    id: "is-0-6-31", da: "Encourage outside-in thinking."
                   },
                   {
                    id: "is-0-6-32", da: "Invest in market research and analysis."
                   },
                   {
                    id: "is-0-6-33", da: "Develop a strong innovation portfolio."
                   },
                   {
                    id: "is-0-6-34", da: "Encourage knowledge sharing."
                   },
                   {
                    id: "is-0-6-35", da: "Promote intrapreneurship."
                   },
                   {
                    id: "is-0-6-36", da: "Implement idea management software."
                   },
                   {
                    id: "is-0-6-37", da: "Reward problem-solving skills."
                   },
                   {
                    id: "is-0-6-38", da: "Develop a deep understanding of target audiences."
                   },
                   {
                    id: "is-0-6-39", da: "Focus on brand values and authenticity."
                   },
                   {
                    id: "is-0-6-40", da: "Enhance brand storytelling."
                   },
                   {
                    id: "is-0-6-41", da: "Analyze and segment your audience."
                   },
                   {
                    id: "is-0-6-42", da: "Invest in market positioning research."
                   },
                   {
                    id: "is-0-6-43", da: "Develop a strong online presence."
                   },
                   {
                    id: "is-0-6-44", da: "Monitor and adapt to industry trends."
                   },
                   {
                    id: "is-0-6-45", da: "Implement brand consistency guidelines."
                   },
                   {
                    id: "is-0-6-46", da: "Establish a brand voice and tone."
                   },
                   {
                    id: "is-0-6-47", da: "Leverage social media for brand engagement."
                   },
                   {
                    id: "is-0-6-48", da: "Create partnerships and collaborations."
                   },
                   {
                    id: "is-0-6-49", da: "Continuously evaluate and adapt your branding strategy."
                   },
                ]
              },
              {
                id: 'is-0-7',
                pm: 'End to end customer funnel is being tracked and accessible to entire team.',
                title:'Data Metrics',
                pmMap: 'End to end customer funnel is being tracked and accessible to entire team.',
                developmentActions:[
                  {
                    id: "is-0-7-0", da: "Define clear and measurable key performance indicators (KPIs)."
                   },
                   {
                    id: "is-0-7-1", da: "Establish a data-driven culture within the organization."
                   },
                   {
                    id: "is-0-7-2", da: "Invest in robust data collection and management tools."
                   },
                   {
                    id: "is-0-7-3", da: "Ensure data accuracy and consistency across all sources."
                   },
                   {
                    id: "is-0-7-4", da: "Regularly update and clean the existing data."
                   },
                   {
                    id: "is-0-7-5", da: "Implement data validation processes to eliminate errors."
                   },
                   {
                    id: "is-0-7-6", da: "Set up automated data integration between various systems."
                   },
                   {
                    id: "is-0-7-7", da: "Use data analytics to identify market trends."
                   },
                   {
                    id: "is-0-7-8", da: "Develop predictive models to anticipate market changes."
                   },
                   {
                    id: "is-0-7-9", da: "Utilize sentiment analysis to gauge brand perception."
                   },
                   {
                    id: "is-0-7-10", da: "Collect data on customer demographics and behaviors."
                   },
                   {
                    id: "is-0-7-11", da: "Segment data for more targeted marketing campaigns."
                   },
                   {
                    id: "is-0-7-12", da: "Monitor website and social media traffic."
                   },
                   {
                    id: "is-0-7-13", da: "Analyze conversion rates at different stages of the sales funnel."
                   },
                   {
                    id: "is-0-7-14", da: "Use A\/B testing to optimize website content and design."
                   },
                   {
                    id: "is-0-7-15", da: "Employ data to identify customer pain points."
                   },
                   {
                    id: "is-0-7-16", da: "Assess customer lifetime value."
                   },
                   {
                    id: "is-0-7-17", da: "Track customer acquisition cost."
                   },
                   {
                    id: "is-0-7-18", da: "Analyze customer retention rates."
                   },
                   {
                    id: "is-0-7-19", da: "Investigate reasons for customer churn."
                   },
                   {
                    id: "is-0-7-20", da: "Evaluate the impact of marketing channels on conversion."
                   },
                   {
                    id: "is-0-7-21", da: "Monitor customer feedback and reviews."
                   },
                   {
                    id: "is-0-7-22", da: "Analyze customer service response times and satisfaction."
                   },
                   {
                    id: "is-0-7-23", da: "Track supply chain and logistics data for efficiency."
                   },
                   {
                    id: "is-0-7-24", da: "Optimize inventory management with demand forecasting."
                   },
                   {
                    id: "is-0-7-25", da: "Monitor employee performance and productivity."
                   },
                   {
                    id: "is-0-7-26", da: "Analyze the financial impact of different marketing strategies."
                   },
                   {
                    id: "is-0-7-27", da: "Investigate competitors' data metrics for benchmarking."
                   },
                   {
                    id: "is-0-7-28", da: "Implement data security measures to protect sensitive information."
                   },
                   {
                    id: "is-0-7-29", da: "Evaluate the ROI of different marketing campaigns."
                   },
                   {
                    id: "is-0-7-30", da: "Use data to identify emerging market opportunities."
                   },
                   {
                    id: "is-0-7-31", da: "Investigate customer referral data."
                   },
                   {
                    id: "is-0-7-32", da: "Monitor social media engagement and interactions."
                   },
                   {
                    id: "is-0-7-33", da: "Analyze email marketing open and click-through rates."
                   },
                   {
                    id: "is-0-7-34", da: "Assess the performance of content marketing."
                   },
                   {
                    id: "is-0-7-35", da: "Track user behavior within mobile apps."
                   },
                   {
                    id: "is-0-7-36", da: "Analyze the impact of user-generated content."
                   },
                   {
                    id: "is-0-7-37", da: "Measure brand sentiment on various online platforms."
                   },
                   {
                    id: "is-0-7-38", da: "Evaluate the impact of content format (text, video, images)."
                   },
                   {
                    id: "is-0-7-39", da: "Analyze market seasonality for product launches."
                   },
                   {
                    id: "is-0-7-40", da: "Track the success of influencer marketing campaigns."
                   },
                   {
                    id: "is-0-7-41", da: "Use geospatial data to target specific regions."
                   },
                   {
                    id: "is-0-7-42", da: "Implement data visualization techniques for easier interpretation."
                   },
                   {
                    id: "is-0-7-43", da: "Analyze customer segmentation based on psychographics."
                   },
                   {
                    id: "is-0-7-44", da: "Investigate the impact of pricing strategies on sales."
                   },
                   {
                    id: "is-0-7-45", da: "Monitor customer feedback in real-time."
                   },
                   {
                    id: "is-0-7-46", da: "Analyze social media ad campaign performance."
                   },
                   {
                    id: "is-0-7-47", da: "Utilize customer journey mapping for data insights."
                   },
                   {
                    id: "is-0-7-48", da: "Measure the impact of brand positioning changes."
                   },
                   {
                    id: "is-0-7-49", da: "Continuously update and refine data metrics to adapt to changing market dynamics."
                   },
                ]
              },
              {
                id: 'is-0-8',
                pm: 'Regular team habits and cadences are established (daily huddle, weekly all-hands, planning cycles). Collaboration and knowledge sharing tools (Wiki, Slack) are established.',
                title:'Operations',
                pmMap: 'Regular team habits and cadences are established (daily huddle, weekly all-hands, planning cycles). Collaboration and knowledge sharing tools (Wiki, Slack) are established.',
                developmentActions:[
                  {
                    id: "is-0-8-0", da: "Implement a comprehensive innovation scouting strategy."
                   },
                   {
                    id: "is-0-8-1", da: "Streamline the process of identifying and evaluating innovative ideas."
                   },
                   {
                    id: "is-0-8-2", da: "Establish cross-functional innovation teams."
                   },
                   {
                    id: "is-0-8-3", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "is-0-8-4", da: "Invest in technology for better innovation tracking."
                   },
                   {
                    id: "is-0-8-5", da: "Conduct regular market research to identify trends."
                   },
                   {
                    id: "is-0-8-6", da: "Enhance collaboration with industry experts and thought leaders."
                   },
                   {
                    id: "is-0-8-7", da: "Develop a strong online presence through social media."
                   },
                   {
                    id: "is-0-8-8", da: "Optimize your website for better user experience."
                   },
                   {
                    id: "is-0-8-9", da: "Invest in data analytics for brand insights."
                   },
                   {
                    id: "is-0-8-10", da: "Focus on customer segmentation and targeting."
                   },
                   {
                    id: "is-0-8-11", da: "Implement agile project management methodologies."
                   },
                   {
                    id: "is-0-8-12", da: "Improve supply chain efficiency and reliability."
                   },
                   {
                    id: "is-0-8-13", da: "Enhance production processes to reduce costs."
                   },
                   {
                    id: "is-0-8-14", da: "Implement environmentally sustainable practices."
                   },
                   {
                    id: "is-0-8-15", da: "Automate routine tasks and processes."
                   },
                   {
                    id: "is-0-8-16", da: "Invest in employee training and development."
                   },
                   {
                    id: "is-0-8-17", da: "Optimize inventory management for cost savings."
                   },
                   {
                    id: "is-0-8-18", da: "Create key performance indicators (KPIs) for operations."
                   },
                   {
                    id: "is-0-8-19", da: "Leverage automation for customer support."
                   },
                   {
                    id: "is-0-8-20", da: "Monitor and reduce operational bottlenecks."
                   },
                   {
                    id: "is-0-8-21", da: "Strengthen relationships with suppliers."
                   },
                   {
                    id: "is-0-8-22", da: "Focus on employee satisfaction and retention."
                   },
                   {
                    id: "is-0-8-23", da: "Improve time management and workflow."
                   },
                   {
                    id: "is-0-8-24", da: "Implement lean manufacturing principles."
                   },
                   {
                    id: "is-0-8-25", da: "Enhance risk management and contingency planning."
                   },
                   {
                    id: "is-0-8-26", da: "Establish a robust quality control system."
                   },
                   {
                    id: "is-0-8-27", da: "Ensure compliance with industry standards and regulations."
                   },
                   {
                    id: "is-0-8-28", da: "Invest in predictive maintenance for equipment."
                   },
                   {
                    id: "is-0-8-29", da: "Embrace digital transformation in operations."
                   },
                   {
                    id: "is-0-8-30", da: "Optimize resource allocation and utilization."
                   },
                   {
                    id: "is-0-8-31", da: "Enhance cybersecurity to protect operations."
                   },
                   {
                    id: "is-0-8-32", da: "Improve internal and external communication."
                   },
                   {
                    id: "is-0-8-33", da: "Streamline decision-making processes."
                   },
                   {
                    id: "is-0-8-34", da: "Focus on cost-effective marketing strategies."
                   },
                   {
                    id: "is-0-8-35", da: "Diversify product and service offerings."
                   },
                   {
                    id: "is-0-8-36", da: "Reduce product development cycle times."
                   },
                   {
                    id: "is-0-8-37", da: "Implement efficient project management tools."
                   },
                   {
                    id: "is-0-8-38", da: "Strengthen partnerships and collaborations."
                   },
                   {
                    id: "is-0-8-39", da: "Foster a culture of data-driven decision-making."
                   },
                   {
                    id: "is-0-8-40", da: "Invest in employee wellness programs."
                   },
                   {
                    id: "is-0-8-41", da: "Enhance your branding and messaging."
                   },
                   {
                    id: "is-0-8-42", da: "Optimize packaging and presentation."
                   },
                   {
                    id: "is-0-8-43", da: "Monitor and reduce energy consumption."
                   },
                   {
                    id: "is-0-8-44", da: "Invest in modern inventory tracking systems."
                   },
                   {
                    id: "is-0-8-45", da: "Optimize logistics and transportation."
                   },
                   {
                    id: "is-0-8-46", da: "Develop a crisis management plan."
                   },
                   {
                    id: "is-0-8-47", da: "Implement performance measurement tools."
                   },
                   {
                    id: "is-0-8-48", da: "Continuously monitor and adapt to market changes."
                   },
                   {
                    id: "is-0-8-49", da: "Enhance feedback and review processes for ongoing improvement."
                   },
                ]
              },
              {
                id: 'is-0-9',
                pm: 'Documented clear evidence of a high-growth trajectory with marketable numbers.',
                title:'Exit Strategy',
                pmMap: 'Documented clear evidence of a high-growth trajectory with marketable numbers.',
                developmentActions:[
                  {
                    id: "is-0-9-0", da: "Conduct a comprehensive analysis of current exit strategies."
                   },
                   {
                    id: "is-0-9-1", da: "Evaluate the effectiveness of previous exit strategies."
                   },
                   {
                    id: "is-0-9-2", da: "Identify key stakeholders involved in exit planning."
                   },
                   {
                    id: "is-0-9-3", da: "Develop a clear and concise exit strategy framework."
                   },
                   {
                    id: "is-0-9-4", da: "Establish specific exit criteria and benchmarks."
                   },
                   {
                    id: "is-0-9-5", da: "Determine the most suitable exit channels."
                   },
                   {
                    id: "is-0-9-6", da: "Assess the timing of potential exits."
                   },
                   {
                    id: "is-0-9-7", da: "Review the legal and regulatory requirements for exits."
                   },
                   {
                    id: "is-0-9-8", da: "Identify potential exit barriers and challenges."
                   },
                   {
                    id: "is-0-9-9", da: "Analyze market trends and conditions."
                   },
                   {
                    id: "is-0-9-10", da: "Monitor competitor exit strategies."
                   },
                   {
                    id: "is-0-9-11", da: "Evaluate the financial implications of different exit options."
                   },
                   {
                    id: "is-0-9-12", da: "Create a dedicated exit strategy team."
                   },
                   {
                    id: "is-0-9-13", da: "Implement a continuous monitoring system for Attracting Leads."
                   },
                   {
                    id: "is-0-9-14", da: "Develop a communication plan for exit announcements."
                   },
                   {
                    id: "is-0-9-15", da: "Determine the impact of the exit on employees."
                   },
                   {
                    id: "is-0-9-16", da: "Create a contingency plan for unexpected events."
                   },
                   {
                    id: "is-0-9-17", da: "Consider the tax implications of different exit strategies."
                   },
                   {
                    id: "is-0-9-18", da: "Explore potential mergers and acquisitions."
                   },
                   {
                    id: "is-0-9-19", da: "Assess the potential for an IPO (Initial Public Offering)."
                   },
                   {
                    id: "is-0-9-20", da: "Review the valuation of the business."
                   },
                   {
                    id: "is-0-9-21", da: "Conduct due diligence on potential exit partners."
                   },
                   {
                    id: "is-0-9-22", da: "Evaluate the impact of the exit on customers."
                   },
                   {
                    id: "is-0-9-23", da: "Develop a post-exit plan for the management team."
                   },
                   {
                    id: "is-0-9-24", da: "Consider the impact on company culture and values."
                   },
                   {
                    id: "is-0-9-25", da: "Explore opportunities for business restructuring."
                   },
                   {
                    id: "is-0-9-26", da: "Analyze the impact of the exit on shareholders."
                   },
                   {
                    id: "is-0-9-27", da: "Create an exit strategy timeline."
                   },
                   {
                    id: "is-0-9-28", da: "Evaluate the role of advisors in the exit process."
                   },
                   {
                    id: "is-0-9-29", da: "Assess the impact on suppliers and partners."
                   },
                   {
                    id: "is-0-9-30", da: "Review intellectual property and patents."
                   },
                   {
                    id: "is-0-9-31", da: "Explore potential international exit opportunities."
                   },
                   {
                    id: "is-0-9-32", da: "Consider the impact of economic conditions on the exit."
                   },
                   {
                    id: "is-0-9-33", da: "Assess the impact of environmental and social factors."
                   },
                   {
                    id: "is-0-9-34", da: "Review potential exit financing options."
                   },
                   {
                    id: "is-0-9-35", da: "Develop an exit strategy playbook."
                   },
                   {
                    id: "is-0-9-36", da: "Create a risk management plan for exit scenarios."
                   },
                   {
                    id: "is-0-9-37", da: "Analyze the impact on brand reputation."
                   },
                   {
                    id: "is-0-9-38", da: "Assess the impact on local and global communities."
                   },
                   {
                    id: "is-0-9-39", da: "Evaluate the impact on industry relationships."
                   },
                   {
                    id: "is-0-9-40", da: "Consider the impact on research and development."
                   },
                   {
                    id: "is-0-9-41", da: "Review the impact on intellectual capital."
                   },
                   {
                    id: "is-0-9-42", da: "Develop a strategy for investor relations during exit."
                   },
                   {
                    id: "is-0-9-43", da: "Assess the impact on corporate governance."
                   },
                   {
                    id: "is-0-9-44", da: "Explore opportunities for post-exit partnerships."
                   },
                   {
                    id: "is-0-9-45", da: "Consider the impact on public relations and media."
                   },
                   {
                    id: "is-0-9-46", da: "Develop a plan for employee retention during exit."
                   },
                   {
                    id: "is-0-9-47", da: "Evaluate the potential for a management buyout."
                   },
                   {
                    id: "is-0-9-48", da: "Assess the impact on customer contracts and agreements."
                   },
                   {
                    id: "is-0-9-49", da: "Conduct a final comprehensive review and risk assessment of the exit strategy."
                   },
                ]
              },
            ]
          },
          {
            id: 'is-1',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Outreach',
            wdd: '',
            progressMeasures:[
              {
                id: 'is-1-0',
                pm: 'There is a clear definition of the need in the outreach message.',
                title:'Need',
                pmMap: 'There is a clear definition of the need in the outreach message.',
                developmentActions:[
                  {
                    id: "is-1-0-0", da: "Identify emerging technologies in your industry."
                   },
                   {
                    id: "is-1-0-1", da: "Develop partnerships with startups to foster innovation."
                   },
                   {
                    id: "is-1-0-2", da: "Conduct market research to identify customer needs."
                   },
                   {
                    id: "is-1-0-3", da: "Foster a culture of innovation within the organization."
                   },
                   {
                    id: "is-1-0-4", da: "Create cross-functional innovation teams."
                   },
                   {
                    id: "is-1-0-5", da: "Implement idea management software for employees."
                   },
                   {
                    id: "is-1-0-6", da: "Collaborate with universities and research institutions."
                   },
                   {
                    id: "is-1-0-7", da: "Attend industry conferences and events."
                   },
                   {
                    id: "is-1-0-8", da: "Analyze competitor innovation strategies."
                   },
                   {
                    id: "is-1-0-9", da: "Seek out potential acquisition targets."
                   },
                   {
                    id: "is-1-0-10", da: "Establish an innovation lab or center."
                   },
                   {
                    id: "is-1-0-11", da: "Offer innovation training for employees."
                   },
                   {
                    id: "is-1-0-12", da: "Explore open innovation opportunities."
                   },
                   {
                    id: "is-1-0-13", da: "Monitor industry trends and disruptors."
                   },
                   {
                    id: "is-1-0-14", da: "Engage with innovation consultants."
                   },
                   {
                    id: "is-1-0-15", da: "Foster diversity and inclusion in innovation efforts."
                   },
                   {
                    id: "is-1-0-16", da: "Create innovation challenges or hackathons."
                   },
                   {
                    id: "is-1-0-17", da: "Develop a systematic approach to innovation."
                   },
                   {
                    id: "is-1-0-18", da: "Leverage customer feedback for improvements."
                   },
                   {
                    id: "is-1-0-19", da: "Focus on sustainability and environmental innovation."
                   },
                   {
                    id: "is-1-0-20", da: "Conduct regular brainstorming sessions."
                   },
                   {
                    id: "is-1-0-21", da: "Establish key performance indicators for innovation."
                   },
                   {
                    id: "is-1-0-22", da: "Pilot new technologies and solutions."
                   },
                   {
                    id: "is-1-0-23", da: "Seek out government grants or incentives for innovation."
                   },
                   {
                    id: "is-1-0-24", da: "Create an innovation budget."
                   },
                   {
                    id: "is-1-0-25", da: "Encourage employees to submit patent applications."
                   },
                   {
                    id: "is-1-0-26", da: "Implement agile and lean methodologies."
                   },
                   {
                    id: "is-1-0-27", da: "Establish innovation key result areas (KRAs)."
                   },
                   {
                    id: "is-1-0-28", da: "Map innovation to long-term business strategy."
                   },
                   {
                    id: "is-1-0-29", da: "Leverage design thinking principles."
                   },
                   {
                    id: "is-1-0-30", da: "Explore industry-specific innovation platforms."
                   },
                   {
                    id: "is-1-0-31", da: "Analyze and optimize innovation processes."
                   },
                   {
                    id: "is-1-0-32", da: "Leverage social media for innovation scouting."
                   },
                   {
                    id: "is-1-0-33", da: "Collaborate with industry associations."
                   },
                   {
                    id: "is-1-0-34", da: "Develop innovation partnerships with customers."
                   },
                   {
                    id: "is-1-0-35", da: "Implement stage-gate processes for innovations."
                   },
                   {
                    id: "is-1-0-36", da: "Utilize blockchain for supply chain innovation."
                   },
                   {
                    id: "is-1-0-37", da: "Focus on AI and machine learning advancements."
                   },
                   {
                    id: "is-1-0-38", da: "Encourage experimentation and risk-taking."
                   },
                   {
                    id: "is-1-0-39", da: "Set up innovation metrics and dashboards."
                   },
                   {
                    id: "is-1-0-40", da: "Develop innovation ecosystems in target regions."
                   },
                   {
                    id: "is-1-0-41", da: "Conduct regular technology scouting missions."
                   },
                   {
                    id: "is-1-0-42", da: "Foster innovation scouting through social networks."
                   },
                   {
                    id: "is-1-0-43", da: "Utilize innovation management software."
                   },
                   {
                    id: "is-1-0-44", da: "Expand into new markets through innovation."
                   },
                   {
                    id: "is-1-0-45", da: "Invest in innovation research and development."
                   },
                   {
                    id: "is-1-0-46", da: "Establish a dedicated innovation department."
                   },
                   {
                    id: "is-1-0-47", da: "Enhance the user experience through design."
                   },
                   {
                    id: "is-1-0-48", da: "Build a network of innovation champions."
                   },
                   {
                    id: "is-1-0-49", da: "Develop a comprehensive innovation strategy."
                   },
                ]
              },
              {
                id: 'is-1-1',
                pm: 'Enough content about how the community solves the market need is published for users to be aware. Prospects can do their own research before reaching out.',
                title:'Market',
                pmMap: 'Enough content about how the community solves the market need is published for users to be aware. Prospects can do their own research before reaching out.',
                developmentActions:[
                  {
                    id: "is-1-1-0", da: "Establish an innovation scouting team to identify new market trends."
                   },
                   {
                    id: "is-1-1-1", da: "Collaborate with startups and incubators to scout innovative solutions."
                   },
                   {
                    id: "is-1-1-2", da: "Conduct regular market research to stay updated on industry trends."
                   },
                   {
                    id: "is-1-1-3", da: "Leverage data analytics to identify emerging market opportunities."
                   },
                   {
                    id: "is-1-1-4", da: "Develop partnerships with universities for research and development."
                   },
                   {
                    id: "is-1-1-5", da: "Attend industry conferences and trade shows to scout new technologies."
                   },
                   {
                    id: "is-1-1-6", da: "Implement open innovation strategies to encourage external collaboration."
                   },
                   {
                    id: "is-1-1-7", da: "Create a dedicated innovation portal for idea submission."
                   },
                   {
                    id: "is-1-1-8", da: "Launch an innovation challenge or competition to attract talent."
                   },
                   {
                    id: "is-1-1-9", da: "Offer incentives for employees to suggest innovative ideas."
                   },
                   {
                    id: "is-1-1-10", da: "Establish a customer feedback mechanism for new product suggestions."
                   },
                   {
                    id: "is-1-1-11", da: "Develop a clear innovation strategy aligned with market goals."
                   },
                   {
                    id: "is-1-1-12", da: "Foster a culture of experimentation and risk-taking within the organization."
                   },
                   {
                    id: "is-1-1-13", da: "Identify gaps in the market and explore potential solutions."
                   },
                   {
                    id: "is-1-1-14", da: "Invest in research and development to create innovative products."
                   },
                   {
                    id: "is-1-1-15", da: "Form strategic alliances with competitors for mutual growth."
                   },
                   {
                    id: "is-1-1-16", da: "Seek external funding or venture capital for innovation projects."
                   },
                   {
                    id: "is-1-1-17", da: "Explore emerging markets and expand the geographical reach."
                   },
                   {
                    id: "is-1-1-18", da: "Develop a customer-centric approach to understand needs better."
                   },
                   {
                    id: "is-1-1-19", da: "Use social media and online platforms for outreach and feedback."
                   },
                   {
                    id: "is-1-1-20", da: "Create an innovation lab or center for experimentation."
                   },
                   {
                    id: "is-1-1-21", da: "Collaborate with government agencies for innovation grants."
                   },
                   {
                    id: "is-1-1-22", da: "Implement sustainability and eco-friendly initiatives."
                   },
                   {
                    id: "is-1-1-23", da: "Scout for mergers and acquisitions to expand market share."
                   },
                   {
                    id: "is-1-1-24", da: "Enhance the supply chain for improved product delivery."
                   },
                   {
                    id: "is-1-1-25", da: "Leverage big data and AI for market analysis and predictions."
                   },
                   {
                    id: "is-1-1-26", da: "Launch pilot programs to test new product concepts."
                   },
                   {
                    id: "is-1-1-27", da: "Build a network of industry experts and advisors."
                   },
                   {
                    id: "is-1-1-28", da: "Develop a responsive and user-friendly website."
                   },
                   {
                    id: "is-1-1-29", da: "Invest in employee training and development programs."
                   },
                   {
                    id: "is-1-1-30", da: "Improve customer support and engagement strategies."
                   },
                   {
                    id: "is-1-1-31", da: "Explore diversification opportunities within the industry."
                   },
                   {
                    id: "is-1-1-32", da: "Introduce subscription-based services or products."
                   },
                   {
                    id: "is-1-1-33", da: "Invest in market-specific advertising and branding."
                   },
                   {
                    id: "is-1-1-34", da: "Collaborate with influencers for brand promotion."
                   },
                   {
                    id: "is-1-1-35", da: "Expand product offerings to cater to a broader audience."
                   },
                   {
                    id: "is-1-1-36", da: "Localize marketing efforts for international markets."
                   },
                   {
                    id: "is-1-1-37", da: "Establish feedback loops with stakeholders for continuous improvement."
                   },
                   {
                    id: "is-1-1-38", da: "Create a mobile app for enhanced customer interaction."
                   },
                   {
                    id: "is-1-1-39", da: "Offer customization options for products or services."
                   },
                   {
                    id: "is-1-1-40", da: "Implement a loyalty program to retain existing customers."
                   },
                   {
                    id: "is-1-1-41", da: "Develop strategic pricing models to attract different customer segments."
                   },
                   {
                    id: "is-1-1-42", da: "Offer bundle deals or packages for cost savings."
                   },
                   {
                    id: "is-1-1-43", da: "Build strategic partnerships with complementary businesses."
                   },
                   {
                    id: "is-1-1-44", da: "Enhance product packaging and presentation."
                   },
                   {
                    id: "is-1-1-45", da: "Prioritize customer testimonials and case studies."
                   },
                   {
                    id: "is-1-1-46", da: "Ensure compliance with industry regulations and standards."
                   },
                   {
                    id: "is-1-1-47", da: "Optimize internal processes for greater efficiency."
                   },
                   {
                    id: "is-1-1-48", da: "Monitor and respond to online reviews and feedback."
                   },
                   {
                    id: "is-1-1-49", da: "Conduct regular market analysis and SWOT assessments."
                   },
                ]
              },
              {
                id: 'is-1-2',
                pm: 'Marketing funnel and about 8-12 first level touchpoints are strategized to build outbound campaign.',
                title:'Technology',
                pmMap: 'Marketing funnel and about 8-12 first level touchpoints are strategized to build outbound campaign.',
                developmentActions:[
                  {
                    id: "is-1-2-0", da: "Artificial intelligence and machine learning algorithms for predictive maintenance."
                   },
                   {
                    id: "is-1-2-1", da: "Blockchain technology for secure and transparent transactions."
                   },
                   {
                    id: "is-1-2-2", da: "IoT (Internet of Things) sensor networks for smart cities."
                   },
                   {
                    id: "is-1-2-3", da: "Advanced encryption techniques for data security."
                   },
                   {
                    id: "is-1-2-4", da: "Quantum computing for complex problem solving."
                   },
                   {
                    id: "is-1-2-5", da: "5G technology for faster and more reliable communication."
                   },
                   {
                    id: "is-1-2-6", da: "Robotics for automation in manufacturing."
                   },
                   {
                    id: "is-1-2-7", da: "Virtual reality (VR) for immersive training and experiences."
                   },
                   {
                    id: "is-1-2-8", da: "Augmented reality (AR) for enhancing user interfaces."
                   },
                   {
                    id: "is-1-2-9", da: "Sustainable energy solutions, like advanced solar panels."
                   },
                   {
                    id: "is-1-2-10", da: "Biotechnology for improved healthcare and pharmaceuticals."
                   },
                   {
                    id: "is-1-2-11", da: "Genetic engineering for personalized medicine."
                   },
                   {
                    id: "is-1-2-12", da: "Autonomous vehicles and self-driving technology."
                   },
                   {
                    id: "is-1-2-13", da: "Smart agriculture with IoT and data analytics."
                   },
                   {
                    id: "is-1-2-14", da: "Advanced materials for lighter and stronger structures."
                   },
                   {
                    id: "is-1-2-15", da: "Quantum communication for ultra-secure data transmission."
                   },
                   {
                    id: "is-1-2-16", da: "Cybersecurity measures and AI-driven threat detection."
                   },
                   {
                    id: "is-1-2-17", da: "Advanced drones for surveillance and delivery."
                   },
                   {
                    id: "is-1-2-18", da: "Renewable energy storage solutions."
                   },
                   {
                    id: "is-1-2-19", da: "Health informatics for better patient care."
                   },
                   {
                    id: "is-1-2-20", da: "Telemedicine and remote healthcare solutions."
                   },
                   {
                    id: "is-1-2-21", da: "Water purification and desalination technologies."
                   },
                   {
                    id: "is-1-2-22", da: "Waste management and recycling innovations."
                   },
                   {
                    id: "is-1-2-23", da: "Sustainable packaging materials."
                   },
                   {
                    id: "is-1-2-24", da: "Advanced supply chain management systems."
                   },
                   {
                    id: "is-1-2-25", da: "Artificial intelligence in education."
                   },
                   {
                    id: "is-1-2-26", da: "Smart grid technology for efficient energy distribution."
                   },
                   {
                    id: "is-1-2-27", da: "Biometric authentication methods."
                   },
                   {
                    id: "is-1-2-28", da: "Space exploration and colonization technology."
                   },
                   {
                    id: "is-1-2-29", da: "Advanced 3D printing techniques."
                   },
                   {
                    id: "is-1-2-30", da: "Quantum sensors for precise measurements."
                   },
                   {
                    id: "is-1-2-31", da: "Wearable health monitoring devices."
                   },
                   {
                    id: "is-1-2-32", da: "Nanotechnology for miniaturization."
                   },
                   {
                    id: "is-1-2-33", da: "Cognitive computing for decision support."
                   },
                   {
                    id: "is-1-2-34", da: "Data analytics for business intelligence."
                   },
                   {
                    id: "is-1-2-35", da: "Language translation and natural language processing."
                   },
                   {
                    id: "is-1-2-36", da: "Advanced imaging techniques for medical diagnosis."
                   },
                   {
                    id: "is-1-2-37", da: "Smart clothing and textiles."
                   },
                   {
                    id: "is-1-2-38", da: "Hydrogen fuel cell technology."
                   },
                   {
                    id: "is-1-2-39", da: "Advanced disaster management and prediction systems."
                   },
                   {
                    id: "is-1-2-40", da: "Remote working and collaboration tools."
                   },
                   {
                    id: "is-1-2-41", da: "Sustainable farming and aquaculture."
                   },
                   {
                    id: "is-1-2-42", da: "Advanced waste-to-energy solutions."
                   },
                   {
                    id: "is-1-2-43", da: "Clean and efficient public transportation."
                   },
                   {
                    id: "is-1-2-44", da: "Carbon capture and utilization technologies."
                   },
                   {
                    id: "is-1-2-45", da: "Space tourism and exploration infrastructure."
                   },
                   {
                    id: "is-1-2-46", da: "Autonomous underwater vehicles for ocean exploration."
                   },
                   {
                    id: "is-1-2-47", da: "Sustainable urban planning and design."
                   },
                   {
                    id: "is-1-2-48", da: "Advanced air quality monitoring systems."
                   },
                   {
                    id: "is-1-2-49", da: "Smart home automation and energy management."
                   },
                ]
              },
              {
                id: 'is-1-3',
                pm: 'Awareness is generated and people understand the message and are willing to explore more. Low bounce rates < 10% and high CTRs >10%.',
                title:'Value',
                pmMap: 'Awareness is generated and people understand the message and are willing to explore more. Low bounce rates < 10% and high CTRs >10%.',
                developmentActions:[
                  {
                    id: "is-1-3-0", da: "Explore emerging technologies for process optimization."
                   },
                   {
                    id: "is-1-3-1", da: "Identify market trends and adapt strategies accordingly."
                   },
                   {
                    id: "is-1-3-2", da: "Collaborate with startups for fresh perspectives."
                   },
                   {
                    id: "is-1-3-3", da: "Foster cross-functional collaboration within the organization."
                   },
                   {
                    id: "is-1-3-4", da: "Seek partnerships with industry experts."
                   },
                   {
                    id: "is-1-3-5", da: "Invest in employee training and development."
                   },
                   {
                    id: "is-1-3-6", da: "Conduct customer feedback surveys regularly."
                   },
                   {
                    id: "is-1-3-7", da: "Analyze competitor innovations for inspiration."
                   },
                   {
                    id: "is-1-3-8", da: "Develop a culture of continuous learning."
                   },
                   {
                    id: "is-1-3-9", da: "Create innovation teams within the organization."
                   },
                   {
                    id: "is-1-3-10", da: "Implement agile methodologies for faster development."
                   },
                   {
                    id: "is-1-3-11", da: "Leverage open-source solutions for cost savings."
                   },
                   {
                    id: "is-1-3-12", da: "Enhance data analytics capabilities."
                   },
                   {
                    id: "is-1-3-13", da: "Explore new distribution channels."
                   },
                   {
                    id: "is-1-3-14", da: "Optimize supply chain operations."
                   },
                   {
                    id: "is-1-3-15", da: "Enhance cybersecurity measures."
                   },
                   {
                    id: "is-1-3-16", da: "Invest in sustainability initiatives."
                   },
                   {
                    id: "is-1-3-17", da: "Develop a more diverse workforce."
                   },
                   {
                    id: "is-1-3-18", da: "Improve customer support through AI chatbots."
                   },
                   {
                    id: "is-1-3-19", da: "Foster a culture of intrapreneurship."
                   },
                   {
                    id: "is-1-3-20", da: "Investigate opportunities for globalization."
                   },
                   {
                    id: "is-1-3-21", da: "Develop personalized marketing strategies."
                   },
                   {
                    id: "is-1-3-22", da: "Explore blockchain technology for transparency."
                   },
                   {
                    id: "is-1-3-23", da: "Embrace automation for repetitive tasks."
                   },
                   {
                    id: "is-1-3-24", da: "Invest in design thinking for product innovation."
                   },
                   {
                    id: "is-1-3-25", da: "Optimize manufacturing processes."
                   },
                   {
                    id: "is-1-3-26", da: "Foster partnerships with research institutions."
                   },
                   {
                    id: "is-1-3-27", da: "Leverage data for predictive maintenance."
                   },
                   {
                    id: "is-1-3-28", da: "Enhance the customer experience through UX\/UI improvements."
                   },
                   {
                    id: "is-1-3-29", da: "Investigate opportunities in the gig economy."
                   },
                   {
                    id: "is-1-3-30", da: "Implement a corporate social responsibility program."
                   },
                   {
                    id: "is-1-3-31", da: "Explore new revenue streams."
                   },
                   {
                    id: "is-1-3-32", da: "Optimize pricing strategies."
                   },
                   {
                    id: "is-1-3-33", da: "Develop a strong employer brand."
                   },
                   {
                    id: "is-1-3-34", da: "Invest in cloud-based infrastructure."
                   },
                   {
                    id: "is-1-3-35", da: "Enhance brand storytelling for engagement."
                   },
                   {
                    id: "is-1-3-36", da: "Investigate opportunities in the circular economy."
                   },
                   {
                    id: "is-1-3-37", da: "Develop a mobile app for improved user engagement."
                   },
                   {
                    id: "is-1-3-38", da: "Optimize content marketing strategies."
                   },
                   {
                    id: "is-1-3-39", da: "Foster a culture of innovation across all departments."
                   },
                   {
                    id: "is-1-3-40", da: "Investigate opportunities in the sharing economy."
                   },
                   {
                    id: "is-1-3-41", da: "Enhance product packaging for sustainability."
                   },
                   {
                    id: "is-1-3-42", da: "Develop a corporate innovation lab."
                   },
                   {
                    id: "is-1-3-43", da: "Optimize e-commerce platforms."
                   },
                   {
                    id: "is-1-3-44", da: "Explore opportunities for 3D printing."
                   },
                   {
                    id: "is-1-3-45", da: "Foster partnerships with local communities."
                   },
                   {
                    id: "is-1-3-46", da: "Investigate opportunities in the Internet of Things (IoT)."
                   },
                   {
                    id: "is-1-3-47", da: "Enhance talent acquisition through technology."
                   },
                   {
                    id: "is-1-3-48", da: "Develop innovation metrics for performance tracking."
                   },
                   {
                    id: "is-1-3-49", da: "Invest in market research for data-driven decisions."
                   },
                ]
              },
              {
                id: 'is-1-4',
                pm: 'Estimate CAC.',
                title:'Business Model',
                pmMap: 'Estimate CAC.',
                developmentActions:[
                  {
                    id: "is-1-4-0", da: "Explore new revenue streams."
                   },
                   {
                    id: "is-1-4-1", da: "Identify cost reduction opportunities."
                   },
                   {
                    id: "is-1-4-2", da: "Analyze market trends to adapt your pricing strategy."
                   },
                   {
                    id: "is-1-4-3", da: "Research and implement subscription-based models."
                   },
                   {
                    id: "is-1-4-4", da: "Consider the introduction of tiered pricing."
                   },
                   {
                    id: "is-1-4-5", da: "Investigate strategic partnerships for cost-sharing."
                   },
                   {
                    id: "is-1-4-6", da: "Evaluate the feasibility of a freemium model."
                   },
                   {
                    id: "is-1-4-7", da: "Assess opportunities in emerging markets."
                   },
                   {
                    id: "is-1-4-8", da: "Analyze customer segments for untapped potential."
                   },
                   {
                    id: "is-1-4-9", da: "Research and implement a direct-to-consumer channel."
                   },
                   {
                    id: "is-1-4-10", da: "Explore outsourcing non-core business functions."
                   },
                   {
                    id: "is-1-4-11", da: "Investigate cross-selling and upselling strategies."
                   },
                   {
                    id: "is-1-4-12", da: "Evaluate the feasibility of product bundling."
                   },
                   {
                    id: "is-1-4-13", da: "Examine the potential for white-labeling your products."
                   },
                   {
                    id: "is-1-4-14", da: "Invest in data analytics for better decision-making."
                   },
                   {
                    id: "is-1-4-15", da: "Explore opportunities for international expansion."
                   },
                   {
                    id: "is-1-4-16", da: "Assess the potential for mergers and acquisitions."
                   },
                   {
                    id: "is-1-4-17", da: "Investigate the adoption of blockchain technology."
                   },
                   {
                    id: "is-1-4-18", da: "Research opportunities in sustainable and eco-friendly practices."
                   },
                   {
                    id: "is-1-4-19", da: "Assess the viability of digital transformation."
                   },
                   {
                    id: "is-1-4-20", da: "Consider offering personalized products or services."
                   },
                   {
                    id: "is-1-4-21", da: "Investigate the introduction of a mobile app."
                   },
                   {
                    id: "is-1-4-22", da: "Explore opportunities in e-commerce and online sales."
                   },
                   {
                    id: "is-1-4-23", da: "Invest in marketing automation for lead generation."
                   },
                   {
                    id: "is-1-4-24", da: "Analyze customer retention strategies."
                   },
                   {
                    id: "is-1-4-25", da: "Assess the potential for gamification in your business."
                   },
                   {
                    id: "is-1-4-26", da: "Investigate opportunities for employee training and development."
                   },
                   {
                    id: "is-1-4-27", da: "Explore remote work and virtual teams."
                   },
                   {
                    id: "is-1-4-28", da: "Consider a loyalty program for existing customers."
                   },
                   {
                    id: "is-1-4-29", da: "Assess the viability of AI and machine learning."
                   },
                   {
                    id: "is-1-4-30", da: "Investigate regulatory compliance and risk management."
                   },
                   {
                    id: "is-1-4-31", da: "Explore crowdfunding or alternative financing."
                   },
                   {
                    id: "is-1-4-32", da: "Consider the introduction of a chatbot for customer support."
                   },
                   {
                    id: "is-1-4-33", da: "Investigate the potential for 3D printing technology."
                   },
                   {
                    id: "is-1-4-34", da: "Evaluate opportunities in the Internet of Things (IoT)."
                   },
                   {
                    id: "is-1-4-35", da: "Assess the feasibility of a voice search strategy."
                   },
                   {
                    id: "is-1-4-36", da: "Explore opportunities for content marketing."
                   },
                   {
                    id: "is-1-4-37", da: "Investigate the introduction of a referral program."
                   },
                   {
                    id: "is-1-4-38", da: "Assess the potential for a content subscription model."
                   },
                   {
                    id: "is-1-4-39", da: "Explore influencer marketing collaborations."
                   },
                   {
                    id: "is-1-4-40", da: "Investigate the potential for virtual or augmented reality."
                   },
                   {
                    id: "is-1-4-41", da: "Consider offering a product customization feature."
                   },
                   {
                    id: "is-1-4-42", da: "Assess opportunities for employee well-being initiatives."
                   },
                   {
                    id: "is-1-4-43", da: "Investigate the potential for a circular economy approach."
                   },
                   {
                    id: "is-1-4-44", da: "Explore opportunities in predictive maintenance."
                   },
                   {
                    id: "is-1-4-45", da: "Investigate the use of data-driven decision-making."
                   },
                   {
                    id: "is-1-4-46", da: "Assess the feasibility of an on-demand service model."
                   },
                   {
                    id: "is-1-4-47", da: "Consider offering microservices or APIs."
                   },
                   {
                    id: "is-1-4-48", da: "Investigate opportunities in green supply chain management."
                   },
                   {
                    id: "is-1-4-49", da: "Assess the potential for patents or intellectual property development."
                   },
                ]
              },
              {
                id: 'is-1-5',
                pm: 'Adding campaigns, referral programs, ambassador incentives to create a positive feedback loop.',
                title:'Go to Market',
                pmMap: 'Adding campaigns, referral programs, ambassador incentives to create a positive feedback loop.',
                developmentActions:[
                  {
                    id: "is-1-5-0", da: "Identify emerging market trends and technologies."
                   },
                   {
                    id: "is-1-5-1", da: "Monitor competitor strategies and innovations."
                   },
                   {
                    id: "is-1-5-2", da: "Collaborate with startups and accelerators."
                   },
                   {
                    id: "is-1-5-3", da: "Engage with industry influencers and thought leaders."
                   },
                   {
                    id: "is-1-5-4", da: "Attend relevant industry conferences and events."
                   },
                   {
                    id: "is-1-5-5", da: "Conduct customer surveys and feedback analysis."
                   },
                   {
                    id: "is-1-5-6", da: "Create cross-functional innovation teams."
                   },
                   {
                    id: "is-1-5-7", da: "Develop a culture of continuous learning and improvement."
                   },
                   {
                    id: "is-1-5-8", da: "Invest in market research and analysis."
                   },
                   {
                    id: "is-1-5-9", da: "Leverage data analytics for insights."
                   },
                   {
                    id: "is-1-5-10", da: "Explore new distribution channels and partnerships."
                   },
                   {
                    id: "is-1-5-11", da: "Optimize the pricing strategy."
                   },
                   {
                    id: "is-1-5-12", da: "Implement agile product development."
                   },
                   {
                    id: "is-1-5-13", da: "Focus on customer-centric product design."
                   },
                   {
                    id: "is-1-5-14", da: "Expand into new geographic markets."
                   },
                   {
                    id: "is-1-5-15", da: "Leverage social media and content marketing."
                   },
                   {
                    id: "is-1-5-16", da: "Build strategic alliances and joint ventures."
                   },
                   {
                    id: "is-1-5-17", da: "Enhance supply chain efficiency."
                   },
                   {
                    id: "is-1-5-18", da: "Invest in R&D and product innovation."
                   },
                   {
                    id: "is-1-5-19", da: "Develop a strong employer brand."
                   },
                   {
                    id: "is-1-5-20", da: "Embrace sustainability and CSR initiatives."
                   },
                   {
                    id: "is-1-5-21", da: "Enhance customer support and service."
                   },
                   {
                    id: "is-1-5-22", da: "Optimize the sales process."
                   },
                   {
                    id: "is-1-5-23", da: "Provide personalized product recommendations."
                   },
                   {
                    id: "is-1-5-24", da: "Enhance user experience through UX\/UI design."
                   },
                   {
                    id: "is-1-5-25", da: "Implement lean startup methodologies."
                   },
                   {
                    id: "is-1-5-26", da: "Develop a robust content marketing strategy."
                   },
                   {
                    id: "is-1-5-27", da: "Improve employee training and development."
                   },
                   {
                    id: "is-1-5-28", da: "Identify underserved customer segments."
                   },
                   {
                    id: "is-1-5-29", da: "Collaborate with design thinking experts."
                   },
                   {
                    id: "is-1-5-30", da: "Enhance the after-sales service experience."
                   },
                   {
                    id: "is-1-5-31", da: "Develop a competitive differentiation strategy."
                   },
                   {
                    id: "is-1-5-32", da: "Create a clear Go-to-Market roadmap."
                   },
                   {
                    id: "is-1-5-33", da: "Invest in emerging technology like AI and IoT."
                   },
                   {
                    id: "is-1-5-34", da: "Foster a culture of experimentation."
                   },
                   {
                    id: "is-1-5-35", da: "Conduct market segmentation and targeting."
                   },
                   {
                    id: "is-1-5-36", da: "Explore alternative revenue streams."
                   },
                   {
                    id: "is-1-5-37", da: "Invest in branding and brand identity."
                   },
                   {
                    id: "is-1-5-38", da: "Optimize lead generation and conversion."
                   },
                   {
                    id: "is-1-5-39", da: "Enhance customer relationship management."
                   },
                   {
                    id: "is-1-5-40", da: "Monitor regulatory changes and compliance."
                   },
                   {
                    id: "is-1-5-41", da: "Invest in customer retention programs."
                   },
                   {
                    id: "is-1-5-42", da: "Leverage e-commerce and mobile apps."
                   },
                   {
                    id: "is-1-5-43", da: "Explore niche markets and micro-segments."
                   },
                   {
                    id: "is-1-5-44", da: "Develop innovative packaging and design."
                   },
                   {
                    id: "is-1-5-45", da: "Implement a product launch strategy."
                   },
                   {
                    id: "is-1-5-46", da: "Focus on agile supply chain management."
                   },
                   {
                    id: "is-1-5-47", da: "Enhance digital marketing efforts."
                   },
                   {
                    id: "is-1-5-48", da: "Implement customer journey mapping."
                   },
                   {
                    id: "is-1-5-49", da: "Evaluate and adapt to feedback and results."
                   },
                ]
              },
              {
                id: 'is-1-6',
                pm: 'Core team is formed that attracts key talents and scout for users. Values are made explicit and lived by everyone in the team. Go out with team intros on social media.',
                title:'People',
                pmMap: 'Core team is formed that attracts key talents and scout for users. Values are made explicit and lived by everyone in the team. Go out with team intros on social media.',
                developmentActions:[
                  {
                    id: "is-1-6-0", da: "Establish mentorship programs to foster professional development."
                   },
                   {
                    id: "is-1-6-1", da: "Encourage continuous learning through workshops and training sessions."
                   },
                   {
                    id: "is-1-6-2", da: "Promote a culture of innovation and risk-taking."
                   },
                   {
                    id: "is-1-6-3", da: "Recognize and reward innovative ideas and contributions."
                   },
                   {
                    id: "is-1-6-4", da: "Foster cross-functional collaboration and knowledge sharing."
                   },
                   {
                    id: "is-1-6-5", da: "Provide opportunities for skill development and upskilling."
                   },
                   {
                    id: "is-1-6-6", da: "Offer leadership development programs."
                   },
                   {
                    id: "is-1-6-7", da: "Implement flexible work arrangements to improve work-life balance."
                   },
                   {
                    id: "is-1-6-8", da: "Create a diverse and inclusive workplace."
                   },
                   {
                    id: "is-1-6-9", da: "Support employee wellness and mental health."
                   },
                   {
                    id: "is-1-6-10", da: "Encourage employees to take on new challenges."
                   },
                   {
                    id: "is-1-6-11", da: "Provide access to innovation tools and resources."
                   },
                   {
                    id: "is-1-6-12", da: "Embrace remote work and digital collaboration."
                   },
                   {
                    id: "is-1-6-13", da: "Offer opportunities for creativity and problem-solving."
                   },
                   {
                    id: "is-1-6-14", da: "Establish innovation labs or incubators."
                   },
                   {
                    id: "is-1-6-15", da: "Implement regular feedback and performance reviews."
                   },
                   {
                    id: "is-1-6-16", da: "Support intrapreneurship and internal startups."
                   },
                   {
                    id: "is-1-6-17", da: "Encourage networking and industry engagement."
                   },
                   {
                    id: "is-1-6-18", da: "Create a supportive environment for failure and learning."
                   },
                   {
                    id: "is-1-6-19", da: "Implement agile methodologies in project management."
                   },
                   {
                    id: "is-1-6-20", da: "Develop a strong company culture and values."
                   },
                   {
                    id: "is-1-6-21", da: "Promote ethical and responsible innovation."
                   },
                   {
                    id: "is-1-6-22", da: "Offer career progression paths and opportunities."
                   },
                   {
                    id: "is-1-6-23", da: "Foster a growth mindset in employees."
                   },
                   {
                    id: "is-1-6-24", da: "Encourage continuous improvement in processes."
                   },
                   {
                    id: "is-1-6-25", da: "Provide access to data and analytics for decision-making."
                   },
                   {
                    id: "is-1-6-26", da: "Promote knowledge transfer and succession planning."
                   },
                   {
                    id: "is-1-6-27", da: "Develop a clear innovation strategy and goals."
                   },
                   {
                    id: "is-1-6-28", da: "Encourage employees to become thought leaders."
                   },
                   {
                    id: "is-1-6-29", da: "Support employee resource groups (ERGs)."
                   },
                   {
                    id: "is-1-6-30", da: "Implement employee recognition programs."
                   },
                   {
                    id: "is-1-6-31", da: "Invest in emerging technologies and tools."
                   },
                   {
                    id: "is-1-6-32", da: "Foster curiosity and exploration."
                   },
                   {
                    id: "is-1-6-33", da: "Enable cross-training and skill diversification."
                   },
                   {
                    id: "is-1-6-34", da: "Promote a culture of open communication."
                   },
                   {
                    id: "is-1-6-35", da: "Provide access to innovation funding and grants."
                   },
                   {
                    id: "is-1-6-36", da: "Support a balance between work and personal development."
                   },
                   {
                    id: "is-1-6-37", da: "Encourage volunteering and community engagement."
                   },
                   {
                    id: "is-1-6-38", da: "Develop leadership and soft skills."
                   },
                   {
                    id: "is-1-6-39", da: "Foster an entrepreneurial mindset."
                   },
                   {
                    id: "is-1-6-40", da: "Create a supportive onboarding process."
                   },
                   {
                    id: "is-1-6-41", da: "Promote knowledge sharing platforms."
                   },
                   {
                    id: "is-1-6-42", da: "Offer sabbatical opportunities for personal growth."
                   },
                   {
                    id: "is-1-6-43", da: "Implement employee engagement surveys."
                   },
                   {
                    id: "is-1-6-44", da: "Encourage reverse mentoring (young mentoring senior)."
                   },
                   {
                    id: "is-1-6-45", da: "Create an environment for open brainstorming."
                   },
                   {
                    id: "is-1-6-46", da: "Support self-directed learning."
                   },
                   {
                    id: "is-1-6-47", da: "Offer access to innovation literature and resources."
                   },
                   {
                    id: "is-1-6-48", da: "Encourage participation in hackathons and competitions."
                   },
                   {
                    id: "is-1-6-49", da: "Continuously seek feedback and adapt to changing needs."
                   },
                ]
              },
              {
                id: 'is-1-7',
                pm: 'Marketing metrics throughout the acquisition funnel are trackeable. Qualitative surveys and other techniques are implemented to understand important KPIs.',
                title:'Data Metrics',
                pmMap: 'Marketing metrics throughout the acquisition funnel are trackeable. Qualitative surveys and other techniques are implemented to understand important KPIs.',
                developmentActions:[
                  {
                    id: "is-1-7-0", da: "Establish a dedicated data analytics team."
                   },
                   {
                    id: "is-1-7-1", da: "Identify key performance indicators (KPIs) for your development project."
                   },
                   {
                    id: "is-1-7-2", da: "Implement data collection and tracking tools."
                   },
                   {
                    id: "is-1-7-3", da: "Analyze historical data to identify trends and patterns."
                   },
                   {
                    id: "is-1-7-4", da: "Use data to identify areas in need of improvement."
                   },
                   {
                    id: "is-1-7-5", da: "Collaborate with experts in data analysis."
                   },
                   {
                    id: "is-1-7-6", da: "Implement a data-driven decision-making process."
                   },
                   {
                    id: "is-1-7-7", da: "Conduct regular data audits to ensure data quality."
                   },
                   {
                    id: "is-1-7-8", da: "Develop a data governance framework."
                   },
                   {
                    id: "is-1-7-9", da: "Create dashboards for real-time data monitoring."
                   },
                   {
                    id: "is-1-7-10", da: "Utilize machine learning for predictive analytics."
                   },
                   {
                    id: "is-1-7-11", da: "Implement data visualization techniques."
                   },
                   {
                    id: "is-1-7-12", da: "Foster a data-driven culture within the organization."
                   },
                   {
                    id: "is-1-7-13", da: "Explore new data sources and partnerships."
                   },
                   {
                    id: "is-1-7-14", da: "Leverage IoT devices for data collection."
                   },
                   {
                    id: "is-1-7-15", da: "Invest in data security and privacy."
                   },
                   {
                    id: "is-1-7-16", da: "Implement data anonymization techniques."
                   },
                   {
                    id: "is-1-7-17", da: "Explore open data initiatives."
                   },
                   {
                    id: "is-1-7-18", da: "Engage with data scientists and researchers."
                   },
                   {
                    id: "is-1-7-19", da: "Implement A\/B testing for data-driven experiments."
                   },
                   {
                    id: "is-1-7-20", da: "Utilize sentiment analysis for feedback data."
                   },
                   {
                    id: "is-1-7-21", da: "Develop data sharing agreements with stakeholders."
                   },
                   {
                    id: "is-1-7-22", da: "Automate data collection and reporting processes."
                   },
                   {
                    id: "is-1-7-23", da: "Conduct regular data-driven workshops and training."
                   },
                   {
                    id: "is-1-7-24", da: "Benchmark data metrics against industry standards."
                   },
                   {
                    id: "is-1-7-25", da: "Foster data collaboration with other organizations."
                   },
                   {
                    id: "is-1-7-26", da: "Use geospatial data for location-based insights."
                   },
                   {
                    id: "is-1-7-27", da: "Experiment with different data visualization tools."
                   },
                   {
                    id: "is-1-7-28", da: "Encourage data-driven innovation competitions."
                   },
                   {
                    id: "is-1-7-29", da: "Share data insights with the public for transparency."
                   },
                   {
                    id: "is-1-7-30", da: "Implement data ethics guidelines."
                   },
                   {
                    id: "is-1-7-31", da: "Use data for risk assessment and mitigation."
                   },
                   {
                    id: "is-1-7-32", da: "Analyze data for cost-saving opportunities."
                   },
                   {
                    id: "is-1-7-33", da: "Explore the potential of blockchain for data integrity."
                   },
                   {
                    id: "is-1-7-34", da: "Develop a data warehouse for centralized storage."
                   },
                   {
                    id: "is-1-7-35", da: "Utilize big data technologies for scalability."
                   },
                   {
                    id: "is-1-7-36", da: "Collect data from user feedback and surveys."
                   },
                   {
                    id: "is-1-7-37", da: "Monitor data metrics in real-time during projects."
                   },
                   {
                    id: "is-1-7-38", da: "Utilize data for resource allocation optimization."
                   },
                   {
                    id: "is-1-7-39", da: "Implement data analytics for fraud detection."
                   },
                   {
                    id: "is-1-7-40", da: "Improve data accessibility for decision-makers."
                   },
                   {
                    id: "is-1-7-41", da: "Share data metrics with donors and supporters."
                   },
                   {
                    id: "is-1-7-42", da: "Establish a data innovation lab."
                   },
                   {
                    id: "is-1-7-43", da: "Investigate the potential of data monetization."
                   },
                   {
                    id: "is-1-7-44", da: "Use data to measure the impact of interventions."
                   },
                   {
                    id: "is-1-7-45", da: "Implement data-driven storytelling for outreach."
                   },
                   {
                    id: "is-1-7-46", da: "Conduct data-driven impact assessments."
                   },
                   {
                    id: "is-1-7-47", da: "Utilize social media analytics for outreach."
                   },
                   {
                    id: "is-1-7-48", da: "Engage with data-focused conferences and events."
                   },
                   {
                    id: "is-1-7-49", da: "Continuously iterate and improve data strategies based on feedback."
                   },
                ]
              },
              {
                id: 'is-1-8',
                pm: '',
                title:'Operations',
                pmMap: '',
                developmentActions:[
                  {
                    id: "is-1-8-0", da: "Implement Lean Manufacturing principles."
                   },
                   {
                    id: "is-1-8-1", da: "Optimize supply chain management."
                   },
                   {
                    id: "is-1-8-2", da: "Automate routine administrative tasks."
                   },
                   {
                    id: "is-1-8-3", da: "Improve employee training and development programs."
                   },
                   {
                    id: "is-1-8-4", da: "Enhance quality control processes."
                   },
                   {
                    id: "is-1-8-5", da: "Streamline inventory management."
                   },
                   {
                    id: "is-1-8-6", da: "Invest in energy-efficient technologies."
                   },
                   {
                    id: "is-1-8-7", da: "Upgrade data analytics and reporting tools."
                   },
                   {
                    id: "is-1-8-8", da: "Implement predictive maintenance for machinery."
                   },
                   {
                    id: "is-1-8-9", da: "Explore sustainable manufacturing practices."
                   },
                   {
                    id: "is-1-8-10", da: "Enhance workplace safety protocols."
                   },
                   {
                    id: "is-1-8-11", da: "Invest in IoT for real-time monitoring."
                   },
                   {
                    id: "is-1-8-12", da: "Optimize the production process."
                   },
                   {
                    id: "is-1-8-13", da: "Implement a Just-in-Time (JIT) inventory system."
                   },
                   {
                    id: "is-1-8-14", da: "Improve waste management and recycling."
                   },
                   {
                    id: "is-1-8-15", da: "Develop a flexible workforce."
                   },
                   {
                    id: "is-1-8-16", da: "Enhance product packaging for sustainability."
                   },
                   {
                    id: "is-1-8-17", da: "Implement digital twins for production lines."
                   },
                   {
                    id: "is-1-8-18", da: "Upgrade ERP systems for better resource planning."
                   },
                   {
                    id: "is-1-8-19", da: "Explore 3D printing for rapid prototyping."
                   },
                   {
                    id: "is-1-8-20", da: "Implement Total Quality Management (TQM)."
                   },
                   {
                    id: "is-1-8-21", da: "Optimize maintenance schedules."
                   },
                   {
                    id: "is-1-8-22", da: "Improve communication within the organization."
                   },
                   {
                    id: "is-1-8-23", da: "Implement advanced robotics in production."
                   },
                   {
                    id: "is-1-8-24", da: "Explore AI-driven process optimization."
                   },
                   {
                    id: "is-1-8-25", da: "Upgrade the company's cybersecurity."
                   },
                   {
                    id: "is-1-8-26", da: "Enhance customer relationship management."
                   },
                   {
                    id: "is-1-8-27", da: "Optimize sales and marketing strategies."
                   },
                   {
                    id: "is-1-8-28", da: "Implement a paperless office."
                   },
                   {
                    id: "is-1-8-29", da: "Improve disaster recovery and business continuity plans."
                   },
                   {
                    id: "is-1-8-30", da: "Explore new markets for expansion."
                   },
                   {
                    id: "is-1-8-31", da: "Invest in green and sustainable technologies."
                   },
                   {
                    id: "is-1-8-32", da: "Upgrade employee benefits and well-being programs."
                   },
                   {
                    id: "is-1-8-33", da: "Optimize IT infrastructure for scalability."
                   },
                   {
                    id: "is-1-8-34", da: "Implement remote work and telecommuting options."
                   },
                   {
                    id: "is-1-8-35", da: "Develop a culture of continuous improvement."
                   },
                   {
                    id: "is-1-8-36", da: "Enhance feedback and suggestion systems."
                   },
                   {
                    id: "is-1-8-37", da: "Invest in renewable energy sources."
                   },
                   {
                    id: "is-1-8-38", da: "Improve workplace ergonomics."
                   },
                   {
                    id: "is-1-8-39", da: "Streamline the onboarding process."
                   },
                   {
                    id: "is-1-8-40", da: "Develop partnerships with research institutions."
                   },
                   {
                    id: "is-1-8-41", da: "Implement virtual reality for training and design."
                   },
                   {
                    id: "is-1-8-42", da: "Optimize the procurement process."
                   },
                   {
                    id: "is-1-8-43", da: "Explore automation in customer support."
                   },
                   {
                    id: "is-1-8-44", da: "Upgrade fleet management for logistics."
                   },
                   {
                    id: "is-1-8-45", da: "Implement AI-driven demand forecasting."
                   },
                   {
                    id: "is-1-8-46", da: "Enhance data security and compliance."
                   },
                   {
                    id: "is-1-8-47", da: "Optimize the customer service experience."
                   },
                   {
                    id: "is-1-8-48", da: "Develop a corporate social responsibility program."
                   },
                   {
                    id: "is-1-8-49", da: "Explore alternative materials for production."
                   },
                ]
              },
              {
                id: 'is-1-9',
                pm: 'Basic data room ready including pitch deck, financials, legal docs.',
                title:'Exit Strategy',
                pmMap: 'Basic data room ready including pitch deck, financials, legal docs.',
                developmentActions:[
                  {
                    id: "is-1-9-0", da: "Define clear exit goals and objectives."
                   },
                   {
                    id: "is-1-9-1", da: "Consider various exit options, including acquisition, IPO, or strategic partnerships."
                   },
                   {
                    id: "is-1-9-2", da: "Assess the timing of the exit in relation to market conditions."
                   },
                   {
                    id: "is-1-9-3", da: "Evaluate the scalability of the innovation to attract potential buyers."
                   },
                   {
                    id: "is-1-9-4", da: "Identify potential acquirers or investors."
                   },
                   {
                    id: "is-1-9-5", da: "Establish a target valuation for the exit."
                   },
                   {
                    id: "is-1-9-6", da: "Develop a comprehensive exit plan."
                   },
                   {
                    id: "is-1-9-7", da: "Consider the impact on existing stakeholders."
                   },
                   {
                    id: "is-1-9-8", da: "Assess legal and regulatory requirements."
                   },
                   {
                    id: "is-1-9-9", da: "Ensure the innovation is adequately protected through patents or intellectual property rights."
                   },
                   {
                    id: "is-1-9-10", da: "Evaluate potential risks and challenges associated with the exit."
                   },
                   {
                    id: "is-1-9-11", da: "Monitor market trends and competitors."
                   },
                   {
                    id: "is-1-9-12", da: "Conduct due diligence on potential exit partners."
                   },
                   {
                    id: "is-1-9-13", da: "Consider the impact on employees and staff."
                   },
                   {
                    id: "is-1-9-14", da: "Address any outstanding debt or financial obligations."
                   },
                   {
                    id: "is-1-9-15", da: "Evaluate the potential for a phased exit strategy."
                   },
                   {
                    id: "is-1-9-16", da: "Consider the tax implications of the exit."
                   },
                   {
                    id: "is-1-9-17", da: "Assess the cultural fit with potential partners."
                   },
                   {
                    id: "is-1-9-18", da: "Review the innovation's financial performance and growth potential."
                   },
                   {
                    id: "is-1-9-19", da: "Plan for a seamless transition during the exit."
                   },
                   {
                    id: "is-1-9-20", da: "Consider earn-out agreements or performance-based incentives."
                   },
                   {
                    id: "is-1-9-21", da: "Communicate the exit strategy clearly to all stakeholders."
                   },
                   {
                    id: "is-1-9-22", da: "Prepare for post-exit responsibilities, such as compliance and reporting."
                   },
                   {
                    id: "is-1-9-23", da: "Explore potential exit financing options."
                   },
                   {
                    id: "is-1-9-24", da: "Address any potential conflicts of interest."
                   },
                   {
                    id: "is-1-9-25", da: "Develop a communication plan for the exit announcement."
                   },
                   {
                    id: "is-1-9-26", da: "Ensure all contracts and agreements are in order."
                   },
                   {
                    id: "is-1-9-27", da: "Assess the impact on customers and clients."
                   },
                   {
                    id: "is-1-9-28", da: "Consider the role of the founding team after the exit."
                   },
                   {
                    id: "is-1-9-29", da: "Prepare for the integration process with the acquirer."
                   },
                   {
                    id: "is-1-9-30", da: "Evaluate the impact on suppliers and partners."
                   },
                   {
                    id: "is-1-9-31", da: "Assess the effect on company culture."
                   },
                   {
                    id: "is-1-9-32", da: "Consider the long-term impact on the innovation's brand and reputation."
                   },
                   {
                    id: "is-1-9-33", da: "Evaluate the impact on innovation development and R&D efforts."
                   },
                   {
                    id: "is-1-9-34", da: "Address any potential antitrust or regulatory concerns."
                   },
                   {
                    id: "is-1-9-35", da: "Plan for a post-exit wind-down period."
                   },
                   {
                    id: "is-1-9-36", da: "Ensure key employees are retained during the transition."
                   },
                   {
                    id: "is-1-9-37", da: "Communicate the exit strategy to employees early and transparently."
                   },
                   {
                    id: "is-1-9-38", da: "Address any potential intellectual property disputes."
                   },
                   {
                    id: "is-1-9-39", da: "Evaluate the impact on the local community or region."
                   },
                   {
                    id: "is-1-9-40", da: "Plan for the distribution of proceeds among stakeholders."
                   },
                   {
                    id: "is-1-9-41", da: "Consider the impact on shareholders and equity holders."
                   },
                   {
                    id: "is-1-9-42", da: "Assess the potential for non-compete agreements."
                   },
                   {
                    id: "is-1-9-43", da: "Plan for potential post-exit liabilities."
                   },
                   {
                    id: "is-1-9-44", da: "Ensure customer data and sensitive information are handled appropriately."
                   },
                   {
                    id: "is-1-9-45", da: "Review and update the company's organizational structure."
                   },
                   {
                    id: "is-1-9-46", da: "Assess the impact on ongoing business operations."
                   },
                   {
                    id: "is-1-9-47", da: "Consider the effect on innovation-related partnerships and collaborations."
                   },
                   {
                    id: "is-1-9-48", da: "Address potential contractual obligations with third parties."
                   },
                   {
                    id: "is-1-9-49", da: "Monitor the exit strategy's execution and make necessary adjustments."
                   },
                ]
              },           
            ]
          },
          {
            id: 'is-2',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Attracting Leads',
            wdd: '',
            progressMeasures:[
              {
                id: 'is-2-0',
                pm: 'Users reaching back can articulate their need which is syncronous to the brand position.',
                title:'Need',
                pmMap: 'Users reaching back can articulate their need which is syncronous to the brand position.',
                developmentActions:[
                  {
                    id: "is-2-0-0", da: "Establish a dedicated innovation team."
                   },
                   {
                    id: "is-2-0-1", da: "Define clear innovation objectives."
                   },
                   {
                    id: "is-2-0-2", da: "Create an innovation-friendly culture."
                   },
                   {
                    id: "is-2-0-3", da: "Invest in innovation training."
                   },
                   {
                    id: "is-2-0-4", da: "Engage with startup incubators and accelerators."
                   },
                   {
                    id: "is-2-0-5", da: "Attend innovation-focused events and conferences."
                   },
                   {
                    id: "is-2-0-6", da: "Collaborate with universities for research partnerships."
                   },
                   {
                    id: "is-2-0-7", da: "Leverage social media for innovation scouting."
                   },
                   {
                    id: "is-2-0-8", da: "Conduct open innovation challenges."
                   },
                   {
                    id: "is-2-0-9", da: "Partner with venture capitalists."
                   },
                   {
                    id: "is-2-0-10", da: "Encourage cross-functional collaboration."
                   },
                   {
                    id: "is-2-0-11", da: "Implement an idea management system."
                   },
                   {
                    id: "is-2-0-12", da: "Provide incentives for innovative ideas."
                   },
                   {
                    id: "is-2-0-13", da: "Foster diversity and inclusion in innovation efforts."
                   },
                   {
                    id: "is-2-0-14", da: "Develop innovation-focused KPIs."
                   },
                   {
                    id: "is-2-0-15", da: "Conduct brainstorming sessions regularly."
                   },
                   {
                    id: "is-2-0-16", da: "Encourage employees to take risks."
                   },
                   {
                    id: "is-2-0-17", da: "Build an innovation lab or workspace."
                   },
                   {
                    id: "is-2-0-18", da: "Seek industry-specific innovation insights."
                   },
                   {
                    id: "is-2-0-19", da: "Foster customer feedback and co-creation."
                   },
                   {
                    id: "is-2-0-20", da: "Invest in data analytics for insights."
                   },
                   {
                    id: "is-2-0-21", da: "Collaborate with technology scouting firms."
                   },
                   {
                    id: "is-2-0-22", da: "Establish innovation partnerships with suppliers."
                   },
                   {
                    id: "is-2-0-23", da: "Explore mergers and acquisitions."
                   },
                   {
                    id: "is-2-0-24", da: "Create a strategic roadmap for innovation."
                   },
                   {
                    id: "is-2-0-25", da: "Monitor industry trends and disruptions."
                   },
                   {
                    id: "is-2-0-26", da: "Leverage AI and machine learning for insights."
                   },
                   {
                    id: "is-2-0-27", da: "Embrace open-source innovation."
                   },
                   {
                    id: "is-2-0-28", da: "Promote a fail-fast, learn-fast mindset."
                   },
                   {
                    id: "is-2-0-29", da: "Encourage employees to think like customers."
                   },
                   {
                    id: "is-2-0-30", da: "Launch a corporate innovation challenge."
                   },
                   {
                    id: "is-2-0-31", da: "Share success stories across the organization."
                   },
                   {
                    id: "is-2-0-32", da: "Develop a clear intellectual property strategy."
                   },
                   {
                    id: "is-2-0-33", da: "Identify underutilized resources for innovation."
                   },
                   {
                    id: "is-2-0-34", da: "Leverage the power of crowd innovation."
                   },
                   {
                    id: "is-2-0-35", da: "Encourage employees to spend time on side projects."
                   },
                   {
                    id: "is-2-0-36", da: "Host innovation hackathons."
                   },
                   {
                    id: "is-2-0-37", da: "Collaborate with design thinking experts."
                   },
                   {
                    id: "is-2-0-38", da: "Encourage intrapreneurship."
                   },
                   {
                    id: "is-2-0-39", da: "Develop innovation partnerships with customers."
                   },
                   {
                    id: "is-2-0-40", da: "Regularly review and update your innovation strategy."
                   },
                   {
                    id: "is-2-0-41", da: "Use blockchain for secure collaboration."
                   },
                   {
                    id: "is-2-0-42", da: "Invest in emerging technologies."
                   },
                   {
                    id: "is-2-0-43", da: "Explore partnerships with government agencies."
                   },
                   {
                    id: "is-2-0-44", da: "Benchmark against industry leaders."
                   },
                   {
                    id: "is-2-0-45", da: "Attend trade shows and exhibitions."
                   },
                   {
                    id: "is-2-0-46", da: "Develop a strong presence on innovation platforms."
                   },
                   {
                    id: "is-2-0-47", da: "Create a dedicated innovation website."
                   },
                   {
                    id: "is-2-0-48", da: "Use agile methodologies for innovation projects."
                   },
                   {
                    id: "is-2-0-49", da: "Regularly communicate your organization's innovation goals and achievements."
                   },
                ]
              },
              {
                id: 'is-2-1',
                pm: 'Brand is able to generate inbound leads atleast 1 per week.',
                title:'Market',
                pmMap: 'Brand is able to generate inbound leads atleast 1 per week.',
                developmentActions:[
                  {
                    id: "is-2-1-0", da: "Conduct market research to identify emerging trends."
                   },
                   {
                    id: "is-2-1-1", da: "Identify underserved market segments."
                   },
                   {
                    id: "is-2-1-2", da: "Foster partnerships with industry influencers."
                   },
                   {
                    id: "is-2-1-3", da: "Offer free webinars or workshops on industry trends."
                   },
                   {
                    id: "is-2-1-4", da: "Create informative blog content on relevant topics."
                   },
                   {
                    id: "is-2-1-5", da: "Leverage social media for targeted marketing."
                   },
                   {
                    id: "is-2-1-6", da: "Collaborate with universities for research projects."
                   },
                   {
                    id: "is-2-1-7", da: "Develop case studies showcasing successful innovations."
                   },
                   {
                    id: "is-2-1-8", da: "Engage in co-creation with customers."
                   },
                   {
                    id: "is-2-1-9", da: "Attend industry-specific trade shows and conferences."
                   },
                   {
                    id: "is-2-1-10", da: "Create a dedicated innovation webpage."
                   },
                   {
                    id: "is-2-1-11", da: "Implement an email marketing campaign."
                   },
                   {
                    id: "is-2-1-12", da: "Partner with innovation-focused organizations."
                   },
                   {
                    id: "is-2-1-13", da: "Publish whitepapers on market insights."
                   },
                   {
                    id: "is-2-1-14", da: "Offer innovative product demonstrations."
                   },
                   {
                    id: "is-2-1-15", da: "Collaborate with startups for fresh ideas."
                   },
                   {
                    id: "is-2-1-16", da: "Highlight customer success stories."
                   },
                   {
                    id: "is-2-1-17", da: "Use interactive content like quizzes."
                   },
                   {
                    id: "is-2-1-18", da: "Run online contests for innovative ideas."
                   },
                   {
                    id: "is-2-1-19", da: "Offer exclusive insights through a newsletter."
                   },
                   {
                    id: "is-2-1-20", da: "Create thought leadership content."
                   },
                   {
                    id: "is-2-1-21", da: "Develop innovative product prototypes."
                   },
                   {
                    id: "is-2-1-22", da: "Use augmented reality for immersive experiences."
                   },
                   {
                    id: "is-2-1-23", da: "Create online communities for idea sharing."
                   },
                   {
                    id: "is-2-1-24", da: "Promote innovation culture within the company."
                   },
                   {
                    id: "is-2-1-25", da: "Launch pilot programs for new concepts."
                   },
                   {
                    id: "is-2-1-26", da: "Explore crowdfunding for innovative projects."
                   },
                   {
                    id: "is-2-1-27", da: "Create educational content on innovation."
                   },
                   {
                    id: "is-2-1-28", da: "Host innovation-focused podcasts."
                   },
                   {
                    id: "is-2-1-29", da: "Conduct surveys to gather market insights."
                   },
                   {
                    id: "is-2-1-30", da: "Offer product trials to potential clients."
                   },
                   {
                    id: "is-2-1-31", da: "Collaborate with research institutions."
                   },
                   {
                    id: "is-2-1-32", da: "Leverage AI for data-driven insights."
                   },
                   {
                    id: "is-2-1-33", da: "Use retargeting ads for lead nurturing."
                   },
                   {
                    id: "is-2-1-34", da: "Organize innovation challenges."
                   },
                   {
                    id: "is-2-1-35", da: "Build strategic alliances with complementary businesses."
                   },
                   {
                    id: "is-2-1-36", da: "Host virtual networking events."
                   },
                   {
                    id: "is-2-1-37", da: "Create innovation awards or recognitions."
                   },
                   {
                    id: "is-2-1-38", da: "Provide incentives for idea submissions."
                   },
                   {
                    id: "is-2-1-39", da: "Engage with innovation-focused forums."
                   },
                   {
                    id: "is-2-1-40", da: "Implement chatbots for customer interaction."
                   },
                   {
                    id: "is-2-1-41", da: "Develop an innovation-focused app."
                   },
                   {
                    id: "is-2-1-42", da: "Offer free e-books on industry trends."
                   },
                   {
                    id: "is-2-1-43", da: "Organize meetups for like-minded professionals."
                   },
                   {
                    id: "is-2-1-44", da: "Use testimonials from satisfied clients."
                   },
                   {
                    id: "is-2-1-45", da: "Offer personalized product recommendations."
                   },
                   {
                    id: "is-2-1-46", da: "Leverage video content for engagement."
                   },
                   {
                    id: "is-2-1-47", da: "Collaborate with research think tanks."
                   },
                   {
                    id: "is-2-1-48", da: "Use gamification for idea generation."
                   },
                   {
                    id: "is-2-1-49", da: "Continuously solicit feedback from your audience."
                   },
                ]
              },
              {
                id: 'is-2-2',
                pm: 'A CRM is set to manage leads.',
                title:'Technology',
                pmMap: 'A CRM is set to manage leads.',
                developmentActions:[
                  {
                    id: "is-2-2-0", da: "Implement Artificial Intelligence (AI) and Machine Learning (ML) for lead prediction."
                   },
                   {
                    id: "is-2-2-1", da: "Develop a more user-friendly and intuitive website for lead generation."
                   },
                   {
                    id: "is-2-2-2", da: "Use chatbots to engage with website visitors and gather leads."
                   },
                   {
                    id: "is-2-2-3", da: "Invest in advanced data analytics for lead segmentation."
                   },
                   {
                    id: "is-2-2-4", da: "Enhance cybersecurity measures to protect sensitive lead data."
                   },
                   {
                    id: "is-2-2-5", da: "Optimize your CRM system for better lead management."
                   },
                   {
                    id: "is-2-2-6", da: "Implement blockchain for secure and transparent lead tracking."
                   },
                   {
                    id: "is-2-2-7", da: "Develop a mobile app for lead capture on the go."
                   },
                   {
                    id: "is-2-2-8", da: "Integrate voice search for lead discovery."
                   },
                   {
                    id: "is-2-2-9", da: "Implement IoT devices for gathering leads from physical locations."
                   },
                   {
                    id: "is-2-2-10", da: "Use predictive analytics to identify emerging trends in lead generation."
                   },
                   {
                    id: "is-2-2-11", da: "Incorporate virtual reality (VR) and augmented reality (AR) for immersive lead experiences."
                   },
                   {
                    id: "is-2-2-12", da: "Leverage big data to target leads more effectively."
                   },
                   {
                    id: "is-2-2-13", da: "Enhance the use of social media for lead generation."
                   },
                   {
                    id: "is-2-2-14", da: "Develop a lead scoring system to prioritize high-quality leads."
                   },
                   {
                    id: "is-2-2-15", da: "Utilize marketing automation tools for lead nurturing."
                   },
                   {
                    id: "is-2-2-16", da: "Implement geolocation-based lead targeting."
                   },
                   {
                    id: "is-2-2-17", da: "Improve website loading speed for better lead conversion."
                   },
                   {
                    id: "is-2-2-18", da: "Use gamification to engage and capture leads."
                   },
                   {
                    id: "is-2-2-19", da: "Incorporate voice assistants like Amazon Alexa and Google Assistant."
                   },
                   {
                    id: "is-2-2-20", da: "Enhance email marketing with personalization and segmentation."
                   },
                   {
                    id: "is-2-2-21", da: "Implement a referral program to attract leads through customer recommendations."
                   },
                   {
                    id: "is-2-2-22", da: "Leverage video marketing for lead engagement."
                   },
                   {
                    id: "is-2-2-23", da: "Utilize content marketing for thought leadership and lead attraction."
                   },
                   {
                    id: "is-2-2-24", da: "Develop a mobile-responsive design for lead capture forms."
                   },
                   {
                    id: "is-2-2-25", da: "Invest in A\/B testing for better lead conversion rates."
                   },
                   {
                    id: "is-2-2-26", da: "Implement a subscription model for lead nurturing."
                   },
                   {
                    id: "is-2-2-27", da: "Use influencer marketing to attract leads."
                   },
                   {
                    id: "is-2-2-28", da: "Create a lead magnet, such as eBooks or whitepapers."
                   },
                   {
                    id: "is-2-2-29", da: "Develop partnerships with industry influencers for lead referrals."
                   },
                   {
                    id: "is-2-2-30", da: "Improve data cleansing and validation to ensure lead accuracy."
                   },
                   {
                    id: "is-2-2-31", da: "Integrate real-time chat features for lead engagement."
                   },
                   {
                    id: "is-2-2-32", da: "Utilize social proof to build trust and attract leads."
                   },
                   {
                    id: "is-2-2-33", da: "Create interactive content to engage and capture leads."
                   },
                   {
                    id: "is-2-2-34", da: "Implement SEO best practices for better lead visibility."
                   },
                   {
                    id: "is-2-2-35", da: "Enhance data visualization for better lead insights."
                   },
                   {
                    id: "is-2-2-36", da: "Develop a lead attribution model to track lead sources."
                   },
                   {
                    id: "is-2-2-37", da: "Implement a loyalty program for lead retention."
                   },
                   {
                    id: "is-2-2-38", da: "Utilize cross-channel marketing for lead outreach."
                   },
                   {
                    id: "is-2-2-39", da: "Invest in 5G technology for faster lead interactions."
                   },
                   {
                    id: "is-2-2-40", da: "Implement a lead lifecycle model for comprehensive lead management."
                   },
                   {
                    id: "is-2-2-41", da: "Use mobile push notifications to re-engage leads."
                   },
                   {
                    id: "is-2-2-42", da: "Develop a lead segmentation strategy based on behavior."
                   },
                   {
                    id: "is-2-2-43", da: "Integrate CRM with social media for lead insights."
                   },
                   {
                    id: "is-2-2-44", da: "Utilize chatbots for lead qualification."
                   },
                   {
                    id: "is-2-2-45", da: "Implement sentiment analysis for lead feedback."
                   },
                   {
                    id: "is-2-2-46", da: "Use social listening to identify potential leads."
                   },
                   {
                    id: "is-2-2-47", da: "Develop a personalized lead onboarding process."
                   },
                   {
                    id: "is-2-2-48", da: "Utilize interactive quizzes and surveys for lead capture."
                   },
                   {
                    id: "is-2-2-49", da: "Invest in continuous training and development for your lead generation team."
                   },
                ]
              },
              {
                id: 'is-2-3',
                pm: 'New users return and stick, leading to recurring value exchange and increasing revenue growth.',
                title:'Value',
                pmMap: 'New users return and stick, leading to recurring value exchange and increasing revenue growth.',
                developmentActions:[
                  {
                    id: "is-2-3-0", da: "Identify emerging market trends."
                   },
                   {
                    id: "is-2-3-1", da: "Enhance market research capabilities."
                   },
                   {
                    id: "is-2-3-2", da: "Develop partnerships with research institutions."
                   },
                   {
                    id: "is-2-3-3", da: "Improve competitive analysis."
                   },
                   {
                    id: "is-2-3-4", da: "Enhance lead generation through data analytics."
                   },
                   {
                    id: "is-2-3-5", da: "Implement predictive lead scoring models."
                   },
                   {
                    id: "is-2-3-6", da: "Create targeted content marketing strategies."
                   },
                   {
                    id: "is-2-3-7", da: "Foster industry partnerships."
                   },
                   {
                    id: "is-2-3-8", da: "Enhance the use of social media for lead generation."
                   },
                   {
                    id: "is-2-3-9", da: "Develop referral programs."
                   },
                   {
                    id: "is-2-3-10", da: "Improve CRM systems."
                   },
                   {
                    id: "is-2-3-11", da: "Implement marketing automation."
                   },
                   {
                    id: "is-2-3-12", da: "Optimize lead nurturing processes."
                   },
                   {
                    id: "is-2-3-13", da: "Strengthen brand reputation."
                   },
                   {
                    id: "is-2-3-14", da: "Enhance customer relationship management."
                   },
                   {
                    id: "is-2-3-15", da: "Expand the use of chatbots for lead engagement."
                   },
                   {
                    id: "is-2-3-16", da: "Invest in AI-driven marketing tools."
                   },
                   {
                    id: "is-2-3-17", da: "Implement A\/B testing for lead conversion."
                   },
                   {
                    id: "is-2-3-18", da: "Enhance lead segmentation."
                   },
                   {
                    id: "is-2-3-19", da: "Personalize lead outreach."
                   },
                   {
                    id: "is-2-3-20", da: "Strengthen email marketing campaigns."
                   },
                   {
                    id: "is-2-3-21", da: "Develop lead qualification criteria."
                   },
                   {
                    id: "is-2-3-22", da: "Enhance lead tracking and reporting."
                   },
                   {
                    id: "is-2-3-23", da: "Implement lead magnet strategies."
                   },
                   {
                    id: "is-2-3-24", da: "Optimize landing pages."
                   },
                   {
                    id: "is-2-3-25", da: "Create targeted webinars and events."
                   },
                   {
                    id: "is-2-3-26", da: "Improve SEO strategies."
                   },
                   {
                    id: "is-2-3-27", da: "Invest in paid advertising campaigns."
                   },
                   {
                    id: "is-2-3-28", da: "Develop a content calendar."
                   },
                   {
                    id: "is-2-3-29", da: "Enhance lead nurturing workflows."
                   },
                   {
                    id: "is-2-3-30", da: "Optimize lead conversion funnels."
                   },
                   {
                    id: "is-2-3-31", da: "Strengthen lead follow-up processes."
                   },
                   {
                    id: "is-2-3-32", da: "Implement lead scoring based on engagement."
                   },
                   {
                    id: "is-2-3-33", da: "Foster partnerships with industry influencers."
                   },
                   {
                    id: "is-2-3-34", da: "Invest in customer testimonial campaigns."
                   },
                   {
                    id: "is-2-3-35", da: "Develop referral programs."
                   },
                   {
                    id: "is-2-3-36", da: "Strengthen PR and media outreach."
                   },
                   {
                    id: "is-2-3-37", da: "Enhance trade show and conference participation."
                   },
                   {
                    id: "is-2-3-38", da: "Invest in thought leadership content."
                   },
                   {
                    id: "is-2-3-39", da: "Create gated content resources."
                   },
                   {
                    id: "is-2-3-40", da: "Optimize website user experience."
                   },
                   {
                    id: "is-2-3-41", da: "Foster customer reviews and testimonials."
                   },
                   {
                    id: "is-2-3-42", da: "Develop competitive pricing strategies."
                   },
                   {
                    id: "is-2-3-43", da: "Enhance product or service quality."
                   },
                   {
                    id: "is-2-3-44", da: "Expand product offerings."
                   },
                   {
                    id: "is-2-3-45", da: "Improve supply chain and logistics."
                   },
                   {
                    id: "is-2-3-46", da: "Optimize customer support."
                   },
                   {
                    id: "is-2-3-47", da: "Foster customer loyalty programs."
                   },
                   {
                    id: "is-2-3-48", da: "Invest in employee training and development."
                   },
                   {
                    id: "is-2-3-49", da: "Evaluate and refine your innovation scouting and lead attraction strategies regularly."
                   },
                ]
              },
              {
                id: 'is-2-4',
                pm: 'Estimate CLV and know how to reach positive unit economics with lead generation. Know the pricing.',
                title:'Business Model',
                pmMap: 'Estimate CLV and know how to reach positive unit economics with lead generation. Know the pricing.',
                developmentActions:[
                  {
                    id: "is-2-4-0", da: "Explore new market segments to target."
                   },
                   {
                    id: "is-2-4-1", da: "Identify emerging trends that align with your offerings."
                   },
                   {
                    id: "is-2-4-2", da: "Collaborate with startups for fresh insights."
                   },
                   {
                    id: "is-2-4-3", da: "Develop partnerships with industry influencers."
                   },
                   {
                    id: "is-2-4-4", da: "Conduct competitor analysis to identify gaps."
                   },
                   {
                    id: "is-2-4-5", da: "Innovate pricing strategies for better customer value."
                   },
                   {
                    id: "is-2-4-6", da: "Expand product\/service offerings based on market demands."
                   },
                   {
                    id: "is-2-4-7", da: "Invest in research and development for new products."
                   },
                   {
                    id: "is-2-4-8", da: "Leverage data analytics for informed decisions."
                   },
                   {
                    id: "is-2-4-9", da: "Create a customer-centric culture within your organization."
                   },
                   {
                    id: "is-2-4-10", da: "Implement agile methodologies to adapt quickly."
                   },
                   {
                    id: "is-2-4-11", da: "Foster an environment for cross-functional innovation."
                   },
                   {
                    id: "is-2-4-12", da: "Develop a robust feedback loop with customers."
                   },
                   {
                    id: "is-2-4-13", da: "Create unique value propositions for different segments."
                   },
                   {
                    id: "is-2-4-14", da: "Embrace sustainability and social responsibility."
                   },
                   {
                    id: "is-2-4-15", da: "Innovate your supply chain for efficiency."
                   },
                   {
                    id: "is-2-4-16", da: "Optimize your sales and distribution channels."
                   },
                   {
                    id: "is-2-4-17", da: "Explore international markets for growth."
                   },
                   {
                    id: "is-2-4-18", da: "Establish partnerships for joint ventures."
                   },
                   {
                    id: "is-2-4-19", da: "Invest in technology to improve operations."
                   },
                   {
                    id: "is-2-4-20", da: "Develop a continuous learning culture."
                   },
                   {
                    id: "is-2-4-21", da: "Gamify elements of your product or service."
                   },
                   {
                    id: "is-2-4-22", da: "Enhance customer experience through personalization."
                   },
                   {
                    id: "is-2-4-23", da: "Create an open innovation ecosystem."
                   },
                   {
                    id: "is-2-4-24", da: "Develop a loyalty program for customer retention."
                   },
                   {
                    id: "is-2-4-25", da: "Streamline internal processes through automation."
                   },
                   {
                    id: "is-2-4-26", da: "Embrace a remote or hybrid work model."
                   },
                   {
                    id: "is-2-4-27", da: "Invest in employee training and development."
                   },
                   {
                    id: "is-2-4-28", da: "Innovate your marketing and advertising strategies."
                   },
                   {
                    id: "is-2-4-29", da: "Prioritize mobile and online presence."
                   },
                   {
                    id: "is-2-4-30", da: "Leverage emerging technologies (AI, blockchain, etc.)."
                   },
                   {
                    id: "is-2-4-31", da: "Implement agile marketing campaigns."
                   },
                   {
                    id: "is-2-4-32", da: "Focus on user-generated content and reviews."
                   },
                   {
                    id: "is-2-4-33", da: "Offer flexible payment options for customers."
                   },
                   {
                    id: "is-2-4-34", da: "Develop an omnichannel sales approach."
                   },
                   {
                    id: "is-2-4-35", da: "Create innovative packaging and branding."
                   },
                   {
                    id: "is-2-4-36", da: "Collaborate with universities for research."
                   },
                   {
                    id: "is-2-4-37", da: "Experiment with subscription-based models."
                   },
                   {
                    id: "is-2-4-38", da: "Explore new ways to source raw materials."
                   },
                   {
                    id: "is-2-4-39", da: "Develop a crisis management strategy."
                   },
                   {
                    id: "is-2-4-40", da: "Create innovative partnerships with NGOs."
                   },
                   {
                    id: "is-2-4-41", da: "Innovate your customer service experience."
                   },
                   {
                    id: "is-2-4-42", da: "Offer limited-time promotions and exclusives."
                   },
                   {
                    id: "is-2-4-43", da: "Experiment with alternative revenue streams."
                   },
                   {
                    id: "is-2-4-44", da: "Embrace the circular economy and recycling."
                   },
                   {
                    id: "is-2-4-45", da: "Offer customization options for products."
                   },
                   {
                    id: "is-2-4-46", da: "Build a strong employer brand."
                   },
                   {
                    id: "is-2-4-47", da: "Develop content marketing strategies."
                   },
                   {
                    id: "is-2-4-48", da: "Invest in cybersecurity and data protection."
                   },
                   {
                    id: "is-2-4-49", da: "Continuously monitor market dynamics and adapt."
                   },
                ]
              },
              {
                id: 'is-2-5',
                pm: 'Referrals and case studies from lighthouse customers support new customers acquisition.',
                title:'Go to Market',
                pmMap: 'Referrals and case studies from lighthouse customers support new customers acquisition.',
                developmentActions:[
                  {
                    id: "is-2-5-0", da: "Identify emerging market trends and technologies."
                   },
                   {
                    id: "is-2-5-1", da: "Foster relationships with industry influencers."
                   },
                   {
                    id: "is-2-5-2", da: "Create thought leadership content to establish authority."
                   },
                   {
                    id: "is-2-5-3", da: "Collaborate with startups and accelerators."
                   },
                   {
                    id: "is-2-5-4", da: "Offer webinars on relevant industry topics."
                   },
                   {
                    id: "is-2-5-5", da: "Launch targeted email marketing campaigns."
                   },
                   {
                    id: "is-2-5-6", da: "Participate in industry conferences and expos."
                   },
                   {
                    id: "is-2-5-7", da: "Use data analytics to refine your lead generation strategy."
                   },
                   {
                    id: "is-2-5-8", da: "Develop a referral program for satisfied customers."
                   },
                   {
                    id: "is-2-5-9", da: "Run online ads on relevant platforms."
                   },
                   {
                    id: "is-2-5-10", da: "Engage in social media marketing."
                   },
                   {
                    id: "is-2-5-11", da: "Build a strong online presence through SEO."
                   },
                   {
                    id: "is-2-5-12", da: "Develop engaging landing pages."
                   },
                   {
                    id: "is-2-5-13", da: "Use chatbots for instant customer support."
                   },
                   {
                    id: "is-2-5-14", da: "Offer free resources in exchange for contact information."
                   },
                   {
                    id: "is-2-5-15", da: "Leverage user-generated content."
                   },
                   {
                    id: "is-2-5-16", da: "Launch a podcast or YouTube channel."
                   },
                   {
                    id: "is-2-5-17", da: "Provide case studies on successful projects."
                   },
                   {
                    id: "is-2-5-18", da: "Develop interactive infographics."
                   },
                   {
                    id: "is-2-5-19", da: "Create a knowledge-sharing community."
                   },
                   {
                    id: "is-2-5-20", da: "Participate in online forums and Q&A sites."
                   },
                   {
                    id: "is-2-5-21", da: "Optimize your website for mobile users."
                   },
                   {
                    id: "is-2-5-22", da: "Conduct A\/B testing on landing pages."
                   },
                   {
                    id: "is-2-5-23", da: "Offer personalized product demos."
                   },
                   {
                    id: "is-2-5-24", da: "Build partnerships with complementary businesses."
                   },
                   {
                    id: "is-2-5-25", da: "Implement lead scoring for prioritization."
                   },
                   {
                    id: "is-2-5-26", da: "Host virtual events and webinars."
                   },
                   {
                    id: "is-2-5-27", da: "Collect and utilize customer feedback."
                   },
                   {
                    id: "is-2-5-28", da: "Use retargeting ads for visitors."
                   },
                   {
                    id: "is-2-5-29", da: "Showcase customer testimonials and reviews."
                   },
                   {
                    id: "is-2-5-30", da: "Nurture leads through email drip campaigns."
                   },
                   {
                    id: "is-2-5-31", da: "Develop targeted content for different buyer personas."
                   },
                   {
                    id: "is-2-5-32", da: "Analyze competitors' strategies."
                   },
                   {
                    id: "is-2-5-33", da: "Implement referral marketing programs."
                   },
                   {
                    id: "is-2-5-34", da: "Create explainer videos for your solutions."
                   },
                   {
                    id: "is-2-5-35", da: "Invest in content syndication."
                   },
                   {
                    id: "is-2-5-36", da: "Publish whitepapers and eBooks."
                   },
                   {
                    id: "is-2-5-37", da: "Provide free tools or calculators."
                   },
                   {
                    id: "is-2-5-38", da: "Share success stories on social media."
                   },
                   {
                    id: "is-2-5-39", da: "Offer early access to exclusive content."
                   },
                   {
                    id: "is-2-5-40", da: "Use LinkedIn for B2B lead generation."
                   },
                   {
                    id: "is-2-5-41", da: "Conduct market research to identify pain points."
                   },
                   {
                    id: "is-2-5-42", da: "Collaborate with influencers on social media."
                   },
                   {
                    id: "is-2-5-43", da: "Provide clear and compelling calls to action."
                   },
                   {
                    id: "is-2-5-44", da: "Use data enrichment tools to enhance lead profiles."
                   },
                   {
                    id: "is-2-5-45", da: "Leverage chat marketing for real-time engagement."
                   },
                   {
                    id: "is-2-5-46", da: "Utilize targeted account-based marketing (ABM)."
                   },
                   {
                    id: "is-2-5-47", da: "Develop partnerships with industry associations."
                   },
                   {
                    id: "is-2-5-48", da: "Invest in marketing automation tools."
                   },
                   {
                    id: "is-2-5-49", da: "Continuously measure and adjust your lead generation strategy for improvement."
                   },
                ]
              },
              {
                id: 'is-2-6',
                pm: 'Team has strong industry contacts in their marker.',
                title:'People',
                pmMap: 'Team has strong industry contacts in their marker.',
                developmentActions:[
                  {
                    id: "is-2-6-0", da: "Enhance team collaboration to generate innovative ideas."
                   },
                   {
                    id: "is-2-6-1", da: "Foster a culture of continuous learning and development."
                   },
                   {
                    id: "is-2-6-2", da: "Develop a clear recruitment strategy for attracting top talent."
                   },
                   {
                    id: "is-2-6-3", da: "Train employees on lead generation and nurturing."
                   },
                   {
                    id: "is-2-6-4", da: "Encourage networking and relationship building."
                   },
                   {
                    id: "is-2-6-5", da: "Improve communication skills for better lead engagement."
                   },
                   {
                    id: "is-2-6-6", da: "Invest in leadership training for managers."
                   },
                   {
                    id: "is-2-6-7", da: "Offer mentorship programs for employees."
                   },
                   {
                    id: "is-2-6-8", da: "Enhance employee motivation and job satisfaction."
                   },
                   {
                    id: "is-2-6-9", da: "Develop strong problem-solving skills."
                   },
                   {
                    id: "is-2-6-10", da: "Encourage creativity and out-of-the-box thinking."
                   },
                   {
                    id: "is-2-6-11", da: "Promote a customer-centric mindset."
                   },
                   {
                    id: "is-2-6-12", da: "Strengthen data analysis and interpretation skills."
                   },
                   {
                    id: "is-2-6-13", da: "Develop expertise in market research."
                   },
                   {
                    id: "is-2-6-14", da: "Train in customer relationship management (CRM) tools."
                   },
                   {
                    id: "is-2-6-15", da: "Enhance public speaking and presentation skills."
                   },
                   {
                    id: "is-2-6-16", da: "Foster a diverse and inclusive workplace."
                   },
                   {
                    id: "is-2-6-17", da: "Develop expertise in emerging technologies."
                   },
                   {
                    id: "is-2-6-18", da: "Train in social media marketing for lead generation."
                   },
                   {
                    id: "is-2-6-19", da: "Improve negotiation skills for partnerships."
                   },
                   {
                    id: "is-2-6-20", da: "Encourage a proactive attitude in employees."
                   },
                   {
                    id: "is-2-6-21", da: "Train in data privacy and security practices."
                   },
                   {
                    id: "is-2-6-22", da: "Develop empathy and active listening skills."
                   },
                   {
                    id: "is-2-6-23", da: "Improve time management and organization."
                   },
                   {
                    id: "is-2-6-24", da: "Invest in sales and marketing training."
                   },
                   {
                    id: "is-2-6-25", da: "Foster adaptability and agility in employees."
                   },
                   {
                    id: "is-2-6-26", da: "Develop a customer service-oriented mindset."
                   },
                   {
                    id: "is-2-6-27", da: "Train in conflict resolution and mediation."
                   },
                   {
                    id: "is-2-6-28", da: "Improve project management skills."
                   },
                   {
                    id: "is-2-6-29", da: "Encourage cross-functional teamwork."
                   },
                   {
                    id: "is-2-6-30", da: "Develop industry-specific knowledge."
                   },
                   {
                    id: "is-2-6-31", da: "Train in email marketing for lead nurturing."
                   },
                   {
                    id: "is-2-6-32", da: "Enhance data analytics and reporting skills."
                   },
                   {
                    id: "is-2-6-33", da: "Invest in sales funnel optimization."
                   },
                   {
                    id: "is-2-6-34", da: "Foster a risk-taking culture."
                   },
                   {
                    id: "is-2-6-35", da: "Develop effective storytelling skills."
                   },
                   {
                    id: "is-2-6-36", da: "Train in account-based marketing (ABM) strategies."
                   },
                   {
                    id: "is-2-6-37", da: "Improve cold outreach and prospecting abilities."
                   },
                   {
                    id: "is-2-6-38", da: "Invest in emotional intelligence training."
                   },
                   {
                    id: "is-2-6-39", da: "Foster a feedback-driven environment."
                   },
                   {
                    id: "is-2-6-40", da: "Develop skills in data-driven decision-making."
                   },
                   {
                    id: "is-2-6-41", da: "Train in market segmentation and targeting."
                   },
                   {
                    id: "is-2-6-42", da: "Enhance competitor analysis skills."
                   },
                   {
                    id: "is-2-6-43", da: "Invest in personal branding for employees."
                   },
                   {
                    id: "is-2-6-44", da: "Foster customer journey mapping skills."
                   },
                   {
                    id: "is-2-6-45", da: "Train in content marketing for lead generation."
                   },
                   {
                    id: "is-2-6-46", da: "Improve cross-cultural communication."
                   },
                   {
                    id: "is-2-6-47", da: "Develop technical knowledge as needed."
                   },
                   {
                    id: "is-2-6-48", da: "Invest in continuous improvement initiatives."
                   },
                   {
                    id: "is-2-6-49", da: "Foster a growth mindset in your organization."
                   },
                ]
              },
              {
                id: 'is-2-7',
                pm: 'Based on financial plan, basic community KPIs are established and are regularly reviewed.',
                title:'Data Metrics',
                pmMap: 'Based on financial plan, basic community KPIs are established and are regularly reviewed.',
                developmentActions:[
                  {
                    id: "is-2-7-0", da: "Define clear data objectives for your innovation scouting efforts."
                   },
                   {
                    id: "is-2-7-1", da: "Develop a comprehensive data strategy."
                   },
                   {
                    id: "is-2-7-2", da: "Implement a robust data collection and storage system."
                   },
                   {
                    id: "is-2-7-3", da: "Ensure data accuracy and reliability."
                   },
                   {
                    id: "is-2-7-4", da: "Regularly audit and clean your data."
                   },
                   {
                    id: "is-2-7-5", da: "Employ data validation techniques to eliminate errors."
                   },
                   {
                    id: "is-2-7-6", da: "Create a data governance framework to maintain data quality."
                   },
                   {
                    id: "is-2-7-7", da: "Utilize data profiling to identify inconsistencies."
                   },
                   {
                    id: "is-2-7-8", da: "Standardize data formats and conventions."
                   },
                   {
                    id: "is-2-7-9", da: "Implement data security measures to protect sensitive information."
                   },
                   {
                    id: "is-2-7-10", da: "Enhance data privacy compliance."
                   },
                   {
                    id: "is-2-7-11", da: "Develop data quality metrics to measure and track improvements."
                   },
                   {
                    id: "is-2-7-12", da: "Employ data deduplication techniques."
                   },
                   {
                    id: "is-2-7-13", da: "Implement a master data management system."
                   },
                   {
                    id: "is-2-7-14", da: "Use data enrichment services to enhance existing data."
                   },
                   {
                    id: "is-2-7-15", da: "Continuously monitor data for inconsistencies."
                   },
                   {
                    id: "is-2-7-16", da: "Leverage machine learning for data analysis."
                   },
                   {
                    id: "is-2-7-17", da: "Employ data visualization tools for better insights."
                   },
                   {
                    id: "is-2-7-18", da: "Conduct sentiment analysis to understand leads' sentiments."
                   },
                   {
                    id: "is-2-7-19", da: "Implement natural language processing for text data."
                   },
                   {
                    id: "is-2-7-20", da: "Use data segmentation for targeted lead generation."
                   },
                   {
                    id: "is-2-7-21", da: "Analyze historical data to identify trends and patterns."
                   },
                   {
                    id: "is-2-7-22", da: "Implement data warehousing for centralized storage."
                   },
                   {
                    id: "is-2-7-23", da: "Ensure data scalability to handle increasing leads."
                   },
                   {
                    id: "is-2-7-24", da: "Monitor data sources and integrate relevant ones."
                   },
                   {
                    id: "is-2-7-25", da: "Use machine learning algorithms for lead scoring."
                   },
                   {
                    id: "is-2-7-26", da: "Implement predictive analytics to forecast leads."
                   },
                   {
                    id: "is-2-7-27", da: "Employ A\/B testing for data-driven decision-making."
                   },
                   {
                    id: "is-2-7-28", da: "Create a comprehensive customer relationship management (CRM) system."
                   },
                   {
                    id: "is-2-7-29", da: "Use geospatial data for location-based lead targeting."
                   },
                   {
                    id: "is-2-7-30", da: "Enhance data accessibility for your team."
                   },
                   {
                    id: "is-2-7-31", da: "Implement data analytics dashboards."
                   },
                   {
                    id: "is-2-7-32", da: "Establish data partnerships to access external data sources."
                   },
                   {
                    id: "is-2-7-33", da: "Leverage cloud-based data solutions for flexibility."
                   },
                   {
                    id: "is-2-7-34", da: "Regularly back up and secure your data."
                   },
                   {
                    id: "is-2-7-35", da: "Implement data archiving for historical records."
                   },
                   {
                    id: "is-2-7-36", da: "Establish data ownership and accountability."
                   },
                   {
                    id: "is-2-7-37", da: "Conduct regular data quality training for your team."
                   },
                   {
                    id: "is-2-7-38", da: "Use data profiling tools for quick insights."
                   },
                   {
                    id: "is-2-7-39", da: "Implement data versioning for data change history."
                   },
                   {
                    id: "is-2-7-40", da: "Track data latency to ensure real-time insights."
                   },
                   {
                    id: "is-2-7-41", da: "Employ data compliance checks for regulations."
                   },
                   {
                    id: "is-2-7-42", da: "Use data indexing for efficient data retrieval."
                   },
                   {
                    id: "is-2-7-43", da: "Implement data compression for storage efficiency."
                   },
                   {
                    id: "is-2-7-44", da: "Develop data access controls for security."
                   },
                   {
                    id: "is-2-7-45", da: "Leverage data categorization and tagging."
                   },
                   {
                    id: "is-2-7-46", da: "Implement data lifecycle management."
                   },
                   {
                    id: "is-2-7-47", da: "Conduct data performance tuning."
                   },
                   {
                    id: "is-2-7-48", da: "Ensure data replication and redundancy for backup."
                   },
                   {
                    id: "is-2-7-49", da: "Regularly review and refine your data metrics strategy."
                   },
                ]
              },
              {
                id: 'is-2-8',
                pm: 'Basic processes of community build-up like hiring, customer acquisition, delivery, development are in document and practiced.',
                title:'Operations',
                pmMap: 'Basic processes of community build-up like hiring, customer acquisition, delivery, development are in document and practiced.',
                developmentActions:[
                  {
                    id: "is-2-8-0", da: "Implement a robust CRM system."
                   },
                   {
                    id: "is-2-8-1", da: "Optimize supply chain management."
                   },
                   {
                    id: "is-2-8-2", da: "Develop and document standardized operating procedures."
                   },
                   {
                    id: "is-2-8-3", da: "Automate routine tasks and processes."
                   },
                   {
                    id: "is-2-8-4", da: "Invest in employee training and development."
                   },
                   {
                    id: "is-2-8-5", da: "Conduct regular performance assessments."
                   },
                   {
                    id: "is-2-8-6", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "is-2-8-7", da: "Implement lean manufacturing principles."
                   },
                   {
                    id: "is-2-8-8", da: "Streamline inventory management."
                   },
                   {
                    id: "is-2-8-9", da: "Enhance data analytics and reporting capabilities."
                   },
                   {
                    id: "is-2-8-10", da: "Foster cross-functional collaboration."
                   },
                   {
                    id: "is-2-8-11", da: "Upgrade and integrate software systems."
                   },
                   {
                    id: "is-2-8-12", da: "Conduct regular equipment maintenance."
                   },
                   {
                    id: "is-2-8-13", da: "Implement a quality management system."
                   },
                   {
                    id: "is-2-8-14", da: "Conduct regular market research."
                   },
                   {
                    id: "is-2-8-15", da: "Optimize pricing strategies."
                   },
                   {
                    id: "is-2-8-16", da: "Improve vendor relationships."
                   },
                   {
                    id: "is-2-8-17", da: "Enhance customer service and support."
                   },
                   {
                    id: "is-2-8-18", da: "Invest in cybersecurity measures."
                   },
                   {
                    id: "is-2-8-19", da: "Expand product\/service offerings."
                   },
                   {
                    id: "is-2-8-20", da: "Develop key performance indicators (KPIs)."
                   },
                   {
                    id: "is-2-8-21", da: "Optimize logistics and transportation."
                   },
                   {
                    id: "is-2-8-22", da: "Minimize waste and reduce costs."
                   },
                   {
                    id: "is-2-8-23", da: "Focus on sustainability initiatives."
                   },
                   {
                    id: "is-2-8-24", da: "Enhance workplace safety measures."
                   },
                   {
                    id: "is-2-8-25", da: "Improve energy efficiency."
                   },
                   {
                    id: "is-2-8-26", da: "Implement agile project management."
                   },
                   {
                    id: "is-2-8-27", da: "Develop a disaster recovery plan."
                   },
                   {
                    id: "is-2-8-28", da: "Optimize human resource management."
                   },
                   {
                    id: "is-2-8-29", da: "Invest in new technologies."
                   },
                   {
                    id: "is-2-8-30", da: "Conduct competitor analysis."
                   },
                   {
                    id: "is-2-8-31", da: "Enhance data security and privacy."
                   },
                   {
                    id: "is-2-8-32", da: "Optimize sales and marketing strategies."
                   },
                   {
                    id: "is-2-8-33", da: "Foster a culture of innovation."
                   },
                   {
                    id: "is-2-8-34", da: "Develop a comprehensive risk management plan."
                   },
                   {
                    id: "is-2-8-35", da: "Improve customer relationship management."
                   },
                   {
                    id: "is-2-8-36", da: "Invest in IoT (Internet of Things) solutions."
                   },
                   {
                    id: "is-2-8-37", da: "Implement a continuous feedback system."
                   },
                   {
                    id: "is-2-8-38", da: "Enhance internal communication."
                   },
                   {
                    id: "is-2-8-39", da: "Develop a product development roadmap."
                   },
                   {
                    id: "is-2-8-40", da: "Invest in advanced analytics tools."
                   },
                   {
                    id: "is-2-8-41", da: "Optimize website and online presence."
                   },
                   {
                    id: "is-2-8-42", da: "Conduct a thorough cost analysis."
                   },
                   {
                    id: "is-2-8-43", da: "Implement agile development methodologies."
                   },
                   {
                    id: "is-2-8-44", da: "Enhance employee retention strategies."
                   },
                   {
                    id: "is-2-8-45", da: "Develop a disaster response plan."
                   },
                   {
                    id: "is-2-8-46", da: "Optimize e-commerce solutions."
                   },
                   {
                    id: "is-2-8-47", da: "Foster supplier diversity."
                   },
                   {
                    id: "is-2-8-48", da: "Invest in employee wellness programs."
                   },
                   {
                    id: "is-2-8-49", da: "Establish a comprehensive data backup strategy."
                   },
                ]
              },
              {
                id: 'is-2-9',
                pm: 'First board of directors including investor director is established.',
                title:'Exit Strategy',
                pmMap: 'First board of directors including investor director is established.',
                developmentActions:[
                  {
                    id: "is-2-9-0", da: "Clearly define your exit goals and objectives."
                   },
                   {
                    id: "is-2-9-1", da: "Identify potential exit scenarios, such as acquisition, IPO, or management buyout."
                   },
                   {
                    id: "is-2-9-2", da: "Consider the timing of your exit strategy."
                   },
                   {
                    id: "is-2-9-3", da: "Assess the market conditions and trends that may impact your exit."
                   },
                   {
                    id: "is-2-9-4", da: "Evaluate the financial health of your company as it relates to the exit."
                   },
                   {
                    id: "is-2-9-5", da: "Develop a comprehensive business valuation."
                   },
                   {
                    id: "is-2-9-6", da: "Understand the tax implications of different exit options."
                   },
                   {
                    id: "is-2-9-7", da: "Create an exit team with the right expertise."
                   },
                   {
                    id: "is-2-9-8", da: "Prepare a detailed exit plan."
                   },
                   {
                    id: "is-2-9-9", da: "Consider the impact on employees and stakeholders."
                   },
                   {
                    id: "is-2-9-10", da: "Determine how to maximize value for shareholders."
                   },
                   {
                    id: "is-2-9-11", da: "Explore strategic partnerships that could lead to a smoother exit."
                   },
                   {
                    id: "is-2-9-12", da: "Investigate potential acquirers or investors."
                   },
                   {
                    id: "is-2-9-13", da: "Ensure your intellectual property is protected."
                   },
                   {
                    id: "is-2-9-14", da: "Consider the impact of regulations on your exit."
                   },
                   {
                    id: "is-2-9-15", da: "Review contracts and agreements that may affect the exit."
                   },
                   {
                    id: "is-2-9-16", da: "Identify potential risks and contingencies."
                   },
                   {
                    id: "is-2-9-17", da: "Plan for post-exit management and transition."
                   },
                   {
                    id: "is-2-9-18", da: "Communicate the exit plan to key stakeholders."
                   },
                   {
                    id: "is-2-9-19", da: "Develop a timeline for the exit process."
                   },
                   {
                    id: "is-2-9-20", da: "Determine the role of management and founders post-exit."
                   },
                   {
                    id: "is-2-9-21", da: "Assess the impact on company culture."
                   },
                   {
                    id: "is-2-9-22", da: "Evaluate the competitive landscape."
                   },
                   {
                    id: "is-2-9-23", da: "Consider the financial position of potential acquirers or investors."
                   },
                   {
                    id: "is-2-9-24", da: "Determine the negotiation strategy."
                   },
                   {
                    id: "is-2-9-25", da: "Plan for due diligence by potential investors or acquirers."
                   },
                   {
                    id: "is-2-9-26", da: "Prepare all necessary legal documents."
                   },
                   {
                    id: "is-2-9-27", da: "Explore financing options for the exit."
                   },
                   {
                    id: "is-2-9-28", da: "Understand the terms and conditions of any investment or acquisition offers."
                   },
                   {
                    id: "is-2-9-29", da: "Assess the impact on company operations during the exit process."
                   },
                   {
                    id: "is-2-9-30", da: "Consider the effect on customer relationships."
                   },
                   {
                    id: "is-2-9-31", da: "Plan for a smooth transition of responsibilities."
                   },
                   {
                    id: "is-2-9-32", da: "Develop a communication plan for employees."
                   },
                   {
                    id: "is-2-9-33", da: "Ensure data security and confidentiality during the exit."
                   },
                   {
                    id: "is-2-9-34", da: "Consider the impact on suppliers and partners."
                   },
                   {
                    id: "is-2-9-35", da: "Evaluate the branding and reputation implications."
                   },
                   {
                    id: "is-2-9-36", da: "Plan for the allocation of proceeds from the exit."
                   },
                   {
                    id: "is-2-9-37", da: "Determine the role of the board of directors in the exit."
                   },
                   {
                    id: "is-2-9-38", da: "Consider any debt obligations or liabilities."
                   },
                   {
                    id: "is-2-9-39", da: "Evaluate the impact on innovation and R&D."
                   },
                   {
                    id: "is-2-9-40", da: "Ensure compliance with all legal and regulatory requirements."
                   },
                   {
                    id: "is-2-9-41", da: "Assess the impact on product lines and services."
                   },
                   {
                    id: "is-2-9-42", da: "Consider the impact on marketing and sales efforts."
                   },
                   {
                    id: "is-2-9-43", da: "Evaluate the impact on customer contracts and agreements."
                   },
                   {
                    id: "is-2-9-44", da: "Plan for investor or acquirer approval processes."
                   },
                   {
                    id: "is-2-9-45", da: "Consider any earn-out or performance-based clauses."
                   },
                   {
                    id: "is-2-9-46", da: "Develop a communication plan for investors, acquirers, and the public."
                   },
                   {
                    id: "is-2-9-47", da: "Ensure transparency and trust throughout the exit process."
                   },
                   {
                    id: "is-2-9-48", da: "Plan for post-exit shareholder relations."
                   },
                   {
                    id: "is-2-9-49", da: "Continuously monitor and adapt the exit strategy as circumstances change."
                   },
                ]
              }
            ]
          }
        ]
      },
      'nb':{
        characteristic: 'Network Building',
        wdd: "Take your next step towards becoming the bridgehead for international stakeholders from and to your ecosystem. Bring international awareness to your community and associate your startup ecosystem with one of the fastest-growing tech communities that will instantly uplift and enforce your brand.",
        icon: require('@/assets/Iconography/Characteristics/15_Skilled Communicator.svg'),
        competencies:[
          {
            id: 'nb-0',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Onboarding',
            wdd: '',
            progressMeasures:[
              {
                id: 'nb-0-0',
                pm: 'People understand why they are joining in and a smooth onboarding process aligns them further.',
                title:'Need',
                pmMap: 'People understand why they are joining in and a smooth onboarding process aligns them further.',
                developmentActions:[
                  {
                    id: "nb-0-0-0", da: "Establish clear communication channels."
                   },
                   {
                    id: "nb-0-0-1", da: "Define roles and responsibilities."
                   },
                   {
                    id: "nb-0-0-2", da: "Create a comprehensive training program."
                   },
                   {
                    id: "nb-0-0-3", da: "Develop mentorship opportunities."
                   },
                   {
                    id: "nb-0-0-4", da: "Set up regular feedback mechanisms."
                   },
                   {
                    id: "nb-0-0-5", da: "Promote knowledge sharing."
                   },
                   {
                    id: "nb-0-0-6", da: "Encourage cross-functional collaboration."
                   },
                   {
                    id: "nb-0-0-7", da: "Enhance project management processes."
                   },
                   {
                    id: "nb-0-0-8", da: "Improve time management skills."
                   },
                   {
                    id: "nb-0-0-9", da: "Foster a culture of continuous learning."
                   },
                   {
                    id: "nb-0-0-10", da: "Strengthen leadership development."
                   },
                   {
                    id: "nb-0-0-11", da: "Enhance conflict resolution abilities."
                   },
                   {
                    id: "nb-0-0-12", da: "Improve technical skills."
                   },
                   {
                    id: "nb-0-0-13", da: "Develop problem-solving techniques."
                   },
                   {
                    id: "nb-0-0-14", da: "Promote a growth mindset."
                   },
                   {
                    id: "nb-0-0-15", da: "Enhance creativity and innovation."
                   },
                   {
                    id: "nb-0-0-16", da: "Improve goal setting and achievement."
                   },
                   {
                    id: "nb-0-0-17", da: "Foster emotional intelligence."
                   },
                   {
                    id: "nb-0-0-18", da: "Strengthen self-motivation."
                   },
                   {
                    id: "nb-0-0-19", da: "Develop teamwork and collaboration."
                   },
                   {
                    id: "nb-0-0-20", da: "Improve decision-making skills."
                   },
                   {
                    id: "nb-0-0-21", da: "Enhance critical thinking abilities."
                   },
                   {
                    id: "nb-0-0-22", da: "Boost adaptability and flexibility."
                   },
                   {
                    id: "nb-0-0-23", da: "Promote effective delegation."
                   },
                   {
                    id: "nb-0-0-24", da: "Develop stress management techniques."
                   },
                   {
                    id: "nb-0-0-25", da: "Strengthen risk management skills."
                   },
                   {
                    id: "nb-0-0-26", da: "Improve presentation and public speaking."
                   },
                   {
                    id: "nb-0-0-27", da: "Enhance negotiation and persuasion."
                   },
                   {
                    id: "nb-0-0-28", da: "Foster time management and productivity."
                   },
                   {
                    id: "nb-0-0-29", da: "Develop conflict resolution skills."
                   },
                   {
                    id: "nb-0-0-30", da: "Strengthen project management skills."
                   },
                   {
                    id: "nb-0-0-31", da: "Improve coding and technical abilities."
                   },
                   {
                    id: "nb-0-0-32", da: "Enhance data analysis and interpretation."
                   },
                   {
                    id: "nb-0-0-33", da: "Promote strategic planning."
                   },
                   {
                    id: "nb-0-0-34", da: "Develop business acumen."
                   },
                   {
                    id: "nb-0-0-35", da: "Improve financial literacy."
                   },
                   {
                    id: "nb-0-0-36", da: "Strengthen marketing and sales skills."
                   },
                   {
                    id: "nb-0-0-37", da: "Foster customer relationship management."
                   },
                   {
                    id: "nb-0-0-38", da: "Enhance supply chain management."
                   },
                   {
                    id: "nb-0-0-39", da: "Improve product development."
                   },
                   {
                    id: "nb-0-0-40", da: "Develop industry-specific knowledge."
                   },
                   {
                    id: "nb-0-0-41", da: "Strengthen regulatory compliance understanding."
                   },
                   {
                    id: "nb-0-0-42", da: "Promote health and safety awareness."
                   },
                   {
                    id: "nb-0-0-43", da: "Enhance cybersecurity knowledge."
                   },
                   {
                    id: "nb-0-0-44", da: "Foster diversity and inclusion."
                   },
                   {
                    id: "nb-0-0-45", da: "Improve ethics and corporate responsibility."
                   },
                   {
                    id: "nb-0-0-46", da: "Develop sustainability practices."
                   },
                   {
                    id: "nb-0-0-47", da: "Strengthen market Stakeholder Activation and analysis."
                   },
                   {
                    id: "nb-0-0-48", da: "Enhance competitive analysis."
                   },
                   {
                    id: "nb-0-0-49", da: "Promote customer feedback and satisfaction."
                   },
                ]
              },
              {
                id: 'nb-0-1',
                pm: "Ecosystem partners are willing to participate in the community's vision and success. Plan for internationalisation is established.",
                title:'Market',
                pmMap: "Ecosystem partners are willing to participate in the community's vision and success. Plan for internationalisation is established.",
                developmentActions:[
                  {
                    id: "nb-0-1-0", da: "Identify key industry events and conferences to attend."
                   },
                   {
                    id: "nb-0-1-1", da: "Join relevant industry associations and organizations."
                   },
                   {
                    id: "nb-0-1-2", da: "Build a strong online presence through a professional website."
                   },
                   {
                    id: "nb-0-1-3", da: "Create engaging and informative content on your website."
                   },
                   {
                    id: "nb-0-1-4", da: "Implement a robust SEO strategy to increase website visibility."
                   },
                   {
                    id: "nb-0-1-5", da: "Develop a social media marketing plan."
                   },
                   {
                    id: "nb-0-1-6", da: "Utilize LinkedIn for professional networking."
                   },
                   {
                    id: "nb-0-1-7", da: "Host webinars and online workshops."
                   },
                   {
                    id: "nb-0-1-8", da: "Partner with complementary businesses."
                   },
                   {
                    id: "nb-0-1-9", da: "Attend local networking events."
                   },
                   {
                    id: "nb-0-1-10", da: "Create a detailed buyer persona for your target audience."
                   },
                   {
                    id: "nb-0-1-11", da: "Conduct market Stakeholder Activation to identify trends and opportunities."
                   },
                   {
                    id: "nb-0-1-12", da: "Develop a unique selling proposition (USP)."
                   },
                   {
                    id: "nb-0-1-13", da: "Offer free resources, like eBooks or whitepapers, in exchange for email addresses."
                   },
                   {
                    id: "nb-0-1-14", da: "Utilize email marketing to nurture leads."
                   },
                   {
                    id: "nb-0-1-15", da: "Collaborate with influencers in your industry."
                   },
                   {
                    id: "nb-0-1-16", da: "Launch a referral program."
                   },
                   {
                    id: "nb-0-1-17", da: "Invest in paid advertising on Google or social media."
                   },
                   {
                    id: "nb-0-1-18", da: "Optimize your Google My Business listing."
                   },
                   {
                    id: "nb-0-1-19", da: "Implement a customer relationship management (CRM) system."
                   },
                   {
                    id: "nb-0-1-20", da: "Develop a content calendar to maintain a consistent online presence."
                   },
                   {
                    id: "nb-0-1-21", da: "Create and distribute press releases."
                   },
                   {
                    id: "nb-0-1-22", da: "Offer free consultations or assessments."
                   },
                   {
                    id: "nb-0-1-23", da: "Leverage user-generated content and reviews."
                   },
                   {
                    id: "nb-0-1-24", da: "Offer discounts or promotions."
                   },
                   {
                    id: "nb-0-1-25", da: "Develop a mobile app."
                   },
                   {
                    id: "nb-0-1-26", da: "Implement an affiliate marketing program."
                   },
                   {
                    id: "nb-0-1-27", da: "Host customer appreciation events."
                   },
                   {
                    id: "nb-0-1-28", da: "Offer loyalty programs."
                   },
                   {
                    id: "nb-0-1-29", da: "Engage in email drip campaigns."
                   },
                   {
                    id: "nb-0-1-30", da: "Partner with local influencers."
                   },
                   {
                    id: "nb-0-1-31", da: "Leverage the power of video marketing."
                   },
                   {
                    id: "nb-0-1-32", da: "Optimize your website for mobile devices."
                   },
                   {
                    id: "nb-0-1-33", da: "Establish a presence on industry-specific forums."
                   },
                   {
                    id: "nb-0-1-34", da: "Network with other businesses in your area."
                   },
                   {
                    id: "nb-0-1-35", da: "Provide exceptional customer service."
                   },
                   {
                    id: "nb-0-1-36", da: "Collaborate with local media for exposure."
                   },
                   {
                    id: "nb-0-1-37", da: "Create and distribute regular newsletters."
                   },
                   {
                    id: "nb-0-1-38", da: "Host online contests and giveaways."
                   },
                   {
                    id: "nb-0-1-39", da: "Build a strong brand identity."
                   },
                   {
                    id: "nb-0-1-40", da: "Showcase case studies and success stories."
                   },
                   {
                    id: "nb-0-1-41", da: "Utilize data analytics for decision-making."
                   },
                   {
                    id: "nb-0-1-42", da: "Run online surveys and gather customer feedback."
                   },
                   {
                    id: "nb-0-1-43", da: "Join online marketplaces or directories."
                   },
                   {
                    id: "nb-0-1-44", da: "Develop a customer advocacy program."
                   },
                   {
                    id: "nb-0-1-45", da: "Offer exclusive access or content for subscribers."
                   },
                   {
                    id: "nb-0-1-46", da: "Create a podcast."
                   },
                   {
                    id: "nb-0-1-47", da: "Invest in chatbots and AI for customer support."
                   },
                   {
                    id: "nb-0-1-48", da: "Offer a freemium or trial version of your product."
                   },
                   {
                    id: "nb-0-1-49", da: "Sponsor relevant community events or initiatives."
                   },
                ]
              },
              {
                id: 'nb-0-2',
                pm: ' Onboarding processes are streamlined with tech.',
                title:'Technology',
                pmMap: ' Onboarding processes are streamlined with tech.',
                developmentActions:[
                  {
                    id: "nb-0-2-0", da: "Develop a technology roadmap for the next five years."
                   },
                   {
                    id: "nb-0-2-1", da: "Identify key technology trends and their potential impact on your industry."
                   },
                   {
                    id: "nb-0-2-2", da: "Conduct regular technology assessments to identify areas for improvement."
                   },
                   {
                    id: "nb-0-2-3", da: "Implement a robust cybersecurity strategy to protect sensitive data."
                   },
                   {
                    id: "nb-0-2-4", da: "Invest in employee training and development to enhance technical skills."
                   },
                   {
                    id: "nb-0-2-5", da: "Evaluate and adopt cloud computing solutions for scalability and flexibility."
                   },
                   {
                    id: "nb-0-2-6", da: "Optimize your website and online presence for improved user experience."
                   },
                   {
                    id: "nb-0-2-7", da: "Implement data analytics and reporting tools to make data-driven decisions."
                   },
                   {
                    id: "nb-0-2-8", da: "Upgrade and maintain your hardware and software infrastructure."
                   },
                   {
                    id: "nb-0-2-9", da: "Enhance network security with regular vulnerability assessments."
                   },
                   {
                    id: "nb-0-2-10", da: "Explore the use of artificial intelligence (AI) and machine learning for automation."
                   },
                   {
                    id: "nb-0-2-11", da: "Create a disaster recovery plan to ensure business continuity."
                   },
                   {
                    id: "nb-0-2-12", da: "Develop a mobile app for better customer engagement."
                   },
                   {
                    id: "nb-0-2-13", da: "Integrate Internet of Things (IoT) devices for data collection and automation."
                   },
                   {
                    id: "nb-0-2-14", da: "Leverage blockchain technology for secure transactions and records."
                   },
                   {
                    id: "nb-0-2-15", da: "Improve data storage and retrieval with efficient databases."
                   },
                   {
                    id: "nb-0-2-16", da: "Implement agile development methodologies for faster project delivery."
                   },
                   {
                    id: "nb-0-2-17", da: "Conduct regular code reviews to maintain code quality."
                   },
                   {
                    id: "nb-0-2-18", da: "Explore open-source software options to reduce costs."
                   },
                   {
                    id: "nb-0-2-19", da: "Invest in a robust customer relationship management (CRM) system."
                   },
                   {
                    id: "nb-0-2-20", da: "Build a strong online presence through social media and SEO."
                   },
                   {
                    id: "nb-0-2-21", da: "Automate repetitive tasks with scripting and automation tools."
                   },
                   {
                    id: "nb-0-2-22", da: "Enhance network monitoring and performance optimization."
                   },
                   {
                    id: "nb-0-2-23", da: "Develop a mobile-friendly and responsive website."
                   },
                   {
                    id: "nb-0-2-24", da: "Implement a content delivery network (CDN) for faster web content loading."
                   },
                   {
                    id: "nb-0-2-25", da: "Explore virtual reality (VR) and augmented reality (AR) applications."
                   },
                   {
                    id: "nb-0-2-26", da: "Invest in video conferencing tools for remote collaboration."
                   },
                   {
                    id: "nb-0-2-27", da: "Upgrade your content management system (CMS) for better content control."
                   },
                   {
                    id: "nb-0-2-28", da: "Implement a bug tracking and project management system."
                   },
                   {
                    id: "nb-0-2-29", da: "Optimize your website for mobile users."
                   },
                   {
                    id: "nb-0-2-30", da: "Invest in e-commerce solutions for online sales and payments."
                   },
                   {
                    id: "nb-0-2-31", da: "Develop a robust IT governance framework."
                   },
                   {
                    id: "nb-0-2-32", da: "Upgrade your email and communication systems."
                   },
                   {
                    id: "nb-0-2-33", da: "Enhance data backup and recovery processes."
                   },
                   {
                    id: "nb-0-2-34", da: "Invest in user interface (UI) and user experience (UX) design."
                   },
                   {
                    id: "nb-0-2-35", da: "Explore edge computing for low-latency data processing."
                   },
                   {
                    id: "nb-0-2-36", da: "Improve your data visualization and reporting tools."
                   },
                   {
                    id: "nb-0-2-37", da: "Enhance network redundancy and failover capabilities."
                   },
                   {
                    id: "nb-0-2-38", da: "Implement a knowledge management system for internal use."
                   },
                   {
                    id: "nb-0-2-39", da: "Explore opportunities for data monetization."
                   },
                   {
                    id: "nb-0-2-40", da: "Invest in high-speed internet connections for faster data transfer."
                   },
                   {
                    id: "nb-0-2-41", da: "Evaluate and optimize your supply chain with technology."
                   },
                   {
                    id: "nb-0-2-42", da: "Develop a technology innovation team to drive R&D."
                   },
                   {
                    id: "nb-0-2-43", da: "Enhance your online advertising and marketing strategies."
                   },
                   {
                    id: "nb-0-2-44", da: "Adopt a continuous integration\/continuous deployment (CI\/CD) pipeline."
                   },
                   {
                    id: "nb-0-2-45", da: "Explore options for serverless computing."
                   },
                   {
                    id: "nb-0-2-46", da: "Implement automated testing for software quality assurance."
                   },
                   {
                    id: "nb-0-2-47", da: "Optimize your digital product development cycle."
                   },
                   {
                    id: "nb-0-2-48", da: "Explore options for energy-efficient technology solutions."
                   },
                   {
                    id: "nb-0-2-49", da: "Foster a culture of innovation and technological adaptability among your team."
                   },
                ]
              },
              {
                id: 'nb-0-3',
                pm: 'Community impact is validated and tied to the solution it provides inside and outside.',
                title:'Value',
                pmMap: 'Community impact is validated and tied to the solution it provides inside and outside.',
                developmentActions:[
                  {
                    id: "nb-0-3-0", da: "Identify key stakeholders and potential partners in your network."
                   },
                   {
                    id: "nb-0-3-1", da: "Establish a clear mission and vision for your network."
                   },
                   {
                    id: "nb-0-3-2", da: "Develop a compelling value proposition for new members."
                   },
                   {
                    id: "nb-0-3-3", da: "Create a welcoming and informative onboarding process."
                   },
                   {
                    id: "nb-0-3-4", da: "Provide mentorship and guidance for newcomers."
                   },
                   {
                    id: "nb-0-3-5", da: "Encourage knowledge sharing and collaboration within the network."
                   },
                   {
                    id: "nb-0-3-6", da: "Facilitate introductions and connections between members."
                   },
                   {
                    id: "nb-0-3-7", da: "Conduct regular orientation sessions for new members."
                   },
                   {
                    id: "nb-0-3-8", da: "Offer training and skill development opportunities."
                   },
                   {
                    id: "nb-0-3-9", da: "Host networking events to foster relationships."
                   },
                   {
                    id: "nb-0-3-10", da: "Showcase success stories from within the network."
                   },
                   {
                    id: "nb-0-3-11", da: "Provide resources and tools to help members succeed."
                   },
                   {
                    id: "nb-0-3-12", da: "Establish a strong online presence and community."
                   },
                   {
                    id: "nb-0-3-13", da: "Offer exclusive access to valuable content or insights."
                   },
                   {
                    id: "nb-0-3-14", da: "Create special interest groups or sub-networks."
                   },
                   {
                    id: "nb-0-3-15", da: "Encourage feedback and suggestions from members."
                   },
                   {
                    id: "nb-0-3-16", da: "Monitor the engagement and participation of new members."
                   },
                   {
                    id: "nb-0-3-17", da: "Recognize and celebrate member achievements."
                   },
                   {
                    id: "nb-0-3-18", da: "Foster a culture of inclusivity and diversity."
                   },
                   {
                    id: "nb-0-3-19", da: "Help members overcome common challenges."
                   },
                   {
                    id: "nb-0-3-20", da: "Share industry trends and insights."
                   },
                   {
                    id: "nb-0-3-21", da: "Collaborate on Stakeholder Activation or projects of common interest."
                   },
                   {
                    id: "nb-0-3-22", da: "Provide opportunities for speaking or presenting."
                   },
                   {
                    id: "nb-0-3-23", da: "Offer discounts or promotions from partner organizations."
                   },
                   {
                    id: "nb-0-3-24", da: "Connect members with potential clients or customers."
                   },
                   {
                    id: "nb-0-3-25", da: "Organize themed workshops or webinars."
                   },
                   {
                    id: "nb-0-3-26", da: "Leverage social media to expand your network."
                   },
                   {
                    id: "nb-0-3-27", da: "Establish metrics to measure the value delivered."
                   },
                   {
                    id: "nb-0-3-28", da: "Solicit testimonials and endorsements from satisfied members."
                   },
                   {
                    id: "nb-0-3-29", da: "Develop a resource library for members to access."
                   },
                   {
                    id: "nb-0-3-30", da: "Promote volunteering and community engagement."
                   },
                   {
                    id: "nb-0-3-31", da: "Encourage thought leadership within the network."
                   },
                   {
                    id: "nb-0-3-32", da: "Address issues or concerns promptly and openly."
                   },
                   {
                    id: "nb-0-3-33", da: "Promote ethical and responsible business practices."
                   },
                   {
                    id: "nb-0-3-34", da: "Leverage technology for efficient onboarding."
                   },
                   {
                    id: "nb-0-3-35", da: "Offer a referral program for member recruitment."
                   },
                   {
                    id: "nb-0-3-36", da: "Conduct surveys and feedback sessions with members."
                   },
                   {
                    id: "nb-0-3-37", da: "Promote knowledge transfer between generations."
                   },
                   {
                    id: "nb-0-3-38", da: "Provide access to influential speakers or mentors."
                   },
                   {
                    id: "nb-0-3-39", da: "Collaborate with educational institutions for skill development."
                   },
                   {
                    id: "nb-0-3-40", da: "Highlight the network's impact on members' lives or careers."
                   },
                   {
                    id: "nb-0-3-41", da: "Develop partnerships with complementary organizations."
                   },
                   {
                    id: "nb-0-3-42", da: "Create a member directory for easy networking."
                   },
                   {
                    id: "nb-0-3-43", da: "Showcase success stories from within the network."
                   },
                   {
                    id: "nb-0-3-44", da: "Organize annual conferences or summits."
                   },
                   {
                    id: "nb-0-3-45", da: "Offer opportunities for public recognition."
                   },
                   {
                    id: "nb-0-3-46", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "nb-0-3-47", da: "Celebrate cultural diversity within the network."
                   },
                   {
                    id: "nb-0-3-48", da: "Promote community involvement and social responsibility."
                   },
                   {
                    id: "nb-0-3-49", da: "Establish a clear communication strategy to keep members informed."
                   },
                ]
              },
              {
                id: 'nb-0-4',
                pm: 'Growth of community base accelerates month over month.',
                title:'Business Model',
                pmMap: 'Growth of community base accelerates month over month.',
                developmentActions:[
                  {
                    id: "nb-0-4-0", da: "Identify target customer segments."
                   },
                   {
                    id: "nb-0-4-1", da: "Analyze customer behavior and preferences."
                   },
                   {
                    id: "nb-0-4-2", da: "Assess market trends and dynamics."
                   },
                   {
                    id: "nb-0-4-3", da: "Explore new revenue streams."
                   },
                   {
                    id: "nb-0-4-4", da: "Reevaluate pricing strategies."
                   },
                   {
                    id: "nb-0-4-5", da: "Enhance product or service features."
                   },
                   {
                    id: "nb-0-4-6", da: "Optimize supply chain and logistics."
                   },
                   {
                    id: "nb-0-4-7", da: "Streamline production processes."
                   },
                   {
                    id: "nb-0-4-8", da: "Assess the scalability of the business."
                   },
                   {
                    id: "nb-0-4-9", da: "Investigate cost reduction opportunities."
                   },
                   {
                    id: "nb-0-4-10", da: "Explore strategic partnerships."
                   },
                   {
                    id: "nb-0-4-11", da: "Expand distribution channels."
                   },
                   {
                    id: "nb-0-4-12", da: "Assess the competitive landscape."
                   },
                   {
                    id: "nb-0-4-13", da: "Conduct a SWOT analysis."
                   },
                   {
                    id: "nb-0-4-14", da: "Refine your unique value proposition."
                   },
                   {
                    id: "nb-0-4-15", da: "Reevaluate marketing strategies."
                   },
                   {
                    id: "nb-0-4-16", da: "Explore digital marketing opportunities."
                   },
                   {
                    id: "nb-0-4-17", da: "Enhance customer support and engagement."
                   },
                   {
                    id: "nb-0-4-18", da: "Assess your online presence and branding."
                   },
                   {
                    id: "nb-0-4-19", da: "Consider international expansion."
                   },
                   {
                    id: "nb-0-4-20", da: "Evaluate the regulatory environment."
                   },
                   {
                    id: "nb-0-4-21", da: "Investigate emerging technologies."
                   },
                   {
                    id: "nb-0-4-22", da: "Assess intellectual property protection."
                   },
                   {
                    id: "nb-0-4-23", da: "Enhance employee training and development."
                   },
                   {
                    id: "nb-0-4-24", da: "Implement a performance management system."
                   },
                   {
                    id: "nb-0-4-25", da: "Improve data analytics and insights."
                   },
                   {
                    id: "nb-0-4-26", da: "Assess financial management and reporting."
                   },
                   {
                    id: "nb-0-4-27", da: "Investigate funding and investment options."
                   },
                   {
                    id: "nb-0-4-28", da: "Explore customer feedback mechanisms."
                   },
                   {
                    id: "nb-0-4-29", da: "Optimize resource allocation."
                   },
                   {
                    id: "nb-0-4-30", da: "Reevaluate risk management strategies."
                   },
                   {
                    id: "nb-0-4-31", da: "Enhance corporate social responsibility initiatives."
                   },
                   {
                    id: "nb-0-4-32", da: "Investigate sustainability and green initiatives."
                   },
                   {
                    id: "nb-0-4-33", da: "Assess the legal and compliance framework."
                   },
                   {
                    id: "nb-0-4-34", da: "Explore diversification opportunities."
                   },
                   {
                    id: "nb-0-4-35", da: "Optimize corporate governance."
                   },
                   {
                    id: "nb-0-4-36", da: "Reevaluate exit and succession planning."
                   },
                   {
                    id: "nb-0-4-37", da: "Enhance employee retention strategies."
                   },
                   {
                    id: "nb-0-4-38", da: "Explore outsourcing and offshoring."
                   },
                   {
                    id: "nb-0-4-39", da: "Assess crisis management and continuity planning."
                   },
                   {
                    id: "nb-0-4-40", da: "Investigate customer retention strategies."
                   },
                   {
                    id: "nb-0-4-41", da: "Optimize inventory management."
                   },
                   {
                    id: "nb-0-4-42", da: "Explore innovation and R&D initiatives."
                   },
                   {
                    id: "nb-0-4-43", da: "Assess brand loyalty and advocacy."
                   },
                   {
                    id: "nb-0-4-44", da: "Investigate the use of emerging technologies like AI and blockchain."
                   },
                   {
                    id: "nb-0-4-45", da: "Optimize the use of customer data and analytics."
                   },
                   {
                    id: "nb-0-4-46", da: "Explore opportunities for personalization."
                   },
                   {
                    id: "nb-0-4-47", da: "Evaluate the scalability of digital infrastructure."
                   },
                   {
                    id: "nb-0-4-48", da: "Reevaluate the company's culture and values."
                   },
                   {
                    id: "nb-0-4-49", da: "Assess the impact of global events and trends."
                   },
                ]
              },
              {
                id: 'nb-0-5',
                pm: 'Co-selling offers with other stakeholders created to expand reach.',
                title:'Go to Market',
                pmMap: 'Co-selling offers with other stakeholders created to expand reach.',
                developmentActions:[
                  {
                    id: "nb-0-5-0", da: "Identify and define your target audience."
                   },
                   {
                    id: "nb-0-5-1", da: "Develop buyer personas to understand customer needs."
                   },
                   {
                    id: "nb-0-5-2", da: "Conduct market Stakeholder Activation to identify market trends."
                   },
                   {
                    id: "nb-0-5-3", da: "Segment your market for more targeted approaches."
                   },
                   {
                    id: "nb-0-5-4", da: "Analyze customer behavior and preferences."
                   },
                   {
                    id: "nb-0-5-5", da: "Create a sales funnel to track customer journeys."
                   },
                   {
                    id: "nb-0-5-6", da: "Develop a clear value proposition."
                   },
                   {
                    id: "nb-0-5-7", da: "Craft a compelling elevator pitch."
                   },
                   {
                    id: "nb-0-5-8", da: "Define your unique selling points."
                   },
                   {
                    id: "nb-0-5-9", da: "Establish clear branding and messaging."
                   },
                   {
                    id: "nb-0-5-10", da: "Create a strong online presence."
                   },
                   {
                    id: "nb-0-5-11", da: "Optimize your website for lead generation."
                   },
                   {
                    id: "nb-0-5-12", da: "Implement SEO to improve online visibility."
                   },
                   {
                    id: "nb-0-5-13", da: "Use content marketing to educate and engage."
                   },
                   {
                    id: "nb-0-5-14", da: "Develop a content calendar for consistency."
                   },
                   {
                    id: "nb-0-5-15", da: "Utilize social media for promotion and engagement."
                   },
                   {
                    id: "nb-0-5-16", da: "Invest in email marketing for lead nurturing."
                   },
                   {
                    id: "nb-0-5-17", da: "Implement marketing automation for efficiency."
                   },
                   {
                    id: "nb-0-5-18", da: "Use webinars and online events for education."
                   },
                   {
                    id: "nb-0-5-19", da: "Build partnerships and alliances in your industry."
                   },
                   {
                    id: "nb-0-5-20", da: "Attend and host industry-related events."
                   },
                   {
                    id: "nb-0-5-21", da: "Develop a referral program to encourage word-of-mouth."
                   },
                   {
                    id: "nb-0-5-22", da: "Leverage influencer marketing."
                   },
                   {
                    id: "nb-0-5-23", da: "Invest in paid advertising campaigns."
                   },
                   {
                    id: "nb-0-5-24", da: "Create compelling landing pages for campaigns."
                   },
                   {
                    id: "nb-0-5-25", da: "Implement A\/B testing for marketing campaigns."
                   },
                   {
                    id: "nb-0-5-26", da: "Utilize data analytics for insights and improvements."
                   },
                   {
                    id: "nb-0-5-27", da: "Develop a competitive analysis strategy."
                   },
                   {
                    id: "nb-0-5-28", da: "Provide training for your sales and marketing teams."
                   },
                   {
                    id: "nb-0-5-29", da: "Create sales enablement tools and materials."
                   },
                   {
                    id: "nb-0-5-30", da: "Set clear sales and marketing goals."
                   },
                   {
                    id: "nb-0-5-31", da: "Monitor and measure key performance indicators (KPIs)."
                   },
                   {
                    id: "nb-0-5-32", da: "Optimize pricing and packaging strategies."
                   },
                   {
                    id: "nb-0-5-33", da: "Offer limited-time promotions and discounts."
                   },
                   {
                    id: "nb-0-5-34", da: "Ensure customer support is readily available."
                   },
                   {
                    id: "nb-0-5-35", da: "Develop a customer feedback and review system."
                   },
                   {
                    id: "nb-0-5-36", da: "Monitor competitors and identify gaps in their strategies."
                   },
                   {
                    id: "nb-0-5-37", da: "Collaborate with industry experts and thought leaders."
                   },
                   {
                    id: "nb-0-5-38", da: "Invest in market expansion through internationalization."
                   },
                   {
                    id: "nb-0-5-39", da: "Offer personalized solutions for customers."
                   },
                   {
                    id: "nb-0-5-40", da: "Optimize supply chain and distribution channels."
                   },
                   {
                    id: "nb-0-5-41", da: "Focus on post-purchase customer engagement."
                   },
                   {
                    id: "nb-0-5-42", da: "Leverage affiliate marketing programs."
                   },
                   {
                    id: "nb-0-5-43", da: "Develop product launch strategies."
                   },
                   {
                    id: "nb-0-5-44", da: "Create a crisis management plan."
                   },
                   {
                    id: "nb-0-5-45", da: "Establish clear communication with your team."
                   },
                   {
                    id: "nb-0-5-46", da: "Implement customer relationship management (CRM) tools."
                   },
                   {
                    id: "nb-0-5-47", da: "Invest in employee training and development."
                   },
                   {
                    id: "nb-0-5-48", da: "Regularly update your go-to-market strategy."
                   },
                   {
                    id: "nb-0-5-49", da: "Seek feedback from customers and adapt to their changing needs."
                   },
                ]
              },
              {
                id: 'nb-0-6',
                pm: 'Community is structured in separate role and teams.',
                title:'People',
                pmMap: 'Community is structured in separate role and teams.',
                developmentActions:[
                  {
                    id: "nb-0-6-0", da: "Establish a mentorship program."
                   },
                   {
                    id: "nb-0-6-1", da: "Create opportunities for cross-functional collaboration."
                   },
                   {
                    id: "nb-0-6-2", da: "Develop clear job descriptions and role expectations."
                   },
                   {
                    id: "nb-0-6-3", da: "Offer training in effective communication."
                   },
                   {
                    id: "nb-0-6-4", da: "Foster a culture of inclusion and diversity."
                   },
                   {
                    id: "nb-0-6-5", da: "Provide continuous feedback and performance evaluations."
                   },
                   {
                    id: "nb-0-6-6", da: "Encourage employees to set personal and professional goals."
                   },
                   {
                    id: "nb-0-6-7", da: "Promote a healthy work-life balance."
                   },
                   {
                    id: "nb-0-6-8", da: "Support ongoing learning and skill development."
                   },
                   {
                    id: "nb-0-6-9", da: "Organize team-building activities and events."
                   },
                   {
                    id: "nb-0-6-10", da: "Implement a flexible work schedule."
                   },
                   {
                    id: "nb-0-6-11", da: "Recognize and reward outstanding performance."
                   },
                   {
                    id: "nb-0-6-12", da: "Encourage open and transparent communication."
                   },
                   {
                    id: "nb-0-6-13", da: "Foster a culture of innovation and creativity."
                   },
                   {
                    id: "nb-0-6-14", da: "Provide opportunities for leadership training."
                   },
                   {
                    id: "nb-0-6-15", da: "Support mental health and well-being."
                   },
                   {
                    id: "nb-0-6-16", da: "Establish clear channels for conflict resolution."
                   },
                   {
                    id: "nb-0-6-17", da: "Promote a positive and constructive feedback culture."
                   },
                   {
                    id: "nb-0-6-18", da: "Invest in employee wellness programs."
                   },
                   {
                    id: "nb-0-6-19", da: "Encourage knowledge sharing and documentation."
                   },
                   {
                    id: "nb-0-6-20", da: "Develop a comprehensive onboarding process."
                   },
                   {
                    id: "nb-0-6-21", da: "Offer cross-training opportunities."
                   },
                   {
                    id: "nb-0-6-22", da: "Create a knowledge-sharing platform."
                   },
                   {
                    id: "nb-0-6-23", da: "Implement a buddy system for new hires."
                   },
                   {
                    id: "nb-0-6-24", da: "Conduct regular team-building workshops."
                   },
                   {
                    id: "nb-0-6-25", da: "Offer diversity and inclusion training."
                   },
                   {
                    id: "nb-0-6-26", da: "Create a safe space for idea sharing."
                   },
                   {
                    id: "nb-0-6-27", da: "Promote a growth mindset."
                   },
                   {
                    id: "nb-0-6-28", da: "Encourage autonomy and ownership of projects."
                   },
                   {
                    id: "nb-0-6-29", da: "Provide resources for stress management."
                   },
                   {
                    id: "nb-0-6-30", da: "Recognize and address biases in the workplace."
                   },
                   {
                    id: "nb-0-6-31", da: "Support continuing education and certifications."
                   },
                   {
                    id: "nb-0-6-32", da: "Encourage participation in industry conferences."
                   },
                   {
                    id: "nb-0-6-33", da: "Provide coaching for professional development."
                   },
                   {
                    id: "nb-0-6-34", da: "Develop a clear career progression path."
                   },
                   {
                    id: "nb-0-6-35", da: "Offer leadership and management training."
                   },
                   {
                    id: "nb-0-6-36", da: "Foster a culture of adaptability and change."
                   },
                   {
                    id: "nb-0-6-37", da: "Conduct regular team surveys for feedback."
                   },
                   {
                    id: "nb-0-6-38", da: "Implement peer-to-peer recognition programs."
                   },
                   {
                    id: "nb-0-6-39", da: "Promote ethical behavior and integrity."
                   },
                   {
                    id: "nb-0-6-40", da: "Encourage volunteering and community involvement."
                   },
                   {
                    id: "nb-0-6-41", da: "Support work-related networking events."
                   },
                   {
                    id: "nb-0-6-42", da: "Promote a culture of continuous improvement."
                   },
                   {
                    id: "nb-0-6-43", da: "Offer financial planning and wellness resources."
                   },
                   {
                    id: "nb-0-6-44", da: "Create a knowledge-sharing repository."
                   },
                   {
                    id: "nb-0-6-45", da: "Invest in team-building retreats."
                   },
                   {
                    id: "nb-0-6-46", da: "Establish a flexible remote work policy."
                   },
                   {
                    id: "nb-0-6-47", da: "Encourage creative problem-solving."
                   },
                   {
                    id: "nb-0-6-48", da: "Promote knowledge transfer among teams."
                   },
                   {
                    id: "nb-0-6-49", da: "Develop a clear code of conduct and ethics policy."
                   },
                ]
              },
              {
                id: 'nb-0-7',
                pm: 'Good understandng of funnel and conversion rates.',
                title:'Data Metrics',
                pmMap: 'Good understandng of funnel and conversion rates.',
                developmentActions:[
                  {
                    id: "nb-0-7-0", da: "Identify key data metrics that align with your business goals."
                   },
                   {
                    id: "nb-0-7-1", da: "Develop a clear data strategy."
                   },
                   {
                    id: "nb-0-7-2", da: "Ensure data accuracy and integrity."
                   },
                   {
                    id: "nb-0-7-3", da: "Implement data governance policies."
                   },
                   {
                    id: "nb-0-7-4", da: "Define roles and responsibilities for data management."
                   },
                   {
                    id: "nb-0-7-5", da: "Conduct data audits to identify inconsistencies."
                   },
                   {
                    id: "nb-0-7-6", da: "Create a data dictionary for consistency in terminology."
                   },
                   {
                    id: "nb-0-7-7", da: "Develop a data catalog to track available data sources."
                   },
                   {
                    id: "nb-0-7-8", da: "Standardize data formats and conventions."
                   },
                   {
                    id: "nb-0-7-9", da: "Establish data quality standards and benchmarks."
                   },
                   {
                    id: "nb-0-7-10", da: "Implement data Crossing the Chasm checks."
                   },
                   {
                    id: "nb-0-7-11", da: "Monitor data sources for changes and updates."
                   },
                   {
                    id: "nb-0-7-12", da: "Implement data versioning to track changes."
                   },
                   {
                    id: "nb-0-7-13", da: "Ensure data security and access controls."
                   },
                   {
                    id: "nb-0-7-14", da: "Train teams on data handling and privacy."
                   },
                   {
                    id: "nb-0-7-15", da: "Implement data encryption for sensitive information."
                   },
                   {
                    id: "nb-0-7-16", da: "Set up a disaster recovery plan for data loss."
                   },
                   {
                    id: "nb-0-7-17", da: "Optimize data storage and archiving strategies."
                   },
                   {
                    id: "nb-0-7-18", da: "Automate data collection and processing."
                   },
                   {
                    id: "nb-0-7-19", da: "Invest in data cleansing tools and techniques."
                   },
                   {
                    id: "nb-0-7-20", da: "Implement data profiling to discover issues."
                   },
                   {
                    id: "nb-0-7-21", da: "Create data lineage diagrams for transparency."
                   },
                   {
                    id: "nb-0-7-22", da: "Define key performance indicators (KPIs)."
                   },
                   {
                    id: "nb-0-7-23", da: "Build dashboards for real-time data monitoring."
                   },
                   {
                    id: "nb-0-7-24", da: "Develop reports for data insights."
                   },
                   {
                    id: "nb-0-7-25", da: "Implement data mining and analytics tools."
                   },
                   {
                    id: "nb-0-7-26", da: "Utilize machine learning for predictive analysis."
                   },
                   {
                    id: "nb-0-7-27", da: "A\/B test data-driven strategies."
                   },
                   {
                    id: "nb-0-7-28", da: "Conduct surveys and gather user feedback."
                   },
                   {
                    id: "nb-0-7-29", da: "Collaborate with data scientists for advanced analytics."
                   },
                   {
                    id: "nb-0-7-30", da: "Invest in data visualization tools."
                   },
                   {
                    id: "nb-0-7-31", da: "Create a data feedback loop for continuous improvement."
                   },
                   {
                    id: "nb-0-7-32", da: "Identify and address data silos."
                   },
                   {
                    id: "nb-0-7-33", da: "Establish data integration points."
                   },
                   {
                    id: "nb-0-7-34", da: "Develop APIs for data sharing."
                   },
                   {
                    id: "nb-0-7-35", da: "Leverage cloud solutions for data scalability."
                   },
                   {
                    id: "nb-0-7-36", da: "Implement data compression techniques."
                   },
                   {
                    id: "nb-0-7-37", da: "Optimize database indexing and query performance."
                   },
                   {
                    id: "nb-0-7-38", da: "Use data warehousing for historical analysis."
                   },
                   {
                    id: "nb-0-7-39", da: "Implement data streaming for real-time insights."
                   },
                   {
                    id: "nb-0-7-40", da: "Enhance data backup and recovery solutions."
                   },
                   {
                    id: "nb-0-7-41", da: "Address data storage bottlenecks."
                   },
                   {
                    id: "nb-0-7-42", da: "Consider data sharding for distributed storage."
                   },
                   {
                    id: "nb-0-7-43", da: "Monitor network bandwidth for data transfer."
                   },
                   {
                    id: "nb-0-7-44", da: "Optimize data compression and decompression."
                   },
                   {
                    id: "nb-0-7-45", da: "Ensure data compliance with regulations (e.g., GDPR)."
                   },
                   {
                    id: "nb-0-7-46", da: "Create a data culture within the organization."
                   },
                   {
                    id: "nb-0-7-47", da: "Encourage data collaboration between departments."
                   },
                   {
                    id: "nb-0-7-48", da: "Review data performance regularly."
                   },
                   {
                    id: "nb-0-7-49", da: "Stay updated with industry best practices and emerging technologies."
                   },
                ]
              },
              {
                id: 'nb-0-8',
                pm: 'Satisfaction of community at large and the moderating team is being monitored.',
                title:'Operations',
                pmMap: 'Satisfaction of community at large and the moderating team is being monitored.',
                developmentActions:[
                  {
                    id: "nb-0-8-0", da: "Implement a robust project management system."
                   },
                   {
                    id: "nb-0-8-1", da: "Streamline communication channels."
                   },
                   {
                    id: "nb-0-8-2", da: "Foster cross-functional collaboration."
                   },
                   {
                    id: "nb-0-8-3", da: "Develop clear and concise standard operating procedures."
                   },
                   {
                    id: "nb-0-8-4", da: "Implement regular performance evaluations."
                   },
                   {
                    id: "nb-0-8-5", da: "Provide ongoing training and development for employees."
                   },
                   {
                    id: "nb-0-8-6", da: "Encourage employee feedback and suggestions."
                   },
                   {
                    id: "nb-0-8-7", da: "Optimize inventory management."
                   },
                   {
                    id: "nb-0-8-8", da: "Enhance supply chain efficiency."
                   },
                   {
                    id: "nb-0-8-9", da: "Implement lean manufacturing principles."
                   },
                   {
                    id: "nb-0-8-10", da: "Improve quality control processes."
                   },
                   {
                    id: "nb-0-8-11", da: "Conduct regular equipment maintenance and upgrades."
                   },
                   {
                    id: "nb-0-8-12", da: "Optimize production scheduling."
                   },
                   {
                    id: "nb-0-8-13", da: "Establish clear KPIs and performance metrics."
                   },
                   {
                    id: "nb-0-8-14", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "nb-0-8-15", da: "Invest in advanced technology and automation."
                   },
                   {
                    id: "nb-0-8-16", da: "Enhance data analytics capabilities."
                   },
                   {
                    id: "nb-0-8-17", da: "Implement cost-saving initiatives."
                   },
                   {
                    id: "nb-0-8-18", da: "Enhance risk management strategies."
                   },
                   {
                    id: "nb-0-8-19", da: "Improve customer service and support."
                   },
                   {
                    id: "nb-0-8-20", da: "Expand into new markets and customer segments."
                   },
                   {
                    id: "nb-0-8-21", da: "Enhance vendor and supplier relationships."
                   },
                   {
                    id: "nb-0-8-22", da: "Optimize distribution and logistics."
                   },
                   {
                    id: "nb-0-8-23", da: "Implement energy-efficient practices."
                   },
                   {
                    id: "nb-0-8-24", da: "Enhance environmental sustainability initiatives."
                   },
                   {
                    id: "nb-0-8-25", da: "Develop a disaster recovery and business continuity plan."
                   },
                   {
                    id: "nb-0-8-26", da: "Implement cybersecurity measures."
                   },
                   {
                    id: "nb-0-8-27", da: "Enhance workplace safety and compliance."
                   },
                   {
                    id: "nb-0-8-28", da: "Implement diversity and inclusion programs."
                   },
                   {
                    id: "nb-0-8-29", da: "Optimize employee benefits and wellness programs."
                   },
                   {
                    id: "nb-0-8-30", da: "Foster leadership development."
                   },
                   {
                    id: "nb-0-8-31", da: "Streamline financial and budgeting processes."
                   },
                   {
                    id: "nb-0-8-32", da: "Improve cash flow management."
                   },
                   {
                    id: "nb-0-8-33", da: "Optimize tax planning and compliance."
                   },
                   {
                    id: "nb-0-8-34", da: "Enhance marketing and branding efforts."
                   },
                   {
                    id: "nb-0-8-35", da: "Improve social media and online presence."
                   },
                   {
                    id: "nb-0-8-36", da: "Develop content marketing strategies."
                   },
                   {
                    id: "nb-0-8-37", da: "Expand product and service offerings."
                   },
                   {
                    id: "nb-0-8-38", da: "Enhance sales and customer acquisition strategies."
                   },
                   {
                    id: "nb-0-8-39", da: "Implement feedback and complaint handling procedures."
                   },
                   {
                    id: "nb-0-8-40", da: "Foster community engagement and corporate social responsibility."
                   },
                   {
                    id: "nb-0-8-41", da: "Improve corporate governance and ethics."
                   },
                   {
                    id: "nb-0-8-42", da: "Optimize legal and regulatory compliance."
                   },
                   {
                    id: "nb-0-8-43", da: "Develop a crisis management plan."
                   },
                   {
                    id: "nb-0-8-44", da: "Enhance public relations and media relations."
                   },
                   {
                    id: "nb-0-8-45", da: "Implement a knowledge management system."
                   },
                   {
                    id: "nb-0-8-46", da: "Foster innovation and creativity within the organization."
                   },
                   {
                    id: "nb-0-8-47", da: "Invest in employee well-being and work-life balance."
                   },
                   {
                    id: "nb-0-8-48", da: "Optimize recruitment and talent acquisition."
                   },
                   {
                    id: "nb-0-8-49", da: "Foster a culture of accountability and responsibility."
                   },
                ]
              },
              {
                id: 'nb-0-9',
                pm: 'Potential successors have been identified for key roles.',
                title:'Exit Strategy',
                pmMap: 'Potential successors have been identified for key roles.',
                developmentActions:[
                  {
                    id: "nb-0-9-0", da: "Document the exit strategy from the outset."
                   },
                   {
                    id: "nb-0-9-1", da: "Define clear exit criteria for participants."
                   },
                   {
                    id: "nb-0-9-2", da: "Ensure the exit strategy aligns with organizational goals."
                   },
                   {
                    id: "nb-0-9-3", da: "Assess the financial implications of exit scenarios."
                   },
                   {
                    id: "nb-0-9-4", da: "Evaluate legal and contractual obligations."
                   },
                   {
                    id: "nb-0-9-5", da: "Identify potential exit triggers."
                   },
                   {
                    id: "nb-0-9-6", da: "Consider different exit routes."
                   },
                   {
                    id: "nb-0-9-7", da: "Determine exit timing."
                   },
                   {
                    id: "nb-0-9-8", da: "Analyze market conditions."
                   },
                   {
                    id: "nb-0-9-9", da: "Assess the impact on stakeholders."
                   },
                   {
                    id: "nb-0-9-10", da: "Communicate the strategy to relevant parties."
                   },
                   {
                    id: "nb-0-9-11", da: "Develop a transition plan for departing members."
                   },
                   {
                    id: "nb-0-9-12", da: "Create knowledge transfer mechanisms."
                   },
                   {
                    id: "nb-0-9-13", da: "Implement feedback loops for continuous improvement."
                   },
                   {
                    id: "nb-0-9-14", da: "Plan for data and information transfer."
                   },
                   {
                    id: "nb-0-9-15", da: "Review the exit strategy regularly."
                   },
                   {
                    id: "nb-0-9-16", da: "Consider exit fees or penalties."
                   },
                   {
                    id: "nb-0-9-17", da: "Evaluate the impact on network performance."
                   },
                   {
                    id: "nb-0-9-18", da: "Ensure compliance with regulatory requirements."
                   },
                   {
                    id: "nb-0-9-19", da: "Assess the impact on reputation."
                   },
                   {
                    id: "nb-0-9-20", da: "Maintain a contingency plan for unplanned exits."
                   },
                   {
                    id: "nb-0-9-21", da: "Address intellectual property and ownership."
                   },
                   {
                    id: "nb-0-9-22", da: "Consider a gradual exit approach."
                   },
                   {
                    id: "nb-0-9-23", da: "Collaborate with departing members for a smooth transition."
                   },
                   {
                    id: "nb-0-9-24", da: "Preserve relationships with exiting parties."
                   },
                   {
                    id: "nb-0-9-25", da: "Develop a strategy for resource reallocation."
                   },
                   {
                    id: "nb-0-9-26", da: "Minimize disruptions during the exit process."
                   },
                   {
                    id: "nb-0-9-27", da: "Plan for member buyouts or equity transfers."
                   },
                   {
                    id: "nb-0-9-28", da: "Evaluate the impact on ongoing projects."
                   },
                   {
                    id: "nb-0-9-29", da: "Consider the implications for funding and financing."
                   },
                   {
                    id: "nb-0-9-30", da: "Address the impact on branding and marketing."
                   },
                   {
                    id: "nb-0-9-31", da: "Assess the potential for mergers or acquisitions."
                   },
                   {
                    id: "nb-0-9-32", da: "Evaluate the impact on workforce and talent."
                   },
                   {
                    id: "nb-0-9-33", da: "Determine liability and indemnification."
                   },
                   {
                    id: "nb-0-9-34", da: "Prepare for asset liquidation or divestiture."
                   },
                   {
                    id: "nb-0-9-35", da: "Consider post-exit restrictions and non-competes."
                   },
                   {
                    id: "nb-0-9-36", da: "Ensure that exit plans align with strategic objectives."
                   },
                   {
                    id: "nb-0-9-37", da: "Establish an exit management team or committee."
                   },
                   {
                    id: "nb-0-9-38", da: "Evaluate the impact on innovation and R&D."
                   },
                   {
                    id: "nb-0-9-39", da: "Monitor key performance indicators (KPIs) during the exit."
                   },
                   {
                    id: "nb-0-9-40", da: "Assess the effects on product or service offerings."
                   },
                   {
                    id: "nb-0-9-41", da: "Address challenges related to data security and privacy."
                   },
                   {
                    id: "nb-0-9-42", da: "Develop a communication plan for all stakeholders."
                   },
                   {
                    id: "nb-0-9-43", da: "Ensure transparency and accountability."
                   },
                   {
                    id: "nb-0-9-44", da: "Review insurance and risk management."
                   },
                   {
                    id: "nb-0-9-45", da: "Plan for a knowledge retention strategy."
                   },
                   {
                    id: "nb-0-9-46", da: "Evaluate the effects on suppliers and partners."
                   },
                   {
                    id: "nb-0-9-47", da: "Document historical data for future reference."
                   },
                   {
                    id: "nb-0-9-48", da: "Analyze exit scenarios for each member type."
                   },
                   {
                    id: "nb-0-9-49", da: "Continuously monitor industry trends and adapt the strategy accordingly."
                   },
                ]
              }
            ]
          },
          {
            id: 'nb-1',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Engagement',
            wdd: '',
            progressMeasures:[
              {
                id: 'nb-1-0',
                pm: 'Engagement reaches beyond early adoptors and messaging is adjusted to reach audience within community. The community has its first sense of cultural synergy around the need, mission and values.',
                title:'Need',
                pmMap: 'Engagement reaches beyond early adoptors and messaging is adjusted to reach audience within community. The community has its first sense of cultural synergy around the need, mission and values.',
                developmentActions:[
                  {
                    id: "nb-1-0-0", da: "Create a comprehensive list of existing contacts."
                   },
                   {
                    id: "nb-1-0-1", da: "Identify key stakeholders in your network."
                   },
                   {
                    id: "nb-1-0-2", da: "Segment your network into categories (e.g., clients, partners, mentors)."
                   },
                   {
                    id: "nb-1-0-3", da: "Set specific networking goals for each category."
                   },
                   {
                    id: "nb-1-0-4", da: "Regularly update your contact information."
                   },
                   {
                    id: "nb-1-0-5", da: "Attend industry-specific events and conferences."
                   },
                   {
                    id: "nb-1-0-6", da: "Participate in online forums and groups related to your field."
                   },
                   {
                    id: "nb-1-0-7", da: "Offer to speak at conferences or webinars."
                   },
                   {
                    id: "nb-1-0-8", da: "Host your own networking events."
                   },
                   {
                    id: "nb-1-0-9", da: "Leverage social media to connect with professionals."
                   },
                   {
                    id: "nb-1-0-10", da: "Regularly update your LinkedIn profile."
                   },
                   {
                    id: "nb-1-0-11", da: "Share relevant industry news and insights on social media."
                   },
                   {
                    id: "nb-1-0-12", da: "Join local business organizations and chambers of commerce."
                   },
                   {
                    id: "nb-1-0-13", da: "Attend networking mixers and meetups."
                   },
                   {
                    id: "nb-1-0-14", da: "Use a customer relationship management (CRM) tool."
                   },
                   {
                    id: "nb-1-0-15", da: "Set up regular one-on-one meetings with contacts."
                   },
                   {
                    id: "nb-1-0-16", da: "Seek out and connect with new contacts regularly."
                   },
                   {
                    id: "nb-1-0-17", da: "Practice active listening during conversations."
                   },
                   {
                    id: "nb-1-0-18", da: "Provide value to your network by sharing resources."
                   },
                   {
                    id: "nb-1-0-19", da: "Send personalized follow-up emails after meetings."
                   },
                   {
                    id: "nb-1-0-20", da: "Build relationships with competitors for potential collaborations."
                   },
                   {
                    id: "nb-1-0-21", da: "Volunteer for industry-related committees or boards."
                   },
                   {
                    id: "nb-1-0-22", da: "Create a professional email signature."
                   },
                   {
                    id: "nb-1-0-23", da: "Write and share insightful blog posts."
                   },
                   {
                    id: "nb-1-0-24", da: "Create a personal website or portfolio."
                   },
                   {
                    id: "nb-1-0-25", da: "Learn and remember names and faces."
                   },
                   {
                    id: "nb-1-0-26", da: "Send handwritten thank-you notes."
                   },
                   {
                    id: "nb-1-0-27", da: "Request introductions from mutual contacts."
                   },
                   {
                    id: "nb-1-0-28", da: "Attend local community events."
                   },
                   {
                    id: "nb-1-0-29", da: "Use video conferencing for virtual meetings."
                   },
                   {
                    id: "nb-1-0-30", da: "Invest in professional attire."
                   },
                   {
                    id: "nb-1-0-31", da: "Develop an elevator pitch about your work."
                   },
                   {
                    id: "nb-1-0-32", da: "Mentor and offer support to junior professionals."
                   },
                   {
                    id: "nb-1-0-33", da: "Seek out opportunities for cross-industry networking."
                   },
                   {
                    id: "nb-1-0-34", da: "Attend trade shows and expos."
                   },
                   {
                    id: "nb-1-0-35", da: "Keep track of interactions and follow-ups."
                   },
                   {
                    id: "nb-1-0-36", da: "Be open to new networking technologies and tools."
                   },
                   {
                    id: "nb-1-0-37", da: "Build a referral network."
                   },
                   {
                    id: "nb-1-0-38", da: "Create a networking calendar or schedule."
                   },
                   {
                    id: "nb-1-0-39", da: "Join online platforms like LinkedIn groups."
                   },
                   {
                    id: "nb-1-0-40", da: "Be punctual and respectful of others' time."
                   },
                   {
                    id: "nb-1-0-41", da: "Host webinars or online workshops."
                   },
                   {
                    id: "nb-1-0-42", da: "Collaborate on industry-related Stakeholder Activation or projects."
                   },
                   {
                    id: "nb-1-0-43", da: "Attend local charity events and fundraisers."
                   },
                   {
                    id: "nb-1-0-44", da: "Offer to help with event planning."
                   },
                   {
                    id: "nb-1-0-45", da: "Organize your contacts into tiers of importance."
                   },
                   {
                    id: "nb-1-0-46", da: "Keep business cards handy."
                   },
                   {
                    id: "nb-1-0-47", da: "Take advantage of alumni networks."
                   },
                   {
                    id: "nb-1-0-48", da: "Develop a strong personal brand."
                   },
                   {
                    id: "nb-1-0-49", da: "Continuously seek feedback for self-improvement."
                   },
                ]
              },
              {
                id: 'nb-1-1',
                pm: 'Early partnerships are established with other communities.',
                title:'Market',
                pmMap: 'Early partnerships are established with other communities.',
                developmentActions:[
                  {
                    id: "nb-1-1-0", da: "Conduct surveys to gather customer feedback."
                   },
                   {
                    id: "nb-1-1-1", da: "Analyze competitors' strategies and market positioning."
                   },
                   {
                    id: "nb-1-1-2", da: "Collaborate with industry influencers."
                   },
                   {
                    id: "nb-1-1-3", da: "Host webinars or online events to connect with potential customers."
                   },
                   {
                    id: "nb-1-1-4", da: "Implement social media listening to monitor brand mentions."
                   },
                   {
                    id: "nb-1-1-5", da: "Create targeted email marketing campaigns."
                   },
                   {
                    id: "nb-1-1-6", da: "Develop a referral program for existing customers."
                   },
                   {
                    id: "nb-1-1-7", da: "Enhance your website's user experience."
                   },
                   {
                    id: "nb-1-1-8", da: "Optimize your product or service pricing strategy."
                   },
                   {
                    id: "nb-1-1-9", da: "Stakeholder Activation and understand emerging market trends."
                   },
                   {
                    id: "nb-1-1-10", da: "Launch a loyalty program to retain customers."
                   },
                   {
                    id: "nb-1-1-11", da: "Build strategic partnerships with complementary businesses."
                   },
                   {
                    id: "nb-1-1-12", da: "Develop case studies and success stories to showcase your products."
                   },
                   {
                    id: "nb-1-1-13", da: "Offer discounts and promotions."
                   },
                   {
                    id: "nb-1-1-14", da: "Participate in trade shows and exhibitions."
                   },
                   {
                    id: "nb-1-1-15", da: "Expand your product or service offerings."
                   },
                   {
                    id: "nb-1-1-16", da: "Localize your marketing for different regions."
                   },
                   {
                    id: "nb-1-1-17", da: "Create high-quality, informative content."
                   },
                   {
                    id: "nb-1-1-18", da: "Invest in search engine optimization (SEO) to improve visibility."
                   },
                   {
                    id: "nb-1-1-19", da: "Engage with local communities through sponsorships and events."
                   },
                   {
                    id: "nb-1-1-20", da: "Implement pay-per-click (PPC) advertising campaigns."
                   },
                   {
                    id: "nb-1-1-21", da: "Offer personalized product recommendations."
                   },
                   {
                    id: "nb-1-1-22", da: "Leverage user-generated content and reviews."
                   },
                   {
                    id: "nb-1-1-23", da: "Improve customer support and service."
                   },
                   {
                    id: "nb-1-1-24", da: "Analyze customer purchase behavior to make data-driven decisions."
                   },
                   {
                    id: "nb-1-1-25", da: "Strengthen your social media presence."
                   },
                   {
                    id: "nb-1-1-26", da: "Optimize your online store for mobile devices."
                   },
                   {
                    id: "nb-1-1-27", da: "Invest in customer relationship management (CRM) software."
                   },
                   {
                    id: "nb-1-1-28", da: "Create a mobile app for your business."
                   },
                   {
                    id: "nb-1-1-29", da: "Expand into new geographic markets."
                   },
                   {
                    id: "nb-1-1-30", da: "Conduct competitor analysis to identify gaps in the market."
                   },
                   {
                    id: "nb-1-1-31", da: "Implement influencer marketing campaigns."
                   },
                   {
                    id: "nb-1-1-32", da: "Enhance your packaging and branding."
                   },
                   {
                    id: "nb-1-1-33", da: "Invest in customer segmentation and targeting."
                   },
                   {
                    id: "nb-1-1-34", da: "Use analytics tools to track website performance."
                   },
                   {
                    id: "nb-1-1-35", da: "Develop a comprehensive content marketing strategy."
                   },
                   {
                    id: "nb-1-1-36", da: "Run A\/B tests to optimize website elements."
                   },
                   {
                    id: "nb-1-1-37", da: "Improve your product descriptions and images."
                   },
                   {
                    id: "nb-1-1-38", da: "Collaborate with local businesses for cross-promotions."
                   },
                   {
                    id: "nb-1-1-39", da: "Create a content calendar for consistent publishing."
                   },
                   {
                    id: "nb-1-1-40", da: "Offer exceptional customer service training to your team."
                   },
                   {
                    id: "nb-1-1-41", da: "Implement customer feedback into product development."
                   },
                   {
                    id: "nb-1-1-42", da: "Enhance your online payment options."
                   },
                   {
                    id: "nb-1-1-43", da: "Explore international market expansion."
                   },
                   {
                    id: "nb-1-1-44", da: "Optimize your checkout process for simplicity."
                   },
                   {
                    id: "nb-1-1-45", da: "Build trust and transparency through ethical marketing."
                   },
                   {
                    id: "nb-1-1-46", da: "Invest in sustainability and eco-friendly practices."
                   },
                   {
                    id: "nb-1-1-47", da: "Launch a customer referral program."
                   },
                   {
                    id: "nb-1-1-48", da: "Utilize social proof like testimonials and trust badges."
                   },
                   {
                    id: "nb-1-1-49", da: "Monitor and respond to online reviews and feedback promptly."
                   },
                ]
              },
              {
                id: 'nb-1-2',
                pm: 'Tools to schedule are set for engaging community.',
                title:'Technology',
                pmMap: 'Tools to schedule are set for engaging community.',
                developmentActions:[
                  {
                    id: "nb-1-2-0", da: "Invest in modern and scalable infrastructure."
                   },
                   {
                    id: "nb-1-2-1", da: "Improve network security through encryption and firewalls."
                   },
                   {
                    id: "nb-1-2-2", da: "Implement two-factor authentication for added security."
                   },
                   {
                    id: "nb-1-2-3", da: "Regularly update and patch software and hardware."
                   },
                   {
                    id: "nb-1-2-4", da: "Develop a disaster recovery plan for data backup."
                   },
                   {
                    id: "nb-1-2-5", da: "Implement cloud-based solutions for flexibility."
                   },
                   {
                    id: "nb-1-2-6", da: "Introduce virtualization to optimize resource usage."
                   },
                   {
                    id: "nb-1-2-7", da: "Explore containerization for application deployment."
                   },
                   {
                    id: "nb-1-2-8", da: "Enhance network monitoring and management tools."
                   },
                   {
                    id: "nb-1-2-9", da: "Implement IoT devices for data collection and analysis."
                   },
                   {
                    id: "nb-1-2-10", da: "Improve network performance with load balancing."
                   },
                   {
                    id: "nb-1-2-11", da: "Invest in high-speed internet connectivity."
                   },
                   {
                    id: "nb-1-2-12", da: "Upgrade to faster storage solutions (e.g., SSDs)."
                   },
                   {
                    id: "nb-1-2-13", da: "Develop a mobile app for improved accessibility."
                   },
                   {
                    id: "nb-1-2-14", da: "Embrace DevOps practices for efficient development."
                   },
                   {
                    id: "nb-1-2-15", da: "Use version control (e.g., Git) for code management."
                   },
                   {
                    id: "nb-1-2-16", da: "Implement continuous integration and continuous deployment (CI\/CD)."
                   },
                   {
                    id: "nb-1-2-17", da: "Adopt microservices architecture for flexibility."
                   },
                   {
                    id: "nb-1-2-18", da: "Enhance data analytics capabilities."
                   },
                   {
                    id: "nb-1-2-19", da: "Explore machine learning and AI for data insights."
                   },
                   {
                    id: "nb-1-2-20", da: "Upgrade operating systems to the latest versions."
                   },
                   {
                    id: "nb-1-2-21", da: "Improve network redundancy for reliability."
                   },
                   {
                    id: "nb-1-2-22", da: "Invest in modern data centers."
                   },
                   {
                    id: "nb-1-2-23", da: "Develop a responsive website for mobile users."
                   },
                   {
                    id: "nb-1-2-24", da: "Enhance user experience with intuitive design."
                   },
                   {
                    id: "nb-1-2-25", da: "Implement data encryption at rest and in transit."
                   },
                   {
                    id: "nb-1-2-26", da: "Regularly audit and assess cybersecurity measures."
                   },
                   {
                    id: "nb-1-2-27", da: "Develop a mobile-responsive email marketing strategy."
                   },
                   {
                    id: "nb-1-2-28", da: "Improve website load times for better user experience."
                   },
                   {
                    id: "nb-1-2-29", da: "Explore blockchain technology for secure transactions."
                   },
                   {
                    id: "nb-1-2-30", da: "Upgrade routers and switches for better data flow."
                   },
                   {
                    id: "nb-1-2-31", da: "Invest in advanced data visualization tools."
                   },
                   {
                    id: "nb-1-2-32", da: "Optimize server response times."
                   },
                   {
                    id: "nb-1-2-33", da: "Develop a technology training program for staff."
                   },
                   {
                    id: "nb-1-2-34", da: "Enhance customer support with chatbots."
                   },
                   {
                    id: "nb-1-2-35", da: "Implement video conferencing for remote collaboration."
                   },
                   {
                    id: "nb-1-2-36", da: "Upgrade to 5G connectivity where available."
                   },
                   {
                    id: "nb-1-2-37", da: "Explore augmented reality (AR) for interactive experiences."
                   },
                   {
                    id: "nb-1-2-38", da: "Develop a content delivery network (CDN) for global reach."
                   },
                   {
                    id: "nb-1-2-39", da: "Improve data governance and compliance."
                   },
                   {
                    id: "nb-1-2-40", da: "Invest in cybersecurity awareness training."
                   },
                   {
                    id: "nb-1-2-41", da: "Implement a robust content management system (CMS)."
                   },
                   {
                    id: "nb-1-2-42", da: "Explore edge computing for low-latency applications."
                   },
                   {
                    id: "nb-1-2-43", da: "Develop a mobile payment solution."
                   },
                   {
                    id: "nb-1-2-44", da: "Upgrade to modern programming languages."
                   },
                   {
                    id: "nb-1-2-45", da: "Enhance e-commerce platforms for online sales."
                   },
                   {
                    id: "nb-1-2-46", da: "Explore big data solutions for analytics."
                   },
                   {
                    id: "nb-1-2-47", da: "Develop a responsive customer support portal."
                   },
                   {
                    id: "nb-1-2-48", da: "Implement social media analytics tools."
                   },
                   {
                    id: "nb-1-2-49", da: "Upgrade network infrastructure to support emerging technologies."
                   },
                ]
              },
              {
                id: 'nb-1-3',
                pm: 'Customers love it and are willing to promote solution. NPS and active users are improving.',
                title:'Value',
                pmMap: 'Customers love it and are willing to promote solution. NPS and active users are improving.',
                developmentActions:[
                  {
                    id: "nb-1-3-0", da: "Attend industry conferences and events to meet like-minded professionals."
                   },
                   {
                    id: "nb-1-3-1", da: "Join relevant online forums and communities."
                   },
                   {
                    id: "nb-1-3-2", da: "Collaborate on joint projects with peers."
                   },
                   {
                    id: "nb-1-3-3", da: "Create a personal website or blog to showcase your expertise."
                   },
                   {
                    id: "nb-1-3-4", da: "Share valuable insights and content on social media."
                   },
                   {
                    id: "nb-1-3-5", da: "Seek out mentorship or coaching relationships."
                   },
                   {
                    id: "nb-1-3-6", da: "Participate in webinars and online courses."
                   },
                   {
                    id: "nb-1-3-7", da: "Volunteer for nonprofit or community organizations."
                   },
                   {
                    id: "nb-1-3-8", da: "Connect with professionals on LinkedIn."
                   },
                   {
                    id: "nb-1-3-9", da: "Attend local networking events and meetups."
                   },
                   {
                    id: "nb-1-3-10", da: "Write articles or guest posts for industry publications."
                   },
                   {
                    id: "nb-1-3-11", da: "Host webinars or workshops to share your knowledge."
                   },
                   {
                    id: "nb-1-3-12", da: "Join professional associations or organizations."
                   },
                   {
                    id: "nb-1-3-13", da: "Engage in thought leadership by sharing your perspective on industry trends."
                   },
                   {
                    id: "nb-1-3-14", da: "Offer to speak at conferences or events."
                   },
                   {
                    id: "nb-1-3-15", da: "Create a podcast or YouTube channel."
                   },
                   {
                    id: "nb-1-3-16", da: "Collaborate on Stakeholder Activation or whitepapers."
                   },
                   {
                    id: "nb-1-3-17", da: "Write a book or e-book on your area of expertise."
                   },
                   {
                    id: "nb-1-3-18", da: "Participate in mastermind groups."
                   },
                   {
                    id: "nb-1-3-19", da: "Seek out feedback and constructive criticism from your network."
                   },
                   {
                    id: "nb-1-3-20", da: "Offer your skills and expertise to help others."
                   },
                   {
                    id: "nb-1-3-21", da: "Attend trade shows and exhibitions."
                   },
                   {
                    id: "nb-1-3-22", da: "Host or attend networking dinners or gatherings."
                   },
                   {
                    id: "nb-1-3-23", da: "Provide pro bono services to build your portfolio."
                   },
                   {
                    id: "nb-1-3-24", da: "Conduct surveys or market Stakeholder Activation to gather insights."
                   },
                   {
                    id: "nb-1-3-25", da: "Establish partnerships with complementary businesses."
                   },
                   {
                    id: "nb-1-3-26", da: "Organize local meetups or industry-specific events."
                   },
                   {
                    id: "nb-1-3-27", da: "Create an email newsletter to share updates and insights."
                   },
                   {
                    id: "nb-1-3-28", da: "Share case studies of your successful projects."
                   },
                   {
                    id: "nb-1-3-29", da: "Engage in collaborative problem-solving."
                   },
                   {
                    id: "nb-1-3-30", da: "Build relationships with influencers in your field."
                   },
                   {
                    id: "nb-1-3-31", da: "Offer free workshops or training sessions."
                   },
                   {
                    id: "nb-1-3-32", da: "Initiate one-on-one coffee meetings with peers."
                   },
                   {
                    id: "nb-1-3-33", da: "Create a personal brand that reflects your values."
                   },
                   {
                    id: "nb-1-3-34", da: "Showcase testimonials from satisfied clients or colleagues."
                   },
                   {
                    id: "nb-1-3-35", da: "Share your network's achievements on social media."
                   },
                   {
                    id: "nb-1-3-36", da: "Organize or sponsor charity events."
                   },
                   {
                    id: "nb-1-3-37", da: "Participate in online challenges or competitions."
                   },
                   {
                    id: "nb-1-3-38", da: "Share your success stories and lessons learned."
                   },
                   {
                    id: "nb-1-3-39", da: "Offer to be a guest on podcasts or interviews."
                   },
                   {
                    id: "nb-1-3-40", da: "Leverage video conferencing for remote networking."
                   },
                   {
                    id: "nb-1-3-41", da: "Join Slack or Discord channels related to your interests."
                   },
                   {
                    id: "nb-1-3-42", da: "Write and publish industry-specific guides."
                   },
                   {
                    id: "nb-1-3-43", da: "Invest in ongoing education and skill development."
                   },
                   {
                    id: "nb-1-3-44", da: "Attend meet-and-greet sessions at conferences."
                   },
                   {
                    id: "nb-1-3-45", da: "Build relationships with colleagues from diverse backgrounds."
                   },
                   {
                    id: "nb-1-3-46", da: "Join online peer review groups."
                   },
                   {
                    id: "nb-1-3-47", da: "Connect with alumni from your educational institutions."
                   },
                   {
                    id: "nb-1-3-48", da: "Offer to mentor others in your field."
                   },
                   {
                    id: "nb-1-3-49", da: "Stay open to new opportunities and keep evolving."
                   },
                ]
              },
              {
                id: 'nb-1-4',
                pm: 'Engagement with community events is positive with viable and sustainable unit economics.',
                title:'Business Model',
                pmMap: 'Engagement with community events is positive with viable and sustainable unit economics.',
                developmentActions:[
                  {
                    id: "nb-1-4-0", da: "Conduct a SWOT analysis to identify strengths, weaknesses, opportunities, and threats."
                   },
                   {
                    id: "nb-1-4-1", da: "Define your value proposition clearly."
                   },
                   {
                    id: "nb-1-4-2", da: "Identify your target market and understand their needs."
                   },
                   {
                    id: "nb-1-4-3", da: "Segment your customer base to tailor offerings."
                   },
                   {
                    id: "nb-1-4-4", da: "Explore new customer segments or markets."
                   },
                   {
                    id: "nb-1-4-5", da: "Analyze the competitive landscape."
                   },
                   {
                    id: "nb-1-4-6", da: "Assess the scalability of your business model."
                   },
                   {
                    id: "nb-1-4-7", da: "Optimize your pricing strategy."
                   },
                   {
                    id: "nb-1-4-8", da: "Consider alternative revenue streams."
                   },
                   {
                    id: "nb-1-4-9", da: "Evaluate your cost structure for efficiency."
                   },
                   {
                    id: "nb-1-4-10", da: "Focus on cost reduction strategies."
                   },
                   {
                    id: "nb-1-4-11", da: "Review your distribution channels for effectiveness."
                   },
                   {
                    id: "nb-1-4-12", da: "Explore online and offline distribution options."
                   },
                   {
                    id: "nb-1-4-13", da: "Examine partnerships and collaborations."
                   },
                   {
                    id: "nb-1-4-14", da: "Investigate potential mergers or acquisitions."
                   },
                   {
                    id: "nb-1-4-15", da: "Diversify product or service offerings."
                   },
                   {
                    id: "nb-1-4-16", da: "Enhance customer support and service quality."
                   },
                   {
                    id: "nb-1-4-17", da: "Implement feedback loops for continuous improvement."
                   },
                   {
                    id: "nb-1-4-18", da: "Develop a strong brand identity."
                   },
                   {
                    id: "nb-1-4-19", da: "Invest in marketing and advertising."
                   },
                   {
                    id: "nb-1-4-20", da: "Leverage social media for promotion."
                   },
                   {
                    id: "nb-1-4-21", da: "Establish a content marketing strategy."
                   },
                   {
                    id: "nb-1-4-22", da: "Consider influencer marketing."
                   },
                   {
                    id: "nb-1-4-23", da: "Create a compelling website and improve its user experience."
                   },
                   {
                    id: "nb-1-4-24", da: "Enhance search engine optimization (SEO) efforts."
                   },
                   {
                    id: "nb-1-4-25", da: "Invest in email marketing campaigns."
                   },
                   {
                    id: "nb-1-4-26", da: "Optimize mobile and responsive design."
                   },
                   {
                    id: "nb-1-4-27", da: "Evaluate the effectiveness of your sales funnel."
                   },
                   {
                    id: "nb-1-4-28", da: "Implement lead generation strategies."
                   },
                   {
                    id: "nb-1-4-29", da: "Develop a sales training program."
                   },
                   {
                    id: "nb-1-4-30", da: "Streamline the order fulfillment process."
                   },
                   {
                    id: "nb-1-4-31", da: "Explore international expansion opportunities."
                   },
                   {
                    id: "nb-1-4-32", da: "Invest in Stakeholder Activation and development."
                   },
                   {
                    id: "nb-1-4-33", da: "Foster innovation within the organization."
                   },
                   {
                    id: "nb-1-4-34", da: "Build a culture of entrepreneurship and experimentation."
                   },
                   {
                    id: "nb-1-4-35", da: "Embrace sustainability and environmental practices."
                   },
                   {
                    id: "nb-1-4-36", da: "Invest in technology and automation."
                   },
                   {
                    id: "nb-1-4-37", da: "Improve supply chain management."
                   },
                   {
                    id: "nb-1-4-38", da: "Assess the legal and regulatory environment."
                   },
                   {
                    id: "nb-1-4-39", da: "Enhance risk management and contingency planning."
                   },
                   {
                    id: "nb-1-4-40", da: "Develop a crisis management strategy."
                   },
                   {
                    id: "nb-1-4-41", da: "Review your corporate social responsibility efforts."
                   },
                   {
                    id: "nb-1-4-42", da: "Monitor customer lifetime value."
                   },
                   {
                    id: "nb-1-4-43", da: "Track key performance indicators (KPIs)."
                   },
                   {
                    id: "nb-1-4-44", da: "Assess the impact of external economic factors."
                   },
                   {
                    id: "nb-1-4-45", da: "Monitor market trends and shifts."
                   },
                   {
                    id: "nb-1-4-46", da: "Foster a customer-centric approach."
                   },
                   {
                    id: "nb-1-4-47", da: "Seek customer testimonials and referrals."
                   },
                   {
                    id: "nb-1-4-48", da: "Develop a data-driven decision-making process."
                   },
                   {
                    id: "nb-1-4-49", da: "Continuously assess and adapt your business model."
                   },
                ]
              },
              {
                id: 'nb-1-5',
                pm: 'Engage stakeholders by sharing resources, information and processes.',
                title:'Go to Market',
                pmMap: 'Engage stakeholders by sharing resources, information and processes.',
                developmentActions:[
                  {
                    id: "nb-1-5-0", da: "Identify and segment your target audience."
                   },
                   {
                    id: "nb-1-5-1", da: "Create buyer personas to understand customer needs."
                   },
                   {
                    id: "nb-1-5-2", da: "Analyze your competitors' GTM strategies."
                   },
                   {
                    id: "nb-1-5-3", da: "Define your unique selling proposition (USP)."
                   },
                   {
                    id: "nb-1-5-4", da: "Develop a compelling value proposition."
                   },
                   {
                    id: "nb-1-5-5", da: "Establish clear marketing objectives and goals."
                   },
                   {
                    id: "nb-1-5-6", da: "Build a high-quality website that represents your brand."
                   },
                   {
                    id: "nb-1-5-7", da: "Optimize your website for search engines (SEO)."
                   },
                   {
                    id: "nb-1-5-8", da: "Create valuable, relevant content for your audience."
                   },
                   {
                    id: "nb-1-5-9", da: "Start a company blog to share industry insights."
                   },
                   {
                    id: "nb-1-5-10", da: "Implement a content calendar for consistency."
                   },
                   {
                    id: "nb-1-5-11", da: "Leverage social media to reach your audience."
                   },
                   {
                    id: "nb-1-5-12", da: "Develop a social media content strategy."
                   },
                   {
                    id: "nb-1-5-13", da: "Engage with influencers in your industry."
                   },
                   {
                    id: "nb-1-5-14", da: "Use email marketing to nurture leads."
                   },
                   {
                    id: "nb-1-5-15", da: "Automate email marketing campaigns."
                   },
                   {
                    id: "nb-1-5-16", da: "Create engaging video content."
                   },
                   {
                    id: "nb-1-5-17", da: "Explore podcasting to share your expertise."
                   },
                   {
                    id: "nb-1-5-18", da: "Host webinars to educate your audience."
                   },
                   {
                    id: "nb-1-5-19", da: "Invest in online advertising (e.g., Google Ads, Facebook Ads)."
                   },
                   {
                    id: "nb-1-5-20", da: "Build partnerships with complementary businesses."
                   },
                   {
                    id: "nb-1-5-21", da: "Attend industry conferences and trade shows."
                   },
                   {
                    id: "nb-1-5-22", da: "Create an affiliate marketing program."
                   },
                   {
                    id: "nb-1-5-23", da: "Optimize your sales funnel for conversions."
                   },
                   {
                    id: "nb-1-5-24", da: "Develop a referral program for loyal customers."
                   },
                   {
                    id: "nb-1-5-25", da: "Use analytics tools to measure your marketing efforts."
                   },
                   {
                    id: "nb-1-5-26", da: "A\/B test different marketing strategies."
                   },
                   {
                    id: "nb-1-5-27", da: "Optimize landing pages for lead generation."
                   },
                   {
                    id: "nb-1-5-28", da: "Utilize CRM software to manage customer relationships."
                   },
                   {
                    id: "nb-1-5-29", da: "Personalize your marketing messages."
                   },
                   {
                    id: "nb-1-5-30", da: "Segment your email lists for targeted campaigns."
                   },
                   {
                    id: "nb-1-5-31", da: "Optimize your product pricing strategy."
                   },
                   {
                    id: "nb-1-5-32", da: "Offer discounts and promotions to attract customers."
                   },
                   {
                    id: "nb-1-5-33", da: "Monitor customer reviews and respond to feedback."
                   },
                   {
                    id: "nb-1-5-34", da: "Use social proof (e.g., testimonials, case studies)."
                   },
                   {
                    id: "nb-1-5-35", da: "Offer exceptional customer service and support."
                   },
                   {
                    id: "nb-1-5-36", da: "Explore international expansion opportunities."
                   },
                   {
                    id: "nb-1-5-37", da: "Invest in market Stakeholder Activation to identify trends."
                   },
                   {
                    id: "nb-1-5-38", da: "Collaborate with industry associations."
                   },
                   {
                    id: "nb-1-5-39", da: "Provide thought leadership through whitepapers."
                   },
                   {
                    id: "nb-1-5-40", da: "Explore co-marketing opportunities."
                   },
                   {
                    id: "nb-1-5-41", da: "Conduct surveys and gather customer feedback."
                   },
                   {
                    id: "nb-1-5-42", da: "Optimize your supply chain for efficiency."
                   },
                   {
                    id: "nb-1-5-43", da: "Enhance product packaging and branding."
                   },
                   {
                    id: "nb-1-5-44", da: "Consider expanding your product\/service offerings."
                   },
                   {
                    id: "nb-1-5-45", da: "Implement a loyalty program for repeat customers."
                   },
                   {
                    id: "nb-1-5-46", da: "Test new markets and channels for distribution."
                   },
                   {
                    id: "nb-1-5-47", da: "Create educational resources for your customers."
                   },
                   {
                    id: "nb-1-5-48", da: "Develop a crisis communication plan."
                   },
                   {
                    id: "nb-1-5-49", da: "Continuously adapt and refine your GTM strategy based on performance and market changes."
                   },
                ]
              },
              {
                id: 'nb-1-6',
                pm: 'Early moderators and founders demonstrate their competence to support a growing team for scale and replicating leadership.',
                title:'People',
                pmMap: 'Early moderators and founders demonstrate their competence to support a growing team for scale and replicating leadership.',
                developmentActions:[
                  {
                    id: "nb-1-6-0", da: "Attend industry conferences and events to meet like-minded individuals."
                   },
                   {
                    id: "nb-1-6-1", da: "Join local professional associations related to your field."
                   },
                   {
                    id: "nb-1-6-2", da: "Actively participate in online forums and discussion groups."
                   },
                   {
                    id: "nb-1-6-3", da: "Share your knowledge through blog posts and articles."
                   },
                   {
                    id: "nb-1-6-4", da: "Connect with professionals on LinkedIn and engage with their content."
                   },
                   {
                    id: "nb-1-6-5", da: "Seek out mentors in your industry for guidance."
                   },
                   {
                    id: "nb-1-6-6", da: "Offer mentorship to someone seeking your expertise."
                   },
                   {
                    id: "nb-1-6-7", da: "Attend workshops and webinars to learn from experts."
                   },
                   {
                    id: "nb-1-6-8", da: "Organize meetups or networking events in your area."
                   },
                   {
                    id: "nb-1-6-9", da: "Collaborate on projects with professionals from different backgrounds."
                   },
                   {
                    id: "nb-1-6-10", da: "Create a personal website to showcase your work and connect with others."
                   },
                   {
                    id: "nb-1-6-11", da: "Share your career goals with your network for accountability."
                   },
                   {
                    id: "nb-1-6-12", da: "Attend local business networking groups."
                   },
                   {
                    id: "nb-1-6-13", da: "Volunteer for causes you're passionate about."
                   },
                   {
                    id: "nb-1-6-14", da: "Participate in hackathons or coding challenges."
                   },
                   {
                    id: "nb-1-6-15", da: "Join Toastmasters or similar public speaking clubs."
                   },
                   {
                    id: "nb-1-6-16", da: "Be open to cross-cultural networking opportunities."
                   },
                   {
                    id: "nb-1-6-17", da: "Join online mastermind groups to brainstorm ideas."
                   },
                   {
                    id: "nb-1-6-18", da: "Start a book club or reading group with colleagues."
                   },
                   {
                    id: "nb-1-6-19", da: "Attend alumni events for your educational institution."
                   },
                   {
                    id: "nb-1-6-20", da: "Offer your skills and expertise to others in your network."
                   },
                   {
                    id: "nb-1-6-21", da: "Leverage social media to stay in touch with contacts."
                   },
                   {
                    id: "nb-1-6-22", da: "Create and share informative videos or webinars."
                   },
                   {
                    id: "nb-1-6-23", da: "Participate in peer review and feedback processes."
                   },
                   {
                    id: "nb-1-6-24", da: "Actively seek out opportunities to collaborate on Stakeholder Activation."
                   },
                   {
                    id: "nb-1-6-25", da: "Offer to help colleagues with their projects or assignments."
                   },
                   {
                    id: "nb-1-6-26", da: "Attend hackathons or design-thinking workshops."
                   },
                   {
                    id: "nb-1-6-27", da: "Host or attend web conferences and virtual meetups."
                   },
                   {
                    id: "nb-1-6-28", da: "Participate in open-source software development."
                   },
                   {
                    id: "nb-1-6-29", da: "Engage in public speaking or giving presentations."
                   },
                   {
                    id: "nb-1-6-30", da: "Mentor interns or new employees."
                   },
                   {
                    id: "nb-1-6-31", da: "Use networking events to discover potential job openings."
                   },
                   {
                    id: "nb-1-6-32", da: "Foster connections with individuals from diverse backgrounds."
                   },
                   {
                    id: "nb-1-6-33", da: "Attend career fairs and job expos."
                   },
                   {
                    id: "nb-1-6-34", da: "Create and maintain a professional blog or newsletter."
                   },
                   {
                    id: "nb-1-6-35", da: "Join special interest groups or clubs within your field."
                   },
                   {
                    id: "nb-1-6-36", da: "Regularly update your professional profiles."
                   },
                   {
                    id: "nb-1-6-37", da: "Network with individuals at your current workplace."
                   },
                   {
                    id: "nb-1-6-38", da: "Offer to be a guest speaker or panelist at events."
                   },
                   {
                    id: "nb-1-6-39", da: "Use online platforms like GitHub or GitLab to share code."
                   },
                   {
                    id: "nb-1-6-40", da: "Write and publish a Stakeholder Activation paper or whitepaper."
                   },
                   {
                    id: "nb-1-6-41", da: "Collaborate on charity or community projects."
                   },
                   {
                    id: "nb-1-6-42", da: "Connect with experts in adjacent industries."
                   },
                   {
                    id: "nb-1-6-43", da: "Attend local business meet-and-greet events."
                   },
                   {
                    id: "nb-1-6-44", da: "Participate in local government or community boards."
                   },
                   {
                    id: "nb-1-6-45", da: "Host workshops to share your knowledge."
                   },
                   {
                    id: "nb-1-6-46", da: "Engage in online forums for continuous learning."
                   },
                   {
                    id: "nb-1-6-47", da: "Share your personal and professional growth journey."
                   },
                   {
                    id: "nb-1-6-48", da: "Encourage discussions on emerging trends in your field."
                   },
                   {
                    id: "nb-1-6-49", da: "Develop a personal branding strategy to make a lasting impression."
                   },
                ]
              },
              {
                id: 'nb-1-7',
                pm: 'Language of accountability is established and individual productivity metrics are being measured and reviewed regularly.',
                title:'Data Metrics',
                pmMap: 'Language of accountability is established and individual productivity metrics are being measured and reviewed regularly.',
                developmentActions:[
                  {
                    id: "nb-1-7-0", da: "Identify key performance indicators (KPIs) for your network."
                   },
                   {
                    id: "nb-1-7-1", da: "Set clear objectives for engagement and growth."
                   },
                   {
                    id: "nb-1-7-2", da: "Measure the number of new connections made."
                   },
                   {
                    id: "nb-1-7-3", da: "Monitor the growth of your network over time."
                   },
                   {
                    id: "nb-1-7-4", da: "Track engagement levels on various platforms."
                   },
                   {
                    id: "nb-1-7-5", da: "Measure response rates to Tracking Open calls efforts."
                   },
                   {
                    id: "nb-1-7-6", da: "Analyze conversion rates from connections to active participants."
                   },
                   {
                    id: "nb-1-7-7", da: "Evaluate the frequency of interactions within the network."
                   },
                   {
                    id: "nb-1-7-8", da: "Monitor the bounce rate on your engagement content."
                   },
                   {
                    id: "nb-1-7-9", da: "Measure the reach and impressions of your content."
                   },
                   {
                    id: "nb-1-7-10", da: "Assess the click-through rates on shared links."
                   },
                   {
                    id: "nb-1-7-11", da: "Track the engagement on your social media posts."
                   },
                   {
                    id: "nb-1-7-12", da: "Measure the effectiveness of email campaigns."
                   },
                   {
                    id: "nb-1-7-13", da: "Analyze the growth of your email subscriber list."
                   },
                   {
                    id: "nb-1-7-14", da: "Monitor the number of discussions and conversations."
                   },
                   {
                    id: "nb-1-7-15", da: "Track the time spent by members within your network."
                   },
                   {
                    id: "nb-1-7-16", da: "Measure the percentage of engaged vs. passive members."
                   },
                   {
                    id: "nb-1-7-17", da: "Evaluate the quality of interactions (positive vs. negative)."
                   },
                   {
                    id: "nb-1-7-18", da: "Analyze the feedback and comments received."
                   },
                   {
                    id: "nb-1-7-19", da: "Track the number of leads generated."
                   },
                   {
                    id: "nb-1-7-20", da: "Measure the conversion rate of leads into customers."
                   },
                   {
                    id: "nb-1-7-21", da: "Assess the lifetime value of network connections."
                   },
                   {
                    id: "nb-1-7-22", da: "Analyze the churn rate (loss of network members)."
                   },
                   {
                    id: "nb-1-7-23", da: "Measure the referral rates within your network."
                   },
                   {
                    id: "nb-1-7-24", da: "Evaluate the data accuracy and cleanliness."
                   },
                   {
                    id: "nb-1-7-25", da: "Monitor the data retention and archiving policies."
                   },
                   {
                    id: "nb-1-7-26", da: "Measure the effectiveness of data security measures."
                   },
                   {
                    id: "nb-1-7-27", da: "Assess the responsiveness to data breaches."
                   },
                   {
                    id: "nb-1-7-28", da: "Analyze the compliance with data protection laws."
                   },
                   {
                    id: "nb-1-7-29", da: "Track the data collection methods and sources."
                   },
                   {
                    id: "nb-1-7-30", da: "Monitor the accuracy of member profiles."
                   },
                   {
                    id: "nb-1-7-31", da: "Analyze the frequency of data updates."
                   },
                   {
                    id: "nb-1-7-32", da: "Evaluate the data enrichment and augmentation."
                   },
                   {
                    id: "nb-1-7-33", da: "Measure the efficiency of data storage."
                   },
                   {
                    id: "nb-1-7-34", da: "Track the data access permissions."
                   },
                   {
                    id: "nb-1-7-35", da: "Assess the data governance and stewardship."
                   },
                   {
                    id: "nb-1-7-36", da: "Analyze the data analytics and reporting tools."
                   },
                   {
                    id: "nb-1-7-37", da: "Measure the data processing times."
                   },
                   {
                    id: "nb-1-7-38", da: "Evaluate the data visualization and dashboards."
                   },
                   {
                    id: "nb-1-7-39", da: "Monitor the predictive analytics models."
                   },
                   {
                    id: "nb-1-7-40", da: "Track the sentiment analysis of interactions."
                   },
                   {
                    id: "nb-1-7-41", da: "Analyze the natural language processing capabilities."
                   },
                   {
                    id: "nb-1-7-42", da: "Measure the sentiment analysis of interactions."
                   },
                   {
                    id: "nb-1-7-43", da: "Assess the content sentiment over time."
                   },
                   {
                    id: "nb-1-7-44", da: "Evaluate the influence scores of network members."
                   },
                   {
                    id: "nb-1-7-45", da: "Track the engagement metrics by device or platform."
                   },
                   {
                    id: "nb-1-7-46", da: "Measure the impact of engagement campaigns."
                   },
                   {
                    id: "nb-1-7-47", da: "Analyze the demographics of your network."
                   },
                   {
                    id: "nb-1-7-48", da: "Monitor the geographic distribution of members."
                   },
                   {
                    id: "nb-1-7-49", da: "Assess the competitive benchmarking of data metrics."
                   },
                ]
              },
              {
                id: 'nb-1-8',
                pm: 'Committed team roles are established. Strong focus of HR on team retention (<10%). Culture team established to resolve issues bottom Up.',
                title:'Operations',
                pmMap: 'Committed team roles are established. Strong focus of HR on team retention (<10%). Culture team established to resolve issues bottom Up.',
                developmentActions:[
                  {
                    id: "nb-1-8-0", da: "Collaborate with industry peers to share best practices."
                   },
                   {
                    id: "nb-1-8-1", da: "Engage with key suppliers to enhance supply chain efficiency."
                   },
                   {
                    id: "nb-1-8-2", da: "Seek feedback from customers on their experience."
                   },
                   {
                    id: "nb-1-8-3", da: "Establish partnerships with technology providers to streamline processes."
                   },
                   {
                    id: "nb-1-8-4", da: "Participate in industry-specific conferences and events."
                   },
                   {
                    id: "nb-1-8-5", da: "Connect with local business associations for insights."
                   },
                   {
                    id: "nb-1-8-6", da: "Join online forums and communities related to your field."
                   },
                   {
                    id: "nb-1-8-7", da: "Foster relationships with regulatory agencies for compliance."
                   },
                   {
                    id: "nb-1-8-8", da: "Engage with consultants for process optimization."
                   },
                   {
                    id: "nb-1-8-9", da: "Network with universities for talent and Stakeholder Activation opportunities."
                   },
                   {
                    id: "nb-1-8-10", da: "Leverage social media platforms for market insights."
                   },
                   {
                    id: "nb-1-8-11", da: "Attend trade shows to stay updated on trends."
                   },
                   {
                    id: "nb-1-8-12", da: "Build relationships with local government agencies."
                   },
                   {
                    id: "nb-1-8-13", da: "Establish connections with professional associations."
                   },
                   {
                    id: "nb-1-8-14", da: "Collaborate with non-profit organizations for social impact."
                   },
                   {
                    id: "nb-1-8-15", da: "Connect with thought leaders in your industry."
                   },
                   {
                    id: "nb-1-8-16", da: "Create partnerships with complementary businesses."
                   },
                   {
                    id: "nb-1-8-17", da: "Engage with competitors for benchmarking."
                   },
                   {
                    id: "nb-1-8-18", da: "Network with angel investors for growth opportunities."
                   },
                   {
                    id: "nb-1-8-19", da: "Establish relationships with venture capitalists."
                   },
                   {
                    id: "nb-1-8-20", da: "Collaborate with marketing experts for brand awareness."
                   },
                   {
                    id: "nb-1-8-21", da: "Engage with financial advisors for investment strategies."
                   },
                   {
                    id: "nb-1-8-22", da: "Build relationships with peer companies in different regions."
                   },
                   {
                    id: "nb-1-8-23", da: "Connect with business incubators and accelerators."
                   },
                   {
                    id: "nb-1-8-24", da: "Network with industry influencers."
                   },
                   {
                    id: "nb-1-8-25", da: "Foster relationships with media outlets for PR opportunities."
                   },
                   {
                    id: "nb-1-8-26", da: "Collaborate with legal experts for risk management."
                   },
                   {
                    id: "nb-1-8-27", da: "Engage with logistics providers for supply chain optimization."
                   },
                   {
                    id: "nb-1-8-28", da: "Build relationships with HR consultants for talent acquisition."
                   },
                   {
                    id: "nb-1-8-29", da: "Connect with cybersecurity experts for data protection."
                   },
                   {
                    id: "nb-1-8-30", da: "Network with diversity and inclusion organizations."
                   },
                   {
                    id: "nb-1-8-31", da: "Foster relationships with sustainability experts."
                   },
                   {
                    id: "nb-1-8-32", da: "Engage with quality assurance professionals."
                   },
                   {
                    id: "nb-1-8-33", da: "Build relationships with process improvement consultants."
                   },
                   {
                    id: "nb-1-8-34", da: "Connect with project management experts."
                   },
                   {
                    id: "nb-1-8-35", da: "Collaborate with customer service professionals."
                   },
                   {
                    id: "nb-1-8-36", da: "Network with facilities management experts."
                   },
                   {
                    id: "nb-1-8-37", da: "Foster relationships with inventory control specialists."
                   },
                   {
                    id: "nb-1-8-38", da: "Engage with IT professionals for technology enhancements."
                   },
                   {
                    id: "nb-1-8-39", da: "Build relationships with procurement specialists."
                   },
                   {
                    id: "nb-1-8-40", da: "Connect with energy efficiency experts."
                   },
                   {
                    id: "nb-1-8-41", da: "Collaborate with branding and design agencies."
                   },
                   {
                    id: "nb-1-8-42", da: "Engage with public relations experts for communication."
                   },
                   {
                    id: "nb-1-8-43", da: "Foster relationships with financial analysts."
                   },
                   {
                    id: "nb-1-8-44", da: "Network with industry publications for insights."
                   },
                   {
                    id: "nb-1-8-45", da: "Establish partnerships with Stakeholder Activation and development firms."
                   },
                   {
                    id: "nb-1-8-46", da: "Connect with transportation and logistics experts."
                   },
                   {
                    id: "nb-1-8-47", da: "Collaborate with legal compliance professionals."
                   },
                   {
                    id: "nb-1-8-48", da: "Engage with organizational change management experts."
                   },
                   {
                    id: "nb-1-8-49", da: "Build relationships with internal stakeholders and teams for cross-functional collaboration."
                   },
                ]
              },
              {
                id: 'nb-1-9',
                pm: 'There is inbound interest from large strategic partners for potential M&A.',
                title:'Exit Strategy',
                pmMap: 'There is inbound interest from large strategic partners for potential M&A.',
                developmentActions:[
                  {
                    id: "nb-1-9-0", da: "Identify key stakeholders and involve them in exit planning."
                   },
                   {
                    id: "nb-1-9-1", da: "Establish clear and measurable exit goals."
                   },
                   {
                    id: "nb-1-9-2", da: "Communicate the exit strategy to all stakeholders."
                   },
                   {
                    id: "nb-1-9-3", da: "Develop a timeline for the exit strategy."
                   },
                   {
                    id: "nb-1-9-4", da: "Ensure that the project is sustainable after the exit."
                   },
                   {
                    id: "nb-1-9-5", da: "Build local capacity to take over project functions."
                   },
                   {
                    id: "nb-1-9-6", da: "Develop a sustainability plan."
                   },
                   {
                    id: "nb-1-9-7", da: "Identify potential risks and challenges in the exit process."
                   },
                   {
                    id: "nb-1-9-8", da: "Create a contingency plan."
                   },
                   {
                    id: "nb-1-9-9", da: "Monitor and evaluate the progress of the exit strategy."
                   },
                   {
                    id: "nb-1-9-10", da: "Seek feedback from stakeholders on the exit plan."
                   },
                   {
                    id: "nb-1-9-11", da: "Document the exit strategy and share it with all partners."
                   },
                   {
                    id: "nb-1-9-12", da: "Train local staff to manage the project independently."
                   },
                   {
                    id: "nb-1-9-13", da: "Establish partnerships with local organizations."
                   },
                   {
                    id: "nb-1-9-14", da: "Transfer project assets to local partners."
                   },
                   {
                    id: "nb-1-9-15", da: "Develop a transition plan for staff."
                   },
                   {
                    id: "nb-1-9-16", da: "Consider the long-term impact of the project."
                   },
                   {
                    id: "nb-1-9-17", da: "Secure funding for the post-exit phase."
                   },
                   {
                    id: "nb-1-9-18", da: "Ensure that local partners have access to resources."
                   },
                   {
                    id: "nb-1-9-19", da: "Evaluate the effectiveness of capacity-building efforts."
                   },
                   {
                    id: "nb-1-9-20", da: "Communicate with donors about the exit plan."
                   },
                   {
                    id: "nb-1-9-21", da: "Develop a plan for knowledge transfer."
                   },
                   {
                    id: "nb-1-9-22", da: "Conduct exit interviews with project staff."
                   },
                   {
                    id: "nb-1-9-23", da: "Document lessons learned during the project."
                   },
                   {
                    id: "nb-1-9-24", da: "Consider the potential for replication in other areas."
                   },
                   {
                    id: "nb-1-9-25", da: "Address any legal or contractual obligations."
                   },
                   {
                    id: "nb-1-9-26", da: "Assess the economic impact of the exit."
                   },
                   {
                    id: "nb-1-9-27", da: "Provide ongoing technical assistance to local partners."
                   },
                   {
                    id: "nb-1-9-28", da: "Encourage local ownership of project outcomes."
                   },
                   {
                    id: "nb-1-9-29", da: "Establish a monitoring and evaluation system for the post-exit phase."
                   },
                   {
                    id: "nb-1-9-30", da: "Ensure that local partners have access to relevant networks."
                   },
                   {
                    id: "nb-1-9-31", da: "Identify potential funding sources for post-exit activities."
                   },
                   {
                    id: "nb-1-9-32", da: "Develop a strategy for addressing unexpected challenges."
                   },
                   {
                    id: "nb-1-9-33", da: "Create a communication plan for the post-exit phase."
                   },
                   {
                    id: "nb-1-9-34", da: "Evaluate the impact of capacity-building efforts."
                   },
                   {
                    id: "nb-1-9-35", da: "Monitor the performance of local partners."
                   },
                   {
                    id: "nb-1-9-36", da: "Review and update the exit plan as needed."
                   },
                   {
                    id: "nb-1-9-37", da: "Ensure that local partners have access to training and resources."
                   },
                   {
                    id: "nb-1-9-38", da: "Provide mentorship and coaching to local leaders."
                   },
                   {
                    id: "nb-1-9-39", da: "Promote local leadership and decision-making."
                   },
                   {
                    id: "nb-1-9-40", da: "Build the capacity of local partners to raise funds."
                   },
                   {
                    id: "nb-1-9-41", da: "Monitor the project's environmental impact."
                   },
                   {
                    id: "nb-1-9-42", da: "Assess the social and cultural context of the exit."
                   },
                   {
                    id: "nb-1-9-43", da: "Evaluate the project's contribution to local development."
                   },
                   {
                    id: "nb-1-9-44", da: "Share success stories and best practices."
                   },
                   {
                    id: "nb-1-9-45", da: "Develop a plan for knowledge preservation and transfer."
                   },
                   {
                    id: "nb-1-9-46", da: "Evaluate the project's impact on gender equality."
                   },
                   {
                    id: "nb-1-9-47", da: "Identify opportunities for collaboration with other projects."
                   },
                   {
                    id: "nb-1-9-48", da: "Conduct a final evaluation of the project."
                   },
                   {
                    id: "nb-1-9-49", da: "Celebrate the project's achievements and contributions to the community."
                   },
                ]
              }
            ]
          },
          {
            id: 'nb-2',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Succession',
            wdd: '',
            progressMeasures:[
              {
                id: 'nb-2-0',
                pm: 'People in community know what to expect once they onboard to where they need to go.',
                title:'Need',
                pmMap: 'People in community know what to expect once they onboard to where they need to go.',
                developmentActions:[
                  {
                    id: "nb-2-0-0", da: "Establish clear leadership roles and responsibilities."
                   },
                   {
                    id: "nb-2-0-1", da: "Foster a culture of teamwork and collaboration."
                   },
                   {
                    id: "nb-2-0-2", da: "Develop mentorship programs for employees."
                   },
                   {
                    id: "nb-2-0-3", da: "Enhance communication within the organization."
                   },
                   {
                    id: "nb-2-0-4", da: "Invest in leadership training and development."
                   },
                   {
                    id: "nb-2-0-5", da: "Create a knowledge-sharing platform."
                   },
                   {
                    id: "nb-2-0-6", da: "Implement performance evaluation and feedback mechanisms."
                   },
                   {
                    id: "nb-2-0-7", da: "Encourage diversity and inclusion."
                   },
                   {
                    id: "nb-2-0-8", da: "Identify and nurture emerging leaders."
                   },
                   {
                    id: "nb-2-0-9", da: "Establish a code of conduct and ethics."
                   },
                   {
                    id: "nb-2-0-10", da: "Enhance technological infrastructure for networking."
                   },
                   {
                    id: "nb-2-0-11", da: "Implement effective project management practices."
                   },
                   {
                    id: "nb-2-0-12", da: "Promote a work-life balance."
                   },
                   {
                    id: "nb-2-0-13", da: "Build a robust talent pool."
                   },
                   {
                    id: "nb-2-0-14", da: "Foster continuous learning and skill development."
                   },
                   {
                    id: "nb-2-0-15", da: "Encourage cross-functional collaboration."
                   },
                   {
                    id: "nb-2-0-16", da: "Establish clear strategic goals."
                   },
                   {
                    id: "nb-2-0-17", da: "Develop contingency plans for leadership transitions."
                   },
                   {
                    id: "nb-2-0-18", da: "Improve decision-making processes."
                   },
                   {
                    id: "nb-2-0-19", da: "Enhance communication with stakeholders."
                   },
                   {
                    id: "nb-2-0-20", da: "Build a strong social media presence."
                   },
                   {
                    id: "nb-2-0-21", da: "Conduct regular leadership training workshops."
                   },
                   {
                    id: "nb-2-0-22", da: "Create a knowledge-sharing culture."
                   },
                   {
                    id: "nb-2-0-23", da: "Promote employee recognition and rewards."
                   },
                   {
                    id: "nb-2-0-24", da: "Establish a strong employer brand."
                   },
                   {
                    id: "nb-2-0-25", da: "Develop succession plans for key roles."
                   },
                   {
                    id: "nb-2-0-26", da: "Enhance employee engagement and satisfaction."
                   },
                   {
                    id: "nb-2-0-27", da: "Invest in emotional intelligence training."
                   },
                   {
                    id: "nb-2-0-28", da: "Strengthen the organization's core values."
                   },
                   {
                    id: "nb-2-0-29", da: "Encourage innovation and creativity."
                   },
                   {
                    id: "nb-2-0-30", da: "Improve conflict resolution mechanisms."
                   },
                   {
                    id: "nb-2-0-31", da: "Foster a customer-centric mindset."
                   },
                   {
                    id: "nb-2-0-32", da: "Develop an effective feedback culture."
                   },
                   {
                    id: "nb-2-0-33", da: "Promote continuous improvement initiatives."
                   },
                   {
                    id: "nb-2-0-34", da: "Strengthen project management skills."
                   },
                   {
                    id: "nb-2-0-35", da: "Invest in leadership coaching."
                   },
                   {
                    id: "nb-2-0-36", da: "Develop a clear communication strategy."
                   },
                   {
                    id: "nb-2-0-37", da: "Encourage leadership diversity."
                   },
                   {
                    id: "nb-2-0-38", da: "Enhance networking events and opportunities."
                   },
                   {
                    id: "nb-2-0-39", da: "Invest in technology for remote collaboration."
                   },
                   {
                    id: "nb-2-0-40", da: "Develop a corporate social responsibility program."
                   },
                   {
                    id: "nb-2-0-41", da: "Improve time management skills."
                   },
                   {
                    id: "nb-2-0-42", da: "Foster a risk-taking culture."
                   },
                   {
                    id: "nb-2-0-43", da: "Promote cross-training among employees."
                   },
                   {
                    id: "nb-2-0-44", da: "Develop strategic partnerships."
                   },
                   {
                    id: "nb-2-0-45", da: "Enhance financial literacy among leaders."
                   },
                   {
                    id: "nb-2-0-46", da: "Foster a culture of adaptability."
                   },
                   {
                    id: "nb-2-0-47", da: "Improve change management processes."
                   },
                   {
                    id: "nb-2-0-48", da: "Invest in employee health and well-being."
                   },
                   {
                    id: "nb-2-0-49", da: "Establish a clear organizational structure."
                   },
                ]
              },
              {
                id: 'nb-2-1',
                pm: 'Identifying collaborations and coworking opportunities within community partners. Marketable synergies are explored and relationships fostered.',
                title:'Market',
                pmMap: 'Identifying collaborations and coworking opportunities within community partners. Marketable synergies are explored and relationships fostered.',
                developmentActions:[
                  {
                    id: "nb-2-1-0", da: "Conduct market Stakeholder Activation to identify new opportunities."
                   },
                   {
                    id: "nb-2-1-1", da: "Develop a clear market strategy."
                   },
                   {
                    id: "nb-2-1-2", da: "Identify target customer segments."
                   },
                   {
                    id: "nb-2-1-3", da: "Improve product positioning."
                   },
                   {
                    id: "nb-2-1-4", da: "Enhance the product or service offering."
                   },
                   {
                    id: "nb-2-1-5", da: "Expand to new geographic markets."
                   },
                   {
                    id: "nb-2-1-6", da: "Strengthen brand identity."
                   },
                   {
                    id: "nb-2-1-7", da: "Develop a unique selling proposition."
                   },
                   {
                    id: "nb-2-1-8", da: "Create compelling marketing campaigns."
                   },
                   {
                    id: "nb-2-1-9", da: "Implement digital marketing strategies."
                   },
                   {
                    id: "nb-2-1-10", da: "Optimize website and online presence."
                   },
                   {
                    id: "nb-2-1-11", da: "Improve customer engagement."
                   },
                   {
                    id: "nb-2-1-12", da: "Enhance customer service."
                   },
                   {
                    id: "nb-2-1-13", da: "Utilize social media for marketing."
                   },
                   {
                    id: "nb-2-1-14", da: "Foster strategic partnerships."
                   },
                   {
                    id: "nb-2-1-15", da: "Launch new product features."
                   },
                   {
                    id: "nb-2-1-16", da: "Investigate competitor strategies."
                   },
                   {
                    id: "nb-2-1-17", da: "Conduct A\/B testing for marketing materials."
                   },
                   {
                    id: "nb-2-1-18", da: "Leverage data analytics for insights."
                   },
                   {
                    id: "nb-2-1-19", da: "Develop customer loyalty programs."
                   },
                   {
                    id: "nb-2-1-20", da: "Create referral programs."
                   },
                   {
                    id: "nb-2-1-21", da: "Expand distribution channels."
                   },
                   {
                    id: "nb-2-1-22", da: "Improve pricing strategies."
                   },
                   {
                    id: "nb-2-1-23", da: "Increase sales team training."
                   },
                   {
                    id: "nb-2-1-24", da: "Develop lead generation strategies."
                   },
                   {
                    id: "nb-2-1-25", da: "Optimize lead nurturing processes."
                   },
                   {
                    id: "nb-2-1-26", da: "Focus on customer retention."
                   },
                   {
                    id: "nb-2-1-27", da: "Implement content marketing."
                   },
                   {
                    id: "nb-2-1-28", da: "Enhance email marketing campaigns."
                   },
                   {
                    id: "nb-2-1-29", da: "Upgrade CRM systems."
                   },
                   {
                    id: "nb-2-1-30", da: "Launch product bundles or packages."
                   },
                   {
                    id: "nb-2-1-31", da: "Explore cross-selling opportunities."
                   },
                   {
                    id: "nb-2-1-32", da: "Enhance packaging and branding."
                   },
                   {
                    id: "nb-2-1-33", da: "Investigate influencer marketing."
                   },
                   {
                    id: "nb-2-1-34", da: "Attend trade shows and exhibitions."
                   },
                   {
                    id: "nb-2-1-35", da: "Analyze customer feedback."
                   },
                   {
                    id: "nb-2-1-36", da: "Conduct customer satisfaction surveys."
                   },
                   {
                    id: "nb-2-1-37", da: "Streamline the sales process."
                   },
                   {
                    id: "nb-2-1-38", da: "Optimize inventory management."
                   },
                   {
                    id: "nb-2-1-39", da: "Enhance supply chain operations."
                   },
                   {
                    id: "nb-2-1-40", da: "Create promotional events."
                   },
                   {
                    id: "nb-2-1-41", da: "Improve public relations."
                   },
                   {
                    id: "nb-2-1-42", da: "Invest in search engine optimization (SEO)."
                   },
                   {
                    id: "nb-2-1-43", da: "Implement online advertising."
                   },
                   {
                    id: "nb-2-1-44", da: "Focus on sustainability and corporate responsibility."
                   },
                   {
                    id: "nb-2-1-45", da: "Offer product guarantees or warranties."
                   },
                   {
                    id: "nb-2-1-46", da: "Investigate export opportunities."
                   },
                   {
                    id: "nb-2-1-47", da: "Enhance market visibility through PR."
                   },
                   {
                    id: "nb-2-1-48", da: "Explore guerrilla marketing tactics."
                   },
                   {
                    id: "nb-2-1-49", da: "Continuously monitor and adapt to market changes."
                   },
                ]
              },
              {
                id: 'nb-2-2',
                pm: 'Goal setting plan with structured plan to achieve them. As simple as a task management system in place with target dates and milestones.',
                title:'Technology',
                pmMap: 'Goal setting plan with structured plan to achieve them. As simple as a task management system in place with target dates and milestones.',
                developmentActions:[
                  {
                    id: "nb-2-2-0", da: "Implement a modern Customer Relationship Management (CRM) system."
                   },
                   {
                    id: "nb-2-2-1", da: "Enhance data security with advanced encryption technologies."
                   },
                   {
                    id: "nb-2-2-2", da: "Develop a mobile app for better accessibility."
                   },
                   {
                    id: "nb-2-2-3", da: "Invest in advanced cybersecurity measures."
                   },
                   {
                    id: "nb-2-2-4", da: "Upgrade network infrastructure for faster data transfer."
                   },
                   {
                    id: "nb-2-2-5", da: "Implement data analytics for better decision-making."
                   },
                   {
                    id: "nb-2-2-6", da: "Improve website performance and user experience."
                   },
                   {
                    id: "nb-2-2-7", da: "Automate routine tasks with workflow management tools."
                   },
                   {
                    id: "nb-2-2-8", da: "Enhance digital marketing strategies."
                   },
                   {
                    id: "nb-2-2-9", da: "Invest in cloud computing and storage solutions."
                   },
                   {
                    id: "nb-2-2-10", da: "Implement advanced data backup and recovery solutions."
                   },
                   {
                    id: "nb-2-2-11", da: "Upgrade hardware and software for better performance."
                   },
                   {
                    id: "nb-2-2-12", da: "Implement AI for predictive analytics."
                   },
                   {
                    id: "nb-2-2-13", da: "Enhance social media engagement."
                   },
                   {
                    id: "nb-2-2-14", da: "Develop an intranet for better internal communication."
                   },
                   {
                    id: "nb-2-2-15", da: "Streamline document management with digital tools."
                   },
                   {
                    id: "nb-2-2-16", da: "Invest in video conferencing solutions."
                   },
                   {
                    id: "nb-2-2-17", da: "Develop a disaster recovery plan."
                   },
                   {
                    id: "nb-2-2-18", da: "Enhance e-commerce capabilities."
                   },
                   {
                    id: "nb-2-2-19", da: "Implement advanced project management software."
                   },
                   {
                    id: "nb-2-2-20", da: "Improve IT support and helpdesk services."
                   },
                   {
                    id: "nb-2-2-21", da: "Upgrade employee training programs with e-learning solutions."
                   },
                   {
                    id: "nb-2-2-22", da: "Enhance data visualization tools."
                   },
                   {
                    id: "nb-2-2-23", da: "Implement IoT (Internet of Things) for data collection."
                   },
                   {
                    id: "nb-2-2-24", da: "Upgrade website content management systems."
                   },
                   {
                    id: "nb-2-2-25", da: "Enhance data integration between systems."
                   },
                   {
                    id: "nb-2-2-26", da: "Invest in virtual reality (VR) or augmented reality (AR) solutions."
                   },
                   {
                    id: "nb-2-2-27", da: "Develop a comprehensive technology roadmap."
                   },
                   {
                    id: "nb-2-2-28", da: "Implement blockchain for secure transactions."
                   },
                   {
                    id: "nb-2-2-29", da: "Improve website search functionality."
                   },
                   {
                    id: "nb-2-2-30", da: "Enhance email marketing campaigns."
                   },
                   {
                    id: "nb-2-2-31", da: "Invest in data warehousing solutions."
                   },
                   {
                    id: "nb-2-2-32", da: "Develop a robust disaster response system."
                   },
                   {
                    id: "nb-2-2-33", da: "Upgrade mobile device management for security."
                   },
                   {
                    id: "nb-2-2-34", da: "Implement advanced data storage solutions."
                   },
                   {
                    id: "nb-2-2-35", da: "Improve technology vendor management."
                   },
                   {
                    id: "nb-2-2-36", da: "Invest in IT asset management software."
                   },
                   {
                    id: "nb-2-2-37", da: "Develop a tech-friendly workplace culture."
                   },
                   {
                    id: "nb-2-2-38", da: "Upgrade network monitoring and management."
                   },
                   {
                    id: "nb-2-2-39", da: "Implement advanced content delivery networks (CDNs)."
                   },
                   {
                    id: "nb-2-2-40", da: "Enhance data analytics for personalized customer experiences."
                   },
                   {
                    id: "nb-2-2-41", da: "Invest in predictive maintenance technology for equipment."
                   },
                   {
                    id: "nb-2-2-42", da: "Improve network redundancy and failover systems."
                   },
                   {
                    id: "nb-2-2-43", da: "Develop a technology innovation lab for R&D."
                   },
                   {
                    id: "nb-2-2-44", da: "Implement advanced data governance policies."
                   },
                   {
                    id: "nb-2-2-45", da: "Upgrade IT budget allocation and forecasting."
                   },
                   {
                    id: "nb-2-2-46", da: "Enhance cybersecurity awareness training for employees."
                   },
                   {
                    id: "nb-2-2-47", da: "Invest in 5G technology for faster connectivity."
                   },
                   {
                    id: "nb-2-2-48", da: "Implement advanced data archiving solutions."
                   },
                   {
                    id: "nb-2-2-49", da: "Develop a technology audit and assessment process."
                   },
                ]
              },
              {
                id: 'nb-2-3',
                pm: 'A feedback loop is created with mentorship between veterans and newbies.',
                title:'Value',
                pmMap: 'A feedback loop is created with mentorship between veterans and newbies.',
                developmentActions:[
                  {
                    id: "nb-2-3-0", da: "Identify key stakeholders and influencers."
                   },
                   {
                    id: "nb-2-3-1", da: "Develop a clear networking strategy."
                   },
                   {
                    id: "nb-2-3-2", da: "Create a comprehensive contact list."
                   },
                   {
                    id: "nb-2-3-3", da: "Foster strong relationships with mentors."
                   },
                   {
                    id: "nb-2-3-4", da: "Attend industry-related events and conferences."
                   },
                   {
                    id: "nb-2-3-5", da: "Actively engage in professional associations."
                   },
                   {
                    id: "nb-2-3-6", da: "Stay updated on industry trends and news."
                   },
                   {
                    id: "nb-2-3-7", da: "Cultivate a diverse network."
                   },
                   {
                    id: "nb-2-3-8", da: "Develop a personal brand."
                   },
                   {
                    id: "nb-2-3-9", da: "Share knowledge and expertise."
                   },
                   {
                    id: "nb-2-3-10", da: "Seek out opportunities to collaborate."
                   },
                   {
                    id: "nb-2-3-11", da: "Identify potential successors within your organization."
                   },
                   {
                    id: "nb-2-3-12", da: "Offer mentoring and coaching."
                   },
                   {
                    id: "nb-2-3-13", da: "Create a clear succession plan."
                   },
                   {
                    id: "nb-2-3-14", da: "Conduct regular talent assessments."
                   },
                   {
                    id: "nb-2-3-15", da: "Establish a leadership development program."
                   },
                   {
                    id: "nb-2-3-16", da: "Encourage skill development and training."
                   },
                   {
                    id: "nb-2-3-17", da: "Communicate career growth opportunities."
                   },
                   {
                    id: "nb-2-3-18", da: "Foster a culture of innovation."
                   },
                   {
                    id: "nb-2-3-19", da: "Encourage cross-functional training."
                   },
                   {
                    id: "nb-2-3-20", da: "Create a mentorship program."
                   },
                   {
                    id: "nb-2-3-21", da: "Promote diversity and inclusion."
                   },
                   {
                    id: "nb-2-3-22", da: "Implement a knowledge sharing platform."
                   },
                   {
                    id: "nb-2-3-23", da: "Provide feedback and performance evaluations."
                   },
                   {
                    id: "nb-2-3-24", da: "Offer flexible work arrangements."
                   },
                   {
                    id: "nb-2-3-25", da: "Develop a leadership pipeline."
                   },
                   {
                    id: "nb-2-3-26", da: "Encourage ongoing learning and development."
                   },
                   {
                    id: "nb-2-3-27", da: "Build a strong onboarding process."
                   },
                   {
                    id: "nb-2-3-28", da: "Develop a talent acquisition strategy."
                   },
                   {
                    id: "nb-2-3-29", da: "Set clear performance expectations."
                   },
                   {
                    id: "nb-2-3-30", da: "Create a diverse candidate pool."
                   },
                   {
                    id: "nb-2-3-31", da: "Utilize technology for talent management."
                   },
                   {
                    id: "nb-2-3-32", da: "Offer competitive compensation packages."
                   },
                   {
                    id: "nb-2-3-33", da: "Provide opportunities for internal promotions."
                   },
                   {
                    id: "nb-2-3-34", da: "Encourage employee engagement."
                   },
                   {
                    id: "nb-2-3-35", da: "Foster a healthy work-life balance."
                   },
                   {
                    id: "nb-2-3-36", da: "Develop a recognition and rewards program."
                   },
                   {
                    id: "nb-2-3-37", da: "Establish regular performance reviews."
                   },
                   {
                    id: "nb-2-3-38", da: "Invest in leadership training."
                   },
                   {
                    id: "nb-2-3-39", da: "Create clear job descriptions."
                   },
                   {
                    id: "nb-2-3-40", da: "Implement a feedback mechanism."
                   },
                   {
                    id: "nb-2-3-41", da: "Encourage cross-functional teams."
                   },
                   {
                    id: "nb-2-3-42", da: "Offer opportunities for skill-building."
                   },
                   {
                    id: "nb-2-3-43", da: "Promote employee well-being."
                   },
                   {
                    id: "nb-2-3-44", da: "Ensure succession plans align with business goals."
                   },
                   {
                    id: "nb-2-3-45", da: "Conduct regular leadership assessments."
                   },
                   {
                    id: "nb-2-3-46", da: "Identify high-potential employees."
                   },
                   {
                    id: "nb-2-3-47", da: "Address leadership skill gaps."
                   },
                   {
                    id: "nb-2-3-48", da: "Create a culture of continuous improvement."
                   },
                   {
                    id: "nb-2-3-49", da: "Recognize and reward top performers."
                   },
                ]
              },
              {
                id: 'nb-2-4',
                pm: 'Possible franchise model of forming micro-communities in other geographies.',
                title:'Business Model',
                pmMap: 'Possible franchise model of forming micro-communities in other geographies.',
                developmentActions:[
                  {
                    id: "nb-2-4-0", da: "Customer segmentation refinement for better targeting."
                   },
                   {
                    id: "nb-2-4-1", da: "Enhance value proposition for customers."
                   },
                   {
                    id: "nb-2-4-2", da: "Diversify revenue streams."
                   },
                   {
                    id: "nb-2-4-3", da: "Explore new market opportunities."
                   },
                   {
                    id: "nb-2-4-4", da: "Conduct market Stakeholder Activation to identify emerging trends."
                   },
                   {
                    id: "nb-2-4-5", da: "Expand product or service offerings."
                   },
                   {
                    id: "nb-2-4-6", da: "Optimize pricing strategies."
                   },
                   {
                    id: "nb-2-4-7", da: "Improve customer acquisition and retention."
                   },
                   {
                    id: "nb-2-4-8", da: "Streamline sales and marketing processes."
                   },
                   {
                    id: "nb-2-4-9", da: "Strengthen brand identity."
                   },
                   {
                    id: "nb-2-4-10", da: "Develop a unique selling proposition (USP)."
                   },
                   {
                    id: "nb-2-4-11", da: "Optimize the sales funnel."
                   },
                   {
                    id: "nb-2-4-12", da: "Implement data-driven decision-making."
                   },
                   {
                    id: "nb-2-4-13", da: "Enhance customer support and engagement."
                   },
                   {
                    id: "nb-2-4-14", da: "Expand geographic reach."
                   },
                   {
                    id: "nb-2-4-15", da: "Collaborate with strategic partners."
                   },
                   {
                    id: "nb-2-4-16", da: "Integrate sustainability and CSR initiatives."
                   },
                   {
                    id: "nb-2-4-17", da: "Optimize supply chain management."
                   },
                   {
                    id: "nb-2-4-18", da: "Enhance operational efficiency."
                   },
                   {
                    id: "nb-2-4-19", da: "Invest in technology and automation."
                   },
                   {
                    id: "nb-2-4-20", da: "Develop a clear business strategy and vision."
                   },
                   {
                    id: "nb-2-4-21", da: "Evaluate and adjust key performance indicators (KPIs)."
                   },
                   {
                    id: "nb-2-4-22", da: "Analyze customer feedback and reviews."
                   },
                   {
                    id: "nb-2-4-23", da: "Monitor competitor activity."
                   },
                   {
                    id: "nb-2-4-24", da: "Focus on product innovation."
                   },
                   {
                    id: "nb-2-4-25", da: "Address legal and compliance requirements."
                   },
                   {
                    id: "nb-2-4-26", da: "Enhance employee training and development."
                   },
                   {
                    id: "nb-2-4-27", da: "Optimize inventory management."
                   },
                   {
                    id: "nb-2-4-28", da: "Improve the ordering and delivery process."
                   },
                   {
                    id: "nb-2-4-29", da: "Implement lean and agile methodologies."
                   },
                   {
                    id: "nb-2-4-30", da: "Foster a culture of innovation."
                   },
                   {
                    id: "nb-2-4-31", da: "Establish a contingency and risk management plan."
                   },
                   {
                    id: "nb-2-4-32", da: "Enhance the customer onboarding experience."
                   },
                   {
                    id: "nb-2-4-33", da: "Develop a loyalty program."
                   },
                   {
                    id: "nb-2-4-34", da: "Optimize your website and online presence."
                   },
                   {
                    id: "nb-2-4-35", da: "Invest in content marketing."
                   },
                   {
                    id: "nb-2-4-36", da: "Optimize the user experience (UX)."
                   },
                   {
                    id: "nb-2-4-37", da: "Leverage social media for brand promotion."
                   },
                   {
                    id: "nb-2-4-38", da: "Conduct A\/B testing for marketing campaigns."
                   },
                   {
                    id: "nb-2-4-39", da: "Implement cross-selling and upselling strategies."
                   },
                   {
                    id: "nb-2-4-40", da: "Create a referral program."
                   },
                   {
                    id: "nb-2-4-41", da: "Improve financial forecasting and budgeting."
                   },
                   {
                    id: "nb-2-4-42", da: "Evaluate cost-cutting opportunities."
                   },
                   {
                    id: "nb-2-4-43", da: "Expand into e-commerce or online sales."
                   },
                   {
                    id: "nb-2-4-44", da: "Create a mobile app for customer convenience."
                   },
                   {
                    id: "nb-2-4-45", da: "Establish an employee recognition program."
                   },
                   {
                    id: "nb-2-4-46", da: "Enhance workplace diversity and inclusion."
                   },
                   {
                    id: "nb-2-4-47", da: "Evaluate outsourcing opportunities."
                   },
                   {
                    id: "nb-2-4-48", da: "Develop a crisis management plan."
                   },
                   {
                    id: "nb-2-4-49", da: "Continuously monitor and adapt your business model to changing market conditions."
                   },
                ]
              },
              {
                id: 'nb-2-5',
                pm: 'Help collaborators grow their ecosytem and succeed in their regions. Scale horizontally.',
                title:'Go to Market',
                pmMap: 'Help collaborators grow their ecosytem and succeed in their regions. Scale horizontally.',
                developmentActions:[
                  {
                    id: "nb-2-5-0", da: "Define clear, specific goals and objectives."
                   },
                   {
                    id: "nb-2-5-1", da: "Segment your target audience effectively."
                   },
                   {
                    id: "nb-2-5-2", da: "Develop buyer personas for different customer segments."
                   },
                   {
                    id: "nb-2-5-3", da: "Create a unique value proposition."
                   },
                   {
                    id: "nb-2-5-4", da: "Perform a competitive analysis."
                   },
                   {
                    id: "nb-2-5-5", da: "Establish a clear and concise messaging framework."
                   },
                   {
                    id: "nb-2-5-6", da: "Optimize your pricing strategy."
                   },
                   {
                    id: "nb-2-5-7", da: "Develop a compelling brand story."
                   },
                   {
                    id: "nb-2-5-8", da: "Improve product positioning."
                   },
                   {
                    id: "nb-2-5-9", da: "Conduct market Stakeholder Activation to identify trends."
                   },
                   {
                    id: "nb-2-5-10", da: "Enhance your product's features and benefits."
                   },
                   {
                    id: "nb-2-5-11", da: "Evaluate your distribution channels."
                   },
                   {
                    id: "nb-2-5-12", da: "Develop a sales training program."
                   },
                   {
                    id: "nb-2-5-13", da: "Create a sales playbook."
                   },
                   {
                    id: "nb-2-5-14", da: "Implement a content marketing strategy."
                   },
                   {
                    id: "nb-2-5-15", da: "Optimize your website for lead generation."
                   },
                   {
                    id: "nb-2-5-16", da: "Enhance your SEO strategy."
                   },
                   {
                    id: "nb-2-5-17", da: "Develop a social media plan."
                   },
                   {
                    id: "nb-2-5-18", da: "Launch targeted advertising campaigns."
                   },
                   {
                    id: "nb-2-5-19", da: "Improve your email marketing efforts."
                   },
                   {
                    id: "nb-2-5-20", da: "Build a marketing automation system."
                   },
                   {
                    id: "nb-2-5-21", da: "Invest in customer relationship management (CRM) software."
                   },
                   {
                    id: "nb-2-5-22", da: "Implement lead scoring."
                   },
                   {
                    id: "nb-2-5-23", da: "Enhance lead nurturing processes."
                   },
                   {
                    id: "nb-2-5-24", da: "Establish a referral program."
                   },
                   {
                    id: "nb-2-5-25", da: "Optimize your onboarding process."
                   },
                   {
                    id: "nb-2-5-26", da: "Create upsell and cross-sell strategies."
                   },
                   {
                    id: "nb-2-5-27", da: "Improve customer retention strategies."
                   },
                   {
                    id: "nb-2-5-28", da: "Develop customer support and success programs."
                   },
                   {
                    id: "nb-2-5-29", da: "Leverage user-generated content and reviews."
                   },
                   {
                    id: "nb-2-5-30", da: "Invest in analytics tools for data-driven decisions."
                   },
                   {
                    id: "nb-2-5-31", da: "Implement A\/B testing for campaigns."
                   },
                   {
                    id: "nb-2-5-32", da: "Expand your market reach regionally or globally."
                   },
                   {
                    id: "nb-2-5-33", da: "Seek partnerships and alliances."
                   },
                   {
                    id: "nb-2-5-34", da: "Identify new market opportunities."
                   },
                   {
                    id: "nb-2-5-35", da: "Evaluate regulatory compliance."
                   },
                   {
                    id: "nb-2-5-36", da: "Enhance supply chain management."
                   },
                   {
                    id: "nb-2-5-37", da: "Invest in product quality and reliability."
                   },
                   {
                    id: "nb-2-5-38", da: "Implement sustainability initiatives."
                   },
                   {
                    id: "nb-2-5-39", da: "Develop an innovation pipeline."
                   },
                   {
                    id: "nb-2-5-40", da: "Optimize inventory management."
                   },
                   {
                    id: "nb-2-5-41", da: "Streamline order fulfillment processes."
                   },
                   {
                    id: "nb-2-5-42", da: "Enhance your customer service response time."
                   },
                   {
                    id: "nb-2-5-43", da: "Invest in employee training and development."
                   },
                   {
                    id: "nb-2-5-44", da: "Improve internal communication."
                   },
                   {
                    id: "nb-2-5-45", da: "Develop key performance indicators (KPIs) for success measurement."
                   },
                   {
                    id: "nb-2-5-46", da: "Monitor and track customer feedback."
                   },
                   {
                    id: "nb-2-5-47", da: "Continuously review and update your GTM strategy."
                   },
                   {
                    id: "nb-2-5-48", da: "Seek feedback from sales and marketing teams."
                   },
                   {
                    id: "nb-2-5-49", da: "Foster a culture of continuous improvement and innovation."
                   },
                ]
              },
              {
                id: 'nb-2-6',
                pm: 'Founders and team leads are still involved in day-to-day operations from time to time and support others with knowledge.',
                title:'People',
                pmMap: 'Founders and team leads are still involved in day-to-day operations from time to time and support others with knowledge.',
                developmentActions:[
                  {
                    id: "nb-2-6-0", da: "Provide mentorship opportunities."
                   },
                   {
                    id: "nb-2-6-1", da: "Encourage skill-sharing within the network."
                   },
                   {
                    id: "nb-2-6-2", da: "Promote continuous learning."
                   },
                   {
                    id: "nb-2-6-3", da: "Offer leadership training."
                   },
                   {
                    id: "nb-2-6-4", da: "Foster emotional intelligence."
                   },
                   {
                    id: "nb-2-6-5", da: "Develop effective communication skills."
                   },
                   {
                    id: "nb-2-6-6", da: "Cultivate adaptability."
                   },
                   {
                    id: "nb-2-6-7", da: "Enhance problem-solving abilities."
                   },
                   {
                    id: "nb-2-6-8", da: "Provide opportunities for self-assessment."
                   },
                   {
                    id: "nb-2-6-9", da: "Encourage time management skills."
                   },
                   {
                    id: "nb-2-6-10", da: "Promote cross-functional training."
                   },
                   {
                    id: "nb-2-6-11", da: "Develop negotiation skills."
                   },
                   {
                    id: "nb-2-6-12", da: "Offer conflict resolution training."
                   },
                   {
                    id: "nb-2-6-13", da: "Cultivate teamwork and collaboration."
                   },
                   {
                    id: "nb-2-6-14", da: "Enhance public speaking skills."
                   },
                   {
                    id: "nb-2-6-15", da: "Develop project management capabilities."
                   },
                   {
                    id: "nb-2-6-16", da: "Foster decision-making skills."
                   },
                   {
                    id: "nb-2-6-17", da: "Provide stress management training."
                   },
                   {
                    id: "nb-2-6-18", da: "Promote networking and relationship-building."
                   },
                   {
                    id: "nb-2-6-19", da: "Encourage diversity and inclusion awareness."
                   },
                   {
                    id: "nb-2-6-20", da: "Cultivate a global mindset."
                   },
                   {
                    id: "nb-2-6-21", da: "Enhance cultural competency."
                   },
                   {
                    id: "nb-2-6-22", da: "Develop strategic thinking."
                   },
                   {
                    id: "nb-2-6-23", da: "Offer creativity and innovation training."
                   },
                   {
                    id: "nb-2-6-24", da: "Promote critical thinking skills."
                   },
                   {
                    id: "nb-2-6-25", da: "Cultivate risk management abilities."
                   },
                   {
                    id: "nb-2-6-26", da: "Enhance financial literacy."
                   },
                   {
                    id: "nb-2-6-27", da: "Develop entrepreneurship skills."
                   },
                   {
                    id: "nb-2-6-28", da: "Provide time management training."
                   },
                   {
                    id: "nb-2-6-29", da: "Encourage delegation skills."
                   },
                   {
                    id: "nb-2-6-30", da: "Promote conflict resolution abilities."
                   },
                   {
                    id: "nb-2-6-31", da: "Foster empathy and active listening."
                   },
                   {
                    id: "nb-2-6-32", da: "Develop a growth mindset."
                   },
                   {
                    id: "nb-2-6-33", da: "Enhance customer service skills."
                   },
                   {
                    id: "nb-2-6-34", da: "Promote goal setting and achievement."
                   },
                   {
                    id: "nb-2-6-35", da: "Cultivate a strong work ethic."
                   },
                   {
                    id: "nb-2-6-36", da: "Develop resilience and perseverance."
                   },
                   {
                    id: "nb-2-6-37", da: "Foster a sense of responsibility."
                   },
                   {
                    id: "nb-2-6-38", da: "Enhance ethics and integrity."
                   },
                   {
                    id: "nb-2-6-39", da: "Promote adaptability and flexibility."
                   },
                   {
                    id: "nb-2-6-40", da: "Cultivate organizational skills."
                   },
                   {
                    id: "nb-2-6-41", da: "Develop a customer-centric approach."
                   },
                   {
                    id: "nb-2-6-42", da: "Foster a sense of social responsibility."
                   },
                   {
                    id: "nb-2-6-43", da: "Enhance digital literacy."
                   },
                   {
                    id: "nb-2-6-44", da: "Promote self-confidence."
                   },
                   {
                    id: "nb-2-6-45", da: "Cultivate a sense of purpose."
                   },
                   {
                    id: "nb-2-6-46", da: "Develop networking etiquette."
                   },
                   {
                    id: "nb-2-6-47", da: "Foster leadership by example."
                   },
                   {
                    id: "nb-2-6-48", da: "Encourage professional development workshops."
                   },
                   {
                    id: "nb-2-6-49", da: "Provide opportunities for feedback and reflection."
                   },
                ]
              },
              {
                id: 'nb-2-7',
                pm: 'Financial models are in place. Community surpasses >$1m in ARR while growing.',
                title:'Data Metrics',
                pmMap: 'Financial models are in place. Community surpasses >$1m in ARR while growing.',
                developmentActions:[
                  {
                    id: "nb-2-7-0", da: "Define clear success metrics for your network-building efforts."
                   },
                   {
                    id: "nb-2-7-1", da: "Measure the growth of your network over time."
                   },
                   {
                    id: "nb-2-7-2", da: "Track the engagement of network members."
                   },
                   {
                    id: "nb-2-7-3", da: "Monitor the diversity of your network."
                   },
                   {
                    id: "nb-2-7-4", da: "Analyze the geographical distribution of your network."
                   },
                   {
                    id: "nb-2-7-5", da: "Measure the age distribution of your network members."
                   },
                   {
                    id: "nb-2-7-6", da: "Track the industry sectors represented in your network."
                   },
                   {
                    id: "nb-2-7-7", da: "Analyze the job roles and functions of network members."
                   },
                   {
                    id: "nb-2-7-8", da: "Measure the retention rate of network members."
                   },
                   {
                    id: "nb-2-7-9", da: "Track the acquisition rate of new network members."
                   },
                   {
                    id: "nb-2-7-10", da: "Monitor the frequency of communication within the network."
                   },
                   {
                    id: "nb-2-7-11", da: "Measure the response rate to network communications."
                   },
                   {
                    id: "nb-2-7-12", da: "Analyze the referral rate within the network."
                   },
                   {
                    id: "nb-2-7-13", da: "Track the conversion rate of network leads."
                   },
                   {
                    id: "nb-2-7-14", da: "Monitor the effectiveness of succession planning efforts."
                   },
                   {
                    id: "nb-2-7-15", da: "Measure the readiness of potential successors."
                   },
                   {
                    id: "nb-2-7-16", da: "Track the development of leadership skills in successors."
                   },
                   {
                    id: "nb-2-7-17", da: "Analyze the alignment of successors with organizational goals."
                   },
                   {
                    id: "nb-2-7-18", da: "Monitor the satisfaction of network members."
                   },
                   {
                    id: "nb-2-7-19", da: "Measure the overall network performance."
                   },
                   {
                    id: "nb-2-7-20", da: "Analyze the impact of network building on revenue."
                   },
                   {
                    id: "nb-2-7-21", da: "Track the cost-effectiveness of network-building activities."
                   },
                   {
                    id: "nb-2-7-22", da: "Measure the return on investment (ROI) for network development."
                   },
                   {
                    id: "nb-2-7-23", da: "Analyze the retention rate of successors."
                   },
                   {
                    id: "nb-2-7-24", da: "Monitor the readiness of successors for specific roles."
                   },
                   {
                    id: "nb-2-7-25", da: "Track the promotion rate of successors."
                   },
                   {
                    id: "nb-2-7-26", da: "Measure the success rate of succession planning."
                   },
                   {
                    id: "nb-2-7-27", da: "Analyze the diversity of successors in terms of backgrounds and perspectives."
                   },
                   {
                    id: "nb-2-7-28", da: "Monitor the representation of successors in decision-making roles."
                   },
                   {
                    id: "nb-2-7-29", da: "Track the alignment of successor values with the organization's culture."
                   },
                   {
                    id: "nb-2-7-30", da: "Measure the effectiveness of mentoring and coaching programs."
                   },
                   {
                    id: "nb-2-7-31", da: "Analyze the impact of data-driven decision-making on network performance."
                   },
                   {
                    id: "nb-2-7-32", da: "Track the implementation of data-driven strategies."
                   },
                   {
                    id: "nb-2-7-33", da: "Monitor the usage of data analytics tools within the network."
                   },
                   {
                    id: "nb-2-7-34", da: "Measure the quality of data collected and maintained."
                   },
                   {
                    id: "nb-2-7-35", da: "Analyze data accuracy and integrity."
                   },
                   {
                    id: "nb-2-7-36", da: "Track data security and privacy compliance."
                   },
                   {
                    id: "nb-2-7-37", da: "Monitor the accessibility of data to authorized personnel."
                   },
                   {
                    id: "nb-2-7-38", da: "Measure the timeliness of data reporting and analysis."
                   },
                   {
                    id: "nb-2-7-39", da: "Analyze the availability of historical data for trend analysis."
                   },
                   {
                    id: "nb-2-7-40", da: "Track the use of data visualization tools for better insights."
                   },
                   {
                    id: "nb-2-7-41", da: "Monitor the integration of data sources for comprehensive analysis."
                   },
                   {
                    id: "nb-2-7-42", da: "Measure the effectiveness of data training programs."
                   },
                   {
                    id: "nb-2-7-43", da: "Analyze the impact of data metrics on decision-making."
                   },
                   {
                    id: "nb-2-7-44", da: "Track the communication of data-driven insights to network members."
                   },
                   {
                    id: "nb-2-7-45", da: "Monitor the responsiveness to data-driven recommendations."
                   },
                   {
                    id: "nb-2-7-46", da: "Measure the continuous improvement of data metrics."
                   },
                   {
                    id: "nb-2-7-47", da: "Analyze the standardization of data collection processes."
                   },
                   {
                    id: "nb-2-7-48", da: "Track the establishment of key performance indicators (KPIs)."
                   },
                   {
                    id: "nb-2-7-49", da: "Monitor the alignment of data metrics with the organization's strategic objectives."
                   },
                ]
              },
              {
                id: 'nb-2-8',
                pm: 'Career plan and salary ranges for different roles are established. Growth plans are in place.',
                title:'Operations',
                pmMap: 'Career plan and salary ranges for different roles are established. Growth plans are in place.',
                developmentActions:[
                  {
                    id: "nb-2-8-0", da: "Establish clear communication channels within the network."
                   },
                   {
                    id: "nb-2-8-1", da: "Define roles and responsibilities for network members."
                   },
                   {
                    id: "nb-2-8-2", da: "Regularly review and update network guidelines and policies."
                   },
                   {
                    id: "nb-2-8-3", da: "Develop a structured onboarding process for new members."
                   },
                   {
                    id: "nb-2-8-4", da: "Implement a mentoring program for newcomers."
                   },
                   {
                    id: "nb-2-8-5", da: "Foster a culture of inclusivity and diversity within the network."
                   },
                   {
                    id: "nb-2-8-6", da: "Identify and eliminate operational bottlenecks."
                   },
                   {
                    id: "nb-2-8-7", da: "Streamline decision-making processes."
                   },
                   {
                    id: "nb-2-8-8", da: "Create a knowledge-sharing platform for network members."
                   },
                   {
                    id: "nb-2-8-9", da: "Evaluate and improve the effectiveness of network meetings."
                   },
                   {
                    id: "nb-2-8-10", da: "Implement feedback mechanisms to gather input from network members."
                   },
                   {
                    id: "nb-2-8-11", da: "Conduct regular training sessions for skill development."
                   },
                   {
                    id: "nb-2-8-12", da: "Develop a succession plan for key network roles."
                   },
                   {
                    id: "nb-2-8-13", da: "Identify potential successors and provide them with mentorship."
                   },
                   {
                    id: "nb-2-8-14", da: "Encourage cross-functional collaboration among network members."
                   },
                   {
                    id: "nb-2-8-15", da: "Set up performance metrics to measure network success."
                   },
                   {
                    id: "nb-2-8-16", da: "Invest in technology to enhance network operations."
                   },
                   {
                    id: "nb-2-8-17", da: "Develop a resource allocation strategy."
                   },
                   {
                    id: "nb-2-8-18", da: "Create a crisis management plan for network emergencies."
                   },
                   {
                    id: "nb-2-8-19", da: "Establish partnerships with complementary networks."
                   },
                   {
                    id: "nb-2-8-20", da: "Monitor and address conflicts or disputes within the network."
                   },
                   {
                    id: "nb-2-8-21", da: "Conduct regular member surveys to assess satisfaction."
                   },
                   {
                    id: "nb-2-8-22", da: "Encourage innovation and continuous improvement."
                   },
                   {
                    id: "nb-2-8-23", da: "Develop and maintain a database of network contacts."
                   },
                   {
                    id: "nb-2-8-24", da: "Provide support for leadership development."
                   },
                   {
                    id: "nb-2-8-25", da: "Foster a sense of shared purpose and values."
                   },
                   {
                    id: "nb-2-8-26", da: "Review financial operations to ensure sustainability."
                   },
                   {
                    id: "nb-2-8-27", da: "Create a feedback loop for monitoring network performance."
                   },
                   {
                    id: "nb-2-8-28", da: "Establish clear goals and objectives for the network."
                   },
                   {
                    id: "nb-2-8-29", da: "Implement a knowledge management system."
                   },
                   {
                    id: "nb-2-8-30", da: "Develop a strong brand and online presence for the network."
                   },
                   {
                    id: "nb-2-8-31", da: "Encourage ethical and responsible behavior within the network."
                   },
                   {
                    id: "nb-2-8-32", da: "Establish a clear code of conduct."
                   },
                   {
                    id: "nb-2-8-33", da: "Address issues related to data security and privacy."
                   },
                   {
                    id: "nb-2-8-34", da: "Provide professional development opportunities."
                   },
                   {
                    id: "nb-2-8-35", da: "Enhance the use of data analytics for decision-making."
                   },
                   {
                    id: "nb-2-8-36", da: "Develop a contingency plan for leadership changes."
                   },
                   {
                    id: "nb-2-8-37", da: "Provide tools and resources for networking and collaboration."
                   },
                   {
                    id: "nb-2-8-38", da: "Monitor and improve network health and engagement."
                   },
                   {
                    id: "nb-2-8-39", da: "Foster a sense of ownership and responsibility among members."
                   },
                   {
                    id: "nb-2-8-40", da: "Encourage partnerships with external organizations."
                   },
                   {
                    id: "nb-2-8-41", da: "Implement an evaluation and impact assessment process."
                   },
                   {
                    id: "nb-2-8-42", da: "Identify opportunities for cost reduction and efficiency."
                   },
                   {
                    id: "nb-2-8-43", da: "Develop a strategy for expanding the network's reach."
                   },
                   {
                    id: "nb-2-8-44", da: "Foster a culture of social responsibility and sustainability."
                   },
                   {
                    id: "nb-2-8-45", da: "Establish a crisis communication plan."
                   },
                   {
                    id: "nb-2-8-46", da: "Review and improve the network's legal and governance structures."
                   },
                   {
                    id: "nb-2-8-47", da: "Encourage members to participate in community Tracking Open calls."
                   },
                   {
                    id: "nb-2-8-48", da: "Develop a process for recognizing and rewarding contributions."
                   },
                   {
                    id: "nb-2-8-49", da: "Regularly review and update the network's strategic plan."
                   },
                ]
              },
              {
                id: 'nb-2-9',
                pm: 'Burn multiple should be lower than 3-4x. ',
                title:'Exit Strategy',
                pmMap: 'Burn multiple should be lower than 3-4x. ',
                developmentActions:[
                  {
                    id: "nb-2-9-0", da: "Identify key team members who can step into leadership roles."
                   },
                   {
                    id: "nb-2-9-1", da: "Develop clear criteria for selecting successors."
                   },
                   {
                    id: "nb-2-9-2", da: "Provide ongoing training and development opportunities for potential successors."
                   },
                   {
                    id: "nb-2-9-3", da: "Create a mentorship program for grooming future leaders."
                   },
                   {
                    id: "nb-2-9-4", da: "Document critical processes and procedures."
                   },
                   {
                    id: "nb-2-9-5", da: "Implement a knowledge-sharing platform for seamless information transfer."
                   },
                   {
                    id: "nb-2-9-6", da: "Establish a leadership pipeline."
                   },
                   {
                    id: "nb-2-9-7", da: "Develop a robust feedback system."
                   },
                   {
                    id: "nb-2-9-8", da: "Encourage cross-training among team members."
                   },
                   {
                    id: "nb-2-9-9", da: "Conduct regular leadership assessments."
                   },
                   {
                    id: "nb-2-9-10", da: "Identify external talent for potential recruitment."
                   },
                   {
                    id: "nb-2-9-11", da: "Create a contingency plan for sudden departures."
                   },
                   {
                    id: "nb-2-9-12", da: "Build redundancy in critical roles."
                   },
                   {
                    id: "nb-2-9-13", da: "Evaluate and update the exit strategy regularly."
                   },
                   {
                    id: "nb-2-9-14", da: "Establish a communication plan for announcing leadership changes."
                   },
                   {
                    id: "nb-2-9-15", da: "Consider phased retirements for senior leaders."
                   },
                   {
                    id: "nb-2-9-16", da: "Define the role of an interim leader."
                   },
                   {
                    id: "nb-2-9-17", da: "Ensure that potential successors have exposure to various departments."
                   },
                   {
                    id: "nb-2-9-18", da: "Encourage innovation and adaptability."
                   },
                   {
                    id: "nb-2-9-19", da: "Develop leadership competencies and skills."
                   },
                   {
                    id: "nb-2-9-20", da: "Align succession planning with long-term strategic goals."
                   },
                   {
                    id: "nb-2-9-21", da: "Provide opportunities for aspiring leaders to take on stretch assignments."
                   },
                   {
                    id: "nb-2-9-22", da: "Encourage diversity in leadership."
                   },
                   {
                    id: "nb-2-9-23", da: "Establish a clear timeline for leadership transitions."
                   },
                   {
                    id: "nb-2-9-24", da: "Develop clear job descriptions and expectations for leadership roles."
                   },
                   {
                    id: "nb-2-9-25", da: "Provide executive coaching and leadership development programs."
                   },
                   {
                    id: "nb-2-9-26", da: "Foster a culture of continuous learning and improvement."
                   },
                   {
                    id: "nb-2-9-27", da: "Conduct regular performance reviews and feedback sessions."
                   },
                   {
                    id: "nb-2-9-28", da: "Promote a work-life balance for leaders."
                   },
                   {
                    id: "nb-2-9-29", da: "Encourage leaders to maintain a healthy work environment."
                   },
                   {
                    id: "nb-2-9-30", da: "Consider the impact of leadership changes on the organization's stakeholders."
                   },
                   {
                    id: "nb-2-9-31", da: "Document the responsibilities and authority of leaders."
                   },
                   {
                    id: "nb-2-9-32", da: "Implement a leadership development budget."
                   },
                   {
                    id: "nb-2-9-33", da: "Create a knowledge repository for leadership resources."
                   },
                   {
                    id: "nb-2-9-34", da: "Address potential legal and contractual considerations in the exit plan."
                   },
                   {
                    id: "nb-2-9-35", da: "Ensure that the exit strategy aligns with the organization's values."
                   },
                   {
                    id: "nb-2-9-36", da: "Develop a communication plan for addressing employee concerns."
                   },
                   {
                    id: "nb-2-9-37", da: "Define the roles and responsibilities of the board during leadership changes."
                   },
                   {
                    id: "nb-2-9-38", da: "Plan for the transfer of institutional knowledge."
                   },
                   {
                    id: "nb-2-9-39", da: "Consider the financial implications of leadership transitions."
                   },
                   {
                    id: "nb-2-9-40", da: "Review the organization's insurance policies related to key leadership positions."
                   },
                   {
                    id: "nb-2-9-41", da: "Conduct exit interviews for departing leaders."
                   },
                   {
                    id: "nb-2-9-42", da: "Identify potential successors from different departments."
                   },
                   {
                    id: "nb-2-9-43", da: "Encourage leadership teams to collaborate and share insights."
                   },
                   {
                    id: "nb-2-9-44", da: "Implement a regular review of leadership development efforts."
                   },
                   {
                    id: "nb-2-9-45", da: "Consider the impact of external factors on succession planning."
                   },
                   {
                    id: "nb-2-9-46", da: "Document the organization's mission and vision for continuity."
                   },
                   {
                    id: "nb-2-9-47", da: "Define the decision-making process during leadership transitions."
                   },
                   {
                    id: "nb-2-9-48", da: "Ensure that the organization has a crisis management plan in place."
                   },
                   {
                    id: "nb-2-9-49", da: "Create a process for involving key stakeholders, such as clients, in leadership changes."
                   },
                ]
              }
            ]
          }
        ]
      },
      'eg':{
        characteristic: 'Ecosystem Growth',
        wdd: "Take your next step towards leading the development of your region by positioning as an ecosystem development expert. Multiply your impact by establishing ecosystem development processes and enable more stakeholders to contribute to ecosystem growth.",
        icon: require('@/assets/Iconography/Characteristics/15_Skilled Communicator.svg'),
        competencies:[
          {
            id: 'eg-0',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Stakeholder Activation',
            wdd: '',
            progressMeasures:[
              {
                id: 'eg-0-0',
                pm: 'Needs of multiple segments are serviced within the community. Stakeholder point of view is frequently requested (e.g. for industry related conferences) and thought leadership is established.',
                title:'Need',
                pmMap: 'Needs of multiple segments are serviced within the community. Stakeholder point of view is frequently requested (e.g. for industry related conferences) and thought leadership is established.',
                developmentActions:[
                  {
                    id: "eg-0-0-0", da: "Establish a clear and compelling vision for the ecosystem's growth."
                   },
                   {
                    id: "eg-0-0-1", da: "Identify and prioritize key stakeholders."
                   },
                   {
                    id: "eg-0-0-2", da: "Develop a comprehensive stakeholder engagement strategy."
                   },
                   {
                    id: "eg-0-0-3", da: "Foster collaboration between stakeholders."
                   },
                   {
                    id: "eg-0-0-4", da: "Create an ecosystem advisory board."
                   },
                   {
                    id: "eg-0-0-5", da: "Conduct regular stakeholder surveys for feedback."
                   },
                   {
                    id: "eg-0-0-6", da: "Promote networking events and meetups."
                   },
                   {
                    id: "eg-0-0-7", da: "Enhance the onboarding experience for new stakeholders."
                   },
                   {
                    id: "eg-0-0-8", da: "Offer mentorship and support programs."
                   },
                   {
                    id: "eg-0-0-9", da: "Develop educational resources for stakeholders."
                   },
                   {
                    id: "eg-0-0-10", da: "Improve communication channels and tools."
                   },
                   {
                    id: "eg-0-0-11", da: "Implement a user-friendly online platform for stakeholders."
                   },
                   {
                    id: "eg-0-0-12", da: "Foster partnerships with relevant organizations."
                   },
                   {
                    id: "eg-0-0-13", da: "Support diversity and inclusion initiatives."
                   },
                   {
                    id: "eg-0-0-14", da: "Invest in marketing and Tracking Open calls efforts."
                   },
                   {
                    id: "eg-0-0-15", da: "Offer incentives or rewards for stakeholder engagement."
                   },
                   {
                    id: "eg-0-0-16", da: "Provide access to funding opportunities."
                   },
                   {
                    id: "eg-0-0-17", da: "Conduct regular ecosystem audits."
                   },
                   {
                    id: "eg-0-0-18", da: "Identify growth bottlenecks and address them."
                   },
                   {
                    id: "eg-0-0-19", da: "Encourage knowledge sharing and best practices."
                   },
                   {
                    id: "eg-0-0-20", da: "Create a resource directory for stakeholders."
                   },
                   {
                    id: "eg-0-0-21", da: "Develop a roadmap for ecosystem development."
                   },
                   {
                    id: "eg-0-0-22", da: "Collaborate with educational institutions."
                   },
                   {
                    id: "eg-0-0-23", da: "Organize hackathons and innovation challenges."
                   },
                   {
                    id: "eg-0-0-24", da: "Establish a clear governance structure."
                   },
                   {
                    id: "eg-0-0-25", da: "Strengthen ties with local and national governments."
                   },
                   {
                    id: "eg-0-0-26", da: "Leverage social media and online communities."
                   },
                   {
                    id: "eg-0-0-27", da: "Highlight success stories and case studies."
                   },
                   {
                    id: "eg-0-0-28", da: "Seek external funding and grants."
                   },
                   {
                    id: "eg-0-0-29", da: "Develop a comprehensive data collection and analysis system."
                   },
                   {
                    id: "eg-0-0-30", da: "Promote ecosystem branding and identity."
                   },
                   {
                    id: "eg-0-0-31", da: "Offer regular training and workshops."
                   },
                   {
                    id: "eg-0-0-32", da: "Foster a culture of innovation."
                   },
                   {
                    id: "eg-0-0-33", da: "Engage in advocacy and policy initiatives."
                   },
                   {
                    id: "eg-0-0-34", da: "Establish a mentorship program."
                   },
                   {
                    id: "eg-0-0-35", da: "Implement sustainability and environmental initiatives."
                   },
                   {
                    id: "eg-0-0-36", da: "Support talent acquisition and retention."
                   },
                   {
                    id: "eg-0-0-37", da: "Create a certification program."
                   },
                   {
                    id: "eg-0-0-38", da: "Offer public recognition for outstanding contributions."
                   },
                   {
                    id: "eg-0-0-39", da: "Streamline access to research and development resources."
                   },
                   {
                    id: "eg-0-0-40", da: "Promote cross-industry collaboration."
                   },
                   {
                    id: "eg-0-0-41", da: "Encourage corporate involvement and sponsorship."
                   },
                   {
                    id: "eg-0-0-42", da: "Conduct regular ecosystem performance evaluations."
                   },
                   {
                    id: "eg-0-0-43", da: "Develop a stakeholder reward program."
                   },
                   {
                    id: "eg-0-0-44", da: "Encourage international collaboration and expansion."
                   },
                   {
                    id: "eg-0-0-45", da: "Improve access to legal and intellectual property services."
                   },
                   {
                    id: "eg-0-0-46", da: "Implement a data sharing and collaboration platform."
                   },
                   {
                    id: "eg-0-0-47", da: "Organize regular town hall meetings."
                   },
                   {
                    id: "eg-0-0-48", da: "Enhance cybersecurity measures."
                   },
                   {
                    id: "eg-0-0-49", da: "Establish a crisis management plan."
                   },
                ]
              },
              {
                id: 'eg-0-1',
                pm: 'Collaborations turn into working agreements.',
                title:'Market',
                pmMap: 'Collaborations turn into working agreements.',
                developmentActions:[
                  {
                    id: "eg-0-1-0", da: "Conduct market research to identify emerging trends."
                   },
                   {
                    id: "eg-0-1-1", da: "Analyze competitors' strategies and market positioning."
                   },
                   {
                    id: "eg-0-1-2", da: "Enhance your product or service's unique selling proposition."
                   },
                   {
                    id: "eg-0-1-3", da: "Expand into new geographical markets."
                   },
                   {
                    id: "eg-0-1-4", da: "Create strategic partnerships and alliances."
                   },
                   {
                    id: "eg-0-1-5", da: "Develop a comprehensive marketing plan."
                   },
                   {
                    id: "eg-0-1-6", da: "Optimize your website for search engines (SEO)."
                   },
                   {
                    id: "eg-0-1-7", da: "Launch targeted online advertising campaigns."
                   },
                   {
                    id: "eg-0-1-8", da: "Invest in content marketing and blogging."
                   },
                   {
                    id: "eg-0-1-9", da: "Implement a social media marketing strategy."
                   },
                   {
                    id: "eg-0-1-10", da: "Utilize influencer marketing to reach a broader audience."
                   },
                   {
                    id: "eg-0-1-11", da: "Launch referral programs to incentivize customers."
                   },
                   {
                    id: "eg-0-1-12", da: "Improve your email marketing campaigns."
                   },
                   {
                    id: "eg-0-1-13", da: "Enhance your customer relationship management (CRM) system."
                   },
                   {
                    id: "eg-0-1-14", da: "Participate in industry trade shows and events."
                   },
                   {
                    id: "eg-0-1-15", da: "Offer discounts and promotions to attract new customers."
                   },
                   {
                    id: "eg-0-1-16", da: "Launch loyalty programs to retain existing customers."
                   },
                   {
                    id: "eg-0-1-17", da: "Streamline your sales process."
                   },
                   {
                    id: "eg-0-1-18", da: "Conduct customer surveys to gather feedback."
                   },
                   {
                    id: "eg-0-1-19", da: "Invest in market research tools and data analysis."
                   },
                   {
                    id: "eg-0-1-20", da: "Develop a strong public relations strategy."
                   },
                   {
                    id: "eg-0-1-21", da: "Create engaging and informative product demos."
                   },
                   {
                    id: "eg-0-1-22", da: "Implement a robust customer support system."
                   },
                   {
                    id: "eg-0-1-23", da: "Provide exceptional after-sales service."
                   },
                   {
                    id: "eg-0-1-24", da: "Optimize pricing strategies."
                   },
                   {
                    id: "eg-0-1-25", da: "Launch a referral program for existing customers."
                   },
                   {
                    id: "eg-0-1-26", da: "Offer free trials or samples."
                   },
                   {
                    id: "eg-0-1-27", da: "Create case studies showcasing customer success stories."
                   },
                   {
                    id: "eg-0-1-28", da: "Develop whitepapers and industry reports."
                   },
                   {
                    id: "eg-0-1-29", da: "Explore cross-selling and upselling opportunities."
                   },
                   {
                    id: "eg-0-1-30", da: "Strengthen supplier relationships for better pricing."
                   },
                   {
                    id: "eg-0-1-31", da: "Optimize your supply chain for efficiency."
                   },
                   {
                    id: "eg-0-1-32", da: "Launch a product or feature beta testing program."
                   },
                   {
                    id: "eg-0-1-33", da: "Improve user experience and website design."
                   },
                   {
                    id: "eg-0-1-34", da: "Implement A\/B testing for website optimization."
                   },
                   {
                    id: "eg-0-1-35", da: "Utilize customer feedback to drive product improvements."
                   },
                   {
                    id: "eg-0-1-36", da: "Enhance your packaging and branding."
                   },
                   {
                    id: "eg-0-1-37", da: "Develop a mobile app for your business."
                   },
                   {
                    id: "eg-0-1-38", da: "Explore opportunities for diversification."
                   },
                   {
                    id: "eg-0-1-39", da: "Invest in market segmentation for targeted marketing."
                   },
                   {
                    id: "eg-0-1-40", da: "Conduct employee training on customer service."
                   },
                   {
                    id: "eg-0-1-41", da: "Create a customer advisory board for feedback."
                   },
                   {
                    id: "eg-0-1-42", da: "Invest in market-specific certifications or accreditations."
                   },
                   {
                    id: "eg-0-1-43", da: "Monitor market trends and adjust your strategy accordingly."
                   },
                   {
                    id: "eg-0-1-44", da: "Develop a crisis communication plan."
                   },
                   {
                    id: "eg-0-1-45", da: "Engage with industry influencers and thought leaders."
                   },
                   {
                    id: "eg-0-1-46", da: "Participate in local community initiatives."
                   },
                   {
                    id: "eg-0-1-47", da: "Collaborate with academic institutions for research."
                   },
                   {
                    id: "eg-0-1-48", da: "Explore innovative technologies for market disruption."
                   },
                   {
                    id: "eg-0-1-49", da: "Continuously monitor and assess your market and make data-driven decisions."
                   },
                ]
              },
              {
                id: 'eg-0-2',
                pm: 'Technology is ready for scale and new product offerings or higher subscription models (in case of 3rd party apps) have been put in place based on user feedback.',
                title:'Technology',
                pmMap: 'Technology is ready for scale and new product offerings or higher subscription models (in case of 3rd party apps) have been put in place based on user feedback.',
                developmentActions:[
                  {
                    id: "eg-0-2-0", da: "Develop a user-friendly mobile app for better accessibility."
                   },
                   {
                    id: "eg-0-2-1", da: "Implement AI and machine learning for data analysis and insights."
                   },
                   {
                    id: "eg-0-2-2", da: "Create a developer portal for easy access to APIs."
                   },
                   {
                    id: "eg-0-2-3", da: "Enhance website performance for faster loading times."
                   },
                   {
                    id: "eg-0-2-4", da: "Integrate blockchain technology for data security."
                   },
                   {
                    id: "eg-0-2-5", da: "Implement chatbots for better customer support."
                   },
                   {
                    id: "eg-0-2-6", da: "Enable multi-language support on platforms."
                   },
                   {
                    id: "eg-0-2-7", da: "Develop a virtual reality experience for engagement."
                   },
                   {
                    id: "eg-0-2-8", da: "Optimize websites for voice search."
                   },
                   {
                    id: "eg-0-2-9", da: "Upgrade server infrastructure for scalability."
                   },
                   {
                    id: "eg-0-2-10", da: "Implement IoT devices for data collection."
                   },
                   {
                    id: "eg-0-2-11", da: "Create a customized CRM system."
                   },
                   {
                    id: "eg-0-2-12", da: "Utilize big data analytics for informed decisions."
                   },
                   {
                    id: "eg-0-2-13", da: "Develop a more intuitive UI\/UX design."
                   },
                   {
                    id: "eg-0-2-14", da: "Enhance cybersecurity measures."
                   },
                   {
                    id: "eg-0-2-15", da: "Implement cloud-based solutions."
                   },
                   {
                    id: "eg-0-2-16", da: "Improve website accessibility for all users."
                   },
                   {
                    id: "eg-0-2-17", da: "Create a knowledge base for stakeholders."
                   },
                   {
                    id: "eg-0-2-18", da: "Integrate e-commerce capabilities."
                   },
                   {
                    id: "eg-0-2-19", da: "Enhance data visualization tools."
                   },
                   {
                    id: "eg-0-2-20", da: "Implement gamification for engagement."
                   },
                   {
                    id: "eg-0-2-21", da: "Develop a robust content management system."
                   },
                   {
                    id: "eg-0-2-22", da: "Utilize social media integration."
                   },
                   {
                    id: "eg-0-2-23", da: "Implement responsive web design."
                   },
                   {
                    id: "eg-0-2-24", da: "Enhance API documentation for developers."
                   },
                   {
                    id: "eg-0-2-25", da: "Create a robust email marketing system."
                   },
                   {
                    id: "eg-0-2-26", da: "Implement data encryption for security."
                   },
                   {
                    id: "eg-0-2-27", da: "Develop a mobile payment gateway."
                   },
                   {
                    id: "eg-0-2-28", da: "Utilize geolocation services."
                   },
                   {
                    id: "eg-0-2-29", da: "Implement video conferencing capabilities."
                   },
                   {
                    id: "eg-0-2-30", da: "Create a feedback and survey system."
                   },
                   {
                    id: "eg-0-2-31", da: "Develop a dedicated community forum."
                   },
                   {
                    id: "eg-0-2-32", da: "Improve load balancing for web traffic."
                   },
                   {
                    id: "eg-0-2-33", da: "Implement data backup and recovery solutions."
                   },
                   {
                    id: "eg-0-2-34", da: "Enhance data privacy policies."
                   },
                   {
                    id: "eg-0-2-35", da: "Develop a user-friendly onboarding process."
                   },
                   {
                    id: "eg-0-2-36", da: "Implement data tracking and analytics."
                   },
                   {
                    id: "eg-0-2-37", da: "Create a bug tracking system."
                   },
                   {
                    id: "eg-0-2-38", da: "Utilize automated testing tools."
                   },
                   {
                    id: "eg-0-2-39", da: "Enhance database management."
                   },
                   {
                    id: "eg-0-2-40", da: "Implement A\/B testing for optimization."
                   },
                   {
                    id: "eg-0-2-41", da: "Develop a content personalization system."
                   },
                   {
                    id: "eg-0-2-42", da: "Utilize machine-to-machine communication."
                   },
                   {
                    id: "eg-0-2-43", da: "Implement responsive email templates."
                   },
                   {
                    id: "eg-0-2-44", da: "Develop a knowledge sharing platform."
                   },
                   {
                    id: "eg-0-2-45", da: "Utilize video marketing strategies."
                   },
                   {
                    id: "eg-0-2-46", da: "Implement Single Sign-On (SSO) capabilities."
                   },
                   {
                    id: "eg-0-2-47", da: "Enhance user authentication methods."
                   },
                   {
                    id: "eg-0-2-48", da: "Create a content delivery network (CDN)."
                   },
                   {
                    id: "eg-0-2-49", da: "Develop a system for real-time data processing."
                   },
                ]
              },
              {
                id: 'eg-0-3',
                pm: 'Community stakeholders are able to identify new customers segments.',
                title:'Value',
                pmMap: 'Community stakeholders are able to identify new customers segments.',
                developmentActions:[
                  {
                    id: "eg-0-3-0", da: "Develop a comprehensive ecosystem growth strategy."
                   },
                   {
                    id: "eg-0-3-1", da: "Identify key stakeholders and map their interests."
                   },
                   {
                    id: "eg-0-3-2", da: "Create a stakeholder engagement plan."
                   },
                   {
                    id: "eg-0-3-3", da: "Foster collaboration among ecosystem partners."
                   },
                   {
                    id: "eg-0-3-4", da: "Host regular ecosystem events and workshops."
                   },
                   {
                    id: "eg-0-3-5", da: "Provide educational resources for stakeholders."
                   },
                   {
                    id: "eg-0-3-6", da: "Implement a feedback mechanism for stakeholders."
                   },
                   {
                    id: "eg-0-3-7", da: "Establish partnerships with complementary organizations."
                   },
                   {
                    id: "eg-0-3-8", da: "Conduct market research to identify growth opportunities."
                   },
                   {
                    id: "eg-0-3-9", da: "Launch a referral program to incentivize stakeholder engagement."
                   },
                   {
                    id: "eg-0-3-10", da: "Develop a loyalty program to reward active stakeholders."
                   },
                   {
                    id: "eg-0-3-11", da: "Optimize the user experience for stakeholders."
                   },
                   {
                    id: "eg-0-3-12", da: "Enhance customer support for stakeholders."
                   },
                   {
                    id: "eg-0-3-13", da: "Create a dedicated community forum for interaction."
                   },
                   {
                    id: "eg-0-3-14", da: "Implement a mentorship program for stakeholders."
                   },
                   {
                    id: "eg-0-3-15", da: "Publish success stories and case studies."
                   },
                   {
                    id: "eg-0-3-16", da: "Hold webinars and knowledge-sharing sessions."
                   },
                   {
                    id: "eg-0-3-17", da: "Offer certification or training programs."
                   },
                   {
                    id: "eg-0-3-18", da: "Host hackathons or development challenges."
                   },
                   {
                    id: "eg-0-3-19", da: "Launch a developer portal for resources."
                   },
                   {
                    id: "eg-0-3-20", da: "Conduct regular surveys to gather feedback."
                   },
                   {
                    id: "eg-0-3-21", da: "Create localized content for diverse stakeholders."
                   },
                   {
                    id: "eg-0-3-22", da: "Develop a user-friendly mobile app."
                   },
                   {
                    id: "eg-0-3-23", da: "Invest in SEO and content marketing."
                   },
                   {
                    id: "eg-0-3-24", da: "Encourage user-generated content and testimonials."
                   },
                   {
                    id: "eg-0-3-25", da: "Foster inclusivity and diversity in the ecosystem."
                   },
                   {
                    id: "eg-0-3-26", da: "Streamline onboarding processes."
                   },
                   {
                    id: "eg-0-3-27", da: "Establish a clear governance framework."
                   },
                   {
                    id: "eg-0-3-28", da: "Promote ecosystem benefits and ROI."
                   },
                   {
                    id: "eg-0-3-29", da: "Create shareable content for social media."
                   },
                   {
                    id: "eg-0-3-30", da: "Implement gamification elements for engagement."
                   },
                   {
                    id: "eg-0-3-31", da: "Monitor and analyze stakeholder behavior."
                   },
                   {
                    id: "eg-0-3-32", da: "Utilize data analytics for personalized experiences."
                   },
                   {
                    id: "eg-0-3-33", da: "Launch an ambassador program for advocates."
                   },
                   {
                    id: "eg-0-3-34", da: "Develop an API marketplace for integration."
                   },
                   {
                    id: "eg-0-3-35", da: "Offer premium services or features."
                   },
                   {
                    id: "eg-0-3-36", da: "Collaborate with influencers for promotion."
                   },
                   {
                    id: "eg-0-3-37", da: "Explore new geographic markets for expansion."
                   },
                   {
                    id: "eg-0-3-38", da: "Conduct A\/B testing for optimization."
                   },
                   {
                    id: "eg-0-3-39", da: "Publish whitepapers and thought leadership content."
                   },
                   {
                    id: "eg-0-3-40", da: "Create a marketplace for products or services."
                   },
                   {
                    id: "eg-0-3-41", da: "Expand the ecosystem with new partners."
                   },
                   {
                    id: "eg-0-3-42", da: "Secure funding for ecosystem growth initiatives."
                   },
                   {
                    id: "eg-0-3-43", da: "Conduct competitive analysis and differentiation."
                   },
                   {
                    id: "eg-0-3-44", da: "Establish partnerships with educational institutions."
                   },
                   {
                    id: "eg-0-3-45", da: "Implement a referral tracking system."
                   },
                   {
                    id: "eg-0-3-46", da: "Launch a token or incentive system for stakeholders."
                   },
                   {
                    id: "eg-0-3-47", da: "Regularly update and improve the ecosystem."
                   },
                   {
                    id: "eg-0-3-48", da: "Focus on long-term sustainability and scalability."
                   },
                   {
                    id: "eg-0-3-49", da: "Measure and report the impact of ecosystem growth efforts."
                   },
                ]
              },
              {
                id: 'eg-0-4',
                pm: 'Clear revenue model and share of revenues are established. Stakeholders are identified and agreements confirmed.',
                title:'Business Model',
                pmMap: 'Clear revenue model and share of revenues are established. Stakeholders are identified and agreements confirmed.',
                developmentActions:[
                  {
                    id: "eg-0-4-0", da: "Identify and target new customer segments."
                   },
                   {
                    id: "eg-0-4-1", da: "Expand into untapped geographic markets."
                   },
                   {
                    id: "eg-0-4-2", da: "Enhance customer segmentation for personalized offerings."
                   },
                   {
                    id: "eg-0-4-3", da: "Develop partnerships with complementary businesses."
                   },
                   {
                    id: "eg-0-4-4", da: "Create a more compelling value proposition."
                   },
                   {
                    id: "eg-0-4-5", da: "Implement tiered pricing to cater to different customer budgets."
                   },
                   {
                    id: "eg-0-4-6", da: "Offer subscription-based models for recurring revenue."
                   },
                   {
                    id: "eg-0-4-7", da: "Investigate cost-cutting opportunities to improve profitability."
                   },
                   {
                    id: "eg-0-4-8", da: "Innovate product or service offerings."
                   },
                   {
                    id: "eg-0-4-9", da: "Launch new product lines."
                   },
                   {
                    id: "eg-0-4-10", da: "Improve product quality and performance."
                   },
                   {
                    id: "eg-0-4-11", da: "Conduct market research to identify emerging trends."
                   },
                   {
                    id: "eg-0-4-12", da: "Foster customer loyalty through loyalty programs."
                   },
                   {
                    id: "eg-0-4-13", da: "Enhance user experience on your digital platforms."
                   },
                   {
                    id: "eg-0-4-14", da: "Leverage data analytics for better decision-making."
                   },
                   {
                    id: "eg-0-4-15", da: "Strengthen your supply chain for efficiency."
                   },
                   {
                    id: "eg-0-4-16", da: "Implement green and sustainable practices."
                   },
                   {
                    id: "eg-0-4-17", da: "Establish a more effective sales funnel."
                   },
                   {
                    id: "eg-0-4-18", da: "Provide better customer support services."
                   },
                   {
                    id: "eg-0-4-19", da: "Create an online community for customer engagement."
                   },
                   {
                    id: "eg-0-4-20", da: "Leverage social media for marketing and Tracking Open calls."
                   },
                   {
                    id: "eg-0-4-21", da: "Optimize digital marketing strategies."
                   },
                   {
                    id: "eg-0-4-22", da: "Invest in employee training and development."
                   },
                   {
                    id: "eg-0-4-23", da: "Promote diversity and inclusion in the workplace."
                   },
                   {
                    id: "eg-0-4-24", da: "Streamline business operations."
                   },
                   {
                    id: "eg-0-4-25", da: "Enhance the company's branding and reputation."
                   },
                   {
                    id: "eg-0-4-26", da: "Develop a crisis management plan."
                   },
                   {
                    id: "eg-0-4-27", da: "Invest in research and development."
                   },
                   {
                    id: "eg-0-4-28", da: "Focus on regulatory compliance."
                   },
                   {
                    id: "eg-0-4-29", da: "Optimize inventory management."
                   },
                   {
                    id: "eg-0-4-30", da: "Invest in cybersecurity and data protection."
                   },
                   {
                    id: "eg-0-4-31", da: "Expand your network of suppliers and partners."
                   },
                   {
                    id: "eg-0-4-32", da: "Implement a more efficient content marketing strategy."
                   },
                   {
                    id: "eg-0-4-33", da: "Conduct A\/B testing for marketing campaigns."
                   },
                   {
                    id: "eg-0-4-34", da: "Improve the checkout process for e-commerce."
                   },
                   {
                    id: "eg-0-4-35", da: "Offer extended warranties or guarantees."
                   },
                   {
                    id: "eg-0-4-36", da: "Evaluate the scalability of your operations."
                   },
                   {
                    id: "eg-0-4-37", da: "Identify cross-selling and upselling opportunities."
                   },
                   {
                    id: "eg-0-4-38", da: "Establish clear key performance indicators (KPIs)."
                   },
                   {
                    id: "eg-0-4-39", da: "Conduct regular SWOT analysis."
                   },
                   {
                    id: "eg-0-4-40", da: "Foster a culture of innovation."
                   },
                   {
                    id: "eg-0-4-41", da: "Analyze the competition for insights."
                   },
                   {
                    id: "eg-0-4-42", da: "Enhance the onboarding process for new customers."
                   },
                   {
                    id: "eg-0-4-43", da: "Improve employee engagement and satisfaction."
                   },
                   {
                    id: "eg-0-4-44", da: "Focus on corporate social responsibility."
                   },
                   {
                    id: "eg-0-4-45", da: "Invest in emerging technologies like AI and blockchain."
                   },
                   {
                    id: "eg-0-4-46", da: "Monitor customer feedback and act upon it."
                   },
                   {
                    id: "eg-0-4-47", da: "Enhance data privacy policies."
                   },
                   {
                    id: "eg-0-4-48", da: "Develop a clear exit strategy for underperforming ventures."
                   },
                   {
                    id: "eg-0-4-49", da: "Continually reassess and adapt your business model to evolving market conditions."
                   },
                ]
              },
              {
                id: 'eg-0-5',
                pm: 'Evidence of strong unit economics across multiple channels. Stakeholders are aligned on pricing models and offers.',
                title:'Go to Market',
                pmMap: 'Evidence of strong unit economics across multiple channels. Stakeholders are aligned on pricing models and offers.',
                developmentActions:[
                  {
                    id: "eg-0-5-0", da: "Conduct market research to identify untapped opportunities."
                   },
                   {
                    id: "eg-0-5-1", da: "Define clear target markets and customer segments."
                   },
                   {
                    id: "eg-0-5-2", da: "Develop buyer personas to understand customer needs."
                   },
                   {
                    id: "eg-0-5-3", da: "Create a compelling value proposition."
                   },
                   {
                    id: "eg-0-5-4", da: "Refine product positioning and messaging."
                   },
                   {
                    id: "eg-0-5-5", da: "Optimize your pricing strategy."
                   },
                   {
                    id: "eg-0-5-6", da: "Improve product packaging and bundling."
                   },
                   {
                    id: "eg-0-5-7", da: "Enhance your sales collateral and materials."
                   },
                   {
                    id: "eg-0-5-8", da: "Train your sales team on the latest product knowledge."
                   },
                   {
                    id: "eg-0-5-9", da: "Implement a customer relationship management (CRM) system."
                   },
                   {
                    id: "eg-0-5-10", da: "Focus on lead generation and lead nurturing."
                   },
                   {
                    id: "eg-0-5-11", da: "Develop a content marketing strategy."
                   },
                   {
                    id: "eg-0-5-12", da: "Invest in social media marketing."
                   },
                   {
                    id: "eg-0-5-13", da: "Run targeted online advertising campaigns."
                   },
                   {
                    id: "eg-0-5-14", da: "Strengthen your brand identity and recognition."
                   },
                   {
                    id: "eg-0-5-15", da: "Optimize your website for conversions."
                   },
                   {
                    id: "eg-0-5-16", da: "Implement SEO best practices."
                   },
                   {
                    id: "eg-0-5-17", da: "Enhance user experience on your website."
                   },
                   {
                    id: "eg-0-5-18", da: "Launch email marketing campaigns."
                   },
                   {
                    id: "eg-0-5-19", da: "Develop affiliate marketing partnerships."
                   },
                   {
                    id: "eg-0-5-20", da: "Improve customer onboarding and retention strategies."
                   },
                   {
                    id: "eg-0-5-21", da: "Expand your distribution channels."
                   },
                   {
                    id: "eg-0-5-22", da: "Consider strategic partnerships and alliances."
                   },
                   {
                    id: "eg-0-5-23", da: "Evaluate your sales funnel for bottlenecks."
                   },
                   {
                    id: "eg-0-5-24", da: "Enhance the customer journey."
                   },
                   {
                    id: "eg-0-5-25", da: "Implement customer feedback mechanisms."
                   },
                   {
                    id: "eg-0-5-26", da: "Leverage data analytics for insights."
                   },
                   {
                    id: "eg-0-5-27", da: "Optimize your mobile marketing strategy."
                   },
                   {
                    id: "eg-0-5-28", da: "Explore influencer marketing opportunities."
                   },
                   {
                    id: "eg-0-5-29", da: "Invest in video marketing content."
                   },
                   {
                    id: "eg-0-5-30", da: "Expand to new geographic markets."
                   },
                   {
                    id: "eg-0-5-31", da: "Localize your content and messaging."
                   },
                   {
                    id: "eg-0-5-32", da: "Analyze competitor strategies and differentiators."
                   },
                   {
                    id: "eg-0-5-33", da: "Conduct A\/B testing for marketing campaigns."
                   },
                   {
                    id: "eg-0-5-34", da: "Strengthen referral and loyalty programs."
                   },
                   {
                    id: "eg-0-5-35", da: "Personalize customer interactions."
                   },
                   {
                    id: "eg-0-5-36", da: "Develop a strong public relations strategy."
                   },
                   {
                    id: "eg-0-5-37", da: "Attend industry events and trade shows."
                   },
                   {
                    id: "eg-0-5-38", da: "Implement a community building strategy."
                   },
                   {
                    id: "eg-0-5-39", da: "Conduct webinars and online events."
                   },
                   {
                    id: "eg-0-5-40", da: "Focus on thought leadership in your industry."
                   },
                   {
                    id: "eg-0-5-41", da: "Explore crowdfunding and crowdinvesting."
                   },
                   {
                    id: "eg-0-5-42", da: "Seek feedback from internal teams (sales, support)."
                   },
                   {
                    id: "eg-0-5-43", da: "Optimize the sales-to-customer journey handoff."
                   },
                   {
                    id: "eg-0-5-44", da: "Streamline order fulfillment and delivery processes."
                   },
                   {
                    id: "eg-0-5-45", da: "Explore alternative sales channels like e-commerce."
                   },
                   {
                    id: "eg-0-5-46", da: "Build an effective customer service team."
                   },
                   {
                    id: "eg-0-5-47", da: "Monitor customer sentiment and reviews."
                   },
                   {
                    id: "eg-0-5-48", da: "Create an ambassador or advocacy program."
                   },
                   {
                    id: "eg-0-5-49", da: "Continuously evaluate and adapt your strategy based on results."
                   },
                ]
              },
              {
                id: 'eg-0-6',
                pm: 'Company values are lived and leadership principles are introduced to all members in internal stakeholders.',
                title:'People',
                pmMap: 'Company values are lived and leadership principles are introduced to all members in internal stakeholders.',
                developmentActions:[
                  {
                    id: "eg-0-6-0", da: "Establish mentorship programs for stakeholders."
                   },
                   {
                    id: "eg-0-6-1", da: "Offer training sessions on ecosystem dynamics."
                   },
                   {
                    id: "eg-0-6-2", da: "Encourage stakeholders to attend industry conferences."
                   },
                   {
                    id: "eg-0-6-3", da: "Promote continuous learning and skill development."
                   },
                   {
                    id: "eg-0-6-4", da: "Foster diversity and inclusion within the ecosystem."
                   },
                   {
                    id: "eg-0-6-5", da: "Implement team-building activities and workshops."
                   },
                   {
                    id: "eg-0-6-6", da: "Create a knowledge-sharing platform."
                   },
                   {
                    id: "eg-0-6-7", da: "Launch a leadership development program."
                   },
                   {
                    id: "eg-0-6-8", da: "Develop communication and presentation skills."
                   },
                   {
                    id: "eg-0-6-9", da: "Encourage cross-functional collaboration."
                   },
                   {
                    id: "eg-0-6-10", da: "Support mental health and well-being initiatives."
                   },
                   {
                    id: "eg-0-6-11", da: "Provide resources for stress management."
                   },
                   {
                    id: "eg-0-6-12", da: "Promote work-life balance."
                   },
                   {
                    id: "eg-0-6-13", da: "Organize networking events."
                   },
                   {
                    id: "eg-0-6-14", da: "Enhance conflict resolution skills."
                   },
                   {
                    id: "eg-0-6-15", da: "Implement feedback mechanisms."
                   },
                   {
                    id: "eg-0-6-16", da: "Develop critical thinking abilities."
                   },
                   {
                    id: "eg-0-6-17", da: "Offer negotiation and persuasion training."
                   },
                   {
                    id: "eg-0-6-18", da: "Provide resources for time management."
                   },
                   {
                    id: "eg-0-6-19", da: "Promote creativity and innovation."
                   },
                   {
                    id: "eg-0-6-20", da: "Cultivate problem-solving skills."
                   },
                   {
                    id: "eg-0-6-21", da: "Enhance adaptability and resilience."
                   },
                   {
                    id: "eg-0-6-22", da: "Foster a growth mindset."
                   },
                   {
                    id: "eg-0-6-23", da: "Promote financial literacy."
                   },
                   {
                    id: "eg-0-6-24", da: "Encourage ethical decision-making."
                   },
                   {
                    id: "eg-0-6-25", da: "Develop cultural competence."
                   },
                   {
                    id: "eg-0-6-26", da: "Provide resources for digital literacy."
                   },
                   {
                    id: "eg-0-6-27", da: "Offer training in data analysis and interpretation."
                   },
                   {
                    id: "eg-0-6-28", da: "Promote emotional intelligence."
                   },
                   {
                    id: "eg-0-6-29", da: "Foster self-awareness and self-regulation."
                   },
                   {
                    id: "eg-0-6-30", da: "Develop public speaking skills."
                   },
                   {
                    id: "eg-0-6-31", da: "Implement conflict of interest policies."
                   },
                   {
                    id: "eg-0-6-32", da: "Provide mentorship for first-time entrepreneurs."
                   },
                   {
                    id: "eg-0-6-33", da: "Support stakeholders in building personal brands."
                   },
                   {
                    id: "eg-0-6-34", da: "Offer training in social media management."
                   },
                   {
                    id: "eg-0-6-35", da: "Encourage stakeholders to write thought leadership articles."
                   },
                   {
                    id: "eg-0-6-36", da: "Foster negotiation skills."
                   },
                   {
                    id: "eg-0-6-37", da: "Promote cultural sensitivity training."
                   },
                   {
                    id: "eg-0-6-38", da: "Develop crisis management abilities."
                   },
                   {
                    id: "eg-0-6-39", da: "Offer workshops on risk assessment and mitigation."
                   },
                   {
                    id: "eg-0-6-40", da: "Create a learning management system."
                   },
                   {
                    id: "eg-0-6-41", da: "Develop project management skills."
                   },
                   {
                    id: "eg-0-6-42", da: "Promote community engagement."
                   },
                   {
                    id: "eg-0-6-43", da: "Encourage stakeholders to volunteer in social causes."
                   },
                   {
                    id: "eg-0-6-44", da: "Provide access to leadership literature."
                   },
                   {
                    id: "eg-0-6-45", da: "Implement peer-to-peer feedback systems."
                   },
                   {
                    id: "eg-0-6-46", da: "Foster a sense of ownership in stakeholders."
                   },
                   {
                    id: "eg-0-6-47", da: "Develop networking skills."
                   },
                   {
                    id: "eg-0-6-48", da: "Promote eco-friendly practices."
                   },
                   {
                    id: "eg-0-6-49", da: "Encourage stakeholder participation in local communities."
                   },
                ]
              },
              {
                id: 'eg-0-7',
                pm: 'Excellent understanding of funnel and conversion rates. Stakeholder reports are being periodically published.',
                title:'Data Metrics',
                pmMap: 'Excellent understanding of funnel and conversion rates. Stakeholder reports are being periodically published.',
                developmentActions:[
                  {
                    id: "eg-0-7-0", da: "Implement a comprehensive data collection strategy."
                   },
                   {
                    id: "eg-0-7-1", da: "Define key performance indicators (KPIs) for ecosystem growth."
                   },
                   {
                    id: "eg-0-7-2", da: "Develop KPIs for stakeholder activation."
                   },
                   {
                    id: "eg-0-7-3", da: "Standardize data collection across the ecosystem."
                   },
                   {
                    id: "eg-0-7-4", da: "Ensure data accuracy and consistency."
                   },
                   {
                    id: "eg-0-7-5", da: "Conduct regular data audits."
                   },
                   {
                    id: "eg-0-7-6", da: "Establish a data governance framework."
                   },
                   {
                    id: "eg-0-7-7", da: "Invest in data analytics tools and platforms."
                   },
                   {
                    id: "eg-0-7-8", da: "Create a centralized data repository."
                   },
                   {
                    id: "eg-0-7-9", da: "Implement real-time data tracking."
                   },
                   {
                    id: "eg-0-7-10", da: "Monitor user engagement metrics."
                   },
                   {
                    id: "eg-0-7-11", da: "Track user acquisition rates."
                   },
                   {
                    id: "eg-0-7-12", da: "Measure user retention and churn rates."
                   },
                   {
                    id: "eg-0-7-13", da: "Analyze user demographics."
                   },
                   {
                    id: "eg-0-7-14", da: "Segment stakeholders for targeted strategies."
                   },
                   {
                    id: "eg-0-7-15", da: "Monitor conversion rates for stakeholders."
                   },
                   {
                    id: "eg-0-7-16", da: "Measure the impact of marketing campaigns."
                   },
                   {
                    id: "eg-0-7-17", da: "Analyze user behavior through clickstream data."
                   },
                   {
                    id: "eg-0-7-18", da: "Implement cohort analysis."
                   },
                   {
                    id: "eg-0-7-19", da: "Assess customer lifetime value (CLV)."
                   },
                   {
                    id: "eg-0-7-20", da: "Evaluate customer acquisition cost (CAC)."
                   },
                   {
                    id: "eg-0-7-21", da: "Track product adoption rates."
                   },
                   {
                    id: "eg-0-7-22", da: "Analyze customer satisfaction through surveys."
                   },
                   {
                    id: "eg-0-7-23", da: "Monitor net promoter scores (NPS)."
                   },
                   {
                    id: "eg-0-7-24", da: "Assess user onboarding processes."
                   },
                   {
                    id: "eg-0-7-25", da: "Measure the efficiency of customer support."
                   },
                   {
                    id: "eg-0-7-26", da: "Track product feature usage."
                   },
                   {
                    id: "eg-0-7-27", da: "Analyze funnel drop-off points."
                   },
                   {
                    id: "eg-0-7-28", da: "Monitor referral and word-of-mouth growth."
                   },
                   {
                    id: "eg-0-7-29", da: "Evaluate the impact of partnerships on growth."
                   },
                   {
                    id: "eg-0-7-30", da: "Measure community engagement metrics."
                   },
                   {
                    id: "eg-0-7-31", da: "Track social media reach and engagement."
                   },
                   {
                    id: "eg-0-7-32", da: "Assess website traffic and conversions."
                   },
                   {
                    id: "eg-0-7-33", da: "Monitor SEO performance and keyword rankings."
                   },
                   {
                    id: "eg-0-7-34", da: "Analyze email marketing metrics."
                   },
                   {
                    id: "eg-0-7-35", da: "Evaluate content marketing effectiveness."
                   },
                   {
                    id: "eg-0-7-36", da: "Measure event attendance and participation."
                   },
                   {
                    id: "eg-0-7-37", da: "Analyze user-generated content and reviews."
                   },
                   {
                    id: "eg-0-7-38", da: "Track app store ratings and reviews."
                   },
                   {
                    id: "eg-0-7-39", da: "Monitor open rates and click-through rates for emails."
                   },
                   {
                    id: "eg-0-7-40", da: "Evaluate customer feedback data."
                   },
                   {
                    id: "eg-0-7-41", da: "Analyze user survey responses."
                   },
                   {
                    id: "eg-0-7-42", da: "Track user journey mapping."
                   },
                   {
                    id: "eg-0-7-43", da: "Measure the impact of A\/B testing."
                   },
                   {
                    id: "eg-0-7-44", da: "Analyze market share growth."
                   },
                   {
                    id: "eg-0-7-45", da: "Monitor competitive benchmarking data."
                   },
                   {
                    id: "eg-0-7-46", da: "Assess data privacy and security compliance."
                   },
                   {
                    id: "eg-0-7-47", da: "Evaluate data monetization opportunities."
                   },
                   {
                    id: "eg-0-7-48", da: "Measure data-driven decision-making effectiveness."
                   },
                   {
                    id: "eg-0-7-49", da: "Continuously improve data infrastructure and tools."
                   },
                ]
              },
              {
                id: 'eg-0-8',
                pm: 'Stakeholders get support through training and enablement. A framework of operational support is set.',
                title:'Operations',
                pmMap: 'Stakeholders get support through training and enablement. A framework of operational support is set.',
                developmentActions:[
                  {
                    id: "eg-0-8-0", da: "Develop a clear strategy for ecosystem growth and stakeholder engagement."
                   },
                   {
                    id: "eg-0-8-1", da: "Establish key performance indicators (KPIs) to measure the success of ecosystem development efforts."
                   },
                   {
                    id: "eg-0-8-2", da: "Identify and prioritize target stakeholders within the ecosystem."
                   },
                   {
                    id: "eg-0-8-3", da: "Create a stakeholder mapping to understand their influence and interests."
                   },
                   {
                    id: "eg-0-8-4", da: "Develop a comprehensive stakeholder engagement plan."
                   },
                   {
                    id: "eg-0-8-5", da: "Conduct regular stakeholder analysis to keep the plan up-to-date."
                   },
                   {
                    id: "eg-0-8-6", da: "Implement a communication strategy to engage stakeholders effectively."
                   },
                   {
                    id: "eg-0-8-7", da: "Establish a feedback loop to gather input from stakeholders."
                   },
                   {
                    id: "eg-0-8-8", da: "Foster collaboration and partnerships with key ecosystem players."
                   },
                   {
                    id: "eg-0-8-9", da: "Host regular events, webinars, or meetups to bring stakeholders together."
                   },
                   {
                    id: "eg-0-8-10", da: "Recognize and reward active stakeholders."
                   },
                   {
                    id: "eg-0-8-11", da: "Create an online community or forum for stakeholder discussions."
                   },
                   {
                    id: "eg-0-8-12", da: "Publish regular reports and updates on ecosystem growth."
                   },
                   {
                    id: "eg-0-8-13", da: "Provide resources and educational materials for stakeholders."
                   },
                   {
                    id: "eg-0-8-14", da: "Establish a dedicated support team to assist stakeholders."
                   },
                   {
                    id: "eg-0-8-15", da: "Implement a CRM system to manage stakeholder relationships."
                   },
                   {
                    id: "eg-0-8-16", da: "Conduct surveys and feedback sessions to gather input."
                   },
                   {
                    id: "eg-0-8-17", da: "Set up a referral program to encourage stakeholder referrals."
                   },
                   {
                    id: "eg-0-8-18", da: "Develop a training program for stakeholders to enhance their skills."
                   },
                   {
                    id: "eg-0-8-19", da: "Promote thought leadership within the ecosystem."
                   },
                   {
                    id: "eg-0-8-20", da: "Organize hackathons or innovation challenges to encourage participation."
                   },
                   {
                    id: "eg-0-8-21", da: "Build a robust onboarding process for new stakeholders."
                   },
                   {
                    id: "eg-0-8-22", da: "Develop case studies and success stories to showcase the benefits of the ecosystem."
                   },
                   {
                    id: "eg-0-8-23", da: "Conduct market research to identify emerging stakeholders."
                   },
                   {
                    id: "eg-0-8-24", da: "Foster inclusivity and diversity within the ecosystem."
                   },
                   {
                    id: "eg-0-8-25", da: "Regularly update and refine the ecosystem's value proposition."
                   },
                   {
                    id: "eg-0-8-26", da: "Establish partnerships with educational institutions."
                   },
                   {
                    id: "eg-0-8-27", da: "Create pathways for stakeholders to become advocates."
                   },
                   {
                    id: "eg-0-8-28", da: "Offer early access to new features or products."
                   },
                   {
                    id: "eg-0-8-29", da: "Host an annual ecosystem conference or summit."
                   },
                   {
                    id: "eg-0-8-30", da: "Provide tools and resources for stakeholders to recruit others."
                   },
                   {
                    id: "eg-0-8-31", da: "Develop a knowledge sharing platform for stakeholders."
                   },
                   {
                    id: "eg-0-8-32", da: "Promote mentorship programs within the ecosystem."
                   },
                   {
                    id: "eg-0-8-33", da: "Establish a mechanism for stakeholders to provide feedback on operations."
                   },
                   {
                    id: "eg-0-8-34", da: "Conduct impact assessments to measure the value of ecosystem growth."
                   },
                   {
                    id: "eg-0-8-35", da: "Collaborate with industry associations and trade groups."
                   },
                   {
                    id: "eg-0-8-36", da: "Promote corporate social responsibility initiatives."
                   },
                   {
                    id: "eg-0-8-37", da: "Establish guidelines for ethical and responsible stakeholder behavior."
                   },
                   {
                    id: "eg-0-8-38", da: "Implement a mechanism for conflict resolution among stakeholders."
                   },
                   {
                    id: "eg-0-8-39", da: "Leverage social media for stakeholder engagement and activation."
                   },
                   {
                    id: "eg-0-8-40", da: "Monitor and respond to industry trends to stay relevant."
                   },
                   {
                    id: "eg-0-8-41", da: "Conduct regular SWOT analysis of ecosystem operations."
                   },
                   {
                    id: "eg-0-8-42", da: "Establish a knowledge management system."
                   },
                   {
                    id: "eg-0-8-43", da: "Encourage cross-functional collaboration among stakeholders."
                   },
                   {
                    id: "eg-0-8-44", da: "Develop a crisis management plan for unexpected challenges."
                   },
                   {
                    id: "eg-0-8-45", da: "Promote transparency in decision-making processes."
                   },
                   {
                    id: "eg-0-8-46", da: "Offer exclusive access to premium content or resources."
                   },
                   {
                    id: "eg-0-8-47", da: "Leverage data analytics to gain insights into stakeholder behavior."
                   },
                   {
                    id: "eg-0-8-48", da: "Establish clear governance and rules for the ecosystem."
                   },
                   {
                    id: "eg-0-8-49", da: "Continuously evaluate and adapt the operations strategy based on changing circumstances."
                   },
                ]
              },
              {
                id: 'eg-0-9',
                pm: 'Team has relations with potential acquirers.',
                title:'Exit Strategy',
                pmMap: 'Team has relations with potential acquirers.',
                developmentActions:[
                  {
                    id: "eg-0-9-0", da: "Define clear objectives for the exit strategy."
                   },
                   {
                    id: "eg-0-9-1", da: "Consider potential exit scenarios, such as acquisition, merger, IPO, or shutdown."
                   },
                   {
                    id: "eg-0-9-2", da: "Determine the ideal timing for the exit."
                   },
                   {
                    id: "eg-0-9-3", da: "Assess the financial health of the ecosystem and stakeholders."
                   },
                   {
                    id: "eg-0-9-4", da: "Ensure all stakeholders are aware of the exit strategy."
                   },
                   {
                    id: "eg-0-9-5", da: "Consider how the exit will affect existing partnerships."
                   },
                   {
                    id: "eg-0-9-6", da: "Develop contingency plans for unforeseen challenges."
                   },
                   {
                    id: "eg-0-9-7", da: "Evaluate legal and contractual obligations related to exit."
                   },
                   {
                    id: "eg-0-9-8", da: "Determine how to maximize stakeholder value upon exit."
                   },
                   {
                    id: "eg-0-9-9", da: "Consider the tax implications of the exit."
                   },
                   {
                    id: "eg-0-9-10", da: "Plan for post-exit responsibilities and support for stakeholders."
                   },
                   {
                    id: "eg-0-9-11", da: "Analyze market conditions and trends."
                   },
                   {
                    id: "eg-0-9-12", da: "Monitor competition and potential acquirers."
                   },
                   {
                    id: "eg-0-9-13", da: "Consider the impact of the exit on employees and stakeholders."
                   },
                   {
                    id: "eg-0-9-14", da: "Evaluate the impact of intellectual property rights."
                   },
                   {
                    id: "eg-0-9-15", da: "Ensure data security and privacy compliance."
                   },
                   {
                    id: "eg-0-9-16", da: "Determine how to address customer concerns."
                   },
                   {
                    id: "eg-0-9-17", da: "Develop a communication plan for stakeholders."
                   },
                   {
                    id: "eg-0-9-18", da: "Calculate the financial aspects of the exit strategy."
                   },
                   {
                    id: "eg-0-9-19", da: "Identify potential buyers or investors."
                   },
                   {
                    id: "eg-0-9-20", da: "Establish a clear process for due diligence."
                   },
                   {
                    id: "eg-0-9-21", da: "Assess the competitive landscape in the ecosystem."
                   },
                   {
                    id: "eg-0-9-22", da: "Consider the impact on community engagement."
                   },
                   {
                    id: "eg-0-9-23", da: "Evaluate potential risks and uncertainties."
                   },
                   {
                    id: "eg-0-9-24", da: "Plan for the transfer of assets or responsibilities."
                   },
                   {
                    id: "eg-0-9-25", da: "Consider the impact on brand and reputation."
                   },
                   {
                    id: "eg-0-9-26", da: "Establish mechanisms for stakeholder feedback."
                   },
                   {
                    id: "eg-0-9-27", da: "Ensure legal compliance throughout the exit process."
                   },
                   {
                    id: "eg-0-9-28", da: "Evaluate the impact on employees and their roles."
                   },
                   {
                    id: "eg-0-9-29", da: "Develop employee retention strategies."
                   },
                   {
                    id: "eg-0-9-30", da: "Plan for a smooth transition of operations."
                   },
                   {
                    id: "eg-0-9-31", da: "Assess the impact on third-party vendors and suppliers."
                   },
                   {
                    id: "eg-0-9-32", da: "Establish a timeline for the exit."
                   },
                   {
                    id: "eg-0-9-33", da: "Consider potential scenarios for stakeholder resistance."
                   },
                   {
                    id: "eg-0-9-34", da: "Determine the best methods for value realization."
                   },
                   {
                    id: "eg-0-9-35", da: "Calculate the financial implications of the exit."
                   },
                   {
                    id: "eg-0-9-36", da: "Assess potential financing options for the exit."
                   },
                   {
                    id: "eg-0-9-37", da: "Ensure transparency in communication with stakeholders."
                   },
                   {
                    id: "eg-0-9-38", da: "Plan for addressing investor concerns."
                   },
                   {
                    id: "eg-0-9-39", da: "Consider the impact on product or service delivery."
                   },
                   {
                    id: "eg-0-9-40", da: "Evaluate the impact on stakeholders' financial interests."
                   },
                   {
                    id: "eg-0-9-41", da: "Develop mechanisms for addressing legal disputes."
                   },
                   {
                    id: "eg-0-9-42", da: "Assess the impact on intellectual property rights."
                   },
                   {
                    id: "eg-0-9-43", da: "Ensure compliance with industry regulations."
                   },
                   {
                    id: "eg-0-9-44", da: "Plan for knowledge transfer and documentation."
                   },
                   {
                    id: "eg-0-9-45", da: "Determine the optimal structure for the exit."
                   },
                   {
                    id: "eg-0-9-46", da: "Assess the impact on innovation within the ecosystem."
                   },
                   {
                    id: "eg-0-9-47", da: "Develop a plan for stakeholders' reintegration into new ventures."
                   },
                   {
                    id: "eg-0-9-48", da: "Consider ethical and social responsibilities during the exit."
                   },
                   {
                    id: "eg-0-9-49", da: "Monitor and adjust the exit strategy as needed based on changing circumstances."
                   },
                ]
              }
            ]
          },
          {
            id: 'eg-1',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Consulting',
            wdd: '',
            progressMeasures:[
              {
                id: 'eg-1-0',
                pm: 'Consulting packages as offers are created to serve standard needs.',
                title:'Need',
                pmMap: 'Consulting packages as offers are created to serve standard needs.',
                developmentActions:[
                  {
                    id: "eg-1-0-0", da: "Conduct a SWOT analysis to identify strengths, weaknesses, opportunities, and threats."
                   },
                   {
                    id: "eg-1-0-1", da: "Define clear goals and objectives for ecosystem growth."
                   },
                   {
                    id: "eg-1-0-2", da: "Develop a strategic plan with a clear roadmap."
                   },
                   {
                    id: "eg-1-0-3", da: "Identify and target the right audience or market segment."
                   },
                   {
                    id: "eg-1-0-4", da: "Enhance the user experience for your ecosystem."
                   },
                   {
                    id: "eg-1-0-5", da: "Invest in research and development."
                   },
                   {
                    id: "eg-1-0-6", da: "Improve product or service quality."
                   },
                   {
                    id: "eg-1-0-7", da: "Expand the product or service offering."
                   },
                   {
                    id: "eg-1-0-8", da: "Collaborate with complementary businesses."
                   },
                   {
                    id: "eg-1-0-9", da: "Strengthen your branding and marketing efforts."
                   },
                   {
                    id: "eg-1-0-10", da: "Increase your online presence through social media."
                   },
                   {
                    id: "eg-1-0-11", da: "Invest in content marketing and SEO."
                   },
                   {
                    id: "eg-1-0-12", da: "Launch a referral program to incentivize growth."
                   },
                   {
                    id: "eg-1-0-13", da: "Create educational resources or webinars."
                   },
                   {
                    id: "eg-1-0-14", da: "Improve customer support and responsiveness."
                   },
                   {
                    id: "eg-1-0-15", da: "Implement user feedback and surveys."
                   },
                   {
                    id: "eg-1-0-16", da: "Optimize pricing strategies."
                   },
                   {
                    id: "eg-1-0-17", da: "Diversify revenue streams."
                   },
                   {
                    id: "eg-1-0-18", da: "Invest in new technologies or tools."
                   },
                   {
                    id: "eg-1-0-19", da: "Enhance cybersecurity measures."
                   },
                   {
                    id: "eg-1-0-20", da: "Expand to new geographic regions."
                   },
                   {
                    id: "eg-1-0-21", da: "Develop partnerships or alliances."
                   },
                   {
                    id: "eg-1-0-22", da: "Offer special promotions or discounts."
                   },
                   {
                    id: "eg-1-0-23", da: "Conduct market research to identify trends."
                   },
                   {
                    id: "eg-1-0-24", da: "Focus on sustainability and corporate responsibility."
                   },
                   {
                    id: "eg-1-0-25", da: "Build a strong company culture."
                   },
                   {
                    id: "eg-1-0-26", da: "Invest in employee training and development."
                   },
                   {
                    id: "eg-1-0-27", da: "Explore new distribution channels."
                   },
                   {
                    id: "eg-1-0-28", da: "Optimize supply chain and logistics."
                   },
                   {
                    id: "eg-1-0-29", da: "Review and streamline internal processes."
                   },
                   {
                    id: "eg-1-0-30", da: "Seek external funding or investment."
                   },
                   {
                    id: "eg-1-0-31", da: "Explore mergers and acquisitions."
                   },
                   {
                    id: "eg-1-0-32", da: "Enhance data analytics and insights."
                   },
                   {
                    id: "eg-1-0-33", da: "Foster innovation within the organization."
                   },
                   {
                    id: "eg-1-0-34", da: "Build a strong online community."
                   },
                   {
                    id: "eg-1-0-35", da: "Launch a loyalty program for customers."
                   },
                   {
                    id: "eg-1-0-36", da: "Improve website or app performance."
                   },
                   {
                    id: "eg-1-0-37", da: "Implement CRM (Customer Relationship Management) systems."
                   },
                   {
                    id: "eg-1-0-38", da: "Expand into emerging markets."
                   },
                   {
                    id: "eg-1-0-39", da: "Monitor and adapt to regulatory changes."
                   },
                   {
                    id: "eg-1-0-40", da: "Enhance your mobile strategy."
                   },
                   {
                    id: "eg-1-0-41", da: "Create a competitive analysis framework."
                   },
                   {
                    id: "eg-1-0-42", da: "Develop a disaster recovery plan."
                   },
                   {
                    id: "eg-1-0-43", da: "Implement a continuous improvement mindset."
                   },
                   {
                    id: "eg-1-0-44", da: "Increase market segmentation."
                   },
                   {
                    id: "eg-1-0-45", da: "Optimize customer onboarding processes."
                   },
                   {
                    id: "eg-1-0-46", da: "Monitor and adjust key performance indicators."
                   },
                   {
                    id: "eg-1-0-47", da: "Create a knowledge-sharing culture."
                   },
                   {
                    id: "eg-1-0-48", da: "Invest in diversity and inclusion initiatives."
                   },
                   {
                    id: "eg-1-0-49", da: "Establish key performance measurement metrics."
                   },
                ]
              },
              {
                id: 'eg-1-1',
                pm: 'Mapping the consulting packages to clear market targets with a quantification of market need being solved.',
                title:'Market',
                pmMap: 'Mapping the consulting packages to clear market targets with a quantification of market need being solved.',
                developmentActions:[
                  {
                    id: "eg-1-1-0", da: "Conduct market research to identify emerging trends."
                   },
                   {
                    id: "eg-1-1-1", da: "Expand product offerings to meet new market demands."
                   },
                   {
                    id: "eg-1-1-2", da: "Implement targeted marketing campaigns."
                   },
                   {
                    id: "eg-1-1-3", da: "Enhance the customer onboarding process."
                   },
                   {
                    id: "eg-1-1-4", da: "Develop partnerships with complementary businesses."
                   },
                   {
                    id: "eg-1-1-5", da: "Launch a referral program to attract new customers."
                   },
                   {
                    id: "eg-1-1-6", da: "Optimize your website for search engines."
                   },
                   {
                    id: "eg-1-1-7", da: "Improve user experience on your website."
                   },
                   {
                    id: "eg-1-1-8", da: "Enhance your social media presence."
                   },
                   {
                    id: "eg-1-1-9", da: "Create valuable content to engage your audience."
                   },
                   {
                    id: "eg-1-1-10", da: "Offer webinars and online workshops."
                   },
                   {
                    id: "eg-1-1-11", da: "Participate in industry events and conferences."
                   },
                   {
                    id: "eg-1-1-12", da: "Expand your reach through email marketing."
                   },
                   {
                    id: "eg-1-1-13", da: "Develop a mobile app for your services."
                   },
                   {
                    id: "eg-1-1-14", da: "Improve your customer support processes."
                   },
                   {
                    id: "eg-1-1-15", da: "Collect and analyze customer feedback."
                   },
                   {
                    id: "eg-1-1-16", da: "Offer loyalty programs and incentives."
                   },
                   {
                    id: "eg-1-1-17", da: "Implement data analytics to make informed decisions."
                   },
                   {
                    id: "eg-1-1-18", da: "Leverage social proof through customer reviews."
                   },
                   {
                    id: "eg-1-1-19", da: "Invest in paid advertising campaigns."
                   },
                   {
                    id: "eg-1-1-20", da: "Explore new markets and demographics."
                   },
                   {
                    id: "eg-1-1-21", da: "Foster relationships with industry influencers."
                   },
                   {
                    id: "eg-1-1-22", da: "Streamline your sales funnel for efficiency."
                   },
                   {
                    id: "eg-1-1-23", da: "Develop case studies to showcase success stories."
                   },
                   {
                    id: "eg-1-1-24", da: "Create a comprehensive marketing plan."
                   },
                   {
                    id: "eg-1-1-25", da: "Offer promotions or discounts."
                   },
                   {
                    id: "eg-1-1-26", da: "Engage in community Tracking Open calls and sponsorships."
                   },
                   {
                    id: "eg-1-1-27", da: "Conduct competitor analysis."
                   },
                   {
                    id: "eg-1-1-28", da: "Network with potential clients and partners."
                   },
                   {
                    id: "eg-1-1-29", da: "Optimize your pricing strategy."
                   },
                   {
                    id: "eg-1-1-30", da: "Provide outstanding customer service."
                   },
                   {
                    id: "eg-1-1-31", da: "Adapt to changes in consumer behavior."
                   },
                   {
                    id: "eg-1-1-32", da: "Explore international expansion."
                   },
                   {
                    id: "eg-1-1-33", da: "Conduct A\/B testing for marketing efforts."
                   },
                   {
                    id: "eg-1-1-34", da: "Develop a content calendar for consistency."
                   },
                   {
                    id: "eg-1-1-35", da: "Invest in employee training and development."
                   },
                   {
                    id: "eg-1-1-36", da: "Develop a crisis management plan."
                   },
                   {
                    id: "eg-1-1-37", da: "Incorporate sustainability into your business practices."
                   },
                   {
                    id: "eg-1-1-38", da: "Collaborate with industry associations."
                   },
                   {
                    id: "eg-1-1-39", da: "Stay updated on industry regulations."
                   },
                   {
                    id: "eg-1-1-40", da: "Implement automation for repetitive tasks."
                   },
                   {
                    id: "eg-1-1-41", da: "Strengthen cybersecurity measures."
                   },
                   {
                    id: "eg-1-1-42", da: "Enhance supply chain management."
                   },
                   {
                    id: "eg-1-1-43", da: "Monitor and respond to online reputation."
                   },
                   {
                    id: "eg-1-1-44", da: "Optimize product packaging and branding."
                   },
                   {
                    id: "eg-1-1-45", da: "Explore e-commerce and online sales."
                   },
                   {
                    id: "eg-1-1-46", da: "Develop a feedback loop for improvement."
                   },
                   {
                    id: "eg-1-1-47", da: "Conduct regular SWOT analyses."
                   },
                   {
                    id: "eg-1-1-48", da: "Invest in market research tools and software."
                   },
                   {
                    id: "eg-1-1-49", da: "Continuously adapt to changing market dynamics."
                   },
                ]
              },
              {
                id: 'eg-1-2',
                pm: 'Partnerships to offer tooling consultancy is also a possibility.',
                title:'Technology',
                pmMap: 'Partnerships to offer tooling consultancy is also a possibility.',
                developmentActions:[
                  {
                    id: "eg-1-2-0", da: "Develop a technology-focused innovation center."
                   },
                   {
                    id: "eg-1-2-1", da: "Foster a culture of continuous learning and technology adoption."
                   },
                   {
                    id: "eg-1-2-2", da: "Establish a dedicated technology fund to support startups."
                   },
                   {
                    id: "eg-1-2-3", da: "Enhance infrastructure for high-speed internet access."
                   },
                   {
                    id: "eg-1-2-4", da: "Implement a digital inclusion program for underserved communities."
                   },
                   {
                    id: "eg-1-2-5", da: "Create partnerships with tech companies for knowledge sharing."
                   },
                   {
                    id: "eg-1-2-6", da: "Develop a smart city initiative."
                   },
                   {
                    id: "eg-1-2-7", da: "Promote open data and data sharing policies."
                   },
                   {
                    id: "eg-1-2-8", da: "Support tech-driven educational programs."
                   },
                   {
                    id: "eg-1-2-9", da: "Invest in 5G infrastructure."
                   },
                   {
                    id: "eg-1-2-10", da: "Develop cybersecurity awareness and training programs."
                   },
                   {
                    id: "eg-1-2-11", da: "Establish a tech park or tech hub."
                   },
                   {
                    id: "eg-1-2-12", da: "Promote the use of renewable energy in tech facilities."
                   },
                   {
                    id: "eg-1-2-13", da: "Encourage technology transfer from universities to industry."
                   },
                   {
                    id: "eg-1-2-14", da: "Develop an AI and machine learning strategy."
                   },
                   {
                    id: "eg-1-2-15", da: "Promote tech-focused events, conferences, and meetups."
                   },
                   {
                    id: "eg-1-2-16", da: "Create a blockchain technology sandbox."
                   },
                   {
                    id: "eg-1-2-17", da: "Invest in drone technology for various applications."
                   },
                   {
                    id: "eg-1-2-18", da: "Develop a technology apprenticeship program."
                   },
                   {
                    id: "eg-1-2-19", da: "Promote e-government services."
                   },
                   {
                    id: "eg-1-2-20", da: "Establish a digital health initiative."
                   },
                   {
                    id: "eg-1-2-21", da: "Create technology-focused incubators."
                   },
                   {
                    id: "eg-1-2-22", da: "Develop a regional technology cluster."
                   },
                   {
                    id: "eg-1-2-23", da: "Invest in advanced manufacturing technology."
                   },
                   {
                    id: "eg-1-2-24", da: "Encourage the use of IoT in various industries."
                   },
                   {
                    id: "eg-1-2-25", da: "Implement a tech-driven public transportation system."
                   },
                   {
                    id: "eg-1-2-26", da: "Promote tech-enabled agriculture and farming practices."
                   },
                   {
                    id: "eg-1-2-27", da: "Invest in space technology and satellite programs."
                   },
                   {
                    id: "eg-1-2-28", da: "Develop a regional coding academy."
                   },
                   {
                    id: "eg-1-2-29", da: "Encourage the use of virtual reality and augmented reality."
                   },
                   {
                    id: "eg-1-2-30", da: "Promote green technology and sustainability practices."
                   },
                   {
                    id: "eg-1-2-31", da: "Invest in tech infrastructure for remote work."
                   },
                   {
                    id: "eg-1-2-32", da: "Develop a regional tech startup accelerator."
                   },
                   {
                    id: "eg-1-2-33", da: "Encourage tech solutions for clean water and sanitation."
                   },
                   {
                    id: "eg-1-2-34", da: "Promote technology for disaster preparedness and response."
                   },
                   {
                    id: "eg-1-2-35", da: "Invest in autonomous vehicle technology."
                   },
                   {
                    id: "eg-1-2-36", da: "Develop a tech workforce development program."
                   },
                   {
                    id: "eg-1-2-37", da: "Promote the use of AI in healthcare and diagnostics."
                   },
                   {
                    id: "eg-1-2-38", da: "Establish technology standards and best practices."
                   },
                   {
                    id: "eg-1-2-39", da: "Invest in biotechnology and life sciences research."
                   },
                   {
                    id: "eg-1-2-40", da: "Develop a digital currency or cryptocurrency initiative."
                   },
                   {
                    id: "eg-1-2-41", da: "Promote technology for waste management and recycling."
                   },
                   {
                    id: "eg-1-2-42", da: "Invest in advanced robotics and automation."
                   },
                   {
                    id: "eg-1-2-43", da: "Develop a technology roadmap for the ecosystem."
                   },
                   {
                    id: "eg-1-2-44", da: "Encourage technology solutions for elder care."
                   },
                   {
                    id: "eg-1-2-45", da: "Promote tech solutions for environmental monitoring."
                   },
                   {
                    id: "eg-1-2-46", da: "Invest in quantum computing research."
                   },
                   {
                    id: "eg-1-2-47", da: "Develop a technology for social impact program."
                   },
                   {
                    id: "eg-1-2-48", da: "Encourage tech innovation in tourism and hospitality."
                   },
                   {
                    id: "eg-1-2-49", da: "Invest in technology for improving transportation infrastructure."
                   },
                ]
              },
              {
                id: 'eg-1-3',
                pm: 'Stakeholders are able to indepandantly take up consulting engagements using the documented value framework.',
                title:'Value',
                pmMap: 'Stakeholders are able to indepandantly take up consulting engagements using the documented value framework.',
                developmentActions:[
                  {
                    id: "eg-1-3-0", da: "Identify and nurture emerging markets."
                   },
                   {
                    id: "eg-1-3-1", da: "Enhance customer engagement strategies."
                   },
                   {
                    id: "eg-1-3-2", da: "Implement user-friendly interfaces and experiences."
                   },
                   {
                    id: "eg-1-3-3", da: "Foster innovation through hackathons and ideation sessions."
                   },
                   {
                    id: "eg-1-3-4", da: "Improve product scalability."
                   },
                   {
                    id: "eg-1-3-5", da: "Optimize data analytics and insights."
                   },
                   {
                    id: "eg-1-3-6", da: "Streamline project management processes."
                   },
                   {
                    id: "eg-1-3-7", da: "Enhance regulatory compliance."
                   },
                   {
                    id: "eg-1-3-8", da: "Expand digital marketing efforts."
                   },
                   {
                    id: "eg-1-3-9", da: "Strengthen cybersecurity measures."
                   },
                   {
                    id: "eg-1-3-10", da: "Develop mobile applications for wider reach."
                   },
                   {
                    id: "eg-1-3-11", da: "Optimize supply chain management."
                   },
                   {
                    id: "eg-1-3-12", da: "Implement sustainability initiatives."
                   },
                   {
                    id: "eg-1-3-13", da: "Improve customer support and service."
                   },
                   {
                    id: "eg-1-3-14", da: "Foster strategic partnerships."
                   },
                   {
                    id: "eg-1-3-15", da: "Enhance content marketing strategies."
                   },
                   {
                    id: "eg-1-3-16", da: "Develop AI and machine learning capabilities."
                   },
                   {
                    id: "eg-1-3-17", da: "Implement blockchain technology for transparency."
                   },
                   {
                    id: "eg-1-3-18", da: "Enhance accessibility features for inclusivity."
                   },
                   {
                    id: "eg-1-3-19", da: "Optimize cloud infrastructure and services."
                   },
                   {
                    id: "eg-1-3-20", da: "Improve data governance and privacy."
                   },
                   {
                    id: "eg-1-3-21", da: "Foster employee training and development."
                   },
                   {
                    id: "eg-1-3-22", da: "Expand into international markets."
                   },
                   {
                    id: "eg-1-3-23", da: "Develop a social responsibility program."
                   },
                   {
                    id: "eg-1-3-24", da: "Enhance product personalization."
                   },
                   {
                    id: "eg-1-3-25", da: "Implement chatbots and virtual assistants."
                   },
                   {
                    id: "eg-1-3-26", da: "Optimize website performance and speed."
                   },
                   {
                    id: "eg-1-3-27", da: "Enhance customer feedback mechanisms."
                   },
                   {
                    id: "eg-1-3-28", da: "Strengthen crisis management protocols."
                   },
                   {
                    id: "eg-1-3-29", da: "Invest in renewable energy solutions."
                   },
                   {
                    id: "eg-1-3-30", da: "Develop predictive maintenance capabilities."
                   },
                   {
                    id: "eg-1-3-31", da: "Improve data warehousing and storage."
                   },
                   {
                    id: "eg-1-3-32", da: "Enhance customer loyalty programs."
                   },
                   {
                    id: "eg-1-3-33", da: "Implement a circular economy model."
                   },
                   {
                    id: "eg-1-3-34", da: "Strengthen market research capabilities."
                   },
                   {
                    id: "eg-1-3-35", da: "Optimize logistics and delivery processes."
                   },
                   {
                    id: "eg-1-3-36", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "eg-1-3-37", da: "Improve remote work and collaboration tools."
                   },
                   {
                    id: "eg-1-3-38", da: "Develop sustainable packaging solutions."
                   },
                   {
                    id: "eg-1-3-39", da: "Optimize inventory management."
                   },
                   {
                    id: "eg-1-3-40", da: "Enhance community engagement initiatives."
                   },
                   {
                    id: "eg-1-3-41", da: "Implement agile development methodologies."
                   },
                   {
                    id: "eg-1-3-42", da: "Improve product quality control."
                   },
                   {
                    id: "eg-1-3-43", da: "Foster social media advertising strategies."
                   },
                   {
                    id: "eg-1-3-44", da: "Develop data-driven decision-making."
                   },
                   {
                    id: "eg-1-3-45", da: "Optimize product lifecycle management."
                   },
                   {
                    id: "eg-1-3-46", da: "Strengthen corporate social responsibility."
                   },
                   {
                    id: "eg-1-3-47", da: "Implement energy-efficient practices."
                   },
                   {
                    id: "eg-1-3-48", da: "Improve customer data management."
                   },
                   {
                    id: "eg-1-3-49", da: "Foster ecosystem partnerships for mutual growth."
                   },
                ]
              },
              {
                id: 'eg-1-4',
                pm: 'Business model is validated based on strong unit economics.',
                title:'Business Model',
                pmMap: 'Business model is validated based on strong unit economics.',
                developmentActions:[
                  {
                    id: "eg-1-4-0", da: "Identify target customer segments."
                   },
                   {
                    id: "eg-1-4-1", da: "Understand customer needs and pain points."
                   },
                   {
                    id: "eg-1-4-2", da: "Analyze market trends and dynamics."
                   },
                   {
                    id: "eg-1-4-3", da: "Assess competitive landscape."
                   },
                   {
                    id: "eg-1-4-4", da: "Evaluate pricing strategy."
                   },
                   {
                    id: "eg-1-4-5", da: "Investigate revenue streams."
                   },
                   {
                    id: "eg-1-4-6", da: "Define value proposition."
                   },
                   {
                    id: "eg-1-4-7", da: "Develop a unique selling proposition (USP)."
                   },
                   {
                    id: "eg-1-4-8", da: "Explore new distribution channels."
                   },
                   {
                    id: "eg-1-4-9", da: "Optimize the sales process."
                   },
                   {
                    id: "eg-1-4-10", da: "Enhance customer acquisition strategies."
                   },
                   {
                    id: "eg-1-4-11", da: "Improve customer retention strategies."
                   },
                   {
                    id: "eg-1-4-12", da: "Consider product bundling opportunities."
                   },
                   {
                    id: "eg-1-4-13", da: "Explore strategic partnerships."
                   },
                   {
                    id: "eg-1-4-14", da: "Assess the cost structure."
                   },
                   {
                    id: "eg-1-4-15", da: "Optimize operational efficiency."
                   },
                   {
                    id: "eg-1-4-16", da: "Implement cost-saving measures."
                   },
                   {
                    id: "eg-1-4-17", da: "Evaluate the scalability of the business."
                   },
                   {
                    id: "eg-1-4-18", da: "Assess technology infrastructure."
                   },
                   {
                    id: "eg-1-4-19", da: "Explore new technology adoption."
                   },
                   {
                    id: "eg-1-4-20", da: "Investigate outsourcing options."
                   },
                   {
                    id: "eg-1-4-21", da: "Analyze data analytics capabilities."
                   },
                   {
                    id: "eg-1-4-22", da: "Enhance decision-making with data."
                   },
                   {
                    id: "eg-1-4-23", da: "Develop a risk management strategy."
                   },
                   {
                    id: "eg-1-4-24", da: "Evaluate the regulatory environment."
                   },
                   {
                    id: "eg-1-4-25", da: "Consider international expansion."
                   },
                   {
                    id: "eg-1-4-26", da: "Assess supply chain optimization."
                   },
                   {
                    id: "eg-1-4-27", da: "Implement sustainability initiatives."
                   },
                   {
                    id: "eg-1-4-28", da: "Explore diversification opportunities."
                   },
                   {
                    id: "eg-1-4-29", da: "Optimize branding and marketing."
                   },
                   {
                    id: "eg-1-4-30", da: "Enhance online presence."
                   },
                   {
                    id: "eg-1-4-31", da: "Investigate content marketing."
                   },
                   {
                    id: "eg-1-4-32", da: "Assess customer feedback and surveys."
                   },
                   {
                    id: "eg-1-4-33", da: "Develop a customer-centric approach."
                   },
                   {
                    id: "eg-1-4-34", da: "Explore social responsibility initiatives."
                   },
                   {
                    id: "eg-1-4-35", da: "Evaluate legal and compliance issues."
                   },
                   {
                    id: "eg-1-4-36", da: "Consider agile business practices."
                   },
                   {
                    id: "eg-1-4-37", da: "Optimize talent recruitment and retention."
                   },
                   {
                    id: "eg-1-4-38", da: "Assess leadership and management."
                   },
                   {
                    id: "eg-1-4-39", da: "Explore employee training and development."
                   },
                   {
                    id: "eg-1-4-40", da: "Enhance workplace culture."
                   },
                   {
                    id: "eg-1-4-41", da: "Investigate intellectual property protection."
                   },
                   {
                    id: "eg-1-4-42", da: "Assess the financial health of the business."
                   },
                   {
                    id: "eg-1-4-43", da: "Consider capital-raising options."
                   },
                   {
                    id: "eg-1-4-44", da: "Optimize financial forecasting."
                   },
                   {
                    id: "eg-1-4-45", da: "Explore exit strategy possibilities."
                   },
                   {
                    id: "eg-1-4-46", da: "Assess customer lifetime value (CLV)."
                   },
                   {
                    id: "eg-1-4-47", da: "Evaluate innovation and R&D."
                   },
                   {
                    id: "eg-1-4-48", da: "Consider diversifying product offerings."
                   },
                   {
                    id: "eg-1-4-49", da: "Continuously adapt to changing market conditions."
                   },
                ]
              },
              {
                id: 'eg-1-5',
                pm: 'Consultants have clearity how category creation can help them reach market dominance.',
                title:'Go to Market',
                pmMap: 'Consultants have clearity how category creation can help them reach market dominance.',
                developmentActions:[
                  {
                    id: "eg-1-5-0", da: "Conduct market research to identify untapped market segments."
                   },
                   {
                    id: "eg-1-5-1", da: "Develop a comprehensive market entry strategy."
                   },
                   {
                    id: "eg-1-5-2", da: "Enhance product positioning to address specific market needs."
                   },
                   {
                    id: "eg-1-5-3", da: "Identify key value propositions for target customer segments."
                   },
                   {
                    id: "eg-1-5-4", da: "Create buyer personas to better understand customer behavior."
                   },
                   {
                    id: "eg-1-5-5", da: "Refine pricing strategies based on market dynamics."
                   },
                   {
                    id: "eg-1-5-6", da: "Develop a content marketing plan to educate the market."
                   },
                   {
                    id: "eg-1-5-7", da: "Expand the product\/service portfolio to cater to a broader audience."
                   },
                   {
                    id: "eg-1-5-8", da: "Improve lead generation and qualification processes."
                   },
                   {
                    id: "eg-1-5-9", da: "Strengthen the sales team with additional training and resources."
                   },
                   {
                    id: "eg-1-5-10", da: "Create sales collateral and presentation materials."
                   },
                   {
                    id: "eg-1-5-11", da: "Implement a customer relationship management (CRM) system."
                   },
                   {
                    id: "eg-1-5-12", da: "Develop partnerships and alliances for mutual growth."
                   },
                   {
                    id: "eg-1-5-13", da: "Explore international expansion opportunities."
                   },
                   {
                    id: "eg-1-5-14", da: "Optimize distribution channels and logistics."
                   },
                   {
                    id: "eg-1-5-15", da: "Enhance customer support and post-sales services."
                   },
                   {
                    id: "eg-1-5-16", da: "Implement a referral program to incentivize customers."
                   },
                   {
                    id: "eg-1-5-17", da: "Build a community around the product\/service."
                   },
                   {
                    id: "eg-1-5-18", da: "Foster customer advocacy and reviews."
                   },
                   {
                    id: "eg-1-5-19", da: "Invest in advertising and paid promotion."
                   },
                   {
                    id: "eg-1-5-20", da: "Improve search engine optimization (SEO) efforts."
                   },
                   {
                    id: "eg-1-5-21", da: "Increase social media presence and engagement."
                   },
                   {
                    id: "eg-1-5-22", da: "Run targeted email marketing campaigns."
                   },
                   {
                    id: "eg-1-5-23", da: "Implement a data-driven approach to decision-making."
                   },
                   {
                    id: "eg-1-5-24", da: "Monitor and analyze key performance indicators (KPIs)."
                   },
                   {
                    id: "eg-1-5-25", da: "Develop a crisis management plan for unforeseen challenges."
                   },
                   {
                    id: "eg-1-5-26", da: "Gather competitive intelligence and adjust strategies accordingly."
                   },
                   {
                    id: "eg-1-5-27", da: "Create a loyalty program to retain existing customers."
                   },
                   {
                    id: "eg-1-5-28", da: "Expand market reach through trade shows and events."
                   },
                   {
                    id: "eg-1-5-29", da: "Invest in market-specific research and development."
                   },
                   {
                    id: "eg-1-5-30", da: "Foster innovation through open innovation partnerships."
                   },
                   {
                    id: "eg-1-5-31", da: "Conduct regular SWOT analysis to refine strategies."
                   },
                   {
                    id: "eg-1-5-32", da: "Develop thought leadership in the industry."
                   },
                   {
                    id: "eg-1-5-33", da: "Collaborate with influencers for endorsements."
                   },
                   {
                    id: "eg-1-5-34", da: "Personalize marketing and sales approaches."
                   },
                   {
                    id: "eg-1-5-35", da: "Improve the customer onboarding process."
                   },
                   {
                    id: "eg-1-5-36", da: "Enhance the product's user experience (UX)."
                   },
                   {
                    id: "eg-1-5-37", da: "Create case studies and success stories to showcase value."
                   },
                   {
                    id: "eg-1-5-38", da: "Test and iterate on marketing channels and messages."
                   },
                   {
                    id: "eg-1-5-39", da: "Develop a clear, compelling brand narrative."
                   },
                   {
                    id: "eg-1-5-40", da: "Monitor and respond to industry trends and disruptors."
                   },
                   {
                    id: "eg-1-5-41", da: "Launch a customer feedback program."
                   },
                   {
                    id: "eg-1-5-42", da: "Streamline and automate internal processes."
                   },
                   {
                    id: "eg-1-5-43", da: "Implement data analytics to gain insights."
                   },
                   {
                    id: "eg-1-5-44", da: "Build a scalable technology infrastructure."
                   },
                   {
                    id: "eg-1-5-45", da: "Develop a scalable customer support model."
                   },
                   {
                    id: "eg-1-5-46", da: "Monitor and adjust pricing strategies."
                   },
                   {
                    id: "eg-1-5-47", da: "Optimize inventory management and supply chain."
                   },
                   {
                    id: "eg-1-5-48", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "eg-1-5-49", da: "Develop a disaster recovery and business continuity plan."
                   },
                ]
              },
              {
                id: 'eg-1-6',
                pm: 'Consultants are hired from outside or within the community on a regular committed operation, skilling others and projecting leadership.',
                title:'People',
                pmMap: 'Consultants are hired from outside or within the community on a regular committed operation, skilling others and projecting leadership.',
                developmentActions:[
                  {
                    id: "eg-1-6-0", da: "Identify key stakeholders within the ecosystem."
                   },
                   {
                    id: "eg-1-6-1", da: "Foster a culture of collaboration and knowledge sharing."
                   },
                   {
                    id: "eg-1-6-2", da: "Encourage diversity and inclusion in the ecosystem."
                   },
                   {
                    id: "eg-1-6-3", da: "Provide training and development opportunities for ecosystem participants."
                   },
                   {
                    id: "eg-1-6-4", da: "Establish mentorship programs to support newcomers."
                   },
                   {
                    id: "eg-1-6-5", da: "Create networking events to facilitate connections."
                   },
                   {
                    id: "eg-1-6-6", da: "Recognize and reward ecosystem contributions."
                   },
                   {
                    id: "eg-1-6-7", da: "Conduct regular feedback sessions with ecosystem members."
                   },
                   {
                    id: "eg-1-6-8", da: "Promote ethical and responsible behavior within the ecosystem."
                   },
                   {
                    id: "eg-1-6-9", da: "Develop educational resources for ecosystem participants."
                   },
                   {
                    id: "eg-1-6-10", da: "Offer leadership and management training."
                   },
                   {
                    id: "eg-1-6-11", da: "Implement effective onboarding processes for new members."
                   },
                   {
                    id: "eg-1-6-12", da: "Establish clear roles and responsibilities for ecosystem participants."
                   },
                   {
                    id: "eg-1-6-13", da: "Encourage ecosystem participants to take on leadership roles."
                   },
                   {
                    id: "eg-1-6-14", da: "Provide resources for mental health and well-being."
                   },
                   {
                    id: "eg-1-6-15", da: "Conduct team-building exercises."
                   },
                   {
                    id: "eg-1-6-16", da: "Foster a sense of belonging and community."
                   },
                   {
                    id: "eg-1-6-17", da: "Set up cross-functional teams to address ecosystem challenges."
                   },
                   {
                    id: "eg-1-6-18", da: "Create opportunities for public speaking and presentations."
                   },
                   {
                    id: "eg-1-6-19", da: "Develop an ecosystem-wide code of conduct."
                   },
                   {
                    id: "eg-1-6-20", da: "Promote the value of lifelong learning."
                   },
                   {
                    id: "eg-1-6-21", da: "Offer support for career growth and advancement."
                   },
                   {
                    id: "eg-1-6-22", da: "Encourage the development of soft skills, such as communication and teamwork."
                   },
                   {
                    id: "eg-1-6-23", da: "Provide access to industry experts and advisors."
                   },
                   {
                    id: "eg-1-6-24", da: "Support continuous improvement and innovation."
                   },
                   {
                    id: "eg-1-6-25", da: "Facilitate access to funding and resources."
                   },
                   {
                    id: "eg-1-6-26", da: "Develop a knowledge base or documentation."
                   },
                   {
                    id: "eg-1-6-27", da: "Encourage members to attend industry conferences and events."
                   },
                   {
                    id: "eg-1-6-28", da: "Promote responsible use of resources within the ecosystem."
                   },
                   {
                    id: "eg-1-6-29", da: "Provide access to market research and data analysis."
                   },
                   {
                    id: "eg-1-6-30", da: "Facilitate partnerships and collaborations."
                   },
                   {
                    id: "eg-1-6-31", da: "Offer legal and regulatory guidance."
                   },
                   {
                    id: "eg-1-6-32", da: "Promote an entrepreneurial mindset."
                   },
                   {
                    id: "eg-1-6-33", da: "Encourage ecosystem participants to be environmentally conscious."
                   },
                   {
                    id: "eg-1-6-34", da: "Create opportunities for volunteering and community engagement."
                   },
                   {
                    id: "eg-1-6-35", da: "Establish feedback loops to assess the impact of development actions."
                   },
                   {
                    id: "eg-1-6-36", da: "Support the development of leadership skills."
                   },
                   {
                    id: "eg-1-6-37", da: "Promote ethical decision-making and responsible innovation."
                   },
                   {
                    id: "eg-1-6-38", da: "Encourage ecosystem participants to pursue higher education."
                   },
                   {
                    id: "eg-1-6-39", da: "Develop a shared vision and mission for the ecosystem."
                   },
                   {
                    id: "eg-1-6-40", da: "Foster a sense of ownership and pride in the ecosystem."
                   },
                   {
                    id: "eg-1-6-41", da: "Provide access to digital tools and technology."
                   },
                   {
                    id: "eg-1-6-42", da: "Promote financial literacy and investment skills."
                   },
                   {
                    id: "eg-1-6-43", da: "Encourage ecosystem participants to become thought leaders."
                   },
                   {
                    id: "eg-1-6-44", da: "Facilitate access to legal and intellectual property expertise."
                   },
                   {
                    id: "eg-1-6-45", da: "Promote the use of data-driven decision-making."
                   },
                   {
                    id: "eg-1-6-46", da: "Develop case studies and success stories."
                   },
                   {
                    id: "eg-1-6-47", da: "Support ecosystem participants in building personal brands."
                   },
                   {
                    id: "eg-1-6-48", da: "Create opportunities for skill-building workshops."
                   },
                   {
                    id: "eg-1-6-49", da: "Establish a feedback mechanism for continuous improvement."
                   },
                ]
              },
              {
                id: 'eg-1-7',
                pm: 'Part time consultants and mentors are dedicating their time. Board is setup if and as needed.',
                title:'Data Metrics',
                pmMap: 'Part time consultants and mentors are dedicating their time. Board is setup if and as needed.',
                developmentActions:[
                  {
                    id: "eg-1-7-0", da: "Define clear data metrics objectives."
                   },
                   {
                    id: "eg-1-7-1", da: "Establish key performance indicators (KPIs)."
                   },
                   {
                    id: "eg-1-7-2", da: "Develop a data governance framework."
                   },
                   {
                    id: "eg-1-7-3", da: "Implement a robust data collection strategy."
                   },
                   {
                    id: "eg-1-7-4", da: "Ensure data accuracy and consistency."
                   },
                   {
                    id: "eg-1-7-5", da: "Conduct a data audit."
                   },
                   {
                    id: "eg-1-7-6", da: "Enhance data quality through Crossing the Chasm."
                   },
                   {
                    id: "eg-1-7-7", da: "Standardize data formats and structures."
                   },
                   {
                    id: "eg-1-7-8", da: "Implement data profiling and cleansing."
                   },
                   {
                    id: "eg-1-7-9", da: "Create a centralized data repository."
                   },
                   {
                    id: "eg-1-7-10", da: "Invest in data security measures."
                   },
                   {
                    id: "eg-1-7-11", da: "Train employees on data handling."
                   },
                   {
                    id: "eg-1-7-12", da: "Promote data ownership within teams."
                   },
                   {
                    id: "eg-1-7-13", da: "Foster a data-driven culture."
                   },
                   {
                    id: "eg-1-7-14", da: "Implement data encryption."
                   },
                   {
                    id: "eg-1-7-15", da: "Monitor data access and usage."
                   },
                   {
                    id: "eg-1-7-16", da: "Develop data archiving policies."
                   },
                   {
                    id: "eg-1-7-17", da: "Use data anonymization techniques."
                   },
                   {
                    id: "eg-1-7-18", da: "Establish data retention policies."
                   },
                   {
                    id: "eg-1-7-19", da: "Enhance data backup and recovery procedures."
                   },
                   {
                    id: "eg-1-7-20", da: "Conduct regular data compliance checks."
                   },
                   {
                    id: "eg-1-7-21", da: "Improve data extraction methods."
                   },
                   {
                    id: "eg-1-7-22", da: "Automate data collection processes."
                   },
                   {
                    id: "eg-1-7-23", da: "Enhance data integration capabilities."
                   },
                   {
                    id: "eg-1-7-24", da: "Implement master data management."
                   },
                   {
                    id: "eg-1-7-25", da: "Utilize data visualization tools."
                   },
                   {
                    id: "eg-1-7-26", da: "Employ machine learning for data analysis."
                   },
                   {
                    id: "eg-1-7-27", da: "Create interactive dashboards."
                   },
                   {
                    id: "eg-1-7-28", da: "Utilize real-time data analytics."
                   },
                   {
                    id: "eg-1-7-29", da: "Enhance data reporting capabilities."
                   },
                   {
                    id: "eg-1-7-30", da: "Implement predictive analytics."
                   },
                   {
                    id: "eg-1-7-31", da: "Employ data segmentation for insights."
                   },
                   {
                    id: "eg-1-7-32", da: "Conduct A\/B testing for data-driven decisions."
                   },
                   {
                    id: "eg-1-7-33", da: "Develop customer personas from data."
                   },
                   {
                    id: "eg-1-7-34", da: "Analyze user behavior data."
                   },
                   {
                    id: "eg-1-7-35", da: "Utilize social listening tools."
                   },
                   {
                    id: "eg-1-7-36", da: "Implement sentiment analysis."
                   },
                   {
                    id: "eg-1-7-37", da: "Enhance customer feedback mechanisms."
                   },
                   {
                    id: "eg-1-7-38", da: "Optimize email marketing through data."
                   },
                   {
                    id: "eg-1-7-39", da: "Personalize user experiences based on data."
                   },
                   {
                    id: "eg-1-7-40", da: "Utilize data for product recommendations."
                   },
                   {
                    id: "eg-1-7-41", da: "Conduct competitive intelligence analysis."
                   },
                   {
                    id: "eg-1-7-42", da: "Evaluate market trends using data."
                   },
                   {
                    id: "eg-1-7-43", da: "Enhance demand forecasting models."
                   },
                   {
                    id: "eg-1-7-44", da: "Utilize data for risk management."
                   },
                   {
                    id: "eg-1-7-45", da: "Improve supplier performance using data."
                   },
                   {
                    id: "eg-1-7-46", da: "Monitor production processes with data."
                   },
                   {
                    id: "eg-1-7-47", da: "Utilize data for cost optimization."
                   },
                   {
                    id: "eg-1-7-48", da: "Implement sustainability reporting."
                   },
                   {
                    id: "eg-1-7-49", da: "Continuously evolve data metrics based on insights."
                   },
                ]
              },
              {
                id: 'eg-1-8',
                pm: 'Operations are documented.',
                title:'Operations',
                pmMap: 'Operations are documented.',
                developmentActions:[
                  {
                    id: "eg-1-8-0", da: "Implement lean operations principles."
                   },
                   {
                    id: "eg-1-8-1", da: "Conduct a thorough process audit."
                   },
                   {
                    id: "eg-1-8-2", da: "Streamline workflow processes."
                   },
                   {
                    id: "eg-1-8-3", da: "Automate repetitive tasks."
                   },
                   {
                    id: "eg-1-8-4", da: "Optimize supply chain management."
                   },
                   {
                    id: "eg-1-8-5", da: "Enhance inventory control."
                   },
                   {
                    id: "eg-1-8-6", da: "Improve demand forecasting."
                   },
                   {
                    id: "eg-1-8-7", da: "Reduce production lead times."
                   },
                   {
                    id: "eg-1-8-8", da: "Optimize resource allocation."
                   },
                   {
                    id: "eg-1-8-9", da: "Enhance project management methodologies."
                   },
                   {
                    id: "eg-1-8-10", da: "Implement agile development practices."
                   },
                   {
                    id: "eg-1-8-11", da: "Foster cross-functional collaboration."
                   },
                   {
                    id: "eg-1-8-12", da: "Enhance communication channels."
                   },
                   {
                    id: "eg-1-8-13", da: "Invest in employee training and development."
                   },
                   {
                    id: "eg-1-8-14", da: "Implement quality control measures."
                   },
                   {
                    id: "eg-1-8-15", da: "Reduce waste in operations."
                   },
                   {
                    id: "eg-1-8-16", da: "Optimize equipment maintenance."
                   },
                   {
                    id: "eg-1-8-17", da: "Upgrade technology infrastructure."
                   },
                   {
                    id: "eg-1-8-18", da: "Develop disaster recovery plans."
                   },
                   {
                    id: "eg-1-8-19", da: "Implement energy-efficient practices."
                   },
                   {
                    id: "eg-1-8-20", da: "Enhance workplace safety measures."
                   },
                   {
                    id: "eg-1-8-21", da: "Improve data security protocols."
                   },
                   {
                    id: "eg-1-8-22", da: "Enhance customer relationship management."
                   },
                   {
                    id: "eg-1-8-23", da: "Optimize call center operations."
                   },
                   {
                    id: "eg-1-8-24", da: "Implement feedback loops for continuous improvement."
                   },
                   {
                    id: "eg-1-8-25", da: "Reduce customer response times."
                   },
                   {
                    id: "eg-1-8-26", da: "Enhance order fulfillment processes."
                   },
                   {
                    id: "eg-1-8-27", da: "Optimize packaging and shipping."
                   },
                   {
                    id: "eg-1-8-28", da: "Implement a comprehensive sustainability strategy."
                   },
                   {
                    id: "eg-1-8-29", da: "Reduce operational costs."
                   },
                   {
                    id: "eg-1-8-30", da: "Optimize pricing strategies."
                   },
                   {
                    id: "eg-1-8-31", da: "Implement cost-effective marketing campaigns."
                   },
                   {
                    id: "eg-1-8-32", da: "Improve vendor relationships and negotiations."
                   },
                   {
                    id: "eg-1-8-33", da: "Enhance vendor selection processes."
                   },
                   {
                    id: "eg-1-8-34", da: "Streamline financial reporting."
                   },
                   {
                    id: "eg-1-8-35", da: "Implement financial risk management strategies."
                   },
                   {
                    id: "eg-1-8-36", da: "Optimize credit and collections processes."
                   },
                   {
                    id: "eg-1-8-37", da: "Improve cash flow management."
                   },
                   {
                    id: "eg-1-8-38", da: "Invest in data analytics for operational insights."
                   },
                   {
                    id: "eg-1-8-39", da: "Implement benchmarking against industry standards."
                   },
                   {
                    id: "eg-1-8-40", da: "Enhance compliance and regulatory adherence."
                   },
                   {
                    id: "eg-1-8-41", da: "Improve crisis management and business continuity."
                   },
                   {
                    id: "eg-1-8-42", da: "Optimize facility layout and design."
                   },
                   {
                    id: "eg-1-8-43", da: "Reduce employee turnover and enhance retention."
                   },
                   {
                    id: "eg-1-8-44", da: "Implement performance measurement KPIs."
                   },
                   {
                    id: "eg-1-8-45", da: "Enhance product lifecycle management."
                   },
                   {
                    id: "eg-1-8-46", da: "Optimize warranty and return processes."
                   },
                   {
                    id: "eg-1-8-47", da: "Improve customer onboarding and training."
                   },
                   {
                    id: "eg-1-8-48", da: "Implement effective feedback mechanisms."
                   },
                   {
                    id: "eg-1-8-49", da: "Foster a culture of continuous improvement."
                   },
                ]
              },
              {
                id: 'eg-1-9',
                pm: 'High confidence in potential exit.',
                title:'Exit Strategy',
                pmMap: 'High confidence in potential exit.',
                developmentActions:[
                  {
                    id: "eg-1-9-0", da: "Diversify exit options to include acquisition, IPO, mergers, and strategic partnerships."
                   },
                   {
                    id: "eg-1-9-1", da: "Conduct regular reviews of the exit strategy to adapt to changing market conditions."
                   },
                   {
                    id: "eg-1-9-2", da: "Define clear exit criteria for each startup or project in the ecosystem."
                   },
                   {
                    id: "eg-1-9-3", da: "Assess potential acquirers or investors for alignment with the ecosystem's goals."
                   },
                   {
                    id: "eg-1-9-4", da: "Develop a plan for retaining key talent post-acquisition."
                   },
                   {
                    id: "eg-1-9-5", da: "Consider the timing of the exit in relation to market trends and competition."
                   },
                   {
                    id: "eg-1-9-6", da: "Ensure that intellectual property and patents are protected before exit."
                   },
                   {
                    id: "eg-1-9-7", da: "Assess tax implications and optimize for tax efficiency in the exit."
                   },
                   {
                    id: "eg-1-9-8", da: "Evaluate the impact of the exit on employees, customers, and stakeholders."
                   },
                   {
                    id: "eg-1-9-9", da: "Create a communication plan for announcing the exit to stakeholders."
                   },
                   {
                    id: "eg-1-9-10", da: "Review and optimize the financials for a successful exit."
                   },
                   {
                    id: "eg-1-9-11", da: "Consider earn-outs and performance-based incentives for the exit deal."
                   },
                   {
                    id: "eg-1-9-12", da: "Seek legal counsel to navigate complex regulatory and legal requirements."
                   },
                   {
                    id: "eg-1-9-13", da: "Develop a contingency plan for unexpected delays or obstacles in the exit."
                   },
                   {
                    id: "eg-1-9-14", da: "Evaluate the impact of the exit on the ecosystem's reputation and brand."
                   },
                   {
                    id: "eg-1-9-15", da: "Consider the impact of geopolitical factors on the exit strategy."
                   },
                   {
                    id: "eg-1-9-16", da: "Explore opportunities for international expansion before exit."
                   },
                   {
                    id: "eg-1-9-17", da: "Ensure data privacy and security compliance before the exit."
                   },
                   {
                    id: "eg-1-9-18", da: "Establish an internal team responsible for managing the exit process."
                   },
                   {
                    id: "eg-1-9-19", da: "Assess the ecosystem's readiness for exit in terms of maturity."
                   },
                   {
                    id: "eg-1-9-20", da: "Create a playbook for due diligence during the exit."
                   },
                   {
                    id: "eg-1-9-21", da: "Consider succession planning for leadership post-exit."
                   },
                   {
                    id: "eg-1-9-22", da: "Explore options for reinvesting proceeds from the exit."
                   },
                   {
                    id: "eg-1-9-23", da: "Consider the impact of the exit on the local community and economy."
                   },
                   {
                    id: "eg-1-9-24", da: "Evaluate the potential for post-exit partnerships with the acquiring company."
                   },
                   {
                    id: "eg-1-9-25", da: "Assess the competitive landscape and potential disruptors post-exit."
                   },
                   {
                    id: "eg-1-9-26", da: "Consider the impact of currency exchange rates on international exits."
                   },
                   {
                    id: "eg-1-9-27", da: "Ensure that customer contracts and obligations are considered in the exit."
                   },
                   {
                    id: "eg-1-9-28", da: "Develop a plan for transitioning customer relationships during the exit."
                   },
                   {
                    id: "eg-1-9-29", da: "Explore opportunities for knowledge transfer and IP licensing post-exit."
                   },
                   {
                    id: "eg-1-9-30", da: "Consider regulatory changes that may impact the exit strategy."
                   },
                   {
                    id: "eg-1-9-31", da: "Evaluate the impact of market consolidation on the exit process."
                   },
                   {
                    id: "eg-1-9-32", da: "Assess the impact of macroeconomic factors on the exit."
                   },
                   {
                    id: "eg-1-9-33", da: "Review the ecosystem's product portfolio and patents for the exit."
                   },
                   {
                    id: "eg-1-9-34", da: "Consider the potential for post-exit non-compete agreements."
                   },
                   {
                    id: "eg-1-9-35", da: "Develop a plan for integrating the acquired entities or technologies."
                   },
                   {
                    id: "eg-1-9-36", da: "Evaluate the impact of environmental and sustainability factors on the exit."
                   },
                   {
                    id: "eg-1-9-37", da: "Consider the impact of cybersecurity risks on the exit strategy."
                   },
                   {
                    id: "eg-1-9-38", da: "Assess the impact of global supply chain disruptions on the exit."
                   },
                   {
                    id: "eg-1-9-39", da: "Develop a plan for protecting trade secrets and proprietary information."
                   },
                   {
                    id: "eg-1-9-40", da: "Consider the impact of emerging technologies on the exit strategy."
                   },
                   {
                    id: "eg-1-9-41", da: "Evaluate the impact of political stability on the exit."
                   },
                   {
                    id: "eg-1-9-42", da: "Assess the impact of health and safety regulations on the exit."
                   },
                   {
                    id: "eg-1-9-43", da: "Consider the potential for post-exit consulting and advisory roles."
                   },
                   {
                    id: "eg-1-9-44", da: "Review the ecosystem's partnerships and alliances for the exit."
                   },
                   {
                    id: "eg-1-9-45", da: "Develop a plan for post-exit brand management and marketing."
                   },
                   {
                    id: "eg-1-9-46", da: "Consider the impact of customer data protection laws on the exit."
                   },
                   {
                    id: "eg-1-9-47", da: "Assess the impact of natural disasters and climate change on the exit."
                   },
                   {
                    id: "eg-1-9-48", da: "Consider the potential for post-exit philanthropic initiatives."
                   },
                   {
                    id: "eg-1-9-49", da: "Ensure that the exit strategy aligns with the long-term vision and values of the ecosystem."
                   },
                ]
              }             
            ]
          },
          {
            id: 'eg-2',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Crossing the Chasm',
            wdd: '',
            progressMeasures:[
              {
                id: 'eg-2-0',
                pm: 'Profitable consulting projects are conducted and use-cases are published.',
                title:'Need',
                pmMap: 'Profitable consulting projects are conducted and use-cases are published.',
                developmentActions:[
                  {
                    id: "eg-2-0-0", da: "Conduct market research to identify underserved niches."
                   },
                   {
                    id: "eg-2-0-1", da: "Create a comprehensive marketing strategy."
                   },
                   {
                    id: "eg-2-0-2", da: "Develop clear messaging to target different customer segments."
                   },
                   {
                    id: "eg-2-0-3", da: "Expand marketing efforts to reach new demographics."
                   },
                   {
                    id: "eg-2-0-4", da: "Establish partnerships with complementary businesses."
                   },
                   {
                    id: "eg-2-0-5", da: "Enhance user experience and interface design."
                   },
                   {
                    id: "eg-2-0-6", da: "Provide comprehensive customer support."
                   },
                   {
                    id: "eg-2-0-7", da: "Invest in user onboarding and tutorials."
                   },
                   {
                    id: "eg-2-0-8", da: "Implement referral programs."
                   },
                   {
                    id: "eg-2-0-9", da: "Focus on international expansion."
                   },
                   {
                    id: "eg-2-0-10", da: "Optimize your pricing strategy."
                   },
                   {
                    id: "eg-2-0-11", da: "Improve your product's performance."
                   },
                   {
                    id: "eg-2-0-12", da: "Conduct competitor analysis regularly."
                   },
                   {
                    id: "eg-2-0-13", da: "Enhance data analytics capabilities."
                   },
                   {
                    id: "eg-2-0-14", da: "Foster a culture of innovation within the organization."
                   },
                   {
                    id: "eg-2-0-15", da: "Continuously monitor and analyze user feedback."
                   },
                   {
                    id: "eg-2-0-16", da: "Increase investments in research and development."
                   },
                   {
                    id: "eg-2-0-17", da: "Create more engaging content and documentation."
                   },
                   {
                    id: "eg-2-0-18", da: "Develop a roadmap for new features and updates."
                   },
                   {
                    id: "eg-2-0-19", da: "Optimize your sales funnel and conversion process."
                   },
                   {
                    id: "eg-2-0-20", da: "Address common customer pain points."
                   },
                   {
                    id: "eg-2-0-21", da: "Increase brand awareness through social media."
                   },
                   {
                    id: "eg-2-0-22", da: "Explore new advertising channels."
                   },
                   {
                    id: "eg-2-0-23", da: "Conduct regular usability testing."
                   },
                   {
                    id: "eg-2-0-24", da: "Implement advanced security measures."
                   },
                   {
                    id: "eg-2-0-25", da: "Expand into emerging markets."
                   },
                   {
                    id: "eg-2-0-26", da: "Strengthen relationships with existing customers."
                   },
                   {
                    id: "eg-2-0-27", da: "Create a feedback loop between development and customer support."
                   },
                   {
                    id: "eg-2-0-28", da: "Optimize your landing pages for better conversion rates."
                   },
                   {
                    id: "eg-2-0-29", da: "Invest in search engine optimization (SEO)."
                   },
                   {
                    id: "eg-2-0-30", da: "Develop a strong online community."
                   },
                   {
                    id: "eg-2-0-31", da: "Provide more flexible pricing options."
                   },
                   {
                    id: "eg-2-0-32", da: "Invest in mobile app development."
                   },
                   {
                    id: "eg-2-0-33", da: "Create case studies and success stories."
                   },
                   {
                    id: "eg-2-0-34", da: "Enhance your product's scalability."
                   },
                   {
                    id: "eg-2-0-35", da: "Improve your content marketing strategy."
                   },
                   {
                    id: "eg-2-0-36", da: "Conduct A\/B testing on your website."
                   },
                   {
                    id: "eg-2-0-37", da: "Explore partnerships with industry influencers."
                   },
                   {
                    id: "eg-2-0-38", da: "Offer educational webinars or workshops."
                   },
                   {
                    id: "eg-2-0-39", da: "Increase customer engagement through email marketing."
                   },
                   {
                    id: "eg-2-0-40", da: "Enhance your customer relationship management (CRM) system."
                   },
                   {
                    id: "eg-2-0-41", da: "Conduct regular product performance assessments."
                   },
                   {
                    id: "eg-2-0-42", da: "Foster a culture of continuous learning."
                   },
                   {
                    id: "eg-2-0-43", da: "Expand customer feedback channels."
                   },
                   {
                    id: "eg-2-0-44", da: "Develop a customer loyalty program."
                   },
                   {
                    id: "eg-2-0-45", da: "Optimize your website for speed and performance."
                   },
                   {
                    id: "eg-2-0-46", da: "Explore emerging technology trends."
                   },
                   {
                    id: "eg-2-0-47", da: "Build a strong employer brand to attract top talent."
                   },
                   {
                    id: "eg-2-0-48", da: "Invest in employee training and development."
                   },
                   {
                    id: "eg-2-0-49", da: "Monitor industry trends and adapt strategies accordingly."
                   },
                ]
              },
              {
                id: 'eg-2-1',
                pm: 'Community is expanding quickly into new markets.',
                title:'Market',
                pmMap: 'Community is expanding quickly into new markets.',
                developmentActions:[
                  {
                    id: "eg-2-1-0", da: "Identify target market segments."
                   },
                   {
                    id: "eg-2-1-1", da: "Conduct market research to understand customer needs."
                   },
                   {
                    id: "eg-2-1-2", da: "Develop a compelling value proposition."
                   },
                   {
                    id: "eg-2-1-3", da: "Create customer personas to guide marketing efforts."
                   },
                   {
                    id: "eg-2-1-4", da: "Define clear marketing objectives."
                   },
                   {
                    id: "eg-2-1-5", da: "Develop a comprehensive marketing plan."
                   },
                   {
                    id: "eg-2-1-6", da: "Leverage digital marketing channels."
                   },
                   {
                    id: "eg-2-1-7", da: "Build a strong online presence."
                   },
                   {
                    id: "eg-2-1-8", da: "Optimize your website for search engines."
                   },
                   {
                    id: "eg-2-1-9", da: "Create high-quality content to engage and educate prospects."
                   },
                   {
                    id: "eg-2-1-10", da: "Invest in social media marketing."
                   },
                   {
                    id: "eg-2-1-11", da: "Run targeted online advertising campaigns."
                   },
                   {
                    id: "eg-2-1-12", da: "Develop email marketing campaigns."
                   },
                   {
                    id: "eg-2-1-13", da: "Use influencer marketing to reach a broader audience."
                   },
                   {
                    id: "eg-2-1-14", da: "Attend industry events and conferences."
                   },
                   {
                    id: "eg-2-1-15", da: "Network with potential partners and customers."
                   },
                   {
                    id: "eg-2-1-16", da: "Create educational webinars or workshops."
                   },
                   {
                    id: "eg-2-1-17", da: "Build partnerships with complementary businesses."
                   },
                   {
                    id: "eg-2-1-18", da: "Provide excellent customer support."
                   },
                   {
                    id: "eg-2-1-19", da: "Collect and act on customer feedback."
                   },
                   {
                    id: "eg-2-1-20", da: "Offer loyalty programs to retain customers."
                   },
                   {
                    id: "eg-2-1-21", da: "Establish a referral program to acquire new customers."
                   },
                   {
                    id: "eg-2-1-22", da: "Monitor and adapt to market trends."
                   },
                   {
                    id: "eg-2-1-23", da: "Implement a competitive pricing strategy."
                   },
                   {
                    id: "eg-2-1-24", da: "Differentiate your product or service."
                   },
                   {
                    id: "eg-2-1-25", da: "Develop a sales funnel to guide prospects through the buying process."
                   },
                   {
                    id: "eg-2-1-26", da: "Train sales teams to improve conversion rates."
                   },
                   {
                    id: "eg-2-1-27", da: "Explore new distribution channels."
                   },
                   {
                    id: "eg-2-1-28", da: "Expand into international markets."
                   },
                   {
                    id: "eg-2-1-29", da: "Develop strategic alliances with other companies."
                   },
                   {
                    id: "eg-2-1-30", da: "Invest in market segmentation and targeting."
                   },
                   {
                    id: "eg-2-1-31", da: "Analyze competitors and identify gaps in the market."
                   },
                   {
                    id: "eg-2-1-32", da: "Launch new product features or versions."
                   },
                   {
                    id: "eg-2-1-33", da: "Optimize your product packaging."
                   },
                   {
                    id: "eg-2-1-34", da: "Create a unique selling proposition (USP)."
                   },
                   {
                    id: "eg-2-1-35", da: "Invest in market research and intelligence."
                   },
                   {
                    id: "eg-2-1-36", da: "Expand customer testimonials and case studies."
                   },
                   {
                    id: "eg-2-1-37", da: "Develop partnerships with influencers."
                   },
                   {
                    id: "eg-2-1-38", da: "Leverage customer data for personalized marketing."
                   },
                   {
                    id: "eg-2-1-39", da: "Implement content marketing to establish thought leadership."
                   },
                   {
                    id: "eg-2-1-40", da: "Continuously test and optimize marketing campaigns."
                   },
                   {
                    id: "eg-2-1-41", da: "Consider market expansion through mergers or acquisitions."
                   },
                   {
                    id: "eg-2-1-42", da: "Collaborate with industry associations."
                   },
                   {
                    id: "eg-2-1-43", da: "Create and distribute press releases."
                   },
                   {
                    id: "eg-2-1-44", da: "Develop a crisis management plan."
                   },
                   {
                    id: "eg-2-1-45", da: "Monitor industry regulations and compliance."
                   },
                   {
                    id: "eg-2-1-46", da: "Build a strong brand identity."
                   },
                   {
                    id: "eg-2-1-47", da: "Offer competitive discounts and promotions."
                   },
                   {
                    id: "eg-2-1-48", da: "Invest in market innovation and R&D."
                   },
                   {
                    id: "eg-2-1-49", da: "Adapt to changes in customer behavior and preferences."
                   },
                ]
              },
              {
                id: 'eg-2-2',
                pm: 'Selected tools are able to solve the community needs completely, or near 100%.',
                title:'Technology',
                pmMap: 'Selected tools are able to solve the community needs completely, or near 100%.',
                developmentActions:[
                  {
                    id: "eg-2-2-0", da: "Conduct a technology audit to identify weaknesses."
                   },
                   {
                    id: "eg-2-2-1", da: "Invest in R&D to stay on the cutting edge."
                   },
                   {
                    id: "eg-2-2-2", da: "Enhance cybersecurity measures to protect data."
                   },
                   {
                    id: "eg-2-2-3", da: "Implement AI and machine learning for data analysis."
                   },
                   {
                    id: "eg-2-2-4", da: "Upgrade hardware infrastructure for scalability."
                   },
                   {
                    id: "eg-2-2-5", da: "Develop a mobile app for broader reach."
                   },
                   {
                    id: "eg-2-2-6", da: "Expand cloud infrastructure to improve accessibility."
                   },
                   {
                    id: "eg-2-2-7", da: "Improve data analytics for better decision-making."
                   },
                   {
                    id: "eg-2-2-8", da: "Automate routine tasks to boost efficiency."
                   },
                   {
                    id: "eg-2-2-9", da: "Foster a culture of continuous learning."
                   },
                   {
                    id: "eg-2-2-10", da: "Invest in IoT for data collection and analysis."
                   },
                   {
                    id: "eg-2-2-11", da: "Enhance network infrastructure for reliability."
                   },
                   {
                    id: "eg-2-2-12", da: "Upgrade software to the latest versions."
                   },
                   {
                    id: "eg-2-2-13", da: "Implement DevOps practices for faster releases."
                   },
                   {
                    id: "eg-2-2-14", da: "Develop a disaster recovery plan."
                   },
                   {
                    id: "eg-2-2-15", da: "Improve website performance for user experience."
                   },
                   {
                    id: "eg-2-2-16", da: "Embrace blockchain for security and transparency."
                   },
                   {
                    id: "eg-2-2-17", da: "Optimize SEO for online visibility."
                   },
                   {
                    id: "eg-2-2-18", da: "Enhance user interface and user experience (UI\/UX)."
                   },
                   {
                    id: "eg-2-2-19", da: "Invest in data encryption technologies."
                   },
                   {
                    id: "eg-2-2-20", da: "Upgrade CRM systems for better customer insights."
                   },
                   {
                    id: "eg-2-2-21", da: "Adopt containerization for efficient deployment."
                   },
                   {
                    id: "eg-2-2-22", da: "Implement data warehouses for analytics."
                   },
                   {
                    id: "eg-2-2-23", da: "Develop APIs for integration with partners."
                   },
                   {
                    id: "eg-2-2-24", da: "Embrace 5G technology for faster connectivity."
                   },
                   {
                    id: "eg-2-2-25", da: "Implement edge computing for real-time processing."
                   },
                   {
                    id: "eg-2-2-26", da: "Improve data backup and recovery systems."
                   },
                   {
                    id: "eg-2-2-27", da: "Develop a technology roadmap."
                   },
                   {
                    id: "eg-2-2-28", da: "Invest in quantum computing research."
                   },
                   {
                    id: "eg-2-2-29", da: "Enhance mobile responsiveness for all devices."
                   },
                   {
                    id: "eg-2-2-30", da: "Optimize website load times for mobile users."
                   },
                   {
                    id: "eg-2-2-31", da: "Invest in data privacy compliance."
                   },
                   {
                    id: "eg-2-2-32", da: "Adopt a microservices architecture."
                   },
                   {
                    id: "eg-2-2-33", da: "Develop a technology innovation lab."
                   },
                   {
                    id: "eg-2-2-34", da: "Explore 3D printing for prototyping."
                   },
                   {
                    id: "eg-2-2-35", da: "Enhance cybersecurity awareness training."
                   },
                   {
                    id: "eg-2-2-36", da: "Implement a bug bounty program."
                   },
                   {
                    id: "eg-2-2-37", da: "Invest in data visualization tools."
                   },
                   {
                    id: "eg-2-2-38", da: "Embrace open-source technologies."
                   },
                   {
                    id: "eg-2-2-39", da: "Improve technology vendor management."
                   },
                   {
                    id: "eg-2-2-40", da: "Upgrade the e-commerce platform."
                   },
                   {
                    id: "eg-2-2-41", da: "Invest in AR and VR technologies."
                   },
                   {
                    id: "eg-2-2-42", da: "Enhance data governance policies."
                   },
                   {
                    id: "eg-2-2-43", da: "Explore renewable energy sources."
                   },
                   {
                    id: "eg-2-2-44", da: "Improve data integration between systems."
                   },
                   {
                    id: "eg-2-2-45", da: "Optimize supply chain technology."
                   },
                   {
                    id: "eg-2-2-46", da: "Develop a technology sandbox for testing."
                   },
                   {
                    id: "eg-2-2-47", da: "Invest in remote collaboration tools."
                   },
                   {
                    id: "eg-2-2-48", da: "Explore potential partnerships with tech companies."
                   },
                   {
                    id: "eg-2-2-49", da: "Establish a technology innovation fund."
                   },
                ]
              },
              {
                id: 'eg-2-3',
                pm: 'Existing members are satisfied with offering and stakeholders collaborations lead to new joint value propositions.',
                title:'Value',
                pmMap: 'Existing members are satisfied with offering and stakeholders collaborations lead to new joint value propositions.',
                developmentActions:[
                  {
                    id: "eg-2-3-0", da: "Enhance user onboarding to make it more intuitive."
                   },
                   {
                    id: "eg-2-3-1", da: "Improve documentation for users and developers."
                   },
                   {
                    id: "eg-2-3-2", da: "Streamline the user interface for better user experience."
                   },
                   {
                    id: "eg-2-3-3", da: "Develop a mobile app to reach a wider audience."
                   },
                   {
                    id: "eg-2-3-4", da: "Implement multi-language support for global users."
                   },
                   {
                    id: "eg-2-3-5", da: "Expand the ecosystem by partnering with complementary platforms."
                   },
                   {
                    id: "eg-2-3-6", da: "Create educational resources for users."
                   },
                   {
                    id: "eg-2-3-7", da: "Launch a developer portal for easier integration."
                   },
                   {
                    id: "eg-2-3-8", da: "Enhance security measures to build trust."
                   },
                   {
                    id: "eg-2-3-9", da: "Optimize the platform for faster load times."
                   },
                   {
                    id: "eg-2-3-10", da: "Conduct user surveys to gather feedback."
                   },
                   {
                    id: "eg-2-3-11", da: "Provide personalized recommendations to users."
                   },
                   {
                    id: "eg-2-3-12", da: "Invest in marketing to reach a larger audience."
                   },
                   {
                    id: "eg-2-3-13", da: "Foster a community around the ecosystem."
                   },
                   {
                    id: "eg-2-3-14", da: "Offer premium features for monetization."
                   },
                   {
                    id: "eg-2-3-15", da: "Collaborate with influencers to increase awareness."
                   },
                   {
                    id: "eg-2-3-16", da: "Improve analytics to better understand user behavior."
                   },
                   {
                    id: "eg-2-3-17", da: "Create a loyalty program for dedicated users."
                   },
                   {
                    id: "eg-2-3-18", da: "Integrate with third-party tools for added value."
                   },
                   {
                    id: "eg-2-3-19", da: "Build out a robust API for developers."
                   },
                   {
                    id: "eg-2-3-20", da: "Invest in customer support and help desk."
                   },
                   {
                    id: "eg-2-3-21", da: "Enhance data visualization for users."
                   },
                   {
                    id: "eg-2-3-22", da: "Develop partnerships with industry leaders."
                   },
                   {
                    id: "eg-2-3-23", da: "Optimize for SEO to increase discoverability."
                   },
                   {
                    id: "eg-2-3-24", da: "Conduct A\/B testing for feature optimization."
                   },
                   {
                    id: "eg-2-3-25", da: "Launch a referral program for user acquisition."
                   },
                   {
                    id: "eg-2-3-26", da: "Expand customer service hours for global users."
                   },
                   {
                    id: "eg-2-3-27", da: "Create case studies to showcase success stories."
                   },
                   {
                    id: "eg-2-3-28", da: "Establish an affiliate program for marketers."
                   },
                   {
                    id: "eg-2-3-29", da: "Offer tutorials and webinars for skill development."
                   },
                   {
                    id: "eg-2-3-30", da: "Implement machine learning for personalized experiences."
                   },
                   {
                    id: "eg-2-3-31", da: "Enhance reporting and analytics tools."
                   },
                   {
                    id: "eg-2-3-32", da: "Invest in server and infrastructure upgrades."
                   },
                   {
                    id: "eg-2-3-33", da: "Create a certification program for users."
                   },
                   {
                    id: "eg-2-3-34", da: "Improve integration with third-party apps."
                   },
                   {
                    id: "eg-2-3-35", da: "Implement gamification to increase engagement."
                   },
                   {
                    id: "eg-2-3-36", da: "Foster partnerships with educational institutions."
                   },
                   {
                    id: "eg-2-3-37", da: "Optimize for voice and IoT devices."
                   },
                   {
                    id: "eg-2-3-38", da: "Expand to new geographical regions."
                   },
                   {
                    id: "eg-2-3-39", da: "Establish a content marketing strategy."
                   },
                   {
                    id: "eg-2-3-40", da: "Implement a bug bounty program for security."
                   },
                   {
                    id: "eg-2-3-41", da: "Invest in sustainability initiatives."
                   },
                   {
                    id: "eg-2-3-42", da: "Improve data privacy and compliance."
                   },
                   {
                    id: "eg-2-3-43", da: "Create a knowledge base for self-help."
                   },
                   {
                    id: "eg-2-3-44", da: "Optimize for accessibility for all users."
                   },
                   {
                    id: "eg-2-3-45", da: "Develop a user forum for peer support."
                   },
                   {
                    id: "eg-2-3-46", da: "Conduct regular user training sessions."
                   },
                   {
                    id: "eg-2-3-47", da: "Optimize for social sharing and referrals."
                   },
                   {
                    id: "eg-2-3-48", da: "Invest in continuous performance monitoring."
                   },
                   {
                    id: "eg-2-3-49", da: "Collaborate with industry experts for thought leadership."
                   },
                ]
              },
              {
                id: 'eg-2-4',
                pm: 'Sales begins to become predictable and projections are hit.',
                title:'Business Model',
                pmMap: 'Sales begins to become predictable and projections are hit.',
                developmentActions:[
                  {
                    id: "eg-2-4-0", da: "Identify and target a specific niche market."
                   },
                   {
                    id: "eg-2-4-1", da: "Conduct market research to understand customer needs."
                   },
                   {
                    id: "eg-2-4-2", da: "Define a clear value proposition."
                   },
                   {
                    id: "eg-2-4-3", da: "Create a customer persona for better targeting."
                   },
                   {
                    id: "eg-2-4-4", da: "Develop a competitive pricing strategy."
                   },
                   {
                    id: "eg-2-4-5", da: "Explore subscription-based revenue models."
                   },
                   {
                    id: "eg-2-4-6", da: "Establish strategic partnerships."
                   },
                   {
                    id: "eg-2-4-7", da: "Diversify revenue streams."
                   },
                   {
                    id: "eg-2-4-8", da: "Focus on customer retention and loyalty."
                   },
                   {
                    id: "eg-2-4-9", da: "Implement a referral program."
                   },
                   {
                    id: "eg-2-4-10", da: "Offer freemium services to attract users."
                   },
                   {
                    id: "eg-2-4-11", da: "Expand into new geographical markets."
                   },
                   {
                    id: "eg-2-4-12", da: "Optimize the onboarding process for new customers."
                   },
                   {
                    id: "eg-2-4-13", da: "Invest in customer support and training."
                   },
                   {
                    id: "eg-2-4-14", da: "Leverage data analytics for decision-making."
                   },
                   {
                    id: "eg-2-4-15", da: "Explore upselling and cross-selling opportunities."
                   },
                   {
                    id: "eg-2-4-16", da: "Consider white-labeling or reseller agreements."
                   },
                   {
                    id: "eg-2-4-17", da: "Create an affiliate marketing program."
                   },
                   {
                    id: "eg-2-4-18", da: "Invest in content marketing for lead generation."
                   },
                   {
                    id: "eg-2-4-19", da: "Use SEO and SEM to increase online visibility."
                   },
                   {
                    id: "eg-2-4-20", da: "Develop a comprehensive business plan."
                   },
                   {
                    id: "eg-2-4-21", da: "Seek venture capital or other funding options."
                   },
                   {
                    id: "eg-2-4-22", da: "Create a roadmap for product development."
                   },
                   {
                    id: "eg-2-4-23", da: "Conduct A\/B testing for marketing campaigns."
                   },
                   {
                    id: "eg-2-4-24", da: "Implement a robust CRM system."
                   },
                   {
                    id: "eg-2-4-25", da: "Improve the user interface and user experience."
                   },
                   {
                    id: "eg-2-4-26", da: "Launch a mobile app to reach a wider audience."
                   },
                   {
                    id: "eg-2-4-27", da: "Leverage social media marketing strategies."
                   },
                   {
                    id: "eg-2-4-28", da: "Participate in industry conferences and events."
                   },
                   {
                    id: "eg-2-4-29", da: "Conduct webinars and online workshops."
                   },
                   {
                    id: "eg-2-4-30", da: "Integrate with complementary products or services."
                   },
                   {
                    id: "eg-2-4-31", da: "Develop an API to encourage third-party integration."
                   },
                   {
                    id: "eg-2-4-32", da: "Enhance data security and privacy measures."
                   },
                   {
                    id: "eg-2-4-33", da: "Offer customization options for customers."
                   },
                   {
                    id: "eg-2-4-34", da: "Develop a loyalty rewards program."
                   },
                   {
                    id: "eg-2-4-35", da: "Launch a customer feedback program."
                   },
                   {
                    id: "eg-2-4-36", da: "Implement agile development methodologies."
                   },
                   {
                    id: "eg-2-4-37", da: "Develop a long-term sustainability strategy."
                   },
                   {
                    id: "eg-2-4-38", da: "Explore new distribution channels."
                   },
                   {
                    id: "eg-2-4-39", da: "Invest in R&D for product innovation."
                   },
                   {
                    id: "eg-2-4-40", da: "Consider blockchain technology for transparency."
                   },
                   {
                    id: "eg-2-4-41", da: "Offer freemium services to attract users."
                   },
                   {
                    id: "eg-2-4-42", da: "Create a knowledge base for self-help support."
                   },
                   {
                    id: "eg-2-4-43", da: "Leverage the power of user-generated content."
                   },
                   {
                    id: "eg-2-4-44", da: "Implement multilingual support for global users."
                   },
                   {
                    id: "eg-2-4-45", da: "Monitor industry trends and adapt accordingly."
                   },
                   {
                    id: "eg-2-4-46", da: "Conduct regular competitor analysis."
                   },
                   {
                    id: "eg-2-4-47", da: "Optimize the supply chain and logistics."
                   },
                   {
                    id: "eg-2-4-48", da: "Develop strategic exit strategies."
                   },
                   {
                    id: "eg-2-4-49", da: "Engage with industry associations and forums."
                   },
                ]
              },
              {
                id: 'eg-2-5',
                pm: 'Increasing confidence in sales scalability as different customer acquisition channels are proven to work.',
                title:'Go to Market',
                pmMap: 'Sales begins to become predictable and projections are hit.',
                developmentActions:[
                  {
                    id: "eg-2-5-0", da: "Conduct a market segmentation analysis to identify specific target audiences."
                   },
                   {
                    id: "eg-2-5-1", da: "Develop buyer personas for each target segment."
                   },
                   {
                    id: "eg-2-5-2", da: "Refine the unique value proposition for each persona."
                   },
                   {
                    id: "eg-2-5-3", da: "Conduct a competitive analysis to understand market dynamics."
                   },
                   {
                    id: "eg-2-5-4", da: "Identify key market influencers and build relationships with them."
                   },
                   {
                    id: "eg-2-5-5", da: "Implement a comprehensive content marketing strategy."
                   },
                   {
                    id: "eg-2-5-6", da: "Leverage social media to engage with the target audience."
                   },
                   {
                    id: "eg-2-5-7", da: "Explore partnerships with complementary businesses."
                   },
                   {
                    id: "eg-2-5-8", da: "Create a referral program to encourage word-of-mouth marketing."
                   },
                   {
                    id: "eg-2-5-9", da: "Optimize the website for search engines (SEO)."
                   },
                   {
                    id: "eg-2-5-10", da: "Implement a robust email marketing strategy."
                   },
                   {
                    id: "eg-2-5-11", da: "Leverage customer testimonials and case studies."
                   },
                   {
                    id: "eg-2-5-12", da: "Develop a pricing strategy that aligns with market expectations."
                   },
                   {
                    id: "eg-2-5-13", da: "Launch a pilot program in a specific niche."
                   },
                   {
                    id: "eg-2-5-14", da: "Monitor key performance indicators (KPIs) for marketing efforts."
                   },
                   {
                    id: "eg-2-5-15", da: "Implement a lead nurturing process."
                   },
                   {
                    id: "eg-2-5-16", da: "Improve customer onboarding for a seamless experience."
                   },
                   {
                    id: "eg-2-5-17", da: "Offer free trials or freemium options to attract users."
                   },
                   {
                    id: "eg-2-5-18", da: "Attend industry conferences and events."
                   },
                   {
                    id: "eg-2-5-19", da: "Establish thought leadership through webinars and whitepapers."
                   },
                   {
                    id: "eg-2-5-20", da: "Invest in user interface (UI) and user experience (UX) improvements."
                   },
                   {
                    id: "eg-2-5-21", da: "Provide excellent customer support and feedback channels."
                   },
                   {
                    id: "eg-2-5-22", da: "Explore international expansion opportunities."
                   },
                   {
                    id: "eg-2-5-23", da: "Develop strategic alliances with industry associations."
                   },
                   {
                    id: "eg-2-5-24", da: "Experiment with paid advertising campaigns."
                   },
                   {
                    id: "eg-2-5-25", da: "Invest in a customer relationship management (CRM) system."
                   },
                   {
                    id: "eg-2-5-26", da: "Run targeted ad campaigns on social media platforms."
                   },
                   {
                    id: "eg-2-5-27", da: "Encourage user-generated content and reviews."
                   },
                   {
                    id: "eg-2-5-28", da: "Provide training and certification programs."
                   },
                   {
                    id: "eg-2-5-29", da: "Expand the product or service offering to cater to diverse needs."
                   },
                   {
                    id: "eg-2-5-30", da: "Run referral contests and incentivize loyal customers."
                   },
                   {
                    id: "eg-2-5-31", da: "Conduct surveys to gather market insights."
                   },
                   {
                    id: "eg-2-5-32", da: "Collaborate with industry analysts and influencers."
                   },
                   {
                    id: "eg-2-5-33", da: "Monitor and respond to online reviews and feedback."
                   },
                   {
                    id: "eg-2-5-34", da: "Develop a pricing model based on value delivered."
                   },
                   {
                    id: "eg-2-5-35", da: "Launch a loyalty program for repeat customers."
                   },
                   {
                    id: "eg-2-5-36", da: "Create tailored landing pages for specific segments."
                   },
                   {
                    id: "eg-2-5-37", da: "Implement a retargeting strategy for lost leads."
                   },
                   {
                    id: "eg-2-5-38", da: "Optimize email marketing for mobile devices."
                   },
                   {
                    id: "eg-2-5-39", da: "Conduct A\/B testing for marketing campaigns."
                   },
                   {
                    id: "eg-2-5-40", da: "Leverage user-generated content for social proof."
                   },
                   {
                    id: "eg-2-5-41", da: "Implement an affiliate marketing program."
                   },
                   {
                    id: "eg-2-5-42", da: "Host webinars and workshops for educational purposes."
                   },
                   {
                    id: "eg-2-5-43", da: "Publish a regular blog or newsletter with industry insights."
                   },
                   {
                    id: "eg-2-5-44", da: "Conduct user surveys for feedback and improvements."
                   },
                   {
                    id: "eg-2-5-45", da: "Create product demo videos for online marketing."
                   },
                   {
                    id: "eg-2-5-46", da: "Segment email lists for personalized content."
                   },
                   {
                    id: "eg-2-5-47", da: "Invest in analytics and data-driven decision-making."
                   },
                   {
                    id: "eg-2-5-48", da: "Ensure consistency in branding and messaging."
                   },
                   {
                    id: "eg-2-5-49", da: "Continuously iterate and adapt the strategy based on performance data."
                   },
                ]
              },
              {
                id: 'eg-2-6',
                pm: 'Internal operation teams are combined into departments. Senior leaders are hired from outside or promoted from inside.',
                title:'People',
                pmMap: 'Internal operation teams are combined into departments. Senior leaders are hired from outside or promoted from inside.',
                developmentActions:[
                  {
                    id: "eg-2-6-0", da: "Invest in continuous training and development programs for your team."
                   },
                   {
                    id: "eg-2-6-1", da: "Promote a culture of learning and innovation."
                   },
                   {
                    id: "eg-2-6-2", da: "Foster cross-functional collaboration and knowledge sharing."
                   },
                   {
                    id: "eg-2-6-3", da: "Identify and nurture emerging leaders within your organization."
                   },
                   {
                    id: "eg-2-6-4", da: "Encourage employees to attend relevant industry events and conferences."
                   },
                   {
                    id: "eg-2-6-5", da: "Develop mentoring programs to pair experienced professionals with newcomers."
                   },
                   {
                    id: "eg-2-6-6", da: "Create opportunities for employees to work on cross-departmental projects."
                   },
                   {
                    id: "eg-2-6-7", da: "Improve communication skills through workshops and training."
                   },
                   {
                    id: "eg-2-6-8", da: "Encourage active listening and empathy in team interactions."
                   },
                   {
                    id: "eg-2-6-9", da: "Provide feedback and coaching to enhance individual performance."
                   },
                   {
                    id: "eg-2-6-10", da: "Emphasize the importance of adaptability in a fast-changing landscape."
                   },
                   {
                    id: "eg-2-6-11", da: "Develop strong project management skills to oversee complex initiatives."
                   },
                   {
                    id: "eg-2-6-12", da: "Enhance problem-solving and critical thinking abilities."
                   },
                   {
                    id: "eg-2-6-13", da: "Cultivate a growth mindset among your team members."
                   },
                   {
                    id: "eg-2-6-14", da: "Encourage creativity and out-of-the-box thinking."
                   },
                   {
                    id: "eg-2-6-15", da: "Foster a culture of accountability and ownership."
                   },
                   {
                    id: "eg-2-6-16", da: "Prioritize work-life balance and stress management."
                   },
                   {
                    id: "eg-2-6-17", da: "Develop time management and organization skills."
                   },
                   {
                    id: "eg-2-6-18", da: "Promote diversity and inclusion in your workforce."
                   },
                   {
                    id: "eg-2-6-19", da: "Establish clear career paths and growth opportunities."
                   },
                   {
                    id: "eg-2-6-20", da: "Encourage employees to stay updated on industry trends and best practices."
                   },
                   {
                    id: "eg-2-6-21", da: "Develop negotiation and conflict resolution skills."
                   },
                   {
                    id: "eg-2-6-22", da: "Improve presentation and public speaking abilities."
                   },
                   {
                    id: "eg-2-6-23", da: "Foster teamwork and collaboration."
                   },
                   {
                    id: "eg-2-6-24", da: "Enhance emotional intelligence and self-awareness."
                   },
                   {
                    id: "eg-2-6-25", da: "Create opportunities for employees to take on leadership roles."
                   },
                   {
                    id: "eg-2-6-26", da: "Develop expertise in specific domains relevant to your industry."
                   },
                   {
                    id: "eg-2-6-27", da: "Promote effective delegation and empowerment."
                   },
                   {
                    id: "eg-2-6-28", da: "Encourage risk-taking and innovation."
                   },
                   {
                    id: "eg-2-6-29", da: "Develop networking and relationship-building skills."
                   },
                   {
                    id: "eg-2-6-30", da: "Emphasize the importance of customer-centric thinking."
                   },
                   {
                    id: "eg-2-6-31", da: "Encourage cross-cultural competency in global business."
                   },
                   {
                    id: "eg-2-6-32", da: "Develop negotiation and contract management skills."
                   },
                   {
                    id: "eg-2-6-33", da: "Promote ethical decision-making and integrity."
                   },
                   {
                    id: "eg-2-6-34", da: "Foster a sense of ownership for the success of the ecosystem."
                   },
                   {
                    id: "eg-2-6-35", da: "Train in data analysis and interpretation for informed decision-making."
                   },
                   {
                    id: "eg-2-6-36", da: "Improve digital literacy for tech-driven environments."
                   },
                   {
                    id: "eg-2-6-37", da: "Develop agility and adaptability in response to market changes."
                   },
                   {
                    id: "eg-2-6-38", da: "Encourage active participation in industry associations and communities."
                   },
                   {
                    id: "eg-2-6-39", da: "Enhance understanding of legal and regulatory aspects of the ecosystem."
                   },
                   {
                    id: "eg-2-6-40", da: "Train in risk management and crisis response."
                   },
                   {
                    id: "eg-2-6-41", da: "Develop a customer-first mindset and practices."
                   },
                   {
                    id: "eg-2-6-42", da: "Foster an entrepreneurial spirit among team members."
                   },
                   {
                    id: "eg-2-6-43", da: "Invest in continuous improvement methodologies."
                   },
                   {
                    id: "eg-2-6-44", da: "Encourage innovation through hackathons and idea incubators."
                   },
                   {
                    id: "eg-2-6-45", da: "Develop expertise in content creation and marketing."
                   },
                   {
                    id: "eg-2-6-46", da: "Train in data privacy and cybersecurity best practices."
                   },
                   {
                    id: "eg-2-6-47", da: "Promote systems thinking and holistic problem-solving."
                   },
                   {
                    id: "eg-2-6-48", da: "Encourage team members to become subject matter experts."
                   },
                   {
                    id: "eg-2-6-49", da: "Develop a sense of ownership and responsibility for the ecosystem's long-term success."
                   },
                ]
              },
              {
                id: 'eg-2-7',
                pm: 'Introduce BI solutions to increase visibility and enhance efficiency. CAC payback <15 months.',
                title:'Data Metrics',
                pmMap: 'Introduce BI solutions to increase visibility and enhance efficiency. CAC payback <15 months.',
                developmentActions:[
                  {
                    id: "eg-2-7-0", da: "Define clear data-driven objectives."
                   },
                   {
                    id: "eg-2-7-1", da: "Establish key performance indicators (KPIs) for ecosystem growth."
                   },
                   {
                    id: "eg-2-7-2", da: "Identify data sources and ensure data accuracy."
                   },
                   {
                    id: "eg-2-7-3", da: "Implement data governance policies."
                   },
                   {
                    id: "eg-2-7-4", da: "Invest in data collection and storage infrastructure."
                   },
                   {
                    id: "eg-2-7-5", da: "Integrate data from various channels and touchpoints."
                   },
                   {
                    id: "eg-2-7-6", da: "Create a unified data warehouse."
                   },
                   {
                    id: "eg-2-7-7", da: "Regularly audit and clean the data."
                   },
                   {
                    id: "eg-2-7-8", da: "Implement data quality checks and validations."
                   },
                   {
                    id: "eg-2-7-9", da: "Ensure data privacy and compliance."
                   },
                   {
                    id: "eg-2-7-10", da: "Develop a data analytics strategy."
                   },
                   {
                    id: "eg-2-7-11", da: "Invest in data analytics tools and platforms."
                   },
                   {
                    id: "eg-2-7-12", da: "Provide data analytics training for your team."
                   },
                   {
                    id: "eg-2-7-13", da: "Develop custom dashboards for monitoring metrics."
                   },
                   {
                    id: "eg-2-7-14", da: "Automate data reporting processes."
                   },
                   {
                    id: "eg-2-7-15", da: "Use predictive analytics for future trends."
                   },
                   {
                    id: "eg-2-7-16", da: "Implement A\/B testing for data-driven decisions."
                   },
                   {
                    id: "eg-2-7-17", da: "Establish a data culture within the organization."
                   },
                   {
                    id: "eg-2-7-18", da: "Encourage cross-functional data collaboration."
                   },
                   {
                    id: "eg-2-7-19", da: "Monitor user behavior and engagement metrics."
                   },
                   {
                    id: "eg-2-7-20", da: "Implement cohort analysis to track user groups."
                   },
                   {
                    id: "eg-2-7-21", da: "Segment your audience for targeted marketing."
                   },
                   {
                    id: "eg-2-7-22", da: "Analyze customer lifetime value (CLV)."
                   },
                   {
                    id: "eg-2-7-23", da: "Optimize conversion funnels."
                   },
                   {
                    id: "eg-2-7-24", da: "Monitor customer acquisition costs (CAC)."
                   },
                   {
                    id: "eg-2-7-25", da: "Analyze customer retention rates."
                   },
                   {
                    id: "eg-2-7-26", da: "Evaluate product adoption and usage."
                   },
                   {
                    id: "eg-2-7-27", da: "Identify churn patterns and reasons."
                   },
                   {
                    id: "eg-2-7-28", da: "Perform sentiment analysis on customer feedback."
                   },
                   {
                    id: "eg-2-7-29", da: "Conduct competitive analysis using market data."
                   },
                   {
                    id: "eg-2-7-30", da: "Monitor financial performance metrics."
                   },
                   {
                    id: "eg-2-7-31", da: "Track revenue growth and profitability."
                   },
                   {
                    id: "eg-2-7-32", da: "Measure return on investment (ROI) for marketing."
                   },
                   {
                    id: "eg-2-7-33", da: "Analyze customer support ticket data."
                   },
                   {
                    id: "eg-2-7-34", da: "Monitor response times and resolution rates."
                   },
                   {
                    id: "eg-2-7-35", da: "Evaluate employee productivity metrics."
                   },
                   {
                    id: "eg-2-7-36", da: "Assess the efficiency of supply chain operations."
                   },
                   {
                    id: "eg-2-7-37", da: "Analyze inventory turnover rates."
                   },
                   {
                    id: "eg-2-7-38", da: "Monitor production and quality control metrics."
                   },
                   {
                    id: "eg-2-7-39", da: "Evaluate website traffic and SEO performance."
                   },
                   {
                    id: "eg-2-7-40", da: "Track social media engagement and reach."
                   },
                   {
                    id: "eg-2-7-41", da: "Analyze email marketing open and click-through rates."
                   },
                   {
                    id: "eg-2-7-42", da: "Measure content marketing effectiveness."
                   },
                   {
                    id: "eg-2-7-43", da: "Evaluate the impact of influencer marketing."
                   },
                   {
                    id: "eg-2-7-44", da: "Monitor app store ratings and reviews."
                   },
                   {
                    id: "eg-2-7-45", da: "Analyze referral and affiliate program performance."
                   },
                   {
                    id: "eg-2-7-46", da: "Measure brand awareness and sentiment."
                   },
                   {
                    id: "eg-2-7-47", da: "Evaluate partnerships and collaboration success."
                   },
                   {
                    id: "eg-2-7-48", da: "Analyze the impact of pricing strategies."
                   },
                   {
                    id: "eg-2-7-49", da: "Regularly review and adapt data metrics for evolving business goals."
                   },
                ]
              },
              {
                id: 'eg-2-8',
                pm: 'Operations are transparent and clear. Fully data transparency across all areas of the business (product, customer, finance, HR).',
                title:'Operations',
                pmMap: 'Operations are transparent and clear. Fully data transparency across all areas of the business (product, customer, finance, HR).',
                developmentActions:[
                  {
                    id: "eg-2-8-0", da: "Establish clear operational objectives."
                   },
                   {
                    id: "eg-2-8-1", da: "Define key performance indicators (KPIs) for operations."
                   },
                   {
                    id: "eg-2-8-2", da: "Streamline communication channels within the ecosystem."
                   },
                   {
                    id: "eg-2-8-3", da: "Implement an efficient project management system."
                   },
                   {
                    id: "eg-2-8-4", da: "Foster collaboration among ecosystem partners."
                   },
                   {
                    id: "eg-2-8-5", da: "Develop a unified data management strategy."
                   },
                   {
                    id: "eg-2-8-6", da: "Automate routine operational tasks."
                   },
                   {
                    id: "eg-2-8-7", da: "Enhance supply chain management."
                   },
                   {
                    id: "eg-2-8-8", da: "Implement robust cybersecurity measures."
                   },
                   {
                    id: "eg-2-8-9", da: "Ensure compliance with relevant regulations."
                   },
                   {
                    id: "eg-2-8-10", da: "Optimize resource allocation."
                   },
                   {
                    id: "eg-2-8-11", da: "Improve risk management practices."
                   },
                   {
                    id: "eg-2-8-12", da: "Enhance disaster recovery and business continuity planning."
                   },
                   {
                    id: "eg-2-8-13", da: "Establish a feedback mechanism for ecosystem participants."
                   },
                   {
                    id: "eg-2-8-14", da: "Invest in advanced analytics and data-driven decision-making."
                   },
                   {
                    id: "eg-2-8-15", da: "Develop a comprehensive training program for ecosystem members."
                   },
                   {
                    id: "eg-2-8-16", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "eg-2-8-17", da: "Monitor and reduce operational costs."
                   },
                   {
                    id: "eg-2-8-18", da: "Implement green and sustainable practices."
                   },
                   {
                    id: "eg-2-8-19", da: "Enhance customer support and service."
                   },
                   {
                    id: "eg-2-8-20", da: "Develop a scalable and flexible infrastructure."
                   },
                   {
                    id: "eg-2-8-21", da: "Enhance quality control and assurance."
                   },
                   {
                    id: "eg-2-8-22", da: "Optimize inventory management."
                   },
                   {
                    id: "eg-2-8-23", da: "Improve supplier relationships."
                   },
                   {
                    id: "eg-2-8-24", da: "Standardize operational procedures."
                   },
                   {
                    id: "eg-2-8-25", da: "Ensure data privacy and protection."
                   },
                   {
                    id: "eg-2-8-26", da: "Adopt agile methodologies in operations."
                   },
                   {
                    id: "eg-2-8-27", da: "Streamline procurement processes."
                   },
                   {
                    id: "eg-2-8-28", da: "Invest in advanced technology and tools."
                   },
                   {
                    id: "eg-2-8-29", da: "Optimize energy and resource consumption."
                   },
                   {
                    id: "eg-2-8-30", da: "Improve product lifecycle management."
                   },
                   {
                    id: "eg-2-8-31", da: "Expand and diversify the ecosystem."
                   },
                   {
                    id: "eg-2-8-32", da: "Enhance data sharing and transparency."
                   },
                   {
                    id: "eg-2-8-33", da: "Develop a knowledge management system."
                   },
                   {
                    id: "eg-2-8-34", da: "Create a dedicated operations team."
                   },
                   {
                    id: "eg-2-8-35", da: "Foster innovation in operations."
                   },
                   {
                    id: "eg-2-8-36", da: "Optimize transportation and logistics."
                   },
                   {
                    id: "eg-2-8-37", da: "Enhance customer engagement strategies."
                   },
                   {
                    id: "eg-2-8-38", da: "Monitor and reduce waste generation."
                   },
                   {
                    id: "eg-2-8-39", da: "Standardize reporting and documentation."
                   },
                   {
                    id: "eg-2-8-40", da: "Integrate IoT and sensors for monitoring."
                   },
                   {
                    id: "eg-2-8-41", da: "Implement continuous monitoring and auditing."
                   },
                   {
                    id: "eg-2-8-42", da: "Develop a scalable IT infrastructure."
                   },
                   {
                    id: "eg-2-8-43", da: "Ensure regulatory compliance across the ecosystem."
                   },
                   {
                    id: "eg-2-8-44", da: "Optimize order fulfillment and delivery."
                   },
                   {
                    id: "eg-2-8-45", da: "Foster a culture of safety and security."
                   },
                   {
                    id: "eg-2-8-46", da: "Implement predictive maintenance."
                   },
                   {
                    id: "eg-2-8-47", da: "Enhance procurement analytics."
                   },
                   {
                    id: "eg-2-8-48", da: "Invest in sustainability initiatives."
                   },
                   {
                    id: "eg-2-8-49", da: "Create a roadmap for ongoing operational improvements."
                   },
                ]
              },
              {
                id: 'eg-2-9',
                pm: 'Community growth and revenues are all looking positive and there is no risk of burning out.',
                title:'Exit Strategy',
                pmMap: 'Community growth and revenues are all looking positive and there is no risk of burning out.',
                developmentActions:[
                  {
                    id: "eg-2-9-0", da: "Assess the current stage of ecosystem growth."
                   },
                   {
                    id: "eg-2-9-1", da: "Define clear goals and milestones for crossing the chasm."
                   },
                   {
                    id: "eg-2-9-2", da: "Identify target market segments for expansion."
                   },
                   {
                    id: "eg-2-9-3", da: "Understand the unique needs and pain points of the target segments."
                   },
                   {
                    id: "eg-2-9-4", da: "Refine your product or service offering to meet the needs of the target segments."
                   },
                   {
                    id: "eg-2-9-5", da: "Invest in market research to gather data on the target segments."
                   },
                   {
                    id: "eg-2-9-6", da: "Develop targeted marketing campaigns for each segment."
                   },
                   {
                    id: "eg-2-9-7", da: "Build strong partnerships with key players in the industry."
                   },
                   {
                    id: "eg-2-9-8", da: "Expand your network within the ecosystem."
                   },
                   {
                    id: "eg-2-9-9", da: "Create compelling case studies and success stories."
                   },
                   {
                    id: "eg-2-9-10", da: "Foster customer advocacy and referrals."
                   },
                   {
                    id: "eg-2-9-11", da: "Focus on building trust and credibility."
                   },
                   {
                    id: "eg-2-9-12", da: "Provide outstanding customer support and service."
                   },
                   {
                    id: "eg-2-9-13", da: "Address any product or service shortcomings."
                   },
                   {
                    id: "eg-2-9-14", da: "Develop a clear pricing strategy."
                   },
                   {
                    id: "eg-2-9-15", da: "Offer customization options for different segments."
                   },
                   {
                    id: "eg-2-9-16", da: "Explore international markets."
                   },
                   {
                    id: "eg-2-9-17", da: "Adapt your product for global markets."
                   },
                   {
                    id: "eg-2-9-18", da: "Build a strong online presence through SEO and content marketing."
                   },
                   {
                    id: "eg-2-9-19", da: "Leverage social media and influencer marketing."
                   },
                   {
                    id: "eg-2-9-20", da: "Consider mergers or acquisitions to expand your reach."
                   },
                   {
                    id: "eg-2-9-21", da: "Explore joint ventures or strategic partnerships."
                   },
                   {
                    id: "eg-2-9-22", da: "Develop a competitive analysis strategy."
                   },
                   {
                    id: "eg-2-9-23", da: "Offer incentives for early adopters."
                   },
                   {
                    id: "eg-2-9-24", da: "Enhance the user experience for your product."
                   },
                   {
                    id: "eg-2-9-25", da: "Create a seamless onboarding process."
                   },
                   {
                    id: "eg-2-9-26", da: "Invest in employee training and development."
                   },
                   {
                    id: "eg-2-9-27", da: "Diversify your product or service offerings."
                   },
                   {
                    id: "eg-2-9-28", da: "Consider bundling products for added value."
                   },
                   {
                    id: "eg-2-9-29", da: "Implement a referral program for customers."
                   },
                   {
                    id: "eg-2-9-30", da: "Develop a clear product roadmap."
                   },
                   {
                    id: "eg-2-9-31", da: "Invest in R&D and innovation."
                   },
                   {
                    id: "eg-2-9-32", da: "Explore new distribution channels."
                   },
                   {
                    id: "eg-2-9-33", da: "Optimize supply chain and logistics."
                   },
                   {
                    id: "eg-2-9-34", da: "Create strategic marketing alliances."
                   },
                   {
                    id: "eg-2-9-35", da: "Develop a crisis management plan."
                   },
                   {
                    id: "eg-2-9-36", da: "Establish clear communication channels."
                   },
                   {
                    id: "eg-2-9-37", da: "Monitor customer feedback and reviews."
                   },
                   {
                    id: "eg-2-9-38", da: "Conduct regular SWOT analyses."
                   },
                   {
                    id: "eg-2-9-39", da: "Address legal and regulatory concerns."
                   },
                   {
                    id: "eg-2-9-40", da: "Monitor and respond to market trends."
                   },
                   {
                    id: "eg-2-9-41", da: "Continuously improve product quality."
                   },
                   {
                    id: "eg-2-9-42", da: "Encourage feedback from employees."
                   },
                   {
                    id: "eg-2-9-43", da: "Foster a culture of innovation."
                   },
                   {
                    id: "eg-2-9-44", da: "Implement sustainability practices."
                   },
                   {
                    id: "eg-2-9-45", da: "Expand your customer base."
                   },
                   {
                    id: "eg-2-9-46", da: "Enhance your competitive positioning."
                   },
                   {
                    id: "eg-2-9-47", da: "Develop a customer retention strategy."
                   },
                   {
                    id: "eg-2-9-48", da: "Provide loyalty programs."
                   },
                   {
                    id: "eg-2-9-49", da: "Regularly review and adapt your exit strategy as needed."
                   },
                ]
              }
            ]
          }
        ]
      },
      'pf':{
        characteristic: 'Public Funding',
        wdd: "Take your next step towards creating a strong consortia and tapping into our knowledge on how to compose successful applications.",
        icon: require('@/assets/Iconography/Characteristics/15_Skilled Communicator.svg'),
        competencies:[
          {
            id: 'pf-0',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Funding frameworks',
            wdd: '',
            progressMeasures:[
              {
                id: 'pf-0-0',
                pm: 'Community dominates category as industry leader, >80% of funding networks understand what problem the commuity solves.',
                title:'Need',
                pmMap: 'Community dominates category as industry leader, >80% of funding networks understand what problem the commuity solves.',
                developmentActions:[
                  {
                    id: "pf-0-0-0", da: "Allocate funds to support basic infrastructure development in underprivileged areas."
                   },
                   {
                    id: "pf-0-0-1", da: "Invest in education and training programs to enhance human capital."
                   },
                   {
                    id: "pf-0-0-2", da: "Promote affordable healthcare services and facilities."
                   },
                   {
                    id: "pf-0-0-3", da: "Fund research and innovation to drive technological advancements."
                   },
                   {
                    id: "pf-0-0-4", da: "Support small and medium-sized enterprises (SMEs) to stimulate economic growth."
                   },
                   {
                    id: "pf-0-0-5", da: "Fund projects that improve access to clean water and sanitation."
                   },
                   {
                    id: "pf-0-0-6", da: "Invest in renewable energy initiatives to combat climate change."
                   },
                   {
                    id: "pf-0-0-7", da: "Promote gender equality and support women's empowerment."
                   },
                   {
                    id: "pf-0-0-8", da: "Develop affordable housing projects for low-income individuals."
                   },
                   {
                    id: "pf-0-0-9", da: "Fund rural development programs to reduce urban-rural disparities."
                   },
                   {
                    id: "pf-0-0-10", da: "Support initiatives that enhance food security and reduce hunger."
                   },
                   {
                    id: "pf-0-0-11", da: "Allocate resources to improve public transportation systems."
                   },
                   {
                    id: "pf-0-0-12", da: "Fund cultural and artistic programs to preserve heritage and creativity."
                   },
                   {
                    id: "pf-0-0-13", da: "Promote financial inclusion through microfinance initiatives."
                   },
                   {
                    id: "pf-0-0-14", da: "Invest in sustainable agriculture and farming practices."
                   },
                   {
                    id: "pf-0-0-15", da: "Support disaster preparedness and relief efforts."
                   },
                   {
                    id: "pf-0-0-16", da: "Allocate funds for environmental conservation and wildlife protection."
                   },
                   {
                    id: "pf-0-0-17", da: "Fund projects to promote social entrepreneurship."
                   },
                   {
                    id: "pf-0-0-18", da: "Enhance access to quality healthcare services for marginalized populations."
                   },
                   {
                    id: "pf-0-0-19", da: "Support clean energy and green technology adoption."
                   },
                   {
                    id: "pf-0-0-20", da: "Invest in vocational training to reduce unemployment."
                   },
                   {
                    id: "pf-0-0-21", da: "Promote digital literacy and access to information technology."
                   },
                   {
                    id: "pf-0-0-22", da: "Allocate resources to combat drug addiction and substance abuse."
                   },
                   {
                    id: "pf-0-0-23", da: "Fund projects that improve access to quality education."
                   },
                   {
                    id: "pf-0-0-24", da: "Support clean and efficient public transportation solutions."
                   },
                   {
                    id: "pf-0-0-25", da: "Invest in eco-friendly waste management and recycling programs."
                   },
                   {
                    id: "pf-0-0-26", da: "Promote affordable and accessible childcare services."
                   },
                   {
                    id: "pf-0-0-27", da: "Fund initiatives to address mental health and well-being."
                   },
                   {
                    id: "pf-0-0-28", da: "Allocate resources for public safety and law enforcement."
                   },
                   {
                    id: "pf-0-0-29", da: "Support cultural exchange and international cooperation programs."
                   },
                   {
                    id: "pf-0-0-30", da: "Invest in affordable and reliable high-speed internet access."
                   },
                   {
                    id: "pf-0-0-31", da: "Promote youth entrepreneurship and job creation."
                   },
                   {
                    id: "pf-0-0-32", da: "Fund initiatives to protect and restore ecosystems."
                   },
                   {
                    id: "pf-0-0-33", da: "Allocate resources to reduce air and water pollution."
                   },
                   {
                    id: "pf-0-0-34", da: "Support initiatives for clean and safe drinking water."
                   },
                   {
                    id: "pf-0-0-35", da: "Invest in public libraries and community centers."
                   },
                   {
                    id: "pf-0-0-36", da: "Promote public health campaigns and awareness."
                   },
                   {
                    id: "pf-0-0-37", da: "Fund projects to reduce poverty and income inequality."
                   },
                   {
                    id: "pf-0-0-38", da: "Support refugee resettlement and humanitarian aid efforts."
                   },
                   {
                    id: "pf-0-0-39", da: "Allocate resources for public art and beautification projects."
                   },
                   {
                    id: "pf-0-0-40", da: "Invest in research to combat infectious diseases."
                   },
                   {
                    id: "pf-0-0-41", da: "Promote civic engagement and community participation."
                   },
                   {
                    id: "pf-0-0-42", da: "Fund projects to improve access to legal services."
                   },
                   {
                    id: "pf-0-0-43", da: "Support initiatives for the elderly and retirees."
                   },
                   {
                    id: "pf-0-0-44", da: "Allocate resources to enhance public safety infrastructure."
                   },
                   {
                    id: "pf-0-0-45", da: "Invest in anti-discrimination and diversity programs."
                   },
                   {
                    id: "pf-0-0-46", da: "Promote sustainable tourism and heritage preservation."
                   },
                   {
                    id: "pf-0-0-47", da: "Fund initiatives for at-risk youth and education."
                   },
                   {
                    id: "pf-0-0-48", da: "Support initiatives for persons with disabilities."
                   },
                   {
                    id: "pf-0-0-49", da: "Allocate resources for international development and aid programs."
                   },
                ]
              },
              {
                id: 'pf-0-1',
                pm: 'Brand is widely recognised across market.',
                title:'Market',
                pmMap: 'Brand is widely recognised across market.',
                developmentActions:[
                  {
                    id: "pf-0-1-0", da: "Establish a grant program to support local startups and small businesses."
                   },
                   {
                    id: "pf-0-1-1", da: "Invest in market research to identify emerging trends and opportunities."
                   },
                   {
                    id: "pf-0-1-2", da: "Create business incubators and accelerators to foster innovation."
                   },
                   {
                    id: "pf-0-1-3", da: "Develop a public-private partnership for infrastructure improvements."
                   },
                   {
                    id: "pf-0-1-4", da: "Provide low-interest loans to small and medium-sized enterprises (SMEs)."
                   },
                   {
                    id: "pf-0-1-5", da: "Offer grants for research and development activities."
                   },
                   {
                    id: "pf-0-1-6", da: "Support vocational training programs to enhance the workforce's skill set."
                   },
                   {
                    id: "pf-0-1-7", da: "Promote international trade partnerships to expand market access."
                   },
                   {
                    id: "pf-0-1-8", da: "Fund marketing campaigns to increase awareness of local products and services."
                   },
                   {
                    id: "pf-0-1-9", da: "Establish a technology park to attract high-tech companies."
                   },
                   {
                    id: "pf-0-1-10", da: "Invest in digital infrastructure to facilitate e-commerce growth."
                   },
                   {
                    id: "pf-0-1-11", da: "Provide grants for energy-efficient and sustainable business practices."
                   },
                   {
                    id: "pf-0-1-12", da: "Offer subsidies to reduce the cost of raw materials."
                   },
                   {
                    id: "pf-0-1-13", da: "Develop a mentorship program for aspiring entrepreneurs."
                   },
                   {
                    id: "pf-0-1-14", da: "Fund initiatives that promote social entrepreneurship."
                   },
                   {
                    id: "pf-0-1-15", da: "Create a revolving loan fund for businesses in distressed areas."
                   },
                   {
                    id: "pf-0-1-16", da: "Support the development of industry clusters to drive collaboration."
                   },
                   {
                    id: "pf-0-1-17", da: "Offer incentives for businesses to expand or relocate to underserved areas."
                   },
                   {
                    id: "pf-0-1-18", da: "Fund market-specific training and education programs."
                   },
                   {
                    id: "pf-0-1-19", da: "Establish a business-friendly regulatory environment."
                   },
                   {
                    id: "pf-0-1-20", da: "Invest in agricultural research and development."
                   },
                   {
                    id: "pf-0-1-21", da: "Provide resources for companies to obtain industry certifications."
                   },
                   {
                    id: "pf-0-1-22", da: "Fund export assistance programs to reach international markets."
                   },
                   {
                    id: "pf-0-1-23", da: "Support the growth of local farmers' markets and artisans."
                   },
                   {
                    id: "pf-0-1-24", da: "Develop an e-commerce platform for local businesses."
                   },
                   {
                    id: "pf-0-1-25", da: "Offer grants for businesses to improve their online presence."
                   },
                   {
                    id: "pf-0-1-26", da: "Invest in logistics and transportation infrastructure."
                   },
                   {
                    id: "pf-0-1-27", da: "Promote financial literacy and access to capital for underserved populations."
                   },
                   {
                    id: "pf-0-1-28", da: "Fund local business associations to enhance networking opportunities."
                   },
                   {
                    id: "pf-0-1-29", da: "Provide grants for market studies and feasibility assessments."
                   },
                   {
                    id: "pf-0-1-30", da: "Support innovation hubs for creative industries."
                   },
                   {
                    id: "pf-0-1-31", da: "Fund initiatives to reduce business operational costs."
                   },
                   {
                    id: "pf-0-1-32", da: "Develop a workforce development strategy to meet market demands."
                   },
                   {
                    id: "pf-0-1-33", da: "Offer grants for product development and design."
                   },
                   {
                    id: "pf-0-1-34", da: "Invest in quality control and assurance programs."
                   },
                   {
                    id: "pf-0-1-35", da: "Fund initiatives to reduce waste and promote sustainability."
                   },
                   {
                    id: "pf-0-1-36", da: "Support technology adoption and automation for efficiency."
                   },
                   {
                    id: "pf-0-1-37", da: "Create a hub for the fashion and apparel industry."
                   },
                   {
                    id: "pf-0-1-38", da: "Offer grants for tourism and hospitality businesses."
                   },
                   {
                    id: "pf-0-1-39", da: "Invest in research to identify export markets for local goods."
                   },
                   {
                    id: "pf-0-1-40", da: "Develop a digital marketing training program for businesses."
                   },
                   {
                    id: "pf-0-1-41", da: "Promote local entrepreneurship through pitch competitions."
                   },
                   {
                    id: "pf-0-1-42", da: "Support programs that improve access to affordable healthcare."
                   },
                   {
                    id: "pf-0-1-43", da: "Invest in alternative energy solutions to reduce operational costs."
                   },
                   {
                    id: "pf-0-1-44", da: "Offer grants for businesses to adapt to changing market demands."
                   },
                   {
                    id: "pf-0-1-45", da: "Develop partnerships with educational institutions for skill development."
                   },
                   {
                    id: "pf-0-1-46", da: "Fund initiatives to reduce the digital divide."
                   },
                   {
                    id: "pf-0-1-47", da: "Support cultural and creative industries to boost tourism."
                   },
                   {
                    id: "pf-0-1-48", da: "Invest in data analytics for market insights."
                   },
                   {
                    id: "pf-0-1-49", da: "Offer grants for businesses to adopt sustainable practices."
                   },
                ]
              },
              {
                id: 'pf-0-2',
                pm: 'Platform recognized as best in the industry driving innovation and solving a wide range of problems. There is a clear demonstrable technology, data and process edge to compete with other applicants when comes to grants  & competitions.',
                title:'Technology',
                pmMap: 'Platform recognized as best in the industry driving innovation and solving a wide range of problems. There is a clear demonstrable technology, data and process edge to compete with other applicants when comes to grants  & competitions.',
                developmentActions:[
                  {
                    id: "pf-0-2-0", da: "Establish technology hubs and innovation centers in underdeveloped regions."
                   },
                   {
                    id: "pf-0-2-1", da: "Fund research and development (R&D) initiatives in emerging technologies."
                   },
                   {
                    id: "pf-0-2-2", da: "Provide grants to startups working on innovative tech solutions."
                   },
                   {
                    id: "pf-0-2-3", da: "Support technology incubators and accelerators."
                   },
                   {
                    id: "pf-0-2-4", da: "Create tech-focused vocational training programs."
                   },
                   {
                    id: "pf-0-2-5", da: "Invest in digital infrastructure for remote areas."
                   },
                   {
                    id: "pf-0-2-6", da: "Fund projects for rural broadband expansion."
                   },
                   {
                    id: "pf-0-2-7", da: "Develop a national cybersecurity framework."
                   },
                   {
                    id: "pf-0-2-8", da: "Support the development of open-source software projects."
                   },
                   {
                    id: "pf-0-2-9", da: "Invest in renewable energy technology research."
                   },
                   {
                    id: "pf-0-2-10", da: "Fund initiatives for sustainable agriculture technology."
                   },
                   {
                    id: "pf-0-2-11", da: "Establish data centers for research and data analysis."
                   },
                   {
                    id: "pf-0-2-12", da: "Provide grants for renewable energy startups."
                   },
                   {
                    id: "pf-0-2-13", da: "Support projects that promote smart city development."
                   },
                   {
                    id: "pf-0-2-14", da: "Invest in advanced manufacturing technologies."
                   },
                   {
                    id: "pf-0-2-15", da: "Fund educational technology for schools and universities."
                   },
                   {
                    id: "pf-0-2-16", da: "Establish technology transfer programs from universities to industries."
                   },
                   {
                    id: "pf-0-2-17", da: "Support the development of autonomous vehicles and transportation tech."
                   },
                   {
                    id: "pf-0-2-18", da: "Fund projects for affordable healthcare technology."
                   },
                   {
                    id: "pf-0-2-19", da: "Invest in clean energy and green technology initiatives."
                   },
                   {
                    id: "pf-0-2-20", da: "Support space exploration and satellite technology."
                   },
                   {
                    id: "pf-0-2-21", da: "Provide grants for artificial intelligence (AI) research."
                   },
                   {
                    id: "pf-0-2-22", da: "Fund initiatives to improve internet connectivity in schools."
                   },
                   {
                    id: "pf-0-2-23", da: "Support digital literacy programs for disadvantaged communities."
                   },
                   {
                    id: "pf-0-2-24", da: "Invest in 5G and next-generation wireless technology."
                   },
                   {
                    id: "pf-0-2-25", da: "Fund blockchain technology research and applications."
                   },
                   {
                    id: "pf-0-2-26", da: "Establish a national quantum computing initiative."
                   },
                   {
                    id: "pf-0-2-27", da: "Support tech projects for disaster preparedness and response."
                   },
                   {
                    id: "pf-0-2-28", da: "Invest in renewable energy storage solutions."
                   },
                   {
                    id: "pf-0-2-29", da: "Fund projects for advanced water purification technology."
                   },
                   {
                    id: "pf-0-2-30", da: "Support research in biotechnology and medical devices."
                   },
                   {
                    id: "pf-0-2-31", da: "Invest in drone technology for various applications."
                   },
                   {
                    id: "pf-0-2-32", da: "Fund cybersecurity training and awareness programs."
                   },
                   {
                    id: "pf-0-2-33", da: "Support projects for affordable 3D printing technology."
                   },
                   {
                    id: "pf-0-2-34", da: "Invest in technology for wildlife conservation efforts."
                   },
                   {
                    id: "pf-0-2-35", da: "Fund initiatives for sustainable forestry technology."
                   },
                   {
                    id: "pf-0-2-36", da: "Support the development of smart farming and precision agriculture."
                   },
                   {
                    id: "pf-0-2-37", da: "Invest in technology to address climate change challenges."
                   },
                   {
                    id: "pf-0-2-38", da: "Fund robotics and automation research for industries."
                   },
                   {
                    id: "pf-0-2-39", da: "Support telemedicine and remote healthcare solutions."
                   },
                   {
                    id: "pf-0-2-40", da: "Invest in technology for waste reduction and recycling."
                   },
                   {
                    id: "pf-0-2-41", da: "Fund projects for advanced materials research."
                   },
                   {
                    id: "pf-0-2-42", da: "Support the development of augmented reality (AR) and virtual reality (VR) applications."
                   },
                   {
                    id: "pf-0-2-43", da: "Invest in technology to address air and water quality issues."
                   },
                   {
                    id: "pf-0-2-44", da: "Fund projects for improved disaster prediction technology."
                   },
                   {
                    id: "pf-0-2-45", da: "Support initiatives for affordable space travel technology."
                   },
                   {
                    id: "pf-0-2-46", da: "Invest in tech solutions for environmental conservation."
                   },
                   {
                    id: "pf-0-2-47", da: "Fund projects for accessible assistive technology."
                   },
                   {
                    id: "pf-0-2-48", da: "Support the development of technology for language preservation."
                   },
                   {
                    id: "pf-0-2-49", da: "Invest in tech-based solutions to reduce energy consumption."
                   },
                ]
              },
              {
                id: 'pf-0-3',
                pm: 'Strong evidence of market pull as the majority of sales in target markets are coming from inbound. NPS >70 and stable.',
                title:'Value',
                pmMap: 'Strong evidence of market pull as the majority of sales in target markets are coming from inbound. NPS >70 and stable.',
                developmentActions:[
                  {
                    id: "pf-0-3-0", da: "Conduct a comprehensive needs assessment."
                   },
                   {
                    id: "pf-0-3-1", da: "Define clear project goals and objectives."
                   },
                   {
                    id: "pf-0-3-2", da: "Establish a dedicated project team."
                   },
                   {
                    id: "pf-0-3-3", da: "Develop a project timeline and milestones."
                   },
                   {
                    id: "pf-0-3-4", da: "Identify potential sources of public funding."
                   },
                   {
                    id: "pf-0-3-5", da: "Explore grant opportunities at the federal, state, and local levels."
                   },
                   {
                    id: "pf-0-3-6", da: "Create a project proposal and budget."
                   },
                   {
                    id: "pf-0-3-7", da: "Engage with stakeholders to gather input and support."
                   },
                   {
                    id: "pf-0-3-8", da: "Develop a strategic project plan."
                   },
                   {
                    id: "pf-0-3-9", da: "Implement transparent financial management practices."
                   },
                   {
                    id: "pf-0-3-10", da: "Create a project monitoring and evaluation framework."
                   },
                   {
                    id: "pf-0-3-11", da: "Ensure compliance with all relevant regulations."
                   },
                   {
                    id: "pf-0-3-12", da: "Explore partnerships with other organizations."
                   },
                   {
                    id: "pf-0-3-13", da: "Build a strong online and offline presence."
                   },
                   {
                    id: "pf-0-3-14", da: "Conduct a SWOT analysis for the project."
                   },
                   {
                    id: "pf-0-3-15", da: "Prioritize projects based on potential impact."
                   },
                   {
                    id: "pf-0-3-16", da: "Build a strong case for public funding."
                   },
                   {
                    id: "pf-0-3-17", da: "Leverage data and analytics for decision-making."
                   },
                   {
                    id: "pf-0-3-18", da: "Implement effective risk management strategies."
                   },
                   {
                    id: "pf-0-3-19", da: "Allocate resources efficiently."
                   },
                   {
                    id: "pf-0-3-20", da: "Monitor and control project expenses."
                   },
                   {
                    id: "pf-0-3-21", da: "Focus on project sustainability."
                   },
                   {
                    id: "pf-0-3-22", da: "Conduct regular progress reviews."
                   },
                   {
                    id: "pf-0-3-23", da: "Communicate project updates to the public."
                   },
                   {
                    id: "pf-0-3-24", da: "Build a diverse and inclusive team."
                   },
                   {
                    id: "pf-0-3-25", da: "Encourage innovative solutions."
                   },
                   {
                    id: "pf-0-3-26", da: "Invest in staff training and development."
                   },
                   {
                    id: "pf-0-3-27", da: "Identify potential cost-saving measures."
                   },
                   {
                    id: "pf-0-3-28", da: "Implement green and sustainable practices."
                   },
                   {
                    id: "pf-0-3-29", da: "Explore public-private partnerships."
                   },
                   {
                    id: "pf-0-3-30", da: "Promote project transparency and accountability."
                   },
                   {
                    id: "pf-0-3-31", da: "Ensure the equitable distribution of benefits."
                   },
                   {
                    id: "pf-0-3-32", da: "Evaluate the social impact of the project."
                   },
                   {
                    id: "pf-0-3-33", da: "Conduct regular performance assessments."
                   },
                   {
                    id: "pf-0-3-34", da: "Encourage public participation and feedback."
                   },
                   {
                    id: "pf-0-3-35", da: "Address community concerns and objections."
                   },
                   {
                    id: "pf-0-3-36", da: "Consider long-term economic benefits."
                   },
                   {
                    id: "pf-0-3-37", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "pf-0-3-38", da: "Promote local job creation."
                   },
                   {
                    id: "pf-0-3-39", da: "Align project objectives with community needs."
                   },
                   {
                    id: "pf-0-3-40", da: "Seek input from subject matter experts."
                   },
                   {
                    id: "pf-0-3-41", da: "Consider scalability and replicability."
                   },
                   {
                    id: "pf-0-3-42", da: "Invest in technology and infrastructure."
                   },
                   {
                    id: "pf-0-3-43", da: "Develop a robust marketing and Tracking Open calls plan."
                   },
                   {
                    id: "pf-0-3-44", da: "Collaborate with educational institutions."
                   },
                   {
                    id: "pf-0-3-45", da: "Ensure project resilience to external factors."
                   },
                   {
                    id: "pf-0-3-46", da: "Promote knowledge sharing and capacity building."
                   },
                   {
                    id: "pf-0-3-47", da: "Address inequalities and disparities."
                   },
                   {
                    id: "pf-0-3-48", da: "Celebrate project successes and milestones."
                   },
                   {
                    id: "pf-0-3-49", da: "Continuously adapt and evolve the project to meet changing needs."
                   },
                ]
              },
              {
                id: 'pf-0-4',
                pm: 'The team has achieved joint operating business models in collaboration with others. Business Model is considered innovative and a strong competitive advantage in itself.',
                title:'Business Model',
                pmMap: 'The team has achieved joint operating business models in collaboration with others. Business Model is considered innovative and a strong competitive advantage in itself.',
                developmentActions:[
                  {
                    id: "pf-0-4-0", da: "Conduct a comprehensive business model analysis."
                   },
                   {
                    id: "pf-0-4-1", da: "Identify key areas for improvement."
                   },
                   {
                    id: "pf-0-4-2", da: "Research available public funding opportunities."
                   },
                   {
                    id: "pf-0-4-3", da: "Create a detailed project plan."
                   },
                   {
                    id: "pf-0-4-4", da: "Define clear objectives and key performance indicators (KPIs)."
                   },
                   {
                    id: "pf-0-4-5", da: "Develop a budget that includes funding needs."
                   },
                   {
                    id: "pf-0-4-6", da: "Explore grants and subsidies for innovation."
                   },
                   {
                    id: "pf-0-4-7", da: "Investigate government-sponsored programs."
                   },
                   {
                    id: "pf-0-4-8", da: "Seek support from local economic development agencies."
                   },
                   {
                    id: "pf-0-4-9", da: "Collaborate with industry associations for funding options."
                   },
                   {
                    id: "pf-0-4-10", da: "Explore venture capital and angel investor networks."
                   },
                   {
                    id: "pf-0-4-11", da: "Leverage crowdfunding platforms for additional capital."
                   },
                   {
                    id: "pf-0-4-12", da: "Consider equity financing for long-term growth."
                   },
                   {
                    id: "pf-0-4-13", da: "Develop a strategic partnership with other businesses."
                   },
                   {
                    id: "pf-0-4-14", da: "Assess the impact of potential funding on your business."
                   },
                   {
                    id: "pf-0-4-15", da: "Determine the level of control you're willing to relinquish."
                   },
                   {
                    id: "pf-0-4-16", da: "Create a business plan that aligns with funding goals."
                   },
                   {
                    id: "pf-0-4-17", da: "Develop a compelling pitch for potential investors."
                   },
                   {
                    id: "pf-0-4-18", da: "Engage with financial advisors and consultants."
                   },
                   {
                    id: "pf-0-4-19", da: "Explore tax incentives for research and development."
                   },
                   {
                    id: "pf-0-4-20", da: "Investigate low-interest loans and loan guarantees."
                   },
                   {
                    id: "pf-0-4-21", da: "Analyze the impact of grant funding on your business."
                   },
                   {
                    id: "pf-0-4-22", da: "Ensure compliance with funding requirements."
                   },
                   {
                    id: "pf-0-4-23", da: "Build a strong team capable of executing the plan."
                   },
                   {
                    id: "pf-0-4-24", da: "Develop a contingency plan for funding gaps."
                   },
                   {
                    id: "pf-0-4-25", da: "Consider partnerships with academic institutions."
                   },
                   {
                    id: "pf-0-4-26", da: "Invest in technology and infrastructure upgrades."
                   },
                   {
                    id: "pf-0-4-27", da: "Focus on sustainable and eco-friendly initiatives."
                   },
                   {
                    id: "pf-0-4-28", da: "Expand marketing and branding efforts."
                   },
                   {
                    id: "pf-0-4-29", da: "Conduct market research to identify growth opportunities."
                   },
                   {
                    id: "pf-0-4-30", da: "Optimize supply chain and logistics for efficiency."
                   },
                   {
                    id: "pf-0-4-31", da: "Enhance customer service and support."
                   },
                   {
                    id: "pf-0-4-32", da: "Improve product and service quality."
                   },
                   {
                    id: "pf-0-4-33", da: "Develop a clear pricing strategy."
                   },
                   {
                    id: "pf-0-4-34", da: "Streamline internal processes and workflows."
                   },
                   {
                    id: "pf-0-4-35", da: "Invest in employee training and development."
                   },
                   {
                    id: "pf-0-4-36", da: "Explore expansion into new markets."
                   },
                   {
                    id: "pf-0-4-37", da: "Diversify product or service offerings."
                   },
                   {
                    id: "pf-0-4-38", da: "Conduct customer surveys for feedback."
                   },
                   {
                    id: "pf-0-4-39", da: "Upgrade your digital presence and e-commerce capabilities."
                   },
                   {
                    id: "pf-0-4-40", da: "Create a robust social media strategy."
                   },
                   {
                    id: "pf-0-4-41", da: "Investigate data analytics and business intelligence."
                   },
                   {
                    id: "pf-0-4-42", da: "Implement cost-cutting measures where necessary."
                   },
                   {
                    id: "pf-0-4-43", da: "Optimize your sales and distribution channels."
                   },
                   {
                    id: "pf-0-4-44", da: "Enhance risk management and cybersecurity."
                   },
                   {
                    id: "pf-0-4-45", da: "Evaluate the competitive landscape regularly."
                   },
                   {
                    id: "pf-0-4-46", da: "Explore global export opportunities."
                   },
                   {
                    id: "pf-0-4-47", da: "Invest in research and development."
                   },
                   {
                    id: "pf-0-4-48", da: "Engage in corporate social responsibility initiatives."
                   },
                   {
                    id: "pf-0-4-49", da: "Monitor and measure progress against KPIs."
                   },
                ]
              },
              {
                id: 'pf-0-5',
                pm: 'Team serves different markets, via multiple channels with different products.',
                title:'Go to Market',
                pmMap: 'Team serves different markets, via multiple channels with different products.',
                developmentActions:[
                  {
                    id: "pf-0-5-0", da: "Identify available public funding programs supporting Go to Market initiatives."
                   },
                   {
                    id: "pf-0-5-1", da: "Research and understand the eligibility criteria for these funding opportunities."
                   },
                   {
                    id: "pf-0-5-2", da: "Establish a clear roadmap for your Go to Market strategy."
                   },
                   {
                    id: "pf-0-5-3", da: "Create a detailed business plan outlining your market approach."
                   },
                   {
                    id: "pf-0-5-4", da: "Define measurable goals and objectives for your Go to Market efforts."
                   },
                   {
                    id: "pf-0-5-5", da: "Assess the potential impact of your strategy on the target market."
                   },
                   {
                    id: "pf-0-5-6", da: "Develop a comprehensive budget for your Go to Market plan."
                   },
                   {
                    id: "pf-0-5-7", da: "Seek guidance from experts in public funding and business development."
                   },
                   {
                    id: "pf-0-5-8", da: "Explore grants and subsidies specific to your industry or sector."
                   },
                   {
                    id: "pf-0-5-9", da: "Leverage government-sponsored incubators and accelerators."
                   },
                   {
                    id: "pf-0-5-10", da: "Investigate tax incentives and credits applicable to your strategy."
                   },
                   {
                    id: "pf-0-5-11", da: "Analyze the competitive landscape in your target market."
                   },
                   {
                    id: "pf-0-5-12", da: "Form strategic partnerships with complementary businesses."
                   },
                   {
                    id: "pf-0-5-13", da: "Focus on market research to identify customer pain points."
                   },
                   {
                    id: "pf-0-5-14", da: "Conduct surveys and gather customer feedback."
                   },
                   {
                    id: "pf-0-5-15", da: "Develop a strong value proposition for your product or service."
                   },
                   {
                    id: "pf-0-5-16", da: "Enhance your product or service based on market insights."
                   },
                   {
                    id: "pf-0-5-17", da: "Consider crowdfunding as a funding source."
                   },
                   {
                    id: "pf-0-5-18", da: "Explore venture capital or angel investor opportunities."
                   },
                   {
                    id: "pf-0-5-19", da: "Collaborate with industry associations and trade groups."
                   },
                   {
                    id: "pf-0-5-20", da: "Establish a clear marketing and sales strategy."
                   },
                   {
                    id: "pf-0-5-21", da: "Identify the most effective marketing channels for your audience."
                   },
                   {
                    id: "pf-0-5-22", da: "Optimize your online presence and digital marketing efforts."
                   },
                   {
                    id: "pf-0-5-23", da: "Leverage social media for customer engagement."
                   },
                   {
                    id: "pf-0-5-24", da: "Build a network of industry influencers and thought leaders."
                   },
                   {
                    id: "pf-0-5-25", da: "Develop compelling content marketing materials."
                   },
                   {
                    id: "pf-0-5-26", da: "Consider trade shows and industry events for promotion."
                   },
                   {
                    id: "pf-0-5-27", da: "Develop a strong online presence with a user-friendly website."
                   },
                   {
                    id: "pf-0-5-28", da: "Create a lead generation and conversion strategy."
                   },
                   {
                    id: "pf-0-5-29", da: "Develop partnerships with key distribution channels."
                   },
                   {
                    id: "pf-0-5-30", da: "Offer competitive pricing and promotions."
                   },
                   {
                    id: "pf-0-5-31", da: "Ensure strong customer support and after-sales service."
                   },
                   {
                    id: "pf-0-5-32", da: "Monitor and measure the success of your strategy."
                   },
                   {
                    id: "pf-0-5-33", da: "Be flexible and willing to adjust your Go to Market plan."
                   },
                   {
                    id: "pf-0-5-34", da: "Seek mentorship and guidance from experienced entrepreneurs."
                   },
                   {
                    id: "pf-0-5-35", da: "Investigate opportunities for export and global expansion."
                   },
                   {
                    id: "pf-0-5-36", da: "Consider market entry strategies such as licensing or franchising."
                   },
                   {
                    id: "pf-0-5-37", da: "Develop a robust supply chain and distribution strategy."
                   },
                   {
                    id: "pf-0-5-38", da: "Ensure compliance with relevant regulations and standards."
                   },
                   {
                    id: "pf-0-5-39", da: "Identify opportunities for joint ventures and mergers."
                   },
                   {
                    id: "pf-0-5-40", da: "Explore opportunities to patent or protect intellectual property."
                   },
                   {
                    id: "pf-0-5-41", da: "Develop a clear brand identity and positioning."
                   },
                   {
                    id: "pf-0-5-42", da: "Leverage market segmentation for targeted marketing."
                   },
                   {
                    id: "pf-0-5-43", da: "Build a scalable and adaptable business model."
                   },
                   {
                    id: "pf-0-5-44", da: "Explore e-commerce and online sales platforms."
                   },
                   {
                    id: "pf-0-5-45", da: "Develop a crisis management and risk mitigation plan."
                   },
                   {
                    id: "pf-0-5-46", da: "Invest in employee training and development."
                   },
                   {
                    id: "pf-0-5-47", da: "Prioritize sustainability and corporate social responsibility."
                   },
                   {
                    id: "pf-0-5-48", da: "Foster innovation and continuous improvement."
                   },
                   {
                    id: "pf-0-5-49", da: "Build a strong, customer-centric organizational culture."
                   },
                ]
              },
              {
                id: 'pf-0-6',
                pm: 'High performing leadership team in all departments. CFO is hired that brings prior exit experience (if not already available).',
                title:'People',
                pmMap: 'High performing leadership team in all departments. CFO is hired that brings prior exit experience (if not already available).',
                developmentActions:[
                  {
                    id: "pf-0-6-0", da: "Invest in quality education at all levels."
                   },
                   {
                    id: "pf-0-6-1", da: "Promote lifelong learning and adult education programs."
                   },
                   {
                    id: "pf-0-6-2", da: "Provide scholarships and financial aid for underprivileged students."
                   },
                   {
                    id: "pf-0-6-3", da: "Support vocational and technical training."
                   },
                   {
                    id: "pf-0-6-4", da: "Develop job placement and career counseling services."
                   },
                   {
                    id: "pf-0-6-5", da: "Fund research and innovation in education methods."
                   },
                   {
                    id: "pf-0-6-6", da: "Improve access to healthcare services."
                   },
                   {
                    id: "pf-0-6-7", da: "Enhance mental health support and awareness."
                   },
                   {
                    id: "pf-0-6-8", da: "Promote a healthy lifestyle through fitness and nutrition programs."
                   },
                   {
                    id: "pf-0-6-9", da: "Support maternal and child health initiatives."
                   },
                   {
                    id: "pf-0-6-10", da: "Fund addiction prevention and treatment centers."
                   },
                   {
                    id: "pf-0-6-11", da: "Provide housing assistance for low-income families."
                   },
                   {
                    id: "pf-0-6-12", da: "Improve public transportation for easier access to jobs and services."
                   },
                   {
                    id: "pf-0-6-13", da: "Invest in infrastructure development for economic growth."
                   },
                   {
                    id: "pf-0-6-14", da: "Promote small business development and entrepreneurship."
                   },
                   {
                    id: "pf-0-6-15", da: "Support farmers and agriculture to ensure food security."
                   },
                   {
                    id: "pf-0-6-16", da: "Fund arts and culture programs for creative expression."
                   },
                   {
                    id: "pf-0-6-17", da: "Enhance access to clean water and sanitation."
                   },
                   {
                    id: "pf-0-6-18", da: "Invest in renewable energy sources for sustainability."
                   },
                   {
                    id: "pf-0-6-19", da: "Promote environmental conservation and reduce pollution."
                   },
                   {
                    id: "pf-0-6-20", da: "Support programs for gender equality and women's empowerment."
                   },
                   {
                    id: "pf-0-6-21", da: "Fund initiatives to combat discrimination and promote diversity."
                   },
                   {
                    id: "pf-0-6-22", da: "Improve access to legal aid for vulnerable populations."
                   },
                   {
                    id: "pf-0-6-23", da: "Enhance public safety and community policing."
                   },
                   {
                    id: "pf-0-6-24", da: "Support youth development and mentorship programs."
                   },
                   {
                    id: "pf-0-6-25", da: "Fund elderly care and social services."
                   },
                   {
                    id: "pf-0-6-26", da: "Promote civic engagement and participation."
                   },
                   {
                    id: "pf-0-6-27", da: "Support refugees and displaced populations."
                   },
                   {
                    id: "pf-0-6-28", da: "Improve access to information technology and the internet."
                   },
                   {
                    id: "pf-0-6-29", da: "Fund cultural exchange and diplomacy efforts."
                   },
                   {
                    id: "pf-0-6-30", da: "Enhance disaster preparedness and response."
                   },
                   {
                    id: "pf-0-6-31", da: "Support community development projects."
                   },
                   {
                    id: "pf-0-6-32", da: "Invest in scientific and medical research."
                   },
                   {
                    id: "pf-0-6-33", da: "Promote innovation and technology startups."
                   },
                   {
                    id: "pf-0-6-34", da: "Fund infrastructure for clean and safe drinking water."
                   },
                   {
                    id: "pf-0-6-35", da: "Support job retraining and upskilling."
                   },
                   {
                    id: "pf-0-6-36", da: "Improve transportation infrastructure in rural areas."
                   },
                   {
                    id: "pf-0-6-37", da: "Fund after-school programs and extracurricular activities."
                   },
                   {
                    id: "pf-0-6-38", da: "Enhance access to legal representation for all."
                   },
                   {
                    id: "pf-0-6-39", da: "Support programs for individuals with disabilities."
                   },
                   {
                    id: "pf-0-6-40", da: "Promote vocational rehabilitation for those with disabilities."
                   },
                   {
                    id: "pf-0-6-41", da: "Invest in early childhood education and care."
                   },
                   {
                    id: "pf-0-6-42", da: "Fund programs for substance abuse prevention and recovery."
                   },
                   {
                    id: "pf-0-6-43", da: "Support veterans' services and mental health care."
                   },
                   {
                    id: "pf-0-6-44", da: "Improve public libraries and access to knowledge."
                   },
                   {
                    id: "pf-0-6-45", da: "Enhance the availability of affordable housing."
                   },
                   {
                    id: "pf-0-6-46", da: "Promote financial literacy and economic education."
                   },
                   {
                    id: "pf-0-6-47", da: "Support the arts, including museums and galleries."
                   },
                   {
                    id: "pf-0-6-48", da: "Fund programs for at-risk youth and delinquency prevention."
                   },
                   {
                    id: "pf-0-6-49", da: "Invest in clean and sustainable public transportation."
                   },
                ]
              },
              {
                id: 'pf-0-7',
                pm: 'All KPIs and metrics are being tracked and 3 year projections are ready. Cashflow document is always up-to-date.',
                title:'Data Metrics',
                pmMap: 'All KPIs and metrics are being tracked and 3 year projections are ready. Cashflow document is always up-to-date.',
                developmentActions:[
                  {
                    id: "pf-0-7-0", da: "Define clear and measurable data metrics."
                   },
                   {
                    id: "pf-0-7-1", da: "Establish key performance indicators (KPIs) for each project."
                   },
                   {
                    id: "pf-0-7-2", da: "Implement a robust data collection system."
                   },
                   {
                    id: "pf-0-7-3", da: "Ensure data accuracy and reliability."
                   },
                   {
                    id: "pf-0-7-4", da: "Standardize data collection methods."
                   },
                   {
                    id: "pf-0-7-5", da: "Use technology for efficient data capture."
                   },
                   {
                    id: "pf-0-7-6", da: "Develop a data governance framework."
                   },
                   {
                    id: "pf-0-7-7", da: "Train staff in data collection and analysis."
                   },
                   {
                    id: "pf-0-7-8", da: "Regularly audit data sources."
                   },
                   {
                    id: "pf-0-7-9", da: "Monitor data quality."
                   },
                   {
                    id: "pf-0-7-10", da: "Create a centralized data repository."
                   },
                   {
                    id: "pf-0-7-11", da: "Secure data to maintain privacy."
                   },
                   {
                    id: "pf-0-7-12", da: "Conduct data impact assessments."
                   },
                   {
                    id: "pf-0-7-13", da: "Establish data sharing agreements."
                   },
                   {
                    id: "pf-0-7-14", da: "Use open data standards."
                   },
                   {
                    id: "pf-0-7-15", da: "Foster data transparency."
                   },
                   {
                    id: "pf-0-7-16", da: "Encourage data sharing among stakeholders."
                   },
                   {
                    id: "pf-0-7-17", da: "Develop data dashboards for real-time tracking."
                   },
                   {
                    id: "pf-0-7-18", da: "Use data analytics for insights."
                   },
                   {
                    id: "pf-0-7-19", da: "Establish baselines for data comparison."
                   },
                   {
                    id: "pf-0-7-20", da: "Leverage geographic information systems (GIS) for spatial data."
                   },
                   {
                    id: "pf-0-7-21", da: "Create data visualization tools."
                   },
                   {
                    id: "pf-0-7-22", da: "Monitor project milestones and outcomes."
                   },
                   {
                    id: "pf-0-7-23", da: "Measure project effectiveness."
                   },
                   {
                    id: "pf-0-7-24", da: "Assess the impact on target populations."
                   },
                   {
                    id: "pf-0-7-25", da: "Analyze demographic data."
                   },
                   {
                    id: "pf-0-7-26", da: "Evaluate socio-economic indicators."
                   },
                   {
                    id: "pf-0-7-27", da: "Collect data on environmental impact."
                   },
                   {
                    id: "pf-0-7-28", da: "Consider gender-based data analysis."
                   },
                   {
                    id: "pf-0-7-29", da: "Track resource allocation."
                   },
                   {
                    id: "pf-0-7-30", da: "Assess cost-effectiveness."
                   },
                   {
                    id: "pf-0-7-31", da: "Benchmark against industry standards."
                   },
                   {
                    id: "pf-0-7-32", da: "Analyze historical data trends."
                   },
                   {
                    id: "pf-0-7-33", da: "Evaluate project risks."
                   },
                   {
                    id: "pf-0-7-34", da: "Use data to improve decision-making."
                   },
                   {
                    id: "pf-0-7-35", da: "Identify areas for process improvement."
                   },
                   {
                    id: "pf-0-7-36", da: "Review data on public opinion and feedback."
                   },
                   {
                    id: "pf-0-7-37", da: "Consider the scalability of projects."
                   },
                   {
                    id: "pf-0-7-38", da: "Analyze the return on investment."
                   },
                   {
                    id: "pf-0-7-39", da: "Assess data security measures."
                   },
                   {
                    id: "pf-0-7-40", da: "Implement data encryption."
                   },
                   {
                    id: "pf-0-7-41", da: "Promote data accessibility."
                   },
                   {
                    id: "pf-0-7-42", da: "Use data to create public reports."
                   },
                   {
                    id: "pf-0-7-43", da: "Consider real-time data reporting."
                   },
                   {
                    id: "pf-0-7-44", da: "Develop data-driven policy recommendations."
                   },
                   {
                    id: "pf-0-7-45", da: "Address data silos."
                   },
                   {
                    id: "pf-0-7-46", da: "Conduct data audits for compliance."
                   },
                   {
                    id: "pf-0-7-47", da: "Ensure data interoperability."
                   },
                   {
                    id: "pf-0-7-48", da: "Engage with data experts and analysts."
                   },
                   {
                    id: "pf-0-7-49", da: "Continuously review and adapt data metrics for improvement."
                   },
                ]
              },
              {
                id: 'pf-0-8',
                pm: 'Establish operational excellence.',
                title:'Operations',
                pmMap: 'Establish operational excellence.',
                developmentActions:[
                  {
                    id: "pf-0-8-0", da: "Invest in upgrading and modernizing existing infrastructure."
                   },
                   {
                    id: "pf-0-8-1", da: "Develop and implement a comprehensive project management system."
                   },
                   {
                    id: "pf-0-8-2", da: "Enhance transparency in project selection and allocation of funds."
                   },
                   {
                    id: "pf-0-8-3", da: "Establish clear performance metrics and key performance indicators (KPIs)."
                   },
                   {
                    id: "pf-0-8-4", da: "Promote collaboration and knowledge sharing among government agencies."
                   },
                   {
                    id: "pf-0-8-5", da: "Allocate resources for research and development."
                   },
                   {
                    id: "pf-0-8-6", da: "Create a dedicated fund for innovation and technology adoption."
                   },
                   {
                    id: "pf-0-8-7", da: "Strengthen cybersecurity measures for critical infrastructure."
                   },
                   {
                    id: "pf-0-8-8", da: "Support vocational and technical training programs."
                   },
                   {
                    id: "pf-0-8-9", da: "Expand access to high-quality healthcare services."
                   },
                   {
                    id: "pf-0-8-10", da: "Improve public transportation networks."
                   },
                   {
                    id: "pf-0-8-11", da: "Invest in renewable energy projects."
                   },
                   {
                    id: "pf-0-8-12", da: "Upgrade and expand broadband internet access."
                   },
                   {
                    id: "pf-0-8-13", da: "Support small and medium-sized enterprises (SMEs)."
                   },
                   {
                    id: "pf-0-8-14", da: "Develop a skilled workforce through education and training programs."
                   },
                   {
                    id: "pf-0-8-15", da: "Enhance emergency response and disaster preparedness."
                   },
                   {
                    id: "pf-0-8-16", da: "Invest in clean energy and sustainable practices."
                   },
                   {
                    id: "pf-0-8-17", da: "Implement eco-friendly waste management solutions."
                   },
                   {
                    id: "pf-0-8-18", da: "Promote rural development and agriculture initiatives."
                   },
                   {
                    id: "pf-0-8-19", da: "Upgrade water and sanitation infrastructure."
                   },
                   {
                    id: "pf-0-8-20", da: "Develop affordable housing solutions."
                   },
                   {
                    id: "pf-0-8-21", da: "Improve public safety through enhanced law enforcement."
                   },
                   {
                    id: "pf-0-8-22", da: "Invest in green and smart city initiatives."
                   },
                   {
                    id: "pf-0-8-23", da: "Enhance public education facilities and programs."
                   },
                   {
                    id: "pf-0-8-24", da: "Support cultural and artistic endeavors."
                   },
                   {
                    id: "pf-0-8-25", da: "Strengthen public health and disease prevention efforts."
                   },
                   {
                    id: "pf-0-8-26", da: "Upgrade public spaces and recreational areas."
                   },
                   {
                    id: "pf-0-8-27", da: "Invest in public research and development institutions."
                   },
                   {
                    id: "pf-0-8-28", da: "Expand access to quality childcare and early education."
                   },
                   {
                    id: "pf-0-8-29", da: "Promote gender equality and women's empowerment."
                   },
                   {
                    id: "pf-0-8-30", da: "Support initiatives to reduce poverty and inequality."
                   },
                   {
                    id: "pf-0-8-31", da: "Invest in job creation and workforce development."
                   },
                   {
                    id: "pf-0-8-32", da: "Develop clean and sustainable transportation solutions."
                   },
                   {
                    id: "pf-0-8-33", da: "Strengthen public-private partnerships for infrastructure projects."
                   },
                   {
                    id: "pf-0-8-34", da: "Support affordable and accessible healthcare."
                   },
                   {
                    id: "pf-0-8-35", da: "Enhance public transit and mobility options."
                   },
                   {
                    id: "pf-0-8-36", da: "Invest in renewable energy and clean technologies."
                   },
                   {
                    id: "pf-0-8-37", da: "Upgrade and modernize educational institutions."
                   },
                   {
                    id: "pf-0-8-38", da: "Promote environmentally friendly agriculture practices."
                   },
                   {
                    id: "pf-0-8-39", da: "Expand access to affordable housing."
                   },
                   {
                    id: "pf-0-8-40", da: "Strengthen public safety and emergency services."
                   },
                   {
                    id: "pf-0-8-41", da: "Invest in urban development and planning."
                   },
                   {
                    id: "pf-0-8-42", da: "Support public health research and disease prevention."
                   },
                   {
                    id: "pf-0-8-43", da: "Upgrade public libraries and cultural institutions."
                   },
                   {
                    id: "pf-0-8-44", da: "Enhance social services and support for vulnerable populations."
                   },
                   {
                    id: "pf-0-8-45", da: "Invest in sustainable and green building practices."
                   },
                   {
                    id: "pf-0-8-46", da: "Develop inclusive and accessible public spaces."
                   },
                   {
                    id: "pf-0-8-47", da: "Promote digital literacy and technology access."
                   },
                   {
                    id: "pf-0-8-48", da: "Support initiatives to combat climate change."
                   },
                   {
                    id: "pf-0-8-49", da: "Invest in research and development for emerging technologies."
                   },
                ]
              },
              {
                id: 'pf-0-9',
                pm: 'Fine-tune the equity story and valuation framework based on initial feedback from investors.',
                title:'Exit Strategy',
                pmMap: 'Fine-tune the equity story and valuation framework based on initial feedback from investors.',
                developmentActions:[
                  {
                    id: "pf-0-9-0", da: " Start planning the exit strategy from the beginning of the project."
                   },
                   {
                    id: "pf-0-9-1", da: " Involve all stakeholders in exit discussions."
                   },
                   {
                    id: "pf-0-9-2", da: " Define clear and measurable exit objectives."
                   },
                   {
                    id: "pf-0-9-3", da: " Ensure that project outcomes are sustainable after funding ends."
                   },
                   {
                    id: "pf-0-9-4", da: " Promote local ownership of the project's future."
                   },
                   {
                    id: "pf-0-9-5", da: " Strengthen local capacity for project management."
                   },
                   {
                    id: "pf-0-9-6", da: " Continuously assess and mitigate risks associated with the exit."
                   },
                   {
                    id: "pf-0-9-7", da: " Address legal and regulatory aspects of exit."
                   },
                   {
                    id: "pf-0-9-8", da: " Identify sustainable funding sources post-exit."
                   },
                   {
                    id: "pf-0-9-9", da: " Implement robust M&E systems for tracking progress."
                   },
                   {
                    id: "pf-0-9-10", da: " Be flexible and adapt the exit plan as needed."
                   },
                   {
                    id: "pf-0-9-11", da: " Consider a phased or gradual exit process."
                   },
                   {
                    id: "pf-0-9-12", da: " Transparently communicate the exit strategy to all stakeholders."
                   },
                   {
                    id: "pf-0-9-13", da: " Keep comprehensive records and documentation."
                   },
                   {
                    id: "pf-0-9-14", da: " Develop contingency plans for unexpected challenges."
                   },
                   {
                    id: "pf-0-9-15", da: " Collect feedback from project beneficiaries."
                   },
                   {
                    id: "pf-0-9-16", da: " Assess the economic impact of the exit on the community."
                   },
                   {
                    id: "pf-0-9-17", da: " Measure and address the social impact of the exit."
                   },
                   {
                    id: "pf-0-9-18", da: " Consider environmental sustainability post-exit."
                   },
                   {
                    id: "pf-0-9-19", da: " Transfer relevant technology or skills."
                   },
                   {
                    id: "pf-0-9-20", da: " Promote knowledge sharing and capacity transfer."
                   },
                   {
                    id: "pf-0-9-21", da: " Foster integration into local markets."
                   },
                   {
                    id: "pf-0-9-22", da: " Train local staff for post-exit management."
                   },
                   {
                    id: "pf-0-9-23", da: " Appoint an exit team or coordinator."
                   },
                   {
                    id: "pf-0-9-24", da: " Map available local resources."
                   },
                   {
                    id: "pf-0-9-25", da: " Ensure compliance with local legal frameworks."
                   },
                   {
                    id: "pf-0-9-26", da: " Engage the community in exit planning."
                   },
                   {
                    id: "pf-0-9-27", da: " Define specific exit indicators."
                   },
                   {
                    id: "pf-0-9-28", da: " Conduct cost-benefit analysis of the exit."
                   },
                   {
                    id: "pf-0-9-29", da: " Address potential conflicts related to the exit."
                   },
                   {
                    id: "pf-0-9-30", da: " Create a feedback loop for lessons learned."
                   },
                   {
                    id: "pf-0-9-31", da: " Plan for transitioning partnerships."
                   },
                   {
                    id: "pf-0-9-32", da: " Ensure the continuity of essential programs."
                   },
                   {
                    id: "pf-0-9-33", da: " Organize workshops on exit strategies."
                   },
                   {
                    id: "pf-0-9-34", da: " Ensure that project data remains accessible."
                   },
                   {
                    id: "pf-0-9-35", da: " Identify future funding sources."
                   },
                   {
                    id: "pf-0-9-36", da: " Integrate into local value chains."
                   },
                   {
                    id: "pf-0-9-37", da: " Assess the long-term impact post-exit."
                   },
                   {
                    id: "pf-0-9-38", da: " Support local businesses and enterprises."
                   },
                   {
                    id: "pf-0-9-39", da: " Manage public relations during exit."
                   },
                   {
                    id: "pf-0-9-40", da: " Plan for succession in leadership roles."
                   },
                   {
                    id: "pf-0-9-41", da: " Address the handover of infrastructure."
                   },
                   {
                    id: "pf-0-9-42", da: " Develop training materials for local use."
                   },
                   {
                    id: "pf-0-9-43", da: " Analyze local market dynamics."
                   },
                   {
                    id: "pf-0-9-44", da: " Preserve project knowledge."
                   },
                   {
                    id: "pf-0-9-45", da: " Involve the community in exit plans."
                   },
                   {
                    id: "pf-0-9-46", da: " Conduct financial audits during exit."
                   },
                   {
                    id: "pf-0-9-47", da: " Ensure compliance with local regulations."
                   },
                   {
                    id: "pf-0-9-48", da: " Consider how the project may influence policies."
                   },
                   {
                    id: "pf-0-9-49", da: " Perform a comprehensive final project evaluation."
                   },
                ]
              }
            ]
          },
          {
            id: 'pf-1',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Tracking Open calls',
            wdd: '',
            progressMeasures:[
              {
                id: 'pf-1-0',
                pm: 'Subscription to various funding lists and newsletters.',
                title:'Need',
                pmMap: 'Subscription to various funding lists and newsletters.',
                developmentActions:[
                  {
                    id: "pf-1-0-0", da: "Transparency in public funding allocation."
                   },
                   {
                    id: "pf-1-0-1", da: "Equitable distribution of funds across regions."
                   },
                   {
                    id: "pf-1-0-2", da: "Timely release of funding information."
                   },
                   {
                    id: "pf-1-0-3", da: "Clear eligibility criteria for funding applications."
                   },
                   {
                    id: "pf-1-0-4", da: "Efficient application and approval processes."
                   },
                   {
                    id: "pf-1-0-5", da: "Ensuring inclusivity in development projects."
                   },
                   {
                    id: "pf-1-0-6", da: "Monitoring and evaluation of funded projects."
                   },
                   {
                    id: "pf-1-0-7", da: "Allocating funds for infrastructure development."
                   },
                   {
                    id: "pf-1-0-8", da: "Funding for social and welfare programs."
                   },
                   {
                    id: "pf-1-0-9", da: "Encouraging innovation in development projects."
                   },
                   {
                    id: "pf-1-0-10", da: "Involvement of local communities in decision-making."
                   },
                   {
                    id: "pf-1-0-11", da: "Tracking funds allocated to education initiatives."
                   },
                   {
                    id: "pf-1-0-12", da: "Monitoring environmental sustainability efforts."
                   },
                   {
                    id: "pf-1-0-13", da: "Ensuring gender equality in development projects."
                   },
                   {
                    id: "pf-1-0-14", da: "Funding for healthcare and medical services."
                   },
                   {
                    id: "pf-1-0-15", da: "Promoting research and development."
                   },
                   {
                    id: "pf-1-0-16", da: "Support for small and medium-sized enterprises."
                   },
                   {
                    id: "pf-1-0-17", da: "Encouraging entrepreneurship and startups."
                   },
                   {
                    id: "pf-1-0-18", da: "Funding for cultural and artistic initiatives."
                   },
                   {
                    id: "pf-1-0-19", da: "Investment in renewable energy projects."
                   },
                   {
                    id: "pf-1-0-20", da: "Allocating resources for affordable housing."
                   },
                   {
                    id: "pf-1-0-21", da: "Promoting digital infrastructure development."
                   },
                   {
                    id: "pf-1-0-22", da: "Tracking funds for disaster preparedness."
                   },
                   {
                    id: "pf-1-0-23", da: "Supporting agriculture and rural development."
                   },
                   {
                    id: "pf-1-0-24", da: "Funding for vocational training programs."
                   },
                   {
                    id: "pf-1-0-25", da: "Ensuring accountability in fund utilization."
                   },
                   {
                    id: "pf-1-0-26", da: "Encouraging public-private partnerships."
                   },
                   {
                    id: "pf-1-0-27", da: "Investment in public transportation systems."
                   },
                   {
                    id: "pf-1-0-28", da: "Transparency in government procurement."
                   },
                   {
                    id: "pf-1-0-29", da: "Allocating resources for job creation."
                   },
                   {
                    id: "pf-1-0-30", da: "Monitoring public health initiatives."
                   },
                   {
                    id: "pf-1-0-31", da: "Funding for clean water and sanitation."
                   },
                   {
                    id: "pf-1-0-32", da: "Promoting international development."
                   },
                   {
                    id: "pf-1-0-33", da: "Support for research on climate change."
                   },
                   {
                    id: "pf-1-0-34", da: "Investment in infrastructure for trade."
                   },
                   {
                    id: "pf-1-0-35", da: "Tracking funds for poverty alleviation."
                   },
                   {
                    id: "pf-1-0-36", da: "Supporting youth development programs."
                   },
                   {
                    id: "pf-1-0-37", da: "Ensuring food security initiatives."
                   },
                   {
                    id: "pf-1-0-38", da: "Encouraging sustainable tourism."
                   },
                   {
                    id: "pf-1-0-39", da: "Funding for wildlife conservation."
                   },
                   {
                    id: "pf-1-0-40", da: "Investment in public safety initiatives."
                   },
                   {
                    id: "pf-1-0-41", da: "Allocating resources for skills development."
                   },
                   {
                    id: "pf-1-0-42", da: "Monitoring funds for peacebuilding efforts."
                   },
                   {
                    id: "pf-1-0-43", da: "Promoting human rights and justice."
                   },
                   {
                    id: "pf-1-0-44", da: "Support for refugee and migration programs."
                   },
                   {
                    id: "pf-1-0-45", da: "Funding for technological advancement."
                   },
                   {
                    id: "pf-1-0-46", da: "Investment in public libraries and education."
                   },
                   {
                    id: "pf-1-0-47", da: "Tracking funds for community development."
                   },
                   {
                    id: "pf-1-0-48", da: "Ensuring transparency in grant reporting."
                   },
                   {
                    id: "pf-1-0-49", da: "Encouraging anti-corruption measures."
                   },
                ]
              },
              {
                id: 'pf-1-1',
                pm: 'There are enough calls in the market to apply to. The market os big enough to have many actors allocating capital to solve.',
                title:'Market',
                pmMap: 'There are enough calls in the market to apply to. The market os big enough to have many actors allocating capital to solve.',
                developmentActions:[
                  {
                    id: "pf-1-1-0", da: " Research government grants and funding opportunities available for market development."
                   },
                   {
                    id: "pf-1-1-1", da: " Investigate collaborations between the public sector and private businesses to boost market growth."
                   },
                   {
                    id: "pf-1-1-2", da: " Stay updated on open calls and grant opportunities through official government websites."
                   },
                   {
                    id: "pf-1-1-3", da: " Focus on funding opportunities that cater to local market development."
                   },
                   {
                    id: "pf-1-1-4", da: " Stay informed about economic trends that can affect market growth."
                   },
                   {
                    id: "pf-1-1-5", da: " Determine which sectors of the market require funding and support."
                   },
                   {
                    id: "pf-1-1-6", da: " Use market research to identify areas in need of development."
                   },
                   {
                    id: "pf-1-1-7", da: " Encourage entrepreneurship and small business growth with funding initiatives."
                   },
                   {
                    id: "pf-1-1-8", da: " Fund projects that promote innovation within the market."
                   },
                   {
                    id: "pf-1-1-9", da: " Offer grants for sustainable business practices."
                   },
                   {
                    id: "pf-1-1-10", da: " Support initiatives that enable businesses to enter global markets."
                   },
                   {
                    id: "pf-1-1-11", da: " Invest in workforce development and skill-building programs."
                   },
                   {
                    id: "pf-1-1-12", da: " Fund projects that improve market infrastructure, such as transportation and logistics."
                   },
                   {
                    id: "pf-1-1-13", da: " Encourage businesses to adopt cutting-edge technology."
                   },
                   {
                    id: "pf-1-1-14", da: " Allocate resources to educational institutions to nurture talent and skills."
                   },
                   {
                    id: "pf-1-1-15", da: " Encourage collaboration between local businesses and international partners."
                   },
                   {
                    id: "pf-1-1-16", da: " Support initiatives that make the market more competitive."
                   },
                   {
                    id: "pf-1-1-17", da: " Fund projects that improve access to financing for businesses."
                   },
                   {
                    id: "pf-1-1-18", da: " Create opportunities for underserved communities to access the market."
                   },
                   {
                    id: "pf-1-1-19", da: " Promote research and innovation with R&D grants."
                   },
                   {
                    id: "pf-1-1-20", da: " Support businesses in diversifying their product offerings."
                   },
                   {
                    id: "pf-1-1-21", da: " Fund marketing initiatives to increase market visibility."
                   },
                   {
                    id: "pf-1-1-22", da: " Work on reducing bureaucratic hurdles for businesses."
                   },
                   {
                    id: "pf-1-1-23", da: " Support eco-friendly business practices."
                   },
                   {
                    id: "pf-1-1-24", da: " Make it easier for businesses to secure funding through grants and loans."
                   },
                   {
                    id: "pf-1-1-25", da: " Promote events that connect businesses and potential investors."
                   },
                   {
                    id: "pf-1-1-26", da: " Invest in cultural activities that can attract tourists and stimulate the market."
                   },
                   {
                    id: "pf-1-1-27", da: " Allocate resources to promote sustainable farming practices."
                   },
                   {
                    id: "pf-1-1-28", da: " Fund initiatives that preserve and promote traditional craftsmanship."
                   },
                   {
                    id: "pf-1-1-29", da: " Support businesses that contribute to community health."
                   },
                   {
                    id: "pf-1-1-30", da: " Fund projects that optimize the supply chain for efficiency."
                   },
                   {
                    id: "pf-1-1-31", da: " Ensure that the market is accessible to people with disabilities."
                   },
                   {
                    id: "pf-1-1-32", da: " Invest in tourism-related projects to boost the local economy."
                   },
                   {
                    id: "pf-1-1-33", da: " Support initiatives for clean and renewable energy."
                   },
                   {
                    id: "pf-1-1-34", da: " Invest in data collection and analytics to guide market decisions."
                   },
                   {
                    id: "pf-1-1-35", da: " Fund urban development projects to attract more businesses."
                   },
                   {
                    id: "pf-1-1-36", da: " Offer grants to empower underrepresented entrepreneurs."
                   },
                   {
                    id: "pf-1-1-37", da: " Invest in digital infrastructure and broadband access."
                   },
                   {
                    id: "pf-1-1-38", da: " Foster innovation clusters and technology hubs."
                   },
                   {
                    id: "pf-1-1-39", da: " Support marine and maritime businesses."
                   },
                   {
                    id: "pf-1-1-40", da: " Develop research parks to drive innovation and commercialization."
                   },
                   {
                    id: "pf-1-1-41", da: " Promote international trade and border cooperation."
                   },
                   {
                    id: "pf-1-1-42", da: " Support the cultural sector and creative industries."
                   },
                   {
                    id: "pf-1-1-43", da: " Fund agriculture-related initiatives and agribusinesses."
                   },
                   {
                    id: "pf-1-1-44", da: " Build supportive environments for startups."
                   },
                   {
                    id: "pf-1-1-45", da: " Invest in cybersecurity initiatives to protect businesses."
                   },
                   {
                    id: "pf-1-1-46", da: " Fund programs that retrain and upskill the workforce."
                   },
                   {
                    id: "pf-1-1-47", da: " Invest in healthcare technology and services."
                   },
                   {
                    id: "pf-1-1-48", da: " Support urban development with a focus on sustainability."
                   },
                   {
                    id: "pf-1-1-49", da: " Help businesses navigate international trade and export challenges."
                   },
                ]
              },
              {
                id: 'pf-1-2',
                pm: 'Subscriptions, lists, and CRMs in place to tracek and apply to calls.',
                title:'Technology',
                pmMap: 'Subscriptions, lists, and CRMs in place to tracek and apply to calls.',
                developmentActions:[
                  {
                    id: "pf-1-2-0", da: "Launch a grant program to support startups working on innovative technology solutions."
                   },
                   {
                    id: "pf-1-2-1", da: "Provide funding for research and development in emerging technologies."
                   },
                   {
                    id: "pf-1-2-2", da: "Establish open calls for proposals in areas like artificial intelligence, blockchain, and cybersecurity."
                   },
                   {
                    id: "pf-1-2-3", da: "Support projects focused on improving healthcare technology and telemedicine."
                   },
                   {
                    id: "pf-1-2-4", da: "Fund initiatives for advancing renewable energy technologies."
                   },
                   {
                    id: "pf-1-2-5", da: "Create opportunities for technology education and training."
                   },
                   {
                    id: "pf-1-2-6", da: "Invest in projects to enhance agricultural technology and sustainable farming practices."
                   },
                   {
                    id: "pf-1-2-7", da: "Support open-source software development for community-driven solutions."
                   },
                   {
                    id: "pf-1-2-8", da: "Promote technology solutions for waste management and recycling."
                   },
                   {
                    id: "pf-1-2-9", da: "Fund projects that improve internet connectivity in underserved areas."
                   },
                   {
                    id: "pf-1-2-10", da: "Support initiatives to develop smart city infrastructure and technology."
                   },
                   {
                    id: "pf-1-2-11", da: "Provide grants for environmental monitoring and conservation technology."
                   },
                   {
                    id: "pf-1-2-12", da: "Fund research on space exploration and technology for space travel."
                   },
                   {
                    id: "pf-1-2-13", da: "Support projects that enhance disaster preparedness and response technology."
                   },
                   {
                    id: "pf-1-2-14", da: "Invest in technology solutions for reducing air pollution and emissions."
                   },
                   {
                    id: "pf-1-2-15", da: "Promote innovation in autonomous vehicles and transportation technology."
                   },
                   {
                    id: "pf-1-2-16", da: "Fund research on improving water purification and desalination technology."
                   },
                   {
                    id: "pf-1-2-17", da: "Support initiatives for developing educational technology and e-learning platforms."
                   },
                   {
                    id: "pf-1-2-18", da: "Invest in projects to improve cybersecurity and protect against cyber threats."
                   },
                   {
                    id: "pf-1-2-19", da: "Create opportunities for technology-driven solutions in the healthcare industry."
                   },
                   {
                    id: "pf-1-2-20", da: "Provide funding for advancing clean energy technology and reducing carbon emissions."
                   },
                   {
                    id: "pf-1-2-21", da: "Support projects focused on improving renewable energy storage solutions."
                   },
                   {
                    id: "pf-1-2-22", da: "Invest in technology solutions for enhancing public transportation."
                   },
                   {
                    id: "pf-1-2-23", da: "Fund initiatives for the development of 5G technology and infrastructure."
                   },
                   {
                    id: "pf-1-2-24", da: "Promote technology to combat online misinformation and fake news."
                   },
                   {
                    id: "pf-1-2-25", da: "Support research in biotechnology for healthcare and environmental purposes."
                   },
                   {
                    id: "pf-1-2-26", da: "Provide grants for improving accessibility technology for people with disabilities."
                   },
                   {
                    id: "pf-1-2-27", da: "Invest in projects that enhance financial technology and digital banking."
                   },
                   {
                    id: "pf-1-2-28", da: "Create opportunities for the development of blockchain-based solutions."
                   },
                   {
                    id: "pf-1-2-29", da: "Fund initiatives to improve technology for wildlife conservation."
                   },
                   {
                    id: "pf-1-2-30", da: "Support research on enhancing data privacy and encryption technology."
                   },
                   {
                    id: "pf-1-2-31", da: "Invest in projects that promote energy-efficient technology for homes and buildings."
                   },
                   {
                    id: "pf-1-2-32", da: "Provide grants for innovation in the food technology and agriculture industry."
                   },
                   {
                    id: "pf-1-2-33", da: "Fund initiatives to improve technology for disaster recovery and relief efforts."
                   },
                   {
                    id: "pf-1-2-34", da: "Support projects focused on enhancing digital security and authentication."
                   },
                   {
                    id: "pf-1-2-35", da: "Invest in technology solutions for reducing plastic waste and pollution."
                   },
                   {
                    id: "pf-1-2-36", da: "Promote research in space technology and satellite communication."
                   },
                   {
                    id: "pf-1-2-37", da: "Create opportunities for technology-based solutions for mental health and well-being."
                   },
                   {
                    id: "pf-1-2-38", da: "Support initiatives for enhancing technology in the transportation and logistics sector."
                   },
                   {
                    id: "pf-1-2-39", da: "Fund projects focused on developing artificial intelligence for scientific research."
                   },
                   {
                    id: "pf-1-2-40", da: "Invest in technology for efficient water resource management and conservation."
                   },
                   {
                    id: "pf-1-2-41", da: "Provide grants for improving technology solutions for remote work and telecommuting."
                   },
                   {
                    id: "pf-1-2-42", da: "Support research on renewable energy technology for rural communities."
                   },
                   {
                    id: "pf-1-2-43", da: "Promote initiatives to enhance technology for public safety and emergency response."
                   },
                   {
                    id: "pf-1-2-44", da: "Invest in projects that advance technology for wildlife tracking and conservation."
                   },
                   {
                    id: "pf-1-2-45", da: "Create opportunities for the development of sustainable and green building technology."
                   },
                   {
                    id: "pf-1-2-46", da: "Fund initiatives to improve technology solutions for climate change mitigation."
                   },
                   {
                    id: "pf-1-2-47", da: "Support research on technology solutions for waste reduction and recycling."
                   },
                   {
                    id: "pf-1-2-48", da: "Invest in projects that enhance technology for cultural preservation and heritage."
                   },
                   {
                    id: "pf-1-2-49", da: "Provide grants for the development of technology to combat human trafficking and online exploitation."
                   },
                ]
              },
              {
                id: 'pf-1-3',
                pm: 'Unique and highly defendable solution portfolio.',
                title:'Value',
                pmMap: 'Unique and highly defendable solution portfolio.',
                developmentActions:[
                  {
                    id: "pf-1-3-0", da: "Identify key areas that require development or improvement."
                   },
                   {
                    id: "pf-1-3-1", da: "Create a comprehensive list of potential development actions."
                   },
                   {
                    id: "pf-1-3-2", da: "Prioritize development actions based on urgency and impact."
                   },
                   {
                    id: "pf-1-3-3", da: "Establish clear objectives for each development action."
                   },
                   {
                    id: "pf-1-3-4", da: "Determine the required funding for each action."
                   },
                   {
                    id: "pf-1-3-5", da: "Explore government grants and subsidies for development projects."
                   },
                   {
                    id: "pf-1-3-6", da: "Seek partnerships with non-profit organizations for funding support."
                   },
                   {
                    id: "pf-1-3-7", da: "Develop a budget for each development action."
                   },
                   {
                    id: "pf-1-3-8", da: "Consider crowdfunding or crowdsourcing for specific projects."
                   },
                   {
                    id: "pf-1-3-9", da: "Engage with private sector companies for investment opportunities."
                   },
                   {
                    id: "pf-1-3-10", da: "Explore public-private partnerships (PPPs) for joint development initiatives."
                   },
                   {
                    id: "pf-1-3-11", da: "Monitor government budgets and allocations for development."
                   },
                   {
                    id: "pf-1-3-12", da: "Leverage international aid and funding programs."
                   },
                   {
                    id: "pf-1-3-13", da: "Develop a tracking system to stay informed about open funding calls."
                   },
                   {
                    id: "pf-1-3-14", da: "Collaborate with local and regional development agencies."
                   },
                   {
                    id: "pf-1-3-15", da: "Engage with community leaders and organizations for support."
                   },
                   {
                    id: "pf-1-3-16", da: "Foster relationships with potential investors and donors."
                   },
                   {
                    id: "pf-1-3-17", da: "Attend development-focused conferences and events."
                   },
                   {
                    id: "pf-1-3-18", da: "Keep an eye on emerging funding trends and opportunities."
                   },
                   {
                    id: "pf-1-3-19", da: "Consider microloans for small-scale development projects."
                   },
                   {
                    id: "pf-1-3-20", da: "Evaluate the feasibility of impact investing."
                   },
                   {
                    id: "pf-1-3-21", da: "Leverage sustainable and green development grants."
                   },
                   {
                    id: "pf-1-3-22", da: "Explore research and development (R&D) funding opportunities."
                   },
                   {
                    id: "pf-1-3-23", da: "Consider innovation grants for technology-driven projects."
                   },
                   {
                    id: "pf-1-3-24", da: "Build a database of open funding calls and deadlines."
                   },
                   {
                    id: "pf-1-3-25", da: "Develop a team responsible for tracking funding opportunities."
                   },
                   {
                    id: "pf-1-3-26", da: "Stay informed about changes in government policies and initiatives."
                   },
                   {
                    id: "pf-1-3-27", da: "Explore development financing through multilateral organizations."
                   },
                   {
                    id: "pf-1-3-28", da: "Collaborate with academic institutions for research funding."
                   },
                   {
                    id: "pf-1-3-29", da: "Create a grant application strategy and template."
                   },
                   {
                    id: "pf-1-3-30", da: "Develop a compelling case for each development action."
                   },
                   {
                    id: "pf-1-3-31", da: "Seek feedback and guidance from experts in your field."
                   },
                   {
                    id: "pf-1-3-32", da: "Build a strong online presence for crowdfunding efforts."
                   },
                   {
                    id: "pf-1-3-33", da: "Engage with local philanthropists and benefactors."
                   },
                   {
                    id: "pf-1-3-34", da: "Pursue grants for workforce development and training."
                   },
                   {
                    id: "pf-1-3-35", da: "Monitor grant databases and websites for updates."
                   },
                   {
                    id: "pf-1-3-36", da: "Establish a clear timeline for each development action."
                   },
                   {
                    id: "pf-1-3-37", da: "Develop a monitoring and evaluation plan for outcomes."
                   },
                   {
                    id: "pf-1-3-38", da: "Consider matching grants that require community contributions."
                   },
                   {
                    id: "pf-1-3-39", da: "Explore tax incentives and credits for development projects."
                   },
                   {
                    id: "pf-1-3-40", da: "Develop partnerships with foundations and trusts."
                   },
                   {
                    id: "pf-1-3-41", da: "Stay informed about disaster recovery and relief funds."
                   },
                   {
                    id: "pf-1-3-42", da: "Attend workshops on grant writing and proposal submission."
                   },
                   {
                    id: "pf-1-3-43", da: "Collaborate with international NGOs for funding."
                   },
                   {
                    id: "pf-1-3-44", da: "Explore community development block grants (CDBG)."
                   },
                   {
                    id: "pf-1-3-45", da: "Monitor changes in development regulations and compliance."
                   },
                   {
                    id: "pf-1-3-46", da: "Engage with social impact investors."
                   },
                   {
                    id: "pf-1-3-47", da: "Leverage local and national development banks."
                   },
                   {
                    id: "pf-1-3-48", da: "Consider venture capital for innovative projects."
                   },
                   {
                    id: "pf-1-3-49", da: "Continuously evaluate the impact and effectiveness of each development action."
                   },
                ]
              },
              {
                id: 'pf-1-4',
                pm: 'Find open calls that fit with sustainability goals.',
                title:'Business Model',
                pmMap: 'Find open calls that fit with sustainability goals.',
                developmentActions:[
                  {
                    id: "pf-1-4-0", da: "Identify government grants and subsidies available for businesses."
                   },
                   {
                    id: "pf-1-4-1", da: "Explore tax incentives and credits offered for specific industries."
                   },
                   {
                    id: "pf-1-4-2", da: "Seek federal grants and contracts for research and development."
                   },
                   {
                    id: "pf-1-4-3", da: "Look for state-level funding opportunities for small businesses."
                   },
                   {
                    id: "pf-1-4-4", da: "Investigate municipal grants and loans for local business development."
                   },
                   {
                    id: "pf-1-4-5", da: "Consider crowd-funding and peer-to-peer lending platforms."
                   },
                   {
                    id: "pf-1-4-6", da: "Research venture capital and angel investor opportunities."
                   },
                   {
                    id: "pf-1-4-7", da: "Explore private equity investments."
                   },
                   {
                    id: "pf-1-4-8", da: "Evaluate opportunities for public-private partnerships."
                   },
                   {
                    id: "pf-1-4-9", da: "Consider government contracts for goods and services."
                   },
                   {
                    id: "pf-1-4-10", da: "Participate in Small Business Innovation Research (SBIR) programs."
                   },
                   {
                    id: "pf-1-4-11", da: "Explore Small Business Technology Transfer (STTR) programs."
                   },
                   {
                    id: "pf-1-4-12", da: "Look for grants and funding from industry-specific associations."
                   },
                   {
                    id: "pf-1-4-13", da: "Investigate opportunities for grants from philanthropic organizations."
                   },
                   {
                    id: "pf-1-4-14", da: "Explore crowdfunding platforms like Kickstarter and Indiegogo."
                   },
                   {
                    id: "pf-1-4-15", da: "Consider impact investing from socially responsible investors."
                   },
                   {
                    id: "pf-1-4-16", da: "Examine opportunities for grants from economic development agencies."
                   },
                   {
                    id: "pf-1-4-17", da: "Investigate funding from business incubators and accelerators."
                   },
                   {
                    id: "pf-1-4-18", da: "Research opportunities for grants from academic institutions."
                   },
                   {
                    id: "pf-1-4-19", da: "Explore grants from non-governmental organizations (NGOs)."
                   },
                   {
                    id: "pf-1-4-20", da: "Consider partnerships with research institutions for funding."
                   },
                   {
                    id: "pf-1-4-21", da: "Evaluate opportunities for grants from international organizations."
                   },
                   {
                    id: "pf-1-4-22", da: "Investigate opportunities for funding through trade associations."
                   },
                   {
                    id: "pf-1-4-23", da: "Consider grants and funding from development banks."
                   },
                   {
                    id: "pf-1-4-24", da: "Research opportunities for grants from industry-specific foundations."
                   },
                   {
                    id: "pf-1-4-25", da: "Explore opportunities for grants from community foundations."
                   },
                   {
                    id: "pf-1-4-26", da: "Investigate grants for minority-owned and women-owned businesses."
                   },
                   {
                    id: "pf-1-4-27", da: "Consider grants for veteran-owned businesses."
                   },
                   {
                    id: "pf-1-4-28", da: "Look for funding opportunities for green and sustainable businesses."
                   },
                   {
                    id: "pf-1-4-29", da: "Investigate grants for businesses in underprivileged communities."
                   },
                   {
                    id: "pf-1-4-30", da: "Research grants for businesses involved in social impact projects."
                   },
                   {
                    id: "pf-1-4-31", da: "Explore grants for technology and innovation-driven businesses."
                   },
                   {
                    id: "pf-1-4-32", da: "Investigate opportunities for funding in the healthcare sector."
                   },
                   {
                    id: "pf-1-4-33", da: "Consider grants for businesses involved in education and training."
                   },
                   {
                    id: "pf-1-4-34", da: "Explore opportunities for grants for clean energy businesses."
                   },
                   {
                    id: "pf-1-4-35", da: "Investigate grants for businesses focusing on cybersecurity."
                   },
                   {
                    id: "pf-1-4-36", da: "Research funding for businesses involved in artificial intelligence."
                   },
                   {
                    id: "pf-1-4-37", da: "Look for grants for businesses in the agriculture and food industry."
                   },
                   {
                    id: "pf-1-4-38", da: "Investigate opportunities for grants for arts and cultural businesses."
                   },
                   {
                    id: "pf-1-4-39", da: "Consider grants for businesses focused on mental health services."
                   },
                   {
                    id: "pf-1-4-40", da: "Explore funding for businesses involved in affordable housing."
                   },
                   {
                    id: "pf-1-4-41", da: "Investigate grants for businesses in the renewable energy sector."
                   },
                   {
                    id: "pf-1-4-42", da: "Research funding for businesses focused on e-commerce."
                   },
                   {
                    id: "pf-1-4-43", da: "Look for grants for businesses in the travel and tourism industry."
                   },
                   {
                    id: "pf-1-4-44", da: "Investigate opportunities for grants for sustainable fashion businesses."
                   },
                   {
                    id: "pf-1-4-45", da: "Consider grants for businesses in the gaming and entertainment sector."
                   },
                   {
                    id: "pf-1-4-46", da: "Explore grants for businesses in the software development industry."
                   },
                   {
                    id: "pf-1-4-47", da: "Investigate opportunities for grants for businesses in real estate."
                   },
                   {
                    id: "pf-1-4-48", da: "Research grants for businesses focused on telemedicine and telehealth."
                   },
                   {
                    id: "pf-1-4-49", da: "Look for grants for businesses specializing in biotechnology."
                   },
                ]
              },
              {
                id: 'pf-1-5',
                pm: 'New and profitable go to market strategies have been explored, piloted, and successfully implemented.',
                title:'Go to Market',
                pmMap: 'New and profitable go to market strategies have been explored, piloted, and successfully implemented.',
                developmentActions:[
                  {
                    id: "pf-1-5-0", da: "Identify relevant government grants and funding opportunities."
                   },
                   {
                    id: "pf-1-5-1", da: "Create a dedicated team to handle grant applications."
                   },
                   {
                    id: "pf-1-5-2", da: "Monitor government websites and portals for open calls."
                   },
                   {
                    id: "pf-1-5-3", da: "Join industry-specific associations to stay informed about funding."
                   },
                   {
                    id: "pf-1-5-4", da: "Leverage online grant databases to find suitable opportunities."
                   },
                   {
                    id: "pf-1-5-5", da: "Build a comprehensive database of open calls and deadlines."
                   },
                   {
                    id: "pf-1-5-6", da: "Develop a clear and concise elevator pitch for grant applications."
                   },
                   {
                    id: "pf-1-5-7", da: "Create a central repository for grant-related documents."
                   },
                   {
                    id: "pf-1-5-8", da: "Form partnerships or consortia for collaborative applications."
                   },
                   {
                    id: "pf-1-5-9", da: "Investigate past grant recipients and their success stories."
                   },
                   {
                    id: "pf-1-5-10", da: "Ensure alignment between your project and grant objectives."
                   },
                   {
                    id: "pf-1-5-11", da: "Explore European Union (EU) funding programs."
                   },
                   {
                    id: "pf-1-5-12", da: "Invest in grant-writing training for your team."
                   },
                   {
                    id: "pf-1-5-13", da: "Consult with grant experts for application reviews."
                   },
                   {
                    id: "pf-1-5-14", da: "Collaborate with universities and research institutions."
                   },
                   {
                    id: "pf-1-5-15", da: "Attend grant-related workshops and seminars."
                   },
                   {
                    id: "pf-1-5-16", da: "Utilize grant management software for tracking applications."
                   },
                   {
                    id: "pf-1-5-17", da: "Set up email alerts for new grant opportunities."
                   },
                   {
                    id: "pf-1-5-18", da: "Network with government officials and program officers."
                   },
                   {
                    id: "pf-1-5-19", da: "Seek expert advice on navigating bureaucratic processes."
                   },
                   {
                    id: "pf-1-5-20", da: "Stay updated on changes in grant regulations and policies."
                   },
                   {
                    id: "pf-1-5-21", da: "Formulate a detailed project plan for each grant application."
                   },
                   {
                    id: "pf-1-5-22", da: "Allocate adequate resources for the application process."
                   },
                   {
                    id: "pf-1-5-23", da: "Maintain a calendar with grant deadlines and milestones."
                   },
                   {
                    id: "pf-1-5-24", da: "Develop a strong business case to support your application."
                   },
                   {
                    id: "pf-1-5-25", da: "Conduct a thorough cost-benefit analysis for grant proposals."
                   },
                   {
                    id: "pf-1-5-26", da: "Ensure your project has measurable key performance indicators (KPIs)."
                   },
                   {
                    id: "pf-1-5-27", da: "Consider environmental and social impact assessments."
                   },
                   {
                    id: "pf-1-5-28", da: "Engage in community outreach and stakeholder engagement."
                   },
                   {
                    id: "pf-1-5-29", da: "Address potential risks and mitigation strategies."
                   },
                   {
                    id: "pf-1-5-30", da: "Demonstrate the economic benefits of your project."
                   },
                   {
                    id: "pf-1-5-31", da: "Highlight job creation and economic growth potential."
                   },
                   {
                    id: "pf-1-5-32", da: "Showcase innovation and technology advancements."
                   },
                   {
                    id: "pf-1-5-33", da: "Emphasize sustainability and green initiatives."
                   },
                   {
                    id: "pf-1-5-34", da: "Foster relationships with local economic development agencies."
                   },
                   {
                    id: "pf-1-5-35", da: "Maintain an updated website with grant information."
                   },
                   {
                    id: "pf-1-5-36", da: "Promote your application through social media channels."
                   },
                   {
                    id: "pf-1-5-37", da: "Use storytelling techniques to make your application compelling."
                   },
                   {
                    id: "pf-1-5-38", da: "Ensure consistency in branding and messaging."
                   },
                   {
                    id: "pf-1-5-39", da: "Offer testimonials from previous grant recipients."
                   },
                   {
                    id: "pf-1-5-40", da: "Include letters of support from industry partners."
                   },
                   {
                    id: "pf-1-5-41", da: "Create a strong financial model with detailed projections."
                   },
                   {
                    id: "pf-1-5-42", da: "Showcase a well-defined market analysis."
                   },
                   {
                    id: "pf-1-5-43", da: "Demonstrate a clear path to commercialization."
                   },
                   {
                    id: "pf-1-5-44", da: "Provide a comprehensive budget for the project."
                   },
                   {
                    id: "pf-1-5-45", da: "Address any potential regulatory hurdles."
                   },
                   {
                    id: "pf-1-5-46", da: "Prepare for due diligence inquiries."
                   },
                   {
                    id: "pf-1-5-47", da: "Develop a contingency plan in case of grant rejection."
                   },
                   {
                    id: "pf-1-5-48", da: "Celebrate successes and milestones in your application."
                   },
                   {
                    id: "pf-1-5-49", da: "Regularly review and update your grant strategy."
                   },
                ]
              },
              {
                id: 'pf-1-6',
                pm: 'Dedicated team to scout and apply for grants, governmental programs, and competitions.',
                title:'People',
                pmMap: 'Dedicated team to scout and apply for grants, governmental programs, and competitions.',
                developmentActions:[
                  {
                    id: "pf-1-6-0", da: "Establish a clear and transparent application process for public funding."
                   },
                   {
                    id: "pf-1-6-1", da: "Create a dedicated website or portal for tracking and applying for open calls."
                   },
                   {
                    id: "pf-1-6-2", da: "Ensure accessibility and inclusivity in the application process."
                   },
                   {
                    id: "pf-1-6-3", da: "Provide guidelines and templates for grant proposals."
                   },
                   {
                    id: "pf-1-6-4", da: "Develop a comprehensive database of open funding opportunities."
                   },
                   {
                    id: "pf-1-6-5", da: "Promote collaboration between government agencies and non-profits."
                   },
                   {
                    id: "pf-1-6-6", da: "Encourage public-private partnerships in development initiatives."
                   },
                   {
                    id: "pf-1-6-7", da: "Set specific goals for improving people's lives through funding."
                   },
                   {
                    id: "pf-1-6-8", da: "Prioritize projects that target marginalized communities."
                   },
                   {
                    id: "pf-1-6-9", da: "Allocate funds for education and skill development programs."
                   },
                   {
                    id: "pf-1-6-10", da: "Invest in healthcare and public health initiatives."
                   },
                   {
                    id: "pf-1-6-11", da: "Support initiatives aimed at reducing poverty and inequality."
                   },
                   {
                    id: "pf-1-6-12", da: "Foster innovation and entrepreneurship through grants."
                   },
                   {
                    id: "pf-1-6-13", da: "Fund projects that promote gender equality and women's empowerment."
                   },
                   {
                    id: "pf-1-6-14", da: "Invest in infrastructure development to improve people's quality of life."
                   },
                   {
                    id: "pf-1-6-15", da: "Encourage sustainable development practices."
                   },
                   {
                    id: "pf-1-6-16", da: "Support arts and culture programs to enhance people's well-being."
                   },
                   {
                    id: "pf-1-6-17", da: "Provide funding for research and development projects."
                   },
                   {
                    id: "pf-1-6-18", da: "Promote clean energy and environmental conservation."
                   },
                   {
                    id: "pf-1-6-19", da: "Allocate resources for affordable housing and urban development."
                   },
                   {
                    id: "pf-1-6-20", da: "Fund initiatives for mental health awareness and support."
                   },
                   {
                    id: "pf-1-6-21", da: "Support community-based projects that address local needs."
                   },
                   {
                    id: "pf-1-6-22", da: "Create incentives for job creation and economic growth."
                   },
                   {
                    id: "pf-1-6-23", da: "Establish monitoring and evaluation mechanisms for funded projects."
                   },
                   {
                    id: "pf-1-6-24", da: "Encourage NGOs to apply for funding for social initiatives."
                   },
                   {
                    id: "pf-1-6-25", da: "Invest in vocational training programs."
                   },
                   {
                    id: "pf-1-6-26", da: "Promote digital literacy and technology access."
                   },
                   {
                    id: "pf-1-6-27", da: "Support programs for at-risk youth and juvenile rehabilitation."
                   },
                   {
                    id: "pf-1-6-28", da: "Fund initiatives to address substance abuse and addiction."
                   },
                   {
                    id: "pf-1-6-29", da: "Allocate resources for disaster preparedness and response."
                   },
                   {
                    id: "pf-1-6-30", da: "Promote public safety and crime prevention."
                   },
                   {
                    id: "pf-1-6-31", da: "Invest in research and treatment for common health issues."
                   },
                   {
                    id: "pf-1-6-32", da: "Support initiatives to combat human trafficking and child exploitation."
                   },
                   {
                    id: "pf-1-6-33", da: "Fund projects to improve accessibility for people with disabilities."
                   },
                   {
                    id: "pf-1-6-34", da: "Promote financial literacy and access to affordable banking."
                   },
                   {
                    id: "pf-1-6-35", da: "Allocate resources for child care and early childhood development."
                   },
                   {
                    id: "pf-1-6-36", da: "Invest in vocational rehabilitation for people with disabilities."
                   },
                   {
                    id: "pf-1-6-37", da: "Support initiatives for senior citizens and elderly care."
                   },
                   {
                    id: "pf-1-6-38", da: "Fund programs to address food insecurity and nutrition."
                   },
                   {
                    id: "pf-1-6-39", da: "Promote access to clean water and sanitation."
                   },
                   {
                    id: "pf-1-6-40", da: "Allocate resources for rural and agricultural development."
                   },
                   {
                    id: "pf-1-6-41", da: "Invest in renewable energy projects."
                   },
                   {
                    id: "pf-1-6-42", da: "Support initiatives for cultural preservation and heritage."
                   },
                   {
                    id: "pf-1-6-43", da: "Fund projects that tackle drug abuse and addiction."
                   },
                   {
                    id: "pf-1-6-44", da: "Promote access to quality education for all."
                   },
                   {
                    id: "pf-1-6-45", da: "Allocate resources for disaster recovery efforts."
                   },
                   {
                    id: "pf-1-6-46", da: "Invest in public transportation and infrastructure."
                   },
                   {
                    id: "pf-1-6-47", da: "Support initiatives to combat domestic violence."
                   },
                   {
                    id: "pf-1-6-48", da: "Fund projects that promote community resilience."
                   },
                   {
                    id: "pf-1-6-49", da: "Encourage public feedback and engagement in the funding process."
                   },
                ]
              },
              {
                id: 'pf-1-7',
                pm: 'A central knowledge base is built for multiple people to track and be applying for open calls.',
                title:'Data Metrics',
                pmMap: 'A central knowledge base is built for multiple people to track and be applying for open calls.',
                developmentActions:[
                  {
                    id: "pf-1-7-0", da: "Establish a centralized platform for tracking public funding opportunities."
                   },
                   {
                    id: "pf-1-7-1", da: "Categorize funding opportunities by sector and target audience."
                   },
                   {
                    id: "pf-1-7-2", da: "Provide a user-friendly interface for applicants to search and apply for grants."
                   },
                   {
                    id: "pf-1-7-3", da: "Offer detailed guidelines on eligibility criteria for each funding opportunity."
                   },
                   {
                    id: "pf-1-7-4", da: "Include a timeline for each grant, including application deadlines and review periods."
                   },
                   {
                    id: "pf-1-7-5", da: "Enable automatic notifications for upcoming deadlines."
                   },
                   {
                    id: "pf-1-7-6", da: "Implement a robust data collection system to monitor grant application data."
                   },
                   {
                    id: "pf-1-7-7", da: "Track the number of applications submitted for each grant."
                   },
                   {
                    id: "pf-1-7-8", da: "Monitor the success rate of grant applications."
                   },
                   {
                    id: "pf-1-7-9", da: "Collect demographic data from grant applicants to assess inclusivity."
                   },
                   {
                    id: "pf-1-7-10", da: "Analyze data to identify trends and patterns in grant applications."
                   },
                   {
                    id: "pf-1-7-11", da: "Evaluate the impact of public funding on various sectors."
                   },
                   {
                    id: "pf-1-7-12", da: "Monitor the geographical distribution of grant recipients."
                   },
                   {
                    id: "pf-1-7-13", da: "Implement data security measures to protect sensitive applicant information."
                   },
                   {
                    id: "pf-1-7-14", da: "Provide regular reports and insights based on grant application data."
                   },
                   {
                    id: "pf-1-7-15", da: "Assess the effectiveness of the application review process."
                   },
                   {
                    id: "pf-1-7-16", da: "Monitor the financial allocation for each development action."
                   },
                   {
                    id: "pf-1-7-17", da: "Track the utilization of funds for each grant."
                   },
                   {
                    id: "pf-1-7-18", da: "Analyze the cost-effectiveness of different development actions."
                   },
                   {
                    id: "pf-1-7-19", da: "Evaluate the outcomes and impact of funded projects."
                   },
                   {
                    id: "pf-1-7-20", da: "Implement performance indicators to measure project success."
                   },
                   {
                    id: "pf-1-7-21", da: "Create a dashboard for visualizing key data metrics."
                   },
                   {
                    id: "pf-1-7-22", da: "Assess the efficiency of the grant approval process."
                   },
                   {
                    id: "pf-1-7-23", da: "Track the duration of grant implementation and project completion."
                   },
                   {
                    id: "pf-1-7-24", da: "Monitor the distribution of funds across regions or communities."
                   },
                   {
                    id: "pf-1-7-25", da: "Analyze the return on investment for public funding initiatives."
                   },
                   {
                    id: "pf-1-7-26", da: "Evaluate the social and economic benefits of funded projects."
                   },
                   {
                    id: "pf-1-7-27", da: "Collect feedback from grant recipients and applicants for continuous improvement."
                   },
                   {
                    id: "pf-1-7-28", da: "Implement tools for real-time data reporting and analysis."
                   },
                   {
                    id: "pf-1-7-29", da: "Ensure transparency in the allocation of public funds."
                   },
                   {
                    id: "pf-1-7-30", da: "Publish detailed reports on the outcomes of funded projects."
                   },
                   {
                    id: "pf-1-7-31", da: "Collaborate with data experts and analysts for in-depth assessments."
                   },
                   {
                    id: "pf-1-7-32", da: "Consider open data standards to facilitate data sharing."
                   },
                   {
                    id: "pf-1-7-33", da: "Assess the impact of public funding on job creation."
                   },
                   {
                    id: "pf-1-7-34", da: "Monitor the sustainability of projects initiated with public funding."
                   },
                   {
                    id: "pf-1-7-35", da: "Analyze the alignment of funded projects with government priorities."
                   },
                   {
                    id: "pf-1-7-36", da: "Evaluate the effectiveness of capacity-building initiatives."
                   },
                   {
                    id: "pf-1-7-37", da: "Collect case studies and success stories to showcase impact."
                   },
                   {
                    id: "pf-1-7-38", da: "Assess the impact on vulnerable or underserved communities."
                   },
                   {
                    id: "pf-1-7-39", da: "Monitor the performance of grant management teams."
                   },
                   {
                    id: "pf-1-7-40", da: "Implement data quality checks and validation processes."
                   },
                   {
                    id: "pf-1-7-41", da: "Track the dissemination of knowledge and best practices from funded projects."
                   },
                   {
                    id: "pf-1-7-42", da: "Evaluate the scalability of successful development actions."
                   },
                   {
                    id: "pf-1-7-43", da: "Analyze the challenges and obstacles faced by grant recipients."
                   },
                   {
                    id: "pf-1-7-44", da: "Monitor changes in policies and regulations related to public funding."
                   },
                   {
                    id: "pf-1-7-45", da: "Engage in regular data-driven discussions and policy dialogues."
                   },
                   {
                    id: "pf-1-7-46", da: "Assess the efficiency of public funding distribution channels."
                   },
                   {
                    id: "pf-1-7-47", da: "Monitor the public perception of funded initiatives."
                   },
                   {
                    id: "pf-1-7-48", da: "Ensure compliance with data protection regulations."
                   },
                   {
                    id: "pf-1-7-49", da: "Continuously seek feedback and input from stakeholders for improvement."
                   },
                ]
              },
              {
                id: 'pf-1-8',
                pm: 'Establish plan and set up resources for your M&A/ IPO project.',
                title:'Operations',
                pmMap: 'Establish plan and set up resources for your M&A/ IPO project.',
                developmentActions:[
                  {
                    id: "pf-1-8-0", da: "Establish a clear and transparent process for public funding applications."
                   },
                   {
                    id: "pf-1-8-1", da: "Define specific criteria for eligibility to ensure fairness."
                   },
                   {
                    id: "pf-1-8-2", da: "Create an accessible online platform for open call announcements."
                   },
                   {
                    id: "pf-1-8-3", da: "Provide detailed guidelines on how to apply for funding."
                   },
                   {
                    id: "pf-1-8-4", da: "Offer regular training and workshops for applicants."
                   },
                   {
                    id: "pf-1-8-5", da: "Develop a standardized application form for consistency."
                   },
                   {
                    id: "pf-1-8-6", da: "Appoint a dedicated team to oversee the open call process."
                   },
                   {
                    id: "pf-1-8-7", da: "Set clear deadlines for application submissions."
                   },
                   {
                    id: "pf-1-8-8", da: "Ensure equal opportunity for all types of organizations."
                   },
                   {
                    id: "pf-1-8-9", da: "Encourage collaboration and partnerships among applicants."
                   },
                   {
                    id: "pf-1-8-10", da: "Establish a review committee to evaluate proposals."
                   },
                   {
                    id: "pf-1-8-11", da: "Use a scoring system to rank and prioritize projects."
                   },
                   {
                    id: "pf-1-8-12", da: "Communicate the results to all applicants in a timely manner."
                   },
                   {
                    id: "pf-1-8-13", da: "Offer feedback to unsuccessful applicants for improvement."
                   },
                   {
                    id: "pf-1-8-14", da: "Allocate funds based on project potential and impact."
                   },
                   {
                    id: "pf-1-8-15", da: "Create a transparent budget allocation process."
                   },
                   {
                    id: "pf-1-8-16", da: "Monitor project progress and adherence to timelines."
                   },
                   {
                    id: "pf-1-8-17", da: "Develop a risk management strategy for funded projects."
                   },
                   {
                    id: "pf-1-8-18", da: "Implement regular reporting requirements for recipients."
                   },
                   {
                    id: "pf-1-8-19", da: "Foster knowledge sharing among grant recipients."
                   },
                   {
                    id: "pf-1-8-20", da: "Promote sustainable and environmentally friendly projects."
                   },
                   {
                    id: "pf-1-8-21", da: "Allocate funds for research and innovation initiatives."
                   },
                   {
                    id: "pf-1-8-22", da: "Encourage projects that focus on improving social impact."
                   },
                   {
                    id: "pf-1-8-23", da: "Support projects that enhance technological infrastructure."
                   },
                   {
                    id: "pf-1-8-24", da: "Allocate resources for skills development and training."
                   },
                   {
                    id: "pf-1-8-25", da: "Establish performance metrics for assessing project success."
                   },
                   {
                    id: "pf-1-8-26", da: "Conduct periodic project evaluations for accountability."
                   },
                   {
                    id: "pf-1-8-27", da: "Ensure that funding aligns with strategic goals and objectives."
                   },
                   {
                    id: "pf-1-8-28", da: "Maintain an open channel for applicant inquiries and clarifications."
                   },
                   {
                    id: "pf-1-8-29", da: "Continuously update and improve the open call process."
                   },
                   {
                    id: "pf-1-8-30", da: "Seek feedback from both applicants and grantors."
                   },
                   {
                    id: "pf-1-8-31", da: "Foster diversity and inclusion in project selection."
                   },
                   {
                    id: "pf-1-8-32", da: "Promote transparency and ethical behavior in funded projects."
                   },
                   {
                    id: "pf-1-8-33", da: "Monitor compliance with legal and ethical standards."
                   },
                   {
                    id: "pf-1-8-34", da: "Encourage innovation in project proposals."
                   },
                   {
                    id: "pf-1-8-35", da: "Support projects with potential for scalability."
                   },
                   {
                    id: "pf-1-8-36", da: "Invest in projects that address pressing community needs."
                   },
                   {
                    id: "pf-1-8-37", da: "Allocate funds for research and development initiatives."
                   },
                   {
                    id: "pf-1-8-38", da: "Promote cross-sector collaboration for holistic solutions."
                   },
                   {
                    id: "pf-1-8-39", da: "Support projects that enhance the quality of life."
                   },
                   {
                    id: "pf-1-8-40", da: "Allocate resources to initiatives that address global challenges."
                   },
                   {
                    id: "pf-1-8-41", da: "Foster an environment of creativity and entrepreneurship."
                   },
                   {
                    id: "pf-1-8-42", da: "Prioritize projects with potential for economic growth."
                   },
                   {
                    id: "pf-1-8-43", da: "Fund projects that align with regional development goals."
                   },
                   {
                    id: "pf-1-8-44", da: "Support projects that improve public service delivery."
                   },
                   {
                    id: "pf-1-8-45", da: "Encourage initiatives that enhance public infrastructure."
                   },
                   {
                    id: "pf-1-8-46", da: "Invest in education and skill development programs."
                   },
                   {
                    id: "pf-1-8-47", da: "Allocate funds to projects with long-term sustainability."
                   },
                   {
                    id: "pf-1-8-48", da: "Promote public-private partnerships for shared goals."
                   },
                   {
                    id: "pf-1-8-49", da: "Celebrate successful projects and their impact on society."
                   },
                ]
              },
              {
                id: 'pf-1-9',
                pm: 'Run IPO or M&A readiness. Decide on the preferred option.',
                title:'Exit Strategy',
                pmMap: 'Run IPO or M&A readiness. Decide on the preferred option.',
                developmentActions:[
                  {
                    id: "pf-1-9-0", da: "Clearly define the project's goals and objectives."
                   },
                   {
                    id: "pf-1-9-1", da: "Assess the current status of the project and identify areas for improvement."
                   },
                   {
                    id: "pf-1-9-2", da: "Conduct a thorough stakeholder analysis to understand their interests and concerns."
                   },
                   {
                    id: "pf-1-9-3", da: "Establish a timeline for the exit strategy."
                   },
                   {
                    id: "pf-1-9-4", da: "Develop a detailed budget for the exit phase."
                   },
                   {
                    id: "pf-1-9-5", da: "Consider the impact of the project on the community and stakeholders."
                   },
                   {
                    id: "pf-1-9-6", da: "Communicate the exit strategy to all relevant parties."
                   },
                   {
                    id: "pf-1-9-7", da: "Identify potential risks and challenges associated with the exit."
                   },
                   {
                    id: "pf-1-9-8", da: "Determine the most appropriate exit method, whether it's a gradual phase-out or a sudden exit."
                   },
                   {
                    id: "pf-1-9-9", da: "Ensure legal and regulatory compliance throughout the exit process."
                   },
                   {
                    id: "pf-1-9-10", da: "Consider the financial sustainability of the project after exit."
                   },
                   {
                    id: "pf-1-9-11", da: "Identify potential funding sources for sustaining project outcomes."
                   },
                   {
                    id: "pf-1-9-12", da: "Develop a knowledge transfer plan to ensure the continuity of project activities."
                   },
                   {
                    id: "pf-1-9-13", da: "Assess the capacity of local organizations to take over project responsibilities."
                   },
                   {
                    id: "pf-1-9-14", da: "Evaluate the scalability and replicability of project activities."
                   },
                   {
                    id: "pf-1-9-15", da: "Create a monitoring and evaluation framework for the exit phase."
                   },
                   {
                    id: "pf-1-9-16", da: "Define clear criteria for success and failure during the exit."
                   },
                   {
                    id: "pf-1-9-17", da: "Establish mechanisms for reporting and accountability."
                   },
                   {
                    id: "pf-1-9-18", da: "Involve stakeholders in the decision-making process regarding the exit."
                   },
                   {
                    id: "pf-1-9-19", da: "Consider the environmental impact of project activities during the exit."
                   },
                   {
                    id: "pf-1-9-20", da: "Ensure that project documentation and data are properly archived and accessible."
                   },
                   {
                    id: "pf-1-9-21", da: "Address any outstanding legal or contractual obligations."
                   },
                   {
                    id: "pf-1-9-22", da: "Provide training and capacity-building support to local partners."
                   },
                   {
                    id: "pf-1-9-23", da: "Develop a communication plan to inform the public about the exit."
                   },
                   {
                    id: "pf-1-9-24", da: "Consider the potential for partnerships with other organizations to continue project efforts."
                   },
                   {
                    id: "pf-1-9-25", da: "Evaluate the sustainability of project outcomes and whether they align with the original objectives."
                   },
                   {
                    id: "pf-1-9-26", da: "Explore opportunities for knowledge-sharing and dissemination of project results."
                   },
                   {
                    id: "pf-1-9-27", da: "Assess the political climate and potential changes that may affect the project's continuity."
                   },
                   {
                    id: "pf-1-9-28", da: "Consider the emotional and psychological impact of the exit on project beneficiaries."
                   },
                   {
                    id: "pf-1-9-29", da: "Document lessons learned and best practices for future projects."
                   },
                   {
                    id: "pf-1-9-30", da: "Review the effectiveness of the project's monitoring and evaluation systems."
                   },
                   {
                    id: "pf-1-9-31", da: "Assess the quality of data collected during the project's lifecycle."
                   },
                   {
                    id: "pf-1-9-32", da: "Consider the potential for innovation and adaptability in the exit strategy."
                   },
                   {
                    id: "pf-1-9-33", da: "Define roles and responsibilities for all stakeholders during the exit."
                   },
                   {
                    id: "pf-1-9-34", da: "Address any conflicts or disputes that may arise during the exit phase."
                   },
                   {
                    id: "pf-1-9-35", da: "Ensure that project beneficiaries have access to necessary resources after the project's closure."
                   },
                   {
                    id: "pf-1-9-36", da: "Explore the possibility of sustaining project activities through income-generating mechanisms."
                   },
                   {
                    id: "pf-1-9-37", da: "Evaluate the extent to which the project has empowered local communities."
                   },
                   {
                    id: "pf-1-9-38", da: "Consider the potential for advocacy and policy change related to the project's goals."
                   },
                   {
                    id: "pf-1-9-39", da: "Assess the ethical and social implications of the exit strategy."
                   },
                   {
                    id: "pf-1-9-40", da: "Ensure that vulnerable populations are not disproportionately affected by the exit."
                   },
                   {
                    id: "pf-1-9-41", da: "Develop a clear communication strategy for sharing exit-related information with all stakeholders."
                   },
                   {
                    id: "pf-1-9-42", da: "Monitor and address any public perception issues related to the project's exit."
                   },
                   {
                    id: "pf-1-9-43", da: "Ensure that all project assets are properly transferred or disposed of."
                   },
                   {
                    id: "pf-1-9-44", da: "Review the project's impact on local economies and job creation."
                   },
                   {
                    id: "pf-1-9-45", da: "Assess the health and social well-being outcomes of the project."
                   },
                   {
                    id: "pf-1-9-46", da: "Consider the potential for creating a legacy organization to continue project activities."
                   },
                   {
                    id: "pf-1-9-47", da: "Establish a feedback mechanism for stakeholders to provide input on the exit strategy."
                   },
                   {
                    id: "pf-1-9-48", da: "Monitor the transition of project responsibilities to local entities."
                   },
                   {
                    id: "pf-1-9-49", da: "Continuously evaluate and adapt the exit strategy based on changing circumstances and feedback."
                   },
                ]
              }
            ]
          },
          {
            id: 'pf-2',
            icon: require('@/assets/Iconography/Attributes/18-02_Being Comfortable With Uncertainty.svg'),
            comp: 'Attracting Funding',
            wdd: '',
            progressMeasures:[
              {
                id: 'pf-2-0',
                pm: 'Matching problem statements are identified that are close to the need that the community solves.',
                title:'Need',
                pmMap: 'Matching problem statements are identified that are close to the need that the community solves.',
                developmentActions:[
                  {
                    id: "pf-2-0-0", da: "Infrastructure development for better transportation."
                   },
                   {
                    id: "pf-2-0-1", da: "Construction of new schools and educational facilities."
                   },
                   {
                    id: "pf-2-0-2", da: "Renovation of existing educational institutions."
                   },
                   {
                    id: "pf-2-0-3", da: "Providing scholarships for underprivileged students."
                   },
                   {
                    id: "pf-2-0-4", da: "Creating job training programs for the unemployed."
                   },
                   {
                    id: "pf-2-0-5", da: "Affordable housing initiatives."
                   },
                   {
                    id: "pf-2-0-6", da: "Developing healthcare facilities and hospitals."
                   },
                   {
                    id: "pf-2-0-7", da: "Improving access to clean drinking water."
                   },
                   {
                    id: "pf-2-0-8", da: "Sanitation projects for improved hygiene."
                   },
                   {
                    id: "pf-2-0-9", da: "Rural electrification to power remote areas."
                   },
                   {
                    id: "pf-2-0-10", da: "Promoting renewable energy sources."
                   },
                   {
                    id: "pf-2-0-11", da: "Disaster management and preparedness."
                   },
                   {
                    id: "pf-2-0-12", da: "Environmental conservation and reforestation."
                   },
                   {
                    id: "pf-2-0-13", da: "Waste management and recycling programs."
                   },
                   {
                    id: "pf-2-0-14", da: "Vocational training centers for skills development."
                   },
                   {
                    id: "pf-2-0-15", da: "Promoting entrepreneurship and small businesses."
                   },
                   {
                    id: "pf-2-0-16", da: "Support for women and minority-owned businesses."
                   },
                   {
                    id: "pf-2-0-17", da: "Initiatives to reduce crime and improve safety."
                   },
                   {
                    id: "pf-2-0-18", da: "Youth development and mentoring programs."
                   },
                   {
                    id: "pf-2-0-19", da: "Rehabilitation and counseling for at-risk individuals."
                   },
                   {
                    id: "pf-2-0-20", da: "Cultural and arts projects to promote local talent."
                   },
                   {
                    id: "pf-2-0-21", da: "Sports facilities and programs for youth."
                   },
                   {
                    id: "pf-2-0-22", da: "Developing community centers for gatherings."
                   },
                   {
                    id: "pf-2-0-23", da: "Senior citizen care and support services."
                   },
                   {
                    id: "pf-2-0-24", da: "Initiatives to combat drug and alcohol abuse."
                   },
                   {
                    id: "pf-2-0-25", da: "Providing legal aid services to the marginalized."
                   },
                   {
                    id: "pf-2-0-26", da: "Promoting tourism and local attractions."
                   },
                   {
                    id: "pf-2-0-27", da: "Agricultural support and modernization."
                   },
                   {
                    id: "pf-2-0-28", da: "Food security and nutrition programs."
                   },
                   {
                    id: "pf-2-0-29", da: "Microfinance and credit for small farmers."
                   },
                   {
                    id: "pf-2-0-30", da: "Access to the internet and digital literacy."
                   },
                   {
                    id: "pf-2-0-31", da: "Library and educational resources."
                   },
                   {
                    id: "pf-2-0-32", da: "Cultural heritage preservation."
                   },
                   {
                    id: "pf-2-0-33", da: "Supporting local crafts and industries."
                   },
                   {
                    id: "pf-2-0-34", da: "Initiatives for gender equality and empowerment."
                   },
                   {
                    id: "pf-2-0-35", da: "Programs for persons with disabilities."
                   },
                   {
                    id: "pf-2-0-36", da: "Healthcare awareness campaigns."
                   },
                   {
                    id: "pf-2-0-37", da: "Mental health support and counseling services."
                   },
                   {
                    id: "pf-2-0-38", da: "Promoting clean and green technology."
                   },
                   {
                    id: "pf-2-0-39", da: "Supporting scientific research and innovation."
                   },
                   {
                    id: "pf-2-0-40", da: "Fire and emergency response services."
                   },
                   {
                    id: "pf-2-0-41", da: "Public transportation and mobility solutions."
                   },
                   {
                    id: "pf-2-0-42", da: "Promoting civic engagement and participation."
                   },
                   {
                    id: "pf-2-0-43", da: "Public parks and recreational spaces."
                   },
                   {
                    id: "pf-2-0-44", da: "Rehabilitation centers for addicts."
                   },
                   {
                    id: "pf-2-0-45", da: "Public Wi-Fi in key areas."
                   },
                   {
                    id: "pf-2-0-46", da: "Human rights awareness and advocacy."
                   },
                   {
                    id: "pf-2-0-47", da: "Programs to combat domestic violence."
                   },
                   {
                    id: "pf-2-0-48", da: "Public health campaigns and clinics."
                   },
                   {
                    id: "pf-2-0-49", da: "Investing in technology and digital infrastructure."
                   },
                ]
              },
              {
                id: 'pf-2-1',
                pm: 'Market leaders are reaching out to apply to their calls. They percieve you as a problem solver in your category.',
                title:'Market',
                pmMap: 'Market leaders are reaching out to apply to their calls. They percieve you as a problem solver in your category.',
                developmentActions:[
                  {
                    id: "pf-2-1-0", da: "Define clear objectives and outcomes for the development actions."
                   },
                   {
                    id: "pf-2-1-1", da: "Conduct a thorough needs assessment to identify market gaps and challenges."
                   },
                   {
                    id: "pf-2-1-2", da: "Develop a detailed project proposal with a budget breakdown."
                   },
                   {
                    id: "pf-2-1-3", da: "Identify potential funding sources at the local, regional, and national levels."
                   },
                   {
                    id: "pf-2-1-4", da: "Research and understand the specific requirements and priorities of each funding source."
                   },
                   {
                    id: "pf-2-1-5", da: "Tailor your proposals to align with the goals and criteria of potential funders."
                   },
                   {
                    id: "pf-2-1-6", da: "Consider public-private partnerships to leverage resources and expertise."
                   },
                   {
                    id: "pf-2-1-7", da: "Engage with relevant government agencies and officials to gain support."
                   },
                   {
                    id: "pf-2-1-8", da: "Highlight the economic and social benefits of market improvement in your proposals."
                   },
                   {
                    id: "pf-2-1-9", da: "Emphasize the potential job creation and economic growth that the actions will stimulate."
                   },
                   {
                    id: "pf-2-1-10", da: "Explore grants, subsidies, and tax incentives that may be available for market development."
                   },
                   {
                    id: "pf-2-1-11", da: "Develop a solid business case that demonstrates the return on investment for public funds."
                   },
                   {
                    id: "pf-2-1-12", da: "Consider crowdfunding or crowdsourcing platforms to engage the public in funding."
                   },
                   {
                    id: "pf-2-1-13", da: "Show how the development actions align with sustainable development goals."
                   },
                   {
                    id: "pf-2-1-14", da: "Emphasize the environmental sustainability of the proposed improvements."
                   },
                   {
                    id: "pf-2-1-15", da: "Build a diverse and skilled project team to demonstrate your capacity to execute the actions."
                   },
                   {
                    id: "pf-2-1-16", da: "Clearly communicate the timeline and milestones for the development actions."
                   },
                   {
                    id: "pf-2-1-17", da: "Show how the improvements will benefit underserved communities or vulnerable populations."
                   },
                   {
                    id: "pf-2-1-18", da: "Develop a risk mitigation strategy to address potential challenges."
                   },
                   {
                    id: "pf-2-1-19", da: "Emphasize the innovation and technology adoption in your market improvement plan."
                   },
                   {
                    id: "pf-2-1-20", da: "Seek endorsements and letters of support from local stakeholders."
                   },
                   {
                    id: "pf-2-1-21", da: "Present a well-structured financial model that outlines cost estimates and revenue projections."
                   },
                   {
                    id: "pf-2-1-22", da: "Demonstrate the scalability and replicability of the actions in other markets."
                   },
                   {
                    id: "pf-2-1-23", da: "Ensure compliance with all regulatory requirements and standards."
                   },
                   {
                    id: "pf-2-1-24", da: "Highlight the potential for increased competitiveness and export opportunities."
                   },
                   {
                    id: "pf-2-1-25", da: "Consider the social impact of the actions, such as improved living conditions and access to education."
                   },
                   {
                    id: "pf-2-1-26", da: "Collaborate with academic institutions for research and data collection."
                   },
                   {
                    id: "pf-2-1-27", da: "Engage with local communities to gather input and build public support."
                   },
                   {
                    id: "pf-2-1-28", da: "Promote transparency and accountability in how public funds will be used."
                   },
                   {
                    id: "pf-2-1-29", da: "Develop a communication plan to keep stakeholders informed about progress."
                   },
                   {
                    id: "pf-2-1-30", da: "Demonstrate how the development actions will align with urban planning and infrastructure improvements."
                   },
                   {
                    id: "pf-2-1-31", da: "Consider a phased approach to ensure a smooth implementation process."
                   },
                   {
                    id: "pf-2-1-32", da: "Leverage public relations and media outreach to generate public interest and support."
                   },
                   {
                    id: "pf-2-1-33", da: "Offer testimonials from other communities or markets that have benefited from similar actions."
                   },
                   {
                    id: "pf-2-1-34", da: "Engage with potential investors who may see the market improvement as a valuable opportunity."
                   },
                   {
                    id: "pf-2-1-35", da: "Align the development actions with local cultural and historical preservation."
                   },
                   {
                    id: "pf-2-1-36", da: "Show how the actions will contribute to a vibrant and dynamic market ecosystem."
                   },
                   {
                    id: "pf-2-1-37", da: "Emphasize the potential for improved health and well-being resulting from market enhancements."
                   },
                   {
                    id: "pf-2-1-38", da: "Consider the potential for smart technology integration to enhance market efficiency."
                   },
                   {
                    id: "pf-2-1-39", da: "Explore public-private financing models, like tax increment financing (TIF)."
                   },
                   {
                    id: "pf-2-1-40", da: "Engage in public consultations to ensure the project meets community needs."
                   },
                   {
                    id: "pf-2-1-41", da: "Highlight the potential for increased tourism and cultural exchange."
                   },
                   {
                    id: "pf-2-1-42", da: "Develop a monitoring and evaluation plan to track progress and measure outcomes."
                   },
                   {
                    id: "pf-2-1-43", da: "Promote local entrepreneurship and job training programs."
                   },
                   {
                    id: "pf-2-1-44", da: "Align the development actions with climate resilience and mitigation strategies."
                   },
                   {
                    id: "pf-2-1-45", da: "Demonstrate alignment with existing economic development plans and strategies."
                   },
                   {
                    id: "pf-2-1-46", da: "Highlight the potential for community ownership and involvement in the project."
                   },
                   {
                    id: "pf-2-1-47", da: "Emphasize the improved quality of life that the actions will bring to residents."
                   },
                   {
                    id: "pf-2-1-48", da: "Explore partnerships with NGOs and civil society organizations for additional support."
                   },
                   {
                    id: "pf-2-1-49", da: "Create a compelling narrative that resonates with both funders and the public, emphasizing the transformational impact of the development actions."
                   },
                ]
              },
              {
                id: 'pf-2-2',
                pm: 'Cashflow and capital management systems in place along with payments operators.',
                title:'Technology',
                pmMap: 'Cashflow and capital management systems in place along with payments operators.',
                developmentActions:[
                  {
                    id: "pf-2-2-0", da: "Develop a comprehensive technology roadmap."
                   },
                   {
                    id: "pf-2-2-1", da: "Promote research and development projects."
                   },
                   {
                    id: "pf-2-2-2", da: "Establish innovation hubs and centers."
                   },
                   {
                    id: "pf-2-2-3", da: "Support technology incubators and accelerators."
                   },
                   {
                    id: "pf-2-2-4", da: "Foster collaboration between universities and tech companies."
                   },
                   {
                    id: "pf-2-2-5", da: "Fund tech education and training programs."
                   },
                   {
                    id: "pf-2-2-6", da: "Invest in digital infrastructure."
                   },
                   {
                    id: "pf-2-2-7", da: "Promote open-source technology initiatives."
                   },
                   {
                    id: "pf-2-2-8", da: "Support startups and small tech businesses."
                   },
                   {
                    id: "pf-2-2-9", da: "Encourage public-private partnerships."
                   },
                   {
                    id: "pf-2-2-10", da: "Create tax incentives for tech investment."
                   },
                   {
                    id: "pf-2-2-11", da: "Fund cybersecurity initiatives."
                   },
                   {
                    id: "pf-2-2-12", da: "Promote technology adoption in healthcare."
                   },
                   {
                    id: "pf-2-2-13", da: "Support digitalization of government services."
                   },
                   {
                    id: "pf-2-2-14", da: "Invest in renewable energy technology."
                   },
                   {
                    id: "pf-2-2-15", da: "Develop smart city solutions."
                   },
                   {
                    id: "pf-2-2-16", da: "Fund projects for affordable and accessible internet."
                   },
                   {
                    id: "pf-2-2-17", da: "Support artificial intelligence research."
                   },
                   {
                    id: "pf-2-2-18", da: "Promote 5G and next-gen connectivity."
                   },
                   {
                    id: "pf-2-2-19", da: "Invest in data analytics and big data projects."
                   },
                   {
                    id: "pf-2-2-20", da: "Fund technology for disaster preparedness and response."
                   },
                   {
                    id: "pf-2-2-21", da: "Support STEM education and awareness."
                   },
                   {
                    id: "pf-2-2-22", da: "Invest in clean energy technologies."
                   },
                   {
                    id: "pf-2-2-23", da: "Promote green technology initiatives."
                   },
                   {
                    id: "pf-2-2-24", da: "Fund blockchain and cryptocurrency research."
                   },
                   {
                    id: "pf-2-2-25", da: "Support technology for agriculture and food security."
                   },
                   {
                    id: "pf-2-2-26", da: "Invest in advanced manufacturing technology."
                   },
                   {
                    id: "pf-2-2-27", da: "Promote tech solutions for environmental conservation."
                   },
                   {
                    id: "pf-2-2-28", da: "Support tech-driven financial inclusion."
                   },
                   {
                    id: "pf-2-2-29", da: "Invest in autonomous vehicles and transportation tech."
                   },
                   {
                    id: "pf-2-2-30", da: "Promote space exploration and technology."
                   },
                   {
                    id: "pf-2-2-31", da: "Fund tech solutions for waste management."
                   },
                   {
                    id: "pf-2-2-32", da: "Support technology for mental health and well-being."
                   },
                   {
                    id: "pf-2-2-33", da: "Invest in renewable energy storage technology."
                   },
                   {
                    id: "pf-2-2-34", da: "Promote tech solutions for education accessibility."
                   },
                   {
                    id: "pf-2-2-35", da: "Support technology for disaster recovery and relief."
                   },
                   {
                    id: "pf-2-2-36", da: "Invest in technology to combat climate change."
                   },
                   {
                    id: "pf-2-2-37", da: "Promote digital inclusion and bridging the digital divide."
                   },
                   {
                    id: "pf-2-2-38", da: "Support tech solutions for accessibility and inclusivity."
                   },
                   {
                    id: "pf-2-2-39", da: "Invest in smart grids and energy efficiency."
                   },
                   {
                    id: "pf-2-2-40", da: "Promote technology for wildlife conservation."
                   },
                   {
                    id: "pf-2-2-41", da: "Support tech-driven solutions for affordable housing."
                   },
                   {
                    id: "pf-2-2-42", da: "Invest in tech solutions for public transportation."
                   },
                   {
                    id: "pf-2-2-43", da: "Promote technology for clean water and sanitation."
                   },
                   {
                    id: "pf-2-2-44", da: "Fund tech research in material science and nanotechnology."
                   },
                   {
                    id: "pf-2-2-45", da: "Invest in space technology for Earth observation."
                   },
                   {
                    id: "pf-2-2-46", da: "Support technology for public safety and emergency services."
                   },
                   {
                    id: "pf-2-2-47", da: "Promote the development of eco-friendly technology."
                   },
                   {
                    id: "pf-2-2-48", da: "Fund projects for the Internet of Things (IoT)."
                   },
                   {
                    id: "pf-2-2-49", da: "Invest in technology that enhances government transparency and accountability."
                   },
                ]
              },
              {
                id: 'pf-2-3',
                pm: 'Proven synergies with potential acquirer to increase strategic interest or ability to accelerate growth through investments.',
                title:'Value',
                pmMap: 'Proven synergies with potential acquirer to increase strategic interest or ability to accelerate growth through investments.',
                developmentActions:[
                  {
                    id: "pf-2-3-0", da: "Clearly define the project's objectives."
                   },
                   {
                    id: "pf-2-3-1", da: "Identify the target audience and beneficiaries."
                   },
                   {
                    id: "pf-2-3-2", da: "Conduct a thorough needs assessment."
                   },
                   {
                    id: "pf-2-3-3", da: "Develop a detailed project plan."
                   },
                   {
                    id: "pf-2-3-4", da: "Create a budget that outlines all costs."
                   },
                   {
                    id: "pf-2-3-5", da: "Calculate the return on investment (ROI)."
                   },
                   {
                    id: "pf-2-3-6", da: "Showcase the project's potential economic impact."
                   },
                   {
                    id: "pf-2-3-7", da: "Highlight the project's alignment with government priorities."
                   },
                   {
                    id: "pf-2-3-8", da: "Emphasize the project's social and environmental benefits."
                   },
                   {
                    id: "pf-2-3-9", da: "Ensure the project addresses pressing community issues."
                   },
                   {
                    id: "pf-2-3-10", da: "Engage with local stakeholders."
                   },
                   {
                    id: "pf-2-3-11", da: "Establish strong partnerships with local organizations."
                   },
                   {
                    id: "pf-2-3-12", da: "Leverage existing resources and infrastructure."
                   },
                   {
                    id: "pf-2-3-13", da: "Provide evidence of successful past projects."
                   },
                   {
                    id: "pf-2-3-14", da: "Highlight the project's innovation and uniqueness."
                   },
                   {
                    id: "pf-2-3-15", da: "Emphasize the project's scalability."
                   },
                   {
                    id: "pf-2-3-16", da: "Demonstrate cost-effectiveness."
                   },
                   {
                    id: "pf-2-3-17", da: "Develop a clear timeline for implementation."
                   },
                   {
                    id: "pf-2-3-18", da: "Create a project management plan."
                   },
                   {
                    id: "pf-2-3-19", da: "Establish key performance indicators (KPIs)."
                   },
                   {
                    id: "pf-2-3-20", da: "Develop a monitoring and evaluation framework."
                   },
                   {
                    id: "pf-2-3-21", da: "Showcase the project's alignment with national and local policies."
                   },
                   {
                    id: "pf-2-3-22", da: "Highlight the potential for job creation."
                   },
                   {
                    id: "pf-2-3-23", da: "Explain how the project will enhance local infrastructure."
                   },
                   {
                    id: "pf-2-3-24", da: "Illustrate how the project will improve the quality of life."
                   },
                   {
                    id: "pf-2-3-25", da: "Provide a risk assessment and mitigation plan."
                   },
                   {
                    id: "pf-2-3-26", da: "Seek support from local leaders and influencers."
                   },
                   {
                    id: "pf-2-3-27", da: "Engage with the public through town hall meetings."
                   },
                   {
                    id: "pf-2-3-28", da: "Create a comprehensive communication strategy."
                   },
                   {
                    id: "pf-2-3-29", da: "Highlight the project's educational opportunities."
                   },
                   {
                    id: "pf-2-3-30", da: "Explore partnerships with universities and research institutions."
                   },
                   {
                    id: "pf-2-3-31", da: "Highlight the project's potential for knowledge transfer."
                   },
                   {
                    id: "pf-2-3-32", da: "Emphasize the project's potential for long-term sustainability."
                   },
                   {
                    id: "pf-2-3-33", da: "Showcase the project's alignment with international development goals."
                   },
                   {
                    id: "pf-2-3-34", da: "Develop a strategy for community involvement."
                   },
                   {
                    id: "pf-2-3-35", da: "Leverage public-private partnerships."
                   },
                   {
                    id: "pf-2-3-36", da: "Demonstrate a commitment to transparency."
                   },
                   {
                    id: "pf-2-3-37", da: "Ensure diversity and inclusion in project implementation."
                   },
                   {
                    id: "pf-2-3-38", da: "Develop a compelling case study."
                   },
                   {
                    id: "pf-2-3-39", da: "Provide testimonials from affected individuals."
                   },
                   {
                    id: "pf-2-3-40", da: "Highlight the potential for replicability in other regions."
                   },
                   {
                    id: "pf-2-3-41", da: "Illustrate how the project will promote technology adoption."
                   },
                   {
                    id: "pf-2-3-42", da: "Create a strong online presence for the project."
                   },
                   {
                    id: "pf-2-3-43", da: "Engage with the media to raise awareness."
                   },
                   {
                    id: "pf-2-3-44", da: "Show how the project will promote entrepreneurship."
                   },
                   {
                    id: "pf-2-3-45", da: "Develop a plan for capacity building."
                   },
                   {
                    id: "pf-2-3-46", da: "Demonstrate how the project will address public health concerns."
                   },
                   {
                    id: "pf-2-3-47", da: "Highlight the potential for increased property values."
                   },
                   {
                    id: "pf-2-3-48", da: "Emphasize the project's alignment with global trends."
                   },
                   {
                    id: "pf-2-3-49", da: "Showcase the project's potential for creating a legacy."
                   },
                ]
              },
              {
                id: 'pf-2-4',
                pm: 'Flywheel effect is achieved and reinforced by ecosystem which leads to competitive advantage.',
                title:'Business Model',
                pmMap: 'Flywheel effect is achieved and reinforced by ecosystem which leads to competitive advantage.',
                developmentActions:[
                  {
                    id: "pf-2-4-0", da: "Clearly define the project's goals and objectives."
                   },
                   {
                    id: "pf-2-4-1", da: "Identify key areas where the business model needs improvement."
                   },
                   {
                    id: "pf-2-4-2", da: "Develop a detailed project plan and timeline."
                   },
                   {
                    id: "pf-2-4-3", da: "Assess the potential impact of the 50 development actions."
                   },
                   {
                    id: "pf-2-4-4", da: "Understand the target audience and beneficiaries."
                   },
                   {
                    id: "pf-2-4-5", da: "Create a compelling mission and vision statement."
                   },
                   {
                    id: "pf-2-4-6", da: "Research available public funding sources."
                   },
                   {
                    id: "pf-2-4-7", da: "Identify grants, subsidies, and financial assistance programs."
                   },
                   {
                    id: "pf-2-4-8", da: "Determine eligibility criteria for each funding source."
                   },
                   {
                    id: "pf-2-4-9", da: "Establish a budget for the entire project."
                   },
                   {
                    id: "pf-2-4-10", da: "Break down the budget into specific action items."
                   },
                   {
                    id: "pf-2-4-11", da: "Seek partnerships and collaborations with relevant organizations."
                   },
                   {
                    id: "pf-2-4-12", da: "Develop a strong value proposition for potential funders."
                   },
                   {
                    id: "pf-2-4-13", da: "Create a comprehensive business plan."
                   },
                   {
                    id: "pf-2-4-14", da: "Clearly articulate how the funding will be utilized."
                   },
                   {
                    id: "pf-2-4-15", da: "Outline the expected outcomes and deliverables."
                   },
                   {
                    id: "pf-2-4-16", da: "Assess the risks associated with the project."
                   },
                   {
                    id: "pf-2-4-17", da: "Develop a sustainability plan for long-term success."
                   },
                   {
                    id: "pf-2-4-18", da: "Consider the social and environmental impact."
                   },
                   {
                    id: "pf-2-4-19", da: "Ensure legal and regulatory compliance."
                   },
                   {
                    id: "pf-2-4-20", da: "Develop a communication and outreach strategy."
                   },
                   {
                    id: "pf-2-4-21", da: "Build a diverse and skilled project team."
                   },
                   {
                    id: "pf-2-4-22", da: "Allocate responsibilities and roles within the team."
                   },
                   {
                    id: "pf-2-4-23", da: "Invest in capacity building and training."
                   },
                   {
                    id: "pf-2-4-24", da: "Develop a monitoring and evaluation framework."
                   },
                   {
                    id: "pf-2-4-25", da: "Gather baseline data for performance measurement."
                   },
                   {
                    id: "pf-2-4-26", da: "Implement performance tracking tools."
                   },
                   {
                    id: "pf-2-4-27", da: "Assess the scalability of the business model."
                   },
                   {
                    id: "pf-2-4-28", da: "Explore alternative revenue streams."
                   },
                   {
                    id: "pf-2-4-29", da: "Consider the potential for cost reductions."
                   },
                   {
                    id: "pf-2-4-30", da: "Optimize the pricing strategy."
                   },
                   {
                    id: "pf-2-4-31", da: "Engage with stakeholders and gather feedback."
                   },
                   {
                    id: "pf-2-4-32", da: "Leverage technology and innovation."
                   },
                   {
                    id: "pf-2-4-33", da: "Build a strong online and offline presence."
                   },
                   {
                    id: "pf-2-4-34", da: "Create a compelling narrative and storytelling."
                   },
                   {
                    id: "pf-2-4-35", da: "Build a network of supporters and advocates."
                   },
                   {
                    id: "pf-2-4-36", da: "Develop a contingency plan for unforeseen challenges."
                   },
                   {
                    id: "pf-2-4-37", da: "Ensure diversity, equity, and inclusion in all actions."
                   },
                   {
                    id: "pf-2-4-38", da: "Evaluate the competition and market dynamics."
                   },
                   {
                    id: "pf-2-4-39", da: "Implement an agile approach to adapt to changes."
                   },
                   {
                    id: "pf-2-4-40", da: "Seek mentorship and expert guidance."
                   },
                   {
                    id: "pf-2-4-41", da: "Prepare a persuasive funding proposal."
                   },
                   {
                    id: "pf-2-4-42", da: "Identify key performance indicators (KPIs)."
                   },
                   {
                    id: "pf-2-4-43", da: "Prepare for periodic reporting to funders."
                   },
                   {
                    id: "pf-2-4-44", da: "Ensure financial transparency."
                   },
                   {
                    id: "pf-2-4-45", da: "Establish ethical and responsible practices."
                   },
                   {
                    id: "pf-2-4-46", da: "Foster a culture of innovation and learning."
                   },
                   {
                    id: "pf-2-4-47", da: "Address potential conflicts of interest."
                   },
                   {
                    id: "pf-2-4-48", da: "Embrace sustainable and ethical sourcing."
                   },
                   {
                    id: "pf-2-4-49", da: "Stay committed to the project's mission and vision."
                   },
                ]
              },
              {
                id: 'pf-2-5',
                pm: 'Category and solution is being recognised as leader by analysts.',
                title:'Go to Market',
                pmMap: 'Category and solution is being recognised as leader by analysts.',
                developmentActions:[
                  {
                    id: "pf-2-5-0", da: "Identify specific funding sources that support projects related to Go-to-Market strategy."
                   },
                   {
                    id: "pf-2-5-1", da: "Research and understand the eligibility criteria for each funding opportunity."
                   },
                   {
                    id: "pf-2-5-2", da: "Create a comprehensive proposal for each initiative, outlining the purpose, goals, and expected outcomes."
                   },
                   {
                    id: "pf-2-5-3", da: "Prioritize initiatives that have a direct impact on sales and market reach."
                   },
                   {
                    id: "pf-2-5-4", da: "Clearly define the budget required for each initiative."
                   },
                   {
                    id: "pf-2-5-5", da: "Develop a detailed timeline for project execution."
                   },
                   {
                    id: "pf-2-5-6", da: "Highlight the potential economic impact of the initiatives."
                   },
                   {
                    id: "pf-2-5-7", da: "Emphasize how these initiatives align with broader economic and social goals."
                   },
                   {
                    id: "pf-2-5-8", da: "Explore partnerships with other organizations to leverage funding opportunities."
                   },
                   {
                    id: "pf-2-5-9", da: "Ensure that your initiatives are well-documented and supported by data."
                   },
                   {
                    id: "pf-2-5-10", da: "Emphasize the job creation potential of these initiatives."
                   },
                   {
                    id: "pf-2-5-11", da: "Include a sustainability plan to show how initiatives will continue after funding ends."
                   },
                   {
                    id: "pf-2-5-12", da: "Consider the scalability of each initiative to maximize long-term impact."
                   },
                   {
                    id: "pf-2-5-13", da: "Provide evidence of demand for the products or services impacted by these initiatives."
                   },
                   {
                    id: "pf-2-5-14", da: "Highlight the potential for increased competitiveness in your market."
                   },
                   {
                    id: "pf-2-5-15", da: "Showcase the positive effects of these initiatives on your organization's growth."
                   },
                   {
                    id: "pf-2-5-16", da: "Emphasize how the initiatives will address specific market challenges or gaps."
                   },
                   {
                    id: "pf-2-5-17", da: "Discuss how the funding will be used to create jobs and stimulate economic growth."
                   },
                   {
                    id: "pf-2-5-18", da: "Present a clear and compelling vision for your organization's future success."
                   },
                   {
                    id: "pf-2-5-19", da: "Demonstrate how these initiatives align with regional or national economic development strategies."
                   },
                   {
                    id: "pf-2-5-20", da: "Include metrics and KPIs to measure the success of each initiative."
                   },
                   {
                    id: "pf-2-5-21", da: "Emphasize innovation and how these initiatives will drive product or service enhancements."
                   },
                   {
                    id: "pf-2-5-22", da: "Highlight how the initiatives will address market trends and customer preferences."
                   },
                   {
                    id: "pf-2-5-23", da: "Include a risk assessment and mitigation plan for each initiative."
                   },
                   {
                    id: "pf-2-5-24", da: "Explain how the funding will be allocated among the 50 initiatives."
                   },
                   {
                    id: "pf-2-5-25", da: "Develop a communication plan to keep stakeholders informed about progress."
                   },
                   {
                    id: "pf-2-5-26", da: "Show how these initiatives will enhance the skills and capabilities of your team."
                   },
                   {
                    id: "pf-2-5-27", da: "Highlight any technology or infrastructure improvements that will result from the funding."
                   },
                   {
                    id: "pf-2-5-28", da: "Address potential environmental or social impacts of the initiatives."
                   },
                   {
                    id: "pf-2-5-29", da: "Emphasize the alignment with the United Nations Sustainable Development Goals, if relevant."
                   },
                   {
                    id: "pf-2-5-30", da: "Develop a robust monitoring and evaluation framework for the initiatives."
                   },
                   {
                    id: "pf-2-5-31", da: "Showcase the potential for export and international market expansion."
                   },
                   {
                    id: "pf-2-5-32", da: "Discuss how the initiatives will enhance your market research and intelligence capabilities."
                   },
                   {
                    id: "pf-2-5-33", da: "Provide evidence of past successful initiatives and their outcomes."
                   },
                   {
                    id: "pf-2-5-34", da: "Highlight the potential for partnerships with local educational institutions."
                   },
                   {
                    id: "pf-2-5-35", da: "Consider how these initiatives can support the growth of local suppliers and partners."
                   },
                   {
                    id: "pf-2-5-36", da: "Explain how the funding will improve your organization's marketing and branding efforts."
                   },
                   {
                    id: "pf-2-5-37", da: "Highlight the potential for increased market share and customer retention."
                   },
                   {
                    id: "pf-2-5-38", da: "Emphasize the positive effects of these initiatives on customer satisfaction and loyalty."
                   },
                   {
                    id: "pf-2-5-39", da: "Include testimonials or endorsements from customers who have benefited from similar initiatives."
                   },
                   {
                    id: "pf-2-5-40", da: "Discuss the potential for expanding into new geographic markets."
                   },
                   {
                    id: "pf-2-5-41", da: "Highlight any research and development opportunities that will be enabled by the funding."
                   },
                   {
                    id: "pf-2-5-42", da: "Address potential challenges and barriers to implementation."
                   },
                   {
                    id: "pf-2-5-43", da: "Provide a detailed plan for recruiting and retaining top talent."
                   },
                   {
                    id: "pf-2-5-44", da: "Demonstrate a commitment to diversity and inclusion in your organization."
                   },
                   {
                    id: "pf-2-5-45", da: "Highlight any pending patents or intellectual property that will benefit from the initiatives."
                   },
                   {
                    id: "pf-2-5-46", da: "Address the potential for disruptive innovation in your industry."
                   },
                   {
                    id: "pf-2-5-47", da: "Explain how these initiatives will support a more agile and adaptable business model."
                   },
                   {
                    id: "pf-2-5-48", da: "Include a detailed financial plan and projections for the initiatives."
                   },
                   {
                    id: "pf-2-5-49", da: "Express gratitude for the opportunity and commitment to making a positive impact on the market and the community."
                   },
                ]
              },
              {
                id: 'pf-2-6',
                pm: 'Team is acknowledged as industry leaders. >1 validation each month is achieved.',
                title:'People',
                pmMap: 'Team is acknowledged as industry leaders. >1 validation each month is achieved.',
                developmentActions:[
                  {
                    id: "pf-2-6-0", da: "Conduct a thorough needs assessment to identify specific areas for improvement."
                   },
                   {
                    id: "pf-2-6-1", da: "Develop a comprehensive project plan with clear objectives."
                   },
                   {
                    id: "pf-2-6-2", da: "Create a budget that outlines the allocation of funds."
                   },
                   {
                    id: "pf-2-6-3", da: "Explore grant opportunities from government agencies."
                   },
                   {
                    id: "pf-2-6-4", da: "Pursue partnerships with local, state, or federal entities for support."
                   },
                   {
                    id: "pf-2-6-5", da: "Engage with philanthropic organizations for potential grants."
                   },
                   {
                    id: "pf-2-6-6", da: "Leverage crowdfunding platforms to raise public contributions."
                   },
                   {
                    id: "pf-2-6-7", da: "Establish a project website to raise awareness and accept donations."
                   },
                   {
                    id: "pf-2-6-8", da: "Organize public awareness campaigns to promote the project."
                   },
                   {
                    id: "pf-2-6-9", da: "Seek corporate sponsorships from socially responsible companies."
                   },
                   {
                    id: "pf-2-6-10", da: "Host fundraising events and charity auctions."
                   },
                   {
                    id: "pf-2-6-11", da: "Apply for community development grants."
                   },
                   {
                    id: "pf-2-6-12", da: "Explore venture capital for innovative projects."
                   },
                   {
                    id: "pf-2-6-13", da: "Identify existing programs that can be expanded or improved."
                   },
                   {
                    id: "pf-2-6-14", da: "Collaborate with educational institutions for research and support."
                   },
                   {
                    id: "pf-2-6-15", da: "Engage with local chambers of commerce for advocacy."
                   },
                   {
                    id: "pf-2-6-16", da: "Consider social impact bonds to fund long-term projects."
                   },
                   {
                    id: "pf-2-6-17", da: "Seek partnerships with non-governmental organizations (NGOs)."
                   },
                   {
                    id: "pf-2-6-18", da: "Develop a compelling mission statement and vision."
                   },
                   {
                    id: "pf-2-6-19", da: "Create a diverse board of directors to provide guidance."
                   },
                   {
                    id: "pf-2-6-20", da: "Use data and research to support funding proposals."
                   },
                   {
                    id: "pf-2-6-21", da: "Develop metrics to measure project success."
                   },
                   {
                    id: "pf-2-6-22", da: "Explore opportunities for in-kind donations."
                   },
                   {
                    id: "pf-2-6-23", da: "Engage with the target community to assess their needs."
                   },
                   {
                    id: "pf-2-6-24", da: "Prioritize projects that promote education and literacy."
                   },
                   {
                    id: "pf-2-6-25", da: "Address healthcare disparities by funding medical clinics."
                   },
                   {
                    id: "pf-2-6-26", da: "Promote access to clean water and sanitation services."
                   },
                   {
                    id: "pf-2-6-27", da: "Improve infrastructure, including roads and public transportation."
                   },
                   {
                    id: "pf-2-6-28", da: "Fund affordable housing and community development projects."
                   },
                   {
                    id: "pf-2-6-29", da: "Support job training programs and vocational education."
                   },
                   {
                    id: "pf-2-6-30", da: "Invest in renewable energy and environmental sustainability."
                   },
                   {
                    id: "pf-2-6-31", da: "Combat food insecurity through community gardens and programs."
                   },
                   {
                    id: "pf-2-6-32", da: "Fund mental health and addiction treatment services."
                   },
                   {
                    id: "pf-2-6-33", da: "Develop after-school programs for at-risk youth."
                   },
                   {
                    id: "pf-2-6-34", da: "Improve public safety and community policing efforts."
                   },
                   {
                    id: "pf-2-6-35", da: "Support cultural initiatives and the arts."
                   },
                   {
                    id: "pf-2-6-36", da: "Fund technology and internet access in underserved areas."
                   },
                   {
                    id: "pf-2-6-37", da: "Provide financial literacy and small business support."
                   },
                   {
                    id: "pf-2-6-38", da: "Support programs for seniors, including healthcare and social services."
                   },
                   {
                    id: "pf-2-6-39", da: "Fund disaster relief and preparedness efforts."
                   },
                   {
                    id: "pf-2-6-40", da: "Invest in programs that empower women and gender equality."
                   },
                   {
                    id: "pf-2-6-41", da: "Address racial and social justice issues."
                   },
                   {
                    id: "pf-2-6-42", da: "Fund youth mentoring and leadership development."
                   },
                   {
                    id: "pf-2-6-43", da: "Support programs that promote inclusivity and diversity."
                   },
                   {
                    id: "pf-2-6-44", da: "Address homelessness and provide shelter for those in need."
                   },
                   {
                    id: "pf-2-6-45", da: "Develop programs to reduce substance abuse."
                   },
                   {
                    id: "pf-2-6-46", da: "Promote civic engagement and voter participation."
                   },
                   {
                    id: "pf-2-6-47", da: "Fund renewable energy projects to combat climate change."
                   },
                   {
                    id: "pf-2-6-48", da: "Invest in rural development and agriculture."
                   },
                   {
                    id: "pf-2-6-49", da: "Advocate for policies and legislation that support the project's goals."
                   },
                ]
              },
              {
                id: 'pf-2-7',
                pm: 'Continued strong year-over- year growth. >90% accuracy in projections and forecasts so that targets are being met quarter after quarter',
                title:'Data Metrics',
                pmMap: 'Continued strong year-over- year growth. >90% accuracy in projections and forecasts so that targets are being met quarter after quarter',
                developmentActions:[
                  {
                    id: "pf-2-7-0", da: "Clearly define your project's objectives."
                   },
                   {
                    id: "pf-2-7-1", da: "Identify the specific data metrics that need improvement."
                   },
                   {
                    id: "pf-2-7-2", da: "Demonstrate how enhanced data metrics will benefit the community or target audience."
                   },
                   {
                    id: "pf-2-7-3", da: "Research available public funding sources."
                   },
                   {
                    id: "pf-2-7-4", da: "Prepare a comprehensive project proposal."
                   },
                   {
                    id: "pf-2-7-5", da: "Highlight the relevance of your project to local, regional, or national development goals."
                   },
                   {
                    id: "pf-2-7-6", da: "Emphasize the potential positive impact on policy-making."
                   },
                   {
                    id: "pf-2-7-7", da: "Showcase past successes and experience in data-related projects."
                   },
                   {
                    id: "pf-2-7-8", da: "Outline a clear project timeline."
                   },
                   {
                    id: "pf-2-7-9", da: "Specify the expected outcomes and deliverables."
                   },
                   {
                    id: "pf-2-7-10", da: "Describe the target demographic or audience."
                   },
                   {
                    id: "pf-2-7-11", da: "Develop a detailed budget that justifies the funding amount requested."
                   },
                   {
                    id: "pf-2-7-12", da: "Show cost-effectiveness and sustainability."
                   },
                   {
                    id: "pf-2-7-13", da: "Address potential risks and mitigation strategies."
                   },
                   {
                    id: "pf-2-7-14", da: "Demonstrate partnerships with relevant organizations."
                   },
                   {
                    id: "pf-2-7-15", da: "Explain the scalability of your project."
                   },
                   {
                    id: "pf-2-7-16", da: "Highlight innovative approaches to data collection and analysis."
                   },
                   {
                    id: "pf-2-7-17", da: "Explain how your project aligns with government priorities."
                   },
                   {
                    id: "pf-2-7-18", da: "Include a plan for data security and privacy."
                   },
                   {
                    id: "pf-2-7-19", da: "Emphasize the project's potential to create jobs."
                   },
                   {
                    id: "pf-2-7-20", da: "Show how it promotes community engagement."
                   },
                   {
                    id: "pf-2-7-21", da: "Explain the technological infrastructure required."
                   },
                   {
                    id: "pf-2-7-22", da: "Demonstrate the potential for replicability in other regions."
                   },
                   {
                    id: "pf-2-7-23", da: "Highlight the capacity building aspect of your project."
                   },
                   {
                    id: "pf-2-7-24", da: "Provide examples of best practices in data metrics improvement."
                   },
                   {
                    id: "pf-2-7-25", da: "Address any legal or regulatory requirements."
                   },
                   {
                    id: "pf-2-7-26", da: "Show evidence of community support or demand."
                   },
                   {
                    id: "pf-2-7-27", da: "Describe how your project addresses social or environmental issues."
                   },
                   {
                    id: "pf-2-7-28", da: "Mention any awards or recognitions your project has received."
                   },
                   {
                    id: "pf-2-7-29", da: "Include a strong monitoring and evaluation plan."
                   },
                   {
                    id: "pf-2-7-30", da: "Consider the use of open data principles."
                   },
                   {
                    id: "pf-2-7-31", da: "Discuss data visualization and accessibility."
                   },
                   {
                    id: "pf-2-7-32", da: "Address the potential for cross-sector collaboration."
                   },
                   {
                    id: "pf-2-7-33", da: "Emphasize the project's alignment with the United Nations Sustainable Development Goals."
                   },
                   {
                    id: "pf-2-7-34", da: "Include feedback mechanisms for project improvement."
                   },
                   {
                    id: "pf-2-7-35", da: "Explain how your project supports data transparency and accountability."
                   },
                   {
                    id: "pf-2-7-36", da: "Address the use of emerging technologies, such as AI or blockchain."
                   },
                   {
                    id: "pf-2-7-37", da: "Highlight partnerships with academic institutions for research."
                   },
                   {
                    id: "pf-2-7-38", da: "Show how the project will empower marginalized communities."
                   },
                   {
                    id: "pf-2-7-39", da: "Emphasize the potential for public-private partnerships."
                   },
                   {
                    id: "pf-2-7-40", da: "Mention any data-related challenges your region faces."
                   },
                   {
                    id: "pf-2-7-41", da: "Consider the use of citizen science or crowd-sourced data."
                   },
                   {
                    id: "pf-2-7-42", da: "Describe the project's adaptability to changing circumstances."
                   },
                   {
                    id: "pf-2-7-43", da: "Highlight the potential for improving access to healthcare or education."
                   },
                   {
                    id: "pf-2-7-44", da: "Include a plan for disaster preparedness and response."
                   },
                   {
                    id: "pf-2-7-45", da: "Address gender-specific data metrics improvements."
                   },
                   {
                    id: "pf-2-7-46", da: "Discuss data standards and interoperability."
                   },
                   {
                    id: "pf-2-7-47", da: "Explain how your project will promote evidence-based decision-making."
                   },
                   {
                    id: "pf-2-7-48", da: "Demonstrate how it fosters a culture of data use."
                   },
                   {
                    id: "pf-2-7-49", da: "Convey the urgency and importance of your project for overall development."
                   },
                ]
              },
              {
                id: 'pf-2-8',
                pm: 'Auditors are appointed. Board of directors have exit experience.',
                title:'Operations',
                pmMap: 'Auditors are appointed. Board of directors have exit experience.',
                developmentActions:[
                  {
                    id: "pf-2-8-0", da: "Identify key areas in operations that require development."
                   },
                   {
                    id: "pf-2-8-1", da: "Develop a comprehensive business plan outlining your objectives."
                   },
                   {
                    id: "pf-2-8-2", da: "Research government grants and funding programs."
                   },
                   {
                    id: "pf-2-8-3", da: "Assess eligibility criteria for public funding."
                   },
                   {
                    id: "pf-2-8-4", da: "Ensure your organization's legal and financial compliance."
                   },
                   {
                    id: "pf-2-8-5", da: "Build a strong case for why your operations need development."
                   },
                   {
                    id: "pf-2-8-6", da: "Define specific goals and objectives for each action."
                   },
                   {
                    id: "pf-2-8-7", da: "Consider public-private partnerships for co-funding opportunities."
                   },
                   {
                    id: "pf-2-8-8", da: "Prepare a budget for each development action."
                   },
                   {
                    id: "pf-2-8-9", da: "Seek out local, regional, and national funding sources."
                   },
                   {
                    id: "pf-2-8-10", da: "Explore grants from industry-specific associations."
                   },
                   {
                    id: "pf-2-8-11", da: "Develop a clear timeline for implementation."
                   },
                   {
                    id: "pf-2-8-12", da: "Evaluate the potential impact of each action."
                   },
                   {
                    id: "pf-2-8-13", da: "Consider environmental sustainability in your plans."
                   },
                   {
                    id: "pf-2-8-14", da: "Collaborate with other organizations pursuing similar goals."
                   },
                   {
                    id: "pf-2-8-15", da: "Showcase the benefits to the community and society."
                   },
                   {
                    id: "pf-2-8-16", da: "Highlight how funding will create jobs or economic growth."
                   },
                   {
                    id: "pf-2-8-17", da: "Prepare a detailed application for each funding opportunity."
                   },
                   {
                    id: "pf-2-8-18", da: "Tailor proposals to the priorities of each funding source."
                   },
                   {
                    id: "pf-2-8-19", da: "Emphasize the expected return on investment."
                   },
                   {
                    id: "pf-2-8-20", da: "Use data and evidence to support your claims."
                   },
                   {
                    id: "pf-2-8-21", da: "Ensure the application is error-free and well-structured."
                   },
                   {
                    id: "pf-2-8-22", da: "Prepare for interviews or presentations to funding bodies."
                   },
                   {
                    id: "pf-2-8-23", da: "Show a commitment to ongoing monitoring and evaluation."
                   },
                   {
                    id: "pf-2-8-24", da: "Develop a strategy for reporting on the progress of each action."
                   },
                   {
                    id: "pf-2-8-25", da: "Foster relationships with local politicians and policymakers."
                   },
                   {
                    id: "pf-2-8-26", da: "Use social media and public relations to raise awareness."
                   },
                   {
                    id: "pf-2-8-27", da: "Engage the community through public meetings or forums."
                   },
                   {
                    id: "pf-2-8-28", da: "Maintain transparency in all financial matters."
                   },
                   {
                    id: "pf-2-8-29", da: "Address potential concerns and obstacles upfront."
                   },
                   {
                    id: "pf-2-8-30", da: "Demonstrate your organization's track record of success."
                   },
                   {
                    id: "pf-2-8-31", da: "Show a clear alignment with government priorities."
                   },
                   {
                    id: "pf-2-8-32", da: "Emphasize the development actions' long-term benefits."
                   },
                   {
                    id: "pf-2-8-33", da: "Engage experts in grant writing and proposal development."
                   },
                   {
                    id: "pf-2-8-34", da: "Communicate how you will involve the public in decisions."
                   },
                   {
                    id: "pf-2-8-35", da: "Explore crowdfunding options for public support."
                   },
                   {
                    id: "pf-2-8-36", da: "Utilize local media to promote your initiatives."
                   },
                   {
                    id: "pf-2-8-37", da: "Engage with influential community leaders."
                   },
                   {
                    id: "pf-2-8-38", da: "Lobby for funding through industry associations."
                   },
                   {
                    id: "pf-2-8-39", da: "Form partnerships with research institutions."
                   },
                   {
                    id: "pf-2-8-40", da: "Engage with chambers of commerce and business networks."
                   },
                   {
                    id: "pf-2-8-41", da: "Align with the Sustainable Development Goals (SDGs)."
                   },
                   {
                    id: "pf-2-8-42", da: "Develop metrics to track the impact of each action."
                   },
                   {
                    id: "pf-2-8-43", da: "Highlight the potential for cost savings in operations."
                   },
                   {
                    id: "pf-2-8-44", da: "Address inclusivity and diversity in your plans."
                   },
                   {
                    id: "pf-2-8-45", da: "Consider the potential for public recognition or awards."
                   },
                   {
                    id: "pf-2-8-46", da: "Engage with stakeholders early in the planning process."
                   },
                   {
                    id: "pf-2-8-47", da: "Be prepared to adapt to changing funding opportunities."
                   },
                   {
                    id: "pf-2-8-48", da: "Share success stories and testimonials from beneficiaries."
                   },
                   {
                    id: "pf-2-8-49", da: "Prepare for continuous communication and advocacy to secure funding."
                   },
                ]
              },
              {
                id: 'pf-2-9',
                pm: 'Team has acquisition offers.',
                title:'Exit Strategy',
                pmMap: 'Team has acquisition offers.',
                developmentActions:[
                  {
                    id: "pf-2-9-0", da: "Clearly define the project's goals and objectives."
                   },
                   {
                    id: "pf-2-9-1", da: "Identify the key stakeholders and their roles."
                   },
                   {
                    id: "pf-2-9-2", da: "Develop a timeline for the project's duration."
                   },
                   {
                    id: "pf-2-9-3", da: "Specify the target audience and beneficiaries."
                   },
                   {
                    id: "pf-2-9-4", da: "Assess potential risks and mitigation strategies."
                   },
                   {
                    id: "pf-2-9-5", da: "Outline the budget and financial requirements."
                   },
                   {
                    id: "pf-2-9-6", da: "Determine the funding sources and options."
                   },
                   {
                    id: "pf-2-9-7", da: "Describe the project's impact on the community."
                   },
                   {
                    id: "pf-2-9-8", da: "Align the exit strategy with the project's mission."
                   },
                   {
                    id: "pf-2-9-9", da: "Detail the metrics for success and impact measurement."
                   },
                   {
                    id: "pf-2-9-10", da: "Consider scalability and sustainability."
                   },
                   {
                    id: "pf-2-9-11", da: "Analyze market trends and competition."
                   },
                   {
                    id: "pf-2-9-12", da: "Highlight the social and economic benefits."
                   },
                   {
                    id: "pf-2-9-13", da: "Explore partnerships and collaborations."
                   },
                   {
                    id: "pf-2-9-14", da: "Assess the legal and regulatory environment."
                   },
                   {
                    id: "pf-2-9-15", da: "Create a detailed project plan."
                   },
                   {
                    id: "pf-2-9-16", da: "Communicate the project's value proposition."
                   },
                   {
                    id: "pf-2-9-17", da: "Engage with the public and gather feedback."
                   },
                   {
                    id: "pf-2-9-18", da: "Demonstrate the potential for growth."
                   },
                   {
                    id: "pf-2-9-19", da: "Ensure transparency in financial reporting."
                   },
                   {
                    id: "pf-2-9-20", da: "Establish a strong organizational structure."
                   },
                   {
                    id: "pf-2-9-21", da: "Evaluate the project's social responsibility."
                   },
                   {
                    id: "pf-2-9-22", da: "Monitor and adapt to changing circumstances."
                   },
                   {
                    id: "pf-2-9-23", da: "Develop a communications strategy."
                   },
                   {
                    id: "pf-2-9-24", da: "Emphasize the project's unique selling points."
                   },
                   {
                    id: "pf-2-9-25", da: "Document lessons learned throughout the project."
                   },
                   {
                    id: "pf-2-9-26", da: "Clarify the project's long-term vision."
                   },
                   {
                    id: "pf-2-9-27", da: "Engage with local authorities and stakeholders."
                   },
                   {
                    id: "pf-2-9-28", da: "Foster community ownership and involvement."
                   },
                   {
                    id: "pf-2-9-29", da: "Prioritize the needs of the target audience."
                   },
                   {
                    id: "pf-2-9-30", da: "Conduct feasibility studies and market research."
                   },
                   {
                    id: "pf-2-9-31", da: "Ensure compliance with legal requirements."
                   },
                   {
                    id: "pf-2-9-32", da: "Develop a diversified funding strategy."
                   },
                   {
                    id: "pf-2-9-33", da: "Address potential roadblocks and challenges."
                   },
                   {
                    id: "pf-2-9-34", da: "Highlight the project's return on investment."
                   },
                   {
                    id: "pf-2-9-35", da: "Identify exit points and transition phases."
                   },
                   {
                    id: "pf-2-9-36", da: "Define the role of project leadership."
                   },
                   {
                    id: "pf-2-9-37", da: "Evaluate the project's alignment with funding goals."
                   },
                   {
                    id: "pf-2-9-38", da: "Showcase the project's innovation and creativity."
                   },
                   {
                    id: "pf-2-9-39", da: "Establish a clear governance structure."
                   },
                   {
                    id: "pf-2-9-40", da: "Create a project advisory board."
                   },
                   {
                    id: "pf-2-9-41", da: "Emphasize the importance of social impact."
                   },
                   {
                    id: "pf-2-9-42", da: "Secure intellectual property rights."
                   },
                   {
                    id: "pf-2-9-43", da: "Foster a culture of continuous improvement."
                   },
                   {
                    id: "pf-2-9-44", da: "Promote environmental sustainability."
                   },
                   {
                    id: "pf-2-9-45", da: "Address potential conflicts of interest."
                   },
                   {
                    id: "pf-2-9-46", da: "Monitor the project's ethical standards."
                   },
                   {
                    id: "pf-2-9-47", da: "Foster inclusivity and diversity."
                   },
                   {
                    id: "pf-2-9-48", da: "Engage with the media and public relations."
                   },
                   {
                    id: "pf-2-9-49", da: "Review and update the exit strategy periodically."
                   }
                ]
              }
            ]
          }
        ]
      }
    }
  },
  selectedCharacteristic: {
    sc1: "Select the startup stage you want to work on",
    sc2: "Select one to continue",
    sc3: "Next",
    sc4: "Search"
  },
  searchCompetency: {
    sc1: "Pick a startup stage that you want to conquer next",
    sc2: "Select one to continue"
  },
  selectCompetency: {
    sc1: "Select the level you want to conquer next",
    sc2: "Select one to continue"
  },
  rateYourLevel: {
    ryl1: "How would you rate your level for this stage?",
    ryl2: "Knowing where your starting point is a step forward to your goal!",
    ryl3: "SLIDE TO YOUR LEVEL",
    ryl4: "DISCOVERING",
    ryl5: "STARTING",
    ryl6: "STARTED",
    ryl7: "VERY GOOD",
    ryl8: "ACHIEVED"
  },
  trainingDuration: {
    td1: "Looking good! How long would you like to work on this?",
    td2: "It’s important to approach a goal with an end in mind. Set your deadline!",
    td3: "1 Month",
    td4: "3 Months",
    td5: "6 Months",
    td6: "12 Months",
    td7: "Custom Time"
  },
  progressMeasure: {
    pm1: "Choose a progress measure",
    pm2: "It's important to note that the progression through these stages may not always be linear, and startups may revisit or iterate on previous stages as they evolve and respond to market feedback and changing circumstances. The path to success can vary based on the nature of the startup, the market conditions, and the ability to execute strategies effectively. Choose an indicator that can measure your progress",
    pm3: "Custom progress measure (Optional)",
    pm4: "Add your own progress measure",
    pm5: "Add custom progress measure",
    pm6: "Submit",
    pm7: "Enter the progress measure",
    pm8: "Progress Measure",
    pm9: "Cancel"
  },
  reviewSkill: {
    rs1: "Alright, review the summary of your development goal",
    rs2: "Main goal",
    rs3: "How you rated your level",
    rs4: "How long you would target",
    rs5: "Training duration",
    rs6: "Measure"
  },
  mySkills: {
    ms1: "Development History",
    ms2: "You haven't added any plan yet",
    ms3: "When you add plans, they will appear here",
    ms4: "Add New Goal",
    ms5: "In Progress",
    ms6: "Completed"
  },
  skillDetails: {
    h1: "The Founder hasn't added any abilities  yet",
    p1: "When Founder adds a plan, they will appear here",
    sd1: "Motivation",
    sd2: "Action",
    sd3: "Feedback",
    details: {
      d0: "Goal Details",
      d1: "Initial Level",
      d2: "Duration",
      d3: "Training Duration",
      d4: "Behavior Progress Measures",
      d5: "Update Training Duration"
    },
    progress: {
      p1: "No Motivation Logs Yet",
      p2: "When you add motivation logs on this skill they will appear here",
      p3: "Assess your Motivation",
      p4: "Your Latest Motivation Log",
      p5: "Your Previous Log",
      p6: "Created Date"
    },

    action: {
      a1: "Add a Custom Development Action",
      a2: "Submit",
      a3: "Enter the Development Action",
      a4: "Development Actions",
      a5: "Define a Development Action",
      a6:"Cancel",
      a7:"Select from a list of suggested development actions",
      a8:"Completed Development Actions"
    },action1: {
      a1: "\n" +
          "Send Feedback Invite",
      a2: "This action will send a feedback request to the selected invitees on ",
      a3: "Submit",
      a4:"Cancel",
      a5: " asking to rate you on selected skill progress.",

    },
    action2: {
      a1: "\n" +
          "\n" +
          "Email Schedules for ",
      a3: "Cancel Email",
      a4:"Reschedule Email",
      a5:"Are you sure that you want to cancel the emails schedule for",
      a6:"Are you sure that you want to reschedule the emails for ",
      a7:"ok",
      a8:"Sent",
      a9:"Followup",
      a10:"Feedback Received",
      a11:"Gap Closed",
      a12:"Scheduled",
      a13:"Canceled",
      a15:"Congrats on completing your goal",
      a16:"Note that by marking this goal closed you will not be able to work on these development actions anymore. Your scheduled email feedbacks will be cancelled and no advisor will be able to give you further feedback. If you are not sure about this action, cancel the popup and consult your coach about it.",
      a17: " I am sure I did a good job, let’s close my goal ",
      a18:"No Initial Gap Rated",
      a19:"Confirmation for No Gap ",
      a20:"This action will mark a NO GAP to the requester. This will indicate no further need to develop the stage, hence no further email will be sent to you for evaluating your progress.\n" +
          "        ",
      a21:"Cancel",
      a22:"Expire ",
      a23:"Expired",
      a24:"Are you sure that you want to cancel the email ",
      a25:"Cancel Single Email",
      a26:"Expire Single Email",
      a27:"Are you sure that you want to expire the email ",
      a28:"Goal Marked As Complete",
      a29:"You can’t cancel this schedule since the email has been already sent to the advisor, you can cancel the schedule once the advisor completes this pending rating or advise them to ignore the email and no other ratings will be send. ",
      a30:'Benchmark'
    },
    endorsement: {
      e1: "Goal Completed",
      e2: "Congratulations on successfully completing your goal!!",
      e3: "Set Another Goal",
      e4: "No Advisors Yet",
      e5: "When you invite others to give you feedback on your progress they will be listed here",
      e6: "Send Invites",
      e7: "Mark Goal Complete"
    }
  },
  components: {
    progressMeasureChart: {
      pmc1: "Relevancy",
      pmc2: "Progress",
      pmc3: "Practice"
    },
    progressMeasureHorizontal: {
      pmh1: "Relevancy",
      pmh2: "Progress",
      pmh3: "Practice"
    },
    threeSwitchToggle: {
      tst1: "    ",
      tst2: "DOING",
      tst3: "DONE"
    }
  },
  competencyProgress: {
    cp1: "Your motivation survey for the developing the behaviour: ",
    cp2: "Going Great",
    cp3: "Not So Good",
    cp4: "Next",
    cp5: "Submit",
    cp6: "Do you still feel this is the right goal to be acheived now?",
    cp7: "Do you feel you are making progress towards your goal?",
    cp8: "Are you getting an opportunity to practice and apply the learning?",
    cp9: " is due for more than ",
    cp10:" days.",

    cp11:" Please take a minute to suggest how your skill development is going.",
    cp12:"Your Motivation Survey is Complete.",

    threeStepToggle: {
      tst1: "YES",
      tst2: "PARTLY",
      tst3: "NO"
    },
    result : {
      r1: "Your progress has been successfully submitted",
      r2: "Your next progress will be in a month. See you.",
      r3: "Seek external feedback?",
      r4: "Close"
    }
  },
  endorsementInvite: {
    lbl1: 'Advisor Email',
    lbl2: 'Advisor Name',
    ei1: "Next",
    ei2: "Send Invite",
    invitePeople: {
      ip1: "Invite People",
      ip2: "Enter email address to invite",
      ip3: "Add Email"
    },
    progressMeasure: {
      pm1: "Assign Progress Measures",
      pm2: "Choose the behaviour measure you want to assign to invitees"
    },
    response: {
      r0: "Hi ",
      r1: "I'm working on developing some new abilities  and I'd like you to help me measure my progress. This will only take a minute or so.",
      r2: "On the next screen you’ll be asked one question for each behavior:",
      r3: "You'll compare where I am today with where you believe I could be with focus, practice and support.",
      r4: "I will not be able to see your numercial ratings on my performance or potential. I will only see the progress you think I am making in closing the gap over time, so please be completely candid about these ratings.",
      r5: "Hi,",
      r6: "With the following feedback, I will be able to see if my current gap is getting wider or getting closed.",
      r7: "I will be able to see if the gap is getting bigger, smaller or staying the same relative to your first rating.",
      r8: "It only take a few seconds to update the answer you provide each time.",
      r9: "In your view, how big is the gap now between: how well I do this (Perform), and how well you think I could do it (Potential)?",
      r10: "The light green dot is your previous response.",
      r11: "In your view, how big is the gap between how well ",
      r12: "SLIDE TO RATE",
      r13: "Thank you for submitting your feedback. As my advisor, I will reach you periodically for advice. If you choose to stop the process, just ignore the email and any further schedules will be stopped. Thank you for your support with my skill development.",
      r14: "Start",
      r15: "Next",
      r16: "Submit Feedback",
      r17: "NO GAP",
      r18: "SMALL GAP",
      r19: "MODERATE GAP",
      r20: "LARGE GAP",
      r21: "SIGNIFICANT GAP",
      r22:"does this now, and how well you think they could do it?",
      r23:"Previous Rating"
    }
  },
  profile: {
    p1: "Username",
    p2: "Name",
    p3: "Email",
    p4: "Status",
    p5: "Company",
    p6: "Edit",
    p7: "Birth Date",
    p8: "Mobile",
    p9: "Gender",
    p10: "Address Line 1",
    p11: "Address Line 2",
    p12: "City",
    p13: "State",
    p14: "Country",
    p15: "Twitter",
    p16: "Facebook",
    p17: "Instagram",
    p18: "LinkedIn",
    p19: "Edit Profile",
    p20: "Account",
    p21: "Information",
    p22: "Social",
    p23: "Save Changes",
    p24: "Reset",
    account: {
      a1: "Change Avatar",
      a2: "Change Password",
      a3: "Old Password",
      a4: "New Password",
      a5: "Confirm Password",
      a6: "First Name",
      a7: "Last Name",
      a8: "Active",
      a9: "Blocked",
      a10: "Deactivated",
      a11: "Password Changed",
      a12: "Password was successfully changed",
      a13: "Password Change Failed",
      a14: "Password could not be changed"
    }
  },
  coach: {
    coachingExperience: {
      ce1: "ID",
      ce2: "Name",
      ce3: "Email",
      ce4: "Coaching Experience",
      ce5: "Cancel"
    },
    coachingExperienceChart: {
      cec1: "Relationship",
      cec2: "Resource Availability",
      cec3: "Network Support"
    },
    coachingExperienceData: {
      ced1: "No Coaching Logs Yet",
      ced2: "When the Player adds coaching logs, they will appear here",
      ced3: "Latest Stats",
      ced4: "Previous Stats"
    },
    traineeList: {
      tl1: "ID",
      tl2: "Name",
      tl3: "Email",
      tl4: "Competencies",
      tl5: "Progress",
      tl6: "View",
      tl7:"Plan"
    }
  },
  tblHeadings: {
    th1: "ID",
    th2: "NAME",
    th3: "EMAIL",
    th4: "ADVISOR NAME",
    th5: "COMPETENCIES",
    th6: "COACHING EXPERIENCE",
    th7: "ONBOARDING",
    th8: "MONITORING",
    th9: "EXPERIENCE",
    th10: "ACTION",
    th11: "ACTIONS",
    th12: "COMPANY",
    th13: "USER TYPE",
    th14: "STATUS",
    th15: "COMPANY NAME",
    th16: "COACHING",
    th17: "MOTIVATION",
    th18: "PLAYER",
    th19: "COACH",
    th20: "COMPETENCY NAME",
    th21: "FEEDBACK",
    th22: "PROGRESS"
  },
  msg:{
    msg1:{
      suc_title: "Account Updated",
      suc_desc: "Account details successfully updated",
      err_title: "Account Update Failed",
      err_desc: "Account details could not be updated"
    },
    msg2:{
      suc_title: "Information Updated",
      suc_desc: "Information was successfully updated",
      err_title: "Information Update Failed",
      err_desc: "Information could not be updated"
    },
    msg3:{
      suc_title: "Social Details Updated",
      suc_desc: "Social Details successfully updated",
      err_title: "Social Details Update Failed",
      err_desc: "Social Details could not be updated"
    }
  },
  notes:{
    title: 'Notes',
    msg_prefix: 'From',
    lbl0 : 'Add Note',
    lbl1 : 'Type',
    lbl3:'Start Time',
    lbl4:'Time Zone',
    lbl1_opt0 : 'Note',
    lbl1_opt1 : 'Kudos',
    lbl1_opt2 : 'Alert',
    lbl1_opt3 : 'Message',
    lbl1_opt4 : 'Meeting',
    lbl2 : 'Meeting Date',
  },
  todo:{
    title : 'Todo',
    h1: 'My Development Actions',
    opt0: 'All Tasks',
    lbl0: 'Filters',
    lbl0_opt0 : 'Doing',
    lbl0_opt1 : 'Done',
    lbl0_opt2 : 'Trashed',
    lbl1 : 'Labels',
    lbl1_opt0 : 'Attribute',
    lbl1_opt1 : 'Skill',
    lbl2 : 'search'
  },
  changelog:{
    title:'Changelog',
    lbl0_opt0:'All entries',
    lbl0_opt1:'New',
    lbl0_opt2:'Improved',
    lbl0_opt3:'Fixed'
  }
}
